/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, callbacks = [];
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId])
/******/ 				callbacks.push.apply(callbacks, installedChunks[chunkId]);
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules);
/******/ 		while(callbacks.length)
/******/ 			callbacks.shift().call(null, __webpack_require__);
/******/ 		if(moreModules[0]) {
/******/ 			installedModules[0] = 0;
/******/ 			return __webpack_require__(0);
/******/ 		}
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// object to store loaded and loading chunks
/******/ 	// "0" means "already loaded"
/******/ 	// Array means "loading", array contains callbacks
/******/ 	var installedChunks = {
/******/ 		0:0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId, callback) {
/******/ 		// "0" is the signal for "already loaded"
/******/ 		if(installedChunks[chunkId] === 0)
/******/ 			return callback.call(null, __webpack_require__);
/******/
/******/ 		// an array means "currently loading".
/******/ 		if(installedChunks[chunkId] !== undefined) {
/******/ 			installedChunks[chunkId].push(callback);
/******/ 		} else {
/******/ 			// start chunk loading
/******/ 			installedChunks[chunkId] = [callback];
/******/ 			var head = document.getElementsByTagName('head')[0];
/******/ 			var script = document.createElement('script');
/******/ 			script.type = 'text/javascript';
/******/ 			script.charset = 'utf-8';
/******/ 			script.async = true;
/******/
/******/ 			script.src = __webpack_require__.p + window["webpackBundleManifest"][chunkId];
/******/ 			head.appendChild(script);
/******/ 		}
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/ })
/************************************************************************/
/******/ ([
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(82);
	__webpack_require__(83);
	__webpack_require__(80);
	__webpack_require__(85);
	__webpack_require__(84);
	__webpack_require__(81);
	__webpack_require__(208);
	__webpack_require__(212);
	__webpack_require__(155);
	__webpack_require__(226);
	__webpack_require__(223);
	__webpack_require__(224);
	__webpack_require__(222);
	__webpack_require__(146);
	__webpack_require__(230);
	__webpack_require__(148);
	__webpack_require__(149);
	__webpack_require__(145);
	__webpack_require__(79);
	__webpack_require__(162);
	__webpack_require__(77);
	__webpack_require__(203);
	__webpack_require__(204);
	__webpack_require__(205);
	__webpack_require__(217);
	__webpack_require__(216);
	
	// revised layout
	__webpack_require__(159);

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(11))(3);

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(239))(4);

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*
	 strftime for Javascript
	 Copyright (c) 2008, Philip S Tellis <philip@bluesmoon.info>
	 All rights reserved.
	 
	 This code is distributed under the terms of the BSD licence
	 
	 Redistribution and use of this software in source and binary forms, with or without modification,
	 are permitted provided that the following conditions are met:
	
	   * Redistributions of source code must retain the above copyright notice, this list of conditions
	     and the following disclaimer.
	   * Redistributions in binary form must reproduce the above copyright notice, this list of
	     conditions and the following disclaimer in the documentation and/or other materials provided
	     with the distribution.
	   * The names of the contributors to this file may not be used to endorse or promote products
	     derived from this software without specific prior written permission.
	
	THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED
	WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
	PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
	ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
	LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
	INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR
	TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF
	ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
	/**
	 * \file strftime.js
	 * \author Philip S Tellis \<philip@bluesmoon.info\>
	 * \version 1.3
	 * \date 2008/06
	 * \brief Javascript implementation of strftime
	 * 
	 * Implements strftime for the Date object in javascript based on the PHP implementation described at
	 * http://www.php.net/strftime  This is in turn based on the Open Group specification defined
	 * at http://www.opengroup.org/onlinepubs/007908799/xsh/strftime.html This implementation does not
	 * include modified conversion specifiers (i.e., Ex and Ox)
	 *
	 * The following format specifiers are supported:
	 *
	 * \copydoc formats
	 *
	 * \%a, \%A, \%b and \%B should be localised for non-English locales.
	 *
	 * \par Usage:
	 * This library may be used as follows:
	 * \code
	 *     var d = new Date();
	 *
	 *     var ymd = d.strftime('%Y/%m/%d');
	 *     var iso = d.strftime('%Y-%m-%dT%H:%M:%S%z');
	 *
	 * \endcode
	 *
	 * \sa \link Date.prototype.strftime Date.strftime \endlink for a description of each of the supported format specifiers
	 * \sa Date.ext.locales for localisation information
	 * \sa http://www.php.net/strftime for the PHP implementation which is the basis for this
	 * \sa http://tech.bluesmoon.info/2008/04/strftime-in-javascript.html for feedback
	 */
	
	//! Date extension object - all supporting objects go in here.
	Date.ext = {};
	
	//! Utility methods
	Date.ext.util = {};
	
	/**
	\brief Left pad a number with something
	\details Takes a number and pads it to the left with the passed in pad character
	\param x	The number to pad
	\param pad	The string to pad with
	\param r	[optional] Upper limit for pad.  A value of 10 pads to 2 digits, a value of 100 pads to 3 digits.
			Default is 10.
	
	\return The number left padded with the pad character.  This function returns a string and not a number.
	*/
	Date.ext.util.xPad = function (x, pad, r) {
	  if (typeof r == 'undefined') {
	    r = 10;
	  }
	  for (; parseInt(x, 10) < r && r > 1; r /= 10) {
	    try {
	      x = pad.toString() + x;
	    } catch (e) {} // eslint-disable-line no-empty
	  }
	  return x.toString();
	};
	
	/**
	\brief Currently selected locale.
	\details
	The locale for a specific date object may be changed using \code Date.locale = "new-locale"; \endcode
	The default will be based on the lang attribute of the HTML tag of your document
	*/
	Date.prototype.locale = 'en-US';
	//! \cond FALSE
	if (document.getElementsByTagName('html') && document.getElementsByTagName('html')[0].lang) {
	  Date.prototype.locale = document.getElementsByTagName('html')[0].lang;
	}
	//! \endcond
	
	/**
	\brief Localised strings for days of the week and months of the year.
	\details
	To create your own local strings, add a locale object to the locales object.
	The key of your object should be the same as your locale name.  For example:
	   en-US,
	   fr,
	   fr-CH,
	   de-DE
	Names are case sensitive and are described at http://www.w3.org/TR/REC-html40/struct/dirlang.html#langcodes
	Your locale object must contain the following keys:
	\param a	Short names of days of week starting with Sunday
	\param A	Long names days of week starting with Sunday
	\param b	Short names of months of the year starting with January
	\param B	Long names of months of the year starting with February
	\param c	The preferred date and time representation in your locale
	\param p	AM or PM in your locale
	\param P	am or pm in your locale
	\param x	The  preferred date representation for the current locale without the time.
	\param X	The preferred time representation for the current locale without the date.
	
	\sa Date.ext.locales.en for a sample implementation
	\sa \ref localisation for detailed documentation on localising strftime for your own locale
	*/
	Date.ext.locales = {};
	
	/**
	 * \brief Localised strings for English (British).
	 * \details
	 * This will be used for any of the English dialects unless overridden by a country specific one.
	 * This is the default locale if none specified
	 */
	Date.ext.locales.en = {
	  a: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
	  A: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
	  b: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
	  B: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
	  c: '%a %d %b %Y %T %Z',
	  p: ['AM', 'PM'],
	  P: ['am', 'pm'],
	  x: '%d/%m/%y',
	  X: '%T'
	};
	
	//! \cond FALSE
	// Localised strings for US English
	Date.ext.locales['en-US'] = Date.ext.locales.en;
	Date.ext.locales['en-US'].c = '%a %d %b %Y %r %Z';
	Date.ext.locales['en-US'].x = '%D';
	Date.ext.locales['en-US'].X = '%r';
	
	// Localised strings for British English
	Date.ext.locales['en-GB'] = Date.ext.locales.en;
	
	// Localised strings for Australian English
	Date.ext.locales['en-AU'] = Date.ext.locales['en-GB'];
	//! \endcond
	
	//! \brief List of supported format specifiers.
	/**
	 * \details
	 * \arg \%a - abbreviated weekday name according to the current locale
	 * \arg \%A - full weekday name according to the current locale
	 * \arg \%b - abbreviated month name according to the current locale
	 * \arg \%B - full month name according to the current locale
	 * \arg \%c - preferred date and time representation for the current locale
	 * \arg \%C - century number (the year divided by 100 and truncated to an integer, range 00 to 99)
	 * \arg \%d - day of the month as a decimal number (range 01 to 31)
	 * \arg \%D - same as %m/%d/%y
	 * \arg \%e - day of the month as a decimal number, a single digit is preceded by a space (range ' 1' to '31')
	 * \arg \%g - like %G, but without the century
	 * \arg \%G - The 4-digit year corresponding to the ISO week number
	 * \arg \%h - same as %b
	 * \arg \%H - hour as a decimal number using a 24-hour clock (range 00 to 23)
	 * \arg \%I - hour as a decimal number using a 12-hour clock (range 01 to 12)
	 * \arg \%j - day of the year as a decimal number (range 001 to 366)
	 * \arg \%m - month as a decimal number (range 01 to 12)
	 * \arg \%M - minute as a decimal number
	 * \arg \%n - newline character
	 * \arg \%p - either `AM' or `PM' according to the given time value, or the corresponding strings for the current locale
	 * \arg \%P - like %p, but lower case
	 * \arg \%r - time in a.m. and p.m. notation equal to %I:%M:%S %p
	 * \arg \%R - time in 24 hour notation equal to %H:%M
	 * \arg \%S - second as a decimal number
	 * \arg \%t - tab character
	 * \arg \%T - current time, equal to %H:%M:%S
	 * \arg \%u - weekday as a decimal number [1,7], with 1 representing Monday
	 * \arg \%U - week number of the current year as a decimal number, starting with
	 *            the first Sunday as the first day of the first week
	 * \arg \%V - The ISO 8601:1988 week number of the current year as a decimal number,
	 *            range 01 to 53, where week 1 is the first week that has at least 4 days
	 *            in the current year, and with Monday as the first day of the week.
	 * \arg \%w - day of the week as a decimal, Sunday being 0
	 * \arg \%W - week number of the current year as a decimal number, starting with the
	 *            first Monday as the first day of the first week
	 * \arg \%x - preferred date representation for the current locale without the time
	 * \arg \%X - preferred time representation for the current locale without the date
	 * \arg \%y - year as a decimal number without a century (range 00 to 99)
	 * \arg \%Y - year as a decimal number including the century
	 * \arg \%z - numerical time zone representation
	 * \arg \%Z - time zone name or abbreviation
	 * \arg \%% - a literal `\%' character
	 */
	Date.ext.formats = {
	  a: function a(d) {
	    return Date.ext.locales[d.locale].a[d.getDay()];
	  },
	  A: function A(d) {
	    return Date.ext.locales[d.locale].A[d.getDay()];
	  },
	  b: function b(d) {
	    return Date.ext.locales[d.locale].b[d.getMonth()];
	  },
	  B: function B(d) {
	    return Date.ext.locales[d.locale].B[d.getMonth()];
	  },
	  c: 'toLocaleString',
	  C: function C(d) {
	    return Date.ext.util.xPad(parseInt(d.getFullYear() / 100, 10), 0);
	  },
	  d: ['getDate', '0'],
	  e: ['getDate', ' '],
	  g: function g(d) {
	    return Date.ext.util.xPad(parseInt(Date.ext.util.G(d) / 100, 10), 0);
	  },
	  G: function G(d) {
	    var y = d.getFullYear();
	    var V = parseInt(Date.ext.formats.V(d), 10);
	    var W = parseInt(Date.ext.formats.W(d), 10);
	
	    if (W > V) {
	      y++;
	    } else if (W === 0 && V >= 52) {
	      y--;
	    }
	
	    return y;
	  },
	  H: ['getHours', '0'],
	  I: function I(d) {
	    var I = d.getHours() % 12;return Date.ext.util.xPad(I === 0 ? 12 : I, 0);
	  },
	  j: function j(d) {
	    var ms = d - new Date('' + d.getFullYear() + '/1/1 GMT');
	    ms += d.getTimezoneOffset() * 60000;
	    var doy = parseInt(ms / 60000 / 60 / 24, 10) + 1;
	    return Date.ext.util.xPad(doy, 0, 100);
	  },
	  l: function l(d) {
	    var I = d.getHours() % 12;return I === 0 ? 12 : I;
	  },
	  m: function m(d) {
	    return Date.ext.util.xPad(d.getMonth() + 1, 0);
	  },
	  M: ['getMinutes', '0'],
	  p: function p(d) {
	    return Date.ext.locales[d.locale].p[d.getHours() >= 12 ? 1 : 0];
	  },
	  P: function P(d) {
	    return Date.ext.locales[d.locale].P[d.getHours() >= 12 ? 1 : 0];
	  },
	  S: ['getSeconds', '0'],
	  u: function u(d) {
	    var dow = d.getDay();return dow === 0 ? 7 : dow;
	  },
	  U: function U(d) {
	    var doy = parseInt(Date.ext.formats.j(d), 10);
	    var rdow = 6 - d.getDay();
	    var woy = parseInt((doy + rdow) / 7, 10);
	    return Date.ext.util.xPad(woy, 0);
	  },
	  V: function V(d) {
	    var woy = parseInt(Date.ext.formats.W(d), 10);
	    var dow1_1 = new Date('' + d.getFullYear() + '/1/1').getDay();
	    // First week is 01 and not 00 as in the case of %U and %W,
	    // so we add 1 to the final result except if day 1 of the year
	    // is a Monday (then %W returns 01).
	    // We also need to subtract 1 if the day 1 of the year is 
	    // Friday-Sunday, so the resulting equation becomes:
	    var idow = woy + (dow1_1 > 4 || dow1_1 <= 1 ? 0 : 1);
	    if (idow == 53 && new Date('' + d.getFullYear() + '/12/31').getDay() < 4) {
	      idow = 1;
	    } else if (idow === 0) {
	      idow = Date.ext.formats.V(new Date('' + (d.getFullYear() - 1) + '/12/31'));
	    }
	
	    return Date.ext.util.xPad(idow, 0);
	  },
	  w: 'getDay',
	  W: function W(d) {
	    var doy = parseInt(Date.ext.formats.j(d), 10);
	    var rdow = 7 - Date.ext.formats.u(d);
	    var woy = parseInt((doy + rdow) / 7, 10);
	    return Date.ext.util.xPad(woy, 0, 10);
	  },
	  y: function y(d) {
	    return Date.ext.util.xPad(d.getFullYear() % 100, 0);
	  },
	  Y: 'getFullYear',
	  z: function z(d) {
	    var o = d.getTimezoneOffset();
	    var H = Date.ext.util.xPad(parseInt(Math.abs(o / 60), 10), 0);
	    var M = Date.ext.util.xPad(o % 60, 0);
	    return (o > 0 ? '-' : '+') + H + M;
	  },
	  Z: function Z(d) {
	    return d.toString().replace(/^.*\(([^)]+)\)$/, '$1');
	  },
	  '%': function _() {
	    return '%';
	  }
	};
	
	/**
	\brief List of aggregate format specifiers.
	\details
	Aggregate format specifiers map to a combination of basic format specifiers.
	These are implemented in terms of Date.ext.formats.
	
	A format specifier that maps to 'locale' is read from Date.ext.locales[current-locale].
	
	\sa Date.ext.formats
	*/
	Date.ext.aggregates = {
	  c: 'locale',
	  D: '%m/%d/%y',
	  h: '%b',
	  n: '\n',
	  r: '%I:%M:%S %p',
	  R: '%H:%M',
	  t: '\t',
	  T: '%H:%M:%S',
	  x: 'locale',
	  X: 'locale'
	};
	
	//! \cond FALSE
	// Cache timezone values because they will never change for a given JS instance
	Date.ext.aggregates.z = Date.ext.formats.z(new Date());
	Date.ext.aggregates.Z = Date.ext.formats.Z(new Date());
	//! \endcond
	
	//! List of unsupported format specifiers.
	/**
	 * \details
	 * All format specifiers supported by the PHP implementation are supported by
	 * this javascript implementation.
	 */
	Date.ext.unsupported = {};
	
	/**
	 * \brief Formats the date according to the specified format.
	 * \param fmt	The format to format the date in.  This may be a combination of the following:
	 * \copydoc formats
	 *
	 * \return	A string representation of the date formatted based on the passed in parameter
	 * \sa http://www.php.net/strftime for documentation on format specifiers
	*/
	Date.prototype.strftime = function (fmt) {
	  // Fix locale if declared locale hasn't been defined
	  // After the first call this condition should never be entered unless someone changes the locale
	  if (!(this.locale in Date.ext.locales)) {
	    if (this.locale.replace(/-[a-zA-Z]+$/, '') in Date.ext.locales) {
	      this.locale = this.locale.replace(/-[a-zA-Z]+$/, '');
	    } else {
	      this.locale = 'en-GB';
	    }
	  }
	
	  var d = this;
	  // First replace aggregates
	  while (fmt.match(/%[cDhnrRtTxXzZ]/)) {
	    fmt = fmt.replace(/%([cDhnrRtTxXzZ])/g, function (m0, m1) {
	      var f = Date.ext.aggregates[m1];
	      return f == 'locale' ? Date.ext.locales[d.locale][m1] : f;
	    });
	  }
	
	  // Now replace formats - we need a closure so that the date object gets passed through
	  var str = fmt.replace(/%([aAbBCdegGHIjlmMpPSuUVwWyY%])/g, function (m0, m1) {
	    var f = Date.ext.formats[m1];
	    if (typeof f == 'string') {
	      return d[f]();
	    } else if (typeof f == 'function') {
	      return f.call(d, d);
	    } else if ((typeof f === 'undefined' ? 'undefined' : _typeof(f)) == 'object' && typeof f[0] == 'string') {
	      return Date.ext.util.xPad(d[f[0]](), f[1]);
	    } else {
	      return m1;
	    }
	  });
	  d = null;
	  return str;
	};
	
	/**
	 * \mainpage strftime for Javascript
	 *
	 * \section toc Table of Contents
	 * - \ref intro_sec
	 * - <a class="el" href="strftime.js">Download full source</a> / <a class="el" href="strftime-min.js">minified</a>
	 * - \subpage usage
	 * - \subpage format_specifiers
	 * - \subpage localisation
	 * - \link strftime.js API Documentation \endlink
	 * - \subpage demo
	 * - \subpage changelog
	 * - \subpage faq
	 * - <a class="el" href="http://tech.bluesmoon.info/2008/04/strftime-in-javascript.html">Feedback</a>
	 * - \subpage copyright_licence
	 *
	 * \section intro_sec Introduction
	 *
	 * C and PHP developers have had access to a built in strftime function for a long time.
	 * This function is an easy way to format dates and times for various display needs.
	 *
	 * This library brings the flexibility of strftime to the javascript Date object
	 *
	 * Use this library if you frequently need to format dates in javascript in a variety of ways.  For example,
	 * if you have PHP code that writes out formatted dates, and want to mimic the functionality using
	 * progressively enhanced javascript, then this library can do exactly what you want.
	 *
	 *
	 *
	 *
	 * \page usage Example usage
	 *
	 * \section usage_sec Usage
	 * This library may be used as follows:
	 * \code
	 *     var d = new Date();
	 *
	 *     var ymd = d.strftime('%Y/%m/%d');
	 *     var iso = d.strftime('%Y-%m-%dT%H:%M:%S%z');
	 *
	 * \endcode
	 *
	 * \subsection examples Examples
	 * 
	 * To get the current time in hours and minutes:
	 * \code
	 * 	var d = new Date();
	 * 	d.strftime("%H:%M");
	 * \endcode
	 *
	 * To get the current time with seconds in AM/PM notation:
	 * \code
	 * 	var d = new Date();
	 * 	d.strftime("%r");
	 * \endcode
	 *
	 * To get the year and day of the year for August 23, 2009:
	 * \code
	 * 	var d = new Date('2009/8/23');
	 * 	d.strftime("%Y-%j");
	 * \endcode
	 *
	 * \section demo_sec Demo
	 *
	 * Try your own examples on the \subpage demo page.  You can use any of the supported
	 * \subpage format_specifiers.
	 *
	 *
	 *
	 *
	 * \page localisation Localisation
	 * You can localise strftime by implementing the short and long forms for days of the
	 * week and months of the year, and the localised aggregates for the preferred date
	 * and time representation for your locale.  You need to add your locale to the
	 * Date.ext.locales object.
	 *
	 * \section localising_fr Localising for french
	 *
	 * For example, this is how we'd add French language strings to the locales object:
	 * \dontinclude index.html
	 * \skip Generic french
	 * \until };
	 * The % format specifiers are all defined in \ref formats.  You can use any of those.
	 *
	 * This locale definition may be included in your own source file, or in the HTML file
	 * including \c strftime.js, however it must be defined \em after including \c strftime.js
	 *
	 * The above definition includes generic french strings and formats that are used in France.
	 * Other french speaking countries may have other representations for dates and times, so we
	 * need to override this for them.  For example, Canadian french uses a Y-m-d date format,
	 * while French french uses d.m.Y.  We fix this by defining Canadian french to be the same
	 * as generic french, and then override the format specifiers for \c x for the \c fr-CA locale:
	 * \until End french
	 *
	 * You can now use any of the French locales at any time by setting \link Date.prototype.locale Date.locale \endlink
	 * to \c "fr", \c "fr-FR", \c "fr-CA", or any other french dialect:
	 * \code
	 *     var d = new Date("2008/04/22");
	 *     d.locale = "fr";
	 *
	 *     d.strftime("%A, %d %B == %x");
	 * \endcode
	 * will return:
	 * \code
	 *     mardi, 22 avril == 22.04.2008
	 * \endcode
	 * While changing the locale to "fr-CA":
	 * \code
	 *     d.locale = "fr-CA";
	 *
	 *     d.strftime("%A, %d %B == %x");
	 * \endcode
	 * will return:
	 * \code
	 *     mardi, 22 avril == 2008-04-22
	 * \endcode
	 *
	 * You can use any of the format specifiers defined at \ref formats
	 *
	 * The locale for all dates defaults to the value of the \c lang attribute of your HTML document if
	 * it is set, or to \c "en" otherwise.
	 * \note
	 * Your locale definitions \b MUST be added to the locale object before calling
	 * \link Date.prototype.strftime Date.strftime \endlink.
	 *
	 * \sa \ref formats for a list of format specifiers that can be used in your definitions
	 * for c, x and X.
	 *
	 * \section locale_names Locale names
	 *
	 * Locale names are defined in RFC 1766. Typically, a locale would be a two letter ISO639
	 * defined language code and an optional ISO3166 defined country code separated by a -
	 * 
	 * eg: fr-FR, de-DE, hi-IN
	 *
	 * \sa http://www.ietf.org/rfc/rfc1766.txt
	 * \sa http://www.loc.gov/standards/iso639-2/php/code_list.php
	 * \sa http://www.iso.org/iso/country_codes/iso_3166_code_lists/english_country_names_and_code_elements.htm
	 * 
	 * \section locale_fallback Locale fallbacks
	 *
	 * If a locale object corresponding to the fully specified locale isn't found, an attempt will be made
	 * to fall back to the two letter language code.  If a locale object corresponding to that isn't found
	 * either, then the locale will fall back to \c "en".  No warning will be issued.
	 *
	 * For example, if we define a locale for de:
	 * \until };
	 * Then set the locale to \c "de-DE":
	 * \code
	 *     d.locale = "de-DE";
	 *
	 *     d.strftime("%a, %d %b");
	 * \endcode
	 * In this case, the \c "de" locale will be used since \c "de-DE" has not been defined:
	 * \code
	 *     Di, 22 Apr
	 * \endcode
	 *
	 * Swiss german will return the same since it will also fall back to \c "de":
	 * \code
	 *     d.locale = "de-CH";
	 *
	 *     d.strftime("%a, %d %b");
	 * \endcode
	 * \code
	 *     Di, 22 Apr
	 * \endcode
	 *
	 * We need to override the \c a specifier for Swiss german, since it's different from German german:
	 * \until End german
	 * We now get the correct results:
	 * \code
	 *     d.locale = "de-CH";
	 *
	 *     d.strftime("%a, %d %b");
	 * \endcode
	 * \code
	 *     Die, 22 Apr
	 * \endcode
	 *
	 * \section builtin_locales Built in locales
	 *
	 * This library comes with pre-defined locales for en, en-GB, en-US and en-AU.
	 *
	 * 
	 *
	 *
	 * \page format_specifiers Format specifiers
	 * 
	 * \section specifiers Format specifiers
	 * strftime has several format specifiers defined by the Open group at 
	 * http://www.opengroup.org/onlinepubs/007908799/xsh/strftime.html
	 *
	 * PHP added a few of its own, defined at http://www.php.net/strftime
	 *
	 * This javascript implementation supports all the PHP specifiers
	 *
	 * \subsection supp Supported format specifiers:
	 * \copydoc formats
	 * 
	 * \subsection unsupportedformats Unsupported format specifiers:
	 * \copydoc unsupported
	 *
	 *
	 *
	 *
	 * \page demo strftime demo
	 * <div style="float:right;width:45%;">
	 * \copydoc formats
	 * </div>
	 * \htmlinclude index.html
	 *
	 *
	 *
	 *
	 * \page faq FAQ
	 * 
	 * \section how_tos Usage
	 *
	 * \subsection howtouse Is there a manual on how to use this library?
	 *
	 * Yes, see \ref usage
	 *
	 * \subsection wheretoget Where can I get a minified version of this library?
	 *
	 * The minified version is available <a href="strftime-min.js" title="Minified strftime.js">here</a>.
	 *
	 * \subsection which_specifiers Which format specifiers are supported?
	 *
	 * See \ref format_specifiers
	 *
	 * \section whys Why?
	 *
	 * \subsection why_lib Why this library?
	 *
	 * I've used the strftime function in C, PHP and the Unix shell, and found it very useful
	 * to do date formatting.  When I needed to do date formatting in javascript, I decided
	 * that it made the most sense to just reuse what I'm already familiar with.
	 *
	 * \subsection why_another Why another strftime implementation for Javascript?
	 *
	 * Yes, there are other strftime implementations for Javascript, but I saw problems with
	 * all of them that meant I couldn't use them directly.  Some implementations had bad
	 * designs.  For example, iterating through all possible specifiers and scanning the string
	 * for them.  Others were tied to specific libraries like prototype.
	 *
	 * Trying to extend any of the existing implementations would have required only slightly
	 * less effort than writing this from scratch.  In the end it took me just about 3 hours
	 * to write the code and about 6 hours battling with doxygen to write these docs.
	 *
	 * I also had an idea of how I wanted to implement this, so decided to try it.
	 *
	 * \subsection why_extend_date Why extend the Date class rather than subclass it?
	 *
	 * I tried subclassing Date and failed.  I didn't want to waste time on figuring
	 * out if there was a problem in my code or if it just wasn't possible.  Adding to the
	 * Date.prototype worked well, so I stuck with it.
	 *
	 * I did have some worries because of the way for..in loops got messed up after json.js added
	 * to the Object.prototype, but that isn't an issue here since {} is not a subclass of Date.
	 *
	 * My last doubt was about the Date.ext namespace that I created.  I still don't like this,
	 * but I felt that \c ext at least makes clear that this is external or an extension.
	 *
	 * It's quite possible that some future version of javascript will add an \c ext or a \c locale
	 * or a \c strftime property/method to the Date class, but this library should probably
	 * check for capabilities before doing what it does.
	 *
	 * \section curiosity Curiosity
	 *
	 * \subsection how_big How big is the code?
	 *
	 * \arg 26K bytes with documentation
	 * \arg 4242 bytes minified using <a href="http://developer.yahoo.com/yui/compressor/">YUI Compressor</a>
	 * \arg 1477 bytes minified and gzipped
	 *
	 * \subsection how_long How long did it take to write this?
	 *
	 * 15 minutes for the idea while I was composing this blog post:
	 * http://tech.bluesmoon.info/2008/04/javascript-date-functions.html
	 *
	 * 3 hours in one evening to write v1.0 of the code and 6 hours the same
	 * night to write the docs and this manual.  As you can tell, I'm fairly
	 * sleepy.
	 *
	 * Versions 1.1 and 1.2 were done in a couple of hours each, and version 1.3
	 * in under one hour.
	 *
	 * \section contributing Contributing
	 *
	 * \subsection how_to_rfe How can I request features or make suggestions?
	 *
	 * You can leave a comment on my blog post about this library here:
	 * http://tech.bluesmoon.info/2008/04/strftime-in-javascript.html
	 *
	 * \subsection how_to_contribute Can I/How can I contribute code to this library?
	 *
	 * Yes, that would be very nice, thank you.  You can do various things.  You can make changes
	 * to the library, and make a diff against the current file and mail me that diff at
	 * philip@bluesmoon.info, or you could just host the new file on your own servers and add
	 * your name to the copyright list at the top stating which parts you've added.
	 *
	 * If you do mail me a diff, let me know how you'd like to be listed in the copyright section.
	 *
	 * \subsection copyright_signover Who owns the copyright on contributed code?
	 *
	 * The contributor retains copyright on contributed code.
	 *
	 * In some cases I may use contributed code as a template and write the code myself.  In this
	 * case I'll give the contributor credit for the idea, but will not add their name to the
	 * copyright holders list.
	 *
	 *
	 *
	 *
	 * \page copyright_licence Copyright & Licence
	 *
	 * \section copyright Copyright
	 * \dontinclude strftime.js
	 * \skip Copyright
	 * \until rights
	 *
	 * \section licence Licence
	 * \skip This code
	 * \until SUCH DAMAGE.
	 *
	 *
	 *
	 * \page changelog ChangeLog
	 *
	 * \par 1.3 - 2008/06/17:
	 * - Fixed padding issue with negative timezone offsets in %r
	 *   reported and fixed by Mikko:
	 *   http://tech.bluesmoon.info/2008/04/strftime-in-javascript.html
	 * - Added support for %P
	 * - Internationalised %r, %p and %P
	 *
	 * \par 1.2 - 2008/04/27:
	 * - Fixed support for c (previously it just returned toLocaleString())
	 * - Add support for c, x and X
	 * - Add locales for en-GB, en-US and en-AU
	 * - Make en-GB the default locale (previous was en)
	 * - Added more localisation docs
	 *
	 * \par 1.1 - 2008/04/27:
	 * - Fix bug in xPad which wasn't padding more than a single digit
	 * - Fix bug in j which had an off by one error for days after March 10th because of daylight savings
	 * - Add support for g, G, U, V and W
	 *
	 * \par 1.0 - 2008/04/22:
	 * - Initial release with support for a, A, b, B, c, C, d, D, e, H, I, j, m, M, p, r, R, S, t, T, u, w, y, Y, z, Z, and %
	 */

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(237))(5);

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(73);
	__webpack_require__(13);
	__webpack_require__(26);
	__webpack_require__(5);
	__webpack_require__(75);
	__webpack_require__(30);

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	'use strict';
	
	Routes = window.Routes || {};
	
	$(function () {
	  rwgps.Events.bind("metrics:changed", Routes.Common.updateMetrics);
	
	  var sel = '#cue_sheet_preview tr, .cue_sheet_preview tr';
	  $(document).on('mouseenter', sel, function () {
	    var $this = $(this);
	    var cp = $this.data("coursepoint");
	    if (cp === undefined) return;
	    $('#cue_sheet_preview tr, .cue_sheet_preview tr').css({ 'background-color': '' });
	    $this.css({ 'background-color': '#E7E7E7', 'cursor': 'pointer' });
	
	    if (Routes.activeMap) {
	      Routes.activeMap.callWhenReady(function () {
	        Routes.activeMap.openCoursePointInfoWindow(cp, false);
	      });
	    }
	  }).on('mouseleave', sel, function () {
	    var $this = $(this);
	    $this.css({ 'background-color': '' });
	
	    if (Routes.activeMap) {
	      Routes.activeMap.callWhenReady(function () {
	        Routes.activeMap.closePreviewInfoWindow();
	      });
	    }
	  }).on('click', sel, function () {
	    var $this = $(this);
	    Routes.activeMap.callWhenReady(function () {
	      Routes.activeMap.openCoursePointInfoWindow($this.data("coursepoint"), true);
	    });
	    $('#cue_sheet_preview tr, .cue_sheet_preview tr').removeClass('openCoursePointInfo');
	    $this.addClass('openCoursePointInfo');
	  });
	});
	
	Routes.Common = {
	  pois: [],
	  onMapCleared: function onMapCleared() {
	    this.pois = [];
	  },
	  geocodeResult: function geocodeResult(countryCode, administrativeArea, locality, postalCode) {
	    var geo = { country_code: countryCode, administrative_area: administrativeArea, locality: locality, postal_code: postalCode };
	    $('#geodata').val(JSON.stringify(geo));
	  },
	  getRouteViewerOptions: function getRouteViewerOptions() {
	    var optsArray = [];
	    var i = 0;
	    $('#options input[type="checkbox"]').each(function () {
	      optsArray[i] = $(this).val() + ":" + $(this).attr('checked');
	      i++;
	    });
	    return optsArray;
	  },
	  resizeMap: function resizeMap() {
	    var offset = $('.globalNav').get(0).getClientRects()[0].top + $('.globalNav').outerHeight();
	    var wh = window.innerHeight ? window.innerHeight - offset : $(window).height() - offset;
	
	    var tipsHeight = $('#page_tips:visible').height() || 0;
	
	    $('.fullpage_left_col,.fullpage_right_col').height(wh);
	    $('#map,#new_route_map').height(wh);
	    if ($('#save_route_form').length != 0) {
	      $('.fullpage_left_col,.fullpage_right_col').css('height', $(window).height() - offset);
	    }
	    if ($('.sidebar_pages').length != 0) {
	      $('.sidebar_pages').each(function () {
	        var buffer = $(this).offset().top - offset;
	        $(this).height(wh - buffer);
	        if ($(this).parents('.fullpage_left_col').length > 0) {
	          $(this).height(wh - buffer - tipsHeight);
	        }
	      });
	    }
	    if ($('.fullpage_right_col .sidebar_pages').length != 0) {
	      if ($('#playback_container').length) {
	        $('.fullpage_right_col .sidebar_pages').height(wh - 153);
	      }
	    }
	    rwgps.Events.trigger('resizeMap:after');
	  },
	  populateCoursePoints: function populateCoursePoints(course_points, append) {
	    var $cuesheet_table = $('#cue_sheet_preview, .cue_sheet_preview');
	    //since we change background of only recently appended notes, fix old ones
	    $cuesheet_table.find("td").css({ "background-color": "#FFFFFF" });
	    if (!append) {
	      $cuesheet_table.empty();
	    }
	    if (course_points == null) return;
	    for (var i = 0; i < course_points.length; i++) {
	      $cuesheet_table.append(Routes.Common.createCoursePointRow(course_points[i], append));
	    }
	  },
	  createCoursePointRow: function createCoursePointRow(cp, append) {
	    $('#start_drawing_for_cue_sheet').hide();
	    var $row = $('<tr><td>' + _.escape(cp['notes']) + '</td><td>' + rwgps.LabelMaker.longLabel(cp['distance'], true) + '</td></tr>');
	    if (append) $row.find("td").css({ "background-color": "#E7E7E7" });
	    $row.data("coursepoint", cp);
	    cp.row = $row;
	    return $row;
	  },
	  prevCoursePointInfo: function prevCoursePointInfo(prevCPI) {
	    $('#cue_sheet_preview tr, .cue_sheet_preview tr').removeClass('openCoursePointInfo');
	    $('#' + prevCPI).addClass('openCoursePointInfo');
	  },
	  nextCoursePointInfo: function nextCoursePointInfo(nextCPI) {
	    $('#cue_sheet_preview tr, .cue_sheet_preview tr').removeClass('openCoursePointInfo');
	    $('#' + nextCPI).addClass('openCoursePointInfo');
	  },
	  updateMetrics: function updateMetrics(metrics, zoomedIn) {
	    if (!metrics || !metrics.v) return;
	    if (zoomedIn) $('.hide_zoomed_out').show();
	
	    if (metrics == null) {
	      metrics = {};
	    }
	
	    $('.changesOnZoom').toggleClass('zoomed_in', !!zoomedIn);
	
	    if (metrics.hasOwnProperty('cad') && metrics.cad.avg) {
	      $("#maxCad").text(metrics.cad.max + " rpm");
	      if (metrics.cad.max_i) $("#maxCad").data('i', metrics.cad.max_i);
	      $("#minCad").text(metrics.cad.min + " rpm");
	      if (metrics.cad.min_i) $("#minCad").data('i', metrics.cad.min_i);
	      $("#avgCad").text(metrics.cad.avg.toFixed(1) + " rpm");
	    }
	    if (metrics.hasOwnProperty('hr') && metrics.hr.avg) {
	      $("#maxHr").text(Math.round(metrics.hr.max) + " bpm");
	      if (metrics.hr.max_i) $("#maxHr").data('i', metrics.hr.max_i);
	      $("#minHr").text(Math.round(metrics.hr.min) + " bpm");
	      if (metrics.hr.min_i) $("#minHr").data('i', metrics.hr.min_i);
	      $("#avgHr").text(metrics.hr.avg.toFixed(1) + " bpm");
	    }
	    if (metrics.hasOwnProperty('watts') && metrics.watts.avg) {
	      $("#maxWatts").text(Math.round(metrics.watts.max));
	      if (metrics.watts.max_i) $("#maxWatts").data('i', metrics.watts.max_i);
	      $("#avgWattsWith0s").text(Math.round(metrics.watts._avg));
	      $("#avgWatts").text(Math.round(metrics.watts.avg));
	      $("#normalizedPower").text(Math.round(metrics.watts.normalized));
	      $("#workKJ").text(Math.round(metrics.kJ) + ' kJ');
	    }
	    if (metrics.hasOwnProperty('speed') && metrics.speed.avg) {
	      $("#maxSpeed").text(rwgps.LabelMaker.speedLabel(metrics.speed.max, true));
	      if (metrics.speed.max_i) $("#maxSpeed").data('i', metrics.speed.max_i);
	      $("#minSpeed").text(rwgps.LabelMaker.speedLabel(metrics.speed.min, true));
	      if (metrics.speed.min_i) $("#minSpeed").data('i', metrics.speed.min_i);
	      $("#avgSpeed").text(rwgps.LabelMaker.speedLabel(metrics.speed.avg, true));
	    }
	
	    if (metrics.hasOwnProperty('distance')) {
	      $(".txtDistance").text(rwgps.LabelMaker.longLabel(metrics.distance, true));
	    } else {
	      $(".txtDistance").text("");
	    }
	    if (!metrics.distance) {
	      $('.hide_unless_distance').hide();
	    } else {
	      $('.hide_unless_distance').show();
	    }
	    if (metrics.hasOwnProperty('ele_gain') && metrics.hasOwnProperty('ele_loss') && !isNaN(metrics.ele_loss) && !(metrics.ele_gain == 0 && metrics.ele_loss == 0)) {
	      $('.hide_unless_ele').show();
	      $(".txtAscent").text(rwgps.LabelMaker.shortLabel(metrics.ele_gain, false));
	      $(".txtDescent").text(rwgps.LabelMaker.shortLabel(metrics.ele_loss, true));
	    } else {
	      $('.hide_unless_ele').hide();
	    }
	    if (metrics.hasOwnProperty('vam')) {
	      $(".txtVam").text(Math.round(metrics.vam) + ' Vm/h');
	      if (Math.round(metrics.vam) == 0) $('.vamRow').hide();else $('.vamRow').show();
	    } else {
	      $('.vamRow').hide();
	    }
	    if (metrics.hasOwnProperty('ascentTime')) {
	      $(".txtAscentTime").text(rwgps.LabelMaker.durationLabel(metrics.ascentTime));
	      if (metrics.ascentTime == 0) $('.ascentRow').hide();else $('.ascentRow').show();
	    }
	    if (metrics.hasOwnProperty('descentTime')) {
	      $(".txtDescentTime").text(rwgps.LabelMaker.durationLabel(metrics.descentTime));
	      if (metrics.descentTime == 0) $('.descentRow').hide();else $('.descentRow').show();
	    }
	    if (metrics.hasOwnProperty('duration') && metrics.duration) {
	      $('#duration').text(rwgps.LabelMaker.durationLabel(metrics.duration));
	      $('#movingTime').text(rwgps.LabelMaker.durationLabel(metrics.movingTime));
	      $('#stoppedTime').text(rwgps.LabelMaker.durationLabel(metrics.stoppedTime));
	    }
	    if (metrics.hasOwnProperty('pace') && metrics.pace && metrics.movingPace) {
	      $('#pace').text(rwgps.LabelMaker.paceLabel(metrics.pace));
	      $('#movingPace').text(rwgps.LabelMaker.paceLabel(metrics.movingPace));
	    }
	    $('.txtTrackPoints').text(metrics.numPoints || 0);
	    try {
	      $('.txtCoursePoints').text(Routes.activeMap.activeRoute.coursePoints().length);
	    } catch (e) {
	      $('.txtCoursePoints').text("");
	    }
	    if (metrics.hasOwnProperty('ele')) {
	      $('.txtMinElevation').text(rwgps.LabelMaker.shortLabel(metrics.ele.min, true));
	      $('.txtMaxElevation').text(rwgps.LabelMaker.shortLabel(metrics.ele.max, true));
	      $('.txtAvgElevation').text(rwgps.LabelMaker.shortLabel(metrics.ele.avg, true));
	    } else {
	      $('.txtMinElevation').text("");
	      $('.txtMaxElevation').text("");
	      $('.txtAvgElevation').text("");
	    }
	    if (metrics.hasOwnProperty('startElevation') && !isNaN(metrics.startElevation)) $('.txtStartElevation').text(rwgps.LabelMaker.shortLabel(metrics.startElevation, true));else $('.txtStartElevation').text("");
	    if (metrics.hasOwnProperty('endElevation') && !isNaN(metrics.endElevation)) $('.txtFinishElevation').text(rwgps.LabelMaker.shortLabel(metrics.endElevation, true));else $('.txtFinishElevation').text("");
	    if (metrics.hasOwnProperty('grade')) {
	      if (metrics.grade.max) {
	        $('.txtMaxGrade').text(metrics.grade.max.toFixed(1) + " %");
	        if (metrics.grade.max_i) $(".txtMaxGrade").data('i', metrics.grade.max_i);
	      }
	      if (metrics.grade.avg) $('.txtAvgGrade').text(metrics.grade.avg.toFixed(1) + " %");
	    } else {
	      $('.txtMaxGrade').text('0 %');
	      $('.txtAvgGrade').text('0 %');
	    }
	    if (metrics.isClimb) {
	      $('.hide_unless_climb').show();
	      $('.txtCat').text(metrics.uciCategory);
	      $('.txtFiets').text(metrics.fietsIndex.toFixed(2));
	    } else {
	      $('.hide_unless_climb').hide();
	    }
	    if (metrics.estimatedTime) {
	      $('.hide_unless_estimatedTime').show();
	      $('.txtEstimatedTime').text(rwgps.LabelMaker.durationLabel(metrics.estimatedTime));
	    } else {
	      $('.hide_unless_estimatedTime').hide();
	    }
	    if (!zoomedIn) $('.hide_zoomed_out').hide();
	  },
	
	  populateTipOfTheDay: function populateTipOfTheDay() {
	    var index = Math.floor(Math.random() * Routes.Common.tipsOfTheDay.length);
	    var tip = Routes.Common.tipsOfTheDay[index];
	
	    $('#tip_link').attr('href', tip.link);
	    if (tip.link === '') {
	      $('#tip_link').hide();
	    }
	
	    $('#tip_text').text(tip.tip);
	  }
	};
	
	Routes.Common.tipsOfTheDay = [{
	  'tip': 'When planning or viewing a route, click and drag on the elevation profile to zoom in on a specific section of your route. Click the Edit link that appears to access advanced tools.',
	  'link': 'https://ridewithgps.com/help/the-elevation-profile-for-routes'
	}, {
	  'tip': "By changing the map style, you can switch between maps that focus on different information. Different styles use different routing data. If you get stuck while planning, or don't see a trail you want, switching your map style may help.",
	  'link': 'https://ridewithgps.com/help/switching-map-styles'
	}, {
	  'tip': 'Change the rules of the road by switching routing optimizations in the right hand sidebar. Don’t be afraid to try walking and driving modes, they can help route around obstructions. Click below to learn more about the different modes.',
	  'link': 'https://ridewithgps.com/help/planning#optimize-for'
	}, {
	  'tip': 'To join two routes together, click the Add Route button at the top of the left sidebar. Once your desired route is added to the map, join them by clicking the green dot. You can route from the end of one to the start of another by clicking on the map like usual.',
	  'link': 'https://ridewithgps.com/help/combining-and-splitting-routes#combining'
	}, {
	  'tip': "To split a route, click and drag on the elevation profile then click the Edit link that appears. You'll be able to then remove the selected section. The remaining route sections can be saved as separate routes, or you can reconnect them in a different way.",
	  'link': 'https://ridewithgps.com/help/combining-and-splitting-routes#splitting'
	}, {
	  'tip': 'Add Points of Interest (POI) to your map by clicking the Add POI button in the right sidebar, then clicking anywhere on the map. POI are shown on printed maps and cuesheets, as well as our mobile app during navigation.',
	  'link': 'https://ridewithgps.com/help/point-of-interest-pois#adding'
	}, {
	  'tip': 'Change the color of a section of your route by clicking and dragging the elevation profile, then clicking the Edit link. Select the change color option, or one of the other editing tools.',
	  'link': 'https://ridewithgps.com/help/edit-color-on-a-section-of-route'
	}, {
	  'tip': 'To delete a section of your route, click and drag on the elevation profile on the section you wish to delete, then click the Edit link. If you delete a selection in the middle of your route, you can re-join the remaining sections in a new way, or you can save them as separate routes.',
	  'link': 'https://ridewithgps.com/help/the-elevation-profile-for-routes#edit'
	}, {
	  'tip': 'You can click and drag your route to edit it. Mouse over the route, then click and drag the blue dot. Click below to learn how to control how much of your route changes when clicking and dragging.',
	  'link': 'https://ridewithgps.com/help/planning#add-remove-control-points'
	}, {
	  'tip': 'Add custom cues by clicking the Add to Cuesheet button in the right sidebar, then clicking the blue dot seen while mousing along your route. These cues will be available on printed maps and when navigating using the Ride with GPS app, a Garmin unit, or a Wahoo ELEMNT.',
	  'link': 'https://ridewithgps.com/help/edit-cue-sheet'
	}, {
	  'tip': 'Use the Draw Lines button in the right sidebar to switch from following roads and paths to drawing straight lines between clicks. This is helpful when working with trails that are not routable, or when dealing with unusual intersections or parking lots.',
	  'link': 'https://ridewithgps.com/help/planning#drawlines'
	}, {
	  'tip': 'Do you like keyboard shortcuts? If so, hit shift-? to get a cheat sheet of route planner hotkeys.',
	  'link': 'https://ridewithgps.com/routes/new#hotkey_modal'
	}, {
	  'tip': 'See more of your map by collapsing the right and left sidebars. Simply click the << and >> icons near the top of the sidebars to collapse them. Click the same icons to re-open them when you need to access route planning tools.'
	}];

/***/ }),
/* 9 */,
/* 10 */
/***/ (function(module, exports) {

	'use strict';
	
	rwgps.ns("postcards", function () {
	  // public namespace
	  var ns = this;
	
	  // image position and scale is serialized independent of postcard resolution. do not change, serialized layouts expect this value.
	  // res ind. px values scaled up by this factor
	  var noResPxNormFactor = 2 << 11;
	  // res ind. scale factors scaled up by this factor
	  var noResScaleNormFactor = 2 << 16;
	
	  var defaultAspectRatio = 3;
	
	  // filmstrip mode shows 3 photos in the metrics flippers, so we require at least 3 photos to enable it
	  var minImagesForFilmstrip = 3;
	
	  // private classes
	  var ImageScaler, ImageMover;
	
	  // structure of objects in postcard.images
	  var ImageProto = {
	    img: null, // the dom img element
	    origWidth: 0, // full res src dimension
	    origHeight: 0,
	    ratio: 0.0, // (w/h), used in autoconfiguring layout (placeImages)
	    src: '',
	    scale: 0.0, // orig dimensions * scale = display dimensions
	    marginLeft: 0.0, // relative to containing cell
	    marginTop: 0.0
	  };
	
	  var defaultOptions = {
	    cellSpacing: 1
	  };
	
	  ns.Postcard = function (postcardSel, options) {
	    this.$postcard = $(postcardSel);
	    this.$container = $('.imagecells', this.$postcard);
	    this.containerWidth = this.$container.width();
	    this.containerHeight = this.$container.height();
	    this.options = _.extend(options || {}, defaultOptions);
	
	    this.cells = []; // will contain all .cell elements
	    this.images = []; // will contain image specs
	    this.filmstripEnabled = false; // will get enabled once postcard is initialized with enough images
	
	    if (this.options.srcs || this.options.layout) {
	      this.init();
	    }
	  };
	
	  // event support for postcard instances
	  _.extend(ns.Postcard.prototype, Backbone.Events);
	  // and at the class level to apply to all postcards
	  _.extend(ns.Postcard, Backbone.Events);
	
	  var layouts = ns.Postcard.layouts = {
	    1: {},
	    2: {
	      row: [{}, { width: 1.5 }]
	    },
	    3: {
	      row: [{ width: 1.5 }, { stack: [{}, {}] }]
	    },
	    "3a": {
	      stack: [{}, { row: [{}, {}] }]
	    },
	    4: {
	      row: [{ stack: [{ height: 2 }, {}] }, { stack: [{}, { height: 2 }] }]
	    },
	    "4a": {
	      stack: [{ row: [{}, {}] }, { row: [{}, {}] }]
	    },
	    "4b": {
	      row: [{}, { stack: [{}, { row: [{}, {}] }] }]
	    },
	    "4c": {
	      stack: [{}, { row: [{}, {}, {}] }]
	    },
	    5: {
	      row: [{ stack: [{}, {}] }, {}, { stack: [{}, {}] }]
	    },
	    "5b": {
	      row: [{ width: 2 }, {
	        width: 3,
	        stack: [{ row: [{ width: 1 }, { width: 2 }] }, { row: [{ width: 2 }, { width: 1 }] }]
	      }]
	    },
	    6: {
	      row: [{
	        width: 2,
	        stack: [{ height: 2 }, { height: 1 }]
	      }, {
	        width: 4,
	        stack: [{ height: 1 }, {
	          height: 2,
	          row: [{ width: 2 }, {
	            width: 2,
	            stack: [{ height: 1 }, { height: 1 }] }] }] }]
	    },
	    "6a": {
	      stack: [{ row: [{}, {}, {}] }, { row: [{}, {}, {}] }]
	    },
	    "6b": {
	      row: [{ stack: [{ height: 2 }, { height: 1 }] }, { stack: [{ row: [{}, {}] }, { row: [{}, {}] }] }]
	    },
	    "gt6": {
	      row: [{
	        width: 2,
	        stack: [{ height: 2 }, { height: 1 }]
	      }, {
	        width: 4,
	        stack: [{ height: 1 }, {
	          height: 2,
	          row: [{ width: 2 }, {
	            width: 2,
	            stack: [{ height: 1 }, { height: 1,
	              row: [{}, {}]
	            }] }] }] }]
	
	    },
	    8: {
	      row: [{
	        width: 2,
	        stack: [{ height: 2 }, { height: 1 }]
	      }, {
	        width: 3,
	        stack: [{ height: 1 }, {
	          height: 2,
	          row: [{ width: 2 }, {
	            width: 2,
	            stack: [{ height: 1 }, { height: 1,
	              row: [{}, {}]
	            }] }] }]
	      }, {
	        width: 1
	      }] }
	  };
	
	  ns.Postcard.prototype.init = function (layoutKey) {
	    var layout;
	    // can init with a populated layout, or with a layout key & srcs, or just srcs
	    if (this.options.layout) {
	      layout = this.processLayout(this.options.layout);
	    } else if (!layoutKey && this.options.srcs) {
	      layoutKey = this.options.srcs.length > 6 ? "gt6" : this.options.srcs.length;
	    }
	    this.renderLayout(layout || layoutKey);
	    this.cells = $('.cell', this.$container).toArray();
	    this.images = [];
	    if (this.options.layout) {
	      this.loadImagesFromLayout();
	    } else if (this.options.srcs) {
	      this.loadImagesFromSrcs();
	    }
	
	    this.filmstripEnabled = !this.options.disableFilmstrip && !this.options.edit && this.images.length >= minImagesForFilmstrip;
	    if (this.filmstripEnabled) {
	      this.$postcard.addClass("filmstrip-enabled").addClass('clickable-images');
	      this.initFilmstrip();
	    }
	    if (this.options.clickableImages) {
	      this.initClickableImages();
	      this.$postcard.addClass("clickable-images");
	    }
	    if (this.options.edit) this.$postcard.addClass("edit-enabled");
	    if (this.options.fluid) this.initFluid();
	    this.initExpandoOverview();
	  };
	
	  ns.Postcard.prototype.enableFluid = function () {
	    var $pcWrapper = this.$container.closest('.ambassador-route-postcard');
	    if ($pcWrapper.size() > 0 && !this.options.fluid) {
	      $pcWrapper.addClass('fluid');
	      this.options.fluid = true;
	      this.initFluid();
	      this.fluidResize();
	    }
	  };
	
	  ns.Postcard.prototype.disableFluid = function () {
	    var $pcWrapper = this.$container.closest('.ambassador-route-postcard');
	    if ($pcWrapper.size() > 0 && this.options.fluid) {
	      $pcWrapper.removeClass('fluid');
	      this.options.fluid = false;
	      var w = $pcWrapper.width(),
	          h = Math.round(w / defaultAspectRatio);
	      this.$container.height(h);
	      if ($pcWrapper.hasClass('with_ambassador')) {
	        $pcWrapper.find('.inner-container').width(w);
	        // this is the width of the ambassador logo & name, including 10px of margin.
	        w -= 140;
	      }
	      this.$container.width(w);
	      this.renderIfSizeChanged();
	    }
	  };
	
	  ns.Postcard.prototype.initExpandoOverview = function () {
	    var $wrapper = this.$container.closest('.ambassador-route-postcard');
	
	    $wrapper.find('.route-overview a').on('click', function () {
	      var $footer = $(this).closest('.footer');
	      $footer.find('.route-overview').hide();
	      $footer.find('.full-overview').show();
	      return false;
	    });
	    $wrapper.find('.full-overview a').on('click', function () {
	      var $footer = $(this).closest('.footer');
	      $footer.find('.full-overview').hide();
	      $footer.find('.route-overview').show();
	      return false;
	    });
	  };
	
	  ns.Postcard.prototype.initFluid = function () {
	    // only init once
	    if (this._fluidResizeEnabled) return;
	    this._fluidResizeEnabled = true;
	
	    var pc = this;
	
	    var syncResizeOnFirstThenDebounce = function () {
	      var delayResize = 0,
	          debounceTime = 300;
	      return function () {
	        if (!delayResize) {
	          pc.fluidResize(); // do one resize immediately.
	          delayResize = -1; // but don't do another immediate resize
	          setTimeout(function () {
	            delayResize = 0;
	          }, debounceTime); // but reset that soon
	        } else {
	          // resize called again within our debounce time, so let's debounce it for real.
	          if (delayResize > 0) {
	            clearTimeout(delayResize); // we use -1 as our special val, otherwise it's a real timeout we need to clear
	          }
	          delayResize = setTimeout(function () {
	            delayResize = 0;pc.fluidResize();
	          }, debounceTime); // actually resize and reset!
	        }
	      };
	    }();
	
	    $(window).resize(syncResizeOnFirstThenDebounce);
	    // if the window resize even isn't thrown (for example find#index on map expansion), can trigger this event to resize all postcards on page
	    ns.Postcard.on('resize', syncResizeOnFirstThenDebounce);
	    this.fluidResize();
	  };
	
	  ns.Postcard.prototype.fluidResize = function () {
	    if (this.$container.length == 0) return;
	    if (!this.options.fluid) return;
	
	    var $fluid = this.$container.closest('.fluid'),
	        fullW = $fluid.width(),
	        w = fullW,
	        h = this.options.fixedHeight || Math.round(w / defaultAspectRatio);
	    if ($fluid.hasClass('with_ambassador')) {
	      // this is the width of the ambassador logo & name, including 10px of margin.
	      w -= 140;
	    }
	    $fluid.find('.inner-container').width(fullW);
	    this.$container.width(w).height(h);
	    this.renderIfSizeChanged();
	  };
	
	  ns.Postcard.prototype.renderIfSizeChanged = function () {
	    var newW = this.$container.width(),
	        newH = this.$container.height();
	    if (newW != this.containerWidth || newH != this.containerHeight) {
	      this.containerWidth = newW;
	      this.containerHeight = newH;
	      this.init();
	    }
	  };
	
	  // let user click on images and just fire an event that can be listened to
	  ns.Postcard.prototype.initClickableImages = function () {
	    var pc = this;
	    $('.flip-container', this.$container).on('click', function () {
	      var image = pc.images[$(this).find(".cell").attr('data-imageI')];
	      pc.trigger('image:click', image);
	    });
	  };
	
	  // set up filmstrip-mode, which let's a user click on a photo to see it larger, and nav through all photos
	  ns.Postcard.prototype.initFilmstrip = function () {
	    var pc = this;
	    // make it a circular doubly linked list for our filmstrip
	    for (var i = 0; i < this.images.length; i++) {
	      if (i === 0) this.images[i].prev = this.images[this.images.length - 1];else this.images[i].prev = this.images[i - 1];
	      if (i === this.images.length - 1) this.images[i].next = this.images[0];else this.images[i].next = this.images[i + 1];
	    }
	    $('.flip-container', this.$container).on('click', function () {
	      if ($(this).find(".metric-flipper").size() > 0 || !pc.filmstripEnabled) return;
	
	      pc.createSupercell();
	
	      var image = pc.images[$(this).find(".cell").attr('data-imageI')];
	      pc.showImageInSupercell(image);
	    });
	
	    this.$postcard.on("click", '.metric-flipper .back', function () {
	      var topPos = $(this).closest(".metric-flipper").position().top;
	      if (topPos === 200) {
	        pc.showImageInSupercell("next");
	      } else if (topPos === 0) {
	        pc.showImageInSupercell("prev");
	      }
	    });
	
	    this.$container.on('click', '.supercell', function () {
	      pc.showImageInSupercell("next");
	    });
	
	    this.$container.on('click', '.closesupercell', function () {
	      pc.$container.find('.supercell').remove();
	      $(this).remove();
	      _.each(pc.images, function (x) {
	        pc.fillCell(x.cell, x, true);
	      });
	      pc.flipMetrics(true);
	    });
	
	    $(".flip-container .front.cell", this.$container).on("mouseenter", function () {
	      $(this).closest(".flip-container").css({ zIndex: 3 });
	    }).on("mouseleave", function () {
	      $(this).closest(".flip-container").css({ zIndex: 2 });
	    });
	  };
	
	  // load only images necessary and render layout exactly as specified in layout spec
	  ns.Postcard.prototype.loadImagesFromLayout = function () {
	    var pc = this;
	    this._imagesToPlace = 0;
	    _.each(this.cells, function (cell) {
	      // layout specified image spec, expecting scale, margins, src
	      var imageOpts = $(cell).data('cell').imageOpts;
	      if (!imageOpts) return;
	
	      pc.placingImage();
	      var x = _.extend({}, ImageProto, imageOpts);
	      x.img = new Image();
	      x.img.src = x.src;
	      // if image no longer exists, handle gracefully  (so at least the postcard editor can be used)
	      x.img.onerror = function () {
	        pc.placedImage(cell);
	      };
	      x.img.onload = function (x) {
	        return function () {
	          x.origWidth = x.img.width;
	          x.origHeight = x.img.height;
	          x.ratio = x.origWidth / x.origHeight;
	          pc.images.push(x);
	          setTimeout(function (cell) {
	            return function () {
	              pc.fillCell(cell, x, true, false, "crossfade");
	              pc.placedImage();
	            };
	          }(cell), Math.random() * 200);
	        };
	      }(x);
	    }, this);
	  };
	
	  // load all images specified in srcs and autoconfigure layout
	  ns.Postcard.prototype.loadImagesFromSrcs = function () {
	    var pc = this;
	    var toLoad = 0;
	    for (var i = 0; i < this.options.srcs.length; i++) {
	      toLoad++;
	
	      var x = _.extend({}, ImageProto);
	      x.img = new Image();
	      x.img.src = x.src = this.options.srcs[i];
	      x.img.onload = function (x) {
	        return function () {
	          x.origWidth = x.img.width;
	          x.origHeight = x.img.height;
	          x.ratio = x.origWidth / x.origHeight;
	          toLoad--;
	          if (toLoad === 0) pc.placeImages();
	        };
	      }(x);
	      this.images.push(x);
	    }
	  };
	
	  // attempt to intelligently place images in the best cell, match images to cells by comparing aspect ratios
	  // (panos get dibs on wide cells)
	  ns.Postcard.prototype.placeImages = function () {
	    var pc = this;
	    this._imagesToPlace = 0;
	
	    this.images.sort(function (a, b) {
	      var r1 = a.ratio;
	      var r2 = b.ratio;
	      if (r1 > 1) r1 = 1 / r1;
	      if (r2 > 1) r2 = 1 / r2;
	      return r1 - r2;
	    });
	    var cellsIdx = _.map(this.cells, function (cell) {
	      var cw = $(cell).width();
	      var ch = $(cell).height();
	      var cratio = cw / ch;
	      return {
	        cell: cell,
	        cw: cw,
	        ch: ch,
	        cratio: cratio
	      };
	    });
	    _.each(this.images, function (x) {
	      if (cellsIdx.length === 0) return;
	      cellsIdx.sort(function (a, b) {
	        var r1 = a.cratio;
	        var r2 = b.cratio;
	        return Math.abs(r2 - x.ratio) - Math.abs(r1 - x.ratio);
	      });
	      var cellx = cellsIdx.shift();
	      x.cell = cellx.cell;
	      this.placingImage();
	      setTimeout(function (cell) {
	        return function () {
	          pc.fillCell(cell, x, true, false, "crossfade");
	          pc.placedImage();
	        };
	      }(cellx.cell), Math.random() * 200);
	    }, this);
	  };
	
	  // all the img tags are present on the page, images are loaded, the postcard is done initializing at this point
	  ns.Postcard.prototype.onImagesPlaced = function () {
	    if (this.options.edit) {
	      this.setupEditingTools();
	    }
	    // invoke callback if provided
	    if (this.options.onImagesPlaced) this.options.onImagesPlaced();
	  };
	
	  // handle the callback onImagesPlaced. need to track how many images we're waiting on (there is a random timeout)
	  ns.Postcard.prototype.placedImage = function (errorCell) {
	    if (errorCell) {
	      if (!this.errorCells) this.errorCells = [];
	      this.errorCells.push(errorCell);
	    }
	    this._imagesToPlace--;
	    if (this._imagesToPlace === 0) {
	      if (this.errorCells && this.errorCells.length > 0 && this.images.length > 0) {
	        _.each(this.errorCells, function (cell) {
	          // copy the first image and stick it in the error cell to get a non-broken postcard
	          var image = _.extend({}, this.images[0]);
	          image.img = image.img.cloneNode();
	          this.images.push(image);
	          this.fillCell($(cell), image, true, false, "crossfade");
	        }, this);
	      }
	      this.onImagesPlaced();
	    }
	  };
	  ns.Postcard.prototype.placingImage = function () {
	    this._imagesToPlace++;
	  };
	
	  ns.Postcard.prototype.renderLayout = function (layoutOrKey) {
	    if (_.isObject(layoutOrKey)) {
	      this.layout = layoutOrKey;
	    } else {
	      // snag the layout from our layout templates
	      this.layout = $.extend(true, {}, layouts[layoutOrKey]);
	    }
	    var cells = [];
	    var spacing = this.options.cellSpacing;
	    // walk nested, res-independent layout spec, and build list of actual size, absolutely positioned cells
	    (function parseLayout(layout, opts) {
	      // rows, stacks, and elements have lots in common, just require some translation.
	      var list, fixedDim, scaledDim, fixedOffset, variableOffset;
	      if (layout.row) {
	        list = layout.row;
	        fixedDim = "height";
	        scaledDim = "width";
	        fixedOffset = "top";
	        variableOffset = "left";
	      } else if (layout.stack) {
	        list = layout.stack;
	        fixedDim = "width";
	        scaledDim = "height";
	        fixedOffset = "left";
	        variableOffset = "top";
	      } else {
	        // reached cell-level element
	        opts = _.extend({}, opts);
	        opts.width -= spacing;
	        opts.height -= spacing;
	        opts.layoutObj = layout;
	        if (layout.image) {
	          opts.imageOpts = layout.image;
	        }
	        cells.push(opts);
	        return;
	      }
	      var totalAbsScaledDim = opts[scaledDim];
	      var totalRelScaledDim = 0;
	      _.each(list, function (x) {
	        if (!x[scaledDim]) x[scaledDim] = 1;
	        totalRelScaledDim += x[scaledDim];
	      });
	      var scalingFactor = totalAbsScaledDim / totalRelScaledDim;
	      var variableOffsetCursor = opts[variableOffset];
	      _.each(list, function (subLayout) {
	        var cellOpts = {};
	        cellOpts[variableOffset] = variableOffsetCursor;
	        cellOpts[fixedOffset] = opts[fixedOffset];
	        cellOpts[scaledDim] = Math.round(subLayout[scaledDim] * scalingFactor);
	        cellOpts[fixedDim] = opts[fixedDim];
	        parseLayout(subLayout, cellOpts);
	        variableOffsetCursor += cellOpts[scaledDim];
	      });
	    })(this.layout, { top: 0, left: 0, width: this.containerWidth, height: this.containerHeight });
	
	    // do a pass to fix rounding issues. this gets us perfect {spacing}px gaps separating images.
	    // on an 8 img test layout this is only 112 iterations, so not using sorted data structure
	    var ys = [],
	        xs = [],
	        eps = 5;
	    _.each(cells, function (cell) {
	      var i;
	      for (i = 0; i < ys.length; i++) {
	        if (Math.abs(cell.top - ys[i]) < eps) {
	          cell.top = ys[i];
	        }
	        if (Math.abs(cell.top + cell.height + spacing - ys[i]) < eps) {
	          cell.height = ys[i] - spacing - cell.top;
	        }
	      }
	      for (i = 0; i < xs.length; i++) {
	        if (Math.abs(cell.left - xs[i]) < eps) {
	          cell.left = xs[i];
	        }
	        if (Math.abs(cell.left + cell.width + spacing - xs[i]) < eps) {
	          cell.width = xs[i] - spacing - cell.left;
	        }
	      }
	      ys.push(cell.top);
	      ys.push(cell.top + cell.height + spacing);
	      xs.push(cell.left);
	      xs.push(cell.left + cell.width + spacing);
	    });
	
	    // build the layout dom and style it up so everything is pixel perfect
	    this.$container.empty();
	    var pc = this;
	    _.each(cells, function (cell) {
	      var $cell = $("<div class='flip-container'><div class='flipper'><div class='front cell'></div><div class='back'></div></div></div>");
	      $cell.css({
	        position: 'absolute',
	        width: cell.width,
	        height: cell.height,
	        top: cell.top,
	        left: cell.left
	      });
	      $cell.find('.front,.back').css({
	        width: cell.width,
	        height: cell.height
	      });
	      $cell.find('.cell').data('cell', cell);
	      pc.$container.append($cell);
	    });
	  };
	
	  // walk through a serialized layout and convert resolution independent values to values normalized for current postcard res
	  ns.Postcard.prototype.processLayout = function processLayout(serialized) {
	    var layout = {};
	    if (serialized.width) layout.width = serialized.width;
	    if (serialized.height) layout.height = serialized.height;
	
	    if (serialized.row) return _.extend(layout, { row: _.map(serialized.row, processLayout, this) });
	    if (serialized.stack) return _.extend(layout, { stack: _.map(serialized.stack, processLayout, this) });
	    if (serialized.image) {
	      if (this.options.editedImageUrls && serialized.image.editedImageId) {
	        layout.image = {
	          photoId: serialized.image.photoId,
	          src: this.options.editedImageUrls[serialized.image.editedImageId]
	        };
	      } else {
	        layout.image = {
	          photoId: serialized.image.photoId,
	          src: serialized.image.src,
	          scale: serialized.image.scaleNoRes * this.containerWidth / noResScaleNormFactor,
	          marginLeft: serialized.image.marginLeftNoRes * this.containerWidth / noResPxNormFactor,
	          marginTop: serialized.image.marginTopNoRes * this.containerHeight / noResPxNormFactor
	        };
	      }
	    }
	    return layout;
	  };
	
	  // serialize postcard layout with resolution independent values
	  var serializingTruncationFactor = 1000; // plenty of precision while avoiding full precision doubles that save as strings
	  ns.Postcard.prototype.serializeLayout = function (layout, photoIds) {
	    var serialized = {};
	    if (!layout) {
	      photoIds = [];
	      layout = this.layout;
	      serialized.photoIds = photoIds;
	    }
	    if (layout.width) serialized.width = layout.width;
	    if (layout.height) serialized.height = layout.height;
	
	    if (layout.row) return _.extend(serialized, { row: _.map(layout.row, function (x) {
	        return this.serializeLayout(x, photoIds);
	      }, this) });
	    if (layout.stack) return _.extend(serialized, { stack: _.map(layout.stack, function (x) {
	        return this.serializeLayout(x, photoIds);
	      }, this) });
	    if (layout.image) {
	      var photoId = parseInt(layout.image.src.match(/photos(?:\/\w+)?\/([0-9]+)/)[1]),
	          $cell = $(layout.image.img).closest('.cell'),
	          w = $cell.width(),
	          h = $cell.height(),
	          relW = this.containerWidth,
	          relH = this.containerHeight;
	
	      serialized.image = {
	        src: layout.image.src,
	        scaleNoRes: Math.floor(serializingTruncationFactor * noResScaleNormFactor * layout.image.scale / relW) / serializingTruncationFactor,
	        marginLeftNoRes: Math.floor(serializingTruncationFactor * noResPxNormFactor * layout.image.marginLeft / relW) / serializingTruncationFactor,
	        marginTopNoRes: Math.floor(serializingTruncationFactor * noResPxNormFactor * layout.image.marginTop / relH) / serializingTruncationFactor,
	        widthNoRes: Math.floor(serializingTruncationFactor * noResPxNormFactor * w / relW) / serializingTruncationFactor,
	        heightNoRes: Math.floor(serializingTruncationFactor * noResPxNormFactor * h / relH) / serializingTruncationFactor,
	        photoId: photoId
	      };
	      photoIds.push(photoId);
	    }
	    return serialized;
	  };
	
	  // put an image into a cell.
	  ns.Postcard.prototype.fillCell = function (cell, image, cropFill, clone, effect) {
	    var imageChanged = false; // most the time we're filling the cell for the very first time.
	    var $cell = $(cell);
	    var cw = $cell.width();
	    var ch = $cell.height();
	    var cratio = cw / ch;
	    var img;
	    if (clone) {
	      img = image.img.cloneNode();
	    } else {
	      $(image.img).remove();
	      img = image.img;
	    }
	    $(img).addClass('postcard-cell-image');
	    if (effect === "crossfade") {
	      var $oldImg = $cell.find('img.postcard-cell-image').css({ opacity: 0, position: 'absolute' }).removeClass('postcard-cell-image');
	      setTimeout(function () {
	        $oldImg.remove();
	      }, 600);
	      var $newImg = $(img);
	      $newImg.css({ position: 'absolute', opacity: 0 });
	      $cell.prepend($newImg);
	      setTimeout(function () {
	        $newImg.css({ opacity: 1 });
	      }, 0);
	    } else {
	      $cell.empty().append(img);
	    }
	    // maintain correctness of images list.
	    var imageI = _.indexOf(this.images, image);
	    if (imageI === -1) {
	      // not in the array? this cell has been filled in the past, so replace its previous image in our images array
	      imageI = $cell.attr('data-imageI');
	      this.images[imageI] = image;
	      imageChanged = true;
	    }
	    // update our dom-embedded ref back to the images list
	    $cell.attr('data-imageI', _.indexOf(this.images, image));
	
	    // figure out placement & size
	    if (image.scale) {
	      // layout spec provided us with a scale, use it.
	      //
	      // since we force the layout to round to whole pixels, and force a 1 px spacing between images, using the scale directly can
	      // result in an image that isn't quite wide or tall enough to fill the cell - usually off by 1 or a couple pixels.
	      //
	      // note: in some cases where the image has the same (or nearly the same) aspect ratio as its cell, after adjusting for 1 dimension the
	      // other dimension is still short. that's why the height test is another if, not if-else, after the width test.
	
	      var newW = image.scale * image.origWidth,
	          newH = image.scale * image.origHeight,
	          adjScale;
	      if (cw > newW) {
	        adjScale = cw / newW;
	        newW = cw;
	        newH *= adjScale;
	      }
	      if (ch > newH) {
	        adjScale = ch / newH;
	        newH = ch;
	        newW *= adjScale;
	      }
	      img.style.width = newW + 'px';
	      img.style.height = newH + "px";
	      img.style.marginLeft = (image.marginLeft + parseFloat(img.style.width) < cw ? cw - parseFloat(img.style.width) : image.marginLeft) + 'px';
	      img.style.marginTop = (image.marginTop + parseFloat(img.style.height) < ch ? ch - parseFloat(img.style.height) : image.marginTop) + 'px';
	    } else if (cropFill ? image.ratio > cratio : image.ratio < cratio) {
	      // fit vertically, center horizontally
	      newW = ch * image.ratio;
	      img.style.width = newW + "px";
	      img.style.height = ch + "px";
	      image.marginLeft = -((newW - cw) / 2);
	      image.marginTop = 0;
	      img.style.marginLeft = image.marginLeft + 'px';
	      img.style.marginTop = image.marginTop + 'px';
	    } else {
	      // fit horizontally, center vertically
	      img.style.width = cw + "px";
	      newH = 1 / image.ratio * cw;
	      img.style.height = newH + "px";
	      image.marginTop = -((newH - ch) / 2);
	      image.marginLeft = 0;
	      img.style.marginLeft = image.marginLeft + 'px';
	      img.style.marginTop = image.marginTop + 'px';
	    }
	
	    // if we're editing we need to reset the image scaler for this replaced image
	    if (imageChanged && this.options.edit) {
	      for (var i = 0; i < this.imageScalers.length; i++) {
	        if (this.imageScalers[i].$cell[0] === $cell[0]) {
	          this.imageScalers[i].imageChanged();
	          break;
	        }
	      }
	    }
	    var data = $cell.data('cell');
	    if (data && data.layoutObj) data.layoutObj.image = image;
	  };
	
	  ns.Postcard.prototype.setupEditingTools = function () {
	    var pc = this,
	        $cells = this.$postcard.find('.cell');
	
	    // set up image mover support.
	    $cells.on('mousedown', 'img.postcard-cell-image', function (e) {
	      if ($(e.currentTarget).hasClass('postcard-cell-image')) {
	        $(this).closest('.cell').find('.image-scaler').hide();
	        pc.startMoveImage(e, $(this));
	      }
	    });
	
	    // set up image scaler support.
	    pc.imageScalers = [];
	    $cells.each(function () {
	      var $cell = $(this),
	          scaler = new ImageScaler(pc, $cell);
	      scaler.$el.hide();
	      pc.imageScalers.push(scaler);
	    });
	    $cells.on('mouseover', function () {
	      if (!pc.imageScaler && !pc.imageMover) $(this).find('.image-scaler').show();
	    }).on('mouseout', function () {
	      if (!pc.imageScaler && !pc.imageMover) $(this).find('.image-scaler').hide();
	    });
	  };
	
	  // ImageMover <=> Postcard glue
	  ns.Postcard.prototype.startMoveImage = function (e, $img) {
	    this.imageMover = new ImageMover($img);
	    this.imageMover.start(this, e);
	  };
	  ns.Postcard.prototype.imageMoveComplete = function () {
	    var image = this.images[this.imageMover.$cell.attr('data-imageI')];
	    image.marginLeft = this.imageMover.pxStrToFloat(this.imageMover.$img.css('marginLeft'));
	    image.marginTop = this.imageMover.pxStrToFloat(this.imageMover.$img.css('marginTop'));
	    if (this.options.onImageMoveComplete) {
	      this.options.onImageMoveComplete();
	    }
	    delete this.imageMover;
	  };
	
	  // set up the main image view for filmstrip mode
	  ns.Postcard.prototype.createSupercell = function () {
	    var $cell = $('<div class="supercell"></div>');
	    $cell.css({
	      position: 'absolute',
	      left: 0,
	      top: 0,
	      width: 599,
	      height: 299,
	      backgroundColor: '#333'
	    });
	    this.$container.append($cell);
	
	    // and create abort button
	    var $abort = $("<div class='closesupercell'><i class='icon-reply icon-3x'></i></div>");
	    $abort.css({
	      position: 'absolute',
	      left: 10,
	      top: this.containerHeight - 53,
	      width: 42,
	      height: 43,
	      color: "#999",
	      cursor: "pointer"
	    });
	    this.$container.append($abort);
	  };
	
	  // spin the metrics around when going in/out of filmstrip mode
	  ns.Postcard.prototype.flipMetrics = function (reverse) {
	    var seqDelay = 50;
	    var toFlip = $('.metric-flipper', this.$postcard).closest('.flip-container').toArray();
	    if (reverse) toFlip.reverse();
	    (function flipNext() {
	      if (toFlip.length === 0) return;
	      var $nextFlip = $(toFlip.shift());
	      $nextFlip[reverse ? 'removeClass' : 'addClass']("hover");
	      $nextFlip.emulateTransitionEnd(400);
	      $nextFlip.find(reverse ? ".front" : ".back").css({ visibility: "visible" });
	      $nextFlip.one(transitionEndEvent, function () {
	        $(this).find(reverse ? ".back" : ".front").css({ visibility: "hidden" });
	      });
	      setTimeout(flipNext, seqDelay);
	    })();
	  };
	
	  // display an image in the main image view during filmstrip mode and update filmstrip cells
	  ns.Postcard.prototype.showImageInSupercell = function (image) {
	    if (image === "next" || image === "prev") {
	      var copyIdx, addFn, topOffset, imagePtrName, rmIdx, topOffsetChange;
	      if (image === "next") {
	        copyIdx = 2;
	        addFn = "after";
	        topOffset = 300;
	        imagePtrName = "next";
	        rmIdx = 0;
	        topOffsetChange = -100;
	      } else {
	        copyIdx = 0;
	        addFn = "before";
	        topOffset = -100;
	        imagePtrName = "prev";
	        rmIdx = 3;
	        topOffsetChange = 100;
	      }
	      var pc = this;
	      $(".metricscells", this.$postcard).queue(function () {
	        var $metricscells = $(this);
	        var stripTrio = $('.metric-flipper .back', $metricscells).toArray();
	        // create offscreen thumb
	        var anchorSlot = $(stripTrio[copyIdx]).closest('.flip-container').get(0);
	        var newSlot = anchorSlot.cloneNode(true);
	        $(newSlot).css({
	          top: topOffset
	        });
	        $(anchorSlot)[addFn](newSlot);
	        pc.fillCell($(newSlot).find('.back'), pc.images[$(stripTrio[copyIdx]).attr("data-imageI")][imagePtrName], true);
	
	        // and animate it!
	        var flippers = $(".metric-flipper", $metricscells).toArray();
	        if (image === "prev") flippers.reverse();
	        var lastFrontHtml;
	        (function animatem() {
	          if (flippers.length === 0) return;
	          var $flipper = $(flippers.shift());
	          $flipper.css({ top: $flipper.position().top + topOffsetChange });
	          var frontHtml = $flipper.find(".front").html();
	          $flipper.find('.front').html(lastFrontHtml);
	          lastFrontHtml = frontHtml;
	          setTimeout(animatem, 15);
	        })();
	        setTimeout(function () {
	          $($(".metric-flipper", $metricscells).get(rmIdx)).remove();
	          $metricscells.dequeue();
	        }, 430);
	      });
	      var $supercell = $(".supercell", this.$container);
	      this.fillCell($supercell, this.images[$supercell.attr("data-imageI")][imagePtrName], false, true, "crossfade");
	    } else {
	      this.fillCell($(".supercell", this.$container), image, false, true, "crossfade");
	      this.flipMetrics();
	      var stripTrio = $('.metric-flipper .back', this.$postcard).toArray();
	      this.fillCell(stripTrio[0], image.prev, true);
	      this.fillCell(stripTrio[1], image, true);
	      this.fillCell(stripTrio[2], image.next, true);
	    }
	  };
	
	  // editor tool to let user adjust image scaling by dragging a slider
	  // manages the scale property of image objects directly.
	  ImageScaler = function ImageScaler(postcard, $cell) {
	    this.postcard = postcard;
	    this.$cell = $cell;
	
	    this.currentSize = { width: 0, height: 0 };
	
	    this.buildSlider();
	    this.imageChanged();
	  };
	  ImageScaler.prototype = {
	    imageChanged: function imageChanged() {
	      // set up drag environment based on image in cell
	      this.image = this.postcard.images[this.$cell.attr('data-imageI')];
	      this.$img = $(this.image.img);
	      this.image.scale = $(this.image.img).height() / this.image.origHeight;
	      this.maxScale = 1;
	      this.minScale = this.calcMinScale();
	      this.scaleRange = this.maxScale - this.minScale;
	      this.renderSliderKnobPosition();
	    },
	    buildSlider: function buildSlider() {
	      this.$el = $(['<div class="image-scaler">', '<div class="slider-bar">', '<div class="slider-knob">', '</div></div></div>'].join(''));
	      this.$sliderKnob = this.$el.find('.slider-knob');
	      this.$cell.append(this.$el);
	      this.$el.width(this.$cell.width() - 20).css('top', this.$cell.height() - 20);
	
	      var scaler = this;
	      this.$el.find('.slider-bar').on('mousedown', function () {
	        scaler.onBarClick.apply(scaler, arguments);
	      });
	    },
	    calcMinScale: function calcMinScale() {
	      var ch = this.$cell.height(),
	          cw = this.$cell.width(),
	          cratio = cw / ch;
	      if (this.image.ratio > cratio) {
	        return ch / this.image.origHeight;
	      } else {
	        return cw / this.image.origWidth;
	      }
	    },
	    onBarClick: function onBarClick(e) {
	      this.setBoundedImageScale(e.pageX);
	      this.startDrag(e);
	      this.renderMove();
	    },
	    startDrag: function startDrag(e) {
	      this.postcard.imageScaler = this;
	
	      var centerX = this.$cell.width() / 2 + this.$cell.offset().left - this.$img.offset().left;
	      var centerY = this.$cell.height() / 2 + this.$cell.offset().top - this.$img.offset().top;
	      this.centerXPct = centerX / this.$img.width();
	      this.centerYPct = centerY / this.$img.height();
	
	      // cancel out any text selections
	      document.body.focus();
	      // prevent text selection in IE
	      document.onselectstart = function () {
	        return false;
	      };
	      // prevent stuff on the page from getting selected during drag
	      e.preventDefault();
	
	      var scaler = this;
	      this.onMouseMove = function () {
	        scaler.move.apply(scaler, arguments);
	      };
	      this.onMouseUp = function () {
	        scaler.success();
	      };
	      $(window).on('mouseup', this.onMouseUp).on('mousemove', this.onMouseMove);
	
	      this.$img.addClass('notransition');
	    },
	    renderSliderKnobPosition: function renderSliderKnobPosition() {
	      var offset = -4;
	      this.$sliderKnob.css('left', (this.image.scale - this.minScale) / this.scaleRange * this.$el.width() + offset);
	    },
	    setBoundedImageScale: function setBoundedImageScale(mouseY) {
	      var pct = (mouseY - this.$el.offset().left) / this.$el.width();
	      if (pct < 0) pct = 0;else if (pct > 1) pct = 1;
	      var mult = pct * this.scaleRange + this.minScale;
	      this.image.scale = mult;
	      this.currentSize.width = this.image.origWidth * mult;
	      this.currentSize.height = this.image.origHeight * mult;
	    },
	    move: function move(e) {
	      // get bounded mouse position to prevent image from escaping frame
	      this.setBoundedImageScale(e.pageX);
	
	      var scaler = this;
	      if (this._renderId) {
	        cancelAnimationFrame(this._renderId);
	      }
	      this._renderId = requestAnimationFrame(function () {
	        scaler.renderMove();
	      });
	    },
	    renderMove: function renderMove() {
	      this.renderSliderKnobPosition();
	      this.$img.width(this.currentSize.width);
	      this.$img.height(this.currentSize.height);
	      var left = -(this.centerXPct * this.currentSize.width - this.$cell.width() / 2),
	          top = -(this.centerYPct * this.currentSize.height - this.$cell.height() / 2);
	
	      // bound image to its frame
	      var minLeft = this.$cell.width() - this.$img.width(),
	          minTop = this.$cell.height() - this.$img.height();
	
	      if (left > 0) left = 0;else if (left < minLeft) left = minLeft;
	      if (top > 0) top = 0;else if (top < minTop) top = minTop;
	
	      this.$img.css('marginLeft', left + 'px');
	      this.$img.css('marginTop', top + 'px');
	    },
	    success: function success() {
	      if (this.postcard.options.onImageScaleComplete) {
	        this.postcard.options.onImageScaleComplete();
	      }
	      this.cleanup();
	    },
	    cleanup: function cleanup() {
	      // cancel any pending rendering
	      if (this._renderId) {
	        cancelAnimationFrame(this._renderId);
	      }
	      this._renderId = requestAnimationFrame(function () {
	        scaler.renderMove();
	      });
	
	      // undo our text selection prevention for IE
	      document.onselectstart = null;
	
	      $(window).off('mouseup', this.onMouseUp).off('mousemove', this.onMouseMove);
	
	      var scaler = this;
	      _.defer(function () {
	        scaler.$img.removeClass('notransition');
	      });
	      delete this.postcard.imageScaler;
	    }
	
	    // editing tool - handles state of dragging an image around to reposition it inside a cell, or move to another cell.
	  };ImageMover = function ImageMover($img) {
	    this.$img = $img;
	    this.$cell = $img.closest('.cell');
	    this.imageOffset = $img.offset();
	    this.cellOffset = $img.closest('.cell').offset();
	    this.mouseToImage = { left: 0, top: 0 };
	    this.mouseToImageOffset = { left: 0, top: 0 };
	    this.mouseOffset = { left: 0, top: 0 };
	  };
	  ImageMover.prototype = {
	    pxStrToFloat: function pxStrToFloat(str) {
	      return parseFloat(str.replace('px', ''));
	    },
	    start: function start(postcard, mousedownEvent) {
	      this.postcard = postcard;
	
	      // cancel out any text selections
	      document.body.focus();
	      // prevent text selection in IE
	      document.onselectstart = function () {
	        return false;
	      };
	      // prevent stuff on the page from getting selected during drag
	      mousedownEvent.preventDefault();
	
	      // set initial state
	      this.mouseToImage.left = this.pxStrToFloat(this.$img.css('marginLeft')) - mousedownEvent.pageX;
	      this.mouseToImage.top = this.pxStrToFloat(this.$img.css('marginTop')) - mousedownEvent.pageY;
	      this.mouseToImageOffset.left = this.imageOffset.left - mousedownEvent.pageX;
	      this.mouseToImageOffset.top = this.imageOffset.top - mousedownEvent.pageY;
	      this.setBoundedMouseOffset(mousedownEvent.pageX, mousedownEvent.pageY);
	
	      var mover = this;
	      this.onMouseMove = function () {
	        mover.move.apply(mover, arguments);
	      };
	      this.onMouseUp = function () {
	        mover.success();
	      };
	      $(window).on('mouseup', this.onMouseUp).on('mousemove', this.onMouseMove);
	
	      // pop the image out of the postcard so it sits above everything
	      $('body').prepend(this.$img.remove());
	      this.$img.addClass('postcard-moving');
	      this.$img.offset(this.imageOffset);
	      // render frame to display cell bounds
	      this.$frame = $('<div></div>').addClass('postcard-moving-frame');
	      $('body').prepend(this.$frame);
	      this.$frame.offset({ left: this.cellOffset.left - 1, top: this.cellOffset.top - 1 }).width(this.$cell.width()).height(this.$cell.height());
	    },
	    setUnboundedMouseOffset: function setUnboundedMouseOffset(mouseLeft, mouseTop) {
	      this.mouseOffset.left = mouseLeft;
	      this.mouseOffset.top = mouseTop;
	    },
	    setBoundedMouseOffset: function setBoundedMouseOffset(mouseLeft, mouseTop) {
	      var left = mouseLeft + this.mouseToImageOffset.left;
	      var top = mouseTop + this.mouseToImageOffset.top;
	      // bound image to its frame
	      var minLeft = this.cellOffset.left + this.$cell.width() - this.$img.width(),
	          minTop = this.cellOffset.top + this.$cell.height() - this.$img.height(),
	          amountExceeding = 0;
	      if (left > this.cellOffset.left) {
	        amountExceeding = left - this.cellOffset.left;
	        left = this.cellOffset.left;
	      } else if (left < minLeft) {
	        amountExceeding = minLeft - left;
	        left = minLeft;
	      }
	      if (top > this.cellOffset.top) {
	        amountExceeding = Math.max(amountExceeding, top - this.cellOffset.top);
	        top = this.cellOffset.top;
	      } else if (top < minTop) {
	        amountExceeding = Math.max(amountExceeding, minTop - top);
	        top = minTop;
	      }
	
	      mouseLeft = left - this.mouseToImageOffset.left;
	      mouseTop = top - this.mouseToImageOffset.top;
	      this.mouseOffset.left = mouseLeft;
	      this.mouseOffset.top = mouseTop;
	      return amountExceeding;
	    },
	    popOut: function popOut() {
	      this.poppedOut = true;
	      this.$frame.remove(); // remove the positioning frame
	      this.$img.addClass('postcard-image-droppable');
	    },
	    move: function move(e) {
	      // get bounded mouse position to prevent image from escaping frame
	      if (!this.poppedOut) {
	        var amountExceeding = this.setBoundedMouseOffset(e.pageX, e.pageY);
	        if (amountExceeding > 100) {
	          this.popOut();
	        }
	      } else {
	        this.setUnboundedMouseOffset(e.pageX, e.pageY);
	      }
	
	      var mover = this;
	      if (this._renderId) {
	        cancelAnimationFrame(this._renderId);
	      }
	      this._renderId = requestAnimationFrame(function () {
	        mover.renderMove();
	      });
	    },
	    renderMove: function renderMove() {
	      var left, top;
	      left = this.mouseOffset.left + this.mouseToImageOffset.left;
	      top = this.mouseOffset.top + this.mouseToImageOffset.top;
	
	      this.$img.offset({ left: left, top: top });
	    },
	    renderFinalPosition: function renderFinalPosition() {
	      var left, top;
	      left = this.mouseOffset.left + this.mouseToImage.left;
	      top = this.mouseOffset.top + this.mouseToImage.top;
	      // bound image to its frame
	      var minLeft = this.$cell.width() - this.$img.width(),
	          minTop = this.$cell.height() - this.$img.height();
	      if (left > 0) left = 0;else if (left < minLeft) left = minLeft;
	      if (top > 0) top = 0;else if (top < minTop) top = minTop;
	
	      this.$img.css('marginLeft', left + 'px');
	      this.$img.css('marginTop', top + 'px');
	    },
	    success: function success() {
	      this.cleanup();
	    },
	    cleanup: function cleanup() {
	      // cancel any pending rendering
	      if (this._renderId) {
	        cancelAnimationFrame(this._renderId);
	      }
	      if (!this.poppedOut) {
	        // remove the positioning frame
	        this.$frame.remove();
	      }
	
	      // undo our text selection prevention for IE
	      document.onselectstart = null;
	
	      $(window).off('mouseup', this.onMouseUp).off('mousemove', this.onMouseMove);
	
	      // put it back into the cell
	      this.$cell.prepend(this.$img.remove());
	      this.$img.css({ left: '', top: '' });
	      this.$img.removeClass('postcard-moving');
	
	      // if it was popped out, swap it if necessary
	      if (this.poppedOut) {
	        this.$img.removeClass('postcard-image-droppable');
	        var _mouseOffset = this.mouseOffset,
	            left = _mouseOffset.left,
	            top = _mouseOffset.top;
	
	        var destCell = _.find(this.postcard.cells, function (cell) {
	          var $cell = $(cell);
	          var cellOffset = $cell.offset();
	          return left > cellOffset.left && left < cellOffset.left + $cell.width() && top > cellOffset.top && top < cellOffset.top + $cell.height();
	        });
	        if (destCell && destCell !== this.$cell.get(0)) {
	          var $destCell = $(destCell);
	          var srcImage = _.extend({}, this.postcard.images[this.$cell.attr('data-imageI')]);
	          var destImage = _.extend({}, this.postcard.images[$destCell.attr('data-imageI')]);[srcImage, destImage].forEach(function (image) {
	            image.scale = image.marginLeft = image.marginTop = null;
	            image.img = image.img.cloneNode();
	          });
	          this.postcard.fillCell($destCell, srcImage, true, false);
	          this.postcard.fillCell(this.$cell, destImage, true, false);
	
	          var destScaler = new ImageScaler(this.postcard, $destCell);
	          destScaler.$el.hide();
	          this.postcard.imageScalers.push(destScaler);
	
	          var scaler = new ImageScaler(this.postcard, this.$cell);
	          scaler.$el.hide();
	          this.postcard.imageScalers.push(scaler);
	        }
	      }
	
	      // adjust margins to it's in the place the user positioned it
	      this.$img.addClass('notransition');
	      this.renderFinalPosition();
	      var pc = this;
	      _.defer(function () {
	        pc.$img.removeClass('notransition');
	      });
	
	      this.postcard.imageMoveComplete();
	    }
	  };
	});

/***/ }),
/* 11 */
/***/ (function(module, exports) {

	module.exports = jquery_ui_lib;

/***/ }),
/* 12 */,
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(11))(80);

/***/ }),
/* 14 */
/***/ (function(module, exports) {

	'use strict';
	
	(function () {
	
		var afterExpandCollapseFns = [];
		window.afterExpandCollapse = function (fn) {
			afterExpandCollapseFns.push(fn);
		};
		var leftWidth = 250;
		var rightWidth = 270;
		window.collapse = function (side) {
			$('#route_container').css('background', '#FFF');
			var col = $('.fullpage_' + side + '_col');
			if (side == 'left') {
				leftWidth = $('.fullpage_left_col').outerWidth();
				$('#map,#central').animate({ marginLeft: 0 }, 50, function () {
					$('#route_container').css('background', '#333');
					_.each(afterExpandCollapseFns, function (fn) {
						fn();
					});
				});
			}
			if (side == 'right') {
				rightWidth = $('.fullpage_right_col').outerWidth();
				$('#map,#central').animate({ marginRight: 0 }, 50, function () {
					_.each(afterExpandCollapseFns, function (fn) {
						fn();
					});
				});
			}
			col.children('.collapse').removeClass('collapse').addClass('expand');
			var toAnimate;
			if (side === 'left') toAnimate = { left: -col.outerWidth() };else toAnimate = { width: 0 };
			col.animate(toAnimate, 50, function () {
				col.addClass('hidden_' + side + '_col');
			});
			col.children('#ds_v, #ds_vl').hide();
			return false;
		};
		window.expand = function (side) {
			var col = $('.fullpage_' + side + '_col');
			var width = leftWidth + 'px';
			col.children('.expand').addClass('collapse').removeClass('expand');
			if (side == 'left') {
				$('.fullpage_left_col a.left').show();
				$('#map,#central').animate({ marginLeft: leftWidth }, 50, function () {
					col.children('#ds_v, #ds_vl').show();
					_.each(afterExpandCollapseFns, function (fn) {
						fn();
					});
				});
			}
			if (side == 'right') {
				$('#map,#central').animate({ marginRight: rightWidth }, 50, function () {
					col.children('#ds_v, #ds_vl').show();
					_.each(afterExpandCollapseFns, function (fn) {
						fn();
					});
				});
				width = rightWidth + 'px';
			}
			var toAnimate;
			if (side === 'left') toAnimate = { left: 0 };else toAnimate = { width: width };
			col.animate(toAnimate, 50, function () {
				col.removeClass('hidden_' + side + '_col');
			});
			return false;
		};
		window.toggleSidebars = function (side) {
			var col = $('.fullpage_' + side + '_col');
			var hidden_class_name = 'hidden_' + side + '_col';
			if (col.hasClass(hidden_class_name)) {
				window.expand(side);
			} else {
				window.collapse(side);
			}
		};
	})();
	$(function () {
		// cant have the left side resizable without doing something smarter.  upgrading to jquery 1.4 made the resizable ui plugin set the left bar as relative, not absolute, which forces the map to flow below.
		//$('.fullpage_left_col').resizable({handles: 'e', maxWidth: 500, minWidth: 240, resize: function(event, ui) {
		//$('#map').css('margin-left', ui.helper.width());
		//}
		//});
	
		$('.contracted').next('div').hide();
	
		$(document).on("click", '.left.collapse', function () {
			collapse('left');
			Application.setPreference('route_planner_left_sidebar_closed', true, true);
			return false;
		});
		$(document).on("click", '.right.collapse', function () {
			collapse('right');
			Application.setPreference('route_planner_right_sidebar_closed', true, true);
			return false;
		});
		$(document).on("click", '.expand.left', function () {
			expand('left');
			Application.setPreference('route_planner_left_sidebar_closed', false, true);
			return false;
		});
		$(document).on("click", '.expand.right', function () {
			expand('right');
			Application.setPreference('route_planner_right_sidebar_closed', false, true);
			return false;
		});
	
		$('.toggle_next').click(function () {
			var $next = $(this).next();
			//the toggle element can be wrapped in a tooltip and still work
			if ($next.length == 0) $next = $(this).parent().next();
			$(this).toggleClass('contracted');
			$next.slideToggle(400);
		});
	});

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["MDConvert"] = __webpack_require__(200);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["Remarkable"] = __webpack_require__(233);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery.scrollTo
	 * Copyright (c) 2007-2015 Ariel Flesler - aflesler ○ gmail • com | http://flesler.blogspot.com
	 * Licensed under MIT
	 * http://flesler.blogspot.com/2007/10/jqueryscrollto.html
	 * @projectDescription Lightweight, cross-browser and highly customizable animated scrolling with jQuery
	 * @author Ariel Flesler
	 * @version 2.1.2
	 */
	;(function(factory) {
		'use strict';
		if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(238)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			// CommonJS
			module.exports = factory(require('jquery'));
		} else {
			// Global
			factory(jQuery);
		}
	})(function($) {
		'use strict';
	
		var $scrollTo = $.scrollTo = function(target, duration, settings) {
			return $(window).scrollTo(target, duration, settings);
		};
	
		$scrollTo.defaults = {
			axis:'xy',
			duration: 0,
			limit:true
		};
	
		function isWin(elem) {
			return !elem.nodeName ||
				$.inArray(elem.nodeName.toLowerCase(), ['iframe','#document','html','body']) !== -1;
		}
	
		$.fn.scrollTo = function(target, duration, settings) {
			if (typeof duration === 'object') {
				settings = duration;
				duration = 0;
			}
			if (typeof settings === 'function') {
				settings = { onAfter:settings };
			}
			if (target === 'max') {
				target = 9e9;
			}
	
			settings = $.extend({}, $scrollTo.defaults, settings);
			// Speed is still recognized for backwards compatibility
			duration = duration || settings.duration;
			// Make sure the settings are given right
			var queue = settings.queue && settings.axis.length > 1;
			if (queue) {
				// Let's keep the overall duration
				duration /= 2;
			}
			settings.offset = both(settings.offset);
			settings.over = both(settings.over);
	
			return this.each(function() {
				// Null target yields nothing, just like jQuery does
				if (target === null) return;
	
				var win = isWin(this),
					elem = win ? this.contentWindow || window : this,
					$elem = $(elem),
					targ = target,
					attr = {},
					toff;
	
				switch (typeof targ) {
					// A number will pass the regex
					case 'number':
					case 'string':
						if (/^([+-]=?)?\d+(\.\d+)?(px|%)?$/.test(targ)) {
							targ = both(targ);
							// We are done
							break;
						}
						// Relative/Absolute selector
						targ = win ? $(targ) : $(targ, elem);
						/* falls through */
					case 'object':
						if (targ.length === 0) return;
						// DOMElement / jQuery
						if (targ.is || targ.style) {
							// Get the real position of the target
							toff = (targ = $(targ)).offset();
						}
				}
	
				var offset = $.isFunction(settings.offset) && settings.offset(elem, targ) || settings.offset;
	
				$.each(settings.axis.split(''), function(i, axis) {
					var Pos	= axis === 'x' ? 'Left' : 'Top',
						pos = Pos.toLowerCase(),
						key = 'scroll' + Pos,
						prev = $elem[key](),
						max = $scrollTo.max(elem, axis);
	
					if (toff) {// jQuery / DOMElement
						attr[key] = toff[pos] + (win ? 0 : prev - $elem.offset()[pos]);
	
						// If it's a dom element, reduce the margin
						if (settings.margin) {
							attr[key] -= parseInt(targ.css('margin'+Pos), 10) || 0;
							attr[key] -= parseInt(targ.css('border'+Pos+'Width'), 10) || 0;
						}
	
						attr[key] += offset[pos] || 0;
	
						if (settings.over[pos]) {
							// Scroll to a fraction of its width/height
							attr[key] += targ[axis === 'x'?'width':'height']() * settings.over[pos];
						}
					} else {
						var val = targ[pos];
						// Handle percentage values
						attr[key] = val.slice && val.slice(-1) === '%' ?
							parseFloat(val) / 100 * max
							: val;
					}
	
					// Number or 'number'
					if (settings.limit && /^\d+$/.test(attr[key])) {
						// Check the limits
						attr[key] = attr[key] <= 0 ? 0 : Math.min(attr[key], max);
					}
	
					// Don't waste time animating, if there's no need.
					if (!i && settings.axis.length > 1) {
						if (prev === attr[key]) {
							// No animation needed
							attr = {};
						} else if (queue) {
							// Intermediate animation
							animate(settings.onAfterFirst);
							// Don't animate this axis again in the next iteration.
							attr = {};
						}
					}
				});
	
				animate(settings.onAfter);
	
				function animate(callback) {
					var opts = $.extend({}, settings, {
						// The queue setting conflicts with animate()
						// Force it to always be true
						queue: true,
						duration: duration,
						complete: callback && function() {
							callback.call(elem, targ, settings);
						}
					});
					$elem.animate(attr, opts);
				}
			});
		};
	
		// Max scrolling position, works on quirks mode
		// It only fails (not too badly) on IE, quirks mode.
		$scrollTo.max = function(elem, axis) {
			var Dim = axis === 'x' ? 'Width' : 'Height',
				scroll = 'scroll'+Dim;
	
			if (!isWin(elem))
				return elem[scroll] - $(elem)[Dim.toLowerCase()]();
	
			var size = 'client' + Dim,
				doc = elem.ownerDocument || elem.document,
				html = doc.documentElement,
				body = doc.body;
	
			return Math.max(html[scroll], body[scroll]) - Math.min(html[size], body[size]);
		};
	
		function both(val) {
			return $.isFunction(val) || $.isPlainObject(val) ? val : { top:val, left:val };
		}
	
		// Add special hooks so that window scroll properties can be animated
		$.Tween.propHooks.scrollLeft =
		$.Tween.propHooks.scrollTop = {
			get: function(t) {
				return $(t.elem)[t.prop]();
			},
			set: function(t) {
				var curr = this.get(t);
				// If interrupt is true and user scrolled, stop animating
				if (t.options.interrupt && t._last && t._last !== curr) {
					return $(t.elem).stop();
				}
				var next = Math.round(t.now);
				// Don't waste CPU
				// Browsers don't render floating point scroll
				if (curr !== next) {
					$(t.elem)[t.prop](next);
					t._last = this.get(t);
				}
			}
		};
	
		// AMD requirement
		return $scrollTo;
	});


/***/ }),
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */
/***/ (function(module, exports) {

	/*
	Copyright 2012 Igor Vaynberg
	
	Version: 3.3.1 Timestamp: Wed Feb 20 09:57:22 PST 2013
	
	This software is licensed under the Apache License, Version 2.0 (the "Apache License") or the GNU
	General Public License version 2 (the "GPL License"). You may choose either license to govern your
	use of this software only upon the condition that you accept all of the terms of either the Apache
	License or the GPL License.
	
	You may obtain a copy of the Apache License and the GPL License at:
	
	    http://www.apache.org/licenses/LICENSE-2.0
	    http://www.gnu.org/licenses/gpl-2.0.html
	
	Unless required by applicable law or agreed to in writing, software distributed under the
	Apache License or the GPL Licesnse is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
	CONDITIONS OF ANY KIND, either express or implied. See the Apache License and the GPL License for
	the specific language governing permissions and limitations under the Apache License and the GPL License.
	*/
	 (function ($) {
	 	if(typeof $.fn.each2 == "undefined"){
	 		$.fn.extend({
	 			/*
				* 4-10 times faster .each replacement
				* use it carefully, as it overrides jQuery context of element on each iteration
				*/
				each2 : function (c) {
					var j = $([0]), i = -1, l = this.length;
					while (
						++i < l
						&& (j.context = j[0] = this[i])
						&& c.call(j[0], i, j) !== false //"this"=DOM, i=index, j=jQuery object
					);
					return this;
				}
	 		});
	 	}
	})(jQuery);
	
	(function ($, undefined) {
	    "use strict";
	    /*global document, window, jQuery, console */
	
	    if (window.Select2 !== undefined) {
	        return;
	    }
	
	    var KEY, AbstractSelect2, SingleSelect2, MultiSelect2, nextUid, sizer,
	        lastMousePosition, $document;
	
	    KEY = {
	        TAB: 9,
	        ENTER: 13,
	        ESC: 27,
	        SPACE: 32,
	        LEFT: 37,
	        UP: 38,
	        RIGHT: 39,
	        DOWN: 40,
	        SHIFT: 16,
	        CTRL: 17,
	        ALT: 18,
	        PAGE_UP: 33,
	        PAGE_DOWN: 34,
	        HOME: 36,
	        END: 35,
	        BACKSPACE: 8,
	        DELETE: 46,
	        isArrow: function (k) {
	            k = k.which ? k.which : k;
	            switch (k) {
	            case KEY.LEFT:
	            case KEY.RIGHT:
	            case KEY.UP:
	            case KEY.DOWN:
	                return true;
	            }
	            return false;
	        },
	        isControl: function (e) {
	            var k = e.which;
	            switch (k) {
	            case KEY.SHIFT:
	            case KEY.CTRL:
	            case KEY.ALT:
	                return true;
	            }
	
	            if (e.metaKey) return true;
	
	            return false;
	        },
	        isFunctionKey: function (k) {
	            k = k.which ? k.which : k;
	            return k >= 112 && k <= 123;
	        }
	    };
	
	    $document = $(document);
	
	    nextUid=(function() { var counter=1; return function() { return counter++; }; }());
	
	    function indexOf(value, array) {
	        var i = 0, l = array.length;
	        for (; i < l; i = i + 1) {
	            if (equal(value, array[i])) return i;
	        }
	        return -1;
	    }
	
	    /**
	     * Compares equality of a and b
	     * @param a
	     * @param b
	     */
	    function equal(a, b) {
	        if (a === b) return true;
	        if (a === undefined || b === undefined) return false;
	        if (a === null || b === null) return false;
	        if (a.constructor === String) return a === b+'';
	        if (b.constructor === String) return b === a+'';
	        return false;
	    }
	
	    /**
	     * Splits the string into an array of values, trimming each value. An empty array is returned for nulls or empty
	     * strings
	     * @param string
	     * @param separator
	     */
	    function splitVal(string, separator) {
	        var val, i, l;
	        if (string === null || string.length < 1) return [];
	        val = string.split(separator);
	        for (i = 0, l = val.length; i < l; i = i + 1) val[i] = $.trim(val[i]);
	        return val;
	    }
	
	    function getSideBorderPadding(element) {
	        return element.outerWidth(false) - element.width();
	    }
	
	    function installKeyUpChangeEvent(element) {
	        var key="keyup-change-value";
	        element.bind("keydown", function () {
	            if ($.data(element, key) === undefined) {
	                $.data(element, key, element.val());
	            }
	        });
	        element.bind("keyup", function () {
	            var val= $.data(element, key);
	            if (val !== undefined && element.val() !== val) {
	                $.removeData(element, key);
	                element.trigger("keyup-change");
	            }
	        });
	    }
	
	    $document.bind("mousemove", function (e) {
	        lastMousePosition = {x: e.pageX, y: e.pageY};
	    });
	
	    /**
	     * filters mouse events so an event is fired only if the mouse moved.
	     *
	     * filters out mouse events that occur when mouse is stationary but
	     * the elements under the pointer are scrolled.
	     */
	    function installFilteredMouseMove(element) {
		    element.bind("mousemove", function (e) {
	            var lastpos = lastMousePosition;
	            if (lastpos === undefined || lastpos.x !== e.pageX || lastpos.y !== e.pageY) {
	                $(e.target).trigger("mousemove-filtered", e);
	            }
	        });
	    }
	
	    /**
	     * Debounces a function. Returns a function that calls the original fn function only if no invocations have been made
	     * within the last quietMillis milliseconds.
	     *
	     * @param quietMillis number of milliseconds to wait before invoking fn
	     * @param fn function to be debounced
	     * @param ctx object to be used as this reference within fn
	     * @return debounced version of fn
	     */
	    function debounce(quietMillis, fn, ctx) {
	        ctx = ctx || undefined;
	        var timeout;
	        return function () {
	            var args = arguments;
	            window.clearTimeout(timeout);
	            timeout = window.setTimeout(function() {
	                fn.apply(ctx, args);
	            }, quietMillis);
	        };
	    }
	
	    /**
	     * A simple implementation of a thunk
	     * @param formula function used to lazily initialize the thunk
	     * @return {Function}
	     */
	    function thunk(formula) {
	        var evaluated = false,
	            value;
	        return function() {
	            if (evaluated === false) { value = formula(); evaluated = true; }
	            return value;
	        };
	    };
	
	    function installDebouncedScroll(threshold, element) {
	        var notify = debounce(threshold, function (e) { element.trigger("scroll-debounced", e);});
	        element.bind("scroll", function (e) {
	            if (indexOf(e.target, element.get()) >= 0) notify(e);
	        });
	    }
	
	    function focus($el) {
	        if ($el[0] === document.activeElement) return;
	
	        /* set the focus in a 0 timeout - that way the focus is set after the processing
	            of the current event has finished - which seems like the only reliable way
	            to set focus */
	        window.setTimeout(function() {
	            var el=$el[0], pos=$el.val().length, range;
	
	            $el.focus();
	
	            /* after the focus is set move the caret to the end, necessary when we val()
	                just before setting focus */
	            if(el.setSelectionRange)
	            {
	                el.setSelectionRange(pos, pos);
	            }
	            else if (el.createTextRange) {
	                range = el.createTextRange();
	                range.collapse(true);
	                range.moveEnd('character', pos);
	                range.moveStart('character', pos);
	                range.select();
	            }
	
	        }, 0);
	    }
	
	    function killEvent(event) {
	        event.preventDefault();
	        event.stopPropagation();
	    }
	    function killEventImmediately(event) {
	        event.preventDefault();
	        event.stopImmediatePropagation();
	    }
	
	    function measureTextWidth(e) {
	        if (!sizer){
	        	var style = e[0].currentStyle || window.getComputedStyle(e[0], null);
	        	sizer = $(document.createElement("div")).css({
		            position: "absolute",
		            left: "-10000px",
		            top: "-10000px",
		            display: "none",
		            fontSize: style.fontSize,
		            fontFamily: style.fontFamily,
		            fontStyle: style.fontStyle,
		            fontWeight: style.fontWeight,
		            letterSpacing: style.letterSpacing,
		            textTransform: style.textTransform,
		            whiteSpace: "nowrap"
		        });
	            sizer.attr("class","select2-sizer");
	        	$("body").append(sizer);
	        }
	        sizer.text(e.val());
	        return sizer.width();
	    }
	
	    function syncCssClasses(dest, src, adapter) {
	        var classes, replacements = [], adapted;
	
	        classes = dest.attr("class");
	        if (typeof classes === "string") {
	            $(classes.split(" ")).each2(function() {
	                if (this.indexOf("select2-") === 0) {
	                    replacements.push(this);
	                }
	            });
	        }
	        classes = src.attr("class");
	        if (typeof classes === "string") {
	            $(classes.split(" ")).each2(function() {
	                if (this.indexOf("select2-") !== 0) {
	                    adapted = adapter(this);
	                    if (typeof adapted === "string" && adapted.length > 0) {
	                        replacements.push(this);
	                    }
	                }
	            });
	        }
	        dest.attr("class", replacements.join(" "));
	    }
	
	
	    function markMatch(text, term, markup, escapeMarkup) {
	        var match=text.toUpperCase().indexOf(term.toUpperCase()),
	            tl=term.length;
	
	        if (match<0) {
	            markup.push(escapeMarkup(text));
	            return;
	        }
	
	        markup.push(escapeMarkup(text.substring(0, match)));
	        markup.push("<span class='select2-match'>");
	        markup.push(escapeMarkup(text.substring(match, match + tl)));
	        markup.push("</span>");
	        markup.push(escapeMarkup(text.substring(match + tl, text.length)));
	    }
	
	    /**
	     * Produces an ajax-based query function
	     *
	     * @param options object containing configuration paramters
	     * @param options.transport function that will be used to execute the ajax request. must be compatible with parameters supported by $.ajax
	     * @param options.url url for the data
	     * @param options.data a function(searchTerm, pageNumber, context) that should return an object containing query string parameters for the above url.
	     * @param options.dataType request data type: ajax, jsonp, other datatatypes supported by jQuery's $.ajax function or the transport function if specified
	     * @param options.traditional a boolean flag that should be true if you wish to use the traditional style of param serialization for the ajax request
	     * @param options.quietMillis (optional) milliseconds to wait before making the ajaxRequest, helps debounce the ajax function if invoked too often
	     * @param options.results a function(remoteData, pageNumber) that converts data returned form the remote request to the format expected by Select2.
	     *      The expected format is an object containing the following keys:
	     *      results array of objects that will be used as choices
	     *      more (optional) boolean indicating whether there are more results available
	     *      Example: {results:[{id:1, text:'Red'},{id:2, text:'Blue'}], more:true}
	     */
	    function ajax(options) {
	        var timeout, // current scheduled but not yet executed request
	            requestSequence = 0, // sequence used to drop out-of-order responses
	            handler = null,
	            quietMillis = options.quietMillis || 100,
	            ajaxUrl = options.url,
	            self = this;
	
	        return function (query) {
	            window.clearTimeout(timeout);
	            timeout = window.setTimeout(function () {
	                requestSequence += 1; // increment the sequence
	                var requestNumber = requestSequence, // this request's sequence number
	                    data = options.data, // ajax data function
	                    url = ajaxUrl, // ajax url string or function
	                    transport = options.transport || $.ajax,
	                    type = options.type || 'GET', // set type of request (GET or POST)
	                    params = {};
	
	                data = data ? data.call(self, query.term, query.page, query.context) : null;
	                url = (typeof url === 'function') ? url.call(self, query.term, query.page, query.context) : url;
	
	                if( null !== handler) { handler.abort(); }
	
	                if (options.params) {
	                    if ($.isFunction(options.params)) {
	                        $.extend(params, options.params.call(self));
	                    } else {
	                        $.extend(params, options.params);
	                    }
	                }
	
	                $.extend(params, {
	                    url: url,
	                    dataType: options.dataType,
	                    data: data,
	                    type: type,
	                    cache: false,
	                    success: function (data) {
	                        if (requestNumber < requestSequence) {
	                            return;
	                        }
	                        // TODO - replace query.page with query so users have access to term, page, etc.
	                        var results = options.results(data, query.page);
	                        query.callback(results);
	                    }
	                });
	                handler = transport.call(self, params);
	            }, quietMillis);
	        };
	    }
	
	    /**
	     * Produces a query function that works with a local array
	     *
	     * @param options object containing configuration parameters. The options parameter can either be an array or an
	     * object.
	     *
	     * If the array form is used it is assumed that it contains objects with 'id' and 'text' keys.
	     *
	     * If the object form is used ti is assumed that it contains 'data' and 'text' keys. The 'data' key should contain
	     * an array of objects that will be used as choices. These objects must contain at least an 'id' key. The 'text'
	     * key can either be a String in which case it is expected that each element in the 'data' array has a key with the
	     * value of 'text' which will be used to match choices. Alternatively, text can be a function(item) that can extract
	     * the text.
	     */
	    function local(options) {
	        var data = options, // data elements
	            dataText,
	            tmp,
	            text = function (item) { return ""+item.text; }; // function used to retrieve the text portion of a data item that is matched against the search
	
			 if ($.isArray(data)) {
	            tmp = data;
	            data = { results: tmp };
	        }
	
			 if ($.isFunction(data) === false) {
	            tmp = data;
	            data = function() { return tmp; };
	        }
	
	        var dataItem = data();
	        if (dataItem.text) {
	            text = dataItem.text;
	            // if text is not a function we assume it to be a key name
	            if (!$.isFunction(text)) {
	                dataText = data.text; // we need to store this in a separate variable because in the next step data gets reset and data.text is no longer available
	                text = function (item) { return item[dataText]; };
	            }
	        }
	
	        return function (query) {
	            var t = query.term, filtered = { results: [] }, process;
	            if (t === "") {
	                query.callback(data());
	                return;
	            }
	
	            process = function(datum, collection) {
	                var group, attr;
	                datum = datum[0];
	                if (datum.children) {
	                    group = {};
	                    for (attr in datum) {
	                        if (datum.hasOwnProperty(attr)) group[attr]=datum[attr];
	                    }
	                    group.children=[];
	                    $(datum.children).each2(function(i, childDatum) { process(childDatum, group.children); });
	                    if (group.children.length || query.matcher(t, text(group), datum)) {
	                        collection.push(group);
	                    }
	                } else {
	                    if (query.matcher(t, text(datum), datum)) {
	                        collection.push(datum);
	                    }
	                }
	            };
	
	            $(data().results).each2(function(i, datum) { process(datum, filtered.results); });
	            query.callback(filtered);
	        };
	    }
	
	    // TODO javadoc
	    function tags(data) {
	        var isFunc = $.isFunction(data);
	        return function (query) {
	            var t = query.term, filtered = {results: []};
	            $(isFunc ? data() : data).each(function () {
	                var isObject = this.text !== undefined,
	                    text = isObject ? this.text : this;
	                if (t === "" || query.matcher(t, text)) {
	                    filtered.results.push(isObject ? this : {id: this, text: this});
	                }
	            });
	            query.callback(filtered);
	        };
	    }
	
	    /**
	     * Checks if the formatter function should be used.
	     *
	     * Throws an error if it is not a function. Returns true if it should be used,
	     * false if no formatting should be performed.
	     *
	     * @param formatter
	     */
	    function checkFormatter(formatter, formatterName) {
	        if ($.isFunction(formatter)) return true;
	        if (!formatter) return false;
	        throw new Error("formatterName must be a function or a falsy value");
	    }
	
	    function evaluate(val) {
	        return $.isFunction(val) ? val() : val;
	    }
	
	    function countResults(results) {
	        var count = 0;
	        $.each(results, function(i, item) {
	            if (item.children) {
	                count += countResults(item.children);
	            } else {
	                count++;
	            }
	        });
	        return count;
	    }
	
	    /**
	     * Default tokenizer. This function uses breaks the input on substring match of any string from the
	     * opts.tokenSeparators array and uses opts.createSearchChoice to create the choice object. Both of those
	     * two options have to be defined in order for the tokenizer to work.
	     *
	     * @param input text user has typed so far or pasted into the search field
	     * @param selection currently selected choices
	     * @param selectCallback function(choice) callback tho add the choice to selection
	     * @param opts select2's opts
	     * @return undefined/null to leave the current input unchanged, or a string to change the input to the returned value
	     */
	    function defaultTokenizer(input, selection, selectCallback, opts) {
	        var original = input, // store the original so we can compare and know if we need to tell the search to update its text
	            dupe = false, // check for whether a token we extracted represents a duplicate selected choice
	            token, // token
	            index, // position at which the separator was found
	            i, l, // looping variables
	            separator; // the matched separator
	
	        if (!opts.createSearchChoice || !opts.tokenSeparators || opts.tokenSeparators.length < 1) return undefined;
	
	        while (true) {
	            index = -1;
	
	            for (i = 0, l = opts.tokenSeparators.length; i < l; i++) {
	                separator = opts.tokenSeparators[i];
	                index = input.indexOf(separator);
	                if (index >= 0) break;
	            }
	
	            if (index < 0) break; // did not find any token separator in the input string, bail
	
	            token = input.substring(0, index);
	            input = input.substring(index + separator.length);
	
	            if (token.length > 0) {
	                token = opts.createSearchChoice(token, selection);
	                if (token !== undefined && token !== null && opts.id(token) !== undefined && opts.id(token) !== null) {
	                    dupe = false;
	                    for (i = 0, l = selection.length; i < l; i++) {
	                        if (equal(opts.id(token), opts.id(selection[i]))) {
	                            dupe = true; break;
	                        }
	                    }
	
	                    if (!dupe) selectCallback(token);
	                }
	            }
	        }
	
	        if (original!==input) return input;
	    }
	
	    /**
	     * Creates a new class
	     *
	     * @param superClass
	     * @param methods
	     */
	    function clazz(SuperClass, methods) {
	        var constructor = function () {};
	        constructor.prototype = new SuperClass;
	        constructor.prototype.constructor = constructor;
	        constructor.prototype.parent = SuperClass.prototype;
	        constructor.prototype = $.extend(constructor.prototype, methods);
	        return constructor;
	    }
	
	    AbstractSelect2 = clazz(Object, {
	
	        // abstract
	        bind: function (func) {
	            var self = this;
	            return function () {
	                func.apply(self, arguments);
	            };
	        },
	
	        // abstract
	        init: function (opts) {
	            var results, search, resultsSelector = ".select2-results", mask;
	
	            // prepare options
	            this.opts = opts = this.prepareOpts(opts);
	
	            this.id=opts.id;
	
	            // destroy if called on an existing component
	            if (opts.element.data("select2") !== undefined &&
	                opts.element.data("select2") !== null) {
	                this.destroy();
	            }
	
	            this.enabled=true;
	            this.container = this.createContainer();
	
	            this.containerId="s2id_"+(opts.element.attr("id") || "autogen"+nextUid());
	            this.containerSelector="#"+this.containerId.replace(/([;&,\.\+\*\~':"\!\^#$%@\[\]\(\)=>\|])/g, '\\$1');
	            this.container.attr("id", this.containerId);
	
	            // cache the body so future lookups are cheap
	            this.body = thunk(function() { return opts.element.closest("body"); });
	
	            syncCssClasses(this.container, this.opts.element, this.opts.adaptContainerCssClass);
	
	            this.container.css(evaluate(opts.containerCss));
	            this.container.addClass(evaluate(opts.containerCssClass));
	
	            this.elementTabIndex = this.opts.element.attr("tabIndex");
	
	            // swap container for the element
	            this.opts.element
	                .data("select2", this)
	                .addClass("select2-offscreen")
	                .bind("focus.select2", function() { $(this).select2("focus"); })
	                .attr("tabIndex", "-1")
	                .before(this.container);
	            this.container.data("select2", this);
	
	            this.dropdown = this.container.find(".select2-drop");
	            this.dropdown.addClass(evaluate(opts.dropdownCssClass));
	            this.dropdown.data("select2", this);
	
	            this.results = results = this.container.find(resultsSelector);
	            this.search = search = this.container.find("input.select2-input");
	
	            search.attr("tabIndex", this.elementTabIndex);
	
	            this.resultsPage = 0;
	            this.context = null;
	
	            // initialize the container
	            this.initContainer();
	
	            installFilteredMouseMove(this.results);
	            this.dropdown.delegate(resultsSelector, "mousemove-filtered touchstart touchmove touchend", this.bind(this.highlightUnderEvent));
	
	            installDebouncedScroll(80, this.results);
	            this.dropdown.delegate(resultsSelector, "scroll-debounced", this.bind(this.loadMoreIfNeeded));
	
	            // if jquery.mousewheel plugin is installed we can prevent out-of-bounds scrolling of results via mousewheel
	            if ($.fn.mousewheel) {
	                results.mousewheel(function (e, delta, deltaX, deltaY) {
	                    var top = results.scrollTop(), height;
	                    if (deltaY > 0 && top - deltaY <= 0) {
	                        results.scrollTop(0);
	                        killEvent(e);
	                    } else if (deltaY < 0 && results.get(0).scrollHeight - results.scrollTop() + deltaY <= results.height()) {
	                        results.scrollTop(results.get(0).scrollHeight - results.height());
	                        killEvent(e);
	                    }
	                });
	            }
	
	            installKeyUpChangeEvent(search);
	            search.bind("keyup-change input paste", this.bind(this.updateResults));
	            search.bind("focus", function () { search.addClass("select2-focused"); });
	            search.bind("blur", function () { search.removeClass("select2-focused");});
	
	            this.dropdown.delegate(resultsSelector, "mouseup", this.bind(function (e) {
	                if ($(e.target).closest(".select2-result-selectable").length > 0) {
	                    this.highlightUnderEvent(e);
	                    this.selectHighlighted(e);
	                }
	            }));
	
	            // trap all mouse events from leaving the dropdown. sometimes there may be a modal that is listening
	            // for mouse events outside of itself so it can close itself. since the dropdown is now outside the select2's
	            // dom it will trigger the popup close, which is not what we want
	            this.dropdown.bind("click mouseup mousedown", function (e) { e.stopPropagation(); });
	
	            if ($.isFunction(this.opts.initSelection)) {
	                // initialize selection based on the current value of the source element
	                this.initSelection();
	
	                // if the user has provided a function that can set selection based on the value of the source element
	                // we monitor the change event on the element and trigger it, allowing for two way synchronization
	                this.monitorSource();
	            }
	
	            if (opts.element.is(":disabled") || opts.element.is("[readonly='readonly']")) this.disable();
	        },
	
	        // abstract
	        destroy: function () {
	            var select2 = this.opts.element.data("select2");
	
	            if (this.propertyObserver) { delete this.propertyObserver; this.propertyObserver = null; }
	
	            if (select2 !== undefined) {
	
	                select2.container.remove();
	                select2.dropdown.remove();
	                select2.opts.element
	                    .removeClass("select2-offscreen")
	                    .removeData("select2")
	                    .unbind(".select2")
	                    .attr({"tabIndex": this.elementTabIndex})
	                    .show();
	            }
	        },
	
	        // abstract
	        prepareOpts: function (opts) {
	            var element, select, idKey, ajaxUrl;
	
	            element = opts.element;
	
	            if (element.get(0).tagName.toLowerCase() === "select") {
	                this.select = select = opts.element;
	            }
	
	            if (select) {
	                // these options are not allowed when attached to a select because they are picked up off the element itself
	                $.each(["id", "multiple", "ajax", "query", "createSearchChoice", "initSelection", "data", "tags"], function () {
	                    if (this in opts) {
	                        throw new Error("Option '" + this + "' is not allowed for Select2 when attached to a <select> element.");
	                    }
	                });
	            }
	
	            opts = $.extend({}, {
	                populateResults: function(container, results, query) {
	                    var populate,  data, result, children, id=this.opts.id, self=this;
	
	                    populate=function(results, container, depth) {
	
	                        var i, l, result, selectable, disabled, compound, node, label, innerContainer, formatted;
	
	                        results = opts.sortResults(results, container, query);
	
	                        for (i = 0, l = results.length; i < l; i = i + 1) {
	
	                            result=results[i];
	
	                            disabled = (result.disabled === true);
	                            selectable = (!disabled) && (id(result) !== undefined);
	
	                            compound=result.children && result.children.length > 0;
	
	                            node=$("<li></li>");
	                            node.addClass("select2-results-dept-"+depth);
	                            node.addClass("select2-result");
	                            node.addClass(selectable ? "select2-result-selectable" : "select2-result-unselectable");
	                            if (disabled) { node.addClass("select2-disabled"); }
	                            if (compound) { node.addClass("select2-result-with-children"); }
	                            node.addClass(self.opts.formatResultCssClass(result));
	
	                            label=$(document.createElement("div"));
	                            label.addClass("select2-result-label");
	
	                            formatted=opts.formatResult(result, label, query, self.opts.escapeMarkup);
	                            if (formatted!==undefined) {
	                                label.html(formatted);
	                            }
	
	                            node.append(label);
	
	                            if (compound) {
	
	                                innerContainer=$("<ul></ul>");
	                                innerContainer.addClass("select2-result-sub");
	                                populate(result.children, innerContainer, depth+1);
	                                node.append(innerContainer);
	                            }
	
	                            node.data("select2-data", result);
	                            container.append(node);
	                        }
	                    };
	
	                    populate(results, container, 0);
	                }
	            }, $.fn.select2.defaults, opts);
	
	            if (typeof(opts.id) !== "function") {
	                idKey = opts.id;
	                opts.id = function (e) { return e[idKey]; };
	            }
	
	            if ($.isArray(opts.element.data("select2Tags"))) {
	                if ("tags" in opts) {
	                    throw "tags specified as both an attribute 'data-select2-tags' and in options of Select2 " + opts.element.attr("id");
	                }
	                opts.tags=opts.element.attr("data-select2-tags");
	            }
	
	            if (select) {
	                opts.query = this.bind(function (query) {
	                    var data = { results: [], more: false },
	                        term = query.term,
	                        children, firstChild, process;
	
	                    process=function(element, collection) {
	                        var group;
	                        if (element.is("option")) {
	                            if (query.matcher(term, element.text(), element)) {
	                                collection.push({id:element.attr("value"), text:element.text(), element: element.get(), css: element.attr("class"), disabled: equal(element.attr("disabled"), "disabled") });
	                            }
	                        } else if (element.is("optgroup")) {
	                            group={text:element.attr("label"), children:[], element: element.get(), css: element.attr("class")};
	                            element.children().each2(function(i, elm) { process(elm, group.children); });
	                            if (group.children.length>0) {
	                                collection.push(group);
	                            }
	                        }
	                    };
	
	                    children=element.children();
	
	                    // ignore the placeholder option if there is one
	                    if (this.getPlaceholder() !== undefined && children.length > 0) {
	                        firstChild = children[0];
	                        if ($(firstChild).text() === "") {
	                            children=children.not(firstChild);
	                        }
	                    }
	
	                    children.each2(function(i, elm) { process(elm, data.results); });
	
	                    query.callback(data);
	                });
	                // this is needed because inside val() we construct choices from options and there id is hardcoded
	                opts.id=function(e) { return e.id; };
	                opts.formatResultCssClass = function(data) { return data.css; };
	            } else {
	                if (!("query" in opts)) {
	
	                    if ("ajax" in opts) {
	                        ajaxUrl = opts.element.data("ajax-url");
	                        if (ajaxUrl && ajaxUrl.length > 0) {
	                            opts.ajax.url = ajaxUrl;
	                        }
	                        opts.query = ajax.call(opts.element, opts.ajax);
	                    } else if ("data" in opts) {
	                        opts.query = local(opts.data);
	                    } else if ("tags" in opts) {
	                        opts.query = tags(opts.tags);
	                        if (opts.createSearchChoice === undefined) {
	                            opts.createSearchChoice = function (term) { return {id: term, text: term}; };
	                        }
	                        if (opts.initSelection === undefined) {
	                            opts.initSelection = function (element, callback) {
	                                var data = [];
	                                $(splitVal(element.val(), opts.separator)).each(function () {
	                                    var id = this, text = this, tags=opts.tags;
	                                    if ($.isFunction(tags)) tags=tags();
	                                    $(tags).each(function() { if (equal(this.id, id)) { text = this.text; return false; } });
	                                    data.push({id: id, text: text});
	                                });
	
	                                callback(data);
	                            };
	                        }
	                    }
	                }
	            }
	            if (typeof(opts.query) !== "function") {
	                throw "query function not defined for Select2 " + opts.element.attr("id");
	            }
	
	            return opts;
	        },
	
	        /**
	         * Monitor the original element for changes and update select2 accordingly
	         */
	        // abstract
	        monitorSource: function () {
	            var el = this.opts.element, sync;
	
	            el.bind("change.select2", this.bind(function (e) {
	                if (this.opts.element.data("select2-change-triggered") !== true) {
	                    this.initSelection();
	                }
	            }));
	
	            sync = this.bind(function () {
	
	                var enabled, readonly, self = this;
	
	                // sync enabled state
	
	                enabled = this.opts.element.attr("disabled") !== "disabled";
	                readonly = this.opts.element.attr("readonly") === "readonly";
	
	                enabled = enabled && !readonly;
	
	                if (this.enabled !== enabled) {
	                    if (enabled) {
	                        this.enable();
	                    } else {
	                        this.disable();
	                    }
	                }
	
	
	                syncCssClasses(this.container, this.opts.element, this.opts.adaptContainerCssClass);
	                this.container.addClass(evaluate(this.opts.containerCssClass));
	
	                syncCssClasses(this.dropdown, this.opts.element, this.opts.adaptDropdownCssClass);
	                this.dropdown.addClass(evaluate(this.opts.dropdownCssClass));
	
	            });
	
	            // mozilla and IE
	            el.bind("propertychange.select2 DOMAttrModified.select2", sync);
	            // safari and chrome
	            if (typeof WebKitMutationObserver !== "undefined") {
	                if (this.propertyObserver) { delete this.propertyObserver; this.propertyObserver = null; }
	                this.propertyObserver = new WebKitMutationObserver(function (mutations) {
	                    mutations.forEach(sync);
	                });
	                this.propertyObserver.observe(el.get(0), { attributes:true, subtree:false });
	            }
	        },
	
	        /**
	         * Triggers the change event on the source element
	         */
	        // abstract
	        triggerChange: function (details) {
	
	            details = details || {};
	            details= $.extend({}, details, { type: "change", val: this.val() });
	            // prevents recursive triggering
	            this.opts.element.data("select2-change-triggered", true);
	            this.opts.element.trigger(details);
	            this.opts.element.data("select2-change-triggered", false);
	
	            // some validation frameworks ignore the change event and listen instead to keyup, click for selects
	            // so here we trigger the click event manually
	            this.opts.element.click();
	
	            // ValidationEngine ignorea the change event and listens instead to blur
	            // so here we trigger the blur event manually if so desired
	            if (this.opts.blurOnChange)
	                this.opts.element.blur();
	        },
	
	        // abstract
	        enable: function() {
	            if (this.enabled) return;
	
	            this.enabled=true;
	            this.container.removeClass("select2-container-disabled");
	            this.opts.element.removeAttr("disabled");
	        },
	
	        // abstract
	        disable: function() {
	            if (!this.enabled) return;
	
	            this.close();
	
	            this.enabled=false;
	            this.container.addClass("select2-container-disabled");
	            this.opts.element.attr("disabled", "disabled");
	        },
	
	        // abstract
	        opened: function () {
	            return this.container.hasClass("select2-dropdown-open");
	        },
	
	        // abstract
	        positionDropdown: function() {
	            var offset = this.container.offset(),
	                height = this.container.outerHeight(false),
	                width = this.container.outerWidth(false),
	                dropHeight = this.dropdown.outerHeight(false),
		            viewPortRight = $(window).scrollLeft() + $(window).width(),
	                viewportBottom = $(window).scrollTop() + $(window).height(),
	                dropTop = offset.top + height,
	                dropLeft = offset.left,
	                enoughRoomBelow = dropTop + dropHeight <= viewportBottom,
	                enoughRoomAbove = (offset.top - dropHeight) >= this.body().scrollTop(),
		            dropWidth = this.dropdown.outerWidth(false),
		            enoughRoomOnRight = dropLeft + dropWidth <= viewPortRight,
	                aboveNow = this.dropdown.hasClass("select2-drop-above"),
	                bodyOffset,
	                above,
	                css;
	
	            //console.log("below/ droptop:", dropTop, "dropHeight", dropHeight, "sum", (dropTop+dropHeight)+" viewport bottom", viewportBottom, "enough?", enoughRoomBelow);
	            //console.log("above/ offset.top", offset.top, "dropHeight", dropHeight, "top", (offset.top-dropHeight), "scrollTop", this.body().scrollTop(), "enough?", enoughRoomAbove);
	
	            // fix positioning when body has an offset and is not position: static
	
	            if (this.body().css('position') !== 'static') {
	                bodyOffset = this.body().offset();
	                dropTop -= bodyOffset.top;
	                dropLeft -= bodyOffset.left;
	            }
	
	            // always prefer the current above/below alignment, unless there is not enough room
	
	            if (aboveNow) {
	                above = true;
	                if (!enoughRoomAbove && enoughRoomBelow) above = false;
	            } else {
	                above = false;
	                if (!enoughRoomBelow && enoughRoomAbove) above = true;
	            }
	
	            if (!enoughRoomOnRight) {
	               dropLeft = offset.left + width - dropWidth;
	            }
	
	            if (above) {
	                dropTop = offset.top - dropHeight;
	                this.container.addClass("select2-drop-above");
	                this.dropdown.addClass("select2-drop-above");
	            }
	            else {
	                this.container.removeClass("select2-drop-above");
	                this.dropdown.removeClass("select2-drop-above");
	            }
	
	            css = $.extend({
	                top: dropTop,
	                left: dropLeft,
	                width: width
	            }, evaluate(this.opts.dropdownCss));
	
	            this.dropdown.css(css);
	        },
	
	        // abstract
	        shouldOpen: function() {
	            var event;
	
	            if (this.opened()) return false;
	
	            event = $.Event("opening");
	            this.opts.element.trigger(event);
	            return !event.isDefaultPrevented();
	        },
	
	        // abstract
	        clearDropdownAlignmentPreference: function() {
	            // clear the classes used to figure out the preference of where the dropdown should be opened
	            this.container.removeClass("select2-drop-above");
	            this.dropdown.removeClass("select2-drop-above");
	        },
	
	        /**
	         * Opens the dropdown
	         *
	         * @return {Boolean} whether or not dropdown was opened. This method will return false if, for example,
	         * the dropdown is already open, or if the 'open' event listener on the element called preventDefault().
	         */
	        // abstract
	        open: function () {
	
	            if (!this.shouldOpen()) return false;
	
	            window.setTimeout(this.bind(this.opening), 1);
	
	            return true;
	        },
	
	        /**
	         * Performs the opening of the dropdown
	         */
	        // abstract
	        opening: function() {
	            var cid = this.containerId,
	                scroll = "scroll." + cid,
	                resize = "resize."+cid,
	                orient = "orientationchange."+cid,
	                mask;
	
	            this.clearDropdownAlignmentPreference();
	
	            this.container.addClass("select2-dropdown-open").addClass("select2-container-active");
	
	
	            if(this.dropdown[0] !== this.body().children().last()[0]) {
	                this.dropdown.detach().appendTo(this.body());
	            }
	
	            this.updateResults(true);
	
	            // create the dropdown mask if doesnt already exist
	            mask = $("#select2-drop-mask");
	            if (mask.length == 0) {
	                mask = $(document.createElement("div"));
	                mask.attr("id","select2-drop-mask").attr("class","select2-drop-mask");
	                mask.hide();
	                mask.appendTo(this.body());
	                mask.bind("mousedown touchstart", function (e) {
	                    var dropdown = $("#select2-drop"), self;
	                    if (dropdown.length > 0) {
	                        self=dropdown.data("select2");
	                        if (self.opts.selectOnBlur) {
	                            self.selectHighlighted({noFocus: true});
	                        }
	                        self.close();
	                    }
	                });
	            }
	
	            // ensure the mask is always right before the dropdown
	            if (this.dropdown.prev()[0] !== mask[0]) {
	                this.dropdown.before(mask);
	            }
	
	            // move the global id to the correct dropdown
	            $("#select2-drop").removeAttr("id");
	            this.dropdown.attr("id", "select2-drop");
	
	            // show the elements
	            mask.css({
	                width: document.documentElement.scrollWidth,
	                height: document.documentElement.scrollHeight});
	            mask.show();
	            this.dropdown.show();
	            this.positionDropdown();
	
	            this.dropdown.addClass("select2-drop-active");
	            this.ensureHighlightVisible();
	
	            // attach listeners to events that can change the position of the container and thus require
	            // the position of the dropdown to be updated as well so it does not come unglued from the container
	            var that = this;
	            this.container.parents().add(window).each(function () {
	                $(this).bind(resize+" "+scroll+" "+orient, function (e) {
	                    $("#select2-drop-mask").css({
	                        width:document.documentElement.scrollWidth,
	                        height:document.documentElement.scrollHeight});
	                    that.positionDropdown();
	                });
	            });
	
	            this.focusSearch();
	        },
	
	        // abstract
	        close: function () {
	            if (!this.opened()) return;
	
	            var cid = this.containerId,
	                scroll = "scroll." + cid,
	                resize = "resize."+cid,
	                orient = "orientationchange."+cid;
	
	            // unbind event listeners
	            this.container.parents().add(window).each(function () { $(this).unbind(scroll).unbind(resize).unbind(orient); });
	
	            this.clearDropdownAlignmentPreference();
	
	            $("#select2-drop-mask").hide();
	            this.dropdown.removeAttr("id"); // only the active dropdown has the select2-drop id
	            this.dropdown.hide();
	            this.container.removeClass("select2-dropdown-open");
	            this.results.empty();
	            this.clearSearch();
	
	            this.opts.element.trigger($.Event("close"));
	        },
	
	        // abstract
	        clearSearch: function () {
	
	        },
	
	        //abstract
	        getMaximumSelectionSize: function() {
	            return evaluate(this.opts.maximumSelectionSize);
	        },
	
	        // abstract
	        ensureHighlightVisible: function () {
	            var results = this.results, children, index, child, hb, rb, y, more;
	
	            index = this.highlight();
	
	            if (index < 0) return;
	
	            if (index == 0) {
	
	                // if the first element is highlighted scroll all the way to the top,
	                // that way any unselectable headers above it will also be scrolled
	                // into view
	
	                results.scrollTop(0);
	                return;
	            }
	
	            children = this.findHighlightableChoices();
	
	            child = $(children[index]);
	
	            hb = child.offset().top + child.outerHeight(true);
	
	            // if this is the last child lets also make sure select2-more-results is visible
	            if (index === children.length - 1) {
	                more = results.find("li.select2-more-results");
	                if (more.length > 0) {
	                    hb = more.offset().top + more.outerHeight(true);
	                }
	            }
	
	            rb = results.offset().top + results.outerHeight(true);
	            if (hb > rb) {
	                results.scrollTop(results.scrollTop() + (hb - rb));
	            }
	            y = child.offset().top - results.offset().top;
	
	            // make sure the top of the element is visible
	            if (y < 0 && child.css('display') != 'none' ) {
	                results.scrollTop(results.scrollTop() + y); // y is negative
	            }
	        },
	
	        // abstract
	        findHighlightableChoices: function() {
	            var h=this.results.find(".select2-result-selectable:not(.select2-selected):not(.select2-disabled)");
	            return this.results.find(".select2-result-selectable:not(.select2-selected):not(.select2-disabled)");
	        },
	
	        // abstract
	        moveHighlight: function (delta) {
	            var choices = this.findHighlightableChoices(),
	                index = this.highlight();
	
	            while (index > -1 && index < choices.length) {
	                index += delta;
	                var choice = $(choices[index]);
	                if (choice.hasClass("select2-result-selectable") && !choice.hasClass("select2-disabled") && !choice.hasClass("select2-selected")) {
	                    this.highlight(index);
	                    break;
	                }
	            }
	        },
	
	        // abstract
	        highlight: function (index) {
	            var choices = this.findHighlightableChoices(),
	                choice,
	                data;
	
	            if (arguments.length === 0) {
	                return indexOf(choices.filter(".select2-highlighted")[0], choices.get());
	            }
	
	            if (index >= choices.length) index = choices.length - 1;
	            if (index < 0) index = 0;
	
	            this.results.find(".select2-highlighted").removeClass("select2-highlighted");
	
	            choice = $(choices[index]);
	            choice.addClass("select2-highlighted");
	
	            this.ensureHighlightVisible();
	
	            data = choice.data("select2-data");
	            if (data) {
	                this.opts.element.trigger({ type: "highlight", val: this.id(data), choice: data });
	            }
	        },
	
	        // abstract
	        countSelectableResults: function() {
	            return this.findHighlightableChoices().length;
	        },
	
	        // abstract
	        highlightUnderEvent: function (event) {
	            var el = $(event.target).closest(".select2-result-selectable");
	            if (el.length > 0 && !el.is(".select2-highlighted")) {
	        		var choices = this.findHighlightableChoices();
	                this.highlight(choices.index(el));
	            } else if (el.length == 0) {
	                // if we are over an unselectable item remove al highlights
	                this.results.find(".select2-highlighted").removeClass("select2-highlighted");
	            }
	        },
	
	        // abstract
	        loadMoreIfNeeded: function () {
	            var results = this.results,
	                more = results.find("li.select2-more-results"),
	                below, // pixels the element is below the scroll fold, below==0 is when the element is starting to be visible
	                offset = -1, // index of first element without data
	                page = this.resultsPage + 1,
	                self=this,
	                term=this.search.val(),
	                context=this.context;
	
	            if (more.length === 0) return;
	            below = more.offset().top - results.offset().top - results.height();
	
	            if (below <= this.opts.loadMorePadding) {
	                more.addClass("select2-active");
	                this.opts.query({
	                        element: this.opts.element,
	                        term: term,
	                        page: page,
	                        context: context,
	                        matcher: this.opts.matcher,
	                        callback: this.bind(function (data) {
	
	                    // ignore a response if the select2 has been closed before it was received
	                    if (!self.opened()) return;
	
	
	                    self.opts.populateResults.call(this, results, data.results, {term: term, page: page, context:context});
	
	                    if (data.more===true) {
	                        more.detach().appendTo(results).text(self.opts.formatLoadMore(page+1));
	                        window.setTimeout(function() { self.loadMoreIfNeeded(); }, 10);
	                    } else {
	                        more.remove();
	                    }
	                    self.positionDropdown();
	                    self.resultsPage = page;
	                    self.context = data.context;
	                })});
	            }
	        },
	
	        /**
	         * Default tokenizer function which does nothing
	         */
	        tokenize: function() {
	
	        },
	
	        /**
	         * @param initial whether or not this is the call to this method right after the dropdown has been opened
	         */
	        // abstract
	        updateResults: function (initial) {
	            var search = this.search, results = this.results, opts = this.opts, data, self=this, input;
	
	            // if the search is currently hidden we do not alter the results
	            if (initial !== true && (this.showSearchInput === false || !this.opened())) {
	                return;
	            }
	
	            search.addClass("select2-active");
	
	            function postRender() {
	                results.scrollTop(0);
	                search.removeClass("select2-active");
	                self.positionDropdown();
	            }
	
	            function render(html) {
	                results.html(html);
	                postRender();
	            }
	
	            var maxSelSize = this.getMaximumSelectionSize();
	            if (maxSelSize >=1) {
	                data = this.data();
	                if ($.isArray(data) && data.length >= maxSelSize && checkFormatter(opts.formatSelectionTooBig, "formatSelectionTooBig")) {
	            	    render("<li class='select2-selection-limit'>" + opts.formatSelectionTooBig(maxSelSize) + "</li>");
	            	    return;
	                }
	            }
	
	            if (search.val().length < opts.minimumInputLength) {
	                if (checkFormatter(opts.formatInputTooShort, "formatInputTooShort")) {
	                    render("<li class='select2-no-results'>" + opts.formatInputTooShort(search.val(), opts.minimumInputLength) + "</li>");
	                } else {
	                    render("");
	                }
	                return;
	            }
	            else if (opts.formatSearching() && initial===true) {
	                render("<li class='select2-searching'>" + opts.formatSearching() + "</li>");
	            }
	
	            if (opts.maximumInputLength && search.val().length > opts.maximumInputLength) {
	                if (checkFormatter(opts.formatInputTooLong, "formatInputTooLong")) {
	                    render("<li class='select2-no-results'>" + opts.formatInputTooLong(search.val(), opts.maximumInputLength) + "</li>");
	                } else {
	                    render("");
	                }
	                return;
	            }
	
	            // give the tokenizer a chance to pre-process the input
	            input = this.tokenize();
	            if (input != undefined && input != null) {
	                search.val(input);
	            }
	
	            this.resultsPage = 1;
	
	            opts.query({
	                element: opts.element,
	                    term: search.val(),
	                    page: this.resultsPage,
	                    context: null,
	                    matcher: opts.matcher,
	                    callback: this.bind(function (data) {
	                var def; // default choice
	
	                // ignore a response if the select2 has been closed before it was received
	                if (!this.opened()) return;
	
	                // save context, if any
	                this.context = (data.context===undefined) ? null : data.context;
	                // create a default choice and prepend it to the list
	                if (this.opts.createSearchChoice && search.val() !== "") {
	                    def = this.opts.createSearchChoice.call(null, search.val(), data.results);
	                    if (def !== undefined && def !== null && self.id(def) !== undefined && self.id(def) !== null) {
	                        if ($(data.results).filter(
	                            function () {
	                                return equal(self.id(this), self.id(def));
	                            }).length === 0) {
	                            data.results.unshift(def);
	                        }
	                    }
	                }
	
	                if (data.results.length === 0 && checkFormatter(opts.formatNoMatches, "formatNoMatches")) {
	                    render("<li class='select2-no-results'>" + opts.formatNoMatches(search.val()) + "</li>");
	                    return;
	                }
	
	                results.empty();
	                self.opts.populateResults.call(this, results, data.results, {term: search.val(), page: this.resultsPage, context:null});
	
	                if (data.more === true && checkFormatter(opts.formatLoadMore, "formatLoadMore")) {
	                    results.append("<li class='select2-more-results'>" + self.opts.escapeMarkup(opts.formatLoadMore(this.resultsPage)) + "</li>");
	                    window.setTimeout(function() { self.loadMoreIfNeeded(); }, 10);
	                }
	
	                this.postprocessResults(data, initial);
	
	                postRender();
	            })});
	        },
	
	        // abstract
	        cancel: function () {
	            this.close();
	        },
	
	        // abstract
	        blur: function () {
	            // if selectOnBlur == true, select the currently highlighted option
	            if (this.opts.selectOnBlur)
	                this.selectHighlighted({noFocus: true});
	
	            this.close();
	            this.container.removeClass("select2-container-active");
	            // synonymous to .is(':focus'), which is available in jquery >= 1.6
	            if (this.search[0] === document.activeElement) { this.search.blur(); }
	            this.clearSearch();
	            this.selection.find(".select2-search-choice-focus").removeClass("select2-search-choice-focus");
	        },
	
	        // abstract
	        focusSearch: function () {
	            focus(this.search);
	        },
	
	        // abstract
	        selectHighlighted: function (options) {
	            var index=this.highlight(),
	                highlighted=this.results.find(".select2-highlighted"),
	                data = highlighted.closest('.select2-result').data("select2-data");
	
	            if (data) {
	                this.highlight(index);
	                this.onSelect(data, options);
	            }
	        },
	
	        // abstract
	        getPlaceholder: function () {
	            return this.opts.element.attr("placeholder") ||
	                this.opts.element.attr("data-placeholder") || // jquery 1.4 compat
	                this.opts.element.data("placeholder") ||
	                this.opts.placeholder;
	        },
	
	        /**
	         * Get the desired width for the container element.  This is
	         * derived first from option `width` passed to select2, then
	         * the inline 'style' on the original element, and finally
	         * falls back to the jQuery calculated element width.
	         */
	        // abstract
	        initContainerWidth: function () {
	            function resolveContainerWidth() {
	                var style, attrs, matches, i, l;
	
	                if (this.opts.width === "off") {
	                    return null;
	                } else if (this.opts.width === "element"){
	                    return this.opts.element.outerWidth(false) === 0 ? 'auto' : this.opts.element.outerWidth(false) + 'px';
	                } else if (this.opts.width === "copy" || this.opts.width === "resolve") {
	                    // check if there is inline style on the element that contains width
	                    style = this.opts.element.attr('style');
	                    if (style !== undefined) {
	                        attrs = style.split(';');
	                        for (i = 0, l = attrs.length; i < l; i = i + 1) {
	                            matches = attrs[i].replace(/\s/g, '')
	                                .match(/width:(([-+]?([0-9]*\.)?[0-9]+)(px|em|ex|%|in|cm|mm|pt|pc))/);
	                            if (matches !== null && matches.length >= 1)
	                                return matches[1];
	                        }
	                    }
	
	                    if (this.opts.width === "resolve") {
	                        // next check if css('width') can resolve a width that is percent based, this is sometimes possible
	                        // when attached to input type=hidden or elements hidden via css
	                        style = this.opts.element.css('width');
	                        if (style.indexOf("%") > 0) return style;
	
	                        // finally, fallback on the calculated width of the element
	                        return (this.opts.element.outerWidth(false) === 0 ? 'auto' : this.opts.element.outerWidth(false) + 'px');
	                    }
	
	                    return null;
	                } else if ($.isFunction(this.opts.width)) {
	                    return this.opts.width();
	                } else {
	                    return this.opts.width;
	               }
	            };
	
	            var width = resolveContainerWidth.call(this);
	            if (width !== null) {
	                this.container.css("width", width);
	            }
	        }
	    });
	
	    SingleSelect2 = clazz(AbstractSelect2, {
	
	        // single
	
			createContainer: function () {
	            var container = $(document.createElement("div")).attr({
	                "class": "select2-container"
	            }).html([
	                "<a href='javascript:void(0)' onclick='return false;' class='select2-choice' tabindex='-1'>",
	                "   <span></span><abbr class='select2-search-choice-close' style='display:none;'></abbr>",
	                "   <div><b></b></div>" ,
	                "</a>",
	                "<input class='select2-focusser select2-offscreen' type='text'/>",
	                "<div class='select2-drop' style='display:none'>" ,
	                "   <div class='select2-search'>" ,
	                "       <input type='text' autocomplete='off' class='select2-input'/>" ,
	                "   </div>" ,
	                "   <ul class='select2-results'>" ,
	                "   </ul>" ,
	                "</div>"].join(""));
	            return container;
	        },
	
	        // single
	        disable: function() {
	            if (!this.enabled) return;
	
	            this.parent.disable.apply(this, arguments);
	
	            this.focusser.attr("disabled", "disabled");
	        },
	
	        // single
	        enable: function() {
	            if (this.enabled) return;
	
	            this.parent.enable.apply(this, arguments);
	
	            this.focusser.removeAttr("disabled");
	        },
	
	        // single
	        opening: function () {
	            this.parent.opening.apply(this, arguments);
	            this.focusser.attr("disabled", "disabled");
	
	            this.opts.element.trigger($.Event("open"));
	        },
	
	        // single
	        close: function () {
	            if (!this.opened()) return;
	            this.parent.close.apply(this, arguments);
	            this.focusser.removeAttr("disabled");
	            focus(this.focusser);
	        },
	
	        // single
	        focus: function () {
	            if (this.opened()) {
	                this.close();
	            } else {
	                this.focusser.removeAttr("disabled");
	                this.focusser.focus();
	            }
	        },
	
	        // single
	        isFocused: function () {
	            return this.container.hasClass("select2-container-active");
	        },
	
	        // single
	        cancel: function () {
	            this.parent.cancel.apply(this, arguments);
	            this.focusser.removeAttr("disabled");
	            this.focusser.focus();
	        },
	
	        // single
	        initContainer: function () {
	
	            var selection,
	                container = this.container,
	                dropdown = this.dropdown,
	                clickingInside = false;
	
	            this.showSearch(this.opts.minimumResultsForSearch >= 0);
	
	            this.selection = selection = container.find(".select2-choice");
	
	            this.focusser = container.find(".select2-focusser");
	
	            this.search.bind("keydown", this.bind(function (e) {
	                if (!this.enabled) return;
	
	                if (e.which === KEY.PAGE_UP || e.which === KEY.PAGE_DOWN) {
	                    // prevent the page from scrolling
	                    killEvent(e);
	                    return;
	                }
	
	                switch (e.which) {
	                    case KEY.UP:
	                    case KEY.DOWN:
	                        this.moveHighlight((e.which === KEY.UP) ? -1 : 1);
	                        killEvent(e);
	                        return;
	                    case KEY.TAB:
	                    case KEY.ENTER:
	                        this.selectHighlighted();
	                        killEvent(e);
	                        return;
	                    case KEY.ESC:
	                        this.cancel(e);
	                        killEvent(e);
	                        return;
	                }
	            }));
	
	            this.focusser.bind("keydown", this.bind(function (e) {
	                if (!this.enabled) return;
	
	                if (e.which === KEY.TAB || KEY.isControl(e) || KEY.isFunctionKey(e) || e.which === KEY.ESC) {
	                    return;
	                }
	
	                if (this.opts.openOnEnter === false && e.which === KEY.ENTER) {
	                    killEvent(e);
	                    return;
	                }
	
	                if (e.which == KEY.DOWN || e.which == KEY.UP
	                    || (e.which == KEY.ENTER && this.opts.openOnEnter)) {
	                    this.open();
	                    killEvent(e);
	                    return;
	                }
	
	                if (e.which == KEY.DELETE || e.which == KEY.BACKSPACE) {
	                    if (this.opts.allowClear) {
	                        this.clear();
	                    }
	                    killEvent(e);
	                    return;
	                }
	            }));
	
	
	            installKeyUpChangeEvent(this.focusser);
	            this.focusser.bind("keyup-change input", this.bind(function(e) {
	                if (this.opened()) return;
	                this.open();
	                if (this.showSearchInput !== false) {
	                    this.search.val(this.focusser.val());
	                }
	                this.focusser.val("");
	                killEvent(e);
	            }));
	
	            selection.delegate("abbr", "mousedown", this.bind(function (e) {
	                if (!this.enabled) return;
	                this.clear();
	                killEventImmediately(e);
	                this.close();
	                this.selection.focus();
	            }));
	
	            selection.bind("mousedown", this.bind(function (e) {
	                clickingInside = true;
	
	                if (this.opened()) {
	                    this.close();
	                } else if (this.enabled) {
	                    this.open();
	                }
	
	                killEvent(e);
	
	                clickingInside = false;
	            }));
	
	            dropdown.bind("mousedown", this.bind(function() { this.search.focus(); }));
	
	            selection.bind("focus", this.bind(function(e) {
	                killEvent(e);
	            }));
	
	            this.focusser.bind("focus", this.bind(function(){
	                this.container.addClass("select2-container-active");
	            })).bind("blur", this.bind(function() {
	                if (!this.opened()) {
	                    this.container.removeClass("select2-container-active");
	                }
	            }));
	            this.search.bind("focus", this.bind(function(){
	                this.container.addClass("select2-container-active");
	            }))
	
	            this.initContainerWidth();
	            this.setPlaceholder();
	
	        },
	
	        // single
	        clear: function() {
	            var data=this.selection.data("select2-data");
	            this.opts.element.val("");
	            this.selection.find("span").empty();
	            this.selection.removeData("select2-data");
	            this.setPlaceholder();
	
	            this.opts.element.trigger({ type: "removed", val: this.id(data), choice: data });
	            this.triggerChange({removed:data});
	        },
	
	        /**
	         * Sets selection based on source element's value
	         */
	        // single
	        initSelection: function () {
	            var selected;
	            if (this.opts.element.val() === "" && this.opts.element.text() === "") {
	                this.close();
	                this.setPlaceholder();
	            } else {
	                var self = this;
	                this.opts.initSelection.call(null, this.opts.element, function(selected){
	                    if (selected !== undefined && selected !== null) {
	                        self.updateSelection(selected);
	                        self.close();
	                        self.setPlaceholder();
	                    }
	                });
	            }
	        },
	
	        // single
	        prepareOpts: function () {
	            var opts = this.parent.prepareOpts.apply(this, arguments);
	
	            if (opts.element.get(0).tagName.toLowerCase() === "select") {
	                // install the selection initializer
	                opts.initSelection = function (element, callback) {
	                    var selected = element.find(":selected");
	                    // a single select box always has a value, no need to null check 'selected'
	                    if ($.isFunction(callback))
	                        callback({id: selected.attr("value"), text: selected.text(), element:selected});
	                };
	            } else if ("data" in opts) {
	                // install default initSelection when applied to hidden input and data is local
	                opts.initSelection = opts.initSelection || function (element, callback) {
	                    var id = element.val();
	                    //search in data by id
	                    opts.query({
	                        matcher: function(term, text, el){
	                            return equal(id, opts.id(el));
	                        },
	                        callback: !$.isFunction(callback) ? $.noop : function(filtered) {
	                            callback(filtered.results.length ? filtered.results[0] : null);
	                        }
	                    });
	                };
	            }
	
	            return opts;
	        },
	
	        // single
	        getPlaceholder: function() {
	            // if a placeholder is specified on a single select without the first empty option ignore it
	            if (this.select) {
	                if (this.select.find("option").first().text() !== "") {
	                    return undefined;
	                }
	            }
	
	            return this.parent.getPlaceholder.apply(this, arguments);
	        },
	
	        // single
	        setPlaceholder: function () {
	            var placeholder = this.getPlaceholder();
	
	            if (this.opts.element.val() === "" && placeholder !== undefined) {
	
	                // check for a first blank option if attached to a select
	                if (this.select && this.select.find("option:first").text() !== "") return;
	
	                this.selection.find("span").html(this.opts.escapeMarkup(placeholder));
	
	                this.selection.addClass("select2-default");
	
	                this.selection.find("abbr").hide();
	            }
	        },
	
	        // single
	        postprocessResults: function (data, initial) {
	            var selected = 0, self = this, showSearchInput = true;
	
	            // find the selected element in the result list
	
	            this.findHighlightableChoices().each2(function (i, elm) {
	                if (equal(self.id(elm.data("select2-data")), self.opts.element.val())) {
	                    selected = i;
	                    return false;
	                }
	            });
	
	            // and highlight it
	
	            this.highlight(selected);
	
	            // hide the search box if this is the first we got the results and there are a few of them
	
	            if (initial === true) {
	                var min=this.opts.minimumResultsForSearch;
	                showSearchInput  = min < 0 ? false : countResults(data.results) >= min;
	                this.showSearch(showSearchInput);
	            }
	
	        },
	
	        // single
	        showSearch: function(showSearchInput) {
	            this.showSearchInput = showSearchInput;
	
	            this.dropdown.find(".select2-search")[showSearchInput ? "removeClass" : "addClass"]("select2-search-hidden");
	            //add "select2-with-searchbox" to the container if search box is shown
	            $(this.dropdown, this.container)[showSearchInput ? "addClass" : "removeClass"]("select2-with-searchbox");
	        },
	
	        // single
	        onSelect: function (data, options) {
	            var old = this.opts.element.val();
	
	            this.opts.element.val(this.id(data));
	            this.updateSelection(data);
	
	            this.opts.element.trigger({ type: "selected", val: this.id(data), choice: data });
	
	            this.close();
	
	            if (!options || !options.noFocus)
	                this.selection.focus();
	
	            if (!equal(old, this.id(data))) { this.triggerChange(); }
	        },
	
	        // single
	        updateSelection: function (data) {
	
	            var container=this.selection.find("span"), formatted;
	
	            this.selection.data("select2-data", data);
	
	            container.empty();
	            formatted=this.opts.formatSelection(data, container);
	            if (formatted !== undefined) {
	                container.append(this.opts.escapeMarkup(formatted));
	            }
	
	            this.selection.removeClass("select2-default");
	
	            if (this.opts.allowClear && this.getPlaceholder() !== undefined) {
	                this.selection.find("abbr").show();
	            }
	        },
	
	        // single
	        val: function () {
	            var val, triggerChange = false, data = null, self = this;
	
	            if (arguments.length === 0) {
	                return this.opts.element.val();
	            }
	
	            val = arguments[0];
	
	            if (arguments.length > 1) {
	                triggerChange = arguments[1];
	            }
	
	            if (this.select) {
	                this.select
	                    .val(val)
	                    .find(":selected").each2(function (i, elm) {
	                        data = {id: elm.attr("value"), text: elm.text()};
	                        return false;
	                    });
	                this.updateSelection(data);
	                this.setPlaceholder();
	                if (triggerChange) {
	                    this.triggerChange();
	                }
	            } else {
	                if (this.opts.initSelection === undefined) {
	                    throw new Error("cannot call val() if initSelection() is not defined");
	                }
	                // val is an id. !val is true for [undefined,null,'',0] - 0 is legal
	                if (!val && val !== 0) {
	                    this.clear();
	                    if (triggerChange) {
	                        this.triggerChange();
	                    }
	                    return;
	                }
	                this.opts.element.val(val);
	                this.opts.initSelection(this.opts.element, function(data){
	                    self.opts.element.val(!data ? "" : self.id(data));
	                    self.updateSelection(data);
	                    self.setPlaceholder();
	                    if (triggerChange) {
	                        self.triggerChange();
	                    }
	                });
	            }
	        },
	
	        // single
	        clearSearch: function () {
	            this.search.val("");
	            this.focusser.val("");
	        },
	
	        // single
	        data: function(value) {
	            var data;
	
	            if (arguments.length === 0) {
	                data = this.selection.data("select2-data");
	                if (data == undefined) data = null;
	                return data;
	            } else {
	                if (!value || value === "") {
	                    this.clear();
	                } else {
	                    this.opts.element.val(!value ? "" : this.id(value));
	                    this.updateSelection(value);
	                }
	            }
	        }
	    });
	
	    MultiSelect2 = clazz(AbstractSelect2, {
	
	        // multi
	        createContainer: function () {
	            var container = $(document.createElement("div")).attr({
	                "class": "select2-container select2-container-multi"
	            }).html([
	                "    <ul class='select2-choices'>",
	                //"<li class='select2-search-choice'><span>California</span><a href="javascript:void(0)" class="select2-search-choice-close"></a></li>" ,
	                "  <li class='select2-search-field'>" ,
	                "    <input type='text' autocomplete='off' class='select2-input'>" ,
	                "  </li>" ,
	                "</ul>" ,
	                "<div class='select2-drop select2-drop-multi' style='display:none;'>" ,
	                "   <ul class='select2-results'>" ,
	                "   </ul>" ,
	                "</div>"].join(""));
				return container;
	        },
	
	        // multi
	        prepareOpts: function () {
	            var opts = this.parent.prepareOpts.apply(this, arguments);
	
	            // TODO validate placeholder is a string if specified
	
	            if (opts.element.get(0).tagName.toLowerCase() === "select") {
	                // install sthe selection initializer
	                opts.initSelection = function (element, callback) {
	
	                    var data = [];
	
	                    element.find(":selected").each2(function (i, elm) {
	                        data.push({id: elm.attr("value"), text: elm.text(), element: elm[0]});
	                    });
	                    callback(data);
	                };
	            } else if ("data" in opts) {
	                // install default initSelection when applied to hidden input and data is local
	                opts.initSelection = opts.initSelection || function (element, callback) {
	                    var ids = splitVal(element.val(), opts.separator);
	                    //search in data by array of ids
	                    opts.query({
	                        matcher: function(term, text, el){
	                            return $.grep(ids, function(id) {
	                                return equal(id, opts.id(el));
	                            }).length;
	                        },
	                        callback: !$.isFunction(callback) ? $.noop : function(filtered) {
	                            callback(filtered.results);
	                        }
	                    });
	                };
	            }
	
	            return opts;
	        },
	
	        // multi
	        initContainer: function () {
	
	            var selector = ".select2-choices", selection;
	
	            this.searchContainer = this.container.find(".select2-search-field");
	            this.selection = selection = this.container.find(selector);
	
	            this.search.bind("input paste", this.bind(function() {
	                if (!this.enabled) return;
	                if (!this.opened()) {
	                    this.open();
	                }
	            }));
	
	            this.search.bind("keydown", this.bind(function (e) {
	                if (!this.enabled) return;
	
	                if (e.which === KEY.BACKSPACE && this.search.val() === "") {
	                    this.close();
	
	                    var choices,
	                        selected = selection.find(".select2-search-choice-focus");
	                    if (selected.length > 0) {
	                        this.unselect(selected.first());
	                        this.search.width(10);
	                        killEvent(e);
	                        return;
	                    }
	
	                    choices = selection.find(".select2-search-choice:not(.select2-locked)");
	                    if (choices.length > 0) {
	                        choices.last().addClass("select2-search-choice-focus");
	                    }
	                } else {
	                    selection.find(".select2-search-choice-focus").removeClass("select2-search-choice-focus");
	                }
	
	                if (this.opened()) {
	                    switch (e.which) {
	                    case KEY.UP:
	                    case KEY.DOWN:
	                        this.moveHighlight((e.which === KEY.UP) ? -1 : 1);
	                        killEvent(e);
	                        return;
	                    case KEY.ENTER:
	                    case KEY.TAB:
	                        this.selectHighlighted();
	                        killEvent(e);
	                        return;
	                    case KEY.ESC:
	                        this.cancel(e);
	                        killEvent(e);
	                        return;
	                    }
	                }
	
	                if (e.which === KEY.TAB || KEY.isControl(e) || KEY.isFunctionKey(e)
	                 || e.which === KEY.BACKSPACE || e.which === KEY.ESC) {
	                    return;
	                }
	
	                if (e.which === KEY.ENTER) {
	                    if (this.opts.openOnEnter === false) {
	                        return;
	                    } else if (e.altKey || e.ctrlKey || e.shiftKey || e.metaKey) {
	                        return;
	                    }
	                }
	
	                this.open();
	
	                if (e.which === KEY.PAGE_UP || e.which === KEY.PAGE_DOWN) {
	                    // prevent the page from scrolling
	                    killEvent(e);
	                }
	            }));
	
	            this.search.bind("keyup", this.bind(this.resizeSearch));
	
	            this.search.bind("blur", this.bind(function(e) {
	                this.container.removeClass("select2-container-active");
	                this.search.removeClass("select2-focused");
	                if (!this.opened()) this.clearSearch();
	                e.stopImmediatePropagation();
	            }));
	
	            this.container.delegate(selector, "mousedown", this.bind(function (e) {
	                if (!this.enabled) return;
	                if ($(e.target).closest(".select2-search-choice").length > 0) {
	                    // clicked inside a select2 search choice, do not open
	                    return;
	                }
	                this.clearPlaceholder();
	                this.open();
	                this.focusSearch();
	                e.preventDefault();
	            }));
	
	            this.container.delegate(selector, "focus", this.bind(function () {
	                if (!this.enabled) return;
	                this.container.addClass("select2-container-active");
	                this.dropdown.addClass("select2-drop-active");
	                this.clearPlaceholder();
	            }));
	
	            this.initContainerWidth();
	
	            // set the placeholder if necessary
	            this.clearSearch();
	        },
	
	        // multi
	        enable: function() {
	            if (this.enabled) return;
	
	            this.parent.enable.apply(this, arguments);
	
	            this.search.removeAttr("disabled");
	        },
	
	        // multi
	        disable: function() {
	            if (!this.enabled) return;
	
	            this.parent.disable.apply(this, arguments);
	
	            this.search.attr("disabled", true);
	        },
	
	        // multi
	        initSelection: function () {
	            var data;
	            if (this.opts.element.val() === "" && this.opts.element.text() === "") {
	                this.updateSelection([]);
	                this.close();
	                // set the placeholder if necessary
	                this.clearSearch();
	            }
	            if (this.select || this.opts.element.val() !== "") {
	                var self = this;
	                this.opts.initSelection.call(null, this.opts.element, function(data){
	                    if (data !== undefined && data !== null) {
	                        self.updateSelection(data);
	                        self.close();
	                        // set the placeholder if necessary
	                        self.clearSearch();
	                    }
	                });
	            }
	        },
	
	        // multi
	        clearSearch: function () {
	            var placeholder = this.getPlaceholder();
	
	            if (placeholder !== undefined  && this.getVal().length === 0 && this.search.hasClass("select2-focused") === false) {
	                this.search.val(placeholder).addClass("select2-default");
	                // stretch the search box to full width of the container so as much of the placeholder is visible as possible
	                this.resizeSearch();
	            } else {
	                this.search.val("").width(10);
	            }
	        },
	
	        // multi
	        clearPlaceholder: function () {
	            if (this.search.hasClass("select2-default")) {
	                this.search.val("").removeClass("select2-default");
	            }
	        },
	
	        // multi
	        opening: function () {
	            this.parent.opening.apply(this, arguments);
	
	            this.clearPlaceholder();
				this.resizeSearch();
	            this.focusSearch();
	
	            this.opts.element.trigger($.Event("open"));
	        },
	
	        // multi
	        close: function () {
	            if (!this.opened()) return;
	            this.parent.close.apply(this, arguments);
	        },
	
	        // multi
	        focus: function () {
	            this.close();
	            this.search.focus();
	            this.opts.element.triggerHandler("focus");
	        },
	
	        // multi
	        isFocused: function () {
	            return this.search.hasClass("select2-focused");
	        },
	
	        // multi
	        updateSelection: function (data) {
	            var ids = [], filtered = [], self = this;
	
	            // filter out duplicates
	            $(data).each(function () {
	                if (indexOf(self.id(this), ids) < 0) {
	                    ids.push(self.id(this));
	                    filtered.push(this);
	                }
	            });
	            data = filtered;
	
	            this.selection.find(".select2-search-choice").remove();
	            $(data).each(function () {
	                self.addSelectedChoice(this);
	            });
	            self.postprocessResults();
	        },
	
	        tokenize: function() {
	            var input = this.search.val();
	            input = this.opts.tokenizer(input, this.data(), this.bind(this.onSelect), this.opts);
	            if (input != null && input != undefined) {
	                this.search.val(input);
	                if (input.length > 0) {
	                    this.open();
	                }
	            }
	
	        },
	
	        // multi
	        onSelect: function (data, options) {
	            this.addSelectedChoice(data);
	
	            this.opts.element.trigger({ type: "selected", val: this.id(data), choice: data });
	
	            if (this.select || !this.opts.closeOnSelect) this.postprocessResults();
	
	            if (this.opts.closeOnSelect) {
	                this.close();
	                this.search.width(10);
	            } else {
	                if (this.countSelectableResults()>0) {
	                    this.search.width(10);
	                    this.resizeSearch();
	                    if (this.val().length >= this.getMaximumSelectionSize()) {
	                        // if we reached max selection size repaint the results so choices
	                        // are replaced with the max selection reached message
	                        this.updateResults(true);
	                    }
	                    this.positionDropdown();
	                } else {
	                    // if nothing left to select close
	                    this.close();
	                    this.search.width(10);
	                }
	            }
	
	            // since its not possible to select an element that has already been
	            // added we do not need to check if this is a new element before firing change
	            this.triggerChange({ added: data });
	
	            if (!options || !options.noFocus)
	                this.focusSearch();
	        },
	
	        // multi
	        cancel: function () {
	            this.close();
	            this.focusSearch();
	        },
	
	        addSelectedChoice: function (data) {
	            var enableChoice = !data.locked,
	                enabledItem = $(
	                    "<li class='select2-search-choice'>" +
	                    "    <div></div>" +
	                    "    <a href='#' onclick='return false;' class='select2-search-choice-close' tabindex='-1'></a>" +
	                    "</li>"),
	                disabledItem = $(
	                    "<li class='select2-search-choice select2-locked'>" +
	                    "<div></div>" +
	                    "</li>");
	            var choice = enableChoice ? enabledItem : disabledItem,
	                id = this.id(data),
	                val = this.getVal(),
	                formatted;
	
	            formatted=this.opts.formatSelection(data, choice.find("div"));
	            if (formatted != undefined) {
	                choice.find("div").replaceWith("<div>"+this.opts.escapeMarkup(formatted)+"</div>");
	            }
	
	            if(enableChoice){
	              choice.find(".select2-search-choice-close")
	                  .bind("mousedown", killEvent)
	                  .bind("click dblclick", this.bind(function (e) {
	                  if (!this.enabled) return;
	
	                  $(e.target).closest(".select2-search-choice").fadeOut('fast', this.bind(function(){
	                      this.unselect($(e.target));
	                      this.selection.find(".select2-search-choice-focus").removeClass("select2-search-choice-focus");
	                      this.close();
	                      this.focusSearch();
	                  })).dequeue();
	                  killEvent(e);
	              })).bind("focus", this.bind(function () {
	                  if (!this.enabled) return;
	                  this.container.addClass("select2-container-active");
	                  this.dropdown.addClass("select2-drop-active");
	              }));
	            }
	
	            choice.data("select2-data", data);
	            choice.insertBefore(this.searchContainer);
	
	            val.push(id);
	            this.setVal(val);
	        },
	
	        // multi
	        unselect: function (selected) {
	            var val = this.getVal(),
	                data,
	                index;
	
	            selected = selected.closest(".select2-search-choice");
	
	            if (selected.length === 0) {
	                throw "Invalid argument: " + selected + ". Must be .select2-search-choice";
	            }
	
	            data = selected.data("select2-data");
	
	            if (!data) {
	                // prevent a race condition when the 'x' is clicked really fast repeatedly the event can be queued
	                // and invoked on an element already removed
	                return;
	            }
	
	            index = indexOf(this.id(data), val);
	
	            if (index >= 0) {
	                val.splice(index, 1);
	                this.setVal(val);
	                if (this.select) this.postprocessResults();
	            }
	            selected.remove();
	
	            this.opts.element.trigger({ type: "removed", val: this.id(data), choice: data });
	            this.triggerChange({ removed: data });
	        },
	
	        // multi
	        postprocessResults: function () {
	            var val = this.getVal(),
	                choices = this.results.find(".select2-result"),
	                compound = this.results.find(".select2-result-with-children"),
	                self = this;
	
	            choices.each2(function (i, choice) {
	                var id = self.id(choice.data("select2-data"));
	                if (indexOf(id, val) >= 0) {
	                    choice.addClass("select2-selected");
	                    // mark all children of the selected parent as selected
	                    choice.find(".select2-result-selectable").addClass("select2-selected");
	                }
	            });
	
	            compound.each2(function(i, choice) {
	                // hide an optgroup if it doesnt have any selectable children
	                if (!choice.is('.select2-result-selectable')
	                    && choice.find(".select2-result-selectable:not(.select2-selected)").length === 0) {
	                    choice.addClass("select2-selected");
	                }
	            });
	
	            if (this.highlight() == -1){
	                self.highlight(0);
	            }
	
	        },
	
	        // multi
	        resizeSearch: function () {
	            var minimumWidth, left, maxWidth, containerLeft, searchWidth,
	            	sideBorderPadding = getSideBorderPadding(this.search);
	
	            minimumWidth = measureTextWidth(this.search) + 10;
	
	            left = this.search.offset().left;
	
	            maxWidth = this.selection.width();
	            containerLeft = this.selection.offset().left;
	
	            searchWidth = maxWidth - (left - containerLeft) - sideBorderPadding;
	
	            if (searchWidth < minimumWidth) {
	                searchWidth = maxWidth - sideBorderPadding;
	            }
	
	            if (searchWidth < 40) {
	                searchWidth = maxWidth - sideBorderPadding;
	            }
	
	            if (searchWidth <= 0) {
	              searchWidth = minimumWidth;
	            }
	
	            this.search.width(searchWidth);
	        },
	
	        // multi
	        getVal: function () {
	            var val;
	            if (this.select) {
	                val = this.select.val();
	                return val === null ? [] : val;
	            } else {
	                val = this.opts.element.val();
	                return splitVal(val, this.opts.separator);
	            }
	        },
	
	        // multi
	        setVal: function (val) {
	            var unique;
	            if (this.select) {
	                this.select.val(val);
	            } else {
	                unique = [];
	                // filter out duplicates
	                $(val).each(function () {
	                    if (indexOf(this, unique) < 0) unique.push(this);
	                });
	                this.opts.element.val(unique.length === 0 ? "" : unique.join(this.opts.separator));
	            }
	        },
	
	        // multi
	        val: function () {
	            var val, triggerChange = false, data = [], self=this;
	
	            if (arguments.length === 0) {
	                return this.getVal();
	            }
	
	            val = arguments[0];
	
	            if (arguments.length > 1) {
	                triggerChange = arguments[1];
	            }
	
	            // val is an id. !val is true for [undefined,null,'',0] - 0 is legal
	            if (!val && val !== 0) {
	                this.opts.element.val("");
	                this.updateSelection([]);
	                this.clearSearch();
	                if (triggerChange) {
	                    this.triggerChange();
	                }
	                return;
	            }
	
	            // val is a list of ids
	            this.setVal(val);
	
	            if (this.select) {
	                this.opts.initSelection(this.select, this.bind(this.updateSelection));
	                if (triggerChange) {
	                    this.triggerChange();
	                }
	            } else {
	                if (this.opts.initSelection === undefined) {
	                    throw new Error("val() cannot be called if initSelection() is not defined");
	                }
	
	                this.opts.initSelection(this.opts.element, function(data){
	                    var ids=$(data).map(self.id);
	                    self.setVal(ids);
	                    self.updateSelection(data);
	                    self.clearSearch();
	                    if (triggerChange) {
	                        self.triggerChange();
	                    }
	                });
	            }
	            this.clearSearch();
	        },
	
	        // multi
	        onSortStart: function() {
	            if (this.select) {
	                throw new Error("Sorting of elements is not supported when attached to <select>. Attach to <input type='hidden'/> instead.");
	            }
	
	            // collapse search field into 0 width so its container can be collapsed as well
	            this.search.width(0);
	            // hide the container
	            this.searchContainer.hide();
	        },
	
	        // multi
	        onSortEnd:function() {
	
	            var val=[], self=this;
	
	            // show search and move it to the end of the list
	            this.searchContainer.show();
	            // make sure the search container is the last item in the list
	            this.searchContainer.appendTo(this.searchContainer.parent());
	            // since we collapsed the width in dragStarted, we resize it here
	            this.resizeSearch();
	
	            // update selection
	
	            this.selection.find(".select2-search-choice").each(function() {
	                val.push(self.opts.id($(this).data("select2-data")));
	            });
	            this.setVal(val);
	            this.triggerChange();
	        },
	
	        // multi
	        data: function(values) {
	            var self=this, ids;
	            if (arguments.length === 0) {
	                 return this.selection
	                     .find(".select2-search-choice")
	                     .map(function() { return $(this).data("select2-data"); })
	                     .get();
	            } else {
	                if (!values) { values = []; }
	                ids = $.map(values, function(e) { return self.opts.id(e); });
	                this.setVal(ids);
	                this.updateSelection(values);
	                this.clearSearch();
	            }
	        }
	    });
	
	    $.fn.select2 = function () {
	
	        var args = Array.prototype.slice.call(arguments, 0),
	            opts,
	            select2,
	            value, multiple, allowedMethods = ["updateResults", "val", "destroy", "opened", "open", "close", "focus", "isFocused", "container", "onSortStart", "onSortEnd", "enable", "disable", "positionDropdown", "data"];
	
	        this.each(function () {
	            if (args.length === 0 || typeof(args[0]) === "object") {
	                opts = args.length === 0 ? {} : $.extend({}, args[0]);
	                opts.element = $(this);
	
	                if (opts.element.get(0).tagName.toLowerCase() === "select") {
	                    multiple = opts.element.attr("multiple");
	                } else {
	                    multiple = opts.multiple || false;
	                    if ("tags" in opts) {opts.multiple = multiple = true;}
	                }
	
	                select2 = multiple ? new MultiSelect2() : new SingleSelect2();
	                select2.init(opts);
	            } else if (typeof(args[0]) === "string") {
	
	                if (indexOf(args[0], allowedMethods) < 0) {
	                    throw "Unknown method: " + args[0];
	                }
	
	                value = undefined;
	                select2 = $(this).data("select2");
	                if (select2 === undefined) return;
	                if (args[0] === "container") {
	                    value=select2.container;
	                } else {
	                    value = select2[args[0]].apply(select2, args.slice(1));
	                }
	                if (value !== undefined) {return false;}
	            } else {
	                throw "Invalid arguments to select2 plugin: " + args;
	            }
	        });
	        return (value === undefined) ? this : value;
	    };
	
	    // plugin defaults, accessible to users
	    $.fn.select2.defaults = {
	        width: "copy",
	        loadMorePadding: 0,
	        closeOnSelect: true,
	        openOnEnter: true,
	        containerCss: {},
	        dropdownCss: {},
	        containerCssClass: "",
	        dropdownCssClass: "",
	        formatResult: function(result, container, query, escapeMarkup) {
	            var markup=[];
	            markMatch(result.text, query.term, markup, escapeMarkup);
	            return markup.join("");
	        },
	        formatSelection: function (data, container) {
	            return data ? data.text : undefined;
	        },
	        sortResults: function (results, container, query) {
	            return results;
	        },
	        formatResultCssClass: function(data) {return undefined;},
	        formatNoMatches: function () { return "No matches found"; },
	        formatInputTooShort: function (input, min) { var n = min - input.length; return "Please enter " + n + " more character" + (n == 1? "" : "s"); },
	        formatInputTooLong: function (input, max) { var n = input.length - max; return "Please enter " + n + " less character" + (n == 1? "" : "s"); },
	        formatSelectionTooBig: function (limit) { return "You can only select " + limit + " item" + (limit == 1 ? "" : "s"); },
	        formatLoadMore: function (pageNumber) { return "Loading more results..."; },
	        formatSearching: function () { return "Searching..."; },
	        minimumResultsForSearch: 0,
	        minimumInputLength: 0,
	        maximumInputLength: null,
	        maximumSelectionSize: 0,
	        id: function (e) { return e.id; },
	        matcher: function(term, text) {
	            return text.toUpperCase().indexOf(term.toUpperCase()) >= 0;
	        },
	        separator: ",",
	        tokenSeparators: [],
	        tokenizer: defaultTokenizer,
	        escapeMarkup: function (markup) {
	            var replace_map = {
	                '\\': '&#92;',
	                '&': '&amp;',
	                '<': '&lt;',
	                '>': '&gt;',
	                '"': '&quot;',
	                "'": '&apos;',
	                "/": '&#47;'
	            };
	
	            return String(markup).replace(/[&<>"'/\\]/g, function (match) {
	                    return replace_map[match[0]];
	            });
	        },
	        blurOnChange: false,
	        selectOnBlur: false,
	        adaptContainerCssClass: function(c) { return c; },
	        adaptDropdownCssClass: function(c) { return null; }
	    };
	
	    // exports
	    window.Select2 = {
	        query: {
	            ajax: ajax,
	            local: local,
	            tags: tags
	        }, util: {
	            debounce: debounce,
	            markMatch: markMatch
	        }, "class": {
	            "abstract": AbstractSelect2,
	            "single": SingleSelect2,
	            "multi": MultiSelect2
	        }
	    };
	
	}(jQuery));


/***/ }),
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */
/***/ (function(module, exports) {

	'use strict';
	
	/*
	 * jQuery File Upload Plugin
	 * https://github.com/blueimp/jQuery-File-Upload
	 *
	 * Copyright 2010, Sebastian Tschan
	 * https://blueimp.net
	 *
	 * Licensed under the MIT license:
	 * http://www.opensource.org/licenses/MIT
	 */
	
	/* jshint nomen:false */
	/* global window, document, location, Blob, FormData */
	
	(function (factory) {
	    'use strict';
	    // Browser globals:
	
	    factory(jQuery);
	})(function ($) {
	    'use strict';
	
	    // Detect file input support, based on
	    // http://viljamis.com/blog/2012/file-upload-support-on-mobile/
	
	    $.support.fileInput = !(new RegExp(
	    // Handle devices which give false positives for the feature detection:
	    '(Android (1\\.[0156]|2\\.[01]))' + '|(Windows Phone (OS 7|8\\.0))|(XBLWP)|(ZuneWP)|(WPDesktop)' + '|(w(eb)?OSBrowser)|(webOS)' + '|(Kindle/(1\\.0|2\\.[05]|3\\.0))').test(window.navigator.userAgent) ||
	    // Feature detection for all other devices:
	    $('<input type="file">').prop('disabled'));
	
	    // The FileReader API is not actually used, but works as feature detection,
	    // as some Safari versions (5?) support XHR file uploads via the FormData API,
	    // but not non-multipart XHR file uploads.
	    // window.XMLHttpRequestUpload is not available on IE10, so we check for
	    // window.ProgressEvent instead to detect XHR2 file upload capability:
	    $.support.xhrFileUpload = !!(window.ProgressEvent && window.FileReader);
	    $.support.xhrFormDataFileUpload = !!window.FormData;
	
	    // Detect support for Blob slicing (required for chunked uploads):
	    $.support.blobSlice = window.Blob && (Blob.prototype.slice || Blob.prototype.webkitSlice || Blob.prototype.mozSlice);
	
	    // Helper function to create drag handlers for dragover/dragenter/dragleave:
	    function getDragHandler(type) {
	        var isDragOver = type === 'dragover';
	        return function (e) {
	            e.dataTransfer = e.originalEvent && e.originalEvent.dataTransfer;
	            var dataTransfer = e.dataTransfer;
	            if (dataTransfer && $.inArray('Files', dataTransfer.types) !== -1 && this._trigger(type, $.Event(type, { delegatedEvent: e })) !== false) {
	                e.preventDefault();
	                if (isDragOver) {
	                    dataTransfer.dropEffect = 'copy';
	                }
	            }
	        };
	    }
	
	    // The fileupload widget listens for change events on file input fields defined
	    // via fileInput setting and paste or drop events of the given dropZone.
	    // In addition to the default jQuery Widget methods, the fileupload widget
	    // exposes the "add" and "send" methods, to add or directly send files using
	    // the fileupload API.
	    // By default, files added via file input selection, paste, drag & drop or
	    // "add" method are uploaded immediately, but it is possible to override
	    // the "add" callback option to queue file uploads.
	    $.widget('blueimp.fileupload', {
	
	        options: {
	            // The drop target element(s), by the default the complete document.
	            // Set to null to disable drag & drop support:
	            dropZone: $(document),
	            // The paste target element(s), by the default undefined.
	            // Set to a DOM node or jQuery object to enable file pasting:
	            pasteZone: undefined,
	            // The file input field(s), that are listened to for change events.
	            // If undefined, it is set to the file input fields inside
	            // of the widget element on plugin initialization.
	            // Set to null to disable the change listener.
	            fileInput: undefined,
	            // By default, the file input field is replaced with a clone after
	            // each input field change event. This is required for iframe transport
	            // queues and allows change events to be fired for the same file
	            // selection, but can be disabled by setting the following option to false:
	            replaceFileInput: true,
	            // The parameter name for the file form data (the request argument name).
	            // If undefined or empty, the name property of the file input field is
	            // used, or "files[]" if the file input name property is also empty,
	            // can be a string or an array of strings:
	            paramName: undefined,
	            // By default, each file of a selection is uploaded using an individual
	            // request for XHR type uploads. Set to false to upload file
	            // selections in one request each:
	            singleFileUploads: true,
	            // To limit the number of files uploaded with one XHR request,
	            // set the following option to an integer greater than 0:
	            limitMultiFileUploads: undefined,
	            // The following option limits the number of files uploaded with one
	            // XHR request to keep the request size under or equal to the defined
	            // limit in bytes:
	            limitMultiFileUploadSize: undefined,
	            // Multipart file uploads add a number of bytes to each uploaded file,
	            // therefore the following option adds an overhead for each file used
	            // in the limitMultiFileUploadSize configuration:
	            limitMultiFileUploadSizeOverhead: 512,
	            // Set the following option to true to issue all file upload requests
	            // in a sequential order:
	            sequentialUploads: false,
	            // To limit the number of concurrent uploads,
	            // set the following option to an integer greater than 0:
	            limitConcurrentUploads: undefined,
	            // Set the following option to true to force iframe transport uploads:
	            forceIframeTransport: false,
	            // Set the following option to the location of a redirect url on the
	            // origin server, for cross-domain iframe transport uploads:
	            redirect: undefined,
	            // The parameter name for the redirect url, sent as part of the form
	            // data and set to 'redirect' if this option is empty:
	            redirectParamName: undefined,
	            // Set the following option to the location of a postMessage window,
	            // to enable postMessage transport uploads:
	            postMessage: undefined,
	            // By default, XHR file uploads are sent as multipart/form-data.
	            // The iframe transport is always using multipart/form-data.
	            // Set to false to enable non-multipart XHR uploads:
	            multipart: true,
	            // To upload large files in smaller chunks, set the following option
	            // to a preferred maximum chunk size. If set to 0, null or undefined,
	            // or the browser does not support the required Blob API, files will
	            // be uploaded as a whole.
	            maxChunkSize: undefined,
	            // When a non-multipart upload or a chunked multipart upload has been
	            // aborted, this option can be used to resume the upload by setting
	            // it to the size of the already uploaded bytes. This option is most
	            // useful when modifying the options object inside of the "add" or
	            // "send" callbacks, as the options are cloned for each file upload.
	            uploadedBytes: undefined,
	            // By default, failed (abort or error) file uploads are removed from the
	            // global progress calculation. Set the following option to false to
	            // prevent recalculating the global progress data:
	            recalculateProgress: true,
	            // Interval in milliseconds to calculate and trigger progress events:
	            progressInterval: 100,
	            // Interval in milliseconds to calculate progress bitrate:
	            bitrateInterval: 500,
	            // By default, uploads are started automatically when adding files:
	            autoUpload: true,
	
	            // Error and info messages:
	            messages: {
	                uploadedBytes: 'Uploaded bytes exceed file size'
	            },
	
	            // Translation function, gets the message key to be translated
	            // and an object with context specific data as arguments:
	            i18n: function i18n(message, context) {
	                message = this.messages[message] || message.toString();
	                if (context) {
	                    $.each(context, function (key, value) {
	                        message = message.replace('{' + key + '}', value);
	                    });
	                }
	                return message;
	            },
	
	            // Additional form data to be sent along with the file uploads can be set
	            // using this option, which accepts an array of objects with name and
	            // value properties, a function returning such an array, a FormData
	            // object (for XHR file uploads), or a simple object.
	            // The form of the first fileInput is given as parameter to the function:
	            formData: function formData(form) {
	                return form.serializeArray();
	            },
	
	            // The add callback is invoked as soon as files are added to the fileupload
	            // widget (via file input selection, drag & drop, paste or add API call).
	            // If the singleFileUploads option is enabled, this callback will be
	            // called once for each file in the selection for XHR file uploads, else
	            // once for each file selection.
	            //
	            // The upload starts when the submit method is invoked on the data parameter.
	            // The data object contains a files property holding the added files
	            // and allows you to override plugin options as well as define ajax settings.
	            //
	            // Listeners for this callback can also be bound the following way:
	            // .bind('fileuploadadd', func);
	            //
	            // data.submit() returns a Promise object and allows to attach additional
	            // handlers using jQuery's Deferred callbacks:
	            // data.submit().done(func).fail(func).always(func);
	            add: function add(e, data) {
	                if (e.isDefaultPrevented()) {
	                    return false;
	                }
	                if (data.autoUpload || data.autoUpload !== false && $(this).fileupload('option', 'autoUpload')) {
	                    data.process().done(function () {
	                        data.submit();
	                    });
	                }
	            },
	
	            // Other callbacks:
	
	            // Callback for the submit event of each file upload:
	            // submit: function (e, data) {}, // .bind('fileuploadsubmit', func);
	
	            // Callback for the start of each file upload request:
	            // send: function (e, data) {}, // .bind('fileuploadsend', func);
	
	            // Callback for successful uploads:
	            // done: function (e, data) {}, // .bind('fileuploaddone', func);
	
	            // Callback for failed (abort or error) uploads:
	            // fail: function (e, data) {}, // .bind('fileuploadfail', func);
	
	            // Callback for completed (success, abort or error) requests:
	            // always: function (e, data) {}, // .bind('fileuploadalways', func);
	
	            // Callback for upload progress events:
	            // progress: function (e, data) {}, // .bind('fileuploadprogress', func);
	
	            // Callback for global upload progress events:
	            // progressall: function (e, data) {}, // .bind('fileuploadprogressall', func);
	
	            // Callback for uploads start, equivalent to the global ajaxStart event:
	            // start: function (e) {}, // .bind('fileuploadstart', func);
	
	            // Callback for uploads stop, equivalent to the global ajaxStop event:
	            // stop: function (e) {}, // .bind('fileuploadstop', func);
	
	            // Callback for change events of the fileInput(s):
	            // change: function (e, data) {}, // .bind('fileuploadchange', func);
	
	            // Callback for paste events to the pasteZone(s):
	            // paste: function (e, data) {}, // .bind('fileuploadpaste', func);
	
	            // Callback for drop events of the dropZone(s):
	            // drop: function (e, data) {}, // .bind('fileuploaddrop', func);
	
	            // Callback for dragover events of the dropZone(s):
	            // dragover: function (e) {}, // .bind('fileuploaddragover', func);
	
	            // Callback for the start of each chunk upload request:
	            // chunksend: function (e, data) {}, // .bind('fileuploadchunksend', func);
	
	            // Callback for successful chunk uploads:
	            // chunkdone: function (e, data) {}, // .bind('fileuploadchunkdone', func);
	
	            // Callback for failed (abort or error) chunk uploads:
	            // chunkfail: function (e, data) {}, // .bind('fileuploadchunkfail', func);
	
	            // Callback for completed (success, abort or error) chunk upload requests:
	            // chunkalways: function (e, data) {}, // .bind('fileuploadchunkalways', func);
	
	            // The plugin options are used as settings object for the ajax calls.
	            // The following are jQuery ajax settings required for the file uploads:
	            processData: false,
	            contentType: false,
	            cache: false,
	            timeout: 0
	        },
	
	        // A list of options that require reinitializing event listeners and/or
	        // special initialization code:
	        _specialOptions: ['fileInput', 'dropZone', 'pasteZone', 'multipart', 'forceIframeTransport'],
	
	        _blobSlice: $.support.blobSlice && function () {
	            var slice = this.slice || this.webkitSlice || this.mozSlice;
	            return slice.apply(this, arguments);
	        },
	
	        _BitrateTimer: function _BitrateTimer() {
	            this.timestamp = Date.now ? Date.now() : new Date().getTime();
	            this.loaded = 0;
	            this.bitrate = 0;
	            this.getBitrate = function (now, loaded, interval) {
	                var timeDiff = now - this.timestamp;
	                if (!this.bitrate || !interval || timeDiff > interval) {
	                    this.bitrate = (loaded - this.loaded) * (1000 / timeDiff) * 8;
	                    this.loaded = loaded;
	                    this.timestamp = now;
	                }
	                return this.bitrate;
	            };
	        },
	
	        _isXHRUpload: function _isXHRUpload(options) {
	            return !options.forceIframeTransport && (!options.multipart && $.support.xhrFileUpload || $.support.xhrFormDataFileUpload);
	        },
	
	        _getFormData: function _getFormData(options) {
	            var formData;
	            if ($.type(options.formData) === 'function') {
	                return options.formData(options.form);
	            }
	            if ($.isArray(options.formData)) {
	                return options.formData;
	            }
	            if ($.type(options.formData) === 'object') {
	                formData = [];
	                $.each(options.formData, function (name, value) {
	                    formData.push({ name: name, value: value });
	                });
	                return formData;
	            }
	            return [];
	        },
	
	        _getTotal: function _getTotal(files) {
	            var total = 0;
	            $.each(files, function (index, file) {
	                total += file.size || 1;
	            });
	            return total;
	        },
	
	        _initProgressObject: function _initProgressObject(obj) {
	            var progress = {
	                loaded: 0,
	                total: 0,
	                bitrate: 0
	            };
	            if (obj._progress) {
	                $.extend(obj._progress, progress);
	            } else {
	                obj._progress = progress;
	            }
	        },
	
	        _initResponseObject: function _initResponseObject(obj) {
	            var prop;
	            if (obj._response) {
	                for (prop in obj._response) {
	                    if (obj._response.hasOwnProperty(prop)) {
	                        delete obj._response[prop];
	                    }
	                }
	            } else {
	                obj._response = {};
	            }
	        },
	
	        _onProgress: function _onProgress(e, data) {
	            if (e.lengthComputable) {
	                var now = Date.now ? Date.now() : new Date().getTime(),
	                    loaded;
	                if (data._time && data.progressInterval && now - data._time < data.progressInterval && e.loaded !== e.total) {
	                    return;
	                }
	                data._time = now;
	                loaded = Math.floor(e.loaded / e.total * (data.chunkSize || data._progress.total)) + (data.uploadedBytes || 0);
	                // Add the difference from the previously loaded state
	                // to the global loaded counter:
	                this._progress.loaded += loaded - data._progress.loaded;
	                this._progress.bitrate = this._bitrateTimer.getBitrate(now, this._progress.loaded, data.bitrateInterval);
	                data._progress.loaded = data.loaded = loaded;
	                data._progress.bitrate = data.bitrate = data._bitrateTimer.getBitrate(now, loaded, data.bitrateInterval);
	                // Trigger a custom progress event with a total data property set
	                // to the file size(s) of the current upload and a loaded data
	                // property calculated accordingly:
	                this._trigger('progress', $.Event('progress', { delegatedEvent: e }), data);
	                // Trigger a global progress event for all current file uploads,
	                // including ajax calls queued for sequential file uploads:
	                this._trigger('progressall', $.Event('progressall', { delegatedEvent: e }), this._progress);
	            }
	        },
	
	        _initProgressListener: function _initProgressListener(options) {
	            var that = this,
	                xhr = options.xhr ? options.xhr() : $.ajaxSettings.xhr();
	            // Accesss to the native XHR object is required to add event listeners
	            // for the upload progress event:
	            if (xhr.upload) {
	                $(xhr.upload).bind('progress', function (e) {
	                    var oe = e.originalEvent;
	                    // Make sure the progress event properties get copied over:
	                    e.lengthComputable = oe.lengthComputable;
	                    e.loaded = oe.loaded;
	                    e.total = oe.total;
	                    that._onProgress(e, options);
	                });
	                options.xhr = function () {
	                    return xhr;
	                };
	            }
	        },
	
	        _isInstanceOf: function _isInstanceOf(type, obj) {
	            // Cross-frame instanceof check
	            return Object.prototype.toString.call(obj) === '[object ' + type + ']';
	        },
	
	        _initXHRData: function _initXHRData(options) {
	            var that = this,
	                formData,
	                file = options.files[0],
	
	            // Ignore non-multipart setting if not supported:
	            multipart = options.multipart || !$.support.xhrFileUpload,
	                paramName = $.type(options.paramName) === 'array' ? options.paramName[0] : options.paramName;
	            options.headers = $.extend({}, options.headers);
	            if (options.contentRange) {
	                options.headers['Content-Range'] = options.contentRange;
	            }
	            if (!multipart || options.blob || !this._isInstanceOf('File', file)) {
	                options.headers['Content-Disposition'] = 'attachment; filename="' + encodeURI(file.name) + '"';
	            }
	            if (!multipart) {
	                options.contentType = file.type || 'application/octet-stream';
	                options.data = options.blob || file;
	            } else if ($.support.xhrFormDataFileUpload) {
	                if (options.postMessage) {
	                    // window.postMessage does not allow sending FormData
	                    // objects, so we just add the File/Blob objects to
	                    // the formData array and let the postMessage window
	                    // create the FormData object out of this array:
	                    formData = this._getFormData(options);
	                    if (options.blob) {
	                        formData.push({
	                            name: paramName,
	                            value: options.blob
	                        });
	                    } else {
	                        $.each(options.files, function (index, file) {
	                            formData.push({
	                                name: $.type(options.paramName) === 'array' && options.paramName[index] || paramName,
	                                value: file
	                            });
	                        });
	                    }
	                } else {
	                    if (that._isInstanceOf('FormData', options.formData)) {
	                        formData = options.formData;
	                    } else {
	                        formData = new FormData();
	                        $.each(this._getFormData(options), function (index, field) {
	                            formData.append(field.name, field.value);
	                        });
	                    }
	                    if (options.blob) {
	                        formData.append(paramName, options.blob, file.name);
	                    } else {
	                        $.each(options.files, function (index, file) {
	                            // This check allows the tests to run with
	                            // dummy objects:
	                            if (that._isInstanceOf('File', file) || that._isInstanceOf('Blob', file)) {
	                                formData.append($.type(options.paramName) === 'array' && options.paramName[index] || paramName, file, file.uploadName || file.name);
	                            }
	                        });
	                    }
	                }
	                options.data = formData;
	            }
	            // Blob reference is not needed anymore, free memory:
	            options.blob = null;
	        },
	
	        _initIframeSettings: function _initIframeSettings(options) {
	            var targetHost = $('<a></a>').prop('href', options.url).prop('host');
	            // Setting the dataType to iframe enables the iframe transport:
	            options.dataType = 'iframe ' + (options.dataType || '');
	            // The iframe transport accepts a serialized array as form data:
	            options.formData = this._getFormData(options);
	            // Add redirect url to form data on cross-domain uploads:
	            if (options.redirect && targetHost && targetHost !== location.host) {
	                options.formData.push({
	                    name: options.redirectParamName || 'redirect',
	                    value: options.redirect
	                });
	            }
	        },
	
	        _initDataSettings: function _initDataSettings(options) {
	            if (this._isXHRUpload(options)) {
	                if (!this._chunkedUpload(options, true)) {
	                    if (!options.data) {
	                        this._initXHRData(options);
	                    }
	                    this._initProgressListener(options);
	                }
	                if (options.postMessage) {
	                    // Setting the dataType to postmessage enables the
	                    // postMessage transport:
	                    options.dataType = 'postmessage ' + (options.dataType || '');
	                }
	            } else {
	                this._initIframeSettings(options);
	            }
	        },
	
	        _getParamName: function _getParamName(options) {
	            var fileInput = $(options.fileInput),
	                paramName = options.paramName;
	            if (!paramName) {
	                paramName = [];
	                fileInput.each(function () {
	                    var input = $(this),
	                        name = input.prop('name') || 'files[]',
	                        i = (input.prop('files') || [1]).length;
	                    while (i) {
	                        paramName.push(name);
	                        i -= 1;
	                    }
	                });
	                if (!paramName.length) {
	                    paramName = [fileInput.prop('name') || 'files[]'];
	                }
	            } else if (!$.isArray(paramName)) {
	                paramName = [paramName];
	            }
	            return paramName;
	        },
	
	        _initFormSettings: function _initFormSettings(options) {
	            // Retrieve missing options from the input field and the
	            // associated form, if available:
	            if (!options.form || !options.form.length) {
	                options.form = $(options.fileInput.prop('form'));
	                // If the given file input doesn't have an associated form,
	                // use the default widget file input's form:
	                if (!options.form.length) {
	                    options.form = $(this.options.fileInput.prop('form'));
	                }
	            }
	            options.paramName = this._getParamName(options);
	            if (!options.url) {
	                options.url = options.form.prop('action') || location.href;
	            }
	            // The HTTP request method must be "POST" or "PUT":
	            options.type = (options.type || $.type(options.form.prop('method')) === 'string' && options.form.prop('method') || '').toUpperCase();
	            if (options.type !== 'POST' && options.type !== 'PUT' && options.type !== 'PATCH') {
	                options.type = 'POST';
	            }
	            if (!options.formAcceptCharset) {
	                options.formAcceptCharset = options.form.attr('accept-charset');
	            }
	        },
	
	        _getAJAXSettings: function _getAJAXSettings(data) {
	            var options = $.extend({}, this.options, data);
	            this._initFormSettings(options);
	            this._initDataSettings(options);
	            return options;
	        },
	
	        // jQuery 1.6 doesn't provide .state(),
	        // while jQuery 1.8+ removed .isRejected() and .isResolved():
	        _getDeferredState: function _getDeferredState(deferred) {
	            if (deferred.state) {
	                return deferred.state();
	            }
	            if (deferred.isResolved()) {
	                return 'resolved';
	            }
	            if (deferred.isRejected()) {
	                return 'rejected';
	            }
	            return 'pending';
	        },
	
	        // Maps jqXHR callbacks to the equivalent
	        // methods of the given Promise object:
	        _enhancePromise: function _enhancePromise(promise) {
	            promise.success = promise.done;
	            promise.error = promise.fail;
	            promise.complete = promise.always;
	            return promise;
	        },
	
	        // Creates and returns a Promise object enhanced with
	        // the jqXHR methods abort, success, error and complete:
	        _getXHRPromise: function _getXHRPromise(resolveOrReject, context, args) {
	            var dfd = $.Deferred(),
	                promise = dfd.promise();
	            context = context || this.options.context || promise;
	            if (resolveOrReject === true) {
	                dfd.resolveWith(context, args);
	            } else if (resolveOrReject === false) {
	                dfd.rejectWith(context, args);
	            }
	            promise.abort = dfd.promise;
	            return this._enhancePromise(promise);
	        },
	
	        // Adds convenience methods to the data callback argument:
	        _addConvenienceMethods: function _addConvenienceMethods(e, data) {
	            var that = this,
	                getPromise = function getPromise(args) {
	                return $.Deferred().resolveWith(that, args).promise();
	            };
	            data.process = function (resolveFunc, rejectFunc) {
	                if (resolveFunc || rejectFunc) {
	                    data._processQueue = this._processQueue = (this._processQueue || getPromise([this])).then(function () {
	                        if (data.errorThrown) {
	                            return $.Deferred().rejectWith(that, [data]).promise();
	                        }
	                        return getPromise(arguments);
	                    }).then(resolveFunc, rejectFunc);
	                }
	                return this._processQueue || getPromise([this]);
	            };
	            data.submit = function () {
	                if (this.state() !== 'pending') {
	                    data.jqXHR = this.jqXHR = that._trigger('submit', $.Event('submit', { delegatedEvent: e }), this) !== false && that._onSend(e, this);
	                }
	                return this.jqXHR || that._getXHRPromise();
	            };
	            data.abort = function () {
	                if (this.jqXHR) {
	                    return this.jqXHR.abort();
	                }
	                this.errorThrown = 'abort';
	                that._trigger('fail', null, this);
	                return that._getXHRPromise(false);
	            };
	            data.state = function () {
	                if (this.jqXHR) {
	                    return that._getDeferredState(this.jqXHR);
	                }
	                if (this._processQueue) {
	                    return that._getDeferredState(this._processQueue);
	                }
	            };
	            data.processing = function () {
	                return !this.jqXHR && this._processQueue && that._getDeferredState(this._processQueue) === 'pending';
	            };
	            data.progress = function () {
	                return this._progress;
	            };
	            data.response = function () {
	                return this._response;
	            };
	        },
	
	        // Parses the Range header from the server response
	        // and returns the uploaded bytes:
	        _getUploadedBytes: function _getUploadedBytes(jqXHR) {
	            var range = jqXHR.getResponseHeader('Range'),
	                parts = range && range.split('-'),
	                upperBytesPos = parts && parts.length > 1 && parseInt(parts[1], 10);
	            return upperBytesPos && upperBytesPos + 1;
	        },
	
	        // Uploads a file in multiple, sequential requests
	        // by splitting the file up in multiple blob chunks.
	        // If the second parameter is true, only tests if the file
	        // should be uploaded in chunks, but does not invoke any
	        // upload requests:
	        _chunkedUpload: function _chunkedUpload(options, testOnly) {
	            options.uploadedBytes = options.uploadedBytes || 0;
	            var that = this,
	                file = options.files[0],
	                fs = file.size,
	                ub = options.uploadedBytes,
	                mcs = options.maxChunkSize || fs,
	                slice = this._blobSlice,
	                dfd = $.Deferred(),
	                promise = dfd.promise(),
	                jqXHR,
	                _upload;
	            if (!(this._isXHRUpload(options) && slice && (ub || mcs < fs)) || options.data) {
	                return false;
	            }
	            if (testOnly) {
	                return true;
	            }
	            if (ub >= fs) {
	                file.error = options.i18n('uploadedBytes');
	                return this._getXHRPromise(false, options.context, [null, 'error', file.error]);
	            }
	            // The chunk upload method:
	            _upload = function upload() {
	                // Clone the options object for each chunk upload:
	                var o = $.extend({}, options),
	                    currentLoaded = o._progress.loaded;
	                o.blob = slice.call(file, ub, ub + mcs, file.type);
	                // Store the current chunk size, as the blob itself
	                // will be dereferenced after data processing:
	                o.chunkSize = o.blob.size;
	                // Expose the chunk bytes position range:
	                o.contentRange = 'bytes ' + ub + '-' + (ub + o.chunkSize - 1) + '/' + fs;
	                // Process the upload data (the blob and potential form data):
	                that._initXHRData(o);
	                // Add progress listeners for this chunk upload:
	                that._initProgressListener(o);
	                jqXHR = (that._trigger('chunksend', null, o) !== false && $.ajax(o) || that._getXHRPromise(false, o.context)).done(function (result, textStatus, jqXHR) {
	                    ub = that._getUploadedBytes(jqXHR) || ub + o.chunkSize;
	                    // Create a progress event if no final progress event
	                    // with loaded equaling total has been triggered
	                    // for this chunk:
	                    if (currentLoaded + o.chunkSize - o._progress.loaded) {
	                        that._onProgress($.Event('progress', {
	                            lengthComputable: true,
	                            loaded: ub - o.uploadedBytes,
	                            total: ub - o.uploadedBytes
	                        }), o);
	                    }
	                    options.uploadedBytes = o.uploadedBytes = ub;
	                    o.result = result;
	                    o.textStatus = textStatus;
	                    o.jqXHR = jqXHR;
	                    that._trigger('chunkdone', null, o);
	                    that._trigger('chunkalways', null, o);
	                    if (ub < fs) {
	                        // File upload not yet complete,
	                        // continue with the next chunk:
	                        _upload();
	                    } else {
	                        dfd.resolveWith(o.context, [result, textStatus, jqXHR]);
	                    }
	                }).fail(function (jqXHR, textStatus, errorThrown) {
	                    o.jqXHR = jqXHR;
	                    o.textStatus = textStatus;
	                    o.errorThrown = errorThrown;
	                    that._trigger('chunkfail', null, o);
	                    that._trigger('chunkalways', null, o);
	                    dfd.rejectWith(o.context, [jqXHR, textStatus, errorThrown]);
	                });
	            };
	            this._enhancePromise(promise);
	            promise.abort = function () {
	                return jqXHR.abort();
	            };
	            _upload();
	            return promise;
	        },
	
	        _beforeSend: function _beforeSend(e, data) {
	            if (this._active === 0) {
	                // the start callback is triggered when an upload starts
	                // and no other uploads are currently running,
	                // equivalent to the global ajaxStart event:
	                this._trigger('start');
	                // Set timer for global bitrate progress calculation:
	                this._bitrateTimer = new this._BitrateTimer();
	                // Reset the global progress values:
	                this._progress.loaded = this._progress.total = 0;
	                this._progress.bitrate = 0;
	            }
	            // Make sure the container objects for the .response() and
	            // .progress() methods on the data object are available
	            // and reset to their initial state:
	            this._initResponseObject(data);
	            this._initProgressObject(data);
	            data._progress.loaded = data.loaded = data.uploadedBytes || 0;
	            data._progress.total = data.total = this._getTotal(data.files) || 1;
	            data._progress.bitrate = data.bitrate = 0;
	            this._active += 1;
	            // Initialize the global progress values:
	            this._progress.loaded += data.loaded;
	            this._progress.total += data.total;
	        },
	
	        _onDone: function _onDone(result, textStatus, jqXHR, options) {
	            var total = options._progress.total,
	                response = options._response;
	            if (options._progress.loaded < total) {
	                // Create a progress event if no final progress event
	                // with loaded equaling total has been triggered:
	                this._onProgress($.Event('progress', {
	                    lengthComputable: true,
	                    loaded: total,
	                    total: total
	                }), options);
	            }
	            response.result = options.result = result;
	            response.textStatus = options.textStatus = textStatus;
	            response.jqXHR = options.jqXHR = jqXHR;
	            this._trigger('done', null, options);
	        },
	
	        _onFail: function _onFail(jqXHR, textStatus, errorThrown, options) {
	            var response = options._response;
	            if (options.recalculateProgress) {
	                // Remove the failed (error or abort) file upload from
	                // the global progress calculation:
	                this._progress.loaded -= options._progress.loaded;
	                this._progress.total -= options._progress.total;
	            }
	            response.jqXHR = options.jqXHR = jqXHR;
	            response.textStatus = options.textStatus = textStatus;
	            response.errorThrown = options.errorThrown = errorThrown;
	            this._trigger('fail', null, options);
	        },
	
	        _onAlways: function _onAlways(jqXHRorResult, textStatus, jqXHRorError, options) {
	            // jqXHRorResult, textStatus and jqXHRorError are added to the
	            // options object via done and fail callbacks
	            this._trigger('always', null, options);
	        },
	
	        _onSend: function _onSend(e, data) {
	            if (!data.submit) {
	                this._addConvenienceMethods(e, data);
	            }
	            var that = this,
	                jqXHR,
	                aborted,
	                slot,
	                pipe,
	                options = that._getAJAXSettings(data),
	                send = function send() {
	                that._sending += 1;
	                // Set timer for bitrate progress calculation:
	                options._bitrateTimer = new that._BitrateTimer();
	                jqXHR = jqXHR || ((aborted || that._trigger('send', $.Event('send', { delegatedEvent: e }), options) === false) && that._getXHRPromise(false, options.context, aborted) || that._chunkedUpload(options) || $.ajax(options)).done(function (result, textStatus, jqXHR) {
	                    that._onDone(result, textStatus, jqXHR, options);
	                }).fail(function (jqXHR, textStatus, errorThrown) {
	                    that._onFail(jqXHR, textStatus, errorThrown, options);
	                }).always(function (jqXHRorResult, textStatus, jqXHRorError) {
	                    that._onAlways(jqXHRorResult, textStatus, jqXHRorError, options);
	                    that._sending -= 1;
	                    that._active -= 1;
	                    if (options.limitConcurrentUploads && options.limitConcurrentUploads > that._sending) {
	                        // Start the next queued upload,
	                        // that has not been aborted:
	                        var nextSlot = that._slots.shift();
	                        while (nextSlot) {
	                            if (that._getDeferredState(nextSlot) === 'pending') {
	                                nextSlot.resolve();
	                                break;
	                            }
	                            nextSlot = that._slots.shift();
	                        }
	                    }
	                    if (that._active === 0) {
	                        // The stop callback is triggered when all uploads have
	                        // been completed, equivalent to the global ajaxStop event:
	                        that._trigger('stop');
	                    }
	                });
	                return jqXHR;
	            };
	            this._beforeSend(e, options);
	            if (this.options.sequentialUploads || this.options.limitConcurrentUploads && this.options.limitConcurrentUploads <= this._sending) {
	                if (this.options.limitConcurrentUploads > 1) {
	                    slot = $.Deferred();
	                    this._slots.push(slot);
	                    pipe = slot.then(send);
	                } else {
	                    this._sequence = this._sequence.then(send, send);
	                    pipe = this._sequence;
	                }
	                // Return the piped Promise object, enhanced with an abort method,
	                // which is delegated to the jqXHR object of the current upload,
	                // and jqXHR callbacks mapped to the equivalent Promise methods:
	                pipe.abort = function () {
	                    aborted = [undefined, 'abort', 'abort'];
	                    if (!jqXHR) {
	                        if (slot) {
	                            slot.rejectWith(options.context, aborted);
	                        }
	                        return send();
	                    }
	                    return jqXHR.abort();
	                };
	                return this._enhancePromise(pipe);
	            }
	            return send();
	        },
	
	        _onAdd: function _onAdd(e, data) {
	            var that = this,
	                result = true,
	                options = $.extend({}, this.options, data),
	                files = data.files,
	                filesLength = files.length,
	                limit = options.limitMultiFileUploads,
	                limitSize = options.limitMultiFileUploadSize,
	                overhead = options.limitMultiFileUploadSizeOverhead,
	                batchSize = 0,
	                paramName = this._getParamName(options),
	                paramNameSet,
	                paramNameSlice,
	                fileSet,
	                i,
	                j = 0;
	            if (!filesLength) {
	                return false;
	            }
	            if (limitSize && files[0].size === undefined) {
	                limitSize = undefined;
	            }
	            if (!(options.singleFileUploads || limit || limitSize) || !this._isXHRUpload(options)) {
	                fileSet = [files];
	                paramNameSet = [paramName];
	            } else if (!(options.singleFileUploads || limitSize) && limit) {
	                fileSet = [];
	                paramNameSet = [];
	                for (i = 0; i < filesLength; i += limit) {
	                    fileSet.push(files.slice(i, i + limit));
	                    paramNameSlice = paramName.slice(i, i + limit);
	                    if (!paramNameSlice.length) {
	                        paramNameSlice = paramName;
	                    }
	                    paramNameSet.push(paramNameSlice);
	                }
	            } else if (!options.singleFileUploads && limitSize) {
	                fileSet = [];
	                paramNameSet = [];
	                for (i = 0; i < filesLength; i = i + 1) {
	                    batchSize += files[i].size + overhead;
	                    if (i + 1 === filesLength || batchSize + files[i + 1].size + overhead > limitSize || limit && i + 1 - j >= limit) {
	                        fileSet.push(files.slice(j, i + 1));
	                        paramNameSlice = paramName.slice(j, i + 1);
	                        if (!paramNameSlice.length) {
	                            paramNameSlice = paramName;
	                        }
	                        paramNameSet.push(paramNameSlice);
	                        j = i + 1;
	                        batchSize = 0;
	                    }
	                }
	            } else {
	                paramNameSet = paramName;
	            }
	            data.originalFiles = files;
	            $.each(fileSet || files, function (index, element) {
	                var newData = $.extend({}, data);
	                newData.files = fileSet ? element : [element];
	                newData.paramName = paramNameSet[index];
	                that._initResponseObject(newData);
	                that._initProgressObject(newData);
	                that._addConvenienceMethods(e, newData);
	                result = that._trigger('add', $.Event('add', { delegatedEvent: e }), newData);
	                return result;
	            });
	            return result;
	        },
	
	        _replaceFileInput: function _replaceFileInput(data) {
	            var input = data.fileInput,
	                inputClone = input.clone(true),
	                restoreFocus = input.is(document.activeElement);
	            // Add a reference for the new cloned file input to the data argument:
	            data.fileInputClone = inputClone;
	            $('<form></form>').append(inputClone)[0].reset();
	            // Detaching allows to insert the fileInput on another form
	            // without loosing the file input value:
	            input.after(inputClone).detach();
	            // If the fileInput had focus before it was detached,
	            // restore focus to the inputClone.
	            if (restoreFocus) {
	                inputClone.focus();
	            }
	            // Avoid memory leaks with the detached file input:
	            $.cleanData(input.unbind('remove'));
	            // Replace the original file input element in the fileInput
	            // elements set with the clone, which has been copied including
	            // event handlers:
	            this.options.fileInput = this.options.fileInput.map(function (i, el) {
	                if (el === input[0]) {
	                    return inputClone[0];
	                }
	                return el;
	            });
	            // If the widget has been initialized on the file input itself,
	            // override this.element with the file input clone:
	            if (input[0] === this.element[0]) {
	                this.element = inputClone;
	            }
	        },
	
	        _handleFileTreeEntry: function _handleFileTreeEntry(entry, path) {
	            var that = this,
	                dfd = $.Deferred(),
	                errorHandler = function errorHandler(e) {
	                if (e && !e.entry) {
	                    e.entry = entry;
	                }
	                // Since $.when returns immediately if one
	                // Deferred is rejected, we use resolve instead.
	                // This allows valid files and invalid items
	                // to be returned together in one set:
	                dfd.resolve([e]);
	            },
	                successHandler = function successHandler(entries) {
	                that._handleFileTreeEntries(entries, path + entry.name + '/').done(function (files) {
	                    dfd.resolve(files);
	                }).fail(errorHandler);
	            },
	                readEntries = function readEntries() {
	                dirReader.readEntries(function (results) {
	                    if (!results.length) {
	                        successHandler(entries);
	                    } else {
	                        entries = entries.concat(results);
	                        readEntries();
	                    }
	                }, errorHandler);
	            },
	                dirReader,
	                entries = [];
	            path = path || '';
	            if (entry.isFile) {
	                if (entry._file) {
	                    // Workaround for Chrome bug #149735
	                    entry._file.relativePath = path;
	                    dfd.resolve(entry._file);
	                } else {
	                    entry.file(function (file) {
	                        file.relativePath = path;
	                        dfd.resolve(file);
	                    }, errorHandler);
	                }
	            } else if (entry.isDirectory) {
	                dirReader = entry.createReader();
	                readEntries();
	            } else {
	                // Return an empy list for file system items
	                // other than files or directories:
	                dfd.resolve([]);
	            }
	            return dfd.promise();
	        },
	
	        _handleFileTreeEntries: function _handleFileTreeEntries(entries, path) {
	            var that = this;
	            return $.when.apply($, $.map(entries, function (entry) {
	                return that._handleFileTreeEntry(entry, path);
	            })).then(function () {
	                return Array.prototype.concat.apply([], arguments);
	            });
	        },
	
	        _getDroppedFiles: function _getDroppedFiles(dataTransfer) {
	            dataTransfer = dataTransfer || {};
	            var items = dataTransfer.items;
	            if (items && items.length && (items[0].webkitGetAsEntry || items[0].getAsEntry)) {
	                return this._handleFileTreeEntries($.map(items, function (item) {
	                    var entry;
	                    if (item.webkitGetAsEntry) {
	                        entry = item.webkitGetAsEntry();
	                        if (entry) {
	                            // Workaround for Chrome bug #149735:
	                            entry._file = item.getAsFile();
	                        }
	                        return entry;
	                    }
	                    return item.getAsEntry();
	                }));
	            }
	            return $.Deferred().resolve($.makeArray(dataTransfer.files)).promise();
	        },
	
	        _getSingleFileInputFiles: function _getSingleFileInputFiles(fileInput) {
	            fileInput = $(fileInput);
	            var entries = fileInput.prop('webkitEntries') || fileInput.prop('entries'),
	                files,
	                value;
	            if (entries && entries.length) {
	                return this._handleFileTreeEntries(entries);
	            }
	            files = $.makeArray(fileInput.prop('files'));
	            if (!files.length) {
	                value = fileInput.prop('value');
	                if (!value) {
	                    return $.Deferred().resolve([]).promise();
	                }
	                // If the files property is not available, the browser does not
	                // support the File API and we add a pseudo File object with
	                // the input value as name with path information removed:
	                files = [{ name: value.replace(/^.*\\/, '') }];
	            } else if (files[0].name === undefined && files[0].fileName) {
	                // File normalization for Safari 4 and Firefox 3:
	                $.each(files, function (index, file) {
	                    file.name = file.fileName;
	                    file.size = file.fileSize;
	                });
	            }
	            return $.Deferred().resolve(files).promise();
	        },
	
	        _getFileInputFiles: function _getFileInputFiles(fileInput) {
	            if (!(fileInput instanceof $) || fileInput.length === 1) {
	                return this._getSingleFileInputFiles(fileInput);
	            }
	            return $.when.apply($, $.map(fileInput, this._getSingleFileInputFiles)).then(function () {
	                return Array.prototype.concat.apply([], arguments);
	            });
	        },
	
	        _onChange: function _onChange(e) {
	            var that = this,
	                data = {
	                fileInput: $(e.target),
	                form: $(e.target.form)
	            };
	            this._getFileInputFiles(data.fileInput).always(function (files) {
	                data.files = files;
	                if (that.options.replaceFileInput) {
	                    that._replaceFileInput(data);
	                }
	                if (that._trigger('change', $.Event('change', { delegatedEvent: e }), data) !== false) {
	                    that._onAdd(e, data);
	                }
	            });
	        },
	
	        _onPaste: function _onPaste(e) {
	            var items = e.originalEvent && e.originalEvent.clipboardData && e.originalEvent.clipboardData.items,
	                data = { files: [] };
	            if (items && items.length) {
	                $.each(items, function (index, item) {
	                    var file = item.getAsFile && item.getAsFile();
	                    if (file) {
	                        data.files.push(file);
	                    }
	                });
	                if (this._trigger('paste', $.Event('paste', { delegatedEvent: e }), data) !== false) {
	                    this._onAdd(e, data);
	                }
	            }
	        },
	
	        _onDrop: function _onDrop(e) {
	            e.dataTransfer = e.originalEvent && e.originalEvent.dataTransfer;
	            var that = this,
	                dataTransfer = e.dataTransfer,
	                data = {};
	            if (dataTransfer && dataTransfer.files && dataTransfer.files.length) {
	                e.preventDefault();
	                this._getDroppedFiles(dataTransfer).always(function (files) {
	                    data.files = files;
	                    if (that._trigger('drop', $.Event('drop', { delegatedEvent: e }), data) !== false) {
	                        that._onAdd(e, data);
	                    }
	                });
	            }
	        },
	
	        _onDragOver: getDragHandler('dragover'),
	
	        _onDragEnter: getDragHandler('dragenter'),
	
	        _onDragLeave: getDragHandler('dragleave'),
	
	        _initEventHandlers: function _initEventHandlers() {
	            if (this._isXHRUpload(this.options)) {
	                this._on(this.options.dropZone, {
	                    dragover: this._onDragOver,
	                    drop: this._onDrop,
	                    // event.preventDefault() on dragenter is required for IE10+:
	                    dragenter: this._onDragEnter,
	                    // dragleave is not required, but added for completeness:
	                    dragleave: this._onDragLeave
	                });
	                this._on(this.options.pasteZone, {
	                    paste: this._onPaste
	                });
	            }
	            if ($.support.fileInput) {
	                this._on(this.options.fileInput, {
	                    change: this._onChange
	                });
	            }
	        },
	
	        _destroyEventHandlers: function _destroyEventHandlers() {
	            this._off(this.options.dropZone, 'dragenter dragleave dragover drop');
	            this._off(this.options.pasteZone, 'paste');
	            this._off(this.options.fileInput, 'change');
	        },
	
	        _setOption: function _setOption(key, value) {
	            var reinit = $.inArray(key, this._specialOptions) !== -1;
	            if (reinit) {
	                this._destroyEventHandlers();
	            }
	            this._super(key, value);
	            if (reinit) {
	                this._initSpecialOptions();
	                this._initEventHandlers();
	            }
	        },
	
	        _initSpecialOptions: function _initSpecialOptions() {
	            var options = this.options;
	            if (options.fileInput === undefined) {
	                options.fileInput = this.element.is('input[type="file"]') ? this.element : this.element.find('input[type="file"]');
	            } else if (!(options.fileInput instanceof $)) {
	                options.fileInput = $(options.fileInput);
	            }
	            if (!(options.dropZone instanceof $)) {
	                options.dropZone = $(options.dropZone);
	            }
	            if (!(options.pasteZone instanceof $)) {
	                options.pasteZone = $(options.pasteZone);
	            }
	        },
	
	        _getRegExp: function _getRegExp(str) {
	            var parts = str.split('/'),
	                modifiers = parts.pop();
	            parts.shift();
	            return new RegExp(parts.join('/'), modifiers);
	        },
	
	        _isRegExpOption: function _isRegExpOption(key, value) {
	            return key !== 'url' && $.type(value) === 'string' && /^\/.*\/[igm]{0,3}$/.test(value);
	        },
	
	        _initDataAttributes: function _initDataAttributes() {
	            var that = this,
	                options = this.options,
	                data = this.element.data();
	            // Initialize options set via HTML5 data-attributes:
	            $.each(this.element[0].attributes, function (index, attr) {
	                var key = attr.name.toLowerCase(),
	                    value;
	                if (/^data-/.test(key)) {
	                    // Convert hyphen-ated key to camelCase:
	                    key = key.slice(5).replace(/-[a-z]/g, function (str) {
	                        return str.charAt(1).toUpperCase();
	                    });
	                    value = data[key];
	                    if (that._isRegExpOption(key, value)) {
	                        value = that._getRegExp(value);
	                    }
	                    options[key] = value;
	                }
	            });
	        },
	
	        _create: function _create() {
	            this._initDataAttributes();
	            this._initSpecialOptions();
	            this._slots = [];
	            this._sequence = this._getXHRPromise(true);
	            this._sending = this._active = 0;
	            this._initProgressObject(this);
	            this._initEventHandlers();
	        },
	
	        // This method is exposed to the widget API and allows to query
	        // the number of active uploads:
	        active: function active() {
	            return this._active;
	        },
	
	        // This method is exposed to the widget API and allows to query
	        // the widget upload progress.
	        // It returns an object with loaded, total and bitrate properties
	        // for the running uploads:
	        progress: function progress() {
	            return this._progress;
	        },
	
	        // This method is exposed to the widget API and allows adding files
	        // using the fileupload API. The data parameter accepts an object which
	        // must have a files property and can contain additional options:
	        // .fileupload('add', {files: filesList});
	        add: function add(data) {
	            var that = this;
	            if (!data || this.options.disabled) {
	                return;
	            }
	            if (data.fileInput && !data.files) {
	                this._getFileInputFiles(data.fileInput).always(function (files) {
	                    data.files = files;
	                    that._onAdd(null, data);
	                });
	            } else {
	                data.files = $.makeArray(data.files);
	                this._onAdd(null, data);
	            }
	        },
	
	        // This method is exposed to the widget API and allows sending files
	        // using the fileupload API. The data parameter accepts an object which
	        // must have a files or fileInput property and can contain additional options:
	        // .fileupload('send', {files: filesList});
	        // The method returns a Promise object for the file upload call.
	        send: function send(data) {
	            if (data && !this.options.disabled) {
	                if (data.fileInput && !data.files) {
	                    var that = this,
	                        dfd = $.Deferred(),
	                        promise = dfd.promise(),
	                        jqXHR,
	                        aborted;
	                    promise.abort = function () {
	                        aborted = true;
	                        if (jqXHR) {
	                            return jqXHR.abort();
	                        }
	                        dfd.reject(null, 'abort', 'abort');
	                        return promise;
	                    };
	                    this._getFileInputFiles(data.fileInput).always(function (files) {
	                        if (aborted) {
	                            return;
	                        }
	                        if (!files.length) {
	                            dfd.reject();
	                            return;
	                        }
	                        data.files = files;
	                        jqXHR = that._onSend(null, data);
	                        jqXHR.then(function (result, textStatus, jqXHR) {
	                            dfd.resolve(result, textStatus, jqXHR);
	                        }, function (jqXHR, textStatus, errorThrown) {
	                            dfd.reject(jqXHR, textStatus, errorThrown);
	                        });
	                    });
	                    return this._enhancePromise(promise);
	                }
	                data.files = $.makeArray(data.files);
	                if (data.files.length) {
	                    return this._onSend(null, data);
	                }
	            }
	            return this._getXHRPromise(false, data && data.context);
	        }
	
	    });
	});

/***/ }),
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["rwgpsG_views_photos"] = __webpack_require__(95);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */
/***/ (function(module, exports) {

	/*
	 * jQuery Iframe Transport Plugin
	 * https://github.com/blueimp/jQuery-File-Upload
	 *
	 * Copyright 2011, Sebastian Tschan
	 * https://blueimp.net
	 *
	 * Licensed under the MIT license:
	 * http://www.opensource.org/licenses/MIT
	 */
	
	/* global window, document */
	
	(function (factory) {
	    'use strict';
	    // Browser globals:
	    factory(jQuery);
	}(function ($) {
	    'use strict';
	
	    // Helper variable to create unique names for the transport iframes:
	    var counter = 0;
	
	    // The iframe transport accepts four additional options:
	    // options.fileInput: a jQuery collection of file input fields
	    // options.paramName: the parameter name for the file form data,
	    //  overrides the name property of the file input field(s),
	    //  can be a string or an array of strings.
	    // options.formData: an array of objects with name and value properties,
	    //  equivalent to the return data of .serializeArray(), e.g.:
	    //  [{name: 'a', value: 1}, {name: 'b', value: 2}]
	    // options.initialIframeSrc: the URL of the initial iframe src,
	    //  by default set to "javascript:false;"
	    $.ajaxTransport('iframe', function (options) {
	        if (options.async) {
	            // javascript:false as initial iframe src
	            // prevents warning popups on HTTPS in IE6:
	            /*jshint scripturl: true */
	            var initialIframeSrc = options.initialIframeSrc || 'javascript:false;',
	            /*jshint scripturl: false */
	                form,
	                iframe,
	                addParamChar;
	            return {
	                send: function (_, completeCallback) {
	                    form = $('<form style="display:none;"></form>');
	                    form.attr('accept-charset', options.formAcceptCharset);
	                    addParamChar = /\?/.test(options.url) ? '&' : '?';
	                    // XDomainRequest only supports GET and POST:
	                    if (options.type === 'DELETE') {
	                        options.url = options.url + addParamChar + '_method=DELETE';
	                        options.type = 'POST';
	                    } else if (options.type === 'PUT') {
	                        options.url = options.url + addParamChar + '_method=PUT';
	                        options.type = 'POST';
	                    } else if (options.type === 'PATCH') {
	                        options.url = options.url + addParamChar + '_method=PATCH';
	                        options.type = 'POST';
	                    }
	                    // IE versions below IE8 cannot set the name property of
	                    // elements that have already been added to the DOM,
	                    // so we set the name along with the iframe HTML markup:
	                    counter += 1;
	                    iframe = $(
	                        '<iframe src="' + initialIframeSrc +
	                            '" name="iframe-transport-' + counter + '"></iframe>'
	                    ).bind('load', function () {
	                        var fileInputClones,
	                            paramNames = $.isArray(options.paramName) ?
	                                    options.paramName : [options.paramName];
	                        iframe
	                            .unbind('load')
	                            .bind('load', function () {
	                                var response;
	                                // Wrap in a try/catch block to catch exceptions thrown
	                                // when trying to access cross-domain iframe contents:
	                                try {
	                                    response = iframe.contents();
	                                    // Google Chrome and Firefox do not throw an
	                                    // exception when calling iframe.contents() on
	                                    // cross-domain requests, so we unify the response:
	                                    if (!response.length || !response[0].firstChild) {
	                                        throw new Error();
	                                    }
	                                } catch (e) {
	                                    response = undefined;
	                                }
	                                // The complete callback returns the
	                                // iframe content document as response object:
	                                completeCallback(
	                                    200,
	                                    'success',
	                                    {'iframe': response}
	                                );
	                                // Fix for IE endless progress bar activity bug
	                                // (happens on form submits to iframe targets):
	                                $('<iframe src="' + initialIframeSrc + '"></iframe>')
	                                    .appendTo(form);
	                                window.setTimeout(function () {
	                                    // Removing the form in a setTimeout call
	                                    // allows Chrome's developer tools to display
	                                    // the response result
	                                    form.remove();
	                                }, 0);
	                            });
	                        form
	                            .prop('target', iframe.prop('name'))
	                            .prop('action', options.url)
	                            .prop('method', options.type);
	                        if (options.formData) {
	                            $.each(options.formData, function (index, field) {
	                                $('<input type="hidden"/>')
	                                    .prop('name', field.name)
	                                    .val(field.value)
	                                    .appendTo(form);
	                            });
	                        }
	                        if (options.fileInput && options.fileInput.length &&
	                                options.type === 'POST') {
	                            fileInputClones = options.fileInput.clone();
	                            // Insert a clone for each file input field:
	                            options.fileInput.after(function (index) {
	                                return fileInputClones[index];
	                            });
	                            if (options.paramName) {
	                                options.fileInput.each(function (index) {
	                                    $(this).prop(
	                                        'name',
	                                        paramNames[index] || options.paramName
	                                    );
	                                });
	                            }
	                            // Appending the file input fields to the hidden form
	                            // removes them from their original location:
	                            form
	                                .append(options.fileInput)
	                                .prop('enctype', 'multipart/form-data')
	                                // enctype must be set as encoding for IE:
	                                .prop('encoding', 'multipart/form-data');
	                            // Remove the HTML5 form attribute from the input(s):
	                            options.fileInput.removeAttr('form');
	                        }
	                        form.submit();
	                        // Insert the file input fields at their original location
	                        // by replacing the clones with the originals:
	                        if (fileInputClones && fileInputClones.length) {
	                            options.fileInput.each(function (index, input) {
	                                var clone = $(fileInputClones[index]);
	                                // Restore the original name and form properties:
	                                $(input)
	                                    .prop('name', clone.prop('name'))
	                                    .attr('form', clone.attr('form'));
	                                clone.replaceWith(input);
	                            });
	                        }
	                    });
	                    form.append(iframe).appendTo(document.body);
	                },
	                abort: function () {
	                    if (iframe) {
	                        // javascript:false as iframe src aborts the request
	                        // and prevents warning popups on HTTPS in IE6.
	                        // concat is used to avoid the "Script URL" JSLint error:
	                        iframe
	                            .unbind('load')
	                            .prop('src', initialIframeSrc);
	                    }
	                    if (form) {
	                        form.remove();
	                    }
	                }
	            };
	        }
	    });
	
	    // The iframe transport returns the iframe content document as response.
	    // The following adds converters from iframe to text, json, html, xml
	    // and script.
	    // Please note that the Content-Type for JSON responses has to be text/plain
	    // or text/html, if the browser doesn't include application/json in the
	    // Accept header, else IE will show a download dialog.
	    // The Content-Type for XML responses on the other hand has to be always
	    // application/xml or text/xml, so IE properly parses the XML response.
	    // See also
	    // https://github.com/blueimp/jQuery-File-Upload/wiki/Setup#content-type-negotiation
	    $.ajaxSetup({
	        converters: {
	            'iframe text': function (iframe) {
	                return iframe && $(iframe[0].body).text();
	            },
	            'iframe json': function (iframe) {
	                return iframe && $.parseJSON($(iframe[0].body).text());
	            },
	            'iframe html': function (iframe) {
	                return iframe && $(iframe[0].body).html();
	            },
	            'iframe xml': function (iframe) {
	                var xmlDoc = iframe && iframe[0];
	                return xmlDoc && $.isXMLDoc(xmlDoc) ? xmlDoc :
	                        $.parseXML((xmlDoc.XMLDocument && xmlDoc.XMLDocument.xml) ||
	                            $(xmlDoc.body).html());
	            },
	            'iframe script': function (iframe) {
	                return iframe && $.globalEval($(iframe[0].body).text());
	            }
	        }
	    });
	
	}));


/***/ }),
/* 74 */,
/* 75 */
/***/ (function(module, exports) {

	;rwgps.templates=rwgps.templates||{};rwgps.templates.photos = {
	uploader: function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="photo_uploader">  <div class="progress.progress-success">    <div class="progress-bar"></div>  </div>  <span class="btn btn-default btn-sm fileinput-button add-photo-prompt">    <span>'+
	((__t=( cta ))==null?'':_.escape(__t))+
	'</span>    <input class="photos_upload" type="file" multiple="multiple"></div>';
	}
	return __p;
	},
	miniSlideshow: function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="mini_slideshow carousel" id="'+
	((__t=( carouselId ))==null?'':_.escape(__t))+
	'"><ol class="carousel-indicators"></ol><div class="carousel-inner"></div><a href="javascript:;" class="carousel-control left"><i class="icon-prev"></i></a><a href="javascript:;" class="carousel-control right"><i class="icon-next"></i></a></div>';
	}
	return __p;
	},
	miniSlideshowIndicator: function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='';
	}
	return __p;
	},
	miniSlideshowItem: function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="item"><a class="popup_photo_modal" href="javascript:;" title="'+
	((__t=( photo.caption || '' ))==null?'':_.escape(__t))+
	'"><img class="ss_img" data-lazy-src="/photos/'+
	((__t=( photo.id ))==null?'':__t)+
	'/sq_thumb.jpg" alt="'+
	((__t=( photo.caption || '' ))==null?'':_.escape(__t))+
	'" data-lat="'+
	((__t=( photo.lat ))==null?'':_.escape(__t))+
	'" data-lng="'+
	((__t=( photo.lng ))==null?'':_.escape(__t))+
	'" data-photo-id="'+
	((__t=( photo.id ))==null?'':_.escape(__t))+
	'"></a></div>';
	}
	return __p;
	},
	modalSlideshow: function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='';
	 if(this.options.modal) { 
	__p+='<div class="modal-dialog"><div class="modal-content"><div class="modal-body"><button class="close" type="button" data-dismiss="modal">&times;</button>';
	 } 
	__p+='<div class="inner"><div class="carousel" id="'+
	((__t=( carouselId ))==null?'':_.escape(__t))+
	'" data-interval="0"><ol class="carousel-indicators"></ol><div class="carousel-inner"></div><a href="javascript:;" class="carousel-control left"><i class="icon-prev"></i></a><a href="javascript:;" class="carousel-control right"><i class="icon-next"></i></a></div></div>';
	 if(this.options.modal) { 
	__p+='</div></div></div>';
	 } 
	__p+='';
	}
	return __p;
	},
	modalSlideshowIndicator: function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<li data-target="#'+
	((__t=( carouselId ))==null?'':__t)+
	'" data-slide-to="'+
	((__t=( slideTo ))==null?'':__t)+
	'" data-photo-id="'+
	((__t=( photoId ))==null?'':__t)+
	'"></li>';
	}
	return __p;
	},
	modalSlideshowItem: function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="item"><div class="image_container"><img class="ss_img" data-lazy-src="/photos/'+
	((__t=( photo.id ))==null?'':__t)+
	'/large.jpg" alt="'+
	((__t=( photo.caption || '' ))==null?'':_.escape(__t))+
	'" data-lat="'+
	((__t=( photo.lat ))==null?'':_.escape(__t))+
	'" data-lng="'+
	((__t=( photo.lng ))==null?'':_.escape(__t))+
	'" data-photo-id="'+
	((__t=( photo.id ))==null?'':_.escape(__t))+
	'"></div><div class="below_image"><div class="controls_spacer"></div>';
	 if(canEdit) { 
	__p+='<div class="pull-right edit_actions">';
	 if(belongsToPhotoset) { 
	__p+='<a href="javascript:;" class="set_highlight">Set as cover</a>';
	 } 
	__p+='<a href="javascript:;" class="rotate_ccw"><i class="icon-rotate-left"></i></a><a href="javascript:;" class="rotate_cw"><i class="icon-rotate-right"></i></a><a href="javascript:;" class="remove"><i class="icon-trash"></i></a></div>';
	 if(!photo.caption) { 
	__p+='<div class="caption can_modify"><span class="nocaption">(click to add caption)</span></div>';
	 } else { 
	__p+='<div class="caption can_modify">'+
	((__t=( photo.caption || '' ))==null?'':_.escape(__t))+
	'</div>';
	 } 
	__p+='';
	 } else { 
	__p+='<div class="caption">'+
	((__t=( photo.caption || '' ))==null?'':_.escape(__t))+
	'</div>';
	 } 
	__p+='';
	 if(photo.captured_at || photo.parent_type === "trip") { 
	__p+='<small>';
	 if(photo.captured_at) { 
	__p+=''+
	((__t=( photo.captured_at.strftime("%A, %B %e, %Y at %l:%M %p") ))==null?'':__t)+
	'';
	 } 
	__p+='';
	 if(photo.parent_type === "trip") { 
	__p+='&nbsp;(<a href="/trips/'+
	((__t=( photo.parent_id ))==null?'':__t)+
	'">go to ride</a>)';
	 } 
	__p+='</small>';
	 } 
	__p+=''+
	((__t=( shareBar ))==null?'':__t)+
	'</div></div>';
	}
	return __p;
	},
	shareBar: function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<ul class="share_bar list-inline list-unstyled"><li><a class="tt remember_this" href="/remember/'+
	((__t=( assetType ))==null?'':__t)+
	'/'+
	((__t=( assetId ))==null?'':__t)+
	'" title="Pin this so you can quickly find it later"><i class="icon-pushpin icon-large"></i></a></li><li>';
	 var fb_uri = uri + "?fb_share=" + assetType + "&mode=manual" 
	__p+='<a class="tt" href="http://facebook.com/sharer.php?u='+
	((__t=( encodeURIComponent(fb_uri) ))==null?'':__t)+
	'" title="Share this with your friends and family on Facebook" onclick="centeredpopup(this.href,\'\',600,600);return false;"><i class="icon-facebook-sign icon-large"></i></a></li><li><div class="dropup"><a href="#" data-toggle="dropdown" class="tt more-share-options dropdown-toggle">Share<span class="caret"></span></a><ul class="dropdown-menu"><li><a href="http://twitter.com/home?status='+
	((__t=( encodeURIComponent(tweet) ))==null?'':__t)+
	'" onclick="centeredpopup(this.href,\'\',600,600);return false;">Twitter</a></li><li><a href="http://plus.google.com/share?url='+
	((__t=( encodeURIComponent(fb_uri) ))==null?'':__t)+
	'" onclick="centeredpopup(this.href,\'\',600,600);return false;">  Google+</a></li><li><a class="share_bar_share_link" href="javascript:;" data-uri="'+
	((__t=( uri ))==null?'':__t)+
	'">Link</a></li>';
	 if(assetType === 'photo') { 
	__p+='<li><a target="_blank" href="/photos/'+
	((__t=( assetId ))==null?'':__t)+
	'/full.jpg">View original</a></li>';
	 } 
	__p+='</ul></div></li></ul>';
	}
	return __p;
	}
	};

/***/ }),
/* 76 */
/***/ (function(module, exports) {

	'use strict';
	
	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout() {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	})();
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch (e) {
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch (e) {
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e) {
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e) {
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while (len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) {
	    return [];
	};
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () {
	    return '/';
	};
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function () {
	    return 0;
	};

/***/ }),
/* 77 */
/***/ (function(module, exports) {

	'use strict';
	
	// polyfill forEach on NodeList for IE11/Edge
	(function () {
	  if (typeof NodeList.prototype.forEach === "function") return false;
	  NodeList.prototype.forEach = Array.prototype.forEach;
	})();
	
	Array.prototype.remove = function (from, to) {
	  var rest = this.slice((to || from) + 1 || this.length);
	  this.length = from < 0 ? this.length + from : from;
	  return this.push.apply(this, rest);
	};
	
	window.reloadTooltips = function reloadTooltips() {
	  $('.tt').tooltip({ container: 'body' });
	};
	window.reloadDatepickers = function reloadDatepickers() {
	  if ($.datepicker) $('input.datepicker').datepicker(rwgps.config.datePickerOpts);
	};
	
	window.trace = function trace(s) {
	  if (window.console && window.console.log) {
	    console.log(s); // eslint-disable-line no-console
	  }
	};
	
	window.stopEvent = function stopEvent(event) {
	  event.cancelBubble = true;
	  if (event.stopPropagation) {
	    event.stopPropagation();
	  }
	};
	
	window.maybeShowAppInstallPrompt = function maybeShowAppInstallPrompt() {
	  if (/Android/i.test(navigator.userAgent) == false) return false;
	  if (window.location.pathname.match(/choose_account|settings\/backups|subscriptions\/manage|subscriptions\/new/)) return false;
	  if (new URLSearchParams(window.location.search).get('no_app_banner') === 'true') {
	    $.cookie("mobile_prompt", '', { expires: 365 });
	    return false;
	  }
	
	  var cookie = $.cookie("mobile_prompt");
	  if (cookie == null) {
	    $('#android-app-install-modal').modal('show');
	    $('#android-app-install-modal a.android-app-install-link').on('click', function () {
	      $.cookie("mobile_prompt", '', { expires: 365 });
	      $("#android-app-install-modal").modal("hide");
	    });
	    $('#android-app-install-modal a.never-again').on('click', function () {
	      $.cookie("mobile_prompt", '', { expires: 365 });
	    });
	    $('#android-app-install-modal a.remind-later').on('click', function () {
	      $.cookie("mobile_prompt", '', { expires: 7 });
	    });
	    $('#android-app-install-modal').on('hidden.bs.modal', function () {
	      $('#android-app-install-modal .ok').off('click');
	    });
	  }
	};
	
	window.hintify = function hintify($field, lbl) {
	  $field.focus(function () {
	    if ($field.val() == lbl) $field.val('').removeClass('field_hint');
	  }).blur(function () {
	    if ($field.val() == '') $field.val(lbl).addClass('field_hint');
	  }).blur();
	};
	
	window.trackEvent = function trackEvent(category, action, label, value) {
	  ga('send', 'event', category, action, label, value);
	};
	
	// Attach user account level to this google analytics session so that
	// we can facet audience segments by account level in reports.
	//
	// Can be managed at Google Analytics > Admin > Property Settings > Custom Dimensions
	$(function () {
	  // -1 means unauthenticated
	  var currentUserAccountLevel = rwgps.config.currentUser && rwgps.config.currentUser.account_level;
	  var analyticsAccountLevel = Number.isFinite(currentUserAccountLevel) ? currentUserAccountLevel : -1;
	  window.ga && window.ga('set', 'dimension1', analyticsAccountLevel);
	});
	
	$(function () {
	  function closeOnEnter(e) {
	    if (e.keyCode == 13) $('#alert_modal').modal('hide');
	  }
	  $('#alert_modal').on('show.bs.modal', function () {
	    $(window).on('keypress', closeOnEnter);
	  });
	  $('#alert_modal').on('hidden.bs.modal', function () {
	    $(window).off('keypress', closeOnEnter);
	  });
	});
	window.customAlert = function customAlert(msg) {
	  if (window.rwgps.plannerAlertModal) {
	    window.rwgps.plannerAlertModal({ msg: msg });
	  } else {
	    $('#alert_modal .modal-body p').html(msg);
	    $('#alert_modal').modal('show');
	  }
	};
	$(function () {
	  function confirmOnEnter(e) {
	    if (e.keyCode == 13) $('#confirm_modal .ok').click();
	  }
	  $('#confirm_modal').on('show.bs.modal', function () {
	    $(window).on('keypress', confirmOnEnter);
	  });
	  $('#confirm_modal').on('shown.bs.modal', function () {
	    $('#confirm_modal .ok').focus();
	  });
	  $('#confirm_modal').on('hidden.bs.modal', function () {
	    $(window).off('keypress', confirmOnEnter);
	  });
	});
	window.customConfirm = function customConfirm(msg, cb, opts) {
	  if (window.rwgps.plannerConfirmModal) {
	    window.rwgps.plannerConfirmModal({ msg: msg, cb: cb });
	    return;
	  }
	
	  if (window._showingCustomConfirm) {
	    return;
	  }
	  window._showingCustomConfirm = true;
	
	  var oldConfirmText, oldCancelText;
	  if (opts) {
	    if (opts.confirmText) {
	      oldConfirmText = $("#confirm_modal .ok").text();
	      $('#confirm_modal .ok').text(opts.confirmText);
	    }
	    if (opts.cancelText) {
	      oldCancelText = $("#confirm_modal .cancel").text();
	      $('#confirm_modal .cancel').text(opts.cancelText);
	    }
	    if (opts.noCancel) {
	      $('#confirm_modal .cancel').text('');
	    }
	  }
	  $('#confirm_modal .modal-body p').html(msg);
	
	  $('#confirm_modal').modal('show');
	  $('#confirm_modal .ok').on('click', _.once(cb));
	  $('#confirm_modal').on('hidden.bs.modal', function () {
	    if (oldConfirmText) $("#confirm_modal .ok").text(oldConfirmText);
	    if (oldCancelText) $("#confirm_modal .cancel").text(oldCancelText);
	
	    window._showingCustomConfirm = false;
	  });
	};
	
	var Application = window.Application = {
	  initSlideshow: function initSlideshow($parent) {
	    $parent.find('img,a.next').click(function () {
	      var slide = $(this).closest('.slide');
	      if (slide.next('.slide').size() == 0) {
	        slide.hide().closest('.slides').find('.slide.first').show();
	      } else {
	        slide.hide().next('.slide').show();
	      }
	    });
	  },
	  preventSpinner: function preventSpinner() {
	    $('<div class="prettyLoader"></div>').css('display', 'none').appendTo('body');
	  },
	  flashLoadCb: function flashLoadCb(e) {
	    if (!e.success) {
	      $('#alternative_content').show();
	    }
	  },
	  initColorbox: function initColorbox() {
	    $('.colorbox').colorbox();
	    $('.bigcolorbox').colorbox({ width: "970px", height: "80%", maxHeight: '800px', onComplete: function onComplete() {
	        $('#cboxLoadedContent').addClass('bigbox');
	      } });
	  },
	  initUpsell: function initUpsell() {
	    // newer upsell thing
	    var accountLevel = rwgps.config.currentUser ? rwgps.config.currentUser.account_level : 0;
	    function showUpsellModal(event) {
	      event.preventDefault();
	      var el = $(this);
	      var feature = el.data('feature');
	      var showUpgradeButton = !el.hasClass('featureModal');
	      rwgps.upgradeModal({ feature: feature, showUpgradeButton: showUpgradeButton });
	    }
	    if (!rwgps.config.bypassPrivileges) {
	      if (accountLevel < 2) {
	        $('body').on('click', '.premium_required', showUpsellModal);
	      }
	      if (accountLevel < 1) {
	        $('body').on('click', '.basic_required', showUpsellModal);
	      }
	    }
	
	    // featureModal shows the modal without the upgrade button (used on the plan info page)
	    $('body').on('click', '.featureModal', showUpsellModal);
	
	    // require-privilege is used to handle stuff like special cases for old basic users, etc
	    $('body').on('click', '[data-requires-privilege]', function (e) {
	      var el = e.target;
	      var privilege = el.dataset.requiresPrivilege;
	      var feature = el.dataset.feature;
	      if (!rwgps.config.privileges[privilege]) {
	        e.preventDefault();
	        rwgps.upgradeModal({ feature: feature, showUpgradeButton: true });
	      }
	    });
	
	    if (!rwgps.config.currentUser) {
	      console.log("no currentUser"); //eslint-disable-line
	      $('#signup_modal').on('show.bs.modal', function () {
	        $(this).css({ top: 20 }).find('.modal-body').css({
	          maxHeight: $(window).height() - 160,
	          "overflow-y": "scroll"
	        });
	      });
	      $('#signup_modal').on('shown.bs.modal', function () {
	        $(this).find('.fb-signup-btn').focus();
	      });
	      $('body').on('click', '.login_required', function () {
	        var $this = $(this),
	            redirect = $this.data('redirect') ? $this.data('redirect') : $this.attr('href');
	        $('#signup_modal').modal('show');
	        $('#signup_modal input[name=redirect]').val(redirect);
	        return false;
	      });
	    }
	  },
	  init: function init() {
	    $(function () {
	      Application.initUpsell();
	      Application.initColorbox();
	
	      //show garmin write stuff if plugin installed
	      if (window.CommunicatorDetector.detectGarminCommunicatorPlugin()) {
	        $(".garmin_write").removeClass("hidden");
	      }
	
	      // wire up top nav login button to
	      $('#login-button').on('click', function () {
	        rwgps.loginModalOverlay();
	      });
	
	      // sign in link on the sign up modal
	      $('#signup_modal a.signin').on('click', function () {
	        $('#signup_modal').modal('hide');
	        $('#login_form').modal('show');
	      });
	
	      // when signin modal pops up focus on email field
	      $('#login_form').on('shown.bs.modal', function () {
	        $(this).find('input:first').focus();
	      });
	
	      // setup global sharing widget
	      $('#share_link_modal').on('shown.bs.modal', function () {
	        $(this).find('input.share_link').focus().select();
	      });
	      $('body').on('click', '.share_bar_share_link', function () {
	        $('#share_link_modal').modal('show').find('input.share_link').val($(this).data('uri'));
	      });
	
	      $('body').on('click', '.share_bar_share_email', function () {
	        var assetType = $(this).data('asset_type'),
	            assetId = $(this).data('asset_id'),
	            assetUrl = $(this).data('uri');
	        $('#share_email_modal').modal('show').find('.share_email_asset_type').val(assetType).end().find('.share_email_asset_id').val(assetId).end().find('.share_email_asset_url').val(assetUrl);
	      });
	      $('#share_email_modal form').ajaxForm({
	        success: function success(response) {
	          $('#share_email_modal').modal('hide');
	          $.jGrowl(response.message);
	        }
	      });
	
	      $('#share_widget_modal').on('shown.bs.modal', function () {
	        $(this).find('textarea.share_widget').focus().select();
	      });
	      $('body').on('click', '.share_bar_share_widget', function () {
	        $('#share_widget_modal').modal('show').find('textarea.share_widget').val($(this).data('code'));
	      });
	
	      // setup friend requests
	      $('body').on('click', '.request_follow', function () {
	        var $this = $(this);
	        var user = $this.data('user');
	        $.post('/follows.json', { "follow": { "item_type": "User", "item_id": user } }, function () {
	          $this.fadeOut(400, function () {
	            var $conf = $('#followConfirm-' + user);
	            if ($conf) {
	              $conf.fadeIn();
	            }
	          });
	        });
	        return false;
	      });
	
	      // setup boosting from the share bar
	      $('body').on('click', '.boost_this', function () {
	        var path = $(this).attr('href'),
	            $li = $(this).closest('li');
	        $.post(path + '.json', function () {
	          $.jGrowl("Thanks for promoting this! Boosted.");
	          $li.slideUp();
	        });
	        return false;
	      });
	
	      $(document).on("click", 'a.delete', function (event) {
	        event.stopPropagation();
	        event.preventDefault();
	        var message = $(this).attr('doconfirm');
	        var onsuccess = $(this).attr('onsuccess');
	        var deleteIt = function deleteIt() {
	          $.post(self.href, { _method: 'delete' }, function () {
	            $(self).closest('li').remove();
	            if (onsuccess) eval(onsuccess);
	          });
	        };
	        if (message) {
	          customConfirm(message, deleteIt);
	        } else {
	          deleteIt();
	        }
	      });
	
	      reloadTooltips();
	
	      $(".mini_summary table tr:odd").addClass('alt');
	      $('li,tr').hover(function () {
	        $(this).addClass('hover');
	      }, function () {
	        $(this).removeClass('hover');
	      });
	
	      $.jGrowl.defaults.position = "bottom-right";
	
	      $('select#units').change(function () {
	        if ($(this).hasClass('reload')) {
	          Application.setPreference('metric_units', $('select#units option:selected').val());
	        } else {
	          rwgps.LabelMaker.metric = $('select#units option:selected').val() === 'true';
	          if (Routes.activeMap.activeRoute) {
	            Routes.activeMap.activeRoute.metricsChange();
	            Routes.activeMap.populateCuesheet(Routes.activeMap.activeRoute.coursePoints());
	            Routes.activeMap.drawRouteDistanceMarkers();
	          }
	          Application.setPreference('metric_units', $('select#units option:selected').val(), true);
	        }
	      });
	
	      $('.dont_bubble').live("click", function (event) {
	        stopEvent(event);
	      });
	
	      //conly call this if we have included it (not every page)
	      reloadDatepickers();
	
	      if ($.prettyLoader) $.prettyLoader({ delay: false });
	
	      // Setup close button for AppLinks.
	      // This opens rwgps:// links on iPhone
	      $('.close_app_link').click(function () {
	        $('.app_link').remove();
	      });
	
	      // End init function
	    });
	  },
	  setupPlaceAutocomplete: function setupPlaceAutocomplete(el) {
	    var cache = {},
	        lastXhr;
	    $(el).autocomplete({
	      minLength: 3,
	      delay: 200,
	      source: function source(request, response) {
	        var term = request.term;
	        if (term in cache) {
	          response(cache[term]);
	          return;
	        }
	        lastXhr = $.getJSON("/places/search.json", { q: request.term }, function (data, status, xhr) {
	          var results = _.map(data, function (o) {
	            var key = [o.name, o.municipality, o.region].join(', ');
	            // cache result so we can get lat/lng
	            rwgps.places[key] = o;
	            return key;
	          });
	          results = _.without(results, null);
	          // cache top result for this term too
	          if (data.length > 0) {
	            rwgps.places[request.term] = data[0];
	          }
	
	          cache[term] = results;
	          if (xhr === lastXhr) {
	            response(results);
	          }
	        });
	      }
	    }).keypress(function (e) {
	      // if the user presses enter in the search box, cancel the xhr request!
	      if (e.keyCode === 13 && lastXhr && lastXhr.abort) lastXhr.abort();
	      $(el).autocomplete('close');
	    });
	  },
	
	  setPreference: function setPreference(key, value, silent) {
	    var route = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '/set_preference';
	
	    Application.preventSpinner();
	    $.post(route, { key: key, value: value }, function () {
	      if (!silent) window.location.reload();
	    });
	  }
	};
	
	// Multiple file selector by Stickman - thanks Stickman (http://www.the-stickman.com)
	window.MultiSelector = function MultiSelector(list_target, object_name) {
	  // Where to write the list
	  this.list_target = list_target;
	  this.addElement = function (element) {
	    // Make sure it's a file input element
	    if (element.tagName == 'INPUT' && element.type == 'file') {
	      element.name = object_name + '[photos][]';
	      // Add reference to this object
	      element.multi_selector = this;
	      // What to do when a file is selected
	      element.onchange = function () {
	        // New file input
	        var new_element = document.createElement('input');
	        // give the id to the new input from the old one
	        var id = $(this).attr('id');
	        $(this).attr('id', '');
	        $(new_element).attr('id', id);
	
	        new_element.type = 'file';
	        // Add new element
	        this.parentNode.insertBefore(new_element, this);
	        // Apply 'update' to element
	        this.multi_selector.addElement(new_element);
	        // Update list
	        this.multi_selector.addListRow(this);
	        // Hide this: we can't use display:none because Safari doesn't like it
	        this.style.position = 'absolute';
	        this.style.left = '-1000px';
	      };
	      // Most recent element
	      this.current_element = element;
	    } else {
	      // This can only be applied to file input elements!
	      alert('Error: not a file input element');
	    }
	  };
	
	  /**
	  * Add a new row to the list of files
	  */
	  this.addListRow = function (element) {
	    // Row div
	    var new_row = document.createElement('div');
	    // Delete button
	    var new_row_button = document.createElement('input');
	    new_row_button.type = 'button';
	    new_row_button.value = 'Delete';
	    // References
	    new_row.element = element;
	    // Delete function
	    new_row_button.onclick = function () {
	      // Remove element from form
	      this.parentNode.element.parentNode.removeChild(this.parentNode.element);
	      // Remove this row from the list
	      this.parentNode.parentNode.removeChild(this.parentNode);
	      // Re-enable input element (if it's disabled)
	      this.parentNode.element.multi_selector.current_element.disabled = false;
	
	      // Appease Safari
	      //    without it Safari wants to reload the browser window
	      //    which nixes your already queued uploads
	      return false;
	    };
	    // Set row value
	    new_row.innerHTML = element.value;
	    // Add button
	    new_row.appendChild(new_row_button);
	    // Add it to the list
	    this.list_target.appendChild(new_row);
	  };
	};
	
	window.centeredpopup = function centeredpopup(url, title, w, h) {
	  var wLeft = window.screenLeft ? window.screenLeft : window.screenX;
	  var wTop = window.screenTop ? window.screenTop : window.screenY;
	
	  var left = wLeft + window.innerWidth / 2 - w / 2;
	  var top = wTop + window.innerHeight / 2 - h / 2;
	  return window.open(url, title, 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);
	};
	
	// https://gist.github.com/paulirish/1579671
	(function () {
	  var lastTime = 0;
	  var vendors = ['ms', 'moz', 'webkit', 'o'];
	  for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
	    window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
	    window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame'] || window[vendors[x] + 'CancelRequestAnimationFrame'];
	  }
	
	  if (!window.requestAnimationFrame) window.requestAnimationFrame = function (callback) {
	    var currTime = new Date().getTime();
	    var timeToCall = Math.max(0, 16 - (currTime - lastTime));
	    var id = window.setTimeout(function () {
	      callback(currTime + timeToCall);
	    }, timeToCall);
	    lastTime = currTime + timeToCall;
	    return id;
	  };
	
	  if (!window.cancelAnimationFrame) window.cancelAnimationFrame = function (id) {
	    clearTimeout(id);
	  };
	})();
	
	// guarantee transition end fires
	// http://blog.alexmaccaw.com/css-transitions
	var transitionEndEvent = window.transitionEndEvent = function () {
	  var t;
	  var el = document.createElement('fakeelement');
	  var transitions = { 'transition': 'transitionend', 'MSTransition': 'msTransitionEnd', 'MozTransition': 'transitionend', 'WebkitTransition': 'webkitTransitionEnd' };
	  for (t in transitions) {
	    if (el.style[t] !== undefined) {
	      return transitions[t];
	    }
	  }
	  return "fakeTransitionEndEvent";
	}();
	$.fn.emulateTransitionEnd = function (duration) {
	  var called = false,
	      $el = this;
	  $(this).one(transitionEndEvent, function () {
	    called = true;
	  });
	  var callback = function callback() {
	    if (!called) $($el).trigger(transitionEndEvent);
	  };
	  setTimeout(callback, duration);
	  return this;
	};
	
	// overwrite innerWidth, innerHeight, outerWidth & outerHeight because our old version of jQuery UI is breaking these functions.
	// if you remove this code, $el.outerHeight() will return an element, when it should return a number. You can remove this once
	// jQuery UI is updated.
	jQuery.each(["Width", "Height"], function (i, name) {
	  var side = name === "Width" ? ["Left", "Right"] : ["Top", "Bottom"],
	      type = name.toLowerCase(),
	      orig = {
	    innerWidth: jQuery.fn.innerWidth,
	    innerHeight: jQuery.fn.innerHeight,
	    outerWidth: jQuery.fn.outerWidth,
	    outerHeight: jQuery.fn.outerHeight
	  };
	
	  function reduce(elem, size, border, margin) {
	    jQuery.each(side, function () {
	      size -= parseFloat(jQuery.css(elem, "padding" + this, true)) || 0;
	      if (border) {
	        size -= parseFloat(jQuery.css(elem, "border" + this + "Width", true)) || 0;
	      }
	      if (margin) {
	        size -= parseFloat(jQuery.css(elem, "margin" + this, true)) || 0;
	      }
	    });
	    return size;
	  }
	
	  jQuery.fn["inner" + name] = function (size) {
	    if (size === undefined) {
	      return orig["inner" + name].call(this);
	    }
	
	    return this.each(function () {
	      jQuery(this).css(type, reduce(this, size) + "px");
	    });
	  };
	
	  jQuery.fn["outer" + name] = function (size, margin) {
	    // default to false
	    if (size === undefined) {
	      size = false;
	    }
	
	    if (typeof size !== "number") {
	      return orig["outer" + name].call(this, size);
	    }
	
	    return this.each(function () {
	      jQuery(this).css(type, reduce(this, size, true, margin) + "px");
	    });
	  };
	});
	
	$('.globalMenuOpen').on('click', function () {
	  $('body').addClass('noscroll');
	  $('.globalNav').addClass('open');
	});
	$('.globalMenuClose').on('click', function () {
	  $('body').removeClass('noscroll');
	  $('.globalNav').removeClass('open');
	});
	
	rwgps.ns('signup').init = function () {
	  rwgps.ns('users.signup.params', function () {
	    var ns = this;
	    $('#user_email,#user_email_confirmation', '#new_user').val(ns.email);
	    if (ns.duplicate_email) {
	      $('#duplicate_email_modal').modal('show');
	
	      $('.goto-login', '#duplicate_email_modal').on('click', function (e) {
	        e.preventDefault();
	
	        $('#duplicate_email_modal').modal('hide');
	        rwgps.loginModalOverlay(); // TODO: prepopulate email field
	      });
	
	      $('.reset-password', '#duplicate_email_modal').on('click', function (e) {
	        e.preventDefault();
	        $('#email', '#duplicate_email_modal').val(ns.email);
	
	        $('.forgot_password form', '#duplicate_email_modal').ajaxSubmit({
	          dataType: 'json',
	          success: function success() {
	            $('#duplicate_email_modal').modal('hide');
	            window.customAlert('An email was sent to the email address you provided with instructions to reset your password on Ride with GPS.');
	          }
	        });
	      });
	    }
	  });
	};

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	(function () {
	  var filter = __webpack_require__(150);
	  // TODO make this non-destructive and look for all uses of it on
	  // subsections of data (zooming in, TrackPoint.calculateSplits) and
	  // make it so those methods no longer copy track points to deal with
	  // this destructiveness
	  //
	  // the readOnly flag won't overwrite data with smoothed values - but the assumption is that
	  // this has already been done. it is used specifically to prevent smoothing the data
	  // multiple times, so do not use readOnly=true unless calculate() has already been run on
	  // the full track data once.
	  // See rwgps/data.js for examples of both usages, in Data and DataSlice respectively.
	
	  // metrics is optional, used to preload the metrics calculator so calculation is not required
	  var MetricsCalculator = function MetricsCalculator(data, readOnly, metrics, serverMode) {
	    // not positive what the implications are of doing this across the
	    // board, but definitely dont need to do this for the new elevation
	    // profile so adding this setting... that way i can stop cloning
	    // points and this can stop being destructive
	    this.readOnly = readOnly;
	    this.serverMode = !!serverMode;
	    if (_.isArray(data)) this._data = new rwgps.Data(data);else this._data = data;
	
	    this._points = [];
	    this._metrics = {};
	    if (metrics && metrics.v == 1) {
	      this._metrics = metrics;
	      this.calculated = true;
	    }
	  };
	
	  MetricsCalculator.version = 1;
	
	  // speed-by-grade trip summary / estimated time settings
	  var minSummaryGrade = -15;
	  var maxSummaryGrade = 15;
	
	  /*
	   * Version 1 structure
	   {
	   "watts"=>{
	   "normalized"=>184.3248112608079,
	   "max"=>620,
	   "min"=>11,
	   "_min"=>1,
	   "_max"=>620,
	   "avg"=>161.6254295532646
	   },
	   "ele"=>{
	   "max"=>460.038,
	   "min"=>136.637,
	   "_min"=>136.637,
	   "_max"=>460.038,
	   "avg"=>219.1570193591459
	   },
	   "hr"=>{
	   "max"=>179,
	   "min"=>90,
	   "_min"=>90,
	   "_max"=>179,
	   "avg"=>149.82443257676903
	   },
	   "cad"=>{
	   "max"=>186,
	   "min"=>21,
	   "_min"=>0,
	   "_max"=>186,
	   "avg"=>81.7462090981644
	   },
	   "watts_ma_30"=>{
	   "max"=>416.48666666666696,
	   "min"=>5.87857142857174,
	   "_max"=>416.48666666666696,
	   "_min"=>2.000000000000239,
	   "avg"=>0
	   },
	   "watts_ma_60"=>{
	   "max"=>317.0847222222222,
	   "min"=>8.419047619047673,
	   "_max"=>317.0847222222222,
	   "_min"=>2.000000000000076,
	   "avg"=>0
	   },
	   "speed"=>{
	   "max"=>54.779,
	   "min"=>0.09,
	   "_max"=>55.30781253600027,
	   "_min"=>0,
	   "avg"=>22.055349092721098
	   },
	   "grade"=>{
	   "max"=>18.421,
	   "min"=>-16.605,
	   "_max"=>38.1,
	   "_min"=>-36.3,
	   "avg"=>1.4174899866488644
	   },
	   "duration"=>8129,
	   "movingTime"=>7949,
	   "stoppedTime"=>180,
	   "pace"=>166.9218506827479,
	   "movingPace"=>163.22570932183086,
	   "distance"=>48699.4360939,
	   "startElevation"=>145.536,
	   "endElevation"=>147.953,
	   "numPoints"=>1526,
	   "ele_gain"=>652.9000000000003,
	   "ele_loss"=>650.851
	   }
	   */
	
	  // MetricsCalculator.aggregate(metrics1, metrics2, metrics3, etc)
	  // TODO: actually use this! or think of something smarter
	  MetricsCalculator.aggregate = function () {
	    return _.reduce(arguments, function (memo, metrics) {
	      //if(!memo) return metrics;
	      //trace(metrics);
	      return metrics;
	    }, null);
	  };
	  MetricsCalculator.prototype = {
	    metrics: function metrics() {
	      if (!this.calculated) this.calculate();
	      return this._metrics;
	    },
	
	    hasMetric: function hasMetric(metric) {
	      if (!this._metrics[metric]) return false;
	      var m = this._metrics[metric]._max;
	      return !(m === undefined || m === null || m == -50000 || isNaN(m));
	    },
	
	    // run fn on up to 10% of points, short circuit when fn is truthy
	    limitedDetect: function limitedDetect(fn) {
	      if (this._data.count > 0) {
	        var checkCount = Math.ceil(this._data.count / 10);
	        for (var i = 0; i < checkCount; i++) {
	          if (fn(this._data.points(i))) return true;
	        }
	      }
	      return false;
	    },
	
	    hasPosition: function hasPosition() {
	      if (this._hasPosition === undefined) {
	        this._hasPosition = this.limitedDetect(function (tp) {
	          return tp.point;
	        });
	      }
	      return this._hasPosition;
	    },
	
	    hasTime: function hasTime() {
	      return !!(this._data.points(0) && !isNaN(this._data.points(0).time) && this._data.points(0).time > 0);
	    },
	
	    hasDistance: function hasDistance() {
	      if (this._hasDistance === undefined) {
	        var dist0;
	        this._hasDistance = this.limitedDetect(function (tp) {
	          // if the point has position, then the track has distance.
	          if (tp.point) return true;
	          // for stationary rides, sometimes provided dist is a nonchanging number. ensure it changes to say we have distance.
	          if (_.isNumber(tp.providedDistance)) {
	            if (dist0 === undefined) {
	              dist0 = tp.providedDistance;
	            } else if (tp.providedDistance - dist0 > 0) {
	              return true;
	            }
	          }
	        });
	      }
	      return this._hasDistance;
	    },
	
	    hasPower: function hasPower() {
	      if (this._data.count == 0) return false;
	      var rand,
	          hasPower = false;
	      for (var i = 0; i < 10; i++) {
	        rand = Math.floor(Math.random() * this._data.count);
	        hasPower = hasPower || this._data.points(rand).watts != null;
	      }
	      return hasPower;
	    },
	
	    enabledMetrics: function enabledMetrics() {
	      var metrics,
	          enabledMetrics = [];
	      if (this.serverMode) {
	        metrics = ["ele", "hr", "cad", "watts", "speed", "grade", "temp"];
	      } else {
	        metrics = ["ele", "surfaces", "hr", "cad", "watts", "watts_ma_30", "watts_ma_60", "speed", "grade", "temp"];
	      }
	
	      for (var i = 0; i < metrics.length; i++) {
	        if (this.hasMetric(metrics[i])) {
	          enabledMetrics.push(metrics[i]);
	        }
	      }
	      return enabledMetrics;
	    },
	
	    enabledBaseMetrics: function enabledBaseMetrics() {
	      var metrics = ["ele", "hr", "cad", "watts", "speed", "grade", "temp"],
	          enabledMetrics = [];
	
	      for (var i = 0; i < metrics.length; i++) {
	        if (this.hasMetric(metrics[i])) enabledMetrics.push(metrics[i]);
	      }
	      return enabledMetrics;
	    },
	
	    getMetric: function getMetric(metric, prop) {
	      var m = this._metrics;
	      return m[metric] && m[metric][prop] ? m[metric][prop] : 0;
	    },
	
	    setMetric: function setMetric(metric, prop, value, i) {
	      if (!this._metrics[metric]) this._metrics[metric] = {};
	      this._metrics[metric][prop] = value;
	      if (i) this._metrics[metric][prop + "_i"] = i;
	    },
	
	    removeMetric: function removeMetric(metric) {
	      delete this._metrics[metric];
	    },
	
	    setHRZoneBoundaries: function setHRZoneBoundaries(hrZoneBoundaries) {
	      this._hrZoneBoundaries = hrZoneBoundaries;
	    },
	
	    getHRZoneBoundaries: function getHRZoneBoundaries() {
	      return this._hrZoneBoundaries;
	    },
	
	    calculate: function calculate(abortIfCalculated) {
	      if (this._data.count < 2) return {};
	      if (abortIfCalculated && this.calculated) {
	        return this._metrics;
	      }
	      // i benchmarked copying points from slices, or referencing them. copying is faster.
	      this._points = this._data.points();
	
	      var i;
	      var metrics;
	      if (this.serverMode) metrics = ["ele", "hr", "cad", "watts", "speed", "grade", "temp"];else metrics = ["ele", "surfaces", "hr", "cad", "watts", "watts_ma_30", "watts_ma_60", "speed", "grade", "temp"];
	      var hasTime = this.hasTime();
	      var d = this._data;
	      var point;
	      var hasPower = this.hasPower();
	      var hasDistance = this.hasDistance();
	      var includedNonInitialPoint;
	      var distance = 0;
	      var elevationGain = 0;
	      var elevationLoss = 0;
	      var ascentTime = 0;
	      var descentTime = 0;
	      var duration;
	      var movingTime;
	      var stoppedTime;
	      var count = 0;
	      var minCadAllowed = 10;
	      var minWattsAllowed = 10;
	      var firstTime;
	      var bounds = this._bounds = {
	        sw: { lat: 90, lng: 180 },
	        ne: { lat: -90, lng: -180 }
	      };
	
	      if (hasPower) {
	        if (this.serverMode) {
	          // calculate all the moving averages we need to get the single best efforts we store on server
	          this._metrics.bestEfforts = this.calculateMovingAverages('watts', [5, 10, 15, 20, 30, 60, 60 * 5, 60 * 10, 60 * 20, 60 * 30, 60 * 60, 60 * 90]);
	        } else {
	          // this is what is displayed as options in sample graph
	          this.calculateMovingAverages('watts', [30, 60]);
	        }
	        this.calculateNormalizedPower();
	      }
	
	      //we must explicitly set these, since it is possible for the first
	      //of the points to have a zero value.  in that case, min elevation
	      //for example, would be zero, even tho it's an outlier.
	      point = d.points(0);
	      for (i = 0; i < metrics.length; i++) {
	        var metric = metrics[i];
	        this.setMetric(metric, 'max', -50000);
	        this.setMetric(metric, 'min', 50000);
	      }
	
	      if (hasTime) {
	        movingTime = 0;
	        stoppedTime = 0;
	        firstTime = point.time;
	      }
	
	      var points = this._points;
	
	      var delta;
	      var prevPoint;
	      var distanceWithoutExcludedPoints = 0;
	      //set start and end of route to have 0 grade, if we dont' have it already
	      //set by ruby and data_full
	      if (!this.readOnly) {
	        var firstpt = d.points(0);
	        if (isNaN(firstpt.grade) && !isNaN(firstpt.ele)) {
	          firstpt.grade = firstpt.grade_orig = 0;
	        }
	        if (isNaN(firstpt.speed) && hasDistance) {
	          firstpt.speed = 0;
	        }
	        firstpt.distance = 0;
	
	        // set distances.
	        point = null;
	        for (i = 0; i < d.count; i++) {
	          if (point && (point.providedDistance !== undefined || point.point)) prevPoint = point;
	          point = points[i];
	          includedNonInitialPoint = prevPoint && (!prevPoint.excludeFromMetrics || !point.excludeFromMetrics);
	          if (point.point) {
	            if (point.point.lat < -90 || point.point.lat > 90 || point.point.lng < -180 || point.point.lng > 180) {
	              point.point = null;
	            }
	          }
	
	          if (prevPoint) {
	            if (prevPoint.providedDistance !== undefined && point.providedDistance !== undefined) {
	              delta = point.providedDistance - prevPoint.providedDistance;
	            } else if (point.point && prevPoint.point) {
	              delta = point.distanceFromPoint(prevPoint);
	            } else {
	              delta = 0;
	            }
	            distance += delta;
	            if (includedNonInitialPoint) {
	              distanceWithoutExcludedPoints += delta;
	            }
	          }
	          point.distance = distance;
	          point.distanceWithoutExcludedPoints = distanceWithoutExcludedPoints;
	        }
	        // reset distance because it will be set in the next loop;
	        distance = 0;
	      }
	      var smoothedEles = this.smoothEles();
	
	      // goodPoint is set when distance exists or can be derived (and is used for speed setting)
	      // when true, prevPoint is reassigned, otherwise points are skipped over for speed calcs, unless stationary
	      var goodPoint = false;
	      point = null;
	      prevPoint = null;
	
	      // moving time gets increased when cad/watts are present, without distance values. prevPoint only
	      // gets reassigned when distance values are present. so, we need a moving time specific version of "prevPoint"
	      // to track time deltas
	      var movingTimePrevPoint;
	      var movingTimeDelta = 0;
	      var moving = false;
	      for (i = 0; i < d.count; i++) {
	        moving = false;
	        if (goodPoint) prevPoint = point;
	        if (hasTime && point && point.time) movingTimePrevPoint = point;
	        point = points[i];
	        includedNonInitialPoint = prevPoint && (!prevPoint.excludeFromMetrics || !point.excludeFromMetrics);
	        goodPoint = point.providedDistance !== undefined || point.point;
	        var prevSpeed;
	        if (!prevPoint) {
	          delta = 0;
	        } else if (prevPoint.providedDistance !== undefined && point.providedDistance !== undefined) {
	          delta = point.providedDistance - prevPoint.providedDistance;
	        } else if (prevPoint.distance !== undefined && point.distance !== undefined) {
	          delta = point.distance - prevPoint.distance;
	        } else if (point.point && prevPoint.point) {
	          // This case will probably not happen as it is covered above.
	          delta = point.distanceFromPoint(prevPoint);
	        } else {
	          delta = 0;
	        }
	        if (delta && includedNonInitialPoint) distance += delta;
	
	        if (hasTime && point.time && includedNonInitialPoint && prevPoint.time && prevPoint.time != point.time) {
	          var timedelta = point.time - prevPoint.time;
	          var speed = (timedelta == 0 ? 0 : delta / timedelta) / 1000.0 * 3600;
	          if (!Number.isFinite(point.speed) && hasDistance) {
	            point.speed = speed;
	            //if over 100kph and we detect a major speed outlier (big jump), kill it
	            if (speed > 100 && prevSpeed) {
	              var speedDelta = (speed - prevSpeed) / timedelta;
	              //motorcycle can do 0-100kph in 3 seconds or so, so upper bound
	              //with 40kph per second acceleration
	              if (prevSpeed * 1.5 < speed && speedDelta > 40) {
	                point.speed = undefined;
	              }
	            }
	            prevSpeed = speed;
	          } else if (point.speed) {
	            prevSpeed = point.speed;
	          }
	          //we use the calculated speed as a double check
	          //This is because when a garmin auto-pauses, the
	          //two points at the start and end of pause might have a speed of 7m/s,
	          //but they have the same distance and similar lat/lng, meaning there is
	          //just a delay in the sensor readings from the garmin.
	          var speedThreshold = 3.2;
	          movingTimeDelta = point.time - movingTimePrevPoint.time;
	          if (movingTimeDelta <= 32 && (point.speed > speedThreshold && speed > speedThreshold || point.cad && point.cad > minCadAllowed || point.watts && point.watts > minWattsAllowed)) {
	            //speed is greater than 2mph or cad/watts sufficient
	            movingTime += movingTimeDelta;
	            count += 1;
	            moving = true;
	          } else if (hasDistance) {
	            // this exclude flag is used to consider the user stopped and will be excluded from maxes/mins/avgs.
	            prevPoint.exclude = true;
	            point.exclude = true;
	            // we're here because timedelta is big, or because we don't want to consider the user moving.
	            // if timedelta is big, we end up with bogus-looking long lines from (for example)
	            // 3mph to 16mph stretched across a 30 minute gap (lunch with smart recording).  in the case of
	            // a large timedelta, set the speeds to 0 to avoid this bogus-looking graph situation.
	            if (movingTimeDelta > 32) {
	              prevPoint.speed = 0;
	              point.speed = 0;
	            }
	          }
	        } else {
	          count += 1; //for routes, still need to count all the points
	        }
	
	        if (!goodPoint && this.hasPosition()) point.speed = null;
	
	        if (point.point) {
	          if (point.point.lng > bounds["ne"]['lng']) bounds["ne"]['lng'] = point.point.lng;
	          if (point.point.lat > bounds["ne"]['lat']) bounds["ne"]['lat'] = point.point.lat;
	          if (point.point.lng < bounds["sw"]['lng']) bounds["sw"]['lng'] = point.point.lng;
	          if (point.point.lat < bounds["sw"]['lat']) bounds["sw"]['lat'] = point.point.lat;
	        }
	
	        var eleIdx = smoothedEles.idxMap[i];
	        if (eleIdx && eleIdx > 0) {
	          var eleDiff = smoothedEles.results[eleIdx] - smoothedEles.results[eleIdx - 1];
	          if (includedNonInitialPoint) {
	            if (eleDiff < 0 && eleDiff > -500) {
	              elevationLoss -= eleDiff;
	              if (hasTime && moving && point.time && prevPoint.time) descentTime += point.time - prevPoint.time;
	            } else if (eleDiff > 0 && eleDiff < 500) {
	              elevationGain += eleDiff;
	              if (hasTime && moving && point.time && prevPoint.time) ascentTime += point.time - prevPoint.time;
	            }
	          }
	
	          if (!isNaN(eleDiff) && (isNaN(point.grade) || point.grade == null)) {
	            //don't go out of index for grade calc
	            point.grade = point.grade_orig = delta == 0 ? 0 : parseInt(eleDiff / delta * 100 * 10.0) / 10.0;
	            if (Math.abs(point.grade) > 40 && prevPoint) //toss outliers, 40% grade is HUGE
	              point.grade = point.grade_orig = prevPoint.grade;
	          }
	        }
	      }
	
	      var ptCount, // count all points with the metric defined
	      ptSum, filteredPtCount, // only count "considered" points (moving, >= 10 for cad or watts)
	      filteredPtSum;
	
	      for (var j = 0; j < metrics.length; j++) {
	        metric = metrics[j];
	        ptCount = ptSum = filteredPtCount = filteredPtSum = 0;
	
	        // for time-weighted average
	        var totalTime = 0,
	            metricSeconds = 0,
	            lastTime = points[0].time,
	            timeDiff = 0,
	            lastVal = null,
	            valAvg;
	
	        for (i = 0; i < d.count; i++) {
	          point = points[i];
	          if (point[metric] === null || isNaN(point[metric])) {
	            continue;
	          }
	          ptCount++;
	          ptSum += point[metric];
	
	          // build up a time-weighted average if we have time data
	          if (hasTime) {
	            if (lastVal !== null) {
	              timeDiff = point.time - lastTime;
	              valAvg = (point[metric] + lastVal) / 2;
	              if (timeDiff > 180) {
	                valAvg = 0;
	              }
	              totalTime += timeDiff;
	              metricSeconds += timeDiff * valAvg;
	            }
	            lastTime = point.time;
	            lastVal = point[metric];
	          }
	
	          if (point[metric] < this._metrics[metric]['_min'] || this._metrics[metric]['_min'] === undefined) this.setMetric(metric, '_min', point[metric]);
	          if (point[metric] > this._metrics[metric]['_max'] || this._metrics[metric]['_max'] === undefined) {
	            this.setMetric(metric, '_max', point[metric]);
	          }
	
	          if (!point.exclude) {
	            if (metric == 'cad') {
	              if (point[metric] < minCadAllowed) continue;
	              filteredPtCount++;
	            } else if (metric == "watts") {
	              if (point[metric] < minWattsAllowed) continue;
	              filteredPtCount++;
	            } else {
	              filteredPtCount++;
	            }
	            if (point[metric] > this.getMetric(metric, 'max')) {
	              this.setMetric(metric, 'max', point[metric], i);
	            }
	            if (point[metric] < this.getMetric(metric, 'min')) this.setMetric(metric, 'min', point[metric], i);
	
	            if (metric != 'speed' || hasTime) {
	              filteredPtSum += point[metric];
	            }
	          }
	        }
	        if (ptCount > 0) {
	          if (hasTime) {
	            // time-weighted average
	            this.setMetric(metric, '_avg', totalTime > 0 ? metricSeconds / totalTime : 0);
	          } else {
	            // simple average
	            this.setMetric(metric, '_avg', ptSum / d.count);
	          }
	          if (filteredPtCount > 0) {
	            this.setMetric(metric, 'avg', filteredPtSum / filteredPtCount);
	          }
	        } else {
	          this.removeMetric(metric);
	        }
	      }
	      if (hasTime) {
	        lastTime = d.points(d.count - 1).time;
	        if (!lastTime) lastTime = d.points(d.count - 2).time;
	        duration = lastTime - d.points(0).time;
	        if (duration > 0) {
	          stoppedTime = duration - movingTime;
	          this._metrics['stationary'] = !this.hasPosition();
	          this._metrics['duration'] = duration;
	          this._metrics['firstTime'] = firstTime;
	          this._metrics['movingTime'] = movingTime;
	          this._metrics['stoppedTime'] = stoppedTime;
	          this._metrics['pace'] = distance > 0 ? duration / (distance / 1000) : 0;
	          this._metrics['movingPace'] = distance > 0 ? movingTime / (distance / 1000) : 0;
	          this._metrics['ascentTime'] = ascentTime;
	          this._metrics['descentTime'] = descentTime;
	          this._metrics['vam'] = ascentTime > 0 ? elevationGain / (ascentTime / 3600) : 0;
	          if (hasPower) this._metrics['kJ'] = this._metrics.watts._avg * duration / 1000;
	          if (this._metrics.speed && movingTime > 0) this._metrics.speed.avg = distance / 1000 / (movingTime / 3600);
	        } else {
	          delete this._metrics.speed;
	        }
	      }
	
	      // heuristics to clean up data if we detect this is stationary
	      // with bad speed/distance
	      if (this._metrics.speed && this.hasTime() && this._metrics.speed.avg < 0.3) {
	        delete this._metrics.speed;
	        this._hasDistance = false;
	        this._hasPosition = false;
	      }
	      this.calculateGradeAndSpeed();
	
	      // build speed-by-grade summary for server / estimate moving time for user
	      if (this.hasPosition()) {
	        if (this.serverMode && hasTime) {
	          this._metrics['tripSummary'] = this.buildTripSummary();
	        } else if (rwgps.summary && rwgps.summary.user_summary) {
	          this._metrics['estimatedTime'] = this.estimateTimeFor(rwgps.summary.user_summary);
	        }
	      }
	
	      // build distance-by-grade summary
	      if (this.serverMode && this.hasPosition() && hasDistance) {
	        this._metrics['routeSummary'] = this.buildRouteSummary();
	      }
	
	      var zoneBoundaries = this._hrZoneBoundaries;
	      if (zoneBoundaries && hasTime) {
	        var hrZones = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
	        var hasHr = false;
	        for (var _i = 0; _i < points.length; ++_i) {
	          var _point = points[_i];
	          if (_point.exclude) {
	            continue;
	          }
	
	          var hrVal = _point['hr'];
	          // Ignore bogus heartrate values
	          if (!Number.isFinite(hrVal)) {
	            continue;
	          }
	
	          var zone = 6;
	          for (; zone > 0 && hrVal < zoneBoundaries[zone - 1]; --zone) {}
	          if (zone > 5 || zone < 1) {
	            continue;
	          }
	
	          var _prevPoint = points[_i - 1];
	          var nextPoint = points[_i + 1];
	          var t0 = (_prevPoint && !_prevPoint.exclude ? _prevPoint : _point).time;
	          var t1 = (nextPoint && !nextPoint.exclude ? nextPoint : _point).time;
	          var _duration = (t1 - t0) / 2.0;
	
	          // Missing 't' values can lead to bogus durations - ignore them
	          if (!Number.isFinite(_duration)) {
	            continue;
	          }
	
	          hasHr = true;
	          hrZones[zone] = (hrZones[zone] || 0) + _duration;
	        }
	        if (hasHr) {
	          this._metrics["hr_zones"] = hrZones;
	        }
	      }
	
	      this._metrics["distance"] = distance; //manually add this in
	      this._metrics['startElevation'] = d.points(0).ele;
	      this._metrics['endElevation'] = d.points(d.count - 1).ele;
	      this._metrics['numPoints'] = d.count;
	      this._metrics["ele_gain"] = elevationGain;
	      this._metrics["ele_loss"] = elevationLoss;
	
	      if (this.hasSurface()) {
	        this._metrics['surfaces'] = this.calculateSurfaceTypes();
	      }
	
	      this.calculated = true;
	      if (elevationGain > 50 && elevationLoss / elevationGain < 0.2) {
	        this._metrics['isClimb'] = true;
	        this.calculateUCIClimbRating();
	        this.calculateFietsIndex();
	      }
	      this._metrics['v'] = MetricsCalculator.version;
	
	      return this._metrics;
	    },
	
	    buildTripSummary: function buildTripSummary() {
	      var points = this._points,
	          gradeSpeeds = {},
	          tripSummary = {},
	          i;
	
	      for (i = minSummaryGrade; i <= maxSummaryGrade; i++) {
	        gradeSpeeds[i.toString()] = [];
	      }
	
	      var lastGoodIdx = -1;
	      for (i = 0; i < points.length; i++) {
	        var point = points[i],
	            grade = point["grade"];
	        if (!_.isFinite(grade) || !_.isFinite(point["speed"]) || point["exclude"] === true) {
	          continue;
	        }
	        if (lastGoodIdx > -1) {
	          if (grade > maxSummaryGrade) {
	            grade = maxSummaryGrade;
	          }
	          if (grade < minSummaryGrade) {
	            grade = minSummaryGrade;
	          }
	          gradeSpeeds[Math.round(grade).toString()].push(point["speed"]);
	        }
	        lastGoodIdx = i;
	      }
	
	      for (i = minSummaryGrade; i <= maxSummaryGrade; i++) {
	        var speeds = gradeSpeeds[i],
	            count = speeds.length,
	            total,
	            average;
	        if (count === 0) {
	          average = 0;
	        } else {
	          total = speeds.reduce(function (a, b) {
	            return (a === undefined ? 0 : a) + (b === undefined ? 0 : b);
	          });
	          average = total / count;
	        }
	        tripSummary[i] = [average, count];
	      }
	      return tripSummary;
	    },
	
	    buildRouteSummary: function buildRouteSummary() {
	      var points = this._points,
	          gradeDistance = {},
	          routeSummary = {},
	          i;
	
	      for (i = minSummaryGrade; i <= maxSummaryGrade; i++) {
	        gradeDistance[i.toString()] = [];
	      }
	
	      var lastGoodI = -1;
	      for (i = 0; i < points.length; i++) {
	        var point = points[i];
	        if (!_.isFinite(point["grade"])) {
	          continue;
	        }
	        if (lastGoodI > -1) {
	          var currentDistance = point["distance"] - points[lastGoodI]["distance"],
	              avgGrade = (points[i]["grade"] + points[lastGoodI]["grade"]) / 2,
	              key = Math.round(avgGrade);
	          if (key > maxSummaryGrade) {
	            key = maxSummaryGrade;
	          }
	          if (key < minSummaryGrade) {
	            key = minSummaryGrade;
	          }
	          gradeDistance[key.toString()].push(currentDistance);
	        }
	        lastGoodI = i;
	      }
	
	      for (i = minSummaryGrade; i <= maxSummaryGrade; i++) {
	        if (gradeDistance[i].length === 0) {
	          routeSummary[i] = 0;
	        } else {
	          var total = gradeDistance[i].reduce(function (a, b) {
	            return (a === undefined ? 0 : a) + (b === undefined ? 0 : b);
	          });
	          routeSummary[i] = total;
	        }
	      }
	      return routeSummary;
	    },
	
	    estimateTimeFor: function estimateTimeFor(userSummary) {
	      var routeSummary = this.buildRouteSummary(),
	          time = 0;
	      Object.keys(routeSummary).forEach(function (grade) {
	        if (grade > maxSummaryGrade) {
	          userSummary[grade] = userSummary[maxSummaryGrade.toString()];
	        }
	        if (grade < minSummaryGrade) {
	          userSummary[grade] = userSummary[minSummaryGrade.toString()];
	        }
	
	        // 1000 is for conversion between speed in kph & distance in meters
	        time += routeSummary[grade] / 1000 / userSummary[grade][0];
	      });
	
	      // time is in hours due to speed being in kph
	      return time * 3600;
	    },
	
	    calculateUCIClimbRating: function calculateUCIClimbRating() {
	      var metrics = this.metrics(),
	          uciCategory,
	          uciScore = metrics.uciScore = metrics.distance * this.getMetric('grade', 'avg');
	      if (uciScore > 64000) uciCategory = 'HC';else if (uciScore > 48000) uciCategory = 1;else if (uciScore > 32000) uciCategory = 2;else if (uciScore > 16000) uciCategory = 3;else if (uciScore > 8000) uciCategory = 4;
	      metrics.uciCategory = uciCategory;
	    },
	
	    calculateFietsIndex: function calculateFietsIndex() {
	      var metrics = this.metrics(),
	          maxEle = this.getMetric('ele', 'max'),
	          minEle = this.getMetric('ele', 'min'),
	          h = maxEle - minEle,
	          d = metrics.distance,
	          t = maxEle;
	      metrics.fietsIndex = h * h / (d * 10) + (t > 1000 ? (t - 1000) / 1000.0 : 0);
	    },
	
	    // example use: calculateMovingAverages('watts', [30, 60])
	    calculateMovingAverages: function calculateMovingAverages(metric, windowDurations) {
	      if (!this._points[0] || this._points[0].hasOwnProperty('watts_ma_' + windowDurations[0])) {
	        return;
	      }
	      // filter out points with duplicate time value, and without watts
	      var points = [],
	          d = this._data,
	          allpoints = this._points;
	      var prevPoint = null,
	          p = null;
	      for (var i = 0, len = d.count; i < len; i++) {
	        prevPoint = p;
	        p = allpoints[i];
	        p._idx = i;
	        if ((i == 0 || p.time != prevPoint.time) && _.isNumber(p.watts)) points.push(p);
	      }
	      // need at least a couple points to not throw an error..
	      if (points.length <= 2) return {};
	      var baseMetric = 'watts',
	          n,
	          max = 0,
	          max_i,
	          maxes = {};
	      for (var durI = 0; durI < windowDurations.length; durI++) {
	        max = 0;
	        n = windowDurations[durI];
	        var avgMetric = baseMetric + '_ma_' + n;
	        var halfN = n / 2;
	        var firstT = points[0].time;
	        var lastT = points[points.length - 1].time;
	        i = 0;
	        // find first point that is >= n/2 seconds in,
	        while (points[++i] && points[i].time - firstT < halfN) {}
	        // there isnt even n seconds worth of data! get out of here
	        if (!points[i] || lastT - points[i].time < halfN) {
	          break;
	        }
	
	        // if we already did it gtfo
	        if (points[i][avgMetric]) {
	          break;
	        }
	
	        // alright, i is the first point where we are at least n/2 seconds
	        // in, and we know we have at least n/2 seconds after i, so lets
	        // do it
	        //
	        // we need to do the full calculation for the first point
	        var res = this.timeWeightedAverage(baseMetric, points[i].time - halfN, points[i].time + halfN, null, points);
	        points[i][avgMetric] = res.avg;
	
	        var backI = res.outerStartI,
	            frontI = res.innerEndI;
	        var lastI = i;
	        for (++i; lastT - points[i].time >= halfN; i++) {
	          var time = points[i].time;
	          var prevTime = points[i - 1].time;
	
	          // we move forward a point, which is deltaT seconds. we'll
	          // discard/add this amount of time from the back/front
	          var deltaT = time - prevTime;
	
	          // figure out what we're going to add from the front
	          var toAdd = this.timeWeightedAverage(baseMetric, prevTime + halfN, time + halfN, frontI, points);
	          frontI = toAdd.innerEndI;
	
	          // figure out what we're going to discard from the back
	          var toDiscard = this.timeWeightedAverage(baseMetric, prevTime - halfN, time - halfN, backI, points);
	          backI = toDiscard.outerStartI;
	
	          // we're adding to / removing from this value
	          var lastAvg = points[lastI][avgMetric];
	
	          // we normalize by multiplying each value by the duration they
	          // represent, then divide by our total duration n
	          var newAvg = (n * lastAvg + deltaT * (toAdd.avg - toDiscard.avg)) / n;
	          // we end up with rounding errors that are barely negative, get rid of them
	          if (newAvg < 0 && newAvg > -0.0000001) newAvg = 0;
	          points[i][avgMetric] = newAvg;
	          // keep track of max
	          if (!max || max < newAvg) {
	            max = newAvg;
	            max_i = points[i]._idx;
	          }
	          // if we skip points because time is the same, this lastI
	          // value still represents the last successful i. it was i-1
	          // before, but once we encountered data with the same time,
	          // i-1 didnt work in all cases.
	          lastI = i;
	        }
	        maxes[n] = [max_i, max];
	      }
	      return maxes;
	    },
	
	    timeWeightedAverage: function timeWeightedAverage(metric, startT, endT, startI, points) {
	      if (!points) {
	        points = this._data.points();
	      }
	      if (!startT) startT = 0;
	      if (!endT) endT = points[points.length - 2].time;
	      if (!startI) startI = 1;
	      // find startI, the idx of the first point after startT
	      while (points[startI].time < startT) {
	        startI++;
	      } // calculate time weighted avg from startI through endI, the idx
	      // of the last point before endT
	      var i = startI;
	      var avgTimesDuration = 0;
	      while (points[++i] && points[i].time <= endT) {
	        var dt = points[i].time - points[i - 1].time;
	        var avg = (points[i][metric] + points[i - 1][metric]) / 2;
	        avgTimesDuration += dt * avg;
	      }
	      var endI = i - 1;
	      // both start and end times fall between two consecutive points,
	      // we overshoot and need to back up endI (which should always be
	      // <= endT!
	      if (points[endI].time > endT || points.length == endI + 1) endI--;
	
	      // calculate the extra interpolated bit at the beginning
	      var firstPt = points[startI];
	      var prevPt = points[startI - 1];
	
	      var leftDeltaT = firstPt.time - startT;
	      var leftEstValue = firstPt[metric] - (firstPt[metric] - prevPt[metric]) * leftDeltaT / (firstPt.time - prevPt.time);
	      // and the extra interpolated bit at the end
	      var lastPt = points[endI];
	      var nextPt = points[endI + 1];
	      var rightDeltaT = endT - lastPt.time;
	      var rightEstValue = lastPt[metric] + (nextPt[metric] - lastPt[metric]) * rightDeltaT / (nextPt.time - lastPt.time);
	      var finalAvg;
	      if (endI < startI) {
	        // both times fall between two points, so just average the
	        // estimated values
	        finalAvg = (leftEstValue + rightEstValue) / 2;
	      } else {
	        var finalProduct = leftDeltaT * (leftEstValue + firstPt[metric]) / 2 + avgTimesDuration + rightDeltaT * (rightEstValue + lastPt[metric]) / 2;
	        finalAvg = finalProduct / (endT - startT);
	      }
	
	      return {
	        outerStartI: startI - 1,
	        innerEndI: endI,
	        avg: finalAvg
	      };
	    },
	
	    resampleEles: function resampleEles(points, targetDelta, key) {
	      var prevPoint,
	          point,
	          pts = [];
	      //always start curDistance with first distance point. in some cases
	      //we drop the first couple no ele points, so distance doesn't always
	      //start at 0. this is to avoid 0->1000ft in the first couple points.
	      var curVal = points[0][key],
	          i = 0;
	
	      pts.push({ x: 0, y: points[0].ele || 0, yDelta: 0 });
	      //second condition double checks how much we are going to interpolate...
	      //without putting a bounds on the span between points, we could add
	      //an extra 100k points to interpolate!
	      while (i < points.length) {
	        point = points[i];
	
	        if (prevPoint && Number.isFinite(point.ele) && prevPoint[key] <= curVal && point[key] > curVal && points[i][key] - curVal < 1000) {
	          var xDelta = point[key] - prevPoint[key];
	          var xPercent = (curVal - prevPoint[key]) / xDelta;
	          var yDelta = point.ele - prevPoint.ele;
	          var e = prevPoint.ele + xPercent * yDelta;
	
	          pts.push({ x: curVal, y: e, yDelta: yDelta });
	
	          //incrementing only curVal in this case causes the next point
	          //to get assigned an erroneous distance
	          if (point[key] - curVal < targetDelta) {
	            i += 1;
	            if (point.ele !== undefined) prevPoint = point;
	          }
	          curVal += targetDelta;
	        } else {
	          if (point.ele !== undefined) prevPoint = point;
	
	          i += 1;
	        }
	      }
	      return pts;
	    },
	
	    smoothEles: function smoothEles() {
	      var tpsWithEle = [],
	          // everything we're doing here requires elevation, need to skip points without it
	      idxMap = [],
	          ySum = 0,
	          filterPoints,
	          // {x,y} objects required by the DJFilter
	      resampledPoints; // evenly spaced points (on x dimension)
	
	      // filter trackpoints to set that includes elevation, build id map to let us reference filtered array back to unfiltered
	      for (var i = 0; i < this._points.length; i++) {
	        if (Number.isFinite(this._points[i].ele)) {
	          idxMap[i] = tpsWithEle.length;
	          tpsWithEle.push(this._points[i]);
	        }
	      }
	
	      // abort early if there are no points with elevation.
	      if (tpsWithEle.length === 0) return { results: [], idxMap: idxMap };
	
	      //not all trips have lat/lng and distance, fallback to time if needed.
	      //get a resampled set of elevation/distance pairs with a standardized
	      //spacing of 20m or 2seconds. we use this dataset to determine the average
	      //elevation gain/loss from point to point in order to tune calculations.
	      if (this.hasDistance()) {
	        filterPoints = _.map(tpsWithEle, function (pt) {
	          return { x: pt.distance, y: pt.ele };
	        });
	        resampledPoints = this.resampleEles(tpsWithEle, 20, 'distance');
	      } else {
	        filterPoints = _.map(tpsWithEle, function (pt) {
	          return { x: pt.timeFromStart, y: pt.ele };
	        });
	        resampledPoints = this.resampleEles(tpsWithEle, 2, 'time');
	      }
	
	      _.each(resampledPoints, function (p) {
	        ySum += Math.pow(p.yDelta, 6);
	      });
	      var yDeltaAvg = Math.pow(ySum / resampledPoints.length, 1 / 6);
	
	      //magical tunable parameters
	      var minSmoothing = 10;
	      var maxSmoothing = 70;
	      var minYDeltaAvg = 0.05;
	      var maxYDeltaAvg = 8.0;
	      var smoothing = minSmoothing;
	
	      if (yDeltaAvg <= minYDeltaAvg) {
	        smoothing = minSmoothing;
	      } else if (yDeltaAvg >= maxYDeltaAvg) {
	        smoothing = maxSmoothing;
	      } else {
	        var avgDelta = yDeltaAvg - minYDeltaAvg;
	        var avgDeltaPercent = avgDelta / (maxYDeltaAvg - minYDeltaAvg);
	        smoothing = Math.round(minSmoothing + (maxSmoothing - minSmoothing) * avgDeltaPercent);
	      }
	
	      return {
	        results: new filter.DJFilter(filterPoints, smoothing).filter(),
	        idxMap: idxMap
	      };
	    },
	
	    /*
	     * Smooths out speed and grade
	     * TODO: needs reworking, since this is just the AS code...
	     */
	    calculateGradeAndSpeed: function calculateGradeAndSpeed() {
	      var d = this._data;
	      var points = this._points;
	      // get out of here if this has already been done
	      // the reason we're hinging this on speed instead of grade, is because when drawing a route
	      // we actually want to run this multiple times, but we continue smoothing from grade_orig
	      // to prevent oversmoothing
	      //
	      // when processing a trip, we really only need to run it once though. this might change
	      // when we allow editing of trips!
	      if (!points[0] || typeof points[0].speed_orig != "undefined") return;
	
	      var dist = 0;
	      var speedDists = [];
	      var speedIndexes = [];
	      var speeds = [];
	      var gradeDists = [];
	      var gradeIndexes = [];
	      var grades = [];
	
	      var hasSpeed = this.hasMetric("speed");
	      var hasGrade = this.hasMetric("grade");
	
	      var skipped = 0;
	
	      var i, prevPoint, point;
	      var j = 0,
	          k = 0;
	      for (i = 0; i < d.count; i++) {
	        prevPoint = point;
	        point = points[i];
	
	        if (i > 0) {
	          if (prevPoint.distance && point.distance) {
	            dist += point.distance - prevPoint.distance;
	          } else if (point.point && prevPoint.point) {
	            dist += point.distanceFromPoint(prevPoint);
	          }
	        }
	
	        if (hasSpeed) {
	          if (point.speed == null) {
	            // on points, speeds will be marked null to indicate invalid data.  These speeds will bring surrounding
	            // values they will be completely excluded from the averaging set.  Using indexes to map smooth speeds back
	            // onto the data.
	            speedIndexes.push(null);
	          } else {
	            speeds.push(point.speed);
	            speedDists.push(dist);
	            speedIndexes.push(j);
	
	            j++;
	          }
	        }
	        if (hasGrade) {
	          // when drawing a new route, this prevents successive runs from oversmoothing grade
	          if (isNaN(point.grade_orig)) {
	            skipped++;
	            gradeIndexes.push(null);
	          } else {
	            grades.push(point.grade_orig);
	            gradeDists.push(dist);
	            gradeIndexes.push(k);
	
	            k++;
	          }
	        }
	      }
	
	      var smoothSpeeds, smoothGrades, myfilter;
	
	      if (hasSpeed) {
	        myfilter = new filter.SincFilter(speedDists, speeds);
	        smoothSpeeds = myfilter.filter();
	        this.setMetric("speed", 'max', -50000);
	        this.setMetric("speed", 'min', 50000);
	      }
	
	      if (hasGrade) {
	        myfilter = new filter.LowPass(gradeDists, grades, 4.4);
	        smoothGrades = myfilter.filter();
	        this.setMetric("grade", 'max', -50000);
	        this.setMetric("grade", 'min', 50000);
	      }
	
	      var lastSpeed = null;
	      var lastGrade = null;
	      var gradesAssigned = 0;
	
	      for (i = 0; i < d.count; i++) {
	        point = points[i];
	
	        if (hasSpeed) {
	          if (point.speed_orig === undefined) {
	            point.speed_orig = point.speed;
	          }
	
	          if (speedIndexes[i] !== null) {
	            lastSpeed = smoothSpeeds[speedIndexes[i]];
	
	            if (!point.exclude) point.speed = lastSpeed;
	
	            if (lastSpeed > this.getMetric("speed", 'max')) {
	              this.setMetric("speed", 'max', lastSpeed, i);
	            }
	            if (lastSpeed < this.getMetric("speed", 'min')) this.setMetric("speed", 'min', lastSpeed, i);
	          } else {
	            point.speed = lastSpeed;
	          }
	        }
	
	        if (hasGrade) {
	          if (gradeIndexes[i] != null) {
	            gradesAssigned++;
	
	            lastGrade = smoothGrades[gradeIndexes[i]];
	            point.grade = lastGrade;
	
	            if (lastGrade > this.getMetric("grade", 'max')) {
	              this.setMetric("grade", 'max', lastGrade, i);
	            }
	
	            if (lastGrade < this.getMetric("grade", 'min')) {
	              this.setMetric("grade", 'min', lastGrade, i);
	            }
	          } else {
	            gradesAssigned++;
	            point.grade = lastGrade;
	          }
	        }
	      }
	    },
	
	    calculateNormalizedPower: function calculateNormalizedPower() {
	      var d = this._data;
	      var quads = [],
	          sum = 0,
	          i,
	          pow,
	          avg,
	          pt,
	          points = this._points;
	      for (i = 0; i < d.count; i++) {
	        pt = points[i];
	        if (pt.watts_ma_30 != null) quads.push(Math.pow(pt.watts_ma_30, 4));
	      }
	      for (i = 0; i < quads.length; i++) {
	        sum += quads[i];
	      }
	      avg = sum / quads.length;
	      pow = Math.pow(avg, 1 / 4.0);
	      this.setMetric("watts", "normalized", pow);
	      return pow;
	    },
	    average: function average(arr) {
	      var sum = 0;
	      for (var i = 0; i < arr.length; i++) {
	        sum += arr[i];
	      }
	      return sum / arr.length;
	    },
	    calculateBestEfforts: function calculateBestEfforts() {
	      // need power for best efforts
	      if (!this.hasPower()) return;
	      var d = this._data;
	      var bestEfforts = {};
	
	      var durations = [30, 60];
	      var points = this._points;
	      var effortsToFind = 4;
	
	      // gimme the index of the first point duration seconds before
	      // or after point i
	      function firstPoint(beforeOrAfter, i, duration) {
	        // assuming i have points...
	        var pt = points[i];
	        var goalTime, j, pct;
	        if (beforeOrAfter == 'after') {
	          goalTime = pt.time + duration;
	          j = i;
	          while (d.points(j + 1) && d.points(j).time <= goalTime) {
	            j++;
	          }
	          --j;
	          pct = (goalTime - d.points(j).time) / (d.points(j + 1).time - d.points(j).time);
	          return [j, pct];
	        } else {
	          goalTime = pt.time - duration;
	          j = i;
	          while (d.points(j - 1) && d.points(j) && d.points(j).time >= goalTime) {
	            j--;
	          }
	          pct = (goalTime - d.points(j).time) / (d.points(j + 1).time - d.points(j).time);
	          return [j, pct];
	        }
	      }
	
	      for (var i = 0; i < durations.length; i++) {
	        var duration = durations[i],
	            key = "watts_ma_" + duration;
	        var halfDuration = duration / 2;
	        // find effortsToFind best non-intersecting efforts
	        var sortedPoints = _.sortBy(_.select(points, function (p) {
	          return p && p[key];
	        }), function (p) {
	          return -p[key];
	        });
	        // all or nothing for now
	        if (sortedPoints.length >= effortsToFind) {
	          // ok snag the first one, woohoo its the best!
	          // need to grab duration/2 seconds to the left and right
	          bestEfforts[duration] = [];
	          var sortedPtIdx = 0;
	          var firstI = firstPoint('before', sortedPoints[0]._idx, halfDuration);
	          var lastI = firstPoint('after', sortedPoints[0]._idx, halfDuration);
	          bestEfforts[duration].push([firstI, lastI]);
	          sortedPtIdx++;
	          // alright find a few more
	          var toFind = effortsToFind - 1;
	          var i1, i2;
	          while (toFind > 0) {
	            i1 = firstPoint('before', sortedPoints[sortedPtIdx]._idx, halfDuration);
	            i2 = firstPoint('after', sortedPoints[sortedPtIdx]._idx, halfDuration);
	            // make sure there are no intersections with any previous
	            // best efforts
	            if (_.all(bestEfforts[duration], function (be) {
	              return i1[0] < be[0][0] && i2[0] < be[0][0] || i1[0] > be[1][0] && i2[0] > be[1][0];
	            })) {
	              firstI = i1;
	              lastI = i2;
	              bestEfforts[duration].push([firstI, lastI]);
	              toFind--;
	            }
	            sortedPtIdx++;
	          }
	        }
	      }
	      return bestEfforts;
	    },
	
	    calculateSpeedBuckets: function calculateSpeedBuckets() {
	      var metric = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      // Raw data is in km/h, convert to mph as needed
	      var speedScale = metric ? 1.0 : 0.621371;
	      var points = this._points;
	      var durations = {};
	      var gteDurations = {};
	      var gradeAvgs = {};
	      var counts = {};
	      var totalDuration = 0;
	
	      for (var i = 0; i < points.length; ++i) {
	        var point = points[i];
	
	        if (point.exclude) {
	          continue;
	        }
	
	        var speed = point.speed * speedScale;
	        var speedInt = Math.floor(speed);
	
	        // Average the duration between adjacent points and scale down to minutes instead of seconds
	        var prevPoint = points[i - 1];
	        var nextPoint = points[i + 1];
	        var t0 = (prevPoint && !prevPoint.exclude ? prevPoint : point).time;
	        var t1 = (nextPoint && !nextPoint.exclude ? nextPoint : point).time;
	        var duration = (t1 - t0) / (2.0 * 60);
	
	        // we dont allow points with >30s gaps to contribute to avg speed, so disregard them
	        if (duration > 0.5 || speedInt == 0) {
	          continue;
	        }
	
	        totalDuration += duration;
	
	        var prevCount = counts[speedInt] || 0;
	        var newCount = counts[speedInt] = prevCount + 1;
	        durations[speedInt] = (durations[speedInt] || 0) + duration;
	        gradeAvgs[speedInt] = ((gradeAvgs[speedInt] || 0) * prevCount + point.grade) / newCount;
	      }
	
	      var speeds = Object.keys(durations);
	      var minSpeed = Math.min.apply(Math, _toConsumableArray(speeds));
	      var maxSpeed = Math.max.apply(Math, _toConsumableArray(speeds));
	
	      for (var _speed = minSpeed; _speed <= maxSpeed; _speed++) {
	        // fill in any 0s
	        if (!durations[_speed]) {
	          durations[_speed] = 0;
	        }
	        if (!gradeAvgs[_speed]) {
	          gradeAvgs[_speed] = 0;
	        }
	
	        // store duration of >= each speed
	        gteDurations[_speed] = totalDuration;
	        totalDuration -= durations[_speed] || 0;
	      }
	
	      return {
	        durations: durations,
	        gradeAvgs: gradeAvgs,
	        gteDurations: gteDurations
	      };
	    },
	
	    hasSurface: function hasSurface() {
	      if (this._hasSurface === undefined) {
	        this._hasSurface = Object.keys(this.surfaces()).length > 0;
	      }
	      return this._hasSurface;
	    },
	
	    surfaces: function surfaces() {
	      if (this._surfaces === undefined) {
	        this._surfaces = this.calculateSurfaceTypes();
	      }
	      return this._surfaces;
	    },
	
	    calculateSurfaceTypes: function calculateSurfaceTypes() {
	      if (this._surfaces) {
	        return this._surfaces;
	      }
	
	      var points = this._points;
	      if (points.length === 0) {
	        return {};
	      }
	      var surfaces = {};
	
	      var excluding = false;
	      var lastDistance = 0;
	      var lastSurface = "" + points[0].surface; // smh string keys
	      var hasSurface = true;
	      points.forEach(function (pt, idx) {
	        if (pt.surface !== undefined) {
	          // add pt distance to collector if surface changes
	          var lastPt = points[idx - 1];
	          var thisSurface = "" + pt.surface;
	          if (idx > 0 && !lastPt.excludeFromMetrics && pt.excludeFromMetrics) {
	            // entering an excludeFromMetrics zone, don't count distances until we're including in metrics again
	            excluding = true;
	            if (Object.keys(surfaces).indexOf(lastSurface) === -1) {
	              surfaces[lastSurface] = 0;
	            }
	
	            surfaces[lastSurface] += pt.distance - lastDistance;
	          } else if (idx > 0 && lastPt.excludeFromMetrics && !pt.excludeFromMetrics) {
	            // leaving an excludeFromMetrics zone, set up to count the next surface change
	            excluding = false;
	            lastDistance = points[idx - 1].distance;
	            lastSurface = thisSurface;
	          } else if (!excluding && thisSurface !== lastSurface) {
	            // surface changed! add the distance from the last change to the last surface aggregator
	            if (Object.keys(surfaces).indexOf(lastSurface) === -1) {
	              surfaces[lastSurface] = 0;
	            }
	
	            surfaces[lastSurface] = surfaces[lastSurface] + (lastPt.distance - lastDistance);
	            lastDistance = lastPt.distance;
	            lastSurface = thisSurface;
	          }
	        } else {
	          // if ANY tp has surface === undefined, infer that this route was
	          // created before st, so we won't show any st in the planner or in
	          // the trsp
	          hasSurface = false;
	        }
	      });
	
	      // do it one more time for the last point
	      var veryLastPt = points[points.length - 1];
	      var veryLastSurface = "" + veryLastPt.surface;
	      if (veryLastSurface !== 'undefined' && !excluding) {
	        if (Object.keys(surfaces).indexOf(veryLastSurface) === -1) {
	          surfaces[veryLastSurface] = 0;
	        }
	        surfaces[veryLastSurface] += veryLastPt.distance - lastDistance;
	      }
	      if (Object.keys(surfaces).length > 0 && hasSurface) {
	        surfaces._max = true; // appease this.hasMetric
	      }
	
	      this._surfaces = surfaces;
	      return surfaces;
	    }
	  };
	
	  module.exports = MetricsCalculator;
	})();

/***/ }),
/* 79 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Unobtrusive scripting adapter for jQuery
	 *
	 * Requires jQuery 1.4.3 or later.
	 * https://github.com/rails/jquery-ujs
	 */
	
	(function ($) {
	    var _allowAction;
	    // Make sure that every Ajax request sends the CSRF token
	    function CSRFProtection(fn) {
	        if (!$.ajaxSettings.stopCSRF) {
	            var token = $('meta[name="csrf-token"]').attr('content');
	            if (token) fn(function (xhr) {
	                xhr.setRequestHeader('X-CSRF-Token', token);
	            });
	        }
	    }
	    if ($().jquery == '1.5') {
	        // gruesome hack
	        var factory = $.ajaxSettings.xhr;
	        $.ajaxSettings.xhr = function () {
	            var xhr = factory();
	            CSRFProtection(function (setHeader) {
	                var open = xhr.open;
	                xhr.open = function () {
	                    open.apply(this, arguments);setHeader(this);
	                };
	            });
	            return xhr;
	        };
	    } else $(document).ajaxSend(function (e, xhr) {
	        CSRFProtection(function (setHeader) {
	            setHeader(xhr);
	        });
	    });
	
	    // Triggers an event on an element and returns the event result
	    function fire(obj, name, data) {
	        var event = new $.Event(name);
	        obj.trigger(event, data);
	        return event.result !== false;
	    }
	
	    // Submits "remote" forms and links with ajax
	    function handleRemote(element) {
	        var method,
	            url,
	            data,
	            dataType = element.attr('data-type') || $.ajaxSettings && $.ajaxSettings.dataType;
	
	        if (element.is('form')) {
	            method = element.attr('method');
	            url = element.attr('action');
	            data = element.serializeArray();
	            // memoized value from clicked submit button
	            var button = element.data('ujs:submit-button');
	            if (button) {
	                data.push(button);
	                element.data('ujs:submit-button', null);
	            }
	        } else {
	            method = element.attr('data-method');
	            url = element.attr('href');
	            data = null;
	        }
	
	        $.ajax({
	            url: url, type: method || 'GET', data: data, dataType: dataType,
	            // stopping the "ajax:beforeSend" event will cancel the ajax request
	            beforeSend: function beforeSend(xhr, settings) {
	                if (settings.dataType === undefined) {
	                    xhr.setRequestHeader('accept', '*/*;q=0.5, ' + settings.accepts.script);
	                }
	                return fire(element, 'ajax:beforeSend', [xhr, settings]);
	            },
	            success: function success(data, status, xhr) {
	                element.trigger('ajax:success', [data, status, xhr]);
	            },
	            complete: function complete(xhr, status) {
	                element.trigger('ajax:complete', [xhr, status]);
	            },
	            error: function error(xhr, status, _error) {
	                element.trigger('ajax:error', [xhr, status, _error]);
	            }
	        });
	    }
	
	    // Handles "data-method" on links such as:
	    // <a href="/users/5" data-method="delete" rel="nofollow" data-confirm="Are you sure?">Delete</a>
	    function handleMethod(link) {
	        var href = link.attr('href'),
	            method = link.attr('data-method'),
	            csrf_token = $('meta[name=csrf-token]').attr('content'),
	            csrf_param = $('meta[name=csrf-param]').attr('content'),
	            form = $('<form method="post" action="' + href + '"></form>'),
	            metadata_input = '<input name="_method" value="' + method + '" type="hidden" />';
	
	        if (csrf_param !== undefined && csrf_token !== undefined) {
	            metadata_input += '<input name="' + csrf_param + '" value="' + csrf_token + '" type="hidden" />';
	        }
	
	        form.hide().append(metadata_input).appendTo('body');
	        form.submit();
	    }
	
	    function disableFormElements(form) {
	        form.find('input[data-disable-with]').each(function () {
	            var input = $(this);
	            input.data('ujs:enable-with', input.val()).val(input.attr('data-disable-with')).attr('disabled', 'disabled');
	        });
	    }
	
	    function enableFormElements(form) {
	        form.find('input[data-disable-with]').each(function () {
	            var input = $(this);
	            input.val(input.data('ujs:enable-with')).removeAttr('disabled');
	        });
	    }
	
	    _allowAction = function allowAction(element) {
	        var message = element.data('confirm'),
	            answer = false,
	            callback;
	        if (!message) {
	            return true;
	        }
	
	        if (fire(element, 'confirm')) {
	            customConfirm(message, function () {
	                callback = fire(element, 'confirm:complete', [answer]);
	                if (callback) {
	                    var oldAllowAction = _allowAction;
	                    _allowAction = function allowAction() {
	                        return true;
	                    };
	                    element.trigger('click');
	                    _allowAction = oldAllowAction;
	                }
	            });
	        }
	        return false;
	    };
	
	    function requiredValuesMissing(form) {
	        var missing = false;
	        form.find('input[name][required]').each(function () {
	            if (!$(this).val()) missing = true;
	        });
	        return missing;
	    }
	
	    $(document).on('click.rails', 'a[data-confirm], a[data-method], a[data-remote]', function () {
	        var link = $(this);
	        if (!_allowAction(link)) return false;
	
	        if (link.attr('data-remote') != undefined) {
	            handleRemote(link);
	            return false;
	        } else if (link.attr('data-method')) {
	            handleMethod(link);
	            return false;
	        }
	    });
	
	    $(document).on('submit.rails', 'form', function () {
	        var form = $(this),
	            remote = form.attr('data-remote') != undefined;
	        if (!_allowAction(form)) return false;
	
	        // skip other logic when required values are missing
	        if (requiredValuesMissing(form)) return !remote;
	
	        if (remote) {
	            handleRemote(form);
	            return false;
	        } else {
	            // slight timeout so that the submit button gets properly serialized
	            setTimeout(function () {
	                disableFormElements(form);
	            }, 13);
	        }
	    });
	
	    $(document).on('click.rails', 'form input[type=submit], form button[type=submit], form button:not([type])', function () {
	        var button = $(this);
	        if (!_allowAction(button)) return false;
	        // register the pressed submit button
	        var name = button.attr('name'),
	            data = name ? { name: name, value: button.val() } : null;
	        button.closest('form').data('ujs:submit-button', data);
	    });
	
	    $(document).on('ajax:beforeSend.rails', 'form', function (event) {
	        if (this == event.target) disableFormElements($(this));
	    });
	
	    $(document).on('ajax:complete.rails', 'form', function (event) {
	        if (this == event.target) enableFormElements($(this));
	    });
	})(jQuery);

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["$"] = __webpack_require__(211);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["Backbone"] = __webpack_require__(215);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["CommunicatorDetector"] = __webpack_require__(91);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["T"] = __webpack_require__(207);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["_"] = __webpack_require__(234);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 85 */
/***/ (function(module, exports) {

	/*!
	 * jQuery Migrate - v1.3.0 - 2016-01-13
	 * Copyright jQuery Foundation and other contributors
	 */
	(function( jQuery, window, undefined ) {
	// See http://bugs.jquery.com/ticket/13335
	// "use strict";
	
	
	jQuery.migrateVersion = "1.3.0";
	
	
	var warnedAbout = {};
	
	// List of warnings already given; public read only
	jQuery.migrateWarnings = [];
	
	// Set to true to prevent console output; migrateWarnings still maintained
	// jQuery.migrateMute = false;
	
	// Show a message on the console so devs know we're active
	if ( !jQuery.migrateMute && window.console && window.console.log ) {
		window.console.log("JQMIGRATE: Logging is active");
	}
	
	// Set to false to disable traces that appear with warnings
	if ( jQuery.migrateTrace === undefined ) {
		jQuery.migrateTrace = true;
	}
	
	// Forget any warnings we've already given; public
	jQuery.migrateReset = function() {
		warnedAbout = {};
		jQuery.migrateWarnings.length = 0;
	};
	
	function migrateWarn( msg) {
		var console = window.console;
		if ( !warnedAbout[ msg ] ) {
			warnedAbout[ msg ] = true;
			jQuery.migrateWarnings.push( msg );
			if ( console && console.warn && !jQuery.migrateMute ) {
				console.warn( "JQMIGRATE: " + msg );
				if ( jQuery.migrateTrace && console.trace ) {
					console.trace();
				}
			}
		}
	}
	
	function migrateWarnProp( obj, prop, value, msg ) {
		if ( Object.defineProperty ) {
			// On ES5 browsers (non-oldIE), warn if the code tries to get prop;
			// allow property to be overwritten in case some other plugin wants it
			try {
				Object.defineProperty( obj, prop, {
					configurable: true,
					enumerable: true,
					get: function() {
						migrateWarn( msg );
						return value;
					},
					set: function( newValue ) {
						migrateWarn( msg );
						value = newValue;
					}
				});
				return;
			} catch( err ) {
				// IE8 is a dope about Object.defineProperty, can't warn there
			}
		}
	
		// Non-ES5 (or broken) browser; just set the property
		jQuery._definePropertyBroken = true;
		obj[ prop ] = value;
	}
	
	if ( document.compatMode === "BackCompat" ) {
		// jQuery has never supported or tested Quirks Mode
		migrateWarn( "jQuery is not compatible with Quirks Mode" );
	}
	
	
	var attrFn = jQuery( "<input/>", { size: 1 } ).attr("size") && jQuery.attrFn,
		oldAttr = jQuery.attr,
		valueAttrGet = jQuery.attrHooks.value && jQuery.attrHooks.value.get ||
			function() { return null; },
		valueAttrSet = jQuery.attrHooks.value && jQuery.attrHooks.value.set ||
			function() { return undefined; },
		rnoType = /^(?:input|button)$/i,
		rnoAttrNodeType = /^[238]$/,
		rboolean = /^(?:autofocus|autoplay|async|checked|controls|defer|disabled|hidden|loop|multiple|open|readonly|required|scoped|selected)$/i,
		ruseDefault = /^(?:checked|selected)$/i;
	
	// jQuery.attrFn
	migrateWarnProp( jQuery, "attrFn", attrFn || {}, "jQuery.attrFn is deprecated" );
	
	jQuery.attr = function( elem, name, value, pass ) {
		var lowerName = name.toLowerCase(),
			nType = elem && elem.nodeType;
	
		if ( pass ) {
			// Since pass is used internally, we only warn for new jQuery
			// versions where there isn't a pass arg in the formal params
			if ( oldAttr.length < 4 ) {
				migrateWarn("jQuery.fn.attr( props, pass ) is deprecated");
			}
			if ( elem && !rnoAttrNodeType.test( nType ) &&
				(attrFn ? name in attrFn : jQuery.isFunction(jQuery.fn[name])) ) {
				return jQuery( elem )[ name ]( value );
			}
		}
	
		// Warn if user tries to set `type`, since it breaks on IE 6/7/8; by checking
		// for disconnected elements we don't warn on $( "<button>", { type: "button" } ).
		if ( name === "type" && value !== undefined && rnoType.test( elem.nodeName ) && elem.parentNode ) {
			migrateWarn("Can't change the 'type' of an input or button in IE 6/7/8");
		}
	
		// Restore boolHook for boolean property/attribute synchronization
		if ( !jQuery.attrHooks[ lowerName ] && rboolean.test( lowerName ) ) {
			jQuery.attrHooks[ lowerName ] = {
				get: function( elem, name ) {
					// Align boolean attributes with corresponding properties
					// Fall back to attribute presence where some booleans are not supported
					var attrNode,
						property = jQuery.prop( elem, name );
					return property === true || typeof property !== "boolean" &&
						( attrNode = elem.getAttributeNode(name) ) && attrNode.nodeValue !== false ?
	
						name.toLowerCase() :
						undefined;
				},
				set: function( elem, value, name ) {
					var propName;
					if ( value === false ) {
						// Remove boolean attributes when set to false
						jQuery.removeAttr( elem, name );
					} else {
						// value is true since we know at this point it's type boolean and not false
						// Set boolean attributes to the same name and set the DOM property
						propName = jQuery.propFix[ name ] || name;
						if ( propName in elem ) {
							// Only set the IDL specifically if it already exists on the element
							elem[ propName ] = true;
						}
	
						elem.setAttribute( name, name.toLowerCase() );
					}
					return name;
				}
			};
	
			// Warn only for attributes that can remain distinct from their properties post-1.9
			if ( ruseDefault.test( lowerName ) ) {
				migrateWarn( "jQuery.fn.attr('" + lowerName + "') might use property instead of attribute" );
			}
		}
	
		return oldAttr.call( jQuery, elem, name, value );
	};
	
	// attrHooks: value
	jQuery.attrHooks.value = {
		get: function( elem, name ) {
			var nodeName = ( elem.nodeName || "" ).toLowerCase();
			if ( nodeName === "button" ) {
				return valueAttrGet.apply( this, arguments );
			}
			if ( nodeName !== "input" && nodeName !== "option" ) {
				migrateWarn("jQuery.fn.attr('value') no longer gets properties");
			}
			return name in elem ?
				elem.value :
				null;
		},
		set: function( elem, value ) {
			var nodeName = ( elem.nodeName || "" ).toLowerCase();
			if ( nodeName === "button" ) {
				return valueAttrSet.apply( this, arguments );
			}
			if ( nodeName !== "input" && nodeName !== "option" ) {
				migrateWarn("jQuery.fn.attr('value', val) no longer sets properties");
			}
			// Does not return so that setAttribute is also used
			elem.value = value;
		}
	};
	
	
	var matched, browser,
		oldInit = jQuery.fn.init,
		oldParseJSON = jQuery.parseJSON,
		rspaceAngle = /^\s*</,
		// Note: XSS check is done below after string is trimmed
		rquickExpr = /^([^<]*)(<[\w\W]+>)([^>]*)$/;
	
	// $(html) "looks like html" rule change
	jQuery.fn.init = function( selector, context, rootjQuery ) {
		var match, ret;
	
		if ( selector && typeof selector === "string" && !jQuery.isPlainObject( context ) &&
				(match = rquickExpr.exec( jQuery.trim( selector ) )) && match[ 0 ] ) {
			// This is an HTML string according to the "old" rules; is it still?
			if ( !rspaceAngle.test( selector ) ) {
				migrateWarn("$(html) HTML strings must start with '<' character");
			}
			if ( match[ 3 ] ) {
				migrateWarn("$(html) HTML text after last tag is ignored");
			}
	
			// Consistently reject any HTML-like string starting with a hash (#9521)
			// Note that this may break jQuery 1.6.x code that otherwise would work.
			if ( match[ 0 ].charAt( 0 ) === "#" ) {
				migrateWarn("HTML string cannot start with a '#' character");
				jQuery.error("JQMIGRATE: Invalid selector string (XSS)");
			}
			// Now process using loose rules; let pre-1.8 play too
			if ( context && context.context ) {
				// jQuery object as context; parseHTML expects a DOM object
				context = context.context;
			}
			if ( jQuery.parseHTML ) {
				return oldInit.call( this,
						jQuery.parseHTML( match[ 2 ], context && context.ownerDocument ||
							context || document, true ), context, rootjQuery );
			}
		}
	
		// jQuery( "#" ) is a bogus ID selector, but it returned an empty set before jQuery 3.0
		if ( selector === "#" ) {
			migrateWarn( "jQuery( '#' ) is not a valid selector" );
			selector = [];
		}
	
		ret = oldInit.apply( this, arguments );
	
		// Fill in selector and context properties so .live() works
		if ( selector && selector.selector !== undefined ) {
			// A jQuery object, copy its properties
			ret.selector = selector.selector;
			ret.context = selector.context;
	
		} else {
			ret.selector = typeof selector === "string" ? selector : "";
			if ( selector ) {
				ret.context = selector.nodeType? selector : context || document;
			}
		}
	
		return ret;
	};
	jQuery.fn.init.prototype = jQuery.fn;
	
	// Let $.parseJSON(falsy_value) return null
	jQuery.parseJSON = function( json ) {
		if ( !json ) {
			migrateWarn("jQuery.parseJSON requires a valid JSON string");
			return null;
		}
		return oldParseJSON.apply( this, arguments );
	};
	
	jQuery.uaMatch = function( ua ) {
		ua = ua.toLowerCase();
	
		var match = /(chrome)[ \/]([\w.]+)/.exec( ua ) ||
			/(webkit)[ \/]([\w.]+)/.exec( ua ) ||
			/(opera)(?:.*version|)[ \/]([\w.]+)/.exec( ua ) ||
			/(msie) ([\w.]+)/.exec( ua ) ||
			ua.indexOf("compatible") < 0 && /(mozilla)(?:.*? rv:([\w.]+)|)/.exec( ua ) ||
			[];
	
		return {
			browser: match[ 1 ] || "",
			version: match[ 2 ] || "0"
		};
	};
	
	// Don't clobber any existing jQuery.browser in case it's different
	if ( !jQuery.browser ) {
		matched = jQuery.uaMatch( navigator.userAgent );
		browser = {};
	
		if ( matched.browser ) {
			browser[ matched.browser ] = true;
			browser.version = matched.version;
		}
	
		// Chrome is Webkit, but Webkit is also Safari.
		if ( browser.chrome ) {
			browser.webkit = true;
		} else if ( browser.webkit ) {
			browser.safari = true;
		}
	
		jQuery.browser = browser;
	}
	
	// Warn if the code tries to get jQuery.browser
	migrateWarnProp( jQuery, "browser", jQuery.browser, "jQuery.browser is deprecated" );
	
	// jQuery.boxModel deprecated in 1.3, jQuery.support.boxModel deprecated in 1.7
	jQuery.boxModel = jQuery.support.boxModel = (document.compatMode === "CSS1Compat");
	migrateWarnProp( jQuery, "boxModel", jQuery.boxModel, "jQuery.boxModel is deprecated" );
	migrateWarnProp( jQuery.support, "boxModel", jQuery.support.boxModel, "jQuery.support.boxModel is deprecated" );
	
	jQuery.sub = function() {
		function jQuerySub( selector, context ) {
			return new jQuerySub.fn.init( selector, context );
		}
		jQuery.extend( true, jQuerySub, this );
		jQuerySub.superclass = this;
		jQuerySub.fn = jQuerySub.prototype = this();
		jQuerySub.fn.constructor = jQuerySub;
		jQuerySub.sub = this.sub;
		jQuerySub.fn.init = function init( selector, context ) {
			var instance = jQuery.fn.init.call( this, selector, context, rootjQuerySub );
			return instance instanceof jQuerySub ?
				instance :
				jQuerySub( instance );
		};
		jQuerySub.fn.init.prototype = jQuerySub.fn;
		var rootjQuerySub = jQuerySub(document);
		migrateWarn( "jQuery.sub() is deprecated" );
		return jQuerySub;
	};
	
	// The number of elements contained in the matched element set
	jQuery.fn.size = function() {
		migrateWarn( "jQuery.fn.size() is deprecated; use the .length property" );
		return this.length;
	};
	
	
	var internalSwapCall = false;
	
	// If this version of jQuery has .swap(), don't false-alarm on internal uses
	if ( jQuery.swap ) {
		jQuery.each( [ "height", "width", "reliableMarginRight" ], function( _, name ) {
			var oldHook = jQuery.cssHooks[ name ] && jQuery.cssHooks[ name ].get;
	
			if ( oldHook ) {
				jQuery.cssHooks[ name ].get = function() {
					var ret;
	
					internalSwapCall = true;
					ret = oldHook.apply( this, arguments );
					internalSwapCall = false;
					return ret;
				};
			}
		});
	}
	
	jQuery.swap = function( elem, options, callback, args ) {
		var ret, name,
			old = {};
	
		if ( !internalSwapCall ) {
			migrateWarn( "jQuery.swap() is undocumented and deprecated" );
		}
	
		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}
	
		ret = callback.apply( elem, args || [] );
	
		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}
	
		return ret;
	};
	
	
	// Ensure that $.ajax gets the new parseJSON defined in core.js
	jQuery.ajaxSetup({
		converters: {
			"text json": jQuery.parseJSON
		}
	});
	
	
	var oldFnData = jQuery.fn.data;
	
	jQuery.fn.data = function( name ) {
		var ret, evt,
			elem = this[0];
	
		// Handles 1.7 which has this behavior and 1.8 which doesn't
		if ( elem && name === "events" && arguments.length === 1 ) {
			ret = jQuery.data( elem, name );
			evt = jQuery._data( elem, name );
			if ( ( ret === undefined || ret === evt ) && evt !== undefined ) {
				migrateWarn("Use of jQuery.fn.data('events') is deprecated");
				return evt;
			}
		}
		return oldFnData.apply( this, arguments );
	};
	
	
	var rscriptType = /\/(java|ecma)script/i;
	
	// Since jQuery.clean is used internally on older versions, we only shim if it's missing
	if ( !jQuery.clean ) {
		jQuery.clean = function( elems, context, fragment, scripts ) {
			// Set context per 1.8 logic
			context = context || document;
			context = !context.nodeType && context[0] || context;
			context = context.ownerDocument || context;
	
			migrateWarn("jQuery.clean() is deprecated");
	
			var i, elem, handleScript, jsTags,
				ret = [];
	
			jQuery.merge( ret, jQuery.buildFragment( elems, context ).childNodes );
	
			// Complex logic lifted directly from jQuery 1.8
			if ( fragment ) {
				// Special handling of each script element
				handleScript = function( elem ) {
					// Check if we consider it executable
					if ( !elem.type || rscriptType.test( elem.type ) ) {
						// Detach the script and store it in the scripts array (if provided) or the fragment
						// Return truthy to indicate that it has been handled
						return scripts ?
							scripts.push( elem.parentNode ? elem.parentNode.removeChild( elem ) : elem ) :
							fragment.appendChild( elem );
					}
				};
	
				for ( i = 0; (elem = ret[i]) != null; i++ ) {
					// Check if we're done after handling an executable script
					if ( !( jQuery.nodeName( elem, "script" ) && handleScript( elem ) ) ) {
						// Append to fragment and handle embedded scripts
						fragment.appendChild( elem );
						if ( typeof elem.getElementsByTagName !== "undefined" ) {
							// handleScript alters the DOM, so use jQuery.merge to ensure snapshot iteration
							jsTags = jQuery.grep( jQuery.merge( [], elem.getElementsByTagName("script") ), handleScript );
	
							// Splice the scripts into ret after their former ancestor and advance our index beyond them
							ret.splice.apply( ret, [i + 1, 0].concat( jsTags ) );
							i += jsTags.length;
						}
					}
				}
			}
	
			return ret;
		};
	}
	
	var eventAdd = jQuery.event.add,
		eventRemove = jQuery.event.remove,
		eventTrigger = jQuery.event.trigger,
		oldToggle = jQuery.fn.toggle,
		oldLive = jQuery.fn.live,
		oldDie = jQuery.fn.die,
		oldLoad = jQuery.fn.load,
		ajaxEvents = "ajaxStart|ajaxStop|ajaxSend|ajaxComplete|ajaxError|ajaxSuccess",
		rajaxEvent = new RegExp( "\\b(?:" + ajaxEvents + ")\\b" ),
		rhoverHack = /(?:^|\s)hover(\.\S+|)\b/,
		hoverHack = function( events ) {
			if ( typeof( events ) !== "string" || jQuery.event.special.hover ) {
				return events;
			}
			if ( rhoverHack.test( events ) ) {
				migrateWarn("'hover' pseudo-event is deprecated, use 'mouseenter mouseleave'");
			}
			return events && events.replace( rhoverHack, "mouseenter$1 mouseleave$1" );
		};
	
	// Event props removed in 1.9, put them back if needed; no practical way to warn them
	if ( jQuery.event.props && jQuery.event.props[ 0 ] !== "attrChange" ) {
		jQuery.event.props.unshift( "attrChange", "attrName", "relatedNode", "srcElement" );
	}
	
	// Undocumented jQuery.event.handle was "deprecated" in jQuery 1.7
	if ( jQuery.event.dispatch ) {
		migrateWarnProp( jQuery.event, "handle", jQuery.event.dispatch, "jQuery.event.handle is undocumented and deprecated" );
	}
	
	// Support for 'hover' pseudo-event and ajax event warnings
	jQuery.event.add = function( elem, types, handler, data, selector ){
		if ( elem !== document && rajaxEvent.test( types ) ) {
			migrateWarn( "AJAX events should be attached to document: " + types );
		}
		eventAdd.call( this, elem, hoverHack( types || "" ), handler, data, selector );
	};
	jQuery.event.remove = function( elem, types, handler, selector, mappedTypes ){
		eventRemove.call( this, elem, hoverHack( types ) || "", handler, selector, mappedTypes );
	};
	
	jQuery.each( [ "load", "unload", "error" ], function( _, name ) {
	
		jQuery.fn[ name ] = function() {
			var args = Array.prototype.slice.call( arguments, 0 );
			migrateWarn( "jQuery.fn." + name + "() is deprecated" );
	
			// If this is an ajax load() the first arg should be the string URL;
			// technically this could also be the "Anything" arg of the event .load()
			// which just goes to show why this dumb signature has been deprecated!
			// jQuery custom builds that exclude the Ajax module justifiably die here.
			if ( name === "load" && typeof arguments[ 0 ] === "string" ) {
				return oldLoad.apply( this, arguments );
			}
	
			args.splice( 0, 0, name );
			if ( arguments.length ) {
				return this.bind.apply( this, args );
			}
	
			// Use .triggerHandler here because:
			// - load and unload events don't need to bubble, only applied to window or image
			// - error event should not bubble to window, although it does pre-1.7
			// See http://bugs.jquery.com/ticket/11820
			this.triggerHandler.apply( this, args );
			return this;
		};
	
	});
	
	jQuery.fn.toggle = function( fn, fn2 ) {
	
		// Don't mess with animation or css toggles
		if ( !jQuery.isFunction( fn ) || !jQuery.isFunction( fn2 ) ) {
			return oldToggle.apply( this, arguments );
		}
		migrateWarn("jQuery.fn.toggle(handler, handler...) is deprecated");
	
		// Save reference to arguments for access in closure
		var args = arguments,
			guid = fn.guid || jQuery.guid++,
			i = 0,
			toggler = function( event ) {
				// Figure out which function to execute
				var lastToggle = ( jQuery._data( this, "lastToggle" + fn.guid ) || 0 ) % i;
				jQuery._data( this, "lastToggle" + fn.guid, lastToggle + 1 );
	
				// Make sure that clicks stop
				event.preventDefault();
	
				// and execute the function
				return args[ lastToggle ].apply( this, arguments ) || false;
			};
	
		// link all the functions, so any of them can unbind this click handler
		toggler.guid = guid;
		while ( i < args.length ) {
			args[ i++ ].guid = guid;
		}
	
		return this.click( toggler );
	};
	
	jQuery.fn.live = function( types, data, fn ) {
		migrateWarn("jQuery.fn.live() is deprecated");
		if ( oldLive ) {
			return oldLive.apply( this, arguments );
		}
		jQuery( this.context ).on( types, this.selector, data, fn );
		return this;
	};
	
	jQuery.fn.die = function( types, fn ) {
		migrateWarn("jQuery.fn.die() is deprecated");
		if ( oldDie ) {
			return oldDie.apply( this, arguments );
		}
		jQuery( this.context ).off( types, this.selector || "**", fn );
		return this;
	};
	
	// Turn global events into document-triggered events
	jQuery.event.trigger = function( event, data, elem, onlyHandlers  ){
		if ( !elem && !rajaxEvent.test( event ) ) {
			migrateWarn( "Global events are undocumented and deprecated" );
		}
		return eventTrigger.call( this,  event, data, elem || document, onlyHandlers  );
	};
	jQuery.each( ajaxEvents.split("|"),
		function( _, name ) {
			jQuery.event.special[ name ] = {
				setup: function() {
					var elem = this;
	
					// The document needs no shimming; must be !== for oldIE
					if ( elem !== document ) {
						jQuery.event.add( document, name + "." + jQuery.guid, function() {
							jQuery.event.trigger( name, Array.prototype.slice.call( arguments, 1 ), elem, true );
						});
						jQuery._data( this, name, jQuery.guid++ );
					}
					return false;
				},
				teardown: function() {
					if ( this !== document ) {
						jQuery.event.remove( document, name + "." + jQuery._data( this, name ) );
					}
					return false;
				}
			};
		}
	);
	
	jQuery.event.special.ready = {
		setup: function() { migrateWarn( "'ready' event is deprecated" ); }
	};
	
	var oldSelf = jQuery.fn.andSelf || jQuery.fn.addBack,
		oldFind = jQuery.fn.find;
	
	jQuery.fn.andSelf = function() {
		migrateWarn("jQuery.fn.andSelf() replaced by jQuery.fn.addBack()");
		return oldSelf.apply( this, arguments );
	};
	
	jQuery.fn.find = function( selector ) {
		var ret = oldFind.apply( this, arguments );
		ret.context = this.context;
		ret.selector = this.selector ? this.selector + " " + selector : selector;
		return ret;
	};
	
	
	// jQuery 1.6 did not support Callbacks, do not warn there
	if ( jQuery.Callbacks ) {
	
		var oldDeferred = jQuery.Deferred,
			tuples = [
				// action, add listener, callbacks, .then handlers, final state
				[ "resolve", "done", jQuery.Callbacks("once memory"),
					jQuery.Callbacks("once memory"), "resolved" ],
				[ "reject", "fail", jQuery.Callbacks("once memory"),
					jQuery.Callbacks("once memory"), "rejected" ],
				[ "notify", "progress", jQuery.Callbacks("memory"),
					jQuery.Callbacks("memory") ]
			];
	
		jQuery.Deferred = function( func ) {
			var deferred = oldDeferred(),
				promise = deferred.promise();
	
			deferred.pipe = promise.pipe = function( /* fnDone, fnFail, fnProgress */ ) {
				var fns = arguments;
	
				migrateWarn( "deferred.pipe() is deprecated" );
	
				return jQuery.Deferred(function( newDefer ) {
					jQuery.each( tuples, function( i, tuple ) {
						var fn = jQuery.isFunction( fns[ i ] ) && fns[ i ];
						// deferred.done(function() { bind to newDefer or newDefer.resolve })
						// deferred.fail(function() { bind to newDefer or newDefer.reject })
						// deferred.progress(function() { bind to newDefer or newDefer.notify })
						deferred[ tuple[1] ](function() {
							var returned = fn && fn.apply( this, arguments );
							if ( returned && jQuery.isFunction( returned.promise ) ) {
								returned.promise()
									.done( newDefer.resolve )
									.fail( newDefer.reject )
									.progress( newDefer.notify );
							} else {
								newDefer[ tuple[ 0 ] + "With" ](
									this === promise ? newDefer.promise() : this,
									fn ? [ returned ] : arguments
								);
							}
						});
					});
					fns = null;
				}).promise();
	
			};
	
			deferred.isResolved = function() {
				migrateWarn( "deferred.isResolved is deprecated" );
				return deferred.state() === "resolved";
			};
	
			deferred.isRejected = function() {
				migrateWarn( "deferred.isRejected is deprecated" );
				return deferred.state() === "rejected";
			};
	
			if ( func ) {
				func.call( deferred, deferred );
			}
	
			return deferred;
		};
	
	}
	
	})( jQuery, window );


/***/ }),
/* 86 */,
/* 87 */,
/* 88 */
/***/ (function(module, exports) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var Translations = {
	  translations: {},
	  load: function load(trans) {
	    this.translations = this.translations || {};
	    for (var attr in trans) {
	      this.translations[attr] = trans[attr];
	    }
	  },
	  t: function t(key, interp) {
	    var t = this.translations[key];
	    if (interp === undefined) return t;
	    if (typeof t == "string") return this.interpolate(t, interp);
	    if ((typeof t === "undefined" ? "undefined" : _typeof(t)) == "object" && interp && interp.count !== undefined) {
	      //nested object, so it's a plural key with zero|one|other keys...
	      //this is kinda a ghetto assumption, but it's easy
	      if (interp.count == 0 && t.zero) return this.interpolate(t.zero, interp);else if (interp.count == 1) return this.interpolate(t.one, interp);else return this.interpolate(t.other, interp);
	    }
	    return key;
	  },
	  interpolate: function interpolate(str, obj) {
	    return str.replace(/%{([^%{}]*)}/g, function (a, b) {
	      var r = obj[b];
	      return typeof r === 'string' || typeof r === 'number' ? r : a;
	    });
	  },
	  needsPlural: function needsPlural(options) {
	    //relies on checking for interpolation key 'count' - won't work
	    //if the interpolation key is anything else...kinda ghetto
	    return options.count && typeof options.count != 'string' && options.count > 1;
	  }
	};
	
	if (typeof module !== 'undefined' && module.exports) {
	  module.exports = Translations;
	}
	
	if (window.translationsToLoad) {
	  Translations.load(window.translationsToLoad);
	}

/***/ }),
/* 89 */,
/* 90 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	  init: function init(selector) {
	    this.selector = selector;
	    this.$container = $(selector);
	    var that = this;
	
	    this.$container.find('.comment_form').submit(function () {
	      var commentText = that.$container.find('.new_comment').val();
	
	      if (commentText != '') {
	        $(this).ajaxSubmit({
	          dataType: 'json',
	          beforeSubmit: function beforeSubmit() {
	            $.prettyLoader.show();
	          },
	          success: function success(response_data) {
	            if (response_data.status > 0) {
	              var res = $(response_data.new_comment).hide();
	              that.$container.find('.comments').append(res);
	              res.slideDown();
	              that.$container.find('.new_comment').val('').blur();
	            } else {
	              $.jGrowl(response_data.message);
	            }
	            $.prettyLoader.hide();
	          },
	          error: function error(request, txt_status, _error) {
	            $.jGrowl(txt_status + ", " + _error + '.  Contact us if this problem persists');
	            $.prettyLoader.hide();
	          }
	        });
	      }
	      return false;
	    });
	
	    this.$container.on('click', 'a.delete-comment', function () {
	      var el = this;
	      customConfirm("Are you sure you want to delete this comment?", function () {
	        that.destroy($(el));
	      });
	    });
	  },
	
	  destroy: function destroy($comment) {
	    var id = $comment.data('comment-id');
	    var that = this;
	
	    $.prettyLoader.show();
	    $.ajax({
	      type: 'POST',
	      url: '/comments/' + id + '.json',
	      data: { _method: 'delete' },
	      dataType: 'json',
	      success: function success() {
	        $.prettyLoader.hide();
	        that.$container.find(".comment[data-comment-id=" + id + "]").slideUp(function () {
	          $(this).remove();
	        });
	      },
	      error: function error() {
	        $.prettyLoader.hide();
	        $.jGrowl("Comment deleted");
	        trace("Something went wrong");
	      }
	    });
	  }
	};

/***/ }),
/* 91 */
/***/ (function(module, exports) {

	'use strict';
	
	var CommunicatorDetector = {
	  hasActiveX: window.ActiveXObject !== undefined,
	
	  canDetectPlugins: function canDetectPlugins() {
	    return CommunicatorDetector.hasActiveX || !!navigator.mimeTypes;
	  },
	
	  detectFlash: function detectFlash() {
	    var pluginFound = CommunicatorDetector.detectPluginByMIME('application/x-shockwave-flash');
	    // if not found, try to initialize with ActiveX
	    if (!pluginFound && CommunicatorDetector.hasActiveX) {
	      pluginFound = CommunicatorDetector.detectActiveXControl('ShockwaveFlash.ShockwaveFlash.1');
	    }
	    return pluginFound;
	  },
	
	  detectGarminCommunicatorPlugin: function detectGarminCommunicatorPlugin() {
	    var pluginFound = CommunicatorDetector.detectPluginByMIME('application/vnd-garmin.mygarmin');
	    // if not found, try to initialize with ActiveX
	    if (!pluginFound && CommunicatorDetector.hasActiveX) {
	      pluginFound = CommunicatorDetector.detectActiveXControl('GARMINAXCONTROL.GarminAxControl_t.1');
	    }
	    return pluginFound;
	  },
	
	  detectPluginByMIME: function detectPluginByMIME(mimeTypeName) {
	    if (navigator.mimeTypes) {
	      var mimeType = navigator.mimeTypes[mimeTypeName];
	      return !!(mimeType && mimeType.enabledPlugin);
	    } else {
	      return false;
	    }
	  },
	
	  detectActiveXControl: function detectActiveXControl(activeXControlName) {
	    try {
	      var control = new window.ActiveXObject(activeXControlName);
	      if (control) return true;
	    } catch (e) {
	      return false;
	    }
	  }
	};
	
	module.exports = CommunicatorDetector;

/***/ }),
/* 92 */
/***/ (function(module, exports) {

	'use strict';
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var Favorites = module.exports = {
	  remember: function remember(url, holder) {
	    this.trackEvent(url);
	    $.ajax({ type: 'post', url: url + '.json', dataType: 'json', data: {},
	      success: function success(response_data) {
	        if (response_data) {
	          $.jGrowl(T.t('remembered_success'));
	          if (holder) {
	            holder.slideUp();
	          }
	        } else {
	          $.jGrowl(response_data.message);
	        }
	        $.prettyLoader.hide();
	      },
	      error: function error() {
	        $.jGrowl(T.t('something_went_wrong'), { sticky: true });
	        $.prettyLoader.hide();
	      }
	    });
	  },
	  trackEvent: function trackEvent(url) {
	    if (window.amplitude) {
	      var path = window.location.pathname;
	
	      var _slice = (url.match(/(route|trip)\/(\d+)$/) || []).slice(-2),
	          _slice2 = _slicedToArray(_slice, 2),
	          assetType = _slice2[0],
	          assetId = _slice2[1];
	
	      var pinSource = null;
	      assetType = assetType === 'trip' ? 'ride' : 'route';
	
	      if (/find$/.test(path)) {
	        pinSource = 'findPage';
	      } else if (/clubs\/[^\/]+\/routes$/.test(path)) {
	        pinSource = 'orgRouteLibrary';
	      }
	
	      window.amplitude.track('Click Pin', {
	        asset_id: parseInt(assetId),
	        asset_type: assetType,
	        pin_source: pinSource,
	        user_pinned: true
	      });
	    }
	  }
	};
	
	$(function () {
	  $('body').on('click', '.remember_this', function () {
	    var $self = $(this);
	    Favorites.remember($self.attr("href"), $self.parent());
	    return false;
	  });
	});

/***/ }),
/* 93 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	  gotoPhoto: function gotoPhoto(photo_id, photoset_id, ajax) {
	    var tmpHeight = $('#medium_image_container').height();
	    var tmpImg = $("<img src='/images/prettyLoader/ajax-loader.gif' style='margin-top:50px;' border='none'/>");
	    $('#show-photo img:first').replaceWith(tmpImg);
	
	    if (navigator.appName.indexOf("Microsoft") == -1) {
	      $('#show-photo').html('<div></div>').css('background-color', '#F7F7F7').css('border', 'solid 1px #CCC').append(tmpImg).height(tmpHeight);
	    }
	    $.get('/photos/show/' + photo_id, { photoset_id: photoset_id, ajax: ajax }, function (data) {
	      if (data != null) {
	        $('#show_photo').html(data);
	      }
	    });
	    //$('#comment_container').load('/photo/comments/' + photo_id);
	    return false;
	  },
	
	  getPage: function getPage(url, page) {
	    $.prettyLoader.show();
	    var index = page - 1;
	    var dest = $('#photo_previewer table:eq(' + index.toString() + ')');
	    $.get(url, {}, function (data) {
	      $.prettyLoader.hide();
	      if (data != null) {
	        var placeHolder = $(data).find('table:first');
	        $('#tempholder').append(placeHolder); //add to dom, get sizes set
	
	        dest.replaceWith(placeHolder);
	        $('#wrapper').trigger('goto', [index]);
	        var numImg = placeHolder.find('img').length;
	        var numRows = Math.ceil(parseFloat(numImg) / 5.0);
	        var newHeight = placeHolder.height();
	        if (3 - numRows > 0) {
	          var rowHeight = placeHolder.find('tr:first').height();
	          newHeight = numRows * rowHeight + numRows * 30; //the multiple of 30 is for padding
	        }
	        $('#paging_links').html($(data).find('#paging_links').html());
	        $('#wrapper').animate({ height: newHeight }, 300);
	      }
	    });
	  }
	};

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var data_module = __webpack_require__(168),
	    date_ext_module = __webpack_require__(169),
	    units_module = __webpack_require__(170),
	    utils_module = __webpack_require__(171),
	    MetricsCalculator = __webpack_require__(78);
	
	// all the above modules will be attached to the rwgps variable which we'll export
	var rwgps;
	
	var Routes = window.Routes = window.Routes || {};
	
	Routes.Common = {};
	
	/**
	 * TODO: Get the map.js functionality inside of this library. It will likely make sense to distribute its contents into other modules, so this module is a placeholder mostly.
	 * @module maps-js
	 */
	
	/**
	 * Defines core Ride with GPS Library functionality.
	 *
	 * @module base
	 */
	
	/**
	 * Handles dependency management and initialization. Provides methods to get and set library properties.
	 * Ran as a function, it expects a single argument that is a function to be executed once the rwgps
	 * library has finished initializing.
	 * @namespace
	 * @class rwgps
	 */
	/**
	 * @namespace rwgps
	 */
	var init = {
	  isComplete: false,
	  afterComplete: [afterInitComplete]
	},
	    R = module.exports = rwgps = function rwgps(onLoad) {
	  if (init.isComplete) onLoad();else init.afterComplete.push(onLoad);
	},
	    baseURL = '',
	    baseSecureURL = '',
	    options = {},
	    $,
	    MapJs;
	
	R.csrfParams = function () {
	  var data = {
	    authenticity_token: encodeURIComponent(rwgps.config.authenticityToken)
	  };
	  data[rwgps.config.sessionKeyName] = rwgps.config.sessionKeyValue;
	  return data;
	};
	
	// bootstrap
	// NOTE: YHA is loading all their own reqs, so need to confirm they are loaded - if not, load them.  For now
	//       we are just assuming they have been loaded.
	//if(jQuery === undefined) {
	//  head.js('http://code.jquery.com/jquery-1.5.1.min.js', function() {
	//    $ = jQuery;
	//  });
	//} else {
	$ = jQuery;
	//}
	//head.js(baseURL + '/javascripts/map.js', function() {
	MapJs = window.Map;
	//}).js('https://ajax.googleapis.com/ajax/libs/swfobject/2.2/swfobject.js')
	//  .js(baseURL + '/javascripts/jquery/jquery.json-1.3.js')
	//  .js(baseURL + '/javascripts/underscore-min.js', baseURL + '/javascripts/backbone-min.js');
	//head(function() {
	init.isComplete = true;
	_.each(init.afterComplete, function (fn) {
	  fn();
	});
	//});
	
	// executed after all dependencies have been loaded
	function afterInitComplete() {
	  // this file should be reorganized??!! so that these dont have to be local vars for documentation to work!
	  /** Site key. Overridden after this is loaded, defaults to rwgps
	   * @property site
	   */
	  var site = 'rwgps';
	  /** Whitelist for uploadify image extensions
	   * @property imageExtensions
	   */
	
	  var imageExtRegEx = /(\.|\/)(gif|jpe?g|png)$/i;
	  /** Whitelisting RegEx for images in multi-file uploader
	   * @property imageExtRegex
	   */
	
	  var gpsExtRegEx = /(\.|\/)(gpx|tcx|kml|fit|kmz|zip|gz|tar)$/i;
	  /** Whitelisting RegEx for images in multi-file uploader
	   * @property gpsExtRegex
	   */
	
	  var imageExtensions = '*.jpg;*.JPG;*.png;*.PNG;*.gif;*.GIF;*.tiff;*.TIFF';
	  /** Whitelist for uploadify data extensions
	   * @property gpsExtensions
	   */
	  var gpsExtensions = '*.gpx;*.GPX;*.tcx;*.TCX;*.kml;*.KML;*.kmz;*.KMZ;*.fit;*.FIT;*.zip;*.ZIP;*.gz;*.GZ;*.tar;*.TAR';
	  /**
	   * Set a global property in the rwgps module.
	   * @method set
	   * @param {String | Object} key As a string, specifies the property to set. Otherwise, expects an object with property/value pairs for mass assignment.
	   * @param {MIXED} val (optional, only use if passing a single string key) The value to assign
	   */
	  function set(key, val) {
	    if (key && val) {
	      options[key] = val;
	    } else {
	      // only 1 param, expected to be an object with multiple properties to set
	      $.extend(options, key);
	    }
	  }
	  /**
	   * Get a global property from the rwgps module.
	   * @method get
	   * @param {String} key The property to get
	   * @return {MIXED} The value associated with the specified property
	   */
	  function get(key, val) {
	    return options[key] = val;
	  }
	  /** Get the path to POI icons.
	   * FIXME This should be somewhere else!
	   * @method poiIconsPath
	   * @return {String} Base href for POI icons (based on the site)
	   */
	  function poiIconsPath() {
	    if (rwgps.site == 'gi') {
	      return 'gi/poi/negativ_med_ramme/';
	    } else {
	      return 'poi_icons/';
	    }
	  }
	  /**
	   * Access/extend namespaces within the rwgps object. Generally for scoping view-specific code.
	   * Convention for namespaces is lower camel, e.g. scheduledReports.show
	   * @method ns
	   * @static
	   * @param {String} ns Period-separated namespace, e.g. foo.bar.baz.
	   * @param {Object | Function} obj If an object, extends the namespace with it. If a function, runs the function in the context of the namespace, and if the function returns an object, extends the namespace with that return value.
	   * @return {Object} The resulting namespace. rwgps.ns('foo.bar.baz') returns rwgps.foo.bar.baz after ensuring it exists.
	   */
	  // all namespaces get this as their basic object
	  var baseNsObj = { ns: function ns() {
	      return this._ns;
	    } };
	  function ns(ns, obj) {
	    var nsResolved = resolveNamespace(ns);
	    if (obj) {
	      if (_.isFunction(obj)) obj = obj.apply(nsResolved);
	      if (obj !== undefined) _.extend(resolveNamespace(ns), obj);
	      // by convention a property named init will execute after dom ready,
	      // but only for the active namespace
	      // TODO: uncomment when you uncomment the other activeNamespace stuff
	      //if(ns == rwgps.activeNamespace() && obj.init) $(obj.init);
	    }
	    return nsResolved;
	  }
	  // namespaces are specified as period-separated strings like so: foo.bar.baz
	  // they resolve to something like rwgps.foo.bar.baz respectively
	  // objects are created if they do not exist - in other words, nested namespaces are created upon declaration
	  function resolveNamespace(nsStr) {
	    var nsResolved = rwgps,
	        nsStrMemo;
	    _.each(nsStr.split('.'), function (x) {
	      nsStrMemo = nsStrMemo === undefined ? x : nsStrMemo + '.' + x;
	      if (nsResolved[x] === undefined) nsResolved[x] = _.extend({ _ns: nsStrMemo }, baseNsObj);
	      nsResolved = nsResolved[x];
	    });
	    return nsResolved;
	  }
	
	  /**
	   * A backbone.js-driven model facilitating validation, persistence, and event handling.
	   *
	   * @class Model
	   */
	  /**
	   * The attributes of the model. Do not modify through this, use set().
	   * @property attributes
	   */
	  /**
	   * Commit changes to the model back to the server to be saved.
	   * @method save
	   */
	  /**
	   * Setter for model attributes.
	   * @method set
	   * @param {Object} attributes A hash of attributes to set on the model
	   */
	  /**
	   * Getter individual model attributes.
	   * @method get
	   * @param {String} attribute The attribute to get the current value of
	   */
	  /**
	   * Get a copy of all attributes.
	   * @method toJSON
	   * @return {Object} All model attributes contained in an object
	   */
	  /**
	   * Permanently delete this model on the server.
	   * @method destroy
	   */
	
	  /**
	   * @namespace rwgps.models
	   */
	  /**
	   * A route is a list of connected points in physical space, with associated metadata.
	   *
	   * This class provides static methods to retrieve one or more routes in a variety of ways.
	   * An instance of this class represents a single route and provides facilities for modification
	   * and retrieval of related objects.
	   * @class Route
	   * @extends Model
	   */
	  var Route = Backbone.Model.extend({
	    /**
	     * Get a full representation of the route, including track points
	     * @method full
	     * @return {Promise} a promise for the full Route instance
	     */
	    full: function full() {
	      if (this.fullDfd) return this.fullDfd.promise();
	      var dfd = this.fullDfd = new $.Deferred();
	
	      if (this.attributes.course_points) {
	        var route = new rwgps.models.Route(this.attributes);
	        route.set('mappingRoute', new rwgps.Route(this.attributes));
	        dfd.resolve(route);
	        return dfd.promise();
	      } // if we have course points, we assume the route is already 'full'
	
	      var uri = baseURL + '/routes/' + this.get('id') + '.json';
	      if (this.get('privacy_code_string')) uri += '?privacy_code=' + this.get('privacy_code_string');
	      $.getJSON(uri, function (data) {
	        if (data) {
	          var route = new rwgps.models.Route(data);
	          route.set('mappingRoute', new rwgps.Route(data));
	          dfd.resolve(route);
	        } else {
	          dfd.reject();
	        }
	      });
	
	      return dfd.promise();
	    },
	    /**
	     * Get the URL to the GPX file for this route.
	     * @method gpxUrl
	     */
	    gpxUrl: function gpxUrl() {
	      return baseURL + '/routes/' + this.get('id') + '.gpx';
	    },
	    /**
	     * Get the URL to the TCX file for this route.
	     * @method tcxUrl
	     */
	    tcxUrl: function tcxUrl() {
	      return baseURL + '/routes/' + this.get('id') + '.tcx';
	    },
	    /**
	     * Get the URL to the KML file for this route.
	     * @method kmlUrl
	     */
	    kmlUrl: function kmlUrl() {
	      return baseURL + '/routes/' + this.get('id') + '.kml';
	    },
	    csvUrl: function csvUrl() {
	      return baseURL + '/routes/' + this.get('id') + '.csv';
	    },
	    printCueSheetUrl: function printCueSheetUrl() {
	      return 'https://ridewithgps.com/routes/' + this.get('id') + '/cue_sheet';
	    },
	    printMapUrl: function printMapUrl() {
	      return 'https://ridewithgps.com/routes/' + this.get('id') + '/full.gif';
	    },
	    embedSrc: function embedSrc() {
	      return '<iframe src="https://ridewithgps.com/routes/' + this.get('id') + '/embed" height="500px" width="100%" frameborder="0"></iframe>';
	    },
	    /**
	     * Send details about this route to an email address.
	     * @method emailTo
	     * @param {String} email Recipient email address
	     * @return {Promise} A promise for this request which will resolve after the email has been confirmed sent.
	     */
	    emailTo: function emailTo(email) {
	      var self = this,
	          dfd = new $.Deferred();
	
	      $.getJSON(baseURL + '/share.js?callback=?', { site: options.site, share: { email: email, model: 'Route', id: self.get('id') } }, function (data) {
	        if (data.success) {
	          dfd.resolve();
	        } else {
	          dfd.reject();
	        }
	      });
	
	      return dfd.promise();
	    },
	
	    copy: function copy() {
	      var self = this,
	          dfd = new $.Deferred();
	
	      $.getJSON(baseURL + '/routes/' + self.get('id') + '/copy.js?callback=?', function (data) {
	        if (data) {
	          dfd.resolve();
	        } else {
	          dfd.reject();
	        }
	      });
	
	      return dfd.promise();
	    },
	
	    remember: function remember() {
	      var self = this,
	          dfd = new $.Deferred();
	
	      $.getJSON(baseURL + '/remember/route/' + self.get('id') + '.js?callback=?', function (data) {
	        if (data) {
	          dfd.resolve();
	        } else {
	          dfd.reject();
	        }
	      });
	
	      return dfd.promise();
	    }
	
	  });
	
	  /**
	   * Search for routes based on many conditions.
	   * @method search
	   * @static
	   * @param {Object} params A set of options that determine how to perform the search.
	   * @param {Function} fn Function to call when search is completed. Will be passed one parameter, the search results, as an array of Route objects.
	   */
	  Route.search = function (params, fn) {
	    $.getJSON(baseURL + '/routes/search.js?callback=?', params, function (data) {
	      var results = [];
	      for (var i = 0, len = data.length; i < len; i++) {
	        results.push(new Route(data[i]));
	      }
	      fn(results);
	    });
	  };
	
	  /**
	   * Fetch a single route by id
	   * @method find
	   * @static
	   * @param {int} id of route to fetch
	   * @return {Route | null} Route with specified id, or null if there is no such route
	   */
	  Route.find = function (id) {
	    var dfd = new $.Deferred();
	
	    $.getJSON(baseURL + '/routes/' + id + '.js?attrs=true&callback=?', function (data) {
	      if (data) {
	        dfd.resolve(new rwgps.models.Route(data));
	      } else {
	        dfd.reject();
	      }
	    });
	
	    return dfd.promise();
	  };
	
	  /**
	   * Provides rendering and manipulation of maps.
	   * @class Map
	   */
	  /**
	   * Initializes a map in a target DOM element. Accepts an options object that can be used to determine initial Map configuration.
	   * @constructor
	   * @param {String} targetId Expects an id value that corresponds to a DOM element that will be the container for the rendered map
	   * @param {Object} config (optional) Config object that specifies initial configuration of map
	   */
	  function Map(targetId, config) {
	    if (!config) config = {
	      defaultLat: 43.99490,
	      defaultLng: -123.08841
	    };
	    this.config = config;
	    this.targetId = targetId;
	
	    // this should be an option
	    MapJs.metric = config.metric = true;
	
	    /**
	     * ID of route currently displayed
	     * @property routeId
	     * @type int
	     */
	    var routeId = config.routeId;
	
	    if (routeId) {
	      MapJs.createMode = false;
	      this.build();
	      this.loadRoute(routeId, config.coursePointsFn);
	    } else if (config.plan) {
	      MapJs.createMode = true;
	      this.build();
	    }
	  }
	
	  /**
	   * Default configuration for a newly instantiated Map. All configuration properties can be overridden upon instantiation through the config parameter on the Map constructor.
	   * @static
	   * @property DEFAULT_CONFIG
	   * @type Object
	   */
	  Map.DEFAULT_CONFIG = {
	    routeId: null
	  };
	
	  Map.prototype = {
	    /**
	     * Render the map into the targeted DOM element
	     * @method build
	     */
	    build: function build() {
	      MapJs.movieId = this.targetId;
	
	      var flashvars = 'mode=view&key=' + options.gmapsApiKey + '&metric_units=' + rwgps.LabelMaker.metric + '&mode=' + (this.config.plan ? 'plan' : '') + '&lat=' + this.config.defaultLat + '&lng=' + this.config.defaultLng,
	          params = {
	        allowFullScreen: 'true',
	        allowScriptAccess: 'always',
	        wmode: 'transparent',
	        bgcolor: '#ffffff',
	        menu: 'false',
	        flashvars: flashvars
	      };
	
	      swfobject.embedSWF(baseURL + '/routeViewer.swf?2000000070', MapJs.movieId, '100%', '100%', '9.0.0', false, false, params, {}); // eslint-disable-line no-undef
	    },
	
	    /**
	     * Save route that is being planned
	     * @method saveRoute
	     * @param {Object} attrs Metadata to save as properties of the route
	     * @param {String} redirectUrl URL to redirect the user to after route is saved. Will be appended with ?route_id=#route_id#
	     */
	    saveRoute: function saveRoute(attrs, redirectUrl) {
	      var baseAttrs = {
	        route_data: MapJs.movie().routeJSON(),
	        course_points: MapJs.movie().coursePointsJSON()
	      };
	      var $form = $('<form action="' + baseURL + '/routes.json" method="POST"></form>');
	      var $field = $('<input type="hidden" name="redirect_to">');
	      $form.append($field);
	      $field.val(redirectUrl);
	      _.each(['route_data', 'points_of_interest', 'course_points'], function (attr) {
	        var $field = $('<input type="hidden" name="' + attr + '">');
	        $form.append($field);
	        $field.val(baseAttrs[attr]);
	      });
	      _.each(['name', 'description', 'recreation_type_ids', 'pavement_type_id', 'visibility'], function (attr) {
	        var $field = $('<input type="hidden" name="route[' + attr + ']">');
	        $form.append($field);
	        $field.val(attrs[attr]);
	      });
	      $('body').append($form);
	      $form.submit();
	    },
	
	    /**
	     * Load a route into the map by route ID
	     * @method loadRoute
	     * @param {int} routeId The ID of the route to fetch and display
	     * @param {Function} fn Function to call when coursepoints are loaded
	     */
	    loadRoute: function loadRoute(routeId, fn) {
	      this.routeId = routeId;
	      $.getJSON(baseURL + '/routes/' + routeId + '.js?string=1&include_cps=1&callback=?', function (data) {
	        MapJs.callWhenReady(function () {
	          MapJs.movie().loadRoute(data[0], JSON.stringify(data[1]));
	        });
	        _.each(data[1], function (cp) {
	          cp.notes = cp.n;
	          cp.distance = cp.d;
	        });
	
	        if (fn) fn(data[1]);
	      });
	    },
	
	    _drawingMode: 'directions', // default
	    drawingMode: function drawingMode(mode) {
	      if (!mode) return this._drawingMode;
	
	      if (mode == 'directions' || mode == 'polyline') {
	        this._drawingMode = mode;
	        MapJs.callWhenReady(function () {
	          MapJs.movie().setDrawingMode(mode);
	        });
	      }
	    },
	
	    setColor: function setColor(color) {
	      MapJs.callWhenReady(function () {
	        MapJs.movie().setColor(color);
	      });
	    },
	
	    gotoLocation: function gotoLocation(query) {
	      MapJs.callWhenReady(function () {
	        MapJs.movie().gotoLocation(query);
	      });
	    },
	
	    showCoursePointMarker: function showCoursePointMarker(id) {
	      MapJs.callWhenReady(function () {
	        MapJs.movie().showCoursePointMarker(id);
	      });
	    },
	
	    hideCoursePointMarker: function hideCoursePointMarker(id) {
	      MapJs.callWhenReady(function () {
	        MapJs.movie().hideCoursePointMarker(id);
	      });
	    },
	
	    recenterMap: function recenterMap() {
	      MapJs.callWhenReady(function () {
	        MapJs.movie().recenterMap();
	      });
	    },
	
	    enableAddPoi: function enableAddPoi() {
	      MapJs.callWhenReady(function () {
	        MapJs.movie().enableAddPoi();
	      });
	    },
	
	    fixCoursePointDistances: function fixCoursePointDistances() {
	      MapJs.callWhenReady(function () {
	        MapJs.movie().fixCoursePointDistances();
	      });
	    },
	
	    enableAddCoursePoint: function enableAddCoursePoint() {
	      MapJs.callWhenReady(function () {
	        MapJs.movie().enableAddCoursePoint();
	      });
	    },
	
	    walkingMode: function walkingMode(bool) {
	      MapJs.callWhenReady(function () {
	        MapJs.movie().walkingMode(bool);
	      });
	    },
	
	    setOption: function setOption(k, v) {
	      MapJs.callWhenReady(function () {
	        MapJs.movie().setOption(k, v);
	      });
	    }
	  };
	
	  /**
	   * Listen for or trigger metricsChange event.
	   * @method metricsChange
	   * @static
	   * @param {Function} fn Function to call when metricsChange is triggered. If not provided, triggers metricsChange.
	   */
	  Map.metricsChange = function (fn) {
	    if (fn) {
	      if (!this.onMetricsChange) this.onMetricsChange = [];
	      this.onMetricsChange.push(fn);
	    } else {
	      // trigger event
	      if (this.onMetricsChange) _.each(this.onMetricsChange, function (fn) {
	        fn(Map.metrics, Map.zoomedIn);
	      });
	    }
	  };
	  /**
	   * Listen for or trigger coursePointsChange event.
	   * @method coursePointsChange
	   * @static
	   * @param {Function} fn Function to call when coursePointsChange is triggered. If not provided, triggers coursePointsChange.
	   */
	  Map.coursePointsChange = function (fn) {
	    if (fn) {
	      if (!this.onCoursePointsChange) this.onCoursePointsChange = [];
	      this.onCoursePointsChange.push(fn);
	    } else {
	      // trigger event
	      if (this.onCoursePointsChange) _.each(this.onCoursePointsChange, function (fn) {
	        fn(Map.coursePoints);
	      });
	    }
	  };
	
	  Map.updateMetrics = function (metrics, zoomedIn) {
	    this.metrics = metrics;
	    this.zoomedIn = zoomedIn;
	    this.metricsChange();
	  };
	
	  Map.updateCoursePoints = function (coursePoints, append) {
	    if (!this.coursePoints) this.coursePoints = [];
	    this.coursePoints = append ? this.coursePoints.concat(coursePoints) : coursePoints;
	    this.coursePointsChange();
	  };
	
	  // when metrics or coursepoints update from the map, store them on the Map statically since maps are a singleton resource for time being
	  Routes.Common.updateMetrics = function (metrics, zoomedIn) {
	    Map.updateMetrics(metrics, zoomedIn);
	  };
	  Routes.Common.populateCoursePoints = function (coursePoints, append) {
	    Map.updateCoursePoints(coursePoints, append);
	  };
	
	  /**
	   * A User from the RWGPS service.
	   *
	   * @class User
	   * @extends Model
	   */
	  var User = Backbone.Model.extend({
	    url: function url() {
	      if (this.id) return baseSecureURL + '/users/' + this.id + '.js';else return baseSecureURL + '/users.js';
	    },
	
	    /**
	     * Fetch a user's routes
	     * @method routes
	     * @return {Promise} A promise for an array of routes belonging to this user.
	     */
	    routes: function routes() {
	      var dfd = new $.Deferred();
	
	      if (this._routes) {
	        dfd.resolve(this._routes);
	        return;
	      }
	
	      $.getJSON(baseURL + '/users/' + this.id + '/routes.js?callback=?', function (data) {
	        if (data) {
	          this._routes = _.map(data, function (r) {
	            return new rwgps.Route(r);
	          });
	          dfd.resolve(this._routes);
	        } else {
	          dfd.reject();
	        }
	      });
	
	      return dfd.promise();
	    },
	
	    /**
	     * Fetch a user's favorited routes
	     * @method routes
	     * @return {Promise} A promise for an array of routes favoritied by this user.
	     */
	    favoriteRoutes: function favoriteRoutes() {
	      var dfd = new $.Deferred();
	
	      if (this._favoriteRoutes) {
	        dfd.resolve(this._routes);
	        return;
	      }
	
	      $.getJSON(baseURL + '/users/' + this.id + '/favorite_routes.js?callback=?', function (data) {
	        if (data) {
	          this._favoriteRoutes = _.map(data, function (r) {
	            return new rwgps.Route(r);
	          });
	          dfd.resolve(this._favoriteRoutes);
	        } else {
	          dfd.reject();
	        }
	      });
	
	      return dfd.promise();
	    }
	
	  });
	
	  // need to override sync so we can use jsonp
	  var originalSync = Backbone.sync;
	  Backbone.sync = function (method, model, success, error) {
	    if (method == 'create' && model instanceof rwgps.models.User) {
	      $.getJSON(baseSecureURL + '/users.js?callback=?', { _method: 'POST', user: model.toJSON() }, function (data) {
	        if (data.user) {
	          success(data.user);
	        } else if (data.errors) {
	          error(data.errors);
	        }
	      });
	    } else {
	      originalSync.apply(this, arguments);
	    }
	  };
	
	  /**
	   * Login a user by username and password
	   * @method login
	   * @static
	   * @param {String} username Username to attempt login for
	   * @param {String} password Password to attempt login with
	   * @return {Promise} A promise for the authenticated user. If login fails, promise will be rejected.
	   */
	  User.login = function (email, password) {
	    var self = this,
	        dfd = new $.Deferred();
	
	    $.getJSON(baseSecureURL + '/login.js?callback=?', { email: email, password: password }, function (data) {
	      if (data) {
	        delete self.currentDfd;
	        self.current = new User(data);
	        dfd.resolve(self.current);
	      } else {
	        dfd.reject();
	      }
	    });
	
	    return dfd.promise();
	  };
	
	  /**
	   * Request a password reset
	   * @method resetPassword
	   * @static
	   * @param {String} username Username to reset password for
	   * @return {Promise} A promise for the password reset response
	   */
	  User.resetPassword = function (email) {
	    var dfd = new $.Deferred();
	
	    $.getJSON(baseURL + '/forgot_password.js?callback=?', { site: options.site, email: email }, function (data) {
	      if (data && data.status == 1) {
	        dfd.resolve();
	      } else {
	        dfd.reject();
	      }
	    });
	
	    return dfd.promise();
	  };
	
	  User.usePasswordReset = function (identifier, password) {
	    var dfd = new $.Deferred();
	
	    $.getJSON(baseSecureURL + '/reset_password/' + identifier + '.js?callback=?', {
	      'user[password]': password,
	      'user[password_confirmation]': password
	    }, function (data) {
	      if (data) {
	        dfd.resolve();
	      } else {
	        dfd.reject();
	      }
	    });
	
	    return dfd.promise();
	  };
	
	  /**
	   * Log out current user
	   * @method logout
	   * @static
	   * @return {Promise} A promise that resolves when the user is logged out
	   */
	  User.logout = function () {
	    var self = this,
	        dfd = new $.Deferred();
	
	    $.getJSON(baseURL + '/logout.js?callback=?', function () {
	      delete self.currentDfd;
	      dfd.resolve();
	    });
	    return dfd.promise();
	  };
	
	  /**
	   * Get currently logged in user
	   * @method getCurrent
	   * @static
	   * @return {Promise} A promise for the currently authenticated user
	   */
	  User.getCurrent = function () {
	    if (this.currentDfd) return this.currentDfd;
	
	    var dfd = this.currentDfd = new $.Deferred();
	    // we might already have a user prepopulated, let's check
	    if (rwgps.ns('config').currentUser !== undefined) {
	      if (rwgps.config.currentUser) {
	        dfd.resolve(new User(rwgps.config.currentUser)); // we have a user
	      } else {
	        dfd.reject(); // user is not logged in
	      }
	    } else {
	      $.getJSON(baseURL + '/users/current.js?callback=?', function (data) {
	        if (data) {
	          dfd.resolve(new User(data));
	        } else {
	          dfd.reject();
	        }
	      });
	    }
	    return dfd;
	  };
	
	  /*** export public properties ***/
	  _.extend(rwgps, {
	    site: site,
	    imageExtensions: imageExtensions,
	    gpsExtensions: gpsExtensions,
	    imageExtRegEx: imageExtRegEx,
	    gpsExtRegEx: gpsExtRegEx,
	    set: set,
	    get: get,
	    ns: ns,
	    // need to keep these root level for backward compatibility with yha
	    //      Route: Route,
	    //      Map: Map,
	    User: User,
	    // this should be somewhere else
	    poiIconsPath: poiIconsPath,
	    places: {}
	  });
	  _.extend(rwgps, data_module);
	  _.extend(rwgps, date_ext_module);
	  _.extend(rwgps, units_module);
	  _.extend(rwgps, utils_module);
	  rwgps.MetricsCalculator = MetricsCalculator;
	  rwgps.ns('Events', Backbone.Events);
	  rwgps.ns('models', {
	    Route: Route,
	    Map: Map,
	    User: User
	  });
	  rwgps.ns('config').datePickerOpts = {
	    buttonImage: '/images/led-icons/calendar_1.png',
	    buttonImageOnly: true,
	    beforeShow: function beforeShow(input) {
	      input.setAttribute('autocomplete', 'off');
	      setTimeout(function () {
	        $("#ui-datepicker-div").css({ "z-index": 11000 });
	      }, 10);
	    },
	    showOn: 'both',
	    dateFormat: 'yy-mm-dd'
	  };
	  if (window.activeRWNamespace) {
	    rwgps.activeNs = rwgps.ns(window.activeRWNamespace);
	  }
	  if (window.rwgpsNSData) {
	    window.rwgpsNSData.forEach(function (keyVal) {
	      rwgps.ns(keyVal[0], keyVal[1]);
	    });
	  }
	}

/***/ }),
/* 95 */
/***/ (function(module, exports) {

	'use strict';
	
	(function () {
	  var CarouselView, PhotosView, PhotosModalView, PhotosRouter;
	
	  // requires that you implement "carousel"
	  CarouselView = Backbone.View.extend({
	    prev: function prev() {
	      this.carousel('prev');
	    },
	    next: function next() {
	      this.carousel('next');
	    },
	
	    // slideshow lazy-loader for both mini-slideshow and full blown modal, works on any carousel
	    // expectation is you use "lazy-src" attribute instead of "src" attribute on images you want
	    // lazy-loaded
	    imageLoader: function imageLoader() {
	      var $active = this.$('.active.item');
	      var $imgs = $active.add($active.next('.item')).add($active.prev('.item')).find('img.ss_img');
	      $imgs.each(function () {
	        var lazy = $(this).data('lazy-src');
	        if (lazy && !$(this).attr('src')) {
	          $(this).attr('src', lazy);
	        }
	      });
	    },
	    activePhotoId: function activePhotoId() {
	      return this.$('.item.active img.ss_img').data('photo-id');
	    },
	    highlightActiveOnMap: function highlightActiveOnMap() {
	      if (!Routes || !Routes.activeMap) return;
	      var photoId = this.activePhotoId();
	      if (Routes.activeMap.selectedImageMarker) {
	        Routes.activeMap.selectedImageMarker.setIcon('/images/image_marker.png?1');
	        Routes.activeMap.selectedImageMarker.selected = false;
	      }
	      if (Routes.activeMap.imageMarkers && Routes.activeMap.imageMarkers[photoId]) {
	        Routes.activeMap.imageMarkers[photoId].setIcon('/images/image_marker_selected.png?1');
	        Routes.activeMap.selectedImageMarker = Routes.activeMap.imageMarkers[photoId];
	        Routes.activeMap.selectedImageMarker.selected = true;
	      }
	    },
	    processPhotos: function processPhotos(photos) {
	      return _.map(photos, function (photo) {
	        if (photo.captured_at && _.isString(photo.captured_at)) {
	          photo.captured_at = rwgps.DateExt.parse(photo.captured_at, true);
	        }
	        return photo;
	      });
	    }
	  });
	
	  PhotosView = CarouselView.extend({
	    id: function id() {
	      return _.uniqueId("photosview_");
	    },
	    className: 'photosview_mini',
	    template: rwgps.templates.photos.miniSlideshow,
	    indicatorTemplate: rwgps.templates.photos.miniSlideshowIndicator,
	    itemTemplate: rwgps.templates.photos.miniSlideshowItem,
	    uploaderTemplate: rwgps.templates.photos.uploader,
	    initialize: function initialize() {
	      _.bindAll(this, 'imageLoader', 'highlightActiveOnMap', 'showTooltipIfMouseover', 'showPhotoById');
	      this.canEdit = this.options.canEdit;
	      this.carouselId = _.uniqueId("photosview_");
	      this.photosetId = this.options.photosetId;
	      this.photos = this.processPhotos(this.options.photos);
	      this.modalView = new PhotosModalView({ photosView: this, modal: !this.options.inline, photosetId: this.photosetId, parentType: this.options.parentType, parentId: this.options.parentId });
	      this.modalView.render();
	
	      if (this.options.inline) {
	        $(this.options.container).html(this.modalView.$el);
	      } else {
	        this.modalView.$el.appendTo('body');
	        this.render();
	        $(this.options.container).html(this.$el);
	      }
	
	      if (this.canEdit && !this.options.hideUploader) this.setupUploader();
	      reloadTooltips();
	
	      if (this.options.coverId) {
	        _.each(this.photos, function (photo, i) {
	          if (photo.id == this.options.coverId) {
	            if (this.options.inline) this.modalView.carousel(i);else this.carousel(i);
	          }
	        }, this);
	      }
	
	      PhotosView.registerPhotos(this.photos, this, this.options.noClobber);
	
	      _.defer(function () {
	        if (!Backbone.History.started) Backbone.history.start();
	      });
	    },
	    events: {
	      'click .carousel-control.left': 'prev',
	      'click .carousel-control.right': 'next',
	      'click .popup_photo_modal': 'showModal',
	      'mouseenter .carousel': 'showTooltip',
	      'mouseleave .carousel': 'hideTooltip'
	    },
	    showPhotoById: function showPhotoById(photoId) {
	      var view = this.options.inline ? this.modalView : this;
	      var $item = view.$('img.ss_img[data-photo-id=' + photoId + ']').closest('.item'),
	          $items = $item.parent().children(),
	          idx = $items.index($item);
	      if (idx === -1) return;
	      view.carousel(idx);
	      if (!this.options.inline) this.showModal();
	    },
	    delegateCarouselEvents: function delegateCarouselEvents() {
	      this.$('.carousel').on('slid.bs.carousel', this.imageLoader).on('slid.bs.carousel', this.highlightActiveOnMap).on('slid.bs.carousel', this.showTooltipIfMouseover);
	    },
	    carousel: function carousel() {
	      this.$('.carousel').carousel.apply(this.$('.carousel'), arguments);
	    },
	    showTooltip: function showTooltip() {
	      this._mouseover = true;
	      this.$('.item.active a.popup_photo_modal').tooltip('show');
	    },
	    hideTooltip: function hideTooltip() {
	      this._mouseover = false;
	      this.$('.item.active a.popup_photo_modal').tooltip('hide');
	    },
	    showTooltipIfMouseover: function showTooltipIfMouseover() {
	      if (this._mouseover) {
	        this.$('a.popup_photo_modal').tooltip('hide');
	        this.showTooltip();
	      }
	    },
	
	    showModal: function showModal() {
	      var slideTo = this.$('.item').index(this.$('.item.active'));
	
	      if (rwgps.gallery) {
	        rwgps.gallery({
	          photos: this.photos,
	          readonly: !this.options.canEdit,
	          defaultActive: slideTo,
	          photosetId: this.photosetId,
	          parentType: this.options.parentType,
	          parentId: this.options.parentId,
	          coverId: this.options.coverId
	        });
	      } else {
	        this.modalView.show(slideTo);
	      }
	    },
	    setupUploader: function setupUploader() {
	      var $container = this.options.inline ? this.modalView.$el : this.$el,
	          $parent = $container.parent(),
	          view = this;
	      $container.append(this.uploaderTemplate({
	        cta: T.t('add_photos')
	      }));
	
	      function photoUploaded(photo) {
	        if (photo.captured_at) photo.captured_at = rwgps.DateExt.parse(photo.captured_at);
	        view.photos.push(photo);
	        view.trigger("photo:added", photo);
	      }
	      function photosUploaded() {
	        if (view.options.inline) {
	          // teardown
	          view.modalView.undelegateEvents();
	          view.modalView.$el.remove();
	
	          // rebuild
	          view.modalView.render();
	          view.modalView.delegateEvents();
	          $parent.html(view.modalView.$el);
	
	          view.setupUploader();
	        } else {
	          // teardown
	          view.hideTooltip();
	          view.undelegateEvents();
	          view.$el.remove();
	          view.modalView.undelegateEvents();
	          view.modalView.$el.remove();
	
	          // rebuild
	          view.render();
	          view.delegateEvents();
	          $parent.html(view.$el);
	          view.modalView.render();
	          view.modalView.delegateEvents();
	          view.modalView.$el.appendTo('body');
	
	          view.setupUploader();
	        }
	      }
	      var $uploader = $parent.find('.photo_uploader');
	      var data = rwgps.csrfParams();
	      if (this.options.parentType && this.options.parentId) {
	        data.parent_type = this.options.parentType;
	        data.parent_id = this.options.parentId;
	      }
	      if (this.photosetId) data.photoset_id = this.photosetId;
	      var fileUploadOpts = {
	        dataType: 'json',
	        url: '/upload/photos',
	        type: 'post',
	        paramName: 'Filedata',
	        sequentialUploads: true,
	        maxFileSize: 15000000,
	        formData: function formData() {
	          return _.map(data, function (val, key) {
	            return { name: key, value: val };
	          });
	        },
	        add: function add(e, f) {
	          var toKeep = [];
	          //TODO: alert user file has wrong extension
	          _.each(f.files, function (file) {
	            if (rwgps.imageExtRegEx.test(file.name)) {
	              toKeep.push(file);
	            } else {
	              trace("File failed regex match: " + file.name);
	            }
	          });
	          if (toKeep.length > 0) {
	            f.files = toKeep;
	
	            if (!view.photosetId && !view.options.parentId && !view.options.photosetDisabled) {
	              if (!view.createPhotoset) {
	                view.createPhotoset = $.post("/photosets").success(function (photoset) {
	                  data.photoset_id = photoset.id;
	                  view.photosetId = photoset.id;
	                });
	              }
	              view.createPhotoset.success(function () {
	                f.submit();
	              });
	            } else {
	              f.submit();
	            }
	          } else {
	            //TODO: handle errors
	            trace("No valid photos");
	          }
	        },
	        start: function start() {
	          $container.find('.below_image').hide();
	          $uploader.find('.fileinput-button').hide();
	          $uploader.find('.progress').show();
	          window.$u = $uploader;
	          view.trigger('upload:start');
	        },
	        stop: function stop() {
	          $uploader.find('.progress').hide();
	          $uploader.find('.fileinput-button').show();
	          photosUploaded();
	          view.trigger('upload:complete');
	        },
	        progressall: function progressall(e, data) {
	          var progress = parseInt(data.loaded / data.total * 100, 10);
	          $uploader.find('.progress .progress-bar').css('width', progress + '%');
	        },
	        done: function done(e, data) {
	          photoUploaded(data.result.photo);
	        },
	        fail: function fail(e, data) {
	          //TODO: actual error handling
	          $uploader.find('.progress').hide();
	          $uploader.find('.fileinput-button').show();
	          if (data.jqXHR && data.jqXHR.responseText) {
	            var res = $.parseJSON(data.jqXHR.responseText);
	            trace("Something went wrong: " + res.error);
	          } else {
	            trace(T.t("something_went_wrong"));
	          }
	        }
	      };
	      var $uploader_input = $uploader.find('.photos_upload');
	      if ($uploader_input.fileupload) $uploader_input.fileupload(fileUploadOpts);
	    },
	    render: function render() {
	      if (this.photos.length > 0) {
	        this.$el.html(this.template({
	          carouselId: this.carouselId
	        }));
	        var $indicators = this.$('.carousel-indicators'),
	            $items = this.$('.carousel-inner');
	        _.each(this.photos, function (photo, i) {
	          $indicators.append(this.indicatorTemplate({
	            carouselId: this.carouselId,
	            slideTo: i,
	            photoId: photo.id
	          }));
	          $items.append(this.itemTemplate({
	            photo: photo
	          }));
	        }, this);
	        $indicators.find('li').first().addClass('active');
	        $items.find('.item').first().addClass('active');
	        $items.find('img.ss_img').each(function () {
	          $(this).attr('src', $(this).data('lazy-src'));
	        });
	        // set up tooltips on hover
	        this.$('a.popup_photo_modal').tooltip({
	          container: 'body',
	          trigger: 'manual',
	          animation: false
	        });
	        this.carousel({ interval: 0 });
	        this.delegateCarouselEvents();
	
	        // hide left/right controls until first image is loaded
	        if (this.photos.length > 1) {
	          this.$('.carousel-control').hide();
	          var $img = this.$('.item.active img.ss_img');
	          if ($img.get(0).height > 0) this.$('.carousel-control').show();else {
	            var view = this;
	            $img.on('load', function () {
	              view.$('.carousel-control').show();
	            });
	          }
	        } else {
	          this.$('.carousel-control').hide();
	          this.$('.carousel-indicators').hide();
	        }
	      }
	    }
	  });
	  PhotosModalView = CarouselView.extend({
	    id: function id() {
	      return _.uniqueId("photosview_");
	    },
	    className: function className() {
	      if (this.options.modal) {
	        return 'modal photo_modal fade';
	      } else {
	        return 'photo_inline';
	      }
	    },
	    template: rwgps.templates.photos.modalSlideshow,
	    indicatorTemplate: rwgps.templates.photos.modalSlideshowIndicator,
	    itemTemplate: rwgps.templates.photos.modalSlideshowItem,
	    shareBarTemplate: rwgps.templates.photos.shareBar,
	    initialize: function initialize() {
	      _.bindAll(this, 'globalArrowNav', 'resizeHandler', 'imageLoader', 'highlightActiveOnMap', 'verticallyCenterImage', 'updateRoute', 'clearRoute', 'enableGlobalArrowNav', 'disableGlobalArrowNav', 'enableResizeHandler', 'disableResizeHandler', 'syncMiniSlideshowPosition', 'hideOnEscape');
	      this.throttledResizeHandler = _.throttle(this.resizeHandler);
	
	      this.parentType = this.options.parentType;
	      this.parentId = this.options.parentId;
	      this.photosView = this.options.photosView;
	      this.photos = this.photosView ? this.photosView.photos : this.processPhotos(this.options.photos);
	      this.photosetId = this.photosView ? this.photosView.photosetId : this.options.photosetId;
	      this.canEdit = this.photosView ? this.photosView.canEdit : this.options.canEdit;
	      this.hideSharing = this.photosView ? this.photosView.options.hideSharing : true;
	      this.carouselId = _.uniqueId("photosview_");
	    },
	    events: {
	      'click .carousel-control.left': 'prev',
	      'click .carousel-control.right': 'next',
	      'click .edit_actions .set_highlight': 'setHighlight',
	      'click .edit_actions .rotate_ccw': 'rotateCcw',
	      'click .edit_actions .rotate_cw': 'rotateCw',
	      'click .edit_actions .remove': 'removeOnConfirm',
	      'click .image_container': 'next',
	
	      'click .share_bar_share_link': 'closeModal',
	
	      'click .can_modify': 'enableCaptionEditor',
	      'click .caption.editing .cancel': 'cancelCaptionEdit',
	      'click .caption.editing .save': 'saveCaptionEdit',
	      'keypress .caption.editing input': 'saveCaptionEditOnEnter'
	    },
	    closeModal: function closeModal() {
	      if (this.options.modal) {
	        this.$el.modal('hide');
	      }
	    },
	    delegateModalEvents: function delegateModalEvents() {
	      this.$el.on('shown.bs.modal', this.verticallyCenterImage).on('shown.bs.modal', this.imageLoader).on('shown.bs.modal', this.enableGlobalArrowNav).on('shown.bs.modal', this.cacheScrollTop).on('hide.bs.modal', this.disableGlobalArrowNav).on('show.bs.modal', this.enableResizeHandler).on('shown.bs.modal', this.resizeHandler).on('shown.bs.modal', this.updateRoute).on('hide.bs.modal', this.clearRoute).on('hide.bs.modal', this.disableResizeHandler).on('hide.bs.modal', this.syncMiniSlideshowPosition).on('hide.bs.modal', this.restoreScrollTop);
	      $('body').on('keyup', this.hideOnEscape);
	    },
	    delegateCarouselEvents: function delegateCarouselEvents() {
	      this.$('.carousel').on('slid.bs.carousel', this.imageLoader).on('slid.bs.carousel', this.highlightActiveOnMap).on('slid.bs.carousel', this.verticallyCenterImage).on('slid.bs.carousel', this.updateRoute);
	    },
	    hideOnEscape: function hideOnEscape(e) {
	      if (e.keyCode === 27) this.closeModal();
	    },
	    clearRoute: function clearRoute() {
	      if (PhotosView.router) PhotosView.router.navigate("", { replace: true });
	    },
	    updateRoute: function updateRoute() {
	      if (PhotosView.router) PhotosView.router.navigate("photos/" + this.activePhotoId(), { replace: true });
	    },
	    cacheScrollTop: function cacheScrollTop() {
	      this._pageScrollTop = $(window).scrollTop();
	    },
	    restoreScrollTop: function restoreScrollTop() {
	      $(window).scrollTop(this._pageScrollTop);
	    },
	    cancelCaptionEdit: function cancelCaptionEdit(e) {
	      var $caption = this.$('.item.active .caption.can_modify');
	      $caption.html(this.prevCaptionHtml);
	      $caption.removeClass('editing');
	      e.stopPropagation();
	    },
	    saveCaptionEditOnEnter: function saveCaptionEditOnEnter(e) {
	      if (e.keyCode == 13) {
	        this.saveCaptionEdit();
	        return false;
	      }
	    },
	    saveCaptionEdit: function saveCaptionEdit(e) {
	      var $caption = this.$('.item.active .caption.can_modify');
	      var caption = $caption.find('input').val();
	      $caption.html('').text(caption);
	      var photoId = this.activePhotoId();
	      var params = { photos: {} };
	      params.photos[photoId] = { caption: caption };
	      Application.preventSpinner();
	      $.post('/photos/update_set', params);
	      $caption.removeClass('editing');
	      if (e) e.stopPropagation();
	    },
	    enableCaptionEditor: function enableCaptionEditor() {
	      var $caption = this.$('.item.active .caption.can_modify');
	      if ($caption.hasClass('editing')) return; // already editing.
	
	      this.prevCaptionHtml = $caption.html();
	      var caption = $caption.find('.nocaption').size() ? '' : $caption.text();
	      $caption.addClass('editing');
	      $caption.html('<form class="form-inline"><input type="text" maxlength="255"><a href="javascript:;" class="btn btn-default save">Save</a><a href="javascript:;" class="btn btn-default cancel">Cancel</a></form>');
	      $caption.find('input').val(caption).focus().select();
	      $caption.find('form').on('submit', function () {
	        return false;
	      });
	    },
	
	    enableResizeHandler: function enableResizeHandler() {
	      $(window).on('resize', this.throttledResizeHandler).resize();
	    },
	    disableResizeHandler: function disableResizeHandler() {
	      $(window).off('resize', this.throttledResizeHandler);
	    },
	    // make the slideshow scale to size of browser
	    resizeHandler: function resizeHandler() {
	      var containerHeight, containerWidth, imageContainerHeight;
	      if (this.photos.length == 0) {
	        containerWidth = this.$el.parent().width();
	        imageContainerHeight = 0;
	        containerHeight = 100;
	      } else if (this.options.modal) {
	        var availableWidth = $(window).width(),
	            availableHeight = $(window).height();
	        containerWidth = availableWidth * 0.8;
	        containerHeight = availableHeight * 0.95;
	        imageContainerHeight = containerHeight - 150;
	      } else {
	        containerWidth = this.$el.parent().width();
	        imageContainerHeight = containerWidth * 0.75;
	        containerHeight = imageContainerHeight + 100;
	      }
	      this.$el.find('.modal-dialog').width(containerWidth);
	      this.$el.find('.modal-content').height(containerHeight);
	      this.$('.carousel-control').height(imageContainerHeight);
	      this.$('.image_container').height(imageContainerHeight);
	      this.verticallyCenterImage();
	    },
	
	    carousel: function carousel() {
	      this.$('.carousel').carousel.apply(this.$('.carousel'), arguments);
	    },
	    // navigate to next/prev image with arrow keys
	    globalArrowNav: function globalArrowNav(e) {
	      if ($(e.target).is('input')) return;
	      if (e.keyCode === 37) {
	        this.prev();
	      } else if (e.keyCode === 39) {
	        this.next();
	      }
	    },
	    enableGlobalArrowNav: function enableGlobalArrowNav() {
	      $('body').on('keydown', this.globalArrowNav);
	    },
	    disableGlobalArrowNav: function disableGlobalArrowNav() {
	      $('body').off('keydown', this.globalArrowNav);
	    },
	    show: function show(slideTo) {
	      this.$el.modal();
	      this.carousel({ interval: 0 });
	      this.carousel(slideTo);
	    },
	    showById: function showById(photoId) {
	      var $item = this.$('img.ss_img[data-photo-id=' + photoId + ']').closest('.item'),
	          $items = $item.parent().children(),
	          idx = $items.index($item);
	      if (idx === -1) return;
	      this.show(idx);
	    },
	    syncMiniSlideshowPosition: function syncMiniSlideshowPosition() {
	      if (!this.photosView) return;
	      var $active = this.$('.item.active'),
	          $items = $active.parent().children(),
	          idx = $items.index($active);
	      // in case the active photo was deleted and was idx 0, need to slide forward first (bug in bootstrap carousel)
	      // no easy way to detect this so doing it if the one that was showing was deleted, regardless of index (doesnt hurt)
	      if (this.photosView.$('.item.active').size() == 0) {
	        this.photosView.next();
	      }
	      this.photosView.carousel(idx);
	    },
	    setHighlight: function setHighlight() {
	      var view = this,
	          photoId = this.activePhotoId();
	      $.post('/photosets/' + this.photosetId + '/photo/' + photoId + '/set_highlight', {
	        parent_type: this.parentType,
	        parent_id: this.parentId
	      }, function () {
	        view.$('.item.active .set_highlight').slideUp();
	      });
	    },
	    rotateCcw: function rotateCcw() {
	      this.rotate(-90);
	    },
	    rotateCw: function rotateCw() {
	      this.rotate(90);
	    },
	    rotate: function rotate(degrees) {
	      var view = this,
	          photoId = this.activePhotoId();
	      $.post('/photos/' + photoId + '/rotate.json', {
	        degrees: degrees
	      }, function () {
	        $('img.ss_img[data-photo-id=' + photoId + ']').each(function () {
	          if ($(this).attr('src')) {
	            $(this).attr('src', $(this).attr('src') + '?1'); // force reload
	          }
	        });
	        view.verticallyCenterImage();
	      });
	    },
	    removeOnConfirm: function removeOnConfirm() {
	      if (confirm("Are you sure you want to delete this photo?")) {
	        this.remove();
	      }
	    },
	    remove: function remove() {
	      var photoId = this.activePhotoId();
	      $.post('/photos/' + photoId + '.json', { _method: 'delete' });
	      // assume success, act now.  move to next in carousel, then remove indicator and item
	      // from modal slideshow as well as mini slideshow
	      this.next();
	      $('img.ss_img[data-photo-id=' + photoId + ']').closest('.item').remove();
	      $('.carousel-indicators li[data-photo-id=' + photoId + ']').each(function () {
	        // since we deleted a photo, all subsequent photos need to have their indexes updated.
	        $(this).nextAll().each(function () {
	          $(this).attr('data-slide-to', $(this).attr('data-slide-to') - 1);
	        });
	      }).remove();
	      // kill slideshows if they no longer have any photos, and close modal
	      var view = this;
	      if (this.options.modal) {
	        $('.mini_slideshow').each(function () {
	          if (!$(this).find('.item').size()) {
	            $(this).html('');
	            // and kill the modal
	            view.$el.modal('hide');
	          }
	        });
	      } else {
	        $('.photo_inline>.inner').each(function () {
	          if (!$(this).find('.item').size()) {
	            $(this).html('');
	          }
	        });
	      }
	      // if it is on the map, remove it
	      if (Routes && Routes.activeMap) {
	        var markers = Routes.activeMap.imageMarkers;
	        if (markers && markers[photoId]) {
	          markers[photoId].setMap(null);
	          if (Routes.activeMap.selectedImageMarker === markers[photoId]) {
	            Routes.activeMap.selectedImageMarker.setMap(null);
	            delete Routes.activeMap.selectedImageMarker;
	          }
	          delete markers[photoId];
	        }
	      }
	      var photo;
	      // finally, remove from photos collection
	      for (var i = 0; i < this.photos.length; i++) {
	        if (this.photos[i].id == photoId) {
	          photo = this.photos[i];
	          this.photos.splice(i, 1);
	          break;
	        }
	      }
	      if (this.photosView) this.photosView.trigger("photo:deleted", photo);
	    },
	
	    // for images that are constrained by width, vertically align if or when they are loaded.
	    verticallyCenterImage: function verticallyCenterImage() {
	      var $img = this.$('.item.active img.ss_img');
	      if (!$img.size()) return;
	
	      if ($img.get(0).height > 0) this._verticallyCenterImage($img);else {
	        $img.off('load');
	        var view = this;
	        $img.on('load', function () {
	          $img.data('loaded', true);
	          view._verticallyCenterImage($img);
	        });
	      }
	    },
	    // actually perform the centering -- the image is loaded!
	    _verticallyCenterImage: function _verticallyCenterImage($img) {
	      var img = $img.get(0),
	          w = img.width,
	          h = img.height,
	          $imgContainer = this.$('.item.active .image_container'),
	          maxW = $imgContainer.width(),
	          maxH = $imgContainer.height();
	      if (maxW === 0) {
	        // modal isn't loaded yet, so don't do anything stupid like move the image based on a max width of 0
	        return;
	      }
	
	      // We might actually know the dimensions, instead of reading them from the DOM where we may or may not have actually loaded the image yet
	      if ($img.attr('data-photo-id')) {
	        var photoId = parseInt($img.data('photo-id'), 10);
	        var photo = _.findWhere(this.photos, { id: photoId });
	        if (photo && _.has(photo, 'height') && _.has(photo, 'width')) {
	          w = photo.width;
	          h = photo.height;
	        }
	      }
	
	      if (w < maxW && h < maxH) {
	        // the image fits within our viewing area, so just center it.
	        $img.css({ marginTop: (maxH - h) / 2 + 'px' });
	      } else if (w / h > maxW / maxH) {
	        //constrained on width
	        var displayHeight = h * maxW / w;
	        $img.css({ marginTop: (maxH - displayHeight) / 2 + 'px' });
	      } else {
	        $img.css({ marginTop: 0 });
	      }
	      // done! let's show the image now.
	      $img.css({ visibility: 'visible' });
	    },
	    render: function render() {
	      this.$el.html(this.template({
	        carouselId: this.carouselId,
	        modal: this.options.modal
	      }));
	      var $indicators = this.$('.carousel-indicators'),
	          $items = this.$('.carousel-inner');
	      _.each(this.photos, function (photo, i) {
	        $indicators.append(this.indicatorTemplate({
	          carouselId: this.carouselId,
	          slideTo: i,
	          photoId: photo.id
	        }));
	        var uri = "http://" + window.location.host + window.location.pathname + "#photos/" + photo.id;
	        var itemTemplateOpts = {
	          photo: photo,
	          canEdit: this.canEdit,
	          belongsToPhotoset: this.photosetId,
	          shareBar: ''
	        };
	        if (!this.hideSharing) {
	          itemTemplateOpts.shareBar = this.shareBarTemplate({
	            assetType: "photo",
	            assetId: photo.id,
	            uri: uri,
	            tweet: "Check out this cool photo: " + uri
	          });
	        }
	        $items.append(this.itemTemplate(itemTemplateOpts));
	      }, this);
	      $indicators.find('li').first().addClass('active');
	      $items.find('.item').first().addClass('active');
	      this.carousel({ interval: 0 });
	      this.delegateCarouselEvents();
	
	      if (this.photos.length === 1) {
	        this.$('.carousel-control').hide();
	        this.$('.carousel-indicators').hide();
	      }
	
	      if (this.options.modal) {
	        this.delegateModalEvents();
	      } else {
	        $items.find('img.ss_img').slice(0, 2).each(function () {
	          $(this).attr('src', $(this).data('lazy-src')).css({ visibility: 'visible' });
	        });
	        this.enableResizeHandler();
	        // if there arent any photos, clear the carousel out.
	        if (!this.photos.length) {
	          this.$('.inner').html('');
	        }
	      }
	    }
	  });
	
	  PhotosRouter = Backbone.Router.extend({
	    routes: {
	      "photos/:id": "photo"
	    }
	  });
	
	  PhotosView.viewsByPhotoIds = {};
	  PhotosView.router = new PhotosRouter();
	  PhotosView.router.on("route:photo", function (photoId) {
	    if (PhotosView.viewsByPhotoIds[photoId]) {
	      PhotosView.viewsByPhotoIds[photoId].showPhotoById(photoId);
	    } else {
	      PhotosView.attemptedPhotoId = photoId;
	    }
	  });
	  PhotosView.registerPhotos = function (photos, view) {
	    var noClobber = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	    for (var i = 0; i < photos.length; i++) {
	      if (!noClobber || !PhotosView.viewsByPhotoIds[photos[i].id]) {
	        PhotosView.viewsByPhotoIds[photos[i].id] = view;
	      }
	      if (PhotosView.attemptedPhotoId && PhotosView.attemptedPhotoId == photos[i].id) {
	        PhotosView.attemptedPhotoId = undefined;
	        view.showPhotoById(photos[i].id);
	      }
	    }
	  };
	
	  // clean up photosview-managed DOM items when a photo is deleted outside this
	  // file
	  PhotosView.removeById = function (photoId) {
	    var photosView = PhotosView.viewsByPhotoIds[photoId];
	    if (!photosView) {
	      return false;
	    }
	    var photo = photosView.photos.find(function (p) {
	      return p.id === photoId;
	    });
	    if (!photo) {
	      return false;
	    }
	    if (photosView.activePhotoId() === photoId) {
	      photosView.next();
	    }
	
	    // used by the map to remove photos from POIs
	    photosView.trigger('photo:deleted', photo);
	
	    // remove from the underlying datasource on the resource gallery
	    photosView.photos = photosView.photos.filter(function (p) {
	      return p.id !== photoId;
	    });
	
	    // remove indicator and item from mini slideshows
	    $('img.ss_img[data-photo-id=' + photoId + ']').closest('.item').remove();
	    // kill slideshows if they no longer have any photos, and close modal
	    $('.mini_slideshow').each(function () {
	      if (!$(this).find('.item').size()) {
	        $(this).html('');
	      }
	    });
	    return true;
	  };
	
	  PhotosView.PhotosModalView = PhotosModalView;
	  module.exports = PhotosView;
	})();

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {"use strict";
	
	(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	        // Callback can either be a function or a string
	        if (typeof callback !== "function") {
	            callback = new Function("" + callback);
	        }
	        // Copy function arguments
	        var args = new Array(arguments.length - 1);
	        for (var i = 0; i < args.length; i++) {
	            args[i] = arguments[i + 1];
	        }
	        // Store and register the task
	        var task = { callback: callback, args: args };
	        tasksByHandle[nextHandle] = task;
	        registerImmediate(nextHandle);
	        return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	            case 0:
	                callback();
	                break;
	            case 1:
	                callback(args[0]);
	                break;
	            case 2:
	                callback(args[0], args[1]);
	                break;
	            case 3:
	                callback(args[0], args[1], args[2]);
	                break;
	            default:
	                callback.apply(undefined, args);
	                break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function registerImmediate(handle) {
	            process.nextTick(function () {
	                runIfPresent(handle);
	            });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function () {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function onGlobalMessage(event) {
	            if (event.source === global && typeof event.data === "string" && event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function registerImmediate(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function (event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function registerImmediate(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function registerImmediate(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function registerImmediate(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	})(typeof self === "undefined" ? typeof global === "undefined" ? undefined : global : self);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(76)))

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var scope = typeof global !== "undefined" && global || typeof self !== "undefined" && self || window;
	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function () {
	  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
	};
	exports.setInterval = function () {
	  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
	};
	exports.clearTimeout = exports.clearInterval = function (timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function () {};
	Timeout.prototype.close = function () {
	  this._clearFn.call(scope, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function (item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function (item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function (item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout) item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(96);
	// On some exotic environments, it's not clear which object `setimmediate` was
	// able to install onto.  Search each possibility in the same order as the
	// `setimmediate` library.
	exports.setImmediate = typeof self !== "undefined" && self.setImmediate || typeof global !== "undefined" && global.setImmediate || undefined && undefined.setImmediate;
	exports.clearImmediate = typeof self !== "undefined" && self.clearImmediate || typeof global !== "undefined" && global.clearImmediate || undefined && undefined.clearImmediate;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Cookie plugin
	 *
	 * Copyright (c) 2006 Klaus Hartl (stilbuero.de)
	 * Dual licensed under the MIT and GPL licenses:
	 * http://www.opensource.org/licenses/mit-license.php
	 * http://www.gnu.org/licenses/gpl.html
	 *
	 */
	
	/**
	 * Create a cookie with the given name and value and other optional parameters.
	 *
	 * @example $.cookie('the_cookie', 'the_value');
	 * @desc Set the value of a cookie.
	 * @example $.cookie('the_cookie', 'the_value', { expires: 7, path: '/', domain: 'jquery.com', secure: true });
	 * @desc Create a cookie with all available options.
	 * @example $.cookie('the_cookie', 'the_value');
	 * @desc Create a session cookie.
	 * @example $.cookie('the_cookie', null);
	 * @desc Delete a cookie by passing null as value. Keep in mind that you have to use the same path and domain
	 *       used when the cookie was set.
	 *
	 * @param String name The name of the cookie.
	 * @param String value The value of the cookie.
	 * @param Object options An object literal containing key/value pairs to provide optional cookie attributes.
	 * @option Number|Date expires Either an integer specifying the expiration date from now on in days or a Date object.
	 *                             If a negative value is specified (e.g. a date in the past), the cookie will be deleted.
	 *                             If set to null or omitted, the cookie will be a session cookie and will not be retained
	 *                             when the the browser exits.
	 * @option String path The value of the path atribute of the cookie (default: path of page that created the cookie).
	 * @option String domain The value of the domain attribute of the cookie (default: domain of page that created the cookie).
	 * @option Boolean secure If true, the secure attribute of the cookie will be set and the cookie transmission will
	 *                        require a secure protocol (like HTTPS).
	 * @type undefined
	 *
	 * @name $.cookie
	 * @cat Plugins/Cookie
	 * @author Klaus Hartl/klaus.hartl@stilbuero.de
	 */
	
	/**
	 * Get the value of a cookie with the given name.
	 *
	 * @example $.cookie('the_cookie');
	 * @desc Get the value of a cookie.
	 *
	 * @param String name The name of the cookie.
	 * @return The value of the cookie.
	 * @type String
	 *
	 * @name $.cookie
	 * @cat Plugins/Cookie
	 * @author Klaus Hartl/klaus.hartl@stilbuero.de
	 */
	jQuery.cookie = function (name, value, options) {
	    if (typeof value != 'undefined') {
	        // name and value given, set cookie
	        options = options || {};
	        if (value === null) {
	            value = '';
	            options.expires = -1;
	        }
	        var expires = '';
	        if (options.expires && (typeof options.expires == 'number' || options.expires.toUTCString)) {
	            var date;
	            if (typeof options.expires == 'number') {
	                date = new Date();
	                date.setTime(date.getTime() + options.expires * 24 * 60 * 60 * 1000);
	            } else {
	                date = options.expires;
	            }
	            expires = '; expires=' + date.toUTCString(); // use expires attribute, max-age is not supported by IE
	        }
	        // CAUTION: Needed to parenthesize options.path and options.domain
	        // in the following expressions, otherwise they evaluate to undefined
	        // in the packed version for some reason...
	        var path = options.path ? '; path=' + options.path : '';
	        var domain = options.domain ? '; domain=' + options.domain : '';
	        var secure = options.secure ? '; secure' : '';
	        document.cookie = [name, '=', encodeURIComponent(value), expires, path, domain, secure].join('');
	    } else {
	        // only name given, get cookie
	        var cookieValue = null;
	        if (document.cookie && document.cookie != '') {
	            var cookies = document.cookie.split(';');
	            for (var i = 0; i < cookies.length; i++) {
	                var cookie = jQuery.trim(cookies[i]);
	                // Does this cookie string begin with the name we want?
	                if (cookie.substring(0, name.length + 1) == name + '=') {
	                    cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
	                    break;
	                }
	            }
	        }
	        return cookieValue;
	    }
	};

/***/ }),
/* 146 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	* hoverIntent is similar to jQuery's built-in "hover" function except that
	* instead of firing the onMouseOver event immediately, hoverIntent checks
	* to see if the user's mouse has slowed down (beneath the sensitivity
	* threshold) before firing the onMouseOver event.
	* 
	* hoverIntent r5 // 2007.03.27 // jQuery 1.1.2+
	* <http://cherne.net/brian/resources/jquery.hoverIntent.html>
	* 
	* hoverIntent is currently available for use in all personal or commercial 
	* projects under both MIT and GPL licenses. This means that you can choose 
	* the license that best suits your project, and use it accordingly.
	* 
	* // basic usage (just like .hover) receives onMouseOver and onMouseOut functions
	* $("ul li").hoverIntent( showNav , hideNav );
	* 
	* // advanced usage receives configuration object only
	* $("ul li").hoverIntent({
	*	sensitivity: 7, // number = sensitivity threshold (must be 1 or higher)
	*	interval: 100,   // number = milliseconds of polling interval
	*	over: showNav,  // function = onMouseOver callback (required)
	*	timeout: 0,   // number = milliseconds delay before onMouseOut function call
	*	out: hideNav    // function = onMouseOut callback (required)
	* });
	* 
	* @param  f  onMouseOver function || An object with configuration options
	* @param  g  onMouseOut function  || Nothing (use configuration options object)
	* @author    Brian Cherne <brian@cherne.net>
	*/
	(function ($) {
		$.fn.hoverIntent = function (f, g) {
			// default configuration options
			var cfg = {
				sensitivity: 7,
				interval: 100,
				timeout: 0
			};
			// override configuration options with user supplied object
			cfg = $.extend(cfg, g ? { over: f, out: g } : f);
	
			// instantiate variables
			// cX, cY = current X and Y position of mouse, updated by mousemove event
			// pX, pY = previous X and Y position of mouse, set by mouseover and polling interval
			var cX, cY, pX, pY;
	
			// A private function for getting mouse position
			var track = function track(ev) {
				cX = ev.pageX;
				cY = ev.pageY;
			};
	
			// A private function for comparing current and previous mouse position
			var compare = function compare(ev, ob) {
				ob.hoverIntent_t = clearTimeout(ob.hoverIntent_t);
				// compare mouse positions to see if they've crossed the threshold
				if (Math.abs(pX - cX) + Math.abs(pY - cY) < cfg.sensitivity) {
					$(ob).unbind("mousemove", track);
					// set hoverIntent state to true (so mouseOut can be called)
					ob.hoverIntent_s = 1;
					return cfg.over.apply(ob, [ev]);
				} else {
					// set previous coordinates for next time
					pX = cX;pY = cY;
					// use self-calling timeout, guarantees intervals are spaced out properly (avoids JavaScript timer bugs)
					ob.hoverIntent_t = setTimeout(function () {
						compare(ev, ob);
					}, cfg.interval);
				}
			};
	
			// A private function for delaying the mouseOut function
			var delay = function delay(ev, ob) {
				ob.hoverIntent_t = clearTimeout(ob.hoverIntent_t);
				ob.hoverIntent_s = 0;
				return cfg.out.apply(ob, [ev]);
			};
	
			// A private function for handling mouse 'hovering'
			var handleHover = function handleHover(e) {
				// next three lines copied from jQuery.hover, ignore children onMouseOver/onMouseOut
				var p = (e.type == "mouseover" ? e.fromElement : e.toElement) || e.relatedTarget;
				while (p && p != this) {
					try {
						p = p.parentNode;
					} catch (e) {
						p = this;
					}
				}
				if (p == this) {
					return false;
				}
	
				// copy objects to be passed into t (required for event object to be passed in IE)
				var ev = jQuery.extend({}, e);
				var ob = this;
	
				// cancel hoverIntent timer if it exists
				if (ob.hoverIntent_t) {
					ob.hoverIntent_t = clearTimeout(ob.hoverIntent_t);
				}
	
				// else e.type == "onmouseover"
				if (e.type == "mouseover") {
					// set "previous" X and Y position based on initial entry point
					pX = ev.pageX;pY = ev.pageY;
					// update "current" X and Y position based on mousemove
					$(ob).bind("mousemove", track);
					// start polling interval (self-calling timeout) to compare mouse coordinates over time
					if (ob.hoverIntent_s != 1) {
						ob.hoverIntent_t = setTimeout(function () {
							compare(ev, ob);
						}, cfg.interval);
					}
	
					// else e.type == "onmouseout"
				} else {
					// unbind expensive mousemove event
					$(ob).unbind("mousemove", track);
					// if hoverIntent state is true, then call the mouseOut function after the specified delay
					if (ob.hoverIntent_s == 1) {
						ob.hoverIntent_t = setTimeout(function () {
							delay(ev, ob);
						}, cfg.timeout);
					}
				}
			};
	
			// bind the function to the two event listeners
			return this.mouseover(handleHover).mouseout(handleHover);
		};
	})(jQuery);

/***/ }),
/* 147 */,
/* 148 */
/***/ (function(module, exports) {

	'use strict';
	
	(function ($) {
	  $.fn.pointOut = function (title, description, adjust_position, callback) {
	    var goleft = this.offset().left < $(document).width() / 2;
	
	    if (!description) description = '';
	    var popup = $('<div class="pointer" style="' + (goleft ? 'text-align:left' : 'text-align:right') + '"><h2>' + (goleft ? '&larr; ' + title : title + ' &rarr;') + '</h2><p>' + description + '</p></div>');
	    $('body').prepend(popup);
	    popup.hide();
	
	    var offset = this.offset();
	
	    var ot, ol, adjust_x, adjust_y;
	
	    if (adjust_position instanceof Array) {
	      adjust_y = adjust_position[0];
	      adjust_x = adjust_position[1];
	    } else if (adjust_position != null) {
	      adjust_y = adjust_position;
	      adjust_x = 0;
	    } else {
	      adjust_y = 0;
	      adjust_x = 0;
	    }
	
	    ot = offset.top + adjust_y;
	    ol = offset.left + adjust_x;
	
	    if (ot > $(window).height() - 70) {
	      ot = $(window).height() - 70;
	      $(this).closest('.overflowing').scrollTo(ot, 200);
	    } else if (ot < 32) {
	      ot = 42;
	      $(this).closest('.overflowing').scrollTo(0, 200);
	    }
	
	    if (goleft) {
	      popup.css({ top: 0, left: ol + this.outerWidth() + 208 });
	      popup.animate({ top: ot - 50, left: ol + this.outerWidth() + 208, opacity: "show" }, 500);
	      popup.animate({ top: ot - 10, left: ol + this.outerWidth() + 3 }, 400);
	    } else {
	      popup.css({ top: 0, left: ol - popup.outerWidth() - 208 });
	      popup.animate({ top: ot - 50, left: ol - popup.outerWidth() - 208, opacity: "show" }, 500);
	      popup.animate({ top: ot - 10, left: ol - popup.outerWidth() - 3 }, 400);
	    }
	    setTimeout(function () {
	      popup.fadeOut(function () {
	        $(this).remove();
	      });
	    }, 3000);
	    if (callback) setTimeout(callback, 1500);
	    return false;
	  };
	})(jQuery);

/***/ }),
/* 149 */
/***/ (function(module, exports) {

	'use strict';
	
	/* ------------------------------------------------------------------------
	  Class: prettyLoader
	  Use: A unified solution for AJAX loader
	  Author: Stephane Caron (http://www.no-margin-for-errors.com)
	  Version: 1.0.1
	------------------------------------------------------------------------- */
	
	(function ($) {
	  $.prettyLoader = { version: '1.0.1' };
	
	  $.prettyLoader = function (settings) {
	    settings = jQuery.extend({
	      animation_speed: 'fast', /* fast/normal/slow/integer */
	      bind_to_ajax: true, /* true/false */
	      delay: false, /* false OR time in milliseconds (ms) */
	      loader: '/images/prettyLoader/ajax-loader.gif?2000000000', /* Path to your loader gif */
	      offset_top: 13, /* integer */
	      offset_left: 10 /* integer */
	    }, settings);
	
	    var scrollPos = _getScroll();
	
	    var imgLoader = new Image();
	    imgLoader.onerror = function () {
	      //alert('Preloader image cannot be loaded. Make sure the path is correct in the settings and that the image is reachable.');
	    };
	    imgLoader.src = settings.loader;
	
	    if (settings.bind_to_ajax) jQuery(document).ajaxStart(function () {
	      $.prettyLoader.show(5000);
	    }).ajaxStop(function () {
	      $.prettyLoader.hide();
	    });
	
	    var cur_x = 0,
	        cur_y = 0;
	    $.prettyLoader.positionLoader = function (e) {
	      e = e ? e : window.event;
	
	      // Set the cursor pos only if the even is returned by the browser.
	      if (e.clientX) cur_x = e.clientX;
	      if (e.clientY) cur_y = e.clientY;
	
	      var left_pos = cur_x + settings.offset_left + scrollPos['scrollLeft'];
	      var top_pos = cur_y + settings.offset_top + scrollPos['scrollTop'];
	
	      $('.prettyLoader').css({
	        'top': top_pos,
	        'left': left_pos
	      });
	    };
	    function onScrollHandler() {
	      scrollPos = _getScroll();
	      $(document).triggerHandler('mousemove');
	    }
	
	    $.prettyLoader.show = function (delay) {
	      if ($('.prettyLoader').length > 0) return;
	
	      // Get the scroll position
	      scrollPos = _getScroll();
	
	      // Build the loader container
	      $('<div></div>').addClass('prettyLoader').addClass('prettyLoader_' + settings.theme).appendTo('body').hide();
	
	      // Build the loader image
	      $('<img />').attr('src', settings.loader).appendTo('.prettyLoader');
	
	      // Show it!
	      $('.prettyLoader').fadeIn(settings.animation_speed);
	      $('.prettyLoader').css({ top: -200, left: -200 });
	
	      $(document).bind('click', $.prettyLoader.positionLoader);
	      $(document).bind('mousemove', $.prettyLoader.positionLoader);
	      $(window).scroll(onScrollHandler);
	
	      delay = delay ? delay : settings.delay;
	
	      if (delay) {
	        setTimeout(function () {
	          $.prettyLoader.hide();
	        }, delay);
	      }
	    };
	
	    $.prettyLoader.hide = function () {
	      $(document).unbind('click', $.prettyLoader.positionLoader);
	      $(document).unbind('mousemove', $.prettyLoader.positionLoader);
	      $(window).unbind('scroll', onScrollHandler);
	
	      $('.prettyLoader').fadeOut(settings.animation_speed, function () {
	        $(this).remove();
	      });
	    };
	
	    function _getScroll() {
	      if (self.pageYOffset) {
	        return { scrollTop: self.pageYOffset, scrollLeft: self.pageXOffset };
	      } else if (document.documentElement && document.documentElement.scrollTop) {
	        // Explorer 6 Strict
	        return { scrollTop: document.documentElement.scrollTop, scrollLeft: document.documentElement.scrollLeft };
	      } else if (document.body) {
	        // all other Explorers
	        return { scrollTop: document.body.scrollTop, scrollLeft: document.body.scrollLeft };
	      }
	    }
	
	    return this;
	  };
	})(jQuery);

/***/ }),
/* 150 */
/***/ (function(module, exports) {

	"use strict";
	
	(function () {
	  var filter = {};
	
	  filter.LowPass = function (x, y, smoothingMult) {
	    this.x = x;
	    this.y = y;
	    var avgXDiff = (x[x.length - 1] - x[0]) / x.length;
	    this.smoothing = smoothingMult * avgXDiff;
	  };
	  filter.LowPass.prototype = {
	    filter: function filter() {
	      var value;
	      var xpt, xprev, ypt, yprev;
	      for (var i = 0, len = this.y.length; i < len; i++) {
	        if (!_.isNumber(this.x[i]) || !_.isNumber(this.y[i])) continue;
	        if (!_.isNumber(value)) value = this.y[i];
	        xprev = xpt;
	        yprev = ypt;
	        xpt = this.x[i];
	        ypt = this.y[i];
	        if (!_.isNumber(xprev) || !_.isNumber(yprev)) continue;
	        var xDiff = xpt - xprev;
	        var adj = this.smoothing / xDiff;
	        if (adj < 1) adj = 1;
	        value += (ypt - value) / adj;
	        this.y[i] = value;
	      }
	      return this.y;
	    }
	  };
	
	  filter.MovingAverage = function (x, y) {
	    this.x = x;
	    this.y = y;
	    this.winWidth = 150;
	    this.kernelWidth = 7;
	  };
	  filter.MovingAverage.prototype = {
	    filter: function filter() {
	      //window size has to be even
	      var z = (this.kernelWidth - 1) / 2; //used to calc indices
	      var s = 0; //point start index
	      var e = 0; //point end index
	      var width = 0;
	      var result = new Array(this.x.length);
	
	      for (var i = 0; i < this.x.length; i++) {
	        s = i - z;
	        e = i + z;
	
	        while (s < 0) {
	          s += 1;
	        }
	        while (e >= this.y.length) {
	          e -= 1;
	        }
	
	        if (this.winWidth > 0) {
	          width = this.x[e] - this.x[s];
	          while (width > this.winWidth) {
	            if (s + 1 <= i && e - i <= i - s) {
	              s += 1;
	            }
	            if (e - 1 >= i && e - 1 >= i - s) {
	              e -= 1;
	            }
	            width = this.x[e] - this.x[s];
	          }
	        }
	        //trace(e-s)
	
	        var sum = 0;
	        for (var j = s; j <= e; j += 1) {
	          sum += this.y[j];
	        }
	        result[i] = sum / (e - s + 1);
	      }
	      return result;
	    }
	  };
	
	  filter.DJFilter = function (points, tau) {
	    this.points = points;
	    this.tau = tau || 30; //30 seconds default
	  };
	  filter.DJFilter.prototype = {
	    filter: function filter() {
	      var directions = [-1, 1];
	      var yPrev, xPrev, ySmooth;
	
	      for (var a = 0; a < directions.length; a++) {
	        var direction = directions[a];
	
	        for (var i = 0; i < this.points.length; i++) {
	          var n = direction == 1 ? i : this.points.length - 1 - i;
	
	          var x = this.points[n].x;
	          var y = this.points[n].y;
	
	          if (ySmooth == null || xPrev == null || yPrev == null) {
	            ySmooth = y;
	          } else {
	            var u = Math.abs(x - xPrev) / this.tau;
	            var z = Math.exp(-u);
	            var dy = y - yPrev;
	
	            if (u > 0) {
	              ySmooth = ySmooth * z + y * (1 - z) + dy / u * ((u + 1) * z - 1);
	            }
	          }
	
	          //trace([y, ySmooth])
	          yPrev = y;
	          xPrev = x;
	
	          if (direction == -1) {
	            this.points[n].ySmooth = ySmooth;
	          } else {
	            this.points[n].ySmooth = (this.points[n].ySmooth + ySmooth) / 2;
	          }
	        }
	      }
	      return _.map(this.points, function (pt) {
	        return pt.ySmooth;
	      });
	    }
	  };
	
	  filter.Filter = function () {};
	  filter.Filter.prototype = {
	    filter: function filter() {
	      //window size has to be even
	      var z = 0; //used to calc indices
	      var s = 0; //point start index
	      var e = 0; //point end index
	      var ks = 0; //kernel start index
	      var ke = 0; //kernel end index
	      var width = 0;
	      var usedKern;
	      var neighbors;
	      var result = new Array(this.x.length);
	      var kernels = [];
	
	      z = (this.kernel.length - 1) / 2;
	      for (var i = 0; i < this.x.length; i++) {
	        var val = 0; //used to push new value into returned array
	        s = i - z;
	        e = i + z;
	        ks = 0;
	        ke = this.kernel.length - 1;
	
	        while (s < 0) {
	          s += 1;ks += 1;
	        }
	        while (e >= this.x.length) {
	          e -= 1;ke -= 1;
	        }
	
	        if (this.winWidth > 0) {
	          width = this.x[e] - this.x[s];
	          while (width > this.winWidth) {
	            if (s + 1 <= i && e - i <= i - s) {
	              s += 1;
	              ks += 1;
	            }
	            if (e - 1 >= i && e - 1 >= i - s) {
	              e -= 1;
	              ke -= 1;
	            }
	            width = this.x[e] - this.x[s];
	          }
	        }
	
	        //be somewhat efficient and cache reuseable kernels
	        if (kernels[ke + 1 - ks]) {
	          usedKern = kernels[ke + 1 - ks];
	        } else {
	          usedKern = this.normalizeKernel(this.kernel.slice(ks, ke + 1));
	          kernels[ke + 1 - ks] = usedKern;
	        }
	
	        neighbors = new Array(e - s);
	        var index = 0;
	        for (var j = s; j <= e; j += 1) {
	          //if(j >= 0 && j < this.y.length)
	          neighbors[index] = this.y[j];
	          index += 1;
	        }
	
	        for (j = 0; j < neighbors.length; j++) {
	          val += neighbors[j] * usedKern[j];
	        }
	        result[i] = Math.round(val * 1000.0) / 1000.0;
	      }
	      return result;
	    },
	
	    createSincKernel: function createSincKernel(kernSize, freq) {
	      if (kernSize == 1) return [1];
	      var kern = new Array(kernSize);
	      var x = 0;
	
	      for (var i = 0; i <= kernSize; i++) {
	        kern[i] = 0.54 - 0.46 * Math.cos(2 * Math.PI * i / kernSize);
	        x = i - kernSize / 2;
	        if (x == 0) kern[i] = kern[i] * 2 * Math.PI * freq;else kern[i] = kern[i] * Math.sin(2 * Math.PI * freq * x) / x;
	      }
	
	      return kern;
	    },
	
	    createGaussianKernel: function createGaussianKernel(kernSize, sd) {
	      if (kernSize == 1) return [1];
	      var kern = new Array(kernSize);
	
	      for (var i = 0; i <= kernSize; i++) {
	        kern[i] = 1 / (Math.sqrt(2 * Math.PI) * sd) * Math.exp(-0.5 * Math.pow(i / sd, 2));
	      }
	      return kern;
	    },
	
	    normalizeKernel: function normalizeKernel(kern) {
	      var i = 0,
	          norm = 0;
	      var newkern = new Array(kern.length);
	
	      for (i = 0; i < kern.length; i++) {
	        norm += kern[i];
	      }
	      for (i = 0; i < kern.length; i++) {
	        newkern[i] = kern[i] / norm;
	      }
	      return newkern;
	    }
	  };
	
	  filter.GaussianFilter = function (x, y, start, sd, winWidth) {
	    var startn = startn || 10;
	    sd = sd || 8.0;
	    var usedn = startn > x.length ? x.length % 2 != 0 ? x.length + 1 : x.length : startn;
	
	    this.x = x;
	    this.y = y;
	    this.winWidth = winWidth || 100;
	    this.kernel = this.createGaussianKernel(usedn, sd);
	  };
	  filter.GaussianFilter.prototype = new filter.Filter();
	
	  filter.SincFilter = function (x, y, startn, freq, winWidth) {
	    startn = startn || 10;
	    freq = freq || 0.04;
	    var usedn = startn > x.length ? x.length % 2 != 0 ? x.length + 1 : x.length : startn;
	
	    this.x = x;
	    this.y = y;
	    this.winWidth = winWidth || 100;
	    this.kernel = this.createSincKernel(usedn, freq);
	  };
	  filter.SincFilter.prototype = new filter.Filter();
	
	  filter.SavitskyGolayFilter = function (x, y) {
	    this.x = x;
	    this.y = y;
	    this.winWidth = 0; //100;
	    this.kernel = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
	    //this.kernel = this.createSGKernel();
	  };
	  filter.SavitskyGolayFilter.prototype = new filter.Filter();
	  module.exports = filter;
	})();

/***/ }),
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */
/***/ (function(module, exports) {

	'use strict';
	
	/* 
	 * This does a similar thing to what you'll find in lib.js
	 *
	 * Why have both? 
	 *
	 * lib.js was created for external sites, and the widget it currently supports 
	 * expects the external widget css to be loaded, which we don't want to use for 
	 * widgets on our site.  It has a reset and everything is !important - it doesn't
	 * match the style of the rwgps site.
	 *
	 * It also uses a stubbed rwgps ready function that is pretty much the same as what 
	 * you'll find in rwgps.js (lets you do rwgps(function() { }) which will execute once 
	 * the rwgps reqs are loaded) but it maintains its own list of functions to run, etc.
	 * Not interested in having both in place.
	 *
	 * So for now... going to build compatible widgets in here which will load their own deps
	 * and whatnot, and once we have a widget that needs to be both internally and 
	 * externally used, we can reconcile this with lib.js
	 *
	 * Also, lib.js uses tunnel.html and easyXDM for rwgps.api.  This file supplies a 
	 * stubbed version that doesn't need to jump through those hoops (more shit to reconcile)
	 */
	(function (rwgps) {
	  // first let's define the on-site version of rwgps.api, contrast with what's in lib.js
	  // interface is the same though, so callers dont have to be changed once its reconciled
	  rwgps.api = function (endpoint, method, params, callback) {
	    /** clean up endpoint **/
	    if (/^\//.test(endpoint)) {
	      // remove leading slash
	      endpoint = endpoint.slice(1);
	    }
	    if (!/\.json/.test(endpoint)) {
	      // append .json 
	      endpoint += '.json';
	    }
	    // tunnel.html does endpoint validation but we trust ourselves so not going to bother
	    if (!/^get|post|put|delete$/i.test(method)) {
	      callback = params;
	      params = method;
	      method = 'get';
	    }
	    if (typeof params === 'function') {
	      callback = params;
	      params = {};
	    }
	    var options = {
	      url: '/' + endpoint,
	      data: params,
	      type: method
	    };
	    options.complete = function (xhr) {
	      if (xhr.status !== 200) {
	        throw { name: 'BadResponseError' };
	      } else {
	        callback(JSON.parse(xhr.responseText));
	      }
	    };
	    jQuery.ajax(options);
	  };
	  // loadScript and loadStylesheet are just copied from sdk.js FYI 
	  rwgps.loadScript = function (url, callback) {
	    var script = document.createElement('script');
	    script.async = true;
	    script.src = url;
	    var entry = document.getElementsByTagName('script')[0];
	    entry.parentNode.insertBefore(script, entry);
	    script.onload = script.onreadystatechange = function () {
	      var readyState = script.readyState;
	      if (!readyState || /complete|loaded/.test(script.readyState)) {
	        callback();
	        script.onload = null;
	        script.onreadystatechange = null;
	      }
	    };
	  };
	  rwgps.loadStylesheet = function (href, cb) {
	    var link = document.createElement("link"),
	        onload = function onload() {
	      if (!done) {
	        done = 1;
	        link.removeAttribute("id");
	        setTimeout(cb, 0);
	      }
	    },
	        id = "rwgps" + +new Date(),
	        ref,
	        done;
	    cb = cb || function () {};
	
	    link.href = href;
	    link.rel = "stylesheet";
	    link.type = "text/css";
	    link.id = id;
	
	    ref = document.getElementsByTagName('script')[0];
	    ref.parentNode.insertBefore(link, ref);
	    link.onload = onload;
	
	    function poll() {
	      try {
	        var sheets = document.styleSheets;
	        for (var j = 0, k = sheets.length; j < k; j++) {
	          if (sheets[j].ownerNode.id == id) {
	            // this throws an exception, I believe, if not full loaded (was originally just "sheets[j].cssRules;")
	            if (sheets[j].cssRules.length) return onload();
	          }
	        }
	        // if we get here, its not in document.styleSheets (we never saw the ID)
	        throw new Error();
	      } catch (e) {
	        // Keep polling
	        setTimeout(poll, 20);
	      }
	    }
	    poll();
	  };
	
	  // alright we're done stubbing stuff and copy-pasting things onto the real code
	
	  // make new widgets by assigning new instance to prototype, see examples below
	  rwgps.widget = function () {
	    this.initialize.apply(this, arguments);
	    this._afterLoaded = [];
	  };
	  rwgps.widget.prototype = {
	    // optionally override 
	    initialize: function initialize() {},
	    deps: [], // override this to be an array of dependencies (will be loaded in parallel)
	    // implement this, it will get called by render after deps are loaded
	    renderSync: function renderSync() {
	      throw "renderSync not implemented";
	    },
	    loaded: function loaded(fn) {
	      if (this._loaded) fn();else this._afterLoaded.push(fn);
	      this.load();
	    },
	    load: function load() {
	      if (this._loading) return;
	      this._loading = true;
	      var that = this;
	      async.forEach(this.deps, function (dep, cb) {
	        if (/\.js$/.test(dep)) {
	          rwgps.loadScript(dep, cb);
	        } else if (/\.css$/.test(dep)) {
	          rwgps.loadStylesheet(dep, cb);
	        } else {
	          cb("Unrecognized file type " + dep);
	        }
	      }, function () {
	        that.loadComplete();
	      });
	    },
	    loadComplete: function loadComplete() {
	      while (this._afterLoaded.length) {
	        this._afterLoaded.pop()();
	      }this._loaded = true;
	    },
	    render: function render() {
	      var that = this;
	      this.loaded(function () {
	        that.renderSync.apply(that, arguments);
	      });
	    }
	  };
	  // specialized version of backbone's implementation for Model/Collection/etc.extend
	  rwgps.widget.extend = function (protoProps) {
	    var parent = this;
	    var child = function child() {
	      return parent.apply(this, arguments);
	    };
	    var Surrogate = function Surrogate() {
	      this.constructor = child;
	    };
	    Surrogate.prototype = parent.prototype;
	    child.prototype = new Surrogate();
	    _.extend(child.prototype, protoProps);
	    return child;
	  };
	
	  rwgps.widget.RouteSelector = rwgps.widget.extend({
	    initialize: function initialize($el) {
	      this.target = $el;
	      this.sortField = 'createdAt';
	      this.sortDir = -1;
	    },
	    deps: ['/javascripts/strftime.min.js', '/javascripts/select2.min.js', '/stylesheets/select2.min.css'],
	    formatOption: function formatOption(option) {
	      var data = $(option.element).data();
	      if (data.distance && data.createdAt) {
	        return option.text + "<div style='float:right;font-style:italic;'>" + rwgps.LabelMaker.longLabel(data.distance, true) + " - " + rwgps.DateExt.parse(data.createdAt).strftime("%Y-%m-%d") + "</div><div style='clear:right'></div>";
	      } else {
	        return option.text;
	      }
	    },
	    renderSync: function renderSync() {
	      var $el = this.target;
	      var widget = this;
	      $el.select2({
	        matcher: function matcher(term, text) {
	          return text.toLowerCase().score(term.toLowerCase());
	        },
	        sortResults: function sortResults(results, container, query) {
	          if (query.term != '') {
	            container.parent().find('.route-selector-sorter').hide();
	            return _.sortBy(results, function (result) {
	              return -result.text.toLowerCase().score(query.term.toLowerCase());
	            });
	          } else {
	            container.parent().find('.route-selector-sorter').show();
	            var sortField = widget.sortField;
	            var sorted = _.sortBy(results, function (result) {
	              if (sortField === 'createdAt') {
	                return widget.sortDir * rwgps.DateExt.parse($(result.element).data(sortField)).getTime();
	              } else if (sortField === 'name') {
	                return result.text;
	              } else {
	                return widget.sortDir * $(result.element).data(widget.sortField);
	              }
	            });
	            if (sortField === 'name' && widget.sortDir === -1) {
	              sorted.reverse();
	            }
	            return sorted;
	          }
	        },
	        width: '400px',
	        placeholder: $el.attr('data-rwgps-widget-placeholder'),
	        allowClear: true,
	        formatResult: this.formatOption
	      });
	      $el.select2('container').data('widget', widget);
	      // render sorting options
	      $el.on('open', function () {
	        var that = this;
	        $('.select2-with-searchbox').each(function () {
	          var $container = $(this);
	          if ($container.find('.route-selector-sorter').size() === 0) {
	            var $sorter = $('<div class="route-selector-sorter" style="margin-top:4px;float:right;">' + T.t('sort_by') + ': <a href="javascript:;" class="route-selector-sort-by" data-sort-by="name">' + T.t('name') + '</a>, <a href="javascript:;" class="route-selector-sort-by" data-sort-by="distance">' + T.t('distance') + '</a>, <a href="javascript:;" class="route-selector-sort-by" data-sort-by="createdAt" style="font-weight:bold">' + T.t('date') + '</a></div>');
	            $container.find('.select2-search').append($sorter);
	            $(that).select2('positionDropdown');
	            $sorter.on('click', '.route-selector-sort-by', function () {
	              var widget = $('.select2-container-active').data('widget');
	              $(this).siblings('.route-selector-sort-by').css({ fontWeight: 'normal' });
	              $(this).css({ fontWeight: 'bold' });
	              var oldDir = $(this).data('sort-dir');
	              widget.sortField = $(this).data('sort-by');
	              widget.sortDir = oldDir == 1 ? -1 : 1;
	              $(this).data('sort-dir', widget.sortDir);
	              // this requires adding updateResults to the allowedMethods in select2.js
	              $('.select2-container-active').select2('updateResults');
	            });
	          }
	        });
	      });
	    }
	  });
	
	  // $el is optional - search whole page for widgets, or search $el
	  rwgps.widget.findAndRender = function ($el) {
	    $(function () {
	      var $col = $el ? $el.find('.rwgps-widget') : $('.rwgps-widget');
	      $col.each(function () {
	        var $this = $(this),
	            type = $this.attr('data-rwgps-widget-type');
	        // prevent it from getting rendered again
	        $this.removeClass('rwgps-widget');
	        switch (type) {
	          case 'route-selector':
	            var rs = new rwgps.widget.RouteSelector($this);
	            rs.render();
	            break;
	        }
	      });
	    });
	  };
	
	  // initialize any widgets on the page
	  rwgps.widget.findAndRender();
	})(rwgps);

/***/ }),
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */
/***/ (function(module, exports) {

	'use strict';
	
	rwgps.ns('pages.home', function () {
	  var ns = this;
	  var detailsRef = void 0;
	  var stepsRef = void 0;
	  var onScroll = void 0;
	  var photoRefs = void 0;
	  var numberRefs = void 0;
	  var numberLineRefs = void 0;
	  var detailRefs = void 0;
	  var step = 1;
	
	  ns.init = function () {
	    stepsRef = $('.steps').get(0);
	    detailsRef = $('.steps .details').get(0);
	    photoRefs = $('.steps .photos img').toArray();
	    numberRefs = $('.steps .number').toArray();
	    numberLineRefs = $('.steps .number img').toArray();
	    detailRefs = $('.steps .detail').toArray();
	    var scrollAnimation = void 0;
	    window.addEventListener('scroll', function () {
	      if (scrollAnimation) {
	        window.cancelAnimationFrame(scrollAnimation);
	      }
	      scrollAnimation = window.requestAnimationFrame(onScroll);
	    });
	    onScroll();
	  };
	
	  var setStep = function setStep(newStep) {
	    $(detailRefs[step - 1]).removeClass('active');
	    $(numberRefs[step - 1]).removeClass('active');
	    step = newStep;
	    $(detailRefs[step - 1]).addClass('active');
	    $(numberRefs[step - 1]).addClass('active');
	
	    switch (step) {
	      case 1:
	        $(numberLineRefs[0]).removeClass('active');
	        $(numberLineRefs[1]).removeClass('active');
	        break;
	      case 2:
	        $(numberLineRefs[0]).addClass('active');
	        $(numberLineRefs[1]).removeClass('active');
	        break;
	      case 3:
	        $(numberLineRefs[0]).addClass('active');
	        $(numberLineRefs[1]).addClass('active');
	        break;
	    }
	  };
	
	  onScroll = function onScroll() {
	    if (window.pageYOffset >= stepsRef.offsetTop) {
	      if (window.pageYOffset >= photoRefs[2].offsetTop) {
	        detailsRef.style.position = 'absolute';
	        detailsRef.style.top = photoRefs[2].offsetTop + 'px';
	      } else {
	        detailsRef.style.position = 'fixed';
	        detailsRef.style.top = 0;
	      }
	    } else {
	      detailsRef.style.position = 'relative';
	      detailsRef.style.top = 0;
	    }
	
	    var offsetBuffer = 400;
	    if (window.pageYOffset > photoRefs[2].offsetTop - offsetBuffer) {
	      if (step !== 3) {
	        setStep(3);
	      }
	    } else if (window.pageYOffset > photoRefs[1].offsetTop - offsetBuffer) {
	      if (step !== 2) {
	        setStep(2);
	      }
	    } else {
	      if (step !== 1) {
	        setStep(1);
	      }
	    }
	  };
	});
	
	rwgps.ns('pages.marketing', function () {
	  var ns = this;
	  var onScroll = void 0;
	
	  var scrollYOffset = window.innerHeight - 50;
	  var isAboveFold = function isAboveFold(el) {
	    return window.pageYOffset + scrollYOffset > el.offsetTop;
	  };
	
	  ns.initFeatureFade = function () {
	    if (window.innerWidth < 1053) {
	      return;
	    }
	    var scrollAnimation = void 0;
	    window.addEventListener('scroll', function () {
	      if (scrollAnimation) {
	        window.cancelAnimationFrame(scrollAnimation);
	      }
	      scrollAnimation = window.requestAnimationFrame(onScroll);
	    });
	    // add the faded out / translated class to stuff
	    $('.feature-breakdown .detail, .feature-breakdown .image').each(function () {
	      if (!isAboveFold(this)) {
	        $(this).addClass('below-fold');
	      }
	    });
	  };
	
	  onScroll = function onScroll() {
	    $('.below-fold').each(function () {
	      if (isAboveFold(this)) {
	        $(this).removeClass('below-fold');
	      }
	    });
	  };
	});

/***/ }),
/* 160 */,
/* 161 */,
/* 162 */
/***/ (function(module, exports) {

	'use strict';
	
	// qs_score - Quicksilver Score
	// 
	// A port of the Quicksilver string ranking algorithm
	// 
	// "hello world".score("axl") //=> 0.0
	// "hello world".score("ow") //=> 0.6
	// "hello world".score("hello world") //=> 1.0
	//
	// Tested in Firefox 2 and Safari 3
	//
	// The Quicksilver code is available here
	// http://code.google.com/p/blacktree-alchemy/
	// http://blacktree-alchemy.googlecode.com/svn/trunk/Crucible/Code/NSString+BLTRRanking.m
	//
	// The MIT License
	// 
	// Copyright (c) 2008 Lachie Cox
	// 
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	// 
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	// 
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	
	String.prototype.score = function (abbreviation, offset) {
	  offset = offset || 0; // TODO: I think this is unused... remove
	
	  if (abbreviation.length == 0) return 0.9;
	  if (abbreviation.length > this.length) return 0.0;
	
	  for (var i = abbreviation.length; i > 0; i--) {
	    var sub_abbreviation = abbreviation.substring(0, i);
	    var index = this.indexOf(sub_abbreviation);
	
	    if (index < 0) continue;
	    if (index + abbreviation.length > this.length + offset) continue;
	
	    var next_string = this.substring(index + sub_abbreviation.length);
	    var next_abbreviation = null;
	
	    if (i >= abbreviation.length) next_abbreviation = '';else next_abbreviation = abbreviation.substring(i);
	
	    var remaining_score = next_string.score(next_abbreviation, offset + index);
	
	    if (remaining_score > 0) {
	      var score = this.length - next_string.length;
	
	      if (index != 0) {
	        var j = 0;
	
	        var c = this.charCodeAt(index - 1);
	        if (c == 32 || c == 9) {
	          for (j = index - 2; j >= 0; j--) {
	            c = this.charCodeAt(j);
	            score -= c == 32 || c == 9 ? 1 : 0.15;
	          }
	
	          // XXX maybe not port this heuristic
	          // 
	          //          } else if ([[NSCharacterSet uppercaseLetterCharacterSet] characterIsMember:[self characterAtIndex:matchedRange.location]]) {
	          //            for (j = matchedRange.location-1; j >= (int) searchRange.location; j--) {
	          //              if ([[NSCharacterSet uppercaseLetterCharacterSet] characterIsMember:[self characterAtIndex:j]])
	          //                score--;
	          //              else
	          //                score -= 0.15;
	          //            }
	        } else {
	          score -= index;
	        }
	      }
	
	      score += remaining_score * next_string.length;
	      score /= this.length;
	      return score;
	    }
	  }
	  return 0.0;
	};

/***/ }),
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	(function () {
	  var MetricsCalculator = __webpack_require__(78);
	
	  var Data, DataSlice, DataPartition;
	  /**
	   * simple class to encapsulate "data", which is points and their
	   * metadata, which is wrapped up in a metrics calculator
	   * having this class allows multiple sample graphs to share the same
	   * data and subscribe to its changes
	   * @class Data
	   * @extends Backbone.Events
	   */
	  Data = function Data(points, metrics) {
	    this._points = points;
	    this.count = points.length;
	    this._metrics = metrics;
	    return this;
	  };
	  /**
	   * pointsAround objects have lowI, highI, closestI, and pct. 
	   * we only need lowI & pct to reconstruct
	   */
	  var pointsAroundPctTruncationFactor = 1000;
	  var pointsAroundMetricTruncationFactor = 100;
	  Data.serializePointsAround = function (pointsAround, metric) {
	    if (!metric) return [pointsAround.lowI, Math.round(pointsAround.pct * pointsAroundPctTruncationFactor) / pointsAroundPctTruncationFactor];else return Math.round(pointsAround.estimatedPoint[metric] * pointsAroundMetricTruncationFactor) / pointsAroundMetricTruncationFactor;
	  };
	
	  _.extend(Data.prototype, Backbone.Events);
	  /**
	   * Setter/getter for points, an array of data points. Fires
	   * points:change event when setting.
	   * @param {Array<rwgps.TrackPoint>} pointsOrI (optional) Array of points to set or index of point to get
	   * @return {Array<rwgps.TrackPoint>} The current points array.
	   */
	  Data.prototype.points = function (pointsOrI) {
	    if (pointsOrI !== undefined) {
	      if (_.isNumber(pointsOrI)) return this._points[pointsOrI];
	      var points = pointsOrI;
	
	      // if the first point has time, and the last one does not, lop
	      // it off! i've seen this in a trip or two, there is probably a
	      // more elegant way of dealing with it but this is what we have
	      // for now...
	      if (points[0] && points[0].time && !points[points.length - 1].time) {
	        points.pop();
	      }
	
	      this._points = points;
	      this.count = points.length;
	      delete this._metricsCalculator;
	      this.trigger('points:change');
	    }
	    return this._points;
	  };
	  Data.prototype.seek = function (startI, key, amount, step) {
	    if (!step) step = 1;
	    var hardStop = step > 0 ? this.count - 1 : 0,
	        i = startI,
	        pts = this.points(),
	        refValue = pts[startI][key];
	    while (i != hardStop) {
	      if (Math.abs(pts[i][key] - refValue) >= amount) {
	        return i;
	      }
	      i += step;
	    }
	    return i;
	  };
	  Data.prototype.pointsAroundX = function (scaledX, xAxisType, data, ptOffset) {
	    if (!data) data = this.points();
	
	    // binary search for nearest point
	    var i,
	        dataX,
	        low = 0,
	        high = data.length - 1;
	    while (low != high) {
	      i = low + Math.floor((high - low) / 2);
	      dataX = data[i][xAxisType];
	      if (scaledX < dataX) high = i;else if (scaledX > dataX) {
	        // break if point is closer to the value we're throwing out than the value that will be the new low
	        if (scaledX - dataX < data[i + 1][xAxisType] - scaledX) {
	          break;
	        }
	        low = ++i;
	      } else {
	        break; // found exact match.
	      }
	    }
	
	    // figure out bounding points and %
	    dataX = data[i][xAxisType];
	    if (scaledX <= dataX) {
	      low = i - 1;
	      high = i;
	    } else {
	      low = i;
	      high = i + 1;
	    }
	    if (i == 0) {
	      low = i;
	      high = i + 1;
	    } else if (i == data.length - 1) {
	      low = i - 1;
	      high = i;
	    }
	    var pct = (scaledX - data[low][xAxisType]) / (data[high][xAxisType] - data[low][xAxisType]);
	    if (data.length == 1) i = 0;
	
	    // if we're zoomed in need to offset our i so its absolute not relative to selected slice
	    if (ptOffset) {
	      i += ptOffset;
	      low += ptOffset;
	      high += ptOffset;
	    }
	
	    // stub out point with linearly interpolated values
	    var estimatedPoint = this.interpolatePoint(low, pct);
	
	    // return a pointsAround object
	    return {
	      x: scaledX,
	      closestI: i,
	      lowI: low,
	      highI: high,
	      pct: pct,
	      estimatedPoint: estimatedPoint
	    };
	  };
	  Data.prototype.metricsKeys = function () {
	    if (!this._metricsKeys) {
	      this._metricsKeys = this.metricsCalculator().enabledMetrics();
	    }
	    return this._metricsKeys;
	  };
	  /**
	   * Lazy load an rwgps.MetricsCalculator instance for the current
	   * points.
	   * @return {rwgps.MetricsCalculator} Instantiated with this.points() and calculate() is already called.
	   */
	  Data.prototype.metricsCalculator = function () {
	    if (!this._metricsCalculator) {
	      delete this._metricsKeys;
	      this._metricsCalculator = new MetricsCalculator(this, false, this._metrics);
	      this._metricsCalculator.calculate(true);
	    }
	    return this._metricsCalculator;
	  };
	  Data.prototype.metrics = function () {
	    return this.metricsCalculator().metrics();
	  };
	
	  Data.prototype.partitionByDistanceFraction = function (frac) {
	    this.metricsCalculator().calculate();
	    var segmentDistance = this.metricsCalculator().metrics().distance * frac,
	        distOffset = segmentDistance,
	        points = this.points(),
	        partitionIndexes = [],
	        lastPt;
	    if (frac < 1) {
	      for (var i = 0, len = points.length; i < len; i++) {
	        if (points[i].distance >= distOffset) {
	          lastPt = points[i - 1];
	          var pct = (distOffset - lastPt.distance) / (points[i].distance - lastPt.distance);
	          if (pct == 1) {
	            pct = 0;
	            ++i;
	          }
	          partitionIndexes.push([i - 1, pct]);
	          distOffset += segmentDistance;
	        }
	      }
	      // if the last split index cuts the data leaving a section that is only a 10th or less the size of our other slices go ahead and avoid splitting it
	      if ((points[points.length - 1].distance - points[partitionIndexes[partitionIndexes.length - 1][0]].distance) / segmentDistance <= frac / 10) partitionIndexes.pop();
	    }
	    var part = new DataPartition(this, partitionIndexes);
	    return part;
	  };
	
	  Data.prototype.slice = function (i, count, pct1, pct2) {
	    return new DataSlice(this, i, count, pct1, pct2);
	  };
	
	  // i is where to start, pct is how far to go forward
	  Data.prototype.interpolatePoint = function (i, pct) {
	    var epOpts = {},
	        left = this.points(i),
	        right = this.points(i + 1);
	    _.each(this.metricsKeys().concat('time', 'distance', 'providedDistance'), function (metric) {
	      if (_.isNumber(left[metric]) && _.isNumber(right[metric])) epOpts[metric] = left[metric] + pct * (right[metric] - left[metric]);
	    });
	    // interpolate x/y
	    epOpts.point = {
	      lat: (right.point.lat - left.point.lat) * pct + left.point.lat,
	      lng: (right.point.lng - left.point.lng) * pct + left.point.lng
	    };
	    var leftHasSurface = left.surface !== undefined;
	    var rigthHasSurface = right.surface !== undefined;
	    if (leftHasSurface && rigthHasSurface) {
	      epOpts.surface = Math.round(pct) === 1 ? right.surface : left.surface;
	    } else if (leftHasSurface) {
	      epOpts.surface = left.surface;
	    } else if (rigthHasSurface) {
	      epOpts.surface = right.surface;
	    }
	
	    return new rwgps.TrackPoint(epOpts);
	  };
	
	  DataSlice = function DataSlice(graphOrData, i, count, pct1, pct2) {
	    var data, lastI;
	    if (graphOrData.canvasId) // its a graph
	      data = graphOrData._data;else data = graphOrData;
	
	    // cannot create a dataslice that selects beyond the bounds of data
	    // if an invalid dataslice is requested, return best attempt
	    if (data.count < i + count) {
	      // need at least 2 points for a slice (for calculating distance etc)
	      if (i > data.count - 2) {
	        i = data.count - 2;
	      }
	      count = data.count - i;
	      pct2 = 0;
	    }
	
	    lastI = i + count - 1;
	
	    // interpolation if required
	    if (_.isNumber(pct1) && pct1 > 0) this.left = data.interpolatePoint(i, pct1);else {
	      pct1 = 0;
	      this.left = data.points(i);
	    }
	    if (_.isNumber(pct2) && pct2 > 0) {
	      this.right = data.interpolatePoint(i + count - 1, pct2);
	      count++;
	    } else {
	      pct2 = 0;
	      this.right = data.points(lastI);
	    }
	
	    this.i = i;
	    this.count = count;
	    this._parentData = data;
	    this.pct1 = pct1;
	    this.pct2 = pct2;
	    this.lastI = lastI;
	  };
	  DataSlice.prototype.serialize = function (metric) {
	    if (!metric) return [this.i, this.count];else return [Math.round(this.firstPoint()[metric] * 100) / 100, Math.round(this.lastPoint()[metric] * 100) / 100];
	  };
	
	  // more efficient way of pulling point, no slice involved
	  DataSlice.prototype.pointByIndex = function (i) {
	    return this.points(i);
	  };
	  DataSlice.prototype.firstPoint = function () {
	    return this.left;
	  };
	  DataSlice.prototype.lastPoint = function () {
	    return this.right;
	  };
	  DataSlice.prototype.buffer = function (key) {
	    var diff = this.lastPoint()[key] - this.firstPoint()[key];
	    var bufferAmt = diff * 0.35;
	    var i = this._parentData.seek(this.i, key, bufferAmt, -1);
	    var lastI = this._parentData.seek(this.lastI, key, bufferAmt);
	    // and since we require a count to build a slice, calc that 
	    var count = lastI - i + 1;
	    return new DataSlice(this._parentData, i, count);
	  };
	  DataSlice.prototype.points = function (i) {
	    // proxy request up to data with offset, efficient!
	    if (i !== undefined) {
	      if (i === 0) return this.left;
	      if (i === this.count - 1) return this.right;
	      return this._parentData.points(i + this.i);
	    }
	
	    // lazy copy selected data in, avoid this if possible
	    if (!this._data) {
	      var pts = [this.left],
	          offset = this.i;
	      for (var x = offset + 1, d = this._parentData.points(), lastI = this.lastI; x <= lastI; x++) {
	        pts.push(d[x]);
	      }
	      if (this.pct2 > 0) pts.push(this.right);
	      this._data = pts;
	    }
	    return this._data;
	  };
	  DataSlice.prototype.data = DataSlice.prototype.points;
	  DataSlice.prototype.dataObj = function () {
	    if (!this._dataObj) {
	      this._dataObj = new Data(this.points());
	    }
	    return this._dataObj;
	  };
	  DataSlice.prototype.metricsCalculator = function () {
	    if (!this._metricsCalculator) {
	      this._metricsCalculator = new MetricsCalculator(this, true);
	      this._metricsCalculator.calculate();
	    }
	    return this._metricsCalculator;
	  };
	  DataSlice.prototype.metrics = function () {
	    return this.metricsCalculator().metrics();
	  };
	
	  DataPartition = function DataPartition(data, divideOnPositions) {
	    this.data = data;
	    var slices = this._slices = [];
	    if (divideOnPositions.length == 0) slices.push(new DataSlice(data, 0, this.data.points().length));else {
	      for (var i = 0, firstPos = [0, 0]; i < divideOnPositions.length; i++) {
	        slices.push(new DataSlice(data, firstPos[0], divideOnPositions[i][0] - firstPos[0] + 1, firstPos[1], divideOnPositions[i][1]));
	        firstPos = divideOnPositions[i];
	      }
	      slices.push(new DataSlice(data, firstPos[0], data.points().length - firstPos[0], firstPos[1]));
	    }
	  };
	  DataPartition.prototype = {
	    slices: function slices() {
	      return this._slices;
	    },
	    slice: function slice(i) {
	      return this._slices[i];
	    }
	  };
	
	  module.exports = {
	    Data: Data,
	    DataSlice: DataSlice,
	    DataPartition: DataPartition
	  };
	})();

/***/ }),
/* 169 */
/***/ (function(module, exports) {

	"use strict";
	
	(function () {
	
	  /**
	   * Static methods to operate on Javascript Date objects
	   * FIXME: make activity center use this, not its own version
	   * @module base
	   * @class DateExt
	   * @namespace rwgps
	   */
	  module.exports = {
	    DateExt: {
	      /** Parse ISO8601 datetime string (e.g. 2010-07-26T17:20:01-07:00)
	       * @method parse
	       * @static
	       * @param {String} dateStr ISO8601 datetime string
	       * @return {Date} Javascript Date object
	       */
	      parse: function parse(dateStr, disableUserLocale) {
	        if (!dateStr) return;
	        if (disableUserLocale === undefined) disableUserLocale = false;
	        dateStr = dateStr.replace("Z", "-00:00");
	        var dateParts = dateStr.match(/^([0-9]{4})-0?([0-9]{1,2})-0?([0-9]{1,2})T0?([0-9]{1,2}):0?([0-9]{1,2}):0?([0-9]{1,2})([-+])0?([0-9]{1,2}):0?([0-9]{1,2})$/),
	            year = parseInt(dateParts[1]),
	            month = parseInt(dateParts[2]) - 1,
	            // javascript dates use 0-based months
	        day = parseInt(dateParts[3]),
	            hours = parseInt(dateParts[4]),
	            minutes = parseInt(dateParts[5]),
	            seconds = parseInt(dateParts[6]),
	            offsetSign = dateParts[7],
	            offsetHours = parseInt(dateParts[8]),
	            offsetMinutes = parseInt(dateParts[9]),
	            offsetMilliseconds = (offsetSign == '-' ? 1 : -1) * (offsetHours * 60 + offsetMinutes) * 60000;
	
	        var date = new Date();
	        if (disableUserLocale) {
	          date.setFullYear(year, month, day);
	          date.setHours(hours, minutes, seconds);
	        } else {
	          date.setUTCFullYear(year, month, day);
	          date.setUTCHours(hours, minutes, seconds);
	          date.setTime(date.getTime() + offsetMilliseconds);
	        }
	
	        return date;
	      },
	      /** Parse YYYY-MM-DD date string
	       * @method parseDate
	       * @static
	       * @param {String} dateStr Date represented as string in format YYYY-MM-DD
	       * @return {Date} Javascript Date object
	       */
	      parseDate: function parseDate(dateStr) {
	        if (!dateStr) return;
	        var dateParts = dateStr.match(/^([0-9]{4})-0?([0-9]{1,2})-0?([0-9]{1,2})$/),
	            year = parseInt(dateParts[1]),
	            month = parseInt(dateParts[2]) - 1,
	            // javascript dates use 0-based months
	        day = parseInt(dateParts[3]);
	
	        var date = new Date(year, month, day);
	
	        return date;
	      }
	    }
	  };
	})();

/***/ }),
/* 170 */
/***/ (function(module, exports) {

	"use strict";
	
	(function () {
	
	  /**
	   * Conversions and labeling of all units.
	   * @module base
	   * @namespace rwgps
	   */
	  module.exports = {
	    /**
	     * Generic conversions that do not mess with precision of results. 
	     * @class Convert
	     */
	    Convert: {
	      /** Convert from miles or km to meters
	       * @method longToM
	       * @static
	       * @param {float} value Miles or KM to convert to meters.
	       * @return {float} Result in meters
	       */
	      longToM: function longToM(value) {
	        if (rwgps.LabelMaker.metric) return value * 1000;else return value * 1609.344;
	      },
	      /** Convert from meters to km or miles
	       * @method mToLong
	       * @static
	       * @param {float} value Meters
	       * @return {float} Result in KM or miles (if using metric or not)
	       */
	      mToLong: function mToLong(value) {
	        if (rwgps.LabelMaker.metric) return value * 0.001;else return value * 0.000621371192;
	      },
	      /** Convert from miles or km to kilometers
	       * @method longToKm
	       * @static
	       * @param {float} value Miles or KM to convert to KM
	       * @return {float} Result in KM
	       */
	      longToKm: function longToKm(value) {
	        if (rwgps.LabelMaker.metric) return value;else return value * 1.609344;
	      },
	      /** Convert from kilometers to km or miles
	       * @method kmToLong
	       * @static
	       * @param {float} value KM
	       * @return {float} Result in KM or miles (if using metric or not)
	       */
	      kmToLong: function kmToLong(value) {
	        if (rwgps.LabelMaker.metric) return value;else return value * 0.621371192;
	      },
	      /** Convert from feet/meters to meters
	       * @method shortToM
	       * @static
	       * @param {float} value Feet or meters
	       * @return {float} Result in meters
	       */
	      shortToM: function shortToM(value) {
	        if (rwgps.LabelMaker.metric) return value;else return value * 0.3048006096012;
	      },
	      /** Convert from meters to feet or meters 
	       * @method mToShort
	       * @static
	       * @param {float} value Meters to convert
	       * @return {float} Result in feet or meters (if using metric or not)
	       */
	      mToShort: function mToShort(value) {
	        if (rwgps.LabelMaker.metric) return value;else return value * 3.2808399;
	      },
	      /** Celsius to celsius or fahrenheit
	       * @method cToDeg
	       * @static
	       * @param {float} value Degrees in C
	       * @return {float} Result in F or C (if using metric units or not)
	       */
	      cToDeg: function cToDeg(value) {
	        if (rwgps.LabelMaker.metric) return value;else return value * 1.8 + 32;
	      },
	      /** Celsius or f to celsius
	       * @method degToC
	       * @static
	       * @param {float} value Degrees in F or C (if using metric units or not)
	       * @return {float} Result in C
	       */
	      degToC: function degToC(value) {
	        if (rwgps.LabelMaker.metric) return value;else return (value - 32) * 5 / 9;
	      }
	    },
	
	    /**
	     * Expects metric values, performs conversions, truncates
	     * accordingly and labels optionally.
	     * @class LabelMaker
	     */
	    LabelMaker: {
	      /**
	       * Whether we are using metric units or not. Very important property!
	       * @property metric
	       */
	      metric: true,
	      longUnit: function longUnit() {
	        return this.metric ? "km" : "miles";
	      },
	      shortUnitAbbrev: function shortUnitAbbrev() {
	        return this.metric ? 'm' : 'ft';
	      },
	      /** Converts KPH to MPH/KPH with 1 number after decimal point, and optionally labels.
	       * @method speedLabel
	       * @static
	       * @param {float} value KPH value to format
	       * @param {Boolean} label (optional) Whether or not to append the label kph/mph, defaults to false
	       * @return {String} Converted/formatted/labeled result
	       */
	      speedLabel: function speedLabel(value, label) {
	        var newVal = this.metric ? value * 1 : value * 0.621371192;
	        return newVal.toFixed(1) + (label ? this.metric ? " kph" : " mph" : '');
	      },
	      /** Converts meters to KM/miles with specified precision, and optionally labels.
	       * @method longLabel
	       * @static
	       * @param {float} value Value to format in meters
	       * @param {String} label (optional) falsey gets no label, "full" gets km/miles, anything else gets km/mi
	       * @param {int} precision (optional) Defaults to 1, value passed to toFixed before result is returned
	       * @return {String} Converted/formatted/labeled result
	       */
	      longLabel: function longLabel(value, label, precision) {
	        if (!precision) precision = 1;
	        var newVal = this.metric ? value * .001 : value * 0.000621371192;
	        return newVal.toFixed(precision) + (label ? label == 'full' ? this.metric ? ' km' : ' miles' : this.metric ? " km" : " mi" : '');
	      },
	      /** Converts meters to m/ft, rounds, optionally labels.
	       * @method shortLabel
	       * @static
	       * @param {float} value Value to format in meters
	       * @param {String} label (optional) falsey gets no label, "full" gets meters/feet, anything else gets m/ft
	       * @return {String} Converted/formatted/labeled result
	       */
	      shortLabel: function shortLabel(value, label) {
	        var newVal = this.metric ? value : value * 3.2808399;
	        return Math.round(newVal) + (label ? label == 'full' ? this.metric ? ' meters' : ' feet' : this.metric ? " m" : " ft" : '');
	      },
	      /** Converts seconds to formatted duration. Short format examples: 1h10m, 5m, 35s.  
	       * Long format: HH:MM:SS.
	       * @method durationLabel
	       * @static
	       * @param {int} seconds Duration in seconds to format
	       * @param {Boolean} shortFormat (optional) Whether or not to use the short format.
	       * @return {String} Converted/formatted/labeled result
	       */
	      durationLabel: function durationLabel(seconds, shortFormat) {
	        var hours = Math.floor(seconds / 3600);
	        seconds -= hours * 3600;
	        var minutes = Math.floor(seconds / 60);
	        seconds = Math.floor(seconds - minutes * 60);
	        if (shortFormat === 1) {
	          return (hours > 0 ? (hours < 10 ? '0' : '') + hours + ':' + (minutes < 10 ? '0' : '') : '') + minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
	        } else if (shortFormat) {
	          var days = 0;
	          if (hours > 99) {
	            days = Math.floor(hours / 24);
	            hours -= days * 24;
	          }
	          // 1h10m 5m 35s
	          if (days > 0) return days + 'd' + (hours == 0 ? '' : hours + 'h');else if (hours > 0) return hours + 'h' + (minutes == 0 ? '' : minutes + 'm');else if (minutes > 9) return minutes + 'm';else if (minutes > 0) return minutes + 'm' + seconds + 's';else return seconds + 's';
	        } else {
	          return (hours < 10 ? '0' : '') + hours + ':' + (minutes < 10 ? '0' : '') + minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
	        }
	      },
	      /** Converts a seconds/km pace appropriately (KM -> miles if not using metric) and returns a duration label
	       * @method paceLabel
	       * @static 
	       * @param {int} secondsPerKm Pace in seconds/km
	       * @param {Boolean} shortFormat (optional) Whether or not to use the short format.
	       * @return {String} Converted/formatted/labeled result
	       */
	      paceLabel: function paceLabel(secondsPerKm, shortFormat) {
	        var paceConverted = Math.round(1 / rwgps.Convert.kmToLong(1 / secondsPerKm));
	        return rwgps.LabelMaker.durationLabel(paceConverted, shortFormat);
	      }
	    }
	  };
	})();

/***/ }),
/* 171 */
/***/ (function(module, exports) {

	'use strict';
	
	(function () {
	
	  /**
	   * General utils
	   * @module base
	   * @class Utils
	   * @namespace rwgps
	   */
	  module.exports = {
	    Utils: {
	      /** Truncate text
	       * @method truncate
	       * @static
	       * @param {String} text Text to truncate
	       * @param {int} len Maximum length of truncated text
	       * @return {String} Truncated text
	       */
	      truncate: function truncate(text, len) {
	        if (text == undefined || text.length == 0) return '';
	        if (text.length <= len) return text;
	        return text.slice(0, len) + "&#133;";
	      },
	      /** Build attribute object from jquery's serializeArray output
	       * @method attrObjFromSerializedArray
	       * @static
	       * @param {Array} arr Array to convert
	       * @return {Object} Object with keys/values corresponding to attr names / values
	       */
	      attrObjFromSerializedArray: function attrObjFromSerializedArray(arr) {
	        return _.reduce(arr, function (memo, attrPair) {
	          memo[attrPair.name] = attrPair.value;
	          return memo;
	        }, {});
	      },
	      /** nl2br and autolink text
	       * @method formatText
	       * @static
	       * @param {String} text Text to format
	       * @return {String} Formatted HTML
	       */
	      formatText: function formatText(text) {
	        if (!text) text = '';
	        text = text.replace(/\r\n?/g, "\n");
	        text = text.replace(/\n+$/, '');
	        text = "<p>" + text + "</p>";
	        text = text.replace(/\n\n+/g, '</p><p>');
	        text = text.replace(/\n/g, '<br/>');
	        return this.autolink(text);
	      },
	      /** autolink text, turns http://blah.com into <a href="http://blah.com">http://blah.com</a>
	       * @method autolink
	       * @static
	       * @param {String} text Text to autolink
	       * @return {String} HTML with links
	       */
	      autolink: function autolink(text, attrs) {
	        var key, link_attributes, url_pattern, value;
	        url_pattern = /(\b(https?):\/\/[\-A-Z0-9+&@#\/%?=~_|!:,.;]*[\-A-Z0-9+&@#\/%=~_|])/ig;
	        if (attrs) {
	          link_attributes = '';
	          for (key in attrs) {
	            value = attrs[key];
	            link_attributes += " " + key + "='" + value + "'";
	          }
	          return text.replace(url_pattern, "<a href='$1' " + link_attributes.trim() + ">$1</a>");
	        } else {
	          return text.replace(url_pattern, "<a href='$1'>$1</a>");
	        }
	      },
	      /** format a number into a string with commas
	       * thanks http://www.mredkj.com/javascript/nfbasic.html
	       * @method addCommas
	       * @static
	       * @param {Number|String} nStr number or string to add commas to
	       * @return {String} Number with commas
	       */
	      addCommas: function addCommas(nStr) {
	        nStr += '';
	        var x = nStr.split('.');
	        var x1 = x[0];
	        var x2 = x.length > 1 ? '.' + x[1] : '';
	        var rgx = /(\d+)(\d{3})/;
	        while (rgx.test(x1)) {
	          x1 = x1.replace(rgx, '$1' + ',' + '$2');
	        }
	        return x1 + x2;
	      },
	      /** parse query string parameters
	       * https://css-tricks.com/snippets/jquery/get-query-params-object/
	       * @method getQueryParameters
	       * @static
	       * @param {String} str window.location.search or similar
	       * @return {Object} An object of keys and values parsed from the querystring
	       */
	      getQueryParameters: function getQueryParameters(str) {
	        return (str || document.location.search).replace(/(^\?)/, '').split("&").map(function (n) {
	          return n = n.split("="), this[n[0]] = n[1], this;
	        }.bind({}))[0];
	      }
	    }
	  };
	})();

/***/ }),
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */
/***/ (function(module, exports) {

	'use strict';
	
	var MDConvert = function MDConvert(fn) {
	  if (MDConvert.done) fn();else MDConvert.afterConvertFns.push(fn);
	};
	MDConvert.afterConvertFns = [];
	
	$(function () {
	  var converter = new Remarkable();
	  $('.mdconvert').each(function () {
	    var $this = $(this);
	    var md = $this.find('textarea').val();
	    $this.html(converter.render(md));
	    $this.removeClass('mdconvert');
	  });
	  MDConvert.done = true;
	  _.each(MDConvert.afterConvertFns, function (fn) {
	    fn();
	  });
	});
	
	/*** EXPORTS FROM exports-loader ***/
	module.exports = MDConvert;

/***/ }),
/* 201 */,
/* 202 */,
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["Comments"] = __webpack_require__(90);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["Favorites"] = __webpack_require__(92);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["Photosets"] = __webpack_require__(93);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 206 */,
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["Translations"] = __webpack_require__(88);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["async"] = __webpack_require__(214);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 209 */,
/* 210 */,
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["jQuery"] = __webpack_require__(220);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["rwgps"] = __webpack_require__(94);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 213 */,
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, setImmediate, process) {/*!
	 * async
	 * https://github.com/caolan/async
	 *
	 * Copyright 2010-2014 Caolan McMahon
	 * Released under the MIT license
	 */
	(function() {
	
	  var async = {};
	
	  function noop() {}
	
	  function identity(v) {
	    return v;
	  }
	
	  function toBool(v) {
	    return !!v;
	  }
	
	  function notId(v) {
	    return !v;
	  }
	
	  // global on the server, window in the browser
	  var previous_async;
	
	  // Establish the root object, `window` (`self`) in the browser, `global`
	  // on the server, or `this` in some virtual machines. We use `self`
	  // instead of `window` for `WebWorker` support.
	  var root = typeof self === 'object' && self.self === self && self || typeof global === 'object' && global.global === global && global || this;
	
	  if (root != null) {
	    previous_async = root.async;
	  }
	
	  async.noConflict = function() {
	    root.async = previous_async;
	    return async;
	  };
	
	  function only_once(fn) {
	    return function() {
	      if (fn === null) throw new Error("Callback was already called.");
	      fn.apply(this, arguments);
	      fn = null;
	    };
	  }
	
	  function _once(fn) {
	    return function() {
	      if (fn === null) return;
	      fn.apply(this, arguments);
	      fn = null;
	    };
	  }
	
	  //// cross-browser compatiblity functions ////
	  var _toString = Object.prototype.toString;
	
	  var _isArray = Array.isArray ||
	  function(obj) {
	    return _toString.call(obj) === '[object Array]';
	  };
	
	  // Ported from underscore.js isObject
	  var _isObject = function(obj) {
	    var type = typeof obj;
	    return type === 'function' || type === 'object' && !! obj;
	  };
	
	  function _isArrayLike(arr) {
	    return _isArray(arr) || (
	    // has a positive integer length property
	    typeof arr.length === "number" && arr.length >= 0 && arr.length % 1 === 0);
	  }
	
	  function _arrayEach(arr, iterator) {
	    var index = -1,
	        length = arr.length;
	
	    while (++index < length) {
	      iterator(arr[index], index, arr);
	    }
	  }
	
	  function _map(arr, iterator) {
	    var index = -1,
	        length = arr.length,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iterator(arr[index], index, arr);
	    }
	    return result;
	  }
	
	  function _range(count) {
	    return _map(Array(count), function(v, i) {
	      return i;
	    });
	  }
	
	  function _reduce(arr, iterator, memo) {
	    _arrayEach(arr, function(x, i, a) {
	      memo = iterator(memo, x, i, a);
	    });
	    return memo;
	  }
	
	  function _forEachOf(object, iterator) {
	    _arrayEach(_keys(object), function(key) {
	      iterator(object[key], key);
	    });
	  }
	
	  function _indexOf(arr, item) {
	    for (var i = 0; i < arr.length; i++) {
	      if (arr[i] === item) return i;
	    }
	    return -1;
	  }
	
	  var _keys = Object.keys ||
	  function(obj) {
	    var keys = [];
	    for (var k in obj) {
	      if (obj.hasOwnProperty(k)) {
	        keys.push(k);
	      }
	    }
	    return keys;
	  };
	
	  function _keyIterator(coll) {
	    var i = -1;
	    var len;
	    var keys;
	    if (_isArrayLike(coll)) {
	      len = coll.length;
	      return function next() {
	        i++;
	        return i < len ? i : null;
	      };
	    } else {
	      keys = _keys(coll);
	      len = keys.length;
	      return function next() {
	        i++;
	        return i < len ? keys[i] : null;
	      };
	    }
	  }
	
	  // Similar to ES6's rest param (http://ariya.ofilabs.com/2013/03/es6-and-rest-parameter.html)
	  // This accumulates the arguments passed into an array, after a given index.
	  // From underscore.js (https://github.com/jashkenas/underscore/pull/2140).
	
	
	  function _restParam(func, startIndex) {
	    startIndex = startIndex == null ? func.length - 1 : +startIndex;
	    return function() {
	      var length = Math.max(arguments.length - startIndex, 0);
	      var rest = Array(length);
	      for (var index = 0; index < length; index++) {
	        rest[index] = arguments[index + startIndex];
	      }
	      switch (startIndex) {
	      case 0:
	        return func.call(this, rest);
	      case 1:
	        return func.call(this, arguments[0], rest);
	      }
	      // Currently unused but handle cases outside of the switch statement:
	      // var args = Array(startIndex + 1);
	      // for (index = 0; index < startIndex; index++) {
	      //     args[index] = arguments[index];
	      // }
	      // args[startIndex] = rest;
	      // return func.apply(this, args);
	    };
	  }
	
	  function _withoutIndex(iterator) {
	    return function(value, index, callback) {
	      return iterator(value, callback);
	    };
	  }
	
	  //// exported async module functions ////
	  //// nextTick implementation with browser-compatible fallback ////
	  // capture the global reference to guard against fakeTimer mocks
	  var _setImmediate = typeof setImmediate === 'function' && setImmediate;
	
	  var _delay = _setImmediate ?
	  function(fn) {
	    // not a direct alias for IE10 compatibility
	    _setImmediate(fn);
	  } : function(fn) {
	    setTimeout(fn, 0);
	  };
	
	  if (typeof process === 'object' && typeof process.nextTick === 'function') {
	    async.nextTick = process.nextTick;
	  } else {
	    async.nextTick = _delay;
	  }
	  async.setImmediate = _setImmediate ? _delay : async.nextTick;
	
	
	  async.forEach =
	  async.each = function(arr, iterator, callback) {
	    return async.eachOf(arr, _withoutIndex(iterator), callback);
	  };
	
	  async.forEachSeries =
	  async.eachSeries = function(arr, iterator, callback) {
	    return async.eachOfSeries(arr, _withoutIndex(iterator), callback);
	  };
	
	
	  async.forEachLimit =
	  async.eachLimit = function(arr, limit, iterator, callback) {
	    return _eachOfLimit(limit)(arr, _withoutIndex(iterator), callback);
	  };
	
	  async.forEachOf =
	  async.eachOf = function(object, iterator, callback) {
	    callback = _once(callback || noop);
	    object = object || [];
	
	    var iter = _keyIterator(object);
	    var key, completed = 0;
	
	    while ((key = iter()) != null) {
	      completed += 1;
	      iterator(object[key], key, only_once(done));
	    }
	
	    if (completed === 0) callback(null);
	
	    function done(err) {
	      completed--;
	      if (err) {
	        callback(err);
	      }
	      // Check key is null in case iterator isn't exhausted
	      // and done resolved synchronously.
	      else if (key === null && completed <= 0) {
	        callback(null);
	      }
	    }
	  };
	
	  async.forEachOfSeries =
	  async.eachOfSeries = function(obj, iterator, callback) {
	    callback = _once(callback || noop);
	    obj = obj || [];
	    var nextKey = _keyIterator(obj);
	    var key = nextKey();
	
	    function iterate() {
	      var sync = true;
	      if (key === null) {
	        return callback(null);
	      }
	      iterator(obj[key], key, only_once(function(err) {
	        if (err) {
	          callback(err);
	        } else {
	          key = nextKey();
	          if (key === null) {
	            return callback(null);
	          } else {
	            if (sync) {
	              async.setImmediate(iterate);
	            } else {
	              iterate();
	            }
	          }
	        }
	      }));
	      sync = false;
	    }
	    iterate();
	  };
	
	
	
	  async.forEachOfLimit =
	  async.eachOfLimit = function(obj, limit, iterator, callback) {
	    _eachOfLimit(limit)(obj, iterator, callback);
	  };
	
	  function _eachOfLimit(limit) {
	
	    return function(obj, iterator, callback) {
	      callback = _once(callback || noop);
	      obj = obj || [];
	      var nextKey = _keyIterator(obj);
	      if (limit <= 0) {
	        return callback(null);
	      }
	      var done = false;
	      var running = 0;
	      var errored = false;
	
	      (function replenish() {
	        if (done && running <= 0) {
	          return callback(null);
	        }
	
	        while (running < limit && !errored) {
	          var key = nextKey();
	          if (key === null) {
	            done = true;
	            if (running <= 0) {
	              callback(null);
	            }
	            return;
	          }
	          running += 1;
	          iterator(obj[key], key, only_once(function(err) {
	            running -= 1;
	            if (err) {
	              callback(err);
	              errored = true;
	            } else {
	              replenish();
	            }
	          }));
	        }
	      })();
	    };
	  }
	
	
	  function doParallel(fn) {
	    return function(obj, iterator, callback) {
	      return fn(async.eachOf, obj, iterator, callback);
	    };
	  }
	
	  function doParallelLimit(fn) {
	    return function(obj, limit, iterator, callback) {
	      return fn(_eachOfLimit(limit), obj, iterator, callback);
	    };
	  }
	
	  function doSeries(fn) {
	    return function(obj, iterator, callback) {
	      return fn(async.eachOfSeries, obj, iterator, callback);
	    };
	  }
	
	  function _asyncMap(eachfn, arr, iterator, callback) {
	    callback = _once(callback || noop);
	    arr = arr || [];
	    var results = _isArrayLike(arr) ? [] : {};
	    eachfn(arr, function(value, index, callback) {
	      iterator(value, function(err, v) {
	        results[index] = v;
	        callback(err);
	      });
	    }, function(err) {
	      callback(err, results);
	    });
	  }
	
	  async.map = doParallel(_asyncMap);
	  async.mapSeries = doSeries(_asyncMap);
	  async.mapLimit = doParallelLimit(_asyncMap);
	
	  // reduce only has a series version, as doing reduce in parallel won't
	  // work in many situations.
	  async.inject =
	  async.foldl =
	  async.reduce = function(arr, memo, iterator, callback) {
	    async.eachOfSeries(arr, function(x, i, callback) {
	      iterator(memo, x, function(err, v) {
	        memo = v;
	        callback(err);
	      });
	    }, function(err) {
	      callback(err, memo);
	    });
	  };
	
	  async.foldr =
	  async.reduceRight = function(arr, memo, iterator, callback) {
	    var reversed = _map(arr, identity).reverse();
	    async.reduce(reversed, memo, iterator, callback);
	  };
	
	  async.transform = function(arr, memo, iterator, callback) {
	    if (arguments.length === 3) {
	      callback = iterator;
	      iterator = memo;
	      memo = _isArray(arr) ? [] : {};
	    }
	
	    async.eachOf(arr, function(v, k, cb) {
	      iterator(memo, v, k, cb);
	    }, function(err) {
	      callback(err, memo);
	    });
	  };
	
	  function _filter(eachfn, arr, iterator, callback) {
	    var results = [];
	    eachfn(arr, function(x, index, callback) {
	      iterator(x, function(v) {
	        if (v) {
	          results.push({
	            index: index,
	            value: x
	          });
	        }
	        callback();
	      });
	    }, function() {
	      callback(_map(results.sort(function(a, b) {
	        return a.index - b.index;
	      }), function(x) {
	        return x.value;
	      }));
	    });
	  }
	
	  async.select =
	  async.filter = doParallel(_filter);
	
	  async.selectLimit =
	  async.filterLimit = doParallelLimit(_filter);
	
	  async.selectSeries =
	  async.filterSeries = doSeries(_filter);
	
	  function _reject(eachfn, arr, iterator, callback) {
	    _filter(eachfn, arr, function(value, cb) {
	      iterator(value, function(v) {
	        cb(!v);
	      });
	    }, callback);
	  }
	  async.reject = doParallel(_reject);
	  async.rejectLimit = doParallelLimit(_reject);
	  async.rejectSeries = doSeries(_reject);
	
	  function _createTester(eachfn, check, getResult) {
	    return function(arr, limit, iterator, cb) {
	      function done() {
	        if (cb) cb(getResult(false, void 0));
	      }
	
	      function iteratee(x, _, callback) {
	        if (!cb) return callback();
	        iterator(x, function(v) {
	          if (cb && check(v)) {
	            cb(getResult(true, x));
	            cb = iterator = false;
	          }
	          callback();
	        });
	      }
	      if (arguments.length > 3) {
	        eachfn(arr, limit, iteratee, done);
	      } else {
	        cb = iterator;
	        iterator = limit;
	        eachfn(arr, iteratee, done);
	      }
	    };
	  }
	
	  async.any =
	  async.some = _createTester(async.eachOf, toBool, identity);
	
	  async.someLimit = _createTester(async.eachOfLimit, toBool, identity);
	
	  async.all =
	  async.every = _createTester(async.eachOf, notId, notId);
	
	  async.everyLimit = _createTester(async.eachOfLimit, notId, notId);
	
	  function _findGetResult(v, x) {
	    return x;
	  }
	  async.detect = _createTester(async.eachOf, identity, _findGetResult);
	  async.detectSeries = _createTester(async.eachOfSeries, identity, _findGetResult);
	  async.detectLimit = _createTester(async.eachOfLimit, identity, _findGetResult);
	
	  async.sortBy = function(arr, iterator, callback) {
	    async.map(arr, function(x, callback) {
	      iterator(x, function(err, criteria) {
	        if (err) {
	          callback(err);
	        } else {
	          callback(null, {
	            value: x,
	            criteria: criteria
	          });
	        }
	      });
	    }, function(err, results) {
	      if (err) {
	        return callback(err);
	      } else {
	        callback(null, _map(results.sort(comparator), function(x) {
	          return x.value;
	        }));
	      }
	
	    });
	
	    function comparator(left, right) {
	      var a = left.criteria,
	          b = right.criteria;
	      return a < b ? -1 : a > b ? 1 : 0;
	    }
	  };
	
	  async.auto = function(tasks, concurrency, callback) {
	    if (typeof arguments[1] === 'function') {
	      // concurrency is optional, shift the args.
	      callback = concurrency;
	      concurrency = null;
	    }
	    callback = _once(callback || noop);
	    var keys = _keys(tasks);
	    var remainingTasks = keys.length;
	    if (!remainingTasks) {
	      return callback(null);
	    }
	    if (!concurrency) {
	      concurrency = remainingTasks;
	    }
	
	    var results = {};
	    var runningTasks = 0;
	
	    var hasError = false;
	
	    var listeners = [];
	
	    function addListener(fn) {
	      listeners.unshift(fn);
	    }
	
	    function removeListener(fn) {
	      var idx = _indexOf(listeners, fn);
	      if (idx >= 0) listeners.splice(idx, 1);
	    }
	
	    function taskComplete() {
	      remainingTasks--;
	      _arrayEach(listeners.slice(0), function(fn) {
	        fn();
	      });
	    }
	
	    addListener(function() {
	      if (!remainingTasks) {
	        callback(null, results);
	      }
	    });
	
	    _arrayEach(keys, function(k) {
	      if (hasError) return;
	      var task = _isArray(tasks[k]) ? tasks[k] : [tasks[k]];
	      var taskCallback = _restParam(function(err, args) {
	        runningTasks--;
	        if (args.length <= 1) {
	          args = args[0];
	        }
	        if (err) {
	          var safeResults = {};
	          _forEachOf(results, function(val, rkey) {
	            safeResults[rkey] = val;
	          });
	          safeResults[k] = args;
	          hasError = true;
	
	          callback(err, safeResults);
	        } else {
	          results[k] = args;
	          async.setImmediate(taskComplete);
	        }
	      });
	      var requires = task.slice(0, task.length - 1);
	      // prevent dead-locks
	      var len = requires.length;
	      var dep;
	      while (len--) {
	        if (!(dep = tasks[requires[len]])) {
	          throw new Error('Has nonexistent dependency in ' + requires.join(', '));
	        }
	        if (_isArray(dep) && _indexOf(dep, k) >= 0) {
	          throw new Error('Has cyclic dependencies');
	        }
	      }
	
	      function ready() {
	        return runningTasks < concurrency && _reduce(requires, function(a, x) {
	          return (a && results.hasOwnProperty(x));
	        }, true) && !results.hasOwnProperty(k);
	      }
	      if (ready()) {
	        runningTasks++;
	        task[task.length - 1](taskCallback, results);
	      } else {
	        addListener(listener);
	      }
	
	      function listener() {
	        if (ready()) {
	          runningTasks++;
	          removeListener(listener);
	          task[task.length - 1](taskCallback, results);
	        }
	      }
	    });
	  };
	
	
	
	  async.retry = function(times, task, callback) {
	    var DEFAULT_TIMES = 5;
	    var DEFAULT_INTERVAL = 0;
	
	    var attempts = [];
	
	    var opts = {
	      times: DEFAULT_TIMES,
	      interval: DEFAULT_INTERVAL
	    };
	
	    function parseTimes(acc, t) {
	      if (typeof t === 'number') {
	        acc.times = parseInt(t, 10) || DEFAULT_TIMES;
	      } else if (typeof t === 'object') {
	        acc.times = parseInt(t.times, 10) || DEFAULT_TIMES;
	        acc.interval = parseInt(t.interval, 10) || DEFAULT_INTERVAL;
	      } else {
	        throw new Error('Unsupported argument type for \'times\': ' + typeof t);
	      }
	    }
	
	    var length = arguments.length;
	    if (length < 1 || length > 3) {
	      throw new Error('Invalid arguments - must be either (task), (task, callback), (times, task) or (times, task, callback)');
	    } else if (length <= 2 && typeof times === 'function') {
	      callback = task;
	      task = times;
	    }
	    if (typeof times !== 'function') {
	      parseTimes(opts, times);
	    }
	    opts.callback = callback;
	    opts.task = task;
	
	    function wrappedTask(wrappedCallback, wrappedResults) {
	      function retryAttempt(task, finalAttempt) {
	        return function(seriesCallback) {
	          task(function(err, result) {
	            seriesCallback(!err || finalAttempt, {
	              err: err,
	              result: result
	            });
	          }, wrappedResults);
	        };
	      }
	
	      function retryInterval(interval) {
	        return function(seriesCallback) {
	          setTimeout(function() {
	            seriesCallback(null);
	          }, interval);
	        };
	      }
	
	      while (opts.times) {
	
	        var finalAttempt = !(opts.times -= 1);
	        attempts.push(retryAttempt(opts.task, finalAttempt));
	        if (!finalAttempt && opts.interval > 0) {
	          attempts.push(retryInterval(opts.interval));
	        }
	      }
	
	      async.series(attempts, function(done, data) {
	        data = data[data.length - 1];
	        (wrappedCallback || opts.callback)(data.err, data.result);
	      });
	    }
	
	    // If a callback is passed, run this as a controll flow
	    return opts.callback ? wrappedTask() : wrappedTask;
	  };
	
	  async.waterfall = function(tasks, callback) {
	    callback = _once(callback || noop);
	    if (!_isArray(tasks)) {
	      var err = new Error('First argument to waterfall must be an array of functions');
	      return callback(err);
	    }
	    if (!tasks.length) {
	      return callback();
	    }
	
	    function wrapIterator(iterator) {
	      return _restParam(function(err, args) {
	        if (err) {
	          callback.apply(null, [err].concat(args));
	        } else {
	          var next = iterator.next();
	          if (next) {
	            args.push(wrapIterator(next));
	          } else {
	            args.push(callback);
	          }
	          ensureAsync(iterator).apply(null, args);
	        }
	      });
	    }
	    wrapIterator(async.iterator(tasks))();
	  };
	
	  function _parallel(eachfn, tasks, callback) {
	    callback = callback || noop;
	    var results = _isArrayLike(tasks) ? [] : {};
	
	    eachfn(tasks, function(task, key, callback) {
	      task(_restParam(function(err, args) {
	        if (args.length <= 1) {
	          args = args[0];
	        }
	        results[key] = args;
	        callback(err);
	      }));
	    }, function(err) {
	      callback(err, results);
	    });
	  }
	
	  async.parallel = function(tasks, callback) {
	    _parallel(async.eachOf, tasks, callback);
	  };
	
	  async.parallelLimit = function(tasks, limit, callback) {
	    _parallel(_eachOfLimit(limit), tasks, callback);
	  };
	
	  async.series = function(tasks, callback) {
	    _parallel(async.eachOfSeries, tasks, callback);
	  };
	
	  async.iterator = function(tasks) {
	    function makeCallback(index) {
	      function fn() {
	        if (tasks.length) {
	          tasks[index].apply(null, arguments);
	        }
	        return fn.next();
	      }
	      fn.next = function() {
	        return (index < tasks.length - 1) ? makeCallback(index + 1) : null;
	      };
	      return fn;
	    }
	    return makeCallback(0);
	  };
	
	  async.apply = _restParam(function(fn, args) {
	    return _restParam(function(callArgs) {
	      return fn.apply(
	      null, args.concat(callArgs));
	    });
	  });
	
	  function _concat(eachfn, arr, fn, callback) {
	    var result = [];
	    eachfn(arr, function(x, index, cb) {
	      fn(x, function(err, y) {
	        result = result.concat(y || []);
	        cb(err);
	      });
	    }, function(err) {
	      callback(err, result);
	    });
	  }
	  async.concat = doParallel(_concat);
	  async.concatSeries = doSeries(_concat);
	
	  async.whilst = function(test, iterator, callback) {
	    callback = callback || noop;
	    if (test()) {
	      var next = _restParam(function(err, args) {
	        if (err) {
	          callback(err);
	        } else if (test.apply(this, args)) {
	          iterator(next);
	        } else {
	          callback.apply(null, [null].concat(args));
	        }
	      });
	      iterator(next);
	    } else {
	      callback(null);
	    }
	  };
	
	  async.doWhilst = function(iterator, test, callback) {
	    var calls = 0;
	    return async.whilst(function() {
	      return ++calls <= 1 || test.apply(this, arguments);
	    }, iterator, callback);
	  };
	
	  async.until = function(test, iterator, callback) {
	    return async.whilst(function() {
	      return !test.apply(this, arguments);
	    }, iterator, callback);
	  };
	
	  async.doUntil = function(iterator, test, callback) {
	    return async.doWhilst(iterator, function() {
	      return !test.apply(this, arguments);
	    }, callback);
	  };
	
	  async.during = function(test, iterator, callback) {
	    callback = callback || noop;
	
	    var next = _restParam(function(err, args) {
	      if (err) {
	        callback(err);
	      } else {
	        args.push(check);
	        test.apply(this, args);
	      }
	    });
	
	    var check = function(err, truth) {
	      if (err) {
	        callback(err);
	      } else if (truth) {
	        iterator(next);
	      } else {
	        callback(null);
	      }
	    };
	
	    test(check);
	  };
	
	  async.doDuring = function(iterator, test, callback) {
	    var calls = 0;
	    async.during(function(next) {
	      if (calls++ < 1) {
	        next(null, true);
	      } else {
	        test.apply(this, arguments);
	      }
	    }, iterator, callback);
	  };
	
	  function _queue(worker, concurrency, payload) {
	    if (concurrency == null) {
	      concurrency = 1;
	    } else if (concurrency === 0) {
	      throw new Error('Concurrency must not be zero');
	    }
	
	    function _insert(q, data, pos, callback) {
	      if (callback != null && typeof callback !== "function") {
	        throw new Error("task callback must be a function");
	      }
	      q.started = true;
	      if (!_isArray(data)) {
	        data = [data];
	      }
	      if (data.length === 0 && q.idle()) {
	        // call drain immediately if there are no tasks
	        return async.setImmediate(function() {
	          q.drain();
	        });
	      }
	      _arrayEach(data, function(task) {
	        var item = {
	          data: task,
	          callback: callback || noop
	        };
	
	        if (pos) {
	          q.tasks.unshift(item);
	        } else {
	          q.tasks.push(item);
	        }
	
	        if (q.tasks.length === q.concurrency) {
	          q.saturated();
	        }
	      });
	      async.setImmediate(q.process);
	    }
	
	    function _next(q, tasks) {
	      return function() {
	        workers -= 1;
	
	        var removed = false;
	        var args = arguments;
	        _arrayEach(tasks, function(task) {
	          _arrayEach(workersList, function(worker, index) {
	            if (worker === task && !removed) {
	              workersList.splice(index, 1);
	              removed = true;
	            }
	          });
	
	          task.callback.apply(task, args);
	        });
	        if (q.tasks.length + workers === 0) {
	          q.drain();
	        }
	        q.process();
	      };
	    }
	
	    var workers = 0;
	    var workersList = [];
	    var q = {
	      tasks: [],
	      concurrency: concurrency,
	      payload: payload,
	      saturated: noop,
	      empty: noop,
	      drain: noop,
	      started: false,
	      paused: false,
	      push: function(data, callback) {
	        _insert(q, data, false, callback);
	      },
	      kill: function() {
	        q.drain = noop;
	        q.tasks = [];
	      },
	      unshift: function(data, callback) {
	        _insert(q, data, true, callback);
	      },
	      process: function() {
	        while (!q.paused && workers < q.concurrency && q.tasks.length) {
	
	          var tasks = q.payload ? q.tasks.splice(0, q.payload) : q.tasks.splice(0, q.tasks.length);
	
	          var data = _map(tasks, function(task) {
	            return task.data;
	          });
	
	          if (q.tasks.length === 0) {
	            q.empty();
	          }
	          workers += 1;
	          workersList.push(tasks[0]);
	          var cb = only_once(_next(q, tasks));
	          worker(data, cb);
	        }
	      },
	      length: function() {
	        return q.tasks.length;
	      },
	      running: function() {
	        return workers;
	      },
	      workersList: function() {
	        return workersList;
	      },
	      idle: function() {
	        return q.tasks.length + workers === 0;
	      },
	      pause: function() {
	        q.paused = true;
	      },
	      resume: function() {
	        if (q.paused === false) {
	          return;
	        }
	        q.paused = false;
	        var resumeCount = Math.min(q.concurrency, q.tasks.length);
	        // Need to call q.process once per concurrent
	        // worker to preserve full concurrency after pause
	        for (var w = 1; w <= resumeCount; w++) {
	          async.setImmediate(q.process);
	        }
	      }
	    };
	    return q;
	  }
	
	  async.queue = function(worker, concurrency) {
	    var q = _queue(function(items, cb) {
	      worker(items[0], cb);
	    }, concurrency, 1);
	
	    return q;
	  };
	
	  async.priorityQueue = function(worker, concurrency) {
	
	    function _compareTasks(a, b) {
	      return a.priority - b.priority;
	    }
	
	    function _binarySearch(sequence, item, compare) {
	      var beg = -1,
	          end = sequence.length - 1;
	      while (beg < end) {
	        var mid = beg + ((end - beg + 1) >>> 1);
	        if (compare(item, sequence[mid]) >= 0) {
	          beg = mid;
	        } else {
	          end = mid - 1;
	        }
	      }
	      return beg;
	    }
	
	    function _insert(q, data, priority, callback) {
	      if (callback != null && typeof callback !== "function") {
	        throw new Error("task callback must be a function");
	      }
	      q.started = true;
	      if (!_isArray(data)) {
	        data = [data];
	      }
	      if (data.length === 0) {
	        // call drain immediately if there are no tasks
	        return async.setImmediate(function() {
	          q.drain();
	        });
	      }
	      _arrayEach(data, function(task) {
	        var item = {
	          data: task,
	          priority: priority,
	          callback: typeof callback === 'function' ? callback : noop
	        };
	
	        q.tasks.splice(_binarySearch(q.tasks, item, _compareTasks) + 1, 0, item);
	
	        if (q.tasks.length === q.concurrency) {
	          q.saturated();
	        }
	        async.setImmediate(q.process);
	      });
	    }
	
	    // Start with a normal queue
	    var q = async.queue(worker, concurrency);
	
	    // Override push to accept second parameter representing priority
	    q.push = function(data, priority, callback) {
	      _insert(q, data, priority, callback);
	    };
	
	    // Remove unshift function
	    delete q.unshift;
	
	    return q;
	  };
	
	  async.cargo = function(worker, payload) {
	    return _queue(worker, 1, payload);
	  };
	
	  function _console_fn(name) {
	    return _restParam(function(fn, args) {
	      fn.apply(null, args.concat([_restParam(function(err, args) {
	        if (typeof console === 'object') {
	          if (err) {
	            if (console.error) {
	              console.error(err);
	            }
	          } else if (console[name]) {
	            _arrayEach(args, function(x) {
	              console[name](x);
	            });
	          }
	        }
	      })]));
	    });
	  }
	  async.log = _console_fn('log');
	  async.dir = _console_fn('dir');
	/*async.info = _console_fn('info');
	    async.warn = _console_fn('warn');
	    async.error = _console_fn('error');*/
	
	  async.memoize = function(fn, hasher) {
	    var memo = {};
	    var queues = {};
	    var has = Object.prototype.hasOwnProperty;
	    hasher = hasher || identity;
	    var memoized = _restParam(function memoized(args) {
	      var callback = args.pop();
	      var key = hasher.apply(null, args);
	      if (has.call(memo, key)) {
	        async.setImmediate(function() {
	          callback.apply(null, memo[key]);
	        });
	      } else if (has.call(queues, key)) {
	        queues[key].push(callback);
	      } else {
	        queues[key] = [callback];
	        fn.apply(null, args.concat([_restParam(function(args) {
	          memo[key] = args;
	          var q = queues[key];
	          delete queues[key];
	          for (var i = 0, l = q.length; i < l; i++) {
	            q[i].apply(null, args);
	          }
	        })]));
	      }
	    });
	    memoized.memo = memo;
	    memoized.unmemoized = fn;
	    return memoized;
	  };
	
	  async.unmemoize = function(fn) {
	    return function() {
	      return (fn.unmemoized || fn).apply(null, arguments);
	    };
	  };
	
	  function _times(mapper) {
	    return function(count, iterator, callback) {
	      mapper(_range(count), iterator, callback);
	    };
	  }
	
	  async.times = _times(async.map);
	  async.timesSeries = _times(async.mapSeries);
	  async.timesLimit = function(count, limit, iterator, callback) {
	    return async.mapLimit(_range(count), limit, iterator, callback);
	  };
	
	  async.seq = function( /* functions... */ ) {
	    var fns = arguments;
	    return _restParam(function(args) {
	      var that = this;
	
	      var callback = args[args.length - 1];
	      if (typeof callback == 'function') {
	        args.pop();
	      } else {
	        callback = noop;
	      }
	
	      async.reduce(fns, args, function(newargs, fn, cb) {
	        fn.apply(that, newargs.concat([_restParam(function(err, nextargs) {
	          cb(err, nextargs);
	        })]));
	      }, function(err, results) {
	        callback.apply(that, [err].concat(results));
	      });
	    });
	  };
	
	  async.compose = function( /* functions... */ ) {
	    return async.seq.apply(null, Array.prototype.reverse.call(arguments));
	  };
	
	
	  function _applyEach(eachfn) {
	    return _restParam(function(fns, args) {
	      var go = _restParam(function(args) {
	        var that = this;
	        var callback = args.pop();
	        return eachfn(fns, function(fn, _, cb) {
	          fn.apply(that, args.concat([cb]));
	        }, callback);
	      });
	      if (args.length) {
	        return go.apply(this, args);
	      } else {
	        return go;
	      }
	    });
	  }
	
	  async.applyEach = _applyEach(async.eachOf);
	  async.applyEachSeries = _applyEach(async.eachOfSeries);
	
	
	  async.forever = function(fn, callback) {
	    var done = only_once(callback || noop);
	    var task = ensureAsync(fn);
	
	    function next(err) {
	      if (err) {
	        return done(err);
	      }
	      task(next);
	    }
	    next();
	  };
	
	  function ensureAsync(fn) {
	    return _restParam(function(args) {
	      var callback = args.pop();
	      args.push(function() {
	        var innerArgs = arguments;
	        if (sync) {
	          async.setImmediate(function() {
	            callback.apply(null, innerArgs);
	          });
	        } else {
	          callback.apply(null, innerArgs);
	        }
	      });
	      var sync = true;
	      fn.apply(this, args);
	      sync = false;
	    });
	  }
	
	  async.ensureAsync = ensureAsync;
	
	  async.constant = _restParam(function(values) {
	    var args = [null].concat(values);
	    return function(callback) {
	      return callback.apply(this, args);
	    };
	  });
	
	  async.wrapSync =
	  async.asyncify = function asyncify(func) {
	    return _restParam(function(args) {
	      var callback = args.pop();
	      var result;
	      try {
	        result = func.apply(this, args);
	      } catch (e) {
	        return callback(e);
	      }
	      // if result is Promise object
	      if (_isObject(result) && typeof result.then === "function") {
	        result.then(function(value) {
	          callback(null, value);
	        })["catch"](function(err) {
	          callback(err.message ? err : new Error(err));
	        });
	      } else {
	        callback(null, result);
	      }
	    });
	  };
	
	  // Node.js
	  if (typeof module === 'object' && module.exports) {
	    module.exports = async;
	  }
	  // AMD / RequireJS
	  else if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return async;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // included directly via <script> tag
	  else {
	    root.async = async;
	  }
	
	}());
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(97).setImmediate, __webpack_require__(76)))

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	//     Backbone.js 1.0.0
	
	//     (c) 2010-2013 Jeremy Ashkenas, DocumentCloud Inc.
	//     Backbone may be freely distributed under the MIT license.
	//     For all details and documentation:
	//     http://backbonejs.org
	
	(function(root, factory) {
	  // Set up Backbone appropriately for the environment.
	  if (true) {
	    // Node/CommonJS, no need for jQuery in that case.
	    factory(root, exports, _, $);
	  } else if (typeof define === 'function' && define.amd) {
	    // AMD
	    define('backbone', ['underscore', 'jquery', 'exports'], function(_, $, exports) {
	      // Export global even in AMD case in case this script is loaded with
	      // others that may still expect a global Backbone.
	      root.Backbone = factory(root, exports, _, $);
	    });
	  } else {
	    // Browser globals
	    root.Backbone = factory(root, {}, root._, (root.jQuery || root.Zepto || root.ender || root.$));
	  }
	}({}, function(root, Backbone, _, $) {
	
	  // Initial Setup
	  // -------------
	
	  // Save the previous value of the `Backbone` variable, so that it can be
	  // restored later on, if `noConflict` is used.
	  var previousBackbone = root.Backbone;
	
	  // Create local references to array methods we'll want to use later.
	  var array = [];
	  var push = array.push;
	  var slice = array.slice;
	  var splice = array.splice;
	
	  // Current version of the library. Keep in sync with `package.json`.
	  Backbone.VERSION = '1.0.0';
	
	  // For Backbone's purposes, jQuery, Zepto, or Ender owns the `$` variable.
	  Backbone.$ = $;
	
	  // Runs Backbone.js in *noConflict* mode, returning the `Backbone` variable
	  // to its previous owner. Returns a reference to this Backbone object.
	  Backbone.noConflict = function() {
	    root.Backbone = previousBackbone;
	    return this;
	  };
	
	  // Turn on `emulateHTTP` to support legacy HTTP servers. Setting this option
	  // will fake `"PUT"` and `"DELETE"` requests via the `_method` parameter and
	  // set a `X-Http-Method-Override` header.
	  Backbone.emulateHTTP = false;
	
	  // Turn on `emulateJSON` to support legacy servers that can't deal with direct
	  // `application/json` requests ... will encode the body as
	  // `application/x-www-form-urlencoded` instead and will send the model in a
	  // form param named `model`.
	  Backbone.emulateJSON = false;
	
	  // Backbone.Events
	  // ---------------
	
	  // A module that can be mixed in to *any object* in order to provide it with
	  // custom events. You may bind with `on` or remove with `off` callback
	  // functions to an event; `trigger`-ing an event fires all callbacks in
	  // succession.
	  //
	  //     var object = {};
	  //     _.extend(object, Backbone.Events);
	  //     object.on('expand', function(){ alert('expanded'); });
	  //     object.trigger('expand');
	  //
	  var Events = Backbone.Events = {
	
	    // Bind an event to a `callback` function. Passing `"all"` will bind
	    // the callback to all events fired.
	    on: function(name, callback, context) {
	      if (!eventsApi(this, 'on', name, [callback, context]) || !callback) return this;
	      this._events || (this._events = {});
	      var events = this._events[name] || (this._events[name] = []);
	      events.push({callback: callback, context: context, ctx: context || this});
	      return this;
	    },
	
	    // Bind an event to only be triggered a single time. After the first time
	    // the callback is invoked, it will be removed.
	    once: function(name, callback, context) {
	      if (!eventsApi(this, 'once', name, [callback, context]) || !callback) return this;
	      var self = this;
	      var once = _.once(function() {
	        self.off(name, once);
	        callback.apply(this, arguments);
	      });
	      once._callback = callback;
	      return this.on(name, once, context);
	    },
	
	    // Remove one or many callbacks. If `context` is null, removes all
	    // callbacks with that function. If `callback` is null, removes all
	    // callbacks for the event. If `name` is null, removes all bound
	    // callbacks for all events.
	    off: function(name, callback, context) {
	      var retain, ev, events, names, i, l, j, k;
	      if (!this._events || !eventsApi(this, 'off', name, [callback, context])) return this;
	      if (!name && !callback && !context) {
	        this._events = {};
	        return this;
	      }
	
	      names = name ? [name] : _.keys(this._events);
	      for (i = 0, l = names.length; i < l; i++) {
	        name = names[i];
	        if (events = this._events[name]) {
	          this._events[name] = retain = [];
	          if (callback || context) {
	            for (j = 0, k = events.length; j < k; j++) {
	              ev = events[j];
	              if ((callback && callback !== ev.callback && callback !== ev.callback._callback) ||
	                  (context && context !== ev.context)) {
	                retain.push(ev);
	              }
	            }
	          }
	          if (!retain.length) delete this._events[name];
	        }
	      }
	
	      return this;
	    },
	
	    // Trigger one or many events, firing all bound callbacks. Callbacks are
	    // passed the same arguments as `trigger` is, apart from the event name
	    // (unless you're listening on `"all"`, which will cause your callback to
	    // receive the true name of the event as the first argument).
	    trigger: function(name) {
	      if (!this._events) return this;
	      var args = slice.call(arguments, 1);
	      if (!eventsApi(this, 'trigger', name, args)) return this;
	      var events = this._events[name];
	      var allEvents = this._events.all;
	      if (events) triggerEvents(events, args);
	      if (allEvents) triggerEvents(allEvents, arguments);
	      return this;
	    },
	
	    // Tell this object to stop listening to either specific events ... or
	    // to every object it's currently listening to.
	    stopListening: function(obj, name, callback) {
	      var listeners = this._listeners;
	      if (!listeners) return this;
	      var deleteListener = !name && !callback;
	      if (typeof name === 'object') callback = this;
	      if (obj) (listeners = {})[obj._listenerId] = obj;
	      for (var id in listeners) {
	        listeners[id].off(name, callback, this);
	        if (deleteListener) delete this._listeners[id];
	      }
	      return this;
	    }
	
	  };
	
	  // Regular expression used to split event strings.
	  var eventSplitter = /\s+/;
	
	  // Implement fancy features of the Events API such as multiple event
	  // names `"change blur"` and jQuery-style event maps `{change: action}`
	  // in terms of the existing API.
	  var eventsApi = function(obj, action, name, rest) {
	    if (!name) return true;
	
	    // Handle event maps.
	    if (typeof name === 'object') {
	      for (var key in name) {
	        obj[action].apply(obj, [key, name[key]].concat(rest));
	      }
	      return false;
	    }
	
	    // Handle space separated event names.
	    if (eventSplitter.test(name)) {
	      var names = name.split(eventSplitter);
	      for (var i = 0, l = names.length; i < l; i++) {
	        obj[action].apply(obj, [names[i]].concat(rest));
	      }
	      return false;
	    }
	
	    return true;
	  };
	
	  // A difficult-to-believe, but optimized internal dispatch function for
	  // triggering events. Tries to keep the usual cases speedy (most internal
	  // Backbone events have 3 arguments).
	  var triggerEvents = function(events, args) {
	    var ev, i = -1, l = events.length, a1 = args[0], a2 = args[1], a3 = args[2];
	    switch (args.length) {
	      case 0: while (++i < l) (ev = events[i]).callback.call(ev.ctx); return;
	      case 1: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1); return;
	      case 2: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2); return;
	      case 3: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2, a3); return;
	      default: while (++i < l) (ev = events[i]).callback.apply(ev.ctx, args);
	    }
	  };
	
	  var listenMethods = {listenTo: 'on', listenToOnce: 'once'};
	
	  // Inversion-of-control versions of `on` and `once`. Tell *this* object to
	  // listen to an event in another object ... keeping track of what it's
	  // listening to.
	  _.each(listenMethods, function(implementation, method) {
	    Events[method] = function(obj, name, callback) {
	      var listeners = this._listeners || (this._listeners = {});
	      var id = obj._listenerId || (obj._listenerId = _.uniqueId('l'));
	      listeners[id] = obj;
	      if (typeof name === 'object') callback = this;
	      obj[implementation](name, callback, this);
	      return this;
	    };
	  });
	
	  // Aliases for backwards compatibility.
	  Events.bind   = Events.on;
	  Events.unbind = Events.off;
	
	  // Allow the `Backbone` object to serve as a global event bus, for folks who
	  // want global "pubsub" in a convenient place.
	  _.extend(Backbone, Events);
	
	  // Backbone.Model
	  // --------------
	
	  // Backbone **Models** are the basic data object in the framework --
	  // frequently representing a row in a table in a database on your server.
	  // A discrete chunk of data and a bunch of useful, related methods for
	  // performing computations and transformations on that data.
	
	  // Create a new model with the specified attributes. A client id (`cid`)
	  // is automatically generated and assigned for you.
	  var Model = Backbone.Model = function(attributes, options) {
	    var defaults;
	    var attrs = attributes || {};
	    options || (options = {});
	    this.cid = _.uniqueId('c');
	    this.attributes = {};
	    _.extend(this, _.pick(options, modelOptions));
	    if (options.parse) attrs = this.parse(attrs, options) || {};
	    if (defaults = _.result(this, 'defaults')) {
	      attrs = _.defaults({}, attrs, defaults);
	    }
	    this.set(attrs, options);
	    this.changed = {};
	    this.initialize.apply(this, arguments);
	  };
	
	  // A list of options to be attached directly to the model, if provided.
	  var modelOptions = ['url', 'urlRoot', 'collection'];
	
	  // Attach all inheritable methods to the Model prototype.
	  _.extend(Model.prototype, Events, {
	
	    // A hash of attributes whose current and previous value differ.
	    changed: null,
	
	    // The value returned during the last failed validation.
	    validationError: null,
	
	    // The default name for the JSON `id` attribute is `"id"`. MongoDB and
	    // CouchDB users may want to set this to `"_id"`.
	    idAttribute: 'id',
	
	    // Initialize is an empty function by default. Override it with your own
	    // initialization logic.
	    initialize: function(){},
	
	    // Return a copy of the model's `attributes` object.
	    toJSON: function(options) {
	      return _.clone(this.attributes);
	    },
	
	    // Proxy `Backbone.sync` by default -- but override this if you need
	    // custom syncing semantics for *this* particular model.
	    sync: function() {
	      return Backbone.sync.apply(this, arguments);
	    },
	
	    // Get the value of an attribute.
	    get: function(attr) {
	      return this.attributes[attr];
	    },
	
	    // Get the HTML-escaped value of an attribute.
	    escape: function(attr) {
	      return _.escape(this.get(attr));
	    },
	
	    // Returns `true` if the attribute contains a value that is not null
	    // or undefined.
	    has: function(attr) {
	      return this.get(attr) != null;
	    },
	
	    // Set a hash of model attributes on the object, firing `"change"`. This is
	    // the core primitive operation of a model, updating the data and notifying
	    // anyone who needs to know about the change in state. The heart of the beast.
	    set: function(key, val, options) {
	      var attr, attrs, unset, changes, silent, changing, prev, current;
	      if (key == null) return this;
	
	      // Handle both `"key", value` and `{key: value}` -style arguments.
	      if (typeof key === 'object') {
	        attrs = key;
	        options = val;
	      } else {
	        (attrs = {})[key] = val;
	      }
	
	      options || (options = {});
	
	      // Run validation.
	      if (!this._validate(attrs, options)) return false;
	
	      // Extract attributes and options.
	      unset           = options.unset;
	      silent          = options.silent;
	      changes         = [];
	      changing        = this._changing;
	      this._changing  = true;
	
	      if (!changing) {
	        this._previousAttributes = _.clone(this.attributes);
	        this.changed = {};
	      }
	      current = this.attributes, prev = this._previousAttributes;
	
	      // Check for changes of `id`.
	      if (this.idAttribute in attrs) this.id = attrs[this.idAttribute];
	
	      // For each `set` attribute, update or delete the current value.
	      for (attr in attrs) {
	        val = attrs[attr];
	        if (!_.isEqual(current[attr], val)) changes.push(attr);
	        if (!_.isEqual(prev[attr], val)) {
	          this.changed[attr] = val;
	        } else {
	          delete this.changed[attr];
	        }
	        unset ? delete current[attr] : current[attr] = val;
	      }
	
	      // Trigger all relevant attribute changes.
	      if (!silent) {
	        if (changes.length) this._pending = true;
	        for (var i = 0, l = changes.length; i < l; i++) {
	          this.trigger('change:' + changes[i], this, current[changes[i]], options);
	        }
	      }
	
	      // You might be wondering why there's a `while` loop here. Changes can
	      // be recursively nested within `"change"` events.
	      if (changing) return this;
	      if (!silent) {
	        while (this._pending) {
	          this._pending = false;
	          this.trigger('change', this, options);
	        }
	      }
	      this._pending = false;
	      this._changing = false;
	      return this;
	    },
	
	    // Remove an attribute from the model, firing `"change"`. `unset` is a noop
	    // if the attribute doesn't exist.
	    unset: function(attr, options) {
	      return this.set(attr, void 0, _.extend({}, options, {unset: true}));
	    },
	
	    // Clear all attributes on the model, firing `"change"`.
	    clear: function(options) {
	      var attrs = {};
	      for (var key in this.attributes) attrs[key] = void 0;
	      return this.set(attrs, _.extend({}, options, {unset: true}));
	    },
	
	    // Determine if the model has changed since the last `"change"` event.
	    // If you specify an attribute name, determine if that attribute has changed.
	    hasChanged: function(attr) {
	      if (attr == null) return !_.isEmpty(this.changed);
	      return _.has(this.changed, attr);
	    },
	
	    // Return an object containing all the attributes that have changed, or
	    // false if there are no changed attributes. Useful for determining what
	    // parts of a view need to be updated and/or what attributes need to be
	    // persisted to the server. Unset attributes will be set to undefined.
	    // You can also pass an attributes object to diff against the model,
	    // determining if there *would be* a change.
	    changedAttributes: function(diff) {
	      if (!diff) return this.hasChanged() ? _.clone(this.changed) : false;
	      var val, changed = false;
	      var old = this._changing ? this._previousAttributes : this.attributes;
	      for (var attr in diff) {
	        if (_.isEqual(old[attr], (val = diff[attr]))) continue;
	        (changed || (changed = {}))[attr] = val;
	      }
	      return changed;
	    },
	
	    // Get the previous value of an attribute, recorded at the time the last
	    // `"change"` event was fired.
	    previous: function(attr) {
	      if (attr == null || !this._previousAttributes) return null;
	      return this._previousAttributes[attr];
	    },
	
	    // Get all of the attributes of the model at the time of the previous
	    // `"change"` event.
	    previousAttributes: function() {
	      return _.clone(this._previousAttributes);
	    },
	
	    // Fetch the model from the server. If the server's representation of the
	    // model differs from its current attributes, they will be overridden,
	    // triggering a `"change"` event.
	    fetch: function(options) {
	      options = options ? _.clone(options) : {};
	      if (options.parse === void 0) options.parse = true;
	      var model = this;
	      var success = options.success;
	      options.success = function(resp) {
	        if (!model.set(model.parse(resp, options), options)) return false;
	        if (success) success(model, resp, options);
	        model.trigger('sync', model, resp, options);
	      };
	      wrapError(this, options);
	      return this.sync('read', this, options);
	    },
	
	    // Set a hash of model attributes, and sync the model to the server.
	    // If the server returns an attributes hash that differs, the model's
	    // state will be `set` again.
	    save: function(key, val, options) {
	      var attrs, method, xhr, attributes = this.attributes;
	
	      // Handle both `"key", value` and `{key: value}` -style arguments.
	      if (key == null || typeof key === 'object') {
	        attrs = key;
	        options = val;
	      } else {
	        (attrs = {})[key] = val;
	      }
	
	      // If we're not waiting and attributes exist, save acts as `set(attr).save(null, opts)`.
	      if (attrs && (!options || !options.wait) && !this.set(attrs, options)) return false;
	
	      options = _.extend({validate: true}, options);
	
	      // Do not persist invalid models.
	      if (!this._validate(attrs, options)) return false;
	
	      // Set temporary attributes if `{wait: true}`.
	      if (attrs && options.wait) {
	        this.attributes = _.extend({}, attributes, attrs);
	      }
	
	      // After a successful server-side save, the client is (optionally)
	      // updated with the server-side state.
	      if (options.parse === void 0) options.parse = true;
	      var model = this;
	      var success = options.success;
	      options.success = function(resp) {
	        // Ensure attributes are restored during synchronous saves.
	        model.attributes = attributes;
	        var serverAttrs = model.parse(resp, options);
	        if (options.wait) serverAttrs = _.extend(attrs || {}, serverAttrs);
	        if (_.isObject(serverAttrs) && !model.set(serverAttrs, options)) {
	          return false;
	        }
	        if (success) success(model, resp, options);
	        model.trigger('sync', model, resp, options);
	      };
	      wrapError(this, options);
	
	      method = this.isNew() ? 'create' : (options.patch ? 'patch' : 'update');
	      if (method === 'patch') options.attrs = attrs;
	      xhr = this.sync(method, this, options);
	
	      // Restore attributes.
	      if (attrs && options.wait) this.attributes = attributes;
	
	      return xhr;
	    },
	
	    // Destroy this model on the server if it was already persisted.
	    // Optimistically removes the model from its collection, if it has one.
	    // If `wait: true` is passed, waits for the server to respond before removal.
	    destroy: function(options) {
	      options = options ? _.clone(options) : {};
	      var model = this;
	      var success = options.success;
	
	      var destroy = function() {
	        model.trigger('destroy', model, model.collection, options);
	      };
	
	      options.success = function(resp) {
	        if (options.wait || model.isNew()) destroy();
	        if (success) success(model, resp, options);
	        if (!model.isNew()) model.trigger('sync', model, resp, options);
	      };
	
	      if (this.isNew()) {
	        options.success();
	        return false;
	      }
	      wrapError(this, options);
	
	      var xhr = this.sync('delete', this, options);
	      if (!options.wait) destroy();
	      return xhr;
	    },
	
	    // Default URL for the model's representation on the server -- if you're
	    // using Backbone's restful methods, override this to change the endpoint
	    // that will be called.
	    url: function() {
	      var base = _.result(this, 'urlRoot') || _.result(this.collection, 'url') || urlError();
	      if (this.isNew()) return base;
	      return base + (base.charAt(base.length - 1) === '/' ? '' : '/') + encodeURIComponent(this.id);
	    },
	
	    // **parse** converts a response into the hash of attributes to be `set` on
	    // the model. The default implementation is just to pass the response along.
	    parse: function(resp, options) {
	      return resp;
	    },
	
	    // Create a new model with identical attributes to this one.
	    clone: function() {
	      return new this.constructor(this.attributes);
	    },
	
	    // A model is new if it has never been saved to the server, and lacks an id.
	    isNew: function() {
	      return this.id == null;
	    },
	
	    // Check if the model is currently in a valid state.
	    isValid: function(options) {
	      return this._validate({}, _.extend(options || {}, { validate: true }));
	    },
	
	    // Run validation against the next complete set of model attributes,
	    // returning `true` if all is well. Otherwise, fire an `"invalid"` event.
	    _validate: function(attrs, options) {
	      if (!options.validate || !this.validate) return true;
	      attrs = _.extend({}, this.attributes, attrs);
	      var error = this.validationError = this.validate(attrs, options) || null;
	      if (!error) return true;
	      this.trigger('invalid', this, error, _.extend(options || {}, {validationError: error}));
	      return false;
	    }
	
	  });
	
	  // Underscore methods that we want to implement on the Model.
	  var modelMethods = ['keys', 'values', 'pairs', 'invert', 'pick', 'omit'];
	
	  // Mix in each Underscore method as a proxy to `Model#attributes`.
	  _.each(modelMethods, function(method) {
	    Model.prototype[method] = function() {
	      var args = slice.call(arguments);
	      args.unshift(this.attributes);
	      return _[method].apply(_, args);
	    };
	  });
	
	  // Backbone.Collection
	  // -------------------
	
	  // If models tend to represent a single row of data, a Backbone Collection is
	  // more analagous to a table full of data ... or a small slice or page of that
	  // table, or a collection of rows that belong together for a particular reason
	  // -- all of the messages in this particular folder, all of the documents
	  // belonging to this particular author, and so on. Collections maintain
	  // indexes of their models, both in order, and for lookup by `id`.
	
	  // Create a new **Collection**, perhaps to contain a specific type of `model`.
	  // If a `comparator` is specified, the Collection will maintain
	  // its models in sort order, as they're added and removed.
	  var Collection = Backbone.Collection = function(models, options) {
	    options || (options = {});
	    if (options.url) this.url = options.url;
	    if (options.model) this.model = options.model;
	    if (options.comparator !== void 0) this.comparator = options.comparator;
	    this._reset();
	    this.initialize.apply(this, arguments);
	    if (models) this.reset(models, _.extend({silent: true}, options));
	  };
	
	  // Default options for `Collection#set`.
	  var setOptions = {add: true, remove: true, merge: true};
	  var addOptions = {add: true, merge: false, remove: false};
	
	  // Define the Collection's inheritable methods.
	  _.extend(Collection.prototype, Events, {
	
	    // The default model for a collection is just a **Backbone.Model**.
	    // This should be overridden in most cases.
	    model: Model,
	
	    // Initialize is an empty function by default. Override it with your own
	    // initialization logic.
	    initialize: function(){},
	
	    // The JSON representation of a Collection is an array of the
	    // models' attributes.
	    toJSON: function(options) {
	      return this.map(function(model){ return model.toJSON(options); });
	    },
	
	    // Proxy `Backbone.sync` by default.
	    sync: function() {
	      return Backbone.sync.apply(this, arguments);
	    },
	
	    // Add a model, or list of models to the set.
	    add: function(models, options) {
	      return this.set(models, _.defaults(options || {}, addOptions));
	    },
	
	    // Remove a model, or a list of models from the set.
	    remove: function(models, options) {
	      models = _.isArray(models) ? models.slice() : [models];
	      options || (options = {});
	      var i, l, index, model;
	      for (i = 0, l = models.length; i < l; i++) {
	        model = this.get(models[i]);
	        if (!model) continue;
	        delete this._byId[model.id];
	        delete this._byId[model.cid];
	        index = this.indexOf(model);
	        this.models.splice(index, 1);
	        this.length--;
	        if (!options.silent) {
	          options.index = index;
	          model.trigger('remove', model, this, options);
	        }
	        this._removeReference(model);
	      }
	      return this;
	    },
	
	    // Update a collection by `set`-ing a new list of models, adding new ones,
	    // removing models that are no longer present, and merging models that
	    // already exist in the collection, as necessary. Similar to **Model#set**,
	    // the core operation for updating the data contained by the collection.
	    set: function(models, options) {
	      options = _.defaults(options || {}, setOptions);
	      if (options.parse) models = this.parse(models, options);
	      if (!_.isArray(models)) models = models ? [models] : [];
	      var i, l, model, attrs, existing, sort;
	      var at = options.at;
	      var sortable = this.comparator && (at == null) && options.sort !== false;
	      var sortAttr = _.isString(this.comparator) ? this.comparator : null;
	      var toAdd = [], toRemove = [], modelMap = {};
	
	      // Turn bare objects into model references, and prevent invalid models
	      // from being added.
	      for (i = 0, l = models.length; i < l; i++) {
	        if (!(model = this._prepareModel(models[i], options))) continue;
	
	        // If a duplicate is found, prevent it from being added and
	        // optionally merge it into the existing model.
	        if (existing = this.get(model)) {
	          if (options.remove) modelMap[existing.cid] = true;
	          if (options.merge) {
	            existing.set(model.attributes, options);
	            if (sortable && !sort && existing.hasChanged(sortAttr)) sort = true;
	          }
	
	        // This is a new model, push it to the `toAdd` list.
	        } else if (options.add) {
	          toAdd.push(model);
	
	          // Listen to added models' events, and index models for lookup by
	          // `id` and by `cid`.
	          model.on('all', this._onModelEvent, this);
	          this._byId[model.cid] = model;
	          if (model.id != null) this._byId[model.id] = model;
	        }
	      }
	
	      // Remove nonexistent models if appropriate.
	      if (options.remove) {
	        for (i = 0, l = this.length; i < l; ++i) {
	          if (!modelMap[(model = this.models[i]).cid]) toRemove.push(model);
	        }
	        if (toRemove.length) this.remove(toRemove, options);
	      }
	
	      // See if sorting is needed, update `length` and splice in new models.
	      if (toAdd.length) {
	        if (sortable) sort = true;
	        this.length += toAdd.length;
	        if (at != null) {
	          splice.apply(this.models, [at, 0].concat(toAdd));
	        } else {
	          push.apply(this.models, toAdd);
	        }
	      }
	
	      // Silently sort the collection if appropriate.
	      if (sort) this.sort({silent: true});
	
	      if (options.silent) return this;
	
	      // Trigger `add` events.
	      for (i = 0, l = toAdd.length; i < l; i++) {
	        (model = toAdd[i]).trigger('add', model, this, options);
	      }
	
	      // Trigger `sort` if the collection was sorted.
	      if (sort) this.trigger('sort', this, options);
	      return this;
	    },
	
	    // When you have more items than you want to add or remove individually,
	    // you can reset the entire set with a new list of models, without firing
	    // any granular `add` or `remove` events. Fires `reset` when finished.
	    // Useful for bulk operations and optimizations.
	    reset: function(models, options) {
	      options || (options = {});
	      for (var i = 0, l = this.models.length; i < l; i++) {
	        this._removeReference(this.models[i]);
	      }
	      options.previousModels = this.models;
	      this._reset();
	      this.add(models, _.extend({silent: true}, options));
	      if (!options.silent) this.trigger('reset', this, options);
	      return this;
	    },
	
	    // Add a model to the end of the collection.
	    push: function(model, options) {
	      model = this._prepareModel(model, options);
	      this.add(model, _.extend({at: this.length}, options));
	      return model;
	    },
	
	    // Remove a model from the end of the collection.
	    pop: function(options) {
	      var model = this.at(this.length - 1);
	      this.remove(model, options);
	      return model;
	    },
	
	    // Add a model to the beginning of the collection.
	    unshift: function(model, options) {
	      model = this._prepareModel(model, options);
	      this.add(model, _.extend({at: 0}, options));
	      return model;
	    },
	
	    // Remove a model from the beginning of the collection.
	    shift: function(options) {
	      var model = this.at(0);
	      this.remove(model, options);
	      return model;
	    },
	
	    // Slice out a sub-array of models from the collection.
	    slice: function(begin, end) {
	      return this.models.slice(begin, end);
	    },
	
	    // Get a model from the set by id.
	    get: function(obj) {
	      if (obj == null) return void 0;
	      return this._byId[obj.id != null ? obj.id : obj.cid || obj];
	    },
	
	    // Get the model at the given index.
	    at: function(index) {
	      return this.models[index];
	    },
	
	    // Return models with matching attributes. Useful for simple cases of
	    // `filter`.
	    where: function(attrs, first) {
	      if (_.isEmpty(attrs)) return first ? void 0 : [];
	      return this[first ? 'find' : 'filter'](function(model) {
	        for (var key in attrs) {
	          if (attrs[key] !== model.get(key)) return false;
	        }
	        return true;
	      });
	    },
	
	    // Return the first model with matching attributes. Useful for simple cases
	    // of `find`.
	    findWhere: function(attrs) {
	      return this.where(attrs, true);
	    },
	
	    // Force the collection to re-sort itself. You don't need to call this under
	    // normal circumstances, as the set will maintain sort order as each item
	    // is added.
	    sort: function(options) {
	      if (!this.comparator) throw new Error('Cannot sort a set without a comparator');
	      options || (options = {});
	
	      // Run sort based on type of `comparator`.
	      if (_.isString(this.comparator) || this.comparator.length === 1) {
	        this.models = this.sortBy(this.comparator, this);
	      } else {
	        this.models.sort(_.bind(this.comparator, this));
	      }
	
	      if (!options.silent) this.trigger('sort', this, options);
	      return this;
	    },
	
	    // Figure out the smallest index at which a model should be inserted so as
	    // to maintain order.
	    sortedIndex: function(model, value, context) {
	      value || (value = this.comparator);
	      var iterator = _.isFunction(value) ? value : function(model) {
	        return model.get(value);
	      };
	      return _.sortedIndex(this.models, model, iterator, context);
	    },
	
	    // Pluck an attribute from each model in the collection.
	    pluck: function(attr) {
	      return _.invoke(this.models, 'get', attr);
	    },
	
	    // Fetch the default set of models for this collection, resetting the
	    // collection when they arrive. If `reset: true` is passed, the response
	    // data will be passed through the `reset` method instead of `set`.
	    fetch: function(options) {
	      options = options ? _.clone(options) : {};
	      if (options.parse === void 0) options.parse = true;
	      var success = options.success;
	      var collection = this;
	      options.success = function(resp) {
	        var method = options.reset ? 'reset' : 'set';
	        collection[method](resp, options);
	        if (success) success(collection, resp, options);
	        collection.trigger('sync', collection, resp, options);
	      };
	      wrapError(this, options);
	      return this.sync('read', this, options);
	    },
	
	    // Create a new instance of a model in this collection. Add the model to the
	    // collection immediately, unless `wait: true` is passed, in which case we
	    // wait for the server to agree.
	    create: function(model, options) {
	      options = options ? _.clone(options) : {};
	      if (!(model = this._prepareModel(model, options))) return false;
	      if (!options.wait) this.add(model, options);
	      var collection = this;
	      var success = options.success;
	      options.success = function(resp) {
	        if (options.wait) collection.add(model, options);
	        if (success) success(model, resp, options);
	      };
	      model.save(null, options);
	      return model;
	    },
	
	    // **parse** converts a response into a list of models to be added to the
	    // collection. The default implementation is just to pass it through.
	    parse: function(resp, options) {
	      return resp;
	    },
	
	    // Create a new collection with an identical list of models as this one.
	    clone: function() {
	      return new this.constructor(this.models);
	    },
	
	    // Private method to reset all internal state. Called when the collection
	    // is first initialized or reset.
	    _reset: function() {
	      this.length = 0;
	      this.models = [];
	      this._byId  = {};
	    },
	
	    // Prepare a hash of attributes (or other model) to be added to this
	    // collection.
	    _prepareModel: function(attrs, options) {
	      if (attrs instanceof Model) {
	        if (!attrs.collection) attrs.collection = this;
	        return attrs;
	      }
	      options || (options = {});
	      options.collection = this;
	      var model = new this.model(attrs, options);
	      if (!model._validate(attrs, options)) {
	        this.trigger('invalid', this, attrs, options);
	        return false;
	      }
	      return model;
	    },
	
	    // Internal method to sever a model's ties to a collection.
	    _removeReference: function(model) {
	      if (this === model.collection) delete model.collection;
	      model.off('all', this._onModelEvent, this);
	    },
	
	    // Internal method called every time a model in the set fires an event.
	    // Sets need to update their indexes when models change ids. All other
	    // events simply proxy through. "add" and "remove" events that originate
	    // in other collections are ignored.
	    _onModelEvent: function(event, model, collection, options) {
	      if ((event === 'add' || event === 'remove') && collection !== this) return;
	      if (event === 'destroy') this.remove(model, options);
	      if (model && event === 'change:' + model.idAttribute) {
	        delete this._byId[model.previous(model.idAttribute)];
	        if (model.id != null) this._byId[model.id] = model;
	      }
	      this.trigger.apply(this, arguments);
	    }
	
	  });
	
	  // Underscore methods that we want to implement on the Collection.
	  // 90% of the core usefulness of Backbone Collections is actually implemented
	  // right here:
	  var methods = ['forEach', 'each', 'map', 'collect', 'reduce', 'foldl',
	    'inject', 'reduceRight', 'foldr', 'find', 'detect', 'filter', 'select',
	    'reject', 'every', 'all', 'some', 'any', 'include', 'contains', 'invoke',
	    'max', 'min', 'toArray', 'size', 'first', 'head', 'take', 'initial', 'rest',
	    'tail', 'drop', 'last', 'without', 'indexOf', 'shuffle', 'lastIndexOf',
	    'isEmpty', 'chain'];
	
	  // Mix in each Underscore method as a proxy to `Collection#models`.
	  _.each(methods, function(method) {
	    Collection.prototype[method] = function() {
	      var args = slice.call(arguments);
	      args.unshift(this.models);
	      return _[method].apply(_, args);
	    };
	  });
	
	  // Underscore methods that take a property name as an argument.
	  var attributeMethods = ['groupBy', 'countBy', 'sortBy'];
	
	  // Use attributes instead of properties.
	  _.each(attributeMethods, function(method) {
	    Collection.prototype[method] = function(value, context) {
	      var iterator = _.isFunction(value) ? value : function(model) {
	        return model.get(value);
	      };
	      return _[method](this.models, iterator, context);
	    };
	  });
	
	  // Backbone.View
	  // -------------
	
	  // Backbone Views are almost more convention than they are actual code. A View
	  // is simply a JavaScript object that represents a logical chunk of UI in the
	  // DOM. This might be a single item, an entire list, a sidebar or panel, or
	  // even the surrounding frame which wraps your whole app. Defining a chunk of
	  // UI as a **View** allows you to define your DOM events declaratively, without
	  // having to worry about render order ... and makes it easy for the view to
	  // react to specific changes in the state of your models.
	
	  // Creating a Backbone.View creates its initial element outside of the DOM,
	  // if an existing element is not provided...
	  var View = Backbone.View = function(options) {
	    this.cid = _.uniqueId('view');
	    this._configure(options || {});
	    this._ensureElement();
	    this.initialize.apply(this, arguments);
	    this.delegateEvents();
	  };
	
	  // Cached regex to split keys for `delegate`.
	  var delegateEventSplitter = /^(\S+)\s*(.*)$/;
	
	  // List of view options to be merged as properties.
	  var viewOptions = ['model', 'collection', 'el', 'id', 'attributes', 'className', 'tagName', 'events'];
	
	  // Set up all inheritable **Backbone.View** properties and methods.
	  _.extend(View.prototype, Events, {
	
	    // The default `tagName` of a View's element is `"div"`.
	    tagName: 'div',
	
	    // jQuery delegate for element lookup, scoped to DOM elements within the
	    // current view. This should be prefered to global lookups where possible.
	    $: function(selector) {
	      return this.$el.find(selector);
	    },
	
	    // Initialize is an empty function by default. Override it with your own
	    // initialization logic.
	    initialize: function(){},
	
	    // **render** is the core function that your view should override, in order
	    // to populate its element (`this.el`), with the appropriate HTML. The
	    // convention is for **render** to always return `this`.
	    render: function() {
	      return this;
	    },
	
	    // Remove this view by taking the element out of the DOM, and removing any
	    // applicable Backbone.Events listeners.
	    remove: function() {
	      this.$el.remove();
	      this.stopListening();
	      return this;
	    },
	
	    // Change the view's element (`this.el` property), including event
	    // re-delegation.
	    setElement: function(element, delegate) {
	      if (this.$el) this.undelegateEvents();
	      this.$el = element instanceof Backbone.$ ? element : Backbone.$(element);
	      this.el = this.$el[0];
	      if (delegate !== false) this.delegateEvents();
	      return this;
	    },
	
	    // Set callbacks, where `this.events` is a hash of
	    //
	    // *{"event selector": "callback"}*
	    //
	    //     {
	    //       'mousedown .title':  'edit',
	    //       'click .button':     'save'
	    //       'click .open':       function(e) { ... }
	    //     }
	    //
	    // pairs. Callbacks will be bound to the view, with `this` set properly.
	    // Uses event delegation for efficiency.
	    // Omitting the selector binds the event to `this.el`.
	    // This only works for delegate-able events: not `focus`, `blur`, and
	    // not `change`, `submit`, and `reset` in Internet Explorer.
	    delegateEvents: function(events) {
	      if (!(events || (events = _.result(this, 'events')))) return this;
	      this.undelegateEvents();
	      for (var key in events) {
	        var method = events[key];
	        if (!_.isFunction(method)) method = this[events[key]];
	        if (!method) continue;
	
	        var match = key.match(delegateEventSplitter);
	        var eventName = match[1], selector = match[2];
	        method = _.bind(method, this);
	        eventName += '.delegateEvents' + this.cid;
	        if (selector === '') {
	          this.$el.on(eventName, method);
	        } else {
	          this.$el.on(eventName, selector, method);
	        }
	      }
	      return this;
	    },
	
	    // Clears all callbacks previously bound to the view with `delegateEvents`.
	    // You usually don't need to use this, but may wish to if you have multiple
	    // Backbone views attached to the same DOM element.
	    undelegateEvents: function() {
	      this.$el.off('.delegateEvents' + this.cid);
	      return this;
	    },
	
	    // Performs the initial configuration of a View with a set of options.
	    // Keys with special meaning *(e.g. model, collection, id, className)* are
	    // attached directly to the view.  See `viewOptions` for an exhaustive
	    // list.
	    _configure: function(options) {
	      if (this.options) options = _.extend({}, _.result(this, 'options'), options);
	      _.extend(this, _.pick(options, viewOptions));
	      this.options = options;
	    },
	
	    // Ensure that the View has a DOM element to render into.
	    // If `this.el` is a string, pass it through `$()`, take the first
	    // matching element, and re-assign it to `el`. Otherwise, create
	    // an element from the `id`, `className` and `tagName` properties.
	    _ensureElement: function() {
	      if (!this.el) {
	        var attrs = _.extend({}, _.result(this, 'attributes'));
	        if (this.id) attrs.id = _.result(this, 'id');
	        if (this.className) attrs['class'] = _.result(this, 'className');
	        var $el = Backbone.$('<' + _.result(this, 'tagName') + '>').attr(attrs);
	        this.setElement($el, false);
	      } else {
	        this.setElement(_.result(this, 'el'), false);
	      }
	    }
	
	  });
	
	  // Backbone.sync
	  // -------------
	
	  // Override this function to change the manner in which Backbone persists
	  // models to the server. You will be passed the type of request, and the
	  // model in question. By default, makes a RESTful Ajax request
	  // to the model's `url()`. Some possible customizations could be:
	  //
	  // * Use `setTimeout` to batch rapid-fire updates into a single request.
	  // * Send up the models as XML instead of JSON.
	  // * Persist models via WebSockets instead of Ajax.
	  //
	  // Turn on `Backbone.emulateHTTP` in order to send `PUT` and `DELETE` requests
	  // as `POST`, with a `_method` parameter containing the true HTTP method,
	  // as well as all requests with the body as `application/x-www-form-urlencoded`
	  // instead of `application/json` with the model in a param named `model`.
	  // Useful when interfacing with server-side languages like **PHP** that make
	  // it difficult to read the body of `PUT` requests.
	  Backbone.sync = function(method, model, options) {
	    var type = methodMap[method];
	
	    // Default options, unless specified.
	    _.defaults(options || (options = {}), {
	      emulateHTTP: Backbone.emulateHTTP,
	      emulateJSON: Backbone.emulateJSON
	    });
	
	    // Default JSON-request options.
	    var params = {type: type, dataType: 'json'};
	
	    // Ensure that we have a URL.
	    if (!options.url) {
	      params.url = _.result(model, 'url') || urlError();
	    }
	
	    // Ensure that we have the appropriate request data.
	    if (options.data == null && model && (method === 'create' || method === 'update' || method === 'patch')) {
	      params.contentType = 'application/json';
	      params.data = JSON.stringify(options.attrs || model.toJSON(options));
	    }
	
	    // For older servers, emulate JSON by encoding the request into an HTML-form.
	    if (options.emulateJSON) {
	      params.contentType = 'application/x-www-form-urlencoded';
	      params.data = params.data ? {model: params.data} : {};
	    }
	
	    // For older servers, emulate HTTP by mimicking the HTTP method with `_method`
	    // And an `X-HTTP-Method-Override` header.
	    if (options.emulateHTTP && (type === 'PUT' || type === 'DELETE' || type === 'PATCH')) {
	      params.type = 'POST';
	      if (options.emulateJSON) params.data._method = type;
	      var beforeSend = options.beforeSend;
	      options.beforeSend = function(xhr) {
	        xhr.setRequestHeader('X-HTTP-Method-Override', type);
	        if (beforeSend) return beforeSend.apply(this, arguments);
	      };
	    }
	
	    // Don't process data on a non-GET request.
	    if (params.type !== 'GET' && !options.emulateJSON) {
	      params.processData = false;
	    }
	
	    // If we're sending a `PATCH` request, and we're in an old Internet Explorer
	    // that still has ActiveX enabled by default, override jQuery to use that
	    // for XHR instead. Remove this line when jQuery supports `PATCH` on IE8.
	    if (params.type === 'PATCH' && window.ActiveXObject &&
	          !(window.external && window.external.msActiveXFilteringEnabled)) {
	      params.xhr = function() {
	        return new ActiveXObject("Microsoft.XMLHTTP");
	      };
	    }
	
	    // Make the request, allowing the user to override any Ajax options.
	    var xhr = options.xhr = Backbone.ajax(_.extend(params, options));
	    model.trigger('request', model, xhr, options);
	    return xhr;
	  };
	
	  // Map from CRUD to HTTP for our default `Backbone.sync` implementation.
	  var methodMap = {
	    'create': 'POST',
	    'update': 'PUT',
	    'patch':  'PATCH',
	    'delete': 'DELETE',
	    'read':   'GET'
	  };
	
	  // Set the default implementation of `Backbone.ajax` to proxy through to `$`.
	  // Override this if you'd like to use a different library.
	  Backbone.ajax = function() {
	    return Backbone.$.ajax.apply(Backbone.$, arguments);
	  };
	
	  // Backbone.Router
	  // ---------------
	
	  // Routers map faux-URLs to actions, and fire events when routes are
	  // matched. Creating a new one sets its `routes` hash, if not set statically.
	  var Router = Backbone.Router = function(options) {
	    options || (options = {});
	    if (options.routes) this.routes = options.routes;
	    this._bindRoutes();
	    this.initialize.apply(this, arguments);
	  };
	
	  // Cached regular expressions for matching named param parts and splatted
	  // parts of route strings.
	  var optionalParam = /\((.*?)\)/g;
	  var namedParam    = /(\(\?)?:\w+/g;
	  var splatParam    = /\*\w+/g;
	  var escapeRegExp  = /[\-{}\[\]+?.,\\\^$|#\s]/g;
	
	  // Set up all inheritable **Backbone.Router** properties and methods.
	  _.extend(Router.prototype, Events, {
	
	    // Initialize is an empty function by default. Override it with your own
	    // initialization logic.
	    initialize: function(){},
	
	    // Manually bind a single named route to a callback. For example:
	    //
	    //     this.route('search/:query/p:num', 'search', function(query, num) {
	    //       ...
	    //     });
	    //
	    route: function(route, name, callback) {
	      if (!_.isRegExp(route)) route = this._routeToRegExp(route);
	      if (_.isFunction(name)) {
	        callback = name;
	        name = '';
	      }
	      if (!callback) callback = this[name];
	      var router = this;
	      Backbone.history.route(route, function(fragment) {
	        var args = router._extractParameters(route, fragment);
	        callback && callback.apply(router, args);
	        router.trigger.apply(router, ['route:' + name].concat(args));
	        router.trigger('route', name, args);
	        Backbone.history.trigger('route', router, name, args);
	      });
	      return this;
	    },
	
	    // Simple proxy to `Backbone.history` to save a fragment into the history.
	    navigate: function(fragment, options) {
	      Backbone.history.navigate(fragment, options);
	      return this;
	    },
	
	    // Bind all defined routes to `Backbone.history`. We have to reverse the
	    // order of the routes here to support behavior where the most general
	    // routes can be defined at the bottom of the route map.
	    _bindRoutes: function() {
	      if (!this.routes) return;
	      this.routes = _.result(this, 'routes');
	      var route, routes = _.keys(this.routes);
	      while ((route = routes.pop()) != null) {
	        this.route(route, this.routes[route]);
	      }
	    },
	
	    // Convert a route string into a regular expression, suitable for matching
	    // against the current location hash.
	    _routeToRegExp: function(route) {
	      route = route.replace(escapeRegExp, '\\$&')
	                   .replace(optionalParam, '(?:$1)?')
	                   .replace(namedParam, function(match, optional){
	                     return optional ? match : '([^\/]+)';
	                   })
	                   .replace(splatParam, '(.*?)');
	      return new RegExp('^' + route + '$');
	    },
	
	    // Given a route, and a URL fragment that it matches, return the array of
	    // extracted decoded parameters. Empty or unmatched parameters will be
	    // treated as `null` to normalize cross-browser behavior.
	    _extractParameters: function(route, fragment) {
	      var params = route.exec(fragment).slice(1);
	      return _.map(params, function(param) {
	        return param ? decodeURIComponent(param) : null;
	      });
	    }
	
	  });
	
	  // Backbone.History
	  // ----------------
	
	  // Handles cross-browser history management, based on either
	  // [pushState](http://diveintohtml5.info/history.html) and real URLs, or
	  // [onhashchange](https://developer.mozilla.org/en-US/docs/DOM/window.onhashchange)
	  // and URL fragments. If the browser supports neither (old IE, natch),
	  // falls back to polling.
	  var History = Backbone.History = function() {
	    this.handlers = [];
	    _.bindAll(this, 'checkUrl');
	
	    // Ensure that `History` can be used outside of the browser.
	    if (typeof window !== 'undefined') {
	      this.location = window.location;
	      this.history = window.history;
	    }
	  };
	
	  // Cached regex for stripping a leading hash/slash and trailing space.
	  var routeStripper = /^[#\/]|\s+$/g;
	
	  // Cached regex for stripping leading and trailing slashes.
	  var rootStripper = /^\/+|\/+$/g;
	
	  // Cached regex for detecting MSIE.
	  var isExplorer = /msie [\w.]+/;
	
	  // Cached regex for removing a trailing slash.
	  var trailingSlash = /\/$/;
	
	  // Has the history handling already been started?
	  History.started = false;
	
	  // Set up all inheritable **Backbone.History** properties and methods.
	  _.extend(History.prototype, Events, {
	
	    // The default interval to poll for hash changes, if necessary, is
	    // twenty times a second.
	    interval: 50,
	
	    // Gets the true hash value. Cannot use location.hash directly due to bug
	    // in Firefox where location.hash will always be decoded.
	    getHash: function(window) {
	      var match = (window || this).location.href.match(/#(.*)$/);
	      return match ? match[1] : '';
	    },
	
	    // Get the cross-browser normalized URL fragment, either from the URL,
	    // the hash, or the override.
	    getFragment: function(fragment, forcePushState) {
	      if (fragment == null) {
	        if (this._hasPushState || !this._wantsHashChange || forcePushState) {
	          fragment = this.location.pathname;
	          var root = this.root.replace(trailingSlash, '');
	          if (!fragment.indexOf(root)) fragment = fragment.substr(root.length);
	        } else {
	          fragment = this.getHash();
	        }
	      }
	      return fragment.replace(routeStripper, '');
	    },
	
	    // Start the hash change handling, returning `true` if the current URL matches
	    // an existing route, and `false` otherwise.
	    start: function(options) {
	      if (History.started) throw new Error("Backbone.history has already been started");
	      History.started = true;
	
	      // Figure out the initial configuration. Do we need an iframe?
	      // Is pushState desired ... is it available?
	      this.options          = _.extend({}, {root: '/'}, this.options, options);
	      this.root             = this.options.root;
	      this._wantsHashChange = this.options.hashChange !== false;
	      this._wantsPushState  = !!this.options.pushState;
	      this._hasPushState    = !!(this.options.pushState && this.history && this.history.pushState);
	      var fragment          = this.getFragment();
	      var docMode           = document.documentMode;
	      var oldIE             = (isExplorer.exec(navigator.userAgent.toLowerCase()) && (!docMode || docMode <= 7));
	
	      // Normalize root to always include a leading and trailing slash.
	      this.root = ('/' + this.root + '/').replace(rootStripper, '/');
	
	      if (oldIE && this._wantsHashChange) {
	        this.iframe = Backbone.$('<iframe src="javascript:0" tabindex="-1" />').hide().appendTo('body')[0].contentWindow;
	        this.navigate(fragment);
	      }
	
	      // Depending on whether we're using pushState or hashes, and whether
	      // 'onhashchange' is supported, determine how we check the URL state.
	      if (this._hasPushState) {
	        Backbone.$(window).on('popstate', this.checkUrl);
	      } else if (this._wantsHashChange && ('onhashchange' in window) && !oldIE) {
	        Backbone.$(window).on('hashchange', this.checkUrl);
	      } else if (this._wantsHashChange) {
	        this._checkUrlInterval = setInterval(this.checkUrl, this.interval);
	      }
	
	      // Determine if we need to change the base url, for a pushState link
	      // opened by a non-pushState browser.
	      this.fragment = fragment;
	      var loc = this.location;
	      var atRoot = loc.pathname.replace(/[^\/]$/, '$&/') === this.root;
	
	      // If we've started off with a route from a `pushState`-enabled browser,
	      // but we're currently in a browser that doesn't support it...
	      if (this._wantsHashChange && this._wantsPushState && !this._hasPushState && !atRoot) {
	        this.fragment = this.getFragment(null, true);
	        this.location.replace(this.root + this.location.search + '#' + this.fragment);
	        // Return immediately as browser will do redirect to new url
	        return true;
	
	      // Or if we've started out with a hash-based route, but we're currently
	      // in a browser where it could be `pushState`-based instead...
	      } else if (this._wantsPushState && this._hasPushState && atRoot && loc.hash) {
	        this.fragment = this.getHash().replace(routeStripper, '');
	        this.history.replaceState({}, document.title, this.root + this.fragment + loc.search);
	      }
	
	      if (!this.options.silent) return this.loadUrl();
	    },
	
	    // Disable Backbone.history, perhaps temporarily. Not useful in a real app,
	    // but possibly useful for unit testing Routers.
	    stop: function() {
	      Backbone.$(window).off('popstate', this.checkUrl).off('hashchange', this.checkUrl);
	      clearInterval(this._checkUrlInterval);
	      History.started = false;
	    },
	
	    // Add a route to be tested when the fragment changes. Routes added later
	    // may override previous routes.
	    route: function(route, callback) {
	      this.handlers.unshift({route: route, callback: callback});
	    },
	
	    // Checks the current URL to see if it has changed, and if it has,
	    // calls `loadUrl`, normalizing across the hidden iframe.
	    checkUrl: function(e) {
	      var current = this.getFragment();
	      if (current === this.fragment && this.iframe) {
	        current = this.getFragment(this.getHash(this.iframe));
	      }
	      if (current === this.fragment) return false;
	      if (this.iframe) this.navigate(current);
	      this.loadUrl() || this.loadUrl(this.getHash());
	    },
	
	    // Attempt to load the current URL fragment. If a route succeeds with a
	    // match, returns `true`. If no defined routes matches the fragment,
	    // returns `false`.
	    loadUrl: function(fragmentOverride) {
	      var fragment = this.fragment = this.getFragment(fragmentOverride);
	      var matched = _.any(this.handlers, function(handler) {
	        if (handler.route.test(fragment)) {
	          handler.callback(fragment);
	          return true;
	        }
	      });
	      return matched;
	    },
	
	    // Save a fragment into the hash history, or replace the URL state if the
	    // 'replace' option is passed. You are responsible for properly URL-encoding
	    // the fragment in advance.
	    //
	    // The options object can contain `trigger: true` if you wish to have the
	    // route callback be fired (not usually desirable), or `replace: true`, if
	    // you wish to modify the current URL without adding an entry to the history.
	    navigate: function(fragment, options) {
	      if (!History.started) return false;
	      if (!options || options === true) options = {trigger: options};
	      fragment = this.getFragment(fragment || '');
	      if (this.fragment === fragment) return;
	      this.fragment = fragment;
	      var url = this.root + fragment;
	
	      // If pushState is available, we use it to set the fragment as a real URL.
	      if (this._hasPushState) {
	        this.history[options.replace ? 'replaceState' : 'pushState']({}, document.title, url);
	
	      // If hash changes haven't been explicitly disabled, update the hash
	      // fragment to store history.
	      } else if (this._wantsHashChange) {
	        this._updateHash(this.location, fragment, options.replace);
	        if (this.iframe && (fragment !== this.getFragment(this.getHash(this.iframe)))) {
	          // Opening and closing the iframe tricks IE7 and earlier to push a
	          // history entry on hash-tag change.  When replace is true, we don't
	          // want this.
	          if(!options.replace) this.iframe.document.open().close();
	          this._updateHash(this.iframe.location, fragment, options.replace);
	        }
	
	      // If you've told us that you explicitly don't want fallback hashchange-
	      // based history, then `navigate` becomes a page refresh.
	      } else {
	        return this.location.assign(url);
	      }
	      if (options.trigger) this.loadUrl(fragment);
	    },
	
	    // Update the hash location, either replacing the current entry, or adding
	    // a new one to the browser history.
	    _updateHash: function(location, fragment, replace) {
	      if (replace) {
	        var href = location.href.replace(/(javascript:|#).*$/, '');
	        location.replace(href + '#' + fragment);
	      } else {
	        // Some browsers require that `hash` contains a leading #.
	        location.hash = '#' + fragment;
	      }
	    }
	
	  });
	
	  // Create the default Backbone.history.
	  Backbone.history = new History;
	
	  // Helpers
	  // -------
	
	  // Helper function to correctly set up the prototype chain, for subclasses.
	  // Similar to `goog.inherits`, but uses a hash of prototype properties and
	  // class properties to be extended.
	  var extend = function(protoProps, staticProps) {
	    var parent = this;
	    var child;
	
	    // The constructor function for the new subclass is either defined by you
	    // (the "constructor" property in your `extend` definition), or defaulted
	    // by us to simply call the parent's constructor.
	    if (protoProps && _.has(protoProps, 'constructor')) {
	      child = protoProps.constructor;
	    } else {
	      child = function(){ return parent.apply(this, arguments); };
	    }
	
	    // Add static properties to the constructor function, if supplied.
	    _.extend(child, parent, staticProps);
	
	    // Set the prototype chain to inherit from `parent`, without calling
	    // `parent`'s constructor function.
	    var Surrogate = function(){ this.constructor = child; };
	    Surrogate.prototype = parent.prototype;
	    child.prototype = new Surrogate;
	
	    // Add prototype properties (instance properties) to the subclass,
	    // if supplied.
	    if (protoProps) _.extend(child.prototype, protoProps);
	
	    // Set a convenience property in case the parent's prototype is needed
	    // later.
	    child.__super__ = parent.prototype;
	
	    return child;
	  };
	
	  // Set up inheritance for the model, collection, router, view and history.
	  Model.extend = Collection.extend = Router.extend = View.extend = History.extend = extend;
	
	  // Throw an error when a URL is needed, and none is supplied.
	  var urlError = function() {
	    throw new Error('A "url" property or function must be specified');
	  };
	
	  // Wrap an optional error callback with a fallback error event.
	  var wrapError = function (model, options) {
	    var error = options.error;
	    options.error = function(resp) {
	      if (error) error(model, resp, options);
	      model.trigger('error', model, resp, options);
	    };
	  };
	
	  return Backbone;
	}));


/***/ }),
/* 216 */
/***/ (function(module, exports) {

	/*!
	 * Bootstrap v3.3.6 (http://getbootstrap.com)
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under the MIT license
	 */
	
	if (typeof jQuery === 'undefined') {
	  throw new Error('Bootstrap\'s JavaScript requires jQuery')
	}
	
	+function ($) {
	  'use strict';
	  var version = $.fn.jquery.split(' ')[0].split('.')
	  if ((version[0] < 2 && version[1] < 9) || (version[0] == 1 && version[1] == 9 && version[2] < 1) || (version[0] > 2)) {
	    throw new Error('Bootstrap\'s JavaScript requires jQuery version 1.9.1 or higher, but lower than version 3')
	  }
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: transition.js v3.3.6
	 * http://getbootstrap.com/javascript/#transitions
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // CSS TRANSITION SUPPORT (Shoutout: http://www.modernizr.com/)
	  // ============================================================
	
	  function transitionEnd() {
	    var el = document.createElement('bootstrap')
	
	    var transEndEventNames = {
	      WebkitTransition : 'webkitTransitionEnd',
	      MozTransition    : 'transitionend',
	      OTransition      : 'oTransitionEnd otransitionend',
	      transition       : 'transitionend'
	    }
	
	    for (var name in transEndEventNames) {
	      if (el.style[name] !== undefined) {
	        return { end: transEndEventNames[name] }
	      }
	    }
	
	    return false // explicit for ie8 (  ._.)
	  }
	
	  // http://blog.alexmaccaw.com/css-transitions
	  $.fn.emulateTransitionEnd = function (duration) {
	    var called = false
	    var $el = this
	    $(this).one('bsTransitionEnd', function () { called = true })
	    var callback = function () { if (!called) $($el).trigger($.support.transition.end) }
	    setTimeout(callback, duration)
	    return this
	  }
	
	  $(function () {
	    $.support.transition = transitionEnd()
	
	    if (!$.support.transition) return
	
	    $.event.special.bsTransitionEnd = {
	      bindType: $.support.transition.end,
	      delegateType: $.support.transition.end,
	      handle: function (e) {
	        if ($(e.target).is(this)) return e.handleObj.handler.apply(this, arguments)
	      }
	    }
	  })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: alert.js v3.3.6
	 * http://getbootstrap.com/javascript/#alerts
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // ALERT CLASS DEFINITION
	  // ======================
	
	  var dismiss = '[data-dismiss="alert"]'
	  var Alert   = function (el) {
	    $(el).on('click', dismiss, this.close)
	  }
	
	  Alert.VERSION = '3.3.6'
	
	  Alert.TRANSITION_DURATION = 150
	
	  Alert.prototype.close = function (e) {
	    var $this    = $(this)
	    var selector = $this.attr('data-target')
	
	    if (!selector) {
	      selector = $this.attr('href')
	      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
	    }
	
	    var $parent = $(selector)
	
	    if (e) e.preventDefault()
	
	    if (!$parent.length) {
	      $parent = $this.closest('.alert')
	    }
	
	    $parent.trigger(e = $.Event('close.bs.alert'))
	
	    if (e.isDefaultPrevented()) return
	
	    $parent.removeClass('in')
	
	    function removeElement() {
	      // detach from parent, fire event then clean up data
	      $parent.detach().trigger('closed.bs.alert').remove()
	    }
	
	    $.support.transition && $parent.hasClass('fade') ?
	      $parent
	        .one('bsTransitionEnd', removeElement)
	        .emulateTransitionEnd(Alert.TRANSITION_DURATION) :
	      removeElement()
	  }
	
	
	  // ALERT PLUGIN DEFINITION
	  // =======================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this)
	      var data  = $this.data('bs.alert')
	
	      if (!data) $this.data('bs.alert', (data = new Alert(this)))
	      if (typeof option == 'string') data[option].call($this)
	    })
	  }
	
	  var old = $.fn.alert
	
	  $.fn.alert             = Plugin
	  $.fn.alert.Constructor = Alert
	
	
	  // ALERT NO CONFLICT
	  // =================
	
	  $.fn.alert.noConflict = function () {
	    $.fn.alert = old
	    return this
	  }
	
	
	  // ALERT DATA-API
	  // ==============
	
	  $(document).on('click.bs.alert.data-api', dismiss, Alert.prototype.close)
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: button.js v3.3.6
	 * http://getbootstrap.com/javascript/#buttons
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // BUTTON PUBLIC CLASS DEFINITION
	  // ==============================
	
	  var Button = function (element, options) {
	    this.$element  = $(element)
	    this.options   = $.extend({}, Button.DEFAULTS, options)
	    this.isLoading = false
	  }
	
	  Button.VERSION  = '3.3.6'
	
	  Button.DEFAULTS = {
	    loadingText: 'loading...'
	  }
	
	  Button.prototype.setState = function (state) {
	    var d    = 'disabled'
	    var $el  = this.$element
	    var val  = $el.is('input') ? 'val' : 'html'
	    var data = $el.data()
	
	    state += 'Text'
	
	    if (data.resetText == null) $el.data('resetText', $el[val]())
	
	    // push to event loop to allow forms to submit
	    setTimeout($.proxy(function () {
	      $el[val](data[state] == null ? this.options[state] : data[state])
	
	      if (state == 'loadingText') {
	        this.isLoading = true
	        $el.addClass(d).attr(d, d)
	      } else if (this.isLoading) {
	        this.isLoading = false
	        $el.removeClass(d).removeAttr(d)
	      }
	    }, this), 0)
	  }
	
	  Button.prototype.toggle = function () {
	    var changed = true
	    var $parent = this.$element.closest('[data-toggle="buttons"]')
	
	    if ($parent.length) {
	      var $input = this.$element.find('input')
	      if ($input.prop('type') == 'radio') {
	        if ($input.prop('checked')) changed = false
	        $parent.find('.active').removeClass('active')
	        this.$element.addClass('active')
	      } else if ($input.prop('type') == 'checkbox') {
	        if (($input.prop('checked')) !== this.$element.hasClass('active')) changed = false
	        this.$element.toggleClass('active')
	      }
	      $input.prop('checked', this.$element.hasClass('active'))
	      if (changed) $input.trigger('change')
	    } else {
	      this.$element.attr('aria-pressed', !this.$element.hasClass('active'))
	      this.$element.toggleClass('active')
	    }
	  }
	
	
	  // BUTTON PLUGIN DEFINITION
	  // ========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.button')
	      var options = typeof option == 'object' && option
	
	      if (!data) $this.data('bs.button', (data = new Button(this, options)))
	
	      if (option == 'toggle') data.toggle()
	      else if (option) data.setState(option)
	    })
	  }
	
	  var old = $.fn.button
	
	  $.fn.button             = Plugin
	  $.fn.button.Constructor = Button
	
	
	  // BUTTON NO CONFLICT
	  // ==================
	
	  $.fn.button.noConflict = function () {
	    $.fn.button = old
	    return this
	  }
	
	
	  // BUTTON DATA-API
	  // ===============
	
	  $(document)
	    .on('click.bs.button.data-api', '[data-toggle^="button"]', function (e) {
	      var $btn = $(e.target).closest('.btn')
	      Plugin.call($btn, 'toggle')
	      if (!($(e.target).is('input[type="radio"]') || $(e.target).is('input[type="checkbox"]'))) {
	        // Prevent double click on radios, and the double selections (so cancellation) on checkboxes
	        e.preventDefault()
	        // The target component still receive the focus
	        if ($btn.is('input,button')) $btn.trigger('focus')
	        else $btn.find('input:visible,button:visible').first().trigger('focus')
	      }
	    })
	    .on('focus.bs.button.data-api blur.bs.button.data-api', '[data-toggle^="button"]', function (e) {
	      $(e.target).closest('.btn').toggleClass('focus', /^focus(in)?$/.test(e.type))
	    })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: carousel.js v3.3.6
	 * http://getbootstrap.com/javascript/#carousel
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // CAROUSEL CLASS DEFINITION
	  // =========================
	
	  var Carousel = function (element, options) {
	    this.$element    = $(element)
	    this.$indicators = this.$element.find('.carousel-indicators')
	    this.options     = options
	    this.paused      = null
	    this.sliding     = null
	    this.interval    = null
	    this.$active     = null
	    this.$items      = null
	
	    this.options.keyboard && this.$element.on('keydown.bs.carousel', $.proxy(this.keydown, this))
	
	    this.options.pause == 'hover' && !('ontouchstart' in document.documentElement) && this.$element
	      .on('mouseenter.bs.carousel', $.proxy(this.pause, this))
	      .on('mouseleave.bs.carousel', $.proxy(this.cycle, this))
	  }
	
	  Carousel.VERSION  = '3.3.6'
	
	  Carousel.TRANSITION_DURATION = 600
	
	  Carousel.DEFAULTS = {
	    interval: 5000,
	    pause: 'hover',
	    wrap: true,
	    keyboard: true
	  }
	
	  Carousel.prototype.keydown = function (e) {
	    if (/input|textarea/i.test(e.target.tagName)) return
	    switch (e.which) {
	      case 37: this.prev(); break
	      case 39: this.next(); break
	      default: return
	    }
	
	    e.preventDefault()
	  }
	
	  Carousel.prototype.cycle = function (e) {
	    e || (this.paused = false)
	
	    this.interval && clearInterval(this.interval)
	
	    this.options.interval
	      && !this.paused
	      && (this.interval = setInterval($.proxy(this.next, this), this.options.interval))
	
	    return this
	  }
	
	  Carousel.prototype.getItemIndex = function (item) {
	    this.$items = item.parent().children('.item')
	    return this.$items.index(item || this.$active)
	  }
	
	  Carousel.prototype.getItemForDirection = function (direction, active) {
	    var activeIndex = this.getItemIndex(active)
	    var willWrap = (direction == 'prev' && activeIndex === 0)
	                || (direction == 'next' && activeIndex == (this.$items.length - 1))
	    if (willWrap && !this.options.wrap) return active
	    var delta = direction == 'prev' ? -1 : 1
	    var itemIndex = (activeIndex + delta) % this.$items.length
	    return this.$items.eq(itemIndex)
	  }
	
	  Carousel.prototype.to = function (pos) {
	    var that        = this
	    var activeIndex = this.getItemIndex(this.$active = this.$element.find('.item.active'))
	
	    if (pos > (this.$items.length - 1) || pos < 0) return
	
	    if (this.sliding)       return this.$element.one('slid.bs.carousel', function () { that.to(pos) }) // yes, "slid"
	    if (activeIndex == pos) return this.pause().cycle()
	
	    return this.slide(pos > activeIndex ? 'next' : 'prev', this.$items.eq(pos))
	  }
	
	  Carousel.prototype.pause = function (e) {
	    e || (this.paused = true)
	
	    if (this.$element.find('.next, .prev').length && $.support.transition) {
	      this.$element.trigger($.support.transition.end)
	      this.cycle(true)
	    }
	
	    this.interval = clearInterval(this.interval)
	
	    return this
	  }
	
	  Carousel.prototype.next = function () {
	    if (this.sliding) return
	    return this.slide('next')
	  }
	
	  Carousel.prototype.prev = function () {
	    if (this.sliding) return
	    return this.slide('prev')
	  }
	
	  Carousel.prototype.slide = function (type, next) {
	    var $active   = this.$element.find('.item.active')
	    var $next     = next || this.getItemForDirection(type, $active)
	    var isCycling = this.interval
	    var direction = type == 'next' ? 'left' : 'right'
	    var that      = this
	
	    if ($next.hasClass('active')) return (this.sliding = false)
	
	    var relatedTarget = $next[0]
	    var slideEvent = $.Event('slide.bs.carousel', {
	      relatedTarget: relatedTarget,
	      direction: direction
	    })
	    this.$element.trigger(slideEvent)
	    if (slideEvent.isDefaultPrevented()) return
	
	    this.sliding = true
	
	    isCycling && this.pause()
	
	    if (this.$indicators.length) {
	      this.$indicators.find('.active').removeClass('active')
	      var $nextIndicator = $(this.$indicators.children()[this.getItemIndex($next)])
	      $nextIndicator && $nextIndicator.addClass('active')
	    }
	
	    var slidEvent = $.Event('slid.bs.carousel', { relatedTarget: relatedTarget, direction: direction }) // yes, "slid"
	    if ($.support.transition && this.$element.hasClass('slide')) {
	      $next.addClass(type)
	      $next[0].offsetWidth // force reflow
	      $active.addClass(direction)
	      $next.addClass(direction)
	      $active
	        .one('bsTransitionEnd', function () {
	          $next.removeClass([type, direction].join(' ')).addClass('active')
	          $active.removeClass(['active', direction].join(' '))
	          that.sliding = false
	          setTimeout(function () {
	            that.$element.trigger(slidEvent)
	          }, 0)
	        })
	        .emulateTransitionEnd(Carousel.TRANSITION_DURATION)
	    } else {
	      $active.removeClass('active')
	      $next.addClass('active')
	      this.sliding = false
	      this.$element.trigger(slidEvent)
	    }
	
	    isCycling && this.cycle()
	
	    return this
	  }
	
	
	  // CAROUSEL PLUGIN DEFINITION
	  // ==========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.carousel')
	      var options = $.extend({}, Carousel.DEFAULTS, $this.data(), typeof option == 'object' && option)
	      var action  = typeof option == 'string' ? option : options.slide
	
	      if (!data) $this.data('bs.carousel', (data = new Carousel(this, options)))
	      if (typeof option == 'number') data.to(option)
	      else if (action) data[action]()
	      else if (options.interval) data.pause().cycle()
	    })
	  }
	
	  var old = $.fn.carousel
	
	  $.fn.carousel             = Plugin
	  $.fn.carousel.Constructor = Carousel
	
	
	  // CAROUSEL NO CONFLICT
	  // ====================
	
	  $.fn.carousel.noConflict = function () {
	    $.fn.carousel = old
	    return this
	  }
	
	
	  // CAROUSEL DATA-API
	  // =================
	
	  var clickHandler = function (e) {
	    var href
	    var $this   = $(this)
	    var $target = $($this.attr('data-target') || (href = $this.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '')) // strip for ie7
	    if (!$target.hasClass('carousel')) return
	    var options = $.extend({}, $target.data(), $this.data())
	    var slideIndex = $this.attr('data-slide-to')
	    if (slideIndex) options.interval = false
	
	    Plugin.call($target, options)
	
	    if (slideIndex) {
	      $target.data('bs.carousel').to(slideIndex)
	    }
	
	    e.preventDefault()
	  }
	
	  $(document)
	    .on('click.bs.carousel.data-api', '[data-slide]', clickHandler)
	    .on('click.bs.carousel.data-api', '[data-slide-to]', clickHandler)
	
	  $(window).on('load', function () {
	    $('[data-ride="carousel"]').each(function () {
	      var $carousel = $(this)
	      Plugin.call($carousel, $carousel.data())
	    })
	  })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: collapse.js v3.3.6
	 * http://getbootstrap.com/javascript/#collapse
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	/* jshint latedef: false */
	
	+function ($) {
	  'use strict';
	
	  // COLLAPSE PUBLIC CLASS DEFINITION
	  // ================================
	
	  var Collapse = function (element, options) {
	    this.$element      = $(element)
	    this.options       = $.extend({}, Collapse.DEFAULTS, options)
	    this.$trigger      = $('[data-toggle="collapse"][href="#' + element.id + '"],' +
	                           '[data-toggle="collapse"][data-target="#' + element.id + '"]')
	    this.transitioning = null
	
	    if (this.options.parent) {
	      this.$parent = this.getParent()
	    } else {
	      this.addAriaAndCollapsedClass(this.$element, this.$trigger)
	    }
	
	    if (this.options.toggle) this.toggle()
	  }
	
	  Collapse.VERSION  = '3.3.6'
	
	  Collapse.TRANSITION_DURATION = 350
	
	  Collapse.DEFAULTS = {
	    toggle: true
	  }
	
	  Collapse.prototype.dimension = function () {
	    var hasWidth = this.$element.hasClass('width')
	    return hasWidth ? 'width' : 'height'
	  }
	
	  Collapse.prototype.show = function () {
	    if (this.transitioning || this.$element.hasClass('in')) return
	
	    var activesData
	    var actives = this.$parent && this.$parent.children('.panel').children('.in, .collapsing')
	
	    if (actives && actives.length) {
	      activesData = actives.data('bs.collapse')
	      if (activesData && activesData.transitioning) return
	    }
	
	    var startEvent = $.Event('show.bs.collapse')
	    this.$element.trigger(startEvent)
	    if (startEvent.isDefaultPrevented()) return
	
	    if (actives && actives.length) {
	      Plugin.call(actives, 'hide')
	      activesData || actives.data('bs.collapse', null)
	    }
	
	    var dimension = this.dimension()
	
	    this.$element
	      .removeClass('collapse')
	      .addClass('collapsing')[dimension](0)
	      .attr('aria-expanded', true)
	
	    this.$trigger
	      .removeClass('collapsed')
	      .attr('aria-expanded', true)
	
	    this.transitioning = 1
	
	    var complete = function () {
	      this.$element
	        .removeClass('collapsing')
	        .addClass('collapse in')[dimension]('')
	      this.transitioning = 0
	      this.$element
	        .trigger('shown.bs.collapse')
	    }
	
	    if (!$.support.transition) return complete.call(this)
	
	    var scrollSize = $.camelCase(['scroll', dimension].join('-'))
	
	    this.$element
	      .one('bsTransitionEnd', $.proxy(complete, this))
	      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)[dimension](this.$element[0][scrollSize])
	  }
	
	  Collapse.prototype.hide = function () {
	    if (this.transitioning || !this.$element.hasClass('in')) return
	
	    var startEvent = $.Event('hide.bs.collapse')
	    this.$element.trigger(startEvent)
	    if (startEvent.isDefaultPrevented()) return
	
	    var dimension = this.dimension()
	
	    this.$element[dimension](this.$element[dimension]())[0].offsetHeight
	
	    this.$element
	      .addClass('collapsing')
	      .removeClass('collapse in')
	      .attr('aria-expanded', false)
	
	    this.$trigger
	      .addClass('collapsed')
	      .attr('aria-expanded', false)
	
	    this.transitioning = 1
	
	    var complete = function () {
	      this.transitioning = 0
	      this.$element
	        .removeClass('collapsing')
	        .addClass('collapse')
	        .trigger('hidden.bs.collapse')
	    }
	
	    if (!$.support.transition) return complete.call(this)
	
	    this.$element
	      [dimension](0)
	      .one('bsTransitionEnd', $.proxy(complete, this))
	      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)
	  }
	
	  Collapse.prototype.toggle = function () {
	    this[this.$element.hasClass('in') ? 'hide' : 'show']()
	  }
	
	  Collapse.prototype.getParent = function () {
	    return $(this.options.parent)
	      .find('[data-toggle="collapse"][data-parent="' + this.options.parent + '"]')
	      .each($.proxy(function (i, element) {
	        var $element = $(element)
	        this.addAriaAndCollapsedClass(getTargetFromTrigger($element), $element)
	      }, this))
	      .end()
	  }
	
	  Collapse.prototype.addAriaAndCollapsedClass = function ($element, $trigger) {
	    var isOpen = $element.hasClass('in')
	
	    $element.attr('aria-expanded', isOpen)
	    $trigger
	      .toggleClass('collapsed', !isOpen)
	      .attr('aria-expanded', isOpen)
	  }
	
	  function getTargetFromTrigger($trigger) {
	    var href
	    var target = $trigger.attr('data-target')
	      || (href = $trigger.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '') // strip for ie7
	
	    return $(target)
	  }
	
	
	  // COLLAPSE PLUGIN DEFINITION
	  // ==========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.collapse')
	      var options = $.extend({}, Collapse.DEFAULTS, $this.data(), typeof option == 'object' && option)
	
	      if (!data && options.toggle && /show|hide/.test(option)) options.toggle = false
	      if (!data) $this.data('bs.collapse', (data = new Collapse(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.collapse
	
	  $.fn.collapse             = Plugin
	  $.fn.collapse.Constructor = Collapse
	
	
	  // COLLAPSE NO CONFLICT
	  // ====================
	
	  $.fn.collapse.noConflict = function () {
	    $.fn.collapse = old
	    return this
	  }
	
	
	  // COLLAPSE DATA-API
	  // =================
	
	  $(document).on('click.bs.collapse.data-api', '[data-toggle="collapse"]', function (e) {
	    var $this   = $(this)
	
	    if (!$this.attr('data-target')) e.preventDefault()
	
	    var $target = getTargetFromTrigger($this)
	    var data    = $target.data('bs.collapse')
	    var option  = data ? 'toggle' : $this.data()
	
	    Plugin.call($target, option)
	  })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: dropdown.js v3.3.6
	 * http://getbootstrap.com/javascript/#dropdowns
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // DROPDOWN CLASS DEFINITION
	  // =========================
	
	  var backdrop = '.dropdown-backdrop'
	  var toggle   = '[data-toggle="dropdown"]'
	  var Dropdown = function (element) {
	    $(element).on('click.bs.dropdown', this.toggle)
	  }
	
	  Dropdown.VERSION = '3.3.6'
	
	  function getParent($this) {
	    var selector = $this.attr('data-target')
	
	    if (!selector) {
	      selector = $this.attr('href')
	      selector = selector && /#[A-Za-z]/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
	    }
	
	    var $parent = selector && $(selector)
	
	    return $parent && $parent.length ? $parent : $this.parent()
	  }
	
	  function clearMenus(e) {
	    if (e && e.which === 3) return
	    $(backdrop).remove()
	    $(toggle).each(function () {
	      var $this         = $(this)
	      var $parent       = getParent($this)
	      var relatedTarget = { relatedTarget: this }
	
	      if (!$parent.hasClass('open')) return
	
	      if (e && e.type == 'click' && /input|textarea/i.test(e.target.tagName) && $.contains($parent[0], e.target)) return
	
	      $parent.trigger(e = $.Event('hide.bs.dropdown', relatedTarget))
	
	      if (e.isDefaultPrevented()) return
	
	      $this.attr('aria-expanded', 'false')
	      $parent.removeClass('open').trigger($.Event('hidden.bs.dropdown', relatedTarget))
	    })
	  }
	
	  Dropdown.prototype.toggle = function (e) {
	    var $this = $(this)
	
	    if ($this.is('.disabled, :disabled')) return
	
	    var $parent  = getParent($this)
	    var isActive = $parent.hasClass('open')
	
	    clearMenus()
	
	    if (!isActive) {
	      if ('ontouchstart' in document.documentElement && !$parent.closest('.navbar-nav').length) {
	        // if mobile we use a backdrop because click events don't delegate
	        $(document.createElement('div'))
	          .addClass('dropdown-backdrop')
	          .insertAfter($(this))
	          .on('click', clearMenus)
	      }
	
	      var relatedTarget = { relatedTarget: this }
	      $parent.trigger(e = $.Event('show.bs.dropdown', relatedTarget))
	
	      if (e.isDefaultPrevented()) return
	
	      $this
	        .trigger('focus')
	        .attr('aria-expanded', 'true')
	
	      $parent
	        .toggleClass('open')
	        .trigger($.Event('shown.bs.dropdown', relatedTarget))
	    }
	
	    return false
	  }
	
	  Dropdown.prototype.keydown = function (e) {
	    if (!/(38|40|27|32)/.test(e.which) || /input|textarea/i.test(e.target.tagName)) return
	
	    var $this = $(this)
	
	    e.preventDefault()
	    e.stopPropagation()
	
	    if ($this.is('.disabled, :disabled')) return
	
	    var $parent  = getParent($this)
	    var isActive = $parent.hasClass('open')
	
	    if (!isActive && e.which != 27 || isActive && e.which == 27) {
	      if (e.which == 27) $parent.find(toggle).trigger('focus')
	      return $this.trigger('click')
	    }
	
	    var desc = ' li:not(.disabled):visible a'
	    var $items = $parent.find('.dropdown-menu' + desc)
	
	    if (!$items.length) return
	
	    var index = $items.index(e.target)
	
	    if (e.which == 38 && index > 0)                 index--         // up
	    if (e.which == 40 && index < $items.length - 1) index++         // down
	    if (!~index)                                    index = 0
	
	    $items.eq(index).trigger('focus')
	  }
	
	
	  // DROPDOWN PLUGIN DEFINITION
	  // ==========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this)
	      var data  = $this.data('bs.dropdown')
	
	      if (!data) $this.data('bs.dropdown', (data = new Dropdown(this)))
	      if (typeof option == 'string') data[option].call($this)
	    })
	  }
	
	  var old = $.fn.dropdown
	
	  $.fn.dropdown             = Plugin
	  $.fn.dropdown.Constructor = Dropdown
	
	
	  // DROPDOWN NO CONFLICT
	  // ====================
	
	  $.fn.dropdown.noConflict = function () {
	    $.fn.dropdown = old
	    return this
	  }
	
	
	  // APPLY TO STANDARD DROPDOWN ELEMENTS
	  // ===================================
	
	  $(document)
	    .on('click.bs.dropdown.data-api', clearMenus)
	    .on('click.bs.dropdown.data-api', '.dropdown form', function (e) { e.stopPropagation() })
	    .on('click.bs.dropdown.data-api', toggle, Dropdown.prototype.toggle)
	    .on('keydown.bs.dropdown.data-api', toggle, Dropdown.prototype.keydown)
	    .on('keydown.bs.dropdown.data-api', '.dropdown-menu', Dropdown.prototype.keydown)
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: modal.js v3.3.6
	 * http://getbootstrap.com/javascript/#modals
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // MODAL CLASS DEFINITION
	  // ======================
	
	  var Modal = function (element, options) {
	    this.options             = options
	    this.$body               = $(document.body)
	    this.$element            = $(element)
	    this.$dialog             = this.$element.find('.modal-dialog')
	    this.$backdrop           = null
	    this.isShown             = null
	    this.originalBodyPad     = null
	    this.scrollbarWidth      = 0
	    this.ignoreBackdropClick = false
	
	    if (this.options.remote) {
	      this.$element
	        .find('.modal-content')
	        .load(this.options.remote, $.proxy(function () {
	          this.$element.trigger('loaded.bs.modal')
	        }, this))
	    }
	  }
	
	  Modal.VERSION  = '3.3.6'
	
	  Modal.TRANSITION_DURATION = 300
	  Modal.BACKDROP_TRANSITION_DURATION = 150
	
	  Modal.DEFAULTS = {
	    backdrop: true,
	    keyboard: true,
	    show: true
	  }
	
	  Modal.prototype.toggle = function (_relatedTarget) {
	    return this.isShown ? this.hide() : this.show(_relatedTarget)
	  }
	
	  Modal.prototype.show = function (_relatedTarget) {
	    var that = this
	    var e    = $.Event('show.bs.modal', { relatedTarget: _relatedTarget })
	
	    this.$element.trigger(e)
	
	    if (this.isShown || e.isDefaultPrevented()) return
	
	    this.isShown = true
	
	    this.checkScrollbar()
	    this.setScrollbar()
	    this.$body.addClass('modal-open')
	
	    this.escape()
	    this.resize()
	
	    this.$element.on('click.dismiss.bs.modal', '[data-dismiss="modal"]', $.proxy(this.hide, this))
	
	    this.$dialog.on('mousedown.dismiss.bs.modal', function () {
	      that.$element.one('mouseup.dismiss.bs.modal', function (e) {
	        if ($(e.target).is(that.$element)) that.ignoreBackdropClick = true
	      })
	    })
	
	    this.backdrop(function () {
	      var transition = $.support.transition && that.$element.hasClass('fade')
	
	      if (!that.$element.parent().length) {
	        that.$element.appendTo(that.$body) // don't move modals dom position
	      }
	
	      that.$element
	        .show()
	        .scrollTop(0)
	
	      that.adjustDialog()
	
	      if (transition) {
	        that.$element[0].offsetWidth // force reflow
	      }
	
	      that.$element.addClass('in')
	
	      that.enforceFocus()
	
	      var e = $.Event('shown.bs.modal', { relatedTarget: _relatedTarget })
	
	      transition ?
	        that.$dialog // wait for modal to slide in
	          .one('bsTransitionEnd', function () {
	            that.$element.trigger('focus').trigger(e)
	          })
	          .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
	        that.$element.trigger('focus').trigger(e)
	    })
	  }
	
	  Modal.prototype.hide = function (e) {
	    if (e) e.preventDefault()
	
	    e = $.Event('hide.bs.modal')
	
	    this.$element.trigger(e)
	
	    if (!this.isShown || e.isDefaultPrevented()) return
	
	    this.isShown = false
	
	    this.escape()
	    this.resize()
	
	    $(document).off('focusin.bs.modal')
	
	    this.$element
	      .removeClass('in')
	      .off('click.dismiss.bs.modal')
	      .off('mouseup.dismiss.bs.modal')
	
	    this.$dialog.off('mousedown.dismiss.bs.modal')
	
	    $.support.transition && this.$element.hasClass('fade') ?
	      this.$element
	        .one('bsTransitionEnd', $.proxy(this.hideModal, this))
	        .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
	      this.hideModal()
	  }
	
	  Modal.prototype.enforceFocus = function () {
	    $(document)
	      .off('focusin.bs.modal') // guard against infinite focus loop
	      .on('focusin.bs.modal', $.proxy(function (e) {
	        if (document !== e.target &&
	            this.$element[0] !== e.target &&
	            !this.$element.has(e.target).length) {
	          this.$element.trigger('focus')
	        }
	      }, this))
	  }
	
	  Modal.prototype.escape = function () {
	    if (this.isShown && this.options.keyboard) {
	      this.$element.on('keydown.dismiss.bs.modal', $.proxy(function (e) {
	        e.which == 27 && this.hide()
	      }, this))
	    } else if (!this.isShown) {
	      this.$element.off('keydown.dismiss.bs.modal')
	    }
	  }
	
	  Modal.prototype.resize = function () {
	    if (this.isShown) {
	      $(window).on('resize.bs.modal', $.proxy(this.handleUpdate, this))
	    } else {
	      $(window).off('resize.bs.modal')
	    }
	  }
	
	  Modal.prototype.hideModal = function () {
	    var that = this
	    this.$element.hide()
	    this.backdrop(function () {
	      that.$body.removeClass('modal-open')
	      that.resetAdjustments()
	      that.resetScrollbar()
	      that.$element.trigger('hidden.bs.modal')
	    })
	  }
	
	  Modal.prototype.removeBackdrop = function () {
	    this.$backdrop && this.$backdrop.remove()
	    this.$backdrop = null
	  }
	
	  Modal.prototype.backdrop = function (callback) {
	    var that = this
	    var animate = this.$element.hasClass('fade') ? 'fade' : ''
	
	    if (this.isShown && this.options.backdrop) {
	      var doAnimate = $.support.transition && animate
	
	      this.$backdrop = $(document.createElement('div'))
	        .addClass('modal-backdrop ' + animate)
	        .appendTo(this.$body)
	
	      this.$element.on('click.dismiss.bs.modal', $.proxy(function (e) {
	        if (this.ignoreBackdropClick) {
	          this.ignoreBackdropClick = false
	          return
	        }
	        if (e.target !== e.currentTarget) return
	        this.options.backdrop == 'static'
	          ? this.$element[0].focus()
	          : this.hide()
	      }, this))
	
	      if (doAnimate) this.$backdrop[0].offsetWidth // force reflow
	
	      this.$backdrop.addClass('in')
	
	      if (!callback) return
	
	      doAnimate ?
	        this.$backdrop
	          .one('bsTransitionEnd', callback)
	          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
	        callback()
	
	    } else if (!this.isShown && this.$backdrop) {
	      this.$backdrop.removeClass('in')
	
	      var callbackRemove = function () {
	        that.removeBackdrop()
	        callback && callback()
	      }
	      $.support.transition && this.$element.hasClass('fade') ?
	        this.$backdrop
	          .one('bsTransitionEnd', callbackRemove)
	          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
	        callbackRemove()
	
	    } else if (callback) {
	      callback()
	    }
	  }
	
	  // these following methods are used to handle overflowing modals
	
	  Modal.prototype.handleUpdate = function () {
	    this.adjustDialog()
	  }
	
	  Modal.prototype.adjustDialog = function () {
	    var modalIsOverflowing = this.$element[0].scrollHeight > document.documentElement.clientHeight
	
	    this.$element.css({
	      paddingLeft:  !this.bodyIsOverflowing && modalIsOverflowing ? this.scrollbarWidth : '',
	      paddingRight: this.bodyIsOverflowing && !modalIsOverflowing ? this.scrollbarWidth : ''
	    })
	  }
	
	  Modal.prototype.resetAdjustments = function () {
	    this.$element.css({
	      paddingLeft: '',
	      paddingRight: ''
	    })
	  }
	
	  Modal.prototype.checkScrollbar = function () {
	    var fullWindowWidth = window.innerWidth
	    if (!fullWindowWidth) { // workaround for missing window.innerWidth in IE8
	      var documentElementRect = document.documentElement.getBoundingClientRect()
	      fullWindowWidth = documentElementRect.right - Math.abs(documentElementRect.left)
	    }
	    this.bodyIsOverflowing = document.body.clientWidth < fullWindowWidth
	    this.scrollbarWidth = this.measureScrollbar()
	  }
	
	  Modal.prototype.setScrollbar = function () {
	    var bodyPad = parseInt((this.$body.css('padding-right') || 0), 10)
	    this.originalBodyPad = document.body.style.paddingRight || ''
	    if (this.bodyIsOverflowing) this.$body.css('padding-right', bodyPad + this.scrollbarWidth)
	  }
	
	  Modal.prototype.resetScrollbar = function () {
	    this.$body.css('padding-right', this.originalBodyPad)
	  }
	
	  Modal.prototype.measureScrollbar = function () { // thx walsh
	    var scrollDiv = document.createElement('div')
	    scrollDiv.className = 'modal-scrollbar-measure'
	    this.$body.append(scrollDiv)
	    var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth
	    this.$body[0].removeChild(scrollDiv)
	    return scrollbarWidth
	  }
	
	
	  // MODAL PLUGIN DEFINITION
	  // =======================
	
	  function Plugin(option, _relatedTarget) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.modal')
	      var options = $.extend({}, Modal.DEFAULTS, $this.data(), typeof option == 'object' && option)
	
	      if (!data) $this.data('bs.modal', (data = new Modal(this, options)))
	      if (typeof option == 'string') data[option](_relatedTarget)
	      else if (options.show) data.show(_relatedTarget)
	    })
	  }
	
	  var old = $.fn.modal
	
	  $.fn.modal             = Plugin
	  $.fn.modal.Constructor = Modal
	
	
	  // MODAL NO CONFLICT
	  // =================
	
	  $.fn.modal.noConflict = function () {
	    $.fn.modal = old
	    return this
	  }
	
	
	  // MODAL DATA-API
	  // ==============
	
	  $(document).on('click.bs.modal.data-api', '[data-toggle="modal"]', function (e) {
	    var $this   = $(this)
	    var href    = $this.attr('href')
	    var $target = $($this.attr('data-target') || (href && href.replace(/.*(?=#[^\s]+$)/, ''))) // strip for ie7
	    var option  = $target.data('bs.modal') ? 'toggle' : $.extend({ remote: !/#/.test(href) && href }, $target.data(), $this.data())
	
	    if ($this.is('a')) e.preventDefault()
	
	    $target.one('show.bs.modal', function (showEvent) {
	      if (showEvent.isDefaultPrevented()) return // only register focus restorer if modal will actually get shown
	      $target.one('hidden.bs.modal', function () {
	        $this.is(':visible') && $this.trigger('focus')
	      })
	    })
	    Plugin.call($target, option, this)
	  })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: tooltip.js v3.3.6
	 * http://getbootstrap.com/javascript/#tooltip
	 * Inspired by the original jQuery.tipsy by Jason Frame
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // TOOLTIP PUBLIC CLASS DEFINITION
	  // ===============================
	
	  var Tooltip = function (element, options) {
	    this.type       = null
	    this.options    = null
	    this.enabled    = null
	    this.timeout    = null
	    this.hoverState = null
	    this.$element   = null
	    this.inState    = null
	
	    this.init('tooltip', element, options)
	  }
	
	  Tooltip.VERSION  = '3.3.6'
	
	  Tooltip.TRANSITION_DURATION = 150
	
	  Tooltip.DEFAULTS = {
	    animation: true,
	    placement: 'top',
	    selector: false,
	    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
	    trigger: 'hover focus',
	    title: '',
	    delay: 0,
	    html: false,
	    container: false,
	    viewport: {
	      selector: 'body',
	      padding: 0
	    }
	  }
	
	  Tooltip.prototype.init = function (type, element, options) {
	    this.enabled   = true
	    this.type      = type
	    this.$element  = $(element)
	    this.options   = this.getOptions(options)
	    this.$viewport = this.options.viewport && $($.isFunction(this.options.viewport) ? this.options.viewport.call(this, this.$element) : (this.options.viewport.selector || this.options.viewport))
	    this.inState   = { click: false, hover: false, focus: false }
	
	    if (this.$element[0] instanceof document.constructor && !this.options.selector) {
	      throw new Error('`selector` option must be specified when initializing ' + this.type + ' on the window.document object!')
	    }
	
	    var triggers = this.options.trigger.split(' ')
	
	    for (var i = triggers.length; i--;) {
	      var trigger = triggers[i]
	
	      if (trigger == 'click') {
	        this.$element.on('click.' + this.type, this.options.selector, $.proxy(this.toggle, this))
	      } else if (trigger != 'manual') {
	        var eventIn  = trigger == 'hover' ? 'mouseenter' : 'focusin'
	        var eventOut = trigger == 'hover' ? 'mouseleave' : 'focusout'
	
	        this.$element.on(eventIn  + '.' + this.type, this.options.selector, $.proxy(this.enter, this))
	        this.$element.on(eventOut + '.' + this.type, this.options.selector, $.proxy(this.leave, this))
	      }
	    }
	
	    this.options.selector ?
	      (this._options = $.extend({}, this.options, { trigger: 'manual', selector: '' })) :
	      this.fixTitle()
	  }
	
	  Tooltip.prototype.getDefaults = function () {
	    return Tooltip.DEFAULTS
	  }
	
	  Tooltip.prototype.getOptions = function (options) {
	    options = $.extend({}, this.getDefaults(), this.$element.data(), options)
	
	    if (options.delay && typeof options.delay == 'number') {
	      options.delay = {
	        show: options.delay,
	        hide: options.delay
	      }
	    }
	
	    return options
	  }
	
	  Tooltip.prototype.getDelegateOptions = function () {
	    var options  = {}
	    var defaults = this.getDefaults()
	
	    this._options && $.each(this._options, function (key, value) {
	      if (defaults[key] != value) options[key] = value
	    })
	
	    return options
	  }
	
	  Tooltip.prototype.enter = function (obj) {
	    var self = obj instanceof this.constructor ?
	      obj : $(obj.currentTarget).data('bs.' + this.type)
	
	    if (!self) {
	      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
	      $(obj.currentTarget).data('bs.' + this.type, self)
	    }
	
	    if (obj instanceof $.Event) {
	      self.inState[obj.type == 'focusin' ? 'focus' : 'hover'] = true
	    }
	
	    if (self.tip().hasClass('in') || self.hoverState == 'in') {
	      self.hoverState = 'in'
	      return
	    }
	
	    clearTimeout(self.timeout)
	
	    self.hoverState = 'in'
	
	    if (!self.options.delay || !self.options.delay.show) return self.show()
	
	    self.timeout = setTimeout(function () {
	      if (self.hoverState == 'in') self.show()
	    }, self.options.delay.show)
	  }
	
	  Tooltip.prototype.isInStateTrue = function () {
	    for (var key in this.inState) {
	      if (this.inState[key]) return true
	    }
	
	    return false
	  }
	
	  Tooltip.prototype.leave = function (obj) {
	    var self = obj instanceof this.constructor ?
	      obj : $(obj.currentTarget).data('bs.' + this.type)
	
	    if (!self) {
	      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
	      $(obj.currentTarget).data('bs.' + this.type, self)
	    }
	
	    if (obj instanceof $.Event) {
	      self.inState[obj.type == 'focusout' ? 'focus' : 'hover'] = false
	    }
	
	    if (self.isInStateTrue()) return
	
	    clearTimeout(self.timeout)
	
	    self.hoverState = 'out'
	
	    if (!self.options.delay || !self.options.delay.hide) return self.hide()
	
	    self.timeout = setTimeout(function () {
	      if (self.hoverState == 'out') self.hide()
	    }, self.options.delay.hide)
	  }
	
	  Tooltip.prototype.show = function () {
	    var e = $.Event('show.bs.' + this.type)
	
	    if (this.hasContent() && this.enabled) {
	      this.$element.trigger(e)
	
	      var inDom = $.contains(this.$element[0].ownerDocument.documentElement, this.$element[0])
	      if (e.isDefaultPrevented() || !inDom) return
	      var that = this
	
	      var $tip = this.tip()
	
	      var tipId = this.getUID(this.type)
	
	      this.setContent()
	      $tip.attr('id', tipId)
	      this.$element.attr('aria-describedby', tipId)
	
	      if (this.options.animation) $tip.addClass('fade')
	
	      var placement = typeof this.options.placement == 'function' ?
	        this.options.placement.call(this, $tip[0], this.$element[0]) :
	        this.options.placement
	
	      var autoToken = /\s?auto?\s?/i
	      var autoPlace = autoToken.test(placement)
	      if (autoPlace) placement = placement.replace(autoToken, '') || 'top'
	
	      $tip
	        .detach()
	        .css({ top: 0, left: 0, display: 'block' })
	        .addClass(placement)
	        .data('bs.' + this.type, this)
	
	      this.options.container ? $tip.appendTo(this.options.container) : $tip.insertAfter(this.$element)
	      this.$element.trigger('inserted.bs.' + this.type)
	
	      var pos          = this.getPosition()
	      var actualWidth  = $tip[0].offsetWidth
	      var actualHeight = $tip[0].offsetHeight
	
	      if (autoPlace) {
	        var orgPlacement = placement
	        var viewportDim = this.getPosition(this.$viewport)
	
	        placement = placement == 'bottom' && pos.bottom + actualHeight > viewportDim.bottom ? 'top'    :
	                    placement == 'top'    && pos.top    - actualHeight < viewportDim.top    ? 'bottom' :
	                    placement == 'right'  && pos.right  + actualWidth  > viewportDim.width  ? 'left'   :
	                    placement == 'left'   && pos.left   - actualWidth  < viewportDim.left   ? 'right'  :
	                    placement
	
	        $tip
	          .removeClass(orgPlacement)
	          .addClass(placement)
	      }
	
	      var calculatedOffset = this.getCalculatedOffset(placement, pos, actualWidth, actualHeight)
	
	      this.applyPlacement(calculatedOffset, placement)
	
	      var complete = function () {
	        var prevHoverState = that.hoverState
	        that.$element.trigger('shown.bs.' + that.type)
	        that.hoverState = null
	
	        if (prevHoverState == 'out') that.leave(that)
	      }
	
	      $.support.transition && this.$tip.hasClass('fade') ?
	        $tip
	          .one('bsTransitionEnd', complete)
	          .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
	        complete()
	    }
	  }
	
	  Tooltip.prototype.applyPlacement = function (offset, placement) {
	    var $tip   = this.tip()
	    var width  = $tip[0].offsetWidth
	    var height = $tip[0].offsetHeight
	
	    // manually read margins because getBoundingClientRect includes difference
	    var marginTop = parseInt($tip.css('margin-top'), 10)
	    var marginLeft = parseInt($tip.css('margin-left'), 10)
	
	    // we must check for NaN for ie 8/9
	    if (isNaN(marginTop))  marginTop  = 0
	    if (isNaN(marginLeft)) marginLeft = 0
	
	    offset.top  += marginTop
	    offset.left += marginLeft
	
	    // $.fn.offset doesn't round pixel values
	    // so we use setOffset directly with our own function B-0
	    $.offset.setOffset($tip[0], $.extend({
	      using: function (props) {
	        $tip.css({
	          top: Math.round(props.top),
	          left: Math.round(props.left)
	        })
	      }
	    }, offset), 0)
	
	    $tip.addClass('in')
	
	    // check to see if placing tip in new offset caused the tip to resize itself
	    var actualWidth  = $tip[0].offsetWidth
	    var actualHeight = $tip[0].offsetHeight
	
	    if (placement == 'top' && actualHeight != height) {
	      offset.top = offset.top + height - actualHeight
	    }
	
	    var delta = this.getViewportAdjustedDelta(placement, offset, actualWidth, actualHeight)
	
	    if (delta.left) offset.left += delta.left
	    else offset.top += delta.top
	
	    var isVertical          = /top|bottom/.test(placement)
	    var arrowDelta          = isVertical ? delta.left * 2 - width + actualWidth : delta.top * 2 - height + actualHeight
	    var arrowOffsetPosition = isVertical ? 'offsetWidth' : 'offsetHeight'
	
	    $tip.offset(offset)
	    this.replaceArrow(arrowDelta, $tip[0][arrowOffsetPosition], isVertical)
	  }
	
	  Tooltip.prototype.replaceArrow = function (delta, dimension, isVertical) {
	    this.arrow()
	      .css(isVertical ? 'left' : 'top', 50 * (1 - delta / dimension) + '%')
	      .css(isVertical ? 'top' : 'left', '')
	  }
	
	  Tooltip.prototype.setContent = function () {
	    var $tip  = this.tip()
	    var title = this.getTitle()
	
	    $tip.find('.tooltip-inner')[this.options.html ? 'html' : 'text'](title)
	    $tip.removeClass('fade in top bottom left right')
	  }
	
	  Tooltip.prototype.hide = function (callback) {
	    var that = this
	    var $tip = $(this.$tip)
	    var e    = $.Event('hide.bs.' + this.type)
	
	    function complete() {
	      if (that.hoverState != 'in') $tip.detach()
	      that.$element
	        .removeAttr('aria-describedby')
	        .trigger('hidden.bs.' + that.type)
	      callback && callback()
	    }
	
	    this.$element.trigger(e)
	
	    if (e.isDefaultPrevented()) return
	
	    $tip.removeClass('in')
	
	    $.support.transition && $tip.hasClass('fade') ?
	      $tip
	        .one('bsTransitionEnd', complete)
	        .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
	      complete()
	
	    this.hoverState = null
	
	    return this
	  }
	
	  Tooltip.prototype.fixTitle = function () {
	    var $e = this.$element
	    if ($e.attr('title') || typeof $e.attr('data-original-title') != 'string') {
	      $e.attr('data-original-title', $e.attr('title') || '').attr('title', '')
	    }
	  }
	
	  Tooltip.prototype.hasContent = function () {
	    return this.getTitle()
	  }
	
	  Tooltip.prototype.getPosition = function ($element) {
	    $element   = $element || this.$element
	
	    var el     = $element[0]
	    var isBody = el.tagName == 'BODY'
	
	    var elRect    = el.getBoundingClientRect()
	    if (elRect.width == null) {
	      // width and height are missing in IE8, so compute them manually; see https://github.com/twbs/bootstrap/issues/14093
	      elRect = $.extend({}, elRect, { width: elRect.right - elRect.left, height: elRect.bottom - elRect.top })
	    }
	    var elOffset  = isBody ? { top: 0, left: 0 } : $element.offset()
	    var scroll    = { scroll: isBody ? document.documentElement.scrollTop || document.body.scrollTop : $element.scrollTop() }
	    var outerDims = isBody ? { width: $(window).width(), height: $(window).height() } : null
	
	    return $.extend({}, elRect, scroll, outerDims, elOffset)
	  }
	
	  Tooltip.prototype.getCalculatedOffset = function (placement, pos, actualWidth, actualHeight) {
	    return placement == 'bottom' ? { top: pos.top + pos.height,   left: pos.left + pos.width / 2 - actualWidth / 2 } :
	           placement == 'top'    ? { top: pos.top - actualHeight, left: pos.left + pos.width / 2 - actualWidth / 2 } :
	           placement == 'left'   ? { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left - actualWidth } :
	        /* placement == 'right' */ { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left + pos.width }
	
	  }
	
	  Tooltip.prototype.getViewportAdjustedDelta = function (placement, pos, actualWidth, actualHeight) {
	    var delta = { top: 0, left: 0 }
	    if (!this.$viewport) return delta
	
	    var viewportPadding = this.options.viewport && this.options.viewport.padding || 0
	    var viewportDimensions = this.getPosition(this.$viewport)
	
	    if (/right|left/.test(placement)) {
	      var topEdgeOffset    = pos.top - viewportPadding - viewportDimensions.scroll
	      var bottomEdgeOffset = pos.top + viewportPadding - viewportDimensions.scroll + actualHeight
	      if (topEdgeOffset < viewportDimensions.top) { // top overflow
	        delta.top = viewportDimensions.top - topEdgeOffset
	      } else if (bottomEdgeOffset > viewportDimensions.top + viewportDimensions.height) { // bottom overflow
	        delta.top = viewportDimensions.top + viewportDimensions.height - bottomEdgeOffset
	      }
	    } else {
	      var leftEdgeOffset  = pos.left - viewportPadding
	      var rightEdgeOffset = pos.left + viewportPadding + actualWidth
	      if (leftEdgeOffset < viewportDimensions.left) { // left overflow
	        delta.left = viewportDimensions.left - leftEdgeOffset
	      } else if (rightEdgeOffset > viewportDimensions.right) { // right overflow
	        delta.left = viewportDimensions.left + viewportDimensions.width - rightEdgeOffset
	      }
	    }
	
	    return delta
	  }
	
	  Tooltip.prototype.getTitle = function () {
	    var title
	    var $e = this.$element
	    var o  = this.options
	
	    title = $e.attr('data-original-title')
	      || (typeof o.title == 'function' ? o.title.call($e[0]) :  o.title)
	
	    return title
	  }
	
	  Tooltip.prototype.getUID = function (prefix) {
	    do prefix += ~~(Math.random() * 1000000)
	    while (document.getElementById(prefix))
	    return prefix
	  }
	
	  Tooltip.prototype.tip = function () {
	    if (!this.$tip) {
	      this.$tip = $(this.options.template)
	      if (this.$tip.length != 1) {
	        throw new Error(this.type + ' `template` option must consist of exactly 1 top-level element!')
	      }
	    }
	    return this.$tip
	  }
	
	  Tooltip.prototype.arrow = function () {
	    return (this.$arrow = this.$arrow || this.tip().find('.tooltip-arrow'))
	  }
	
	  Tooltip.prototype.enable = function () {
	    this.enabled = true
	  }
	
	  Tooltip.prototype.disable = function () {
	    this.enabled = false
	  }
	
	  Tooltip.prototype.toggleEnabled = function () {
	    this.enabled = !this.enabled
	  }
	
	  Tooltip.prototype.toggle = function (e) {
	    var self = this
	    if (e) {
	      self = $(e.currentTarget).data('bs.' + this.type)
	      if (!self) {
	        self = new this.constructor(e.currentTarget, this.getDelegateOptions())
	        $(e.currentTarget).data('bs.' + this.type, self)
	      }
	    }
	
	    if (e) {
	      self.inState.click = !self.inState.click
	      if (self.isInStateTrue()) self.enter(self)
	      else self.leave(self)
	    } else {
	      self.tip().hasClass('in') ? self.leave(self) : self.enter(self)
	    }
	  }
	
	  Tooltip.prototype.destroy = function () {
	    var that = this
	    clearTimeout(this.timeout)
	    this.hide(function () {
	      that.$element.off('.' + that.type).removeData('bs.' + that.type)
	      if (that.$tip) {
	        that.$tip.detach()
	      }
	      that.$tip = null
	      that.$arrow = null
	      that.$viewport = null
	    })
	  }
	
	
	  // TOOLTIP PLUGIN DEFINITION
	  // =========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.tooltip')
	      var options = typeof option == 'object' && option
	
	      if (!data && /destroy|hide/.test(option)) return
	      if (!data) $this.data('bs.tooltip', (data = new Tooltip(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.tooltip
	
	  $.fn.tooltip             = Plugin
	  $.fn.tooltip.Constructor = Tooltip
	
	
	  // TOOLTIP NO CONFLICT
	  // ===================
	
	  $.fn.tooltip.noConflict = function () {
	    $.fn.tooltip = old
	    return this
	  }
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: popover.js v3.3.6
	 * http://getbootstrap.com/javascript/#popovers
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // POPOVER PUBLIC CLASS DEFINITION
	  // ===============================
	
	  var Popover = function (element, options) {
	    this.init('popover', element, options)
	  }
	
	  if (!$.fn.tooltip) throw new Error('Popover requires tooltip.js')
	
	  Popover.VERSION  = '3.3.6'
	
	  Popover.DEFAULTS = $.extend({}, $.fn.tooltip.Constructor.DEFAULTS, {
	    placement: 'right',
	    trigger: 'click',
	    content: '',
	    template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
	  })
	
	
	  // NOTE: POPOVER EXTENDS tooltip.js
	  // ================================
	
	  Popover.prototype = $.extend({}, $.fn.tooltip.Constructor.prototype)
	
	  Popover.prototype.constructor = Popover
	
	  Popover.prototype.getDefaults = function () {
	    return Popover.DEFAULTS
	  }
	
	  Popover.prototype.setContent = function () {
	    var $tip    = this.tip()
	    var title   = this.getTitle()
	    var content = this.getContent()
	
	    $tip.find('.popover-title')[this.options.html ? 'html' : 'text'](title)
	    $tip.find('.popover-content').children().detach().end()[ // we use append for html objects to maintain js events
	      this.options.html ? (typeof content == 'string' ? 'html' : 'append') : 'text'
	    ](content)
	
	    $tip.removeClass('fade top bottom left right in')
	
	    // IE8 doesn't accept hiding via the `:empty` pseudo selector, we have to do
	    // this manually by checking the contents.
	    if (!$tip.find('.popover-title').html()) $tip.find('.popover-title').hide()
	  }
	
	  Popover.prototype.hasContent = function () {
	    return this.getTitle() || this.getContent()
	  }
	
	  Popover.prototype.getContent = function () {
	    var $e = this.$element
	    var o  = this.options
	
	    return $e.attr('data-content')
	      || (typeof o.content == 'function' ?
	            o.content.call($e[0]) :
	            o.content)
	  }
	
	  Popover.prototype.arrow = function () {
	    return (this.$arrow = this.$arrow || this.tip().find('.arrow'))
	  }
	
	
	  // POPOVER PLUGIN DEFINITION
	  // =========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.popover')
	      var options = typeof option == 'object' && option
	
	      if (!data && /destroy|hide/.test(option)) return
	      if (!data) $this.data('bs.popover', (data = new Popover(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.popover
	
	  $.fn.popover             = Plugin
	  $.fn.popover.Constructor = Popover
	
	
	  // POPOVER NO CONFLICT
	  // ===================
	
	  $.fn.popover.noConflict = function () {
	    $.fn.popover = old
	    return this
	  }
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: scrollspy.js v3.3.6
	 * http://getbootstrap.com/javascript/#scrollspy
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // SCROLLSPY CLASS DEFINITION
	  // ==========================
	
	  function ScrollSpy(element, options) {
	    this.$body          = $(document.body)
	    this.$scrollElement = $(element).is(document.body) ? $(window) : $(element)
	    this.options        = $.extend({}, ScrollSpy.DEFAULTS, options)
	    this.selector       = (this.options.target || '') + ' .nav li > a'
	    this.offsets        = []
	    this.targets        = []
	    this.activeTarget   = null
	    this.scrollHeight   = 0
	
	    this.$scrollElement.on('scroll.bs.scrollspy', $.proxy(this.process, this))
	    this.refresh()
	    this.process()
	  }
	
	  ScrollSpy.VERSION  = '3.3.6'
	
	  ScrollSpy.DEFAULTS = {
	    offset: 10
	  }
	
	  ScrollSpy.prototype.getScrollHeight = function () {
	    return this.$scrollElement[0].scrollHeight || Math.max(this.$body[0].scrollHeight, document.documentElement.scrollHeight)
	  }
	
	  ScrollSpy.prototype.refresh = function () {
	    var that          = this
	    var offsetMethod  = 'offset'
	    var offsetBase    = 0
	
	    this.offsets      = []
	    this.targets      = []
	    this.scrollHeight = this.getScrollHeight()
	
	    if (!$.isWindow(this.$scrollElement[0])) {
	      offsetMethod = 'position'
	      offsetBase   = this.$scrollElement.scrollTop()
	    }
	
	    this.$body
	      .find(this.selector)
	      .map(function () {
	        var $el   = $(this)
	        var href  = $el.data('target') || $el.attr('href')
	        var $href = /^#./.test(href) && $(href)
	
	        return ($href
	          && $href.length
	          && $href.is(':visible')
	          && [[$href[offsetMethod]().top + offsetBase, href]]) || null
	      })
	      .sort(function (a, b) { return a[0] - b[0] })
	      .each(function () {
	        that.offsets.push(this[0])
	        that.targets.push(this[1])
	      })
	  }
	
	  ScrollSpy.prototype.process = function () {
	    var scrollTop    = this.$scrollElement.scrollTop() + this.options.offset
	    var scrollHeight = this.getScrollHeight()
	    var maxScroll    = this.options.offset + scrollHeight - this.$scrollElement.height()
	    var offsets      = this.offsets
	    var targets      = this.targets
	    var activeTarget = this.activeTarget
	    var i
	
	    if (this.scrollHeight != scrollHeight) {
	      this.refresh()
	    }
	
	    if (scrollTop >= maxScroll) {
	      return activeTarget != (i = targets[targets.length - 1]) && this.activate(i)
	    }
	
	    if (activeTarget && scrollTop < offsets[0]) {
	      this.activeTarget = null
	      return this.clear()
	    }
	
	    for (i = offsets.length; i--;) {
	      activeTarget != targets[i]
	        && scrollTop >= offsets[i]
	        && (offsets[i + 1] === undefined || scrollTop < offsets[i + 1])
	        && this.activate(targets[i])
	    }
	  }
	
	  ScrollSpy.prototype.activate = function (target) {
	    this.activeTarget = target
	
	    this.clear()
	
	    var selector = this.selector +
	      '[data-target="' + target + '"],' +
	      this.selector + '[href="' + target + '"]'
	
	    var active = $(selector)
	      .parents('li')
	      .addClass('active')
	
	    if (active.parent('.dropdown-menu').length) {
	      active = active
	        .closest('li.dropdown')
	        .addClass('active')
	    }
	
	    active.trigger('activate.bs.scrollspy')
	  }
	
	  ScrollSpy.prototype.clear = function () {
	    $(this.selector)
	      .parentsUntil(this.options.target, '.active')
	      .removeClass('active')
	  }
	
	
	  // SCROLLSPY PLUGIN DEFINITION
	  // ===========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.scrollspy')
	      var options = typeof option == 'object' && option
	
	      if (!data) $this.data('bs.scrollspy', (data = new ScrollSpy(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.scrollspy
	
	  $.fn.scrollspy             = Plugin
	  $.fn.scrollspy.Constructor = ScrollSpy
	
	
	  // SCROLLSPY NO CONFLICT
	  // =====================
	
	  $.fn.scrollspy.noConflict = function () {
	    $.fn.scrollspy = old
	    return this
	  }
	
	
	  // SCROLLSPY DATA-API
	  // ==================
	
	  $(window).on('load.bs.scrollspy.data-api', function () {
	    $('[data-spy="scroll"]').each(function () {
	      var $spy = $(this)
	      Plugin.call($spy, $spy.data())
	    })
	  })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: tab.js v3.3.6
	 * http://getbootstrap.com/javascript/#tabs
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // TAB CLASS DEFINITION
	  // ====================
	
	  var Tab = function (element) {
	    // jscs:disable requireDollarBeforejQueryAssignment
	    this.element = $(element)
	    // jscs:enable requireDollarBeforejQueryAssignment
	  }
	
	  Tab.VERSION = '3.3.6'
	
	  Tab.TRANSITION_DURATION = 150
	
	  Tab.prototype.show = function () {
	    var $this    = this.element
	    var $ul      = $this.closest('ul:not(.dropdown-menu)')
	    var selector = $this.data('target')
	
	    if (!selector) {
	      selector = $this.attr('href')
	      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
	    }
	
	    if ($this.parent('li').hasClass('active')) return
	
	    var $previous = $ul.find('.active:last a')
	    var hideEvent = $.Event('hide.bs.tab', {
	      relatedTarget: $this[0]
	    })
	    var showEvent = $.Event('show.bs.tab', {
	      relatedTarget: $previous[0]
	    })
	
	    $previous.trigger(hideEvent)
	    $this.trigger(showEvent)
	
	    if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented()) return
	
	    var $target = $(selector)
	
	    this.activate($this.closest('li'), $ul)
	    this.activate($target, $target.parent(), function () {
	      $previous.trigger({
	        type: 'hidden.bs.tab',
	        relatedTarget: $this[0]
	      })
	      $this.trigger({
	        type: 'shown.bs.tab',
	        relatedTarget: $previous[0]
	      })
	    })
	  }
	
	  Tab.prototype.activate = function (element, container, callback) {
	    var $active    = container.find('> .active')
	    var transition = callback
	      && $.support.transition
	      && ($active.length && $active.hasClass('fade') || !!container.find('> .fade').length)
	
	    function next() {
	      $active
	        .removeClass('active')
	        .find('> .dropdown-menu > .active')
	          .removeClass('active')
	        .end()
	        .find('[data-toggle="tab"]')
	          .attr('aria-expanded', false)
	
	      element
	        .addClass('active')
	        .find('[data-toggle="tab"]')
	          .attr('aria-expanded', true)
	
	      if (transition) {
	        element[0].offsetWidth // reflow for transition
	        element.addClass('in')
	      } else {
	        element.removeClass('fade')
	      }
	
	      if (element.parent('.dropdown-menu').length) {
	        element
	          .closest('li.dropdown')
	            .addClass('active')
	          .end()
	          .find('[data-toggle="tab"]')
	            .attr('aria-expanded', true)
	      }
	
	      callback && callback()
	    }
	
	    $active.length && transition ?
	      $active
	        .one('bsTransitionEnd', next)
	        .emulateTransitionEnd(Tab.TRANSITION_DURATION) :
	      next()
	
	    $active.removeClass('in')
	  }
	
	
	  // TAB PLUGIN DEFINITION
	  // =====================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this)
	      var data  = $this.data('bs.tab')
	
	      if (!data) $this.data('bs.tab', (data = new Tab(this)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.tab
	
	  $.fn.tab             = Plugin
	  $.fn.tab.Constructor = Tab
	
	
	  // TAB NO CONFLICT
	  // ===============
	
	  $.fn.tab.noConflict = function () {
	    $.fn.tab = old
	    return this
	  }
	
	
	  // TAB DATA-API
	  // ============
	
	  var clickHandler = function (e) {
	    e.preventDefault()
	    Plugin.call($(this), 'show')
	  }
	
	  $(document)
	    .on('click.bs.tab.data-api', '[data-toggle="tab"]', clickHandler)
	    .on('click.bs.tab.data-api', '[data-toggle="pill"]', clickHandler)
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: affix.js v3.3.6
	 * http://getbootstrap.com/javascript/#affix
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // AFFIX CLASS DEFINITION
	  // ======================
	
	  var Affix = function (element, options) {
	    this.options = $.extend({}, Affix.DEFAULTS, options)
	
	    this.$target = $(this.options.target)
	      .on('scroll.bs.affix.data-api', $.proxy(this.checkPosition, this))
	      .on('click.bs.affix.data-api',  $.proxy(this.checkPositionWithEventLoop, this))
	
	    this.$element     = $(element)
	    this.affixed      = null
	    this.unpin        = null
	    this.pinnedOffset = null
	
	    this.checkPosition()
	  }
	
	  Affix.VERSION  = '3.3.6'
	
	  Affix.RESET    = 'affix affix-top affix-bottom'
	
	  Affix.DEFAULTS = {
	    offset: 0,
	    target: window
	  }
	
	  Affix.prototype.getState = function (scrollHeight, height, offsetTop, offsetBottom) {
	    var scrollTop    = this.$target.scrollTop()
	    var position     = this.$element.offset()
	    var targetHeight = this.$target.height()
	
	    if (offsetTop != null && this.affixed == 'top') return scrollTop < offsetTop ? 'top' : false
	
	    if (this.affixed == 'bottom') {
	      if (offsetTop != null) return (scrollTop + this.unpin <= position.top) ? false : 'bottom'
	      return (scrollTop + targetHeight <= scrollHeight - offsetBottom) ? false : 'bottom'
	    }
	
	    var initializing   = this.affixed == null
	    var colliderTop    = initializing ? scrollTop : position.top
	    var colliderHeight = initializing ? targetHeight : height
	
	    if (offsetTop != null && scrollTop <= offsetTop) return 'top'
	    if (offsetBottom != null && (colliderTop + colliderHeight >= scrollHeight - offsetBottom)) return 'bottom'
	
	    return false
	  }
	
	  Affix.prototype.getPinnedOffset = function () {
	    if (this.pinnedOffset) return this.pinnedOffset
	    this.$element.removeClass(Affix.RESET).addClass('affix')
	    var scrollTop = this.$target.scrollTop()
	    var position  = this.$element.offset()
	    return (this.pinnedOffset = position.top - scrollTop)
	  }
	
	  Affix.prototype.checkPositionWithEventLoop = function () {
	    setTimeout($.proxy(this.checkPosition, this), 1)
	  }
	
	  Affix.prototype.checkPosition = function () {
	    if (!this.$element.is(':visible')) return
	
	    var height       = this.$element.height()
	    var offset       = this.options.offset
	    var offsetTop    = offset.top
	    var offsetBottom = offset.bottom
	    var scrollHeight = Math.max($(document).height(), $(document.body).height())
	
	    if (typeof offset != 'object')         offsetBottom = offsetTop = offset
	    if (typeof offsetTop == 'function')    offsetTop    = offset.top(this.$element)
	    if (typeof offsetBottom == 'function') offsetBottom = offset.bottom(this.$element)
	
	    var affix = this.getState(scrollHeight, height, offsetTop, offsetBottom)
	
	    if (this.affixed != affix) {
	      if (this.unpin != null) this.$element.css('top', '')
	
	      var affixType = 'affix' + (affix ? '-' + affix : '')
	      var e         = $.Event(affixType + '.bs.affix')
	
	      this.$element.trigger(e)
	
	      if (e.isDefaultPrevented()) return
	
	      this.affixed = affix
	      this.unpin = affix == 'bottom' ? this.getPinnedOffset() : null
	
	      this.$element
	        .removeClass(Affix.RESET)
	        .addClass(affixType)
	        .trigger(affixType.replace('affix', 'affixed') + '.bs.affix')
	    }
	
	    if (affix == 'bottom') {
	      this.$element.offset({
	        top: scrollHeight - height - offsetBottom
	      })
	    }
	  }
	
	
	  // AFFIX PLUGIN DEFINITION
	  // =======================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.affix')
	      var options = typeof option == 'object' && option
	
	      if (!data) $this.data('bs.affix', (data = new Affix(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.affix
	
	  $.fn.affix             = Plugin
	  $.fn.affix.Constructor = Affix
	
	
	  // AFFIX NO CONFLICT
	  // =================
	
	  $.fn.affix.noConflict = function () {
	    $.fn.affix = old
	    return this
	  }
	
	
	  // AFFIX DATA-API
	  // ==============
	
	  $(window).on('load', function () {
	    $('[data-spy="affix"]').each(function () {
	      var $spy = $(this)
	      var data = $spy.data()
	
	      data.offset = data.offset || {}
	
	      if (data.offsetBottom != null) data.offset.bottom = data.offsetBottom
	      if (data.offsetTop    != null) data.offset.top    = data.offsetTop
	
	      Plugin.call($spy, data)
	    })
	  })
	
	}(jQuery);


/***/ }),
/* 217 */
/***/ (function(module, exports) {

	// ColorBox v1.3.18 - a full featured, light-weight, customizable lightbox based on jQuery 1.3+
	// Copyright (c) 2011 Jack Moore - jack@colorpowered.com
	// Licensed under the MIT license: http://www.opensource.org/licenses/mit-license.php
	
	(function ($, document, window) {
	    var
	    // Default settings object.	
	    // See http://jacklmoore.com/colorbox for details.
	    defaults = {
	        transition: "elastic",
	        speed: 300,
	        width: false,
	        initialWidth: "600",
	        innerWidth: false,
	        maxWidth: false,
	        height: false,
	        initialHeight: "450",
	        innerHeight: false,
	        maxHeight: false,
	        scalePhotos: true,
	        scrolling: true,
	        inline: false,
	        html: false,
	        iframe: false,
	        fastIframe: true,
	        photo: false,
	        href: false,
	        title: false,
	        rel: false,
	        opacity: 0.9,
	        preloading: true,
	        current: "image {current} of {total}",
	        previous: "previous",
	        next: "next",
	        close: "close",
	        open: false,
	        returnFocus: true,
	        loop: true,
	        slideshow: false,
	        slideshowAuto: true,
	        slideshowSpeed: 2500,
	        slideshowStart: "start slideshow",
	        slideshowStop: "stop slideshow",
	        onOpen: false,
	        onLoad: false,
	        onComplete: false,
	        onCleanup: false,
	        onClosed: false,
	        overlayClose: true,		
	        escKey: true,
	        arrowKey: true,
	        top: false,
	        bottom: false,
	        left: false,
	        right: false,
	        fixed: false,
	        data: undefined
	    },
		
	    // Abstracting the HTML and event identifiers for easy rebranding
	    colorbox = 'colorbox',
	    prefix = 'cbox',
	    boxElement = prefix + 'Element',
	    
	    // Events	
	    event_open = prefix + '_open',
	    event_load = prefix + '_load',
	    event_complete = prefix + '_complete',
	    event_cleanup = prefix + '_cleanup',
	    event_closed = prefix + '_closed',
	    event_purge = prefix + '_purge',
	    
	    // Special Handling for IE
	    isIE = false, // this was previously detecting ie<=8, we just don't support it
	    isIE6 = false,
	    event_ie6 = prefix + '_IE6',
	    
	    // Cached jQuery Object Variables
	    $overlay,
	    $box,
	    $wrap,
	    $content,
	    $topBorder,
	    $leftBorder,
	    $rightBorder,
	    $bottomBorder,
	    $related,
	    $window,
	    $loaded,
	    $loadingBay,
	    $loadingOverlay,
	    $title,
	    $current,
	    $slideshow,
	    $next,
	    $prev,
	    $close,
	    $groupControls,
	    
	    // Variables for cached values or use across multiple functions
	    settings,
	    interfaceHeight,
	    interfaceWidth,
	    loadedHeight,
	    loadedWidth,
	    element,
	    index,
	    photo,
	    open,
	    active,
	    closing,
	    loadingTimer,
	    publicMethod,
	    div = "div";
	
		// ****************
		// HELPER FUNCTIONS
		// ****************
	    
		// Convience function for creating new jQuery objects
	    function $tag(tag, id, css) {
	        var element = document.createElement(tag);
	        
	        if (id) {
	            element.id = prefix + id;
	        }
	        
	        if (css) {
	            element.style.cssText = css;
	        }
	        
	        return $(element);
	    }
	
		// Determine the next and previous members in a group.
		function getIndex(increment) {
			var 
			max = $related.length, 
			newIndex = (index + increment) % max;
			
			return (newIndex < 0) ? max + newIndex : newIndex;
		}
	
		// Convert '%' and 'px' values to integers
		function setSize(size, dimension) {
			return Math.round((/%/.test(size) ? ((dimension === 'x' ? $window.width() : $window.height()) / 100) : 1) * parseInt(size, 10));
		}
		
		// Checks an href to see if it is a photo.
		// There is a force photo option (photo: true) for hrefs that cannot be matched by this regex.
		function isImage(url) {
			return settings.photo || /\.(gif|png|jpe?g|bmp|ico)((#|\?).*)?$/i.test(url);
		}
		
		// Assigns function results to their respective properties
		function makeSettings() {
	        var i;
	        settings = $.extend({}, $.data(element, colorbox));
	        
			for (i in settings) {
				if ($.isFunction(settings[i]) && i.slice(0, 2) !== 'on') { // checks to make sure the function isn't one of the callbacks, they will be handled at the appropriate time.
				    settings[i] = settings[i].call(element);
				}
			}
	        
			settings.rel = settings.rel || element.rel || 'nofollow';
			settings.href = settings.href || $(element).attr('href');
			settings.title = settings.title || element.title;
	        
	        if (typeof settings.href === "string") {
	            settings.href = $.trim(settings.href);
	        }
		}
	
		function trigger(event, callback) {
			$.event.trigger(event);
			if (callback) {
				callback.call(element);
			}
		}
	
		// Slideshow functionality
		function slideshow() {
			var
			timeOut,
			className = prefix + "Slideshow_",
			click = "click." + prefix,
			start,
			stop,
			clear;
			
			if (settings.slideshow && $related[1]) {
				start = function () {
					$slideshow
						.text(settings.slideshowStop)
						.unbind(click)
						.bind(event_complete, function () {
							if (index < $related.length - 1 || settings.loop) {
								timeOut = setTimeout(publicMethod.next, settings.slideshowSpeed);
							}
						})
						.bind(event_load, function () {
							clearTimeout(timeOut);
						})
						.one(click + ' ' + event_cleanup, stop);
					$box.removeClass(className + "off").addClass(className + "on");
					timeOut = setTimeout(publicMethod.next, settings.slideshowSpeed);
				};
				
				stop = function () {
					clearTimeout(timeOut);
					$slideshow
						.text(settings.slideshowStart)
						.unbind([event_complete, event_load, event_cleanup, click].join(' '))
						.one(click, function () {
							publicMethod.next();
							start();
						});
					$box.removeClass(className + "on").addClass(className + "off");
				};
				
				if (settings.slideshowAuto) {
					start();
				} else {
					stop();
				}
			} else {
	            $box.removeClass(className + "off " + className + "on");
	        }
		}
	
		function launch(target) {
			if (!closing) {
				
				element = target;
				
				makeSettings();
				
				$related = $(element);
				
				index = 0;
				
				if (settings.rel !== 'nofollow') {
					$related = $('.' + boxElement).filter(function () {
						var relRelated = $.data(this, colorbox).rel || this.rel;
						return (relRelated === settings.rel);
					});
					index = $related.index(element);
					
					// Check direct calls to ColorBox.
					if (index === -1) {
						$related = $related.add(element);
						index = $related.length - 1;
					}
				}
				
				if (!open) {
					open = active = true; // Prevents the page-change action from queuing up if the visitor holds down the left or right keys.
					
					$box.show();
					
					if (settings.returnFocus) {
						try {
							element.blur();
							$(element).one(event_closed, function () {
								try {
									this.focus();
								} catch (e) {
									// do nothing
								}
							});
						} catch (e) {
							// do nothing
						}
					}
					
					// +settings.opacity avoids a problem in IE when using non-zero-prefixed-string-values, like '.5'
					$overlay.css({"opacity": +settings.opacity, "cursor": settings.overlayClose ? "pointer" : "auto"}).show();
					
					// Opens inital empty ColorBox prior to content being loaded.
					settings.w = setSize(settings.initialWidth, 'x');
					settings.h = setSize(settings.initialHeight, 'y');
					publicMethod.position();
					
					if (isIE6) {
						$window.bind('resize.' + event_ie6 + ' scroll.' + event_ie6, function () {
							$overlay.css({width: $window.width(), height: $window.height(), top: $window.scrollTop(), left: $window.scrollLeft()});
						}).trigger('resize.' + event_ie6);
					}
					
					trigger(event_open, settings.onOpen);
					
					$groupControls.add($title).hide();
					
					$close.html(settings.close).show();
				}
				
				publicMethod.load(true);
			}
		}
	
		// ****************
		// PUBLIC FUNCTIONS
		// Usage format: $.fn.colorbox.close();
		// Usage from within an iframe: parent.$.fn.colorbox.close();
		// ****************
		
		publicMethod = $.fn[colorbox] = $[colorbox] = function (options, callback) {
			var $this = this;
			
	        options = options || {};
	        
			publicMethod.init();
			
			if (!$this[0]) {
				if ($this.selector) { // if a selector was given and it didn't match any elements, go ahead and exit.
	                return $this;
	            }
	            // if no selector was given (ie. $.colorbox()), create a temporary element to work with
				$this = $('<a/>');
				options.open = true; // assume an immediate open
			}
			
			if (callback) {
				options.onComplete = callback;
			}
			
			$this.each(function () {
				$.data(this, colorbox, $.extend({}, $.data(this, colorbox) || defaults, options));
				$(this).addClass(boxElement);
			});
			
	        if (($.isFunction(options.open) && options.open.call($this)) || options.open) {
				launch($this[0]);
			}
	        
			return $this;
		};
	
		// Initialize ColorBox: store common calculations, preload the interface graphics, append the html.
		// This preps ColorBox for a speedy open when clicked, and minimizes the burdon on the browser by only
		// having to run once, instead of each time colorbox is opened.
		publicMethod.init = function () {
			if (!$box) {
				
				// If the body is not present yet, wait for DOM ready
				if (!$('body')[0]) {
					$(publicMethod.init);
					return;
				}
				
				// Create the markup and append to BODY
				$window = $(window);
				$box = $tag(div).attr({id: colorbox, 'class': isIE ? prefix + (isIE6 ? 'IE6' : 'IE') : ''});
				$overlay = $tag(div, "Overlay", isIE6 ? 'position:absolute' : '').hide();
				$wrap = $tag(div, "Wrapper");
				$content = $tag(div, "Content").append(
					$loaded = $tag(div, "LoadedContent", 'width:0; height:0; overflow:hidden'),
					$loadingOverlay = $tag(div, "LoadingOverlay").add($tag(div, "LoadingGraphic")),
					$title = $tag(div, "Title"),
					$current = $tag(div, "Current"),
					$next = $tag(div, "Next"),
					$prev = $tag(div, "Previous"),
					$slideshow = $tag(div, "Slideshow").bind(event_open, slideshow),
					$close = $tag(div, "Close")
				);
				
				$wrap.append( // The 3x3 Grid that makes up ColorBox
					$tag(div).append(
						$tag(div, "TopLeft"),
						$topBorder = $tag(div, "TopCenter"),
						$tag(div, "TopRight")
					),
					$tag(div, false, 'clear:left').append(
						$leftBorder = $tag(div, "MiddleLeft"),
						$content,
						$rightBorder = $tag(div, "MiddleRight")
					),
					$tag(div, false, 'clear:left').append(
						$tag(div, "BottomLeft"),
						$bottomBorder = $tag(div, "BottomCenter"),
						$tag(div, "BottomRight")
					)
				).find('div div').css({'float': 'left'});
				
				$loadingBay = $tag(div, false, 'position:absolute; width:9999px; visibility:hidden; display:none');
				
				$('body').prepend($overlay, $box.append($wrap, $loadingBay));
				
				// Cache values needed for size calculations
				interfaceHeight = $topBorder.height() + $bottomBorder.height() + $content.outerHeight(true) - $content.height();//Subtraction needed for IE6
				interfaceWidth = $leftBorder.width() + $rightBorder.width() + $content.outerWidth(true) - $content.width();
				loadedHeight = $loaded.outerHeight(true);
				loadedWidth = $loaded.outerWidth(true);
				
				// Setting padding to remove the need to do size conversions during the animation step.
				$box.css({"padding-bottom": interfaceHeight, "padding-right": interfaceWidth}).hide();
				
				// Setup button events.
				// Anonymous functions here keep the public method from being cached, thereby allowing them to be redefined on the fly.
				$next.click(function () {
					publicMethod.next();
				});
				$prev.click(function () {
					publicMethod.prev();
				});
				$close.click(function () {
					publicMethod.close();
				});
				
				$groupControls = $next.add($prev).add($current).add($slideshow);
				
				$overlay.click(function () {
					if (settings.overlayClose) {
						publicMethod.close();
					}
				});
				
				// Set Navigation Key Bindings
				$(document).bind('keydown.' + prefix, function (e) {
					var key = e.keyCode;
					if (open && settings.escKey && key === 27) {
						e.preventDefault();
						publicMethod.close();
					}
					if (open && settings.arrowKey && $related[1]) {
						if (key === 37) {
							e.preventDefault();
							$prev.click();
						} else if (key === 39) {
							e.preventDefault();
							$next.click();
						}
					}
				});
			}
		};
		
		publicMethod.remove = function () {
			$box.add($overlay).remove();
			$box = null;
			$('.' + boxElement).removeData(colorbox).removeClass(boxElement);
		};
	
		publicMethod.position = function (speed, loadedCallback) {
	        var top = 0, left = 0, offset = $box.offset();
	        
	        $window.unbind('resize.' + prefix);
	
	        // remove the modal so that it doesn't influence the document width/height        
	        $box.css({top: -99999, left: -99999});
	
	        if (settings.fixed && !isIE6) {
	            $box.css({position: 'fixed'});
	        } else {
	            top = $window.scrollTop();
	            left = $window.scrollLeft();
	            $box.css({position: 'absolute'});
	        }
	
			// keeps the top and left positions within the browser's viewport.
	        if (settings.right !== false) {
	            left += Math.max($window.width() - settings.w - loadedWidth - interfaceWidth - setSize(settings.right, 'x'), 0);
	        } else if (settings.left !== false) {
	            left += setSize(settings.left, 'x');
	        } else {
	            left += Math.round(Math.max($window.width() - settings.w - loadedWidth - interfaceWidth, 0) / 2);
	        }
	        
	        if (settings.bottom !== false) {
	            top += Math.max($window.height() - settings.h - loadedHeight - interfaceHeight - setSize(settings.bottom, 'y'), 0);
	        } else if (settings.top !== false) {
	            top += setSize(settings.top, 'y');
	        } else {
	            top += Math.round(Math.max($window.height() - settings.h - loadedHeight - interfaceHeight, 0) / 2);
	        }
	        
	        $box.css({top: offset.top, left: offset.left});
	        
			// setting the speed to 0 to reduce the delay between same-sized content.
			speed = ($box.width() === settings.w + loadedWidth && $box.height() === settings.h + loadedHeight) ? 0 : speed || 0;
	        
			// this gives the wrapper plenty of breathing room so it's floated contents can move around smoothly,
			// but it has to be shrank down around the size of div#colorbox when it's done.  If not,
			// it can invoke an obscure IE bug when using iframes.
			$wrap[0].style.width = $wrap[0].style.height = "9999px";
			
			function modalDimensions(that) {
				// loading overlay height has to be explicitly set for IE6.
				$topBorder[0].style.width = $bottomBorder[0].style.width = $content[0].style.width = that.style.width;
				$loadingOverlay[0].style.height = $loadingOverlay[1].style.height = $content[0].style.height = $leftBorder[0].style.height = $rightBorder[0].style.height = that.style.height;
			}
			
			$box.dequeue().animate({width: settings.w + loadedWidth, height: settings.h + loadedHeight, top: top, left: left}, {
				duration: speed,
				complete: function () {
					modalDimensions(this);
					
					active = false;
					
					// shrink the wrapper down to exactly the size of colorbox to avoid a bug in IE's iframe implementation.
					$wrap[0].style.width = (settings.w + loadedWidth + interfaceWidth) + "px";
					$wrap[0].style.height = (settings.h + loadedHeight + interfaceHeight) + "px";
					
					if (loadedCallback) {
						loadedCallback();
					}
	                
	                setTimeout(function () {  // small delay before binding onresize due to an IE8 bug.
	                    $window.bind('resize.' + prefix, publicMethod.position);
	                }, 1);
				},
				step: function () {
					modalDimensions(this);
				}
			});
		};
	
		publicMethod.resize = function (options) {
			if (open) {
				options = options || {};
				
				if (options.width) {
					settings.w = setSize(options.width, 'x') - loadedWidth - interfaceWidth;
				}
				if (options.innerWidth) {
					settings.w = setSize(options.innerWidth, 'x');
				}
				$loaded.css({width: settings.w});
				
				if (options.height) {
					settings.h = setSize(options.height, 'y') - loadedHeight - interfaceHeight;
				}
				if (options.innerHeight) {
					settings.h = setSize(options.innerHeight, 'y');
				}
				if (!options.innerHeight && !options.height) {
					$loaded.css({height: "auto"});
					settings.h = $loaded.height();
				}
				$loaded.css({height: settings.h});
				
				publicMethod.position(settings.transition === "none" ? 0 : settings.speed);
			}
		};
	
		publicMethod.prep = function (object) {
			if (!open) {
				return;
			}
			
			var callback, speed = settings.transition === "none" ? 0 : settings.speed;
			
			$loaded.remove();
			$loaded = $tag(div, 'LoadedContent').append(object);
			
			function getWidth() {
				settings.w = settings.w || $loaded.width();
				settings.w = settings.mw && settings.mw < settings.w ? settings.mw : settings.w;
				return settings.w;
			}
			function getHeight() {
				settings.h = settings.h || $loaded.height();
				settings.h = settings.mh && settings.mh < settings.h ? settings.mh : settings.h;
				return settings.h;
			}
			
			$loaded.hide()
			.appendTo($loadingBay.show())// content has to be appended to the DOM for accurate size calculations.
			.css({width: getWidth(), overflow: settings.scrolling ? 'auto' : 'hidden'})
			.css({height: getHeight()})// sets the height independently from the width in case the new width influences the value of height.
			.prependTo($content);
			
			$loadingBay.hide();
			
			// floating the IMG removes the bottom line-height and fixed a problem where IE miscalculates the width of the parent element as 100% of the document width.
			//$(photo).css({'float': 'none', marginLeft: 'auto', marginRight: 'auto'});
			
	        $(photo).css({'float': 'none'});
	        
			// Hides SELECT elements in IE6 because they would otherwise sit on top of the overlay.
			if (isIE6) {
				$('select').not($box.find('select')).filter(function () {
					return this.style.visibility !== 'hidden';
				}).css({'visibility': 'hidden'}).one(event_cleanup, function () {
					this.style.visibility = 'inherit';
				});
			}
			
			callback = function () {
	            var preload, i, total = $related.length, iframe, frameBorder = 'frameBorder', allowTransparency = 'allowTransparency', complete, src, img;
	            
	            if (!open) {
	                return;
	            }
	            
	            function removeFilter() {
	                if (isIE) {
	                    $box[0].style.removeAttribute('filter');
	                }
	            }
	            
	            complete = function () {
	                clearTimeout(loadingTimer);
	                $loadingOverlay.hide();
	                trigger(event_complete, settings.onComplete);
	            };
	            
	            if (isIE) {
	                //This fadeIn helps the bicubic resampling to kick-in.
	                if (photo) {
	                    $loaded.fadeIn(100);
	                }
	            }
	            
	            $title.html(settings.title).add($loaded).show();
	            
	            if (total > 1) { // handle grouping
	                if (typeof settings.current === "string") {
	                    $current.html(settings.current.replace('{current}', index + 1).replace('{total}', total)).show();
	                }
	                
	                $next[(settings.loop || index < total - 1) ? "show" : "hide"]().html(settings.next);
	                $prev[(settings.loop || index) ? "show" : "hide"]().html(settings.previous);
					
	                if (settings.slideshow) {
	                    $slideshow.show();
	                }
					
	                // Preloads images within a rel group
	                if (settings.preloading) {
						preload = [
							getIndex(-1),
							getIndex(1)
						];
						while ((i = $related[preload.pop()])) {
							src = $.data(i, colorbox).href || i.href;
							if ($.isFunction(src)) {
								src = src.call(i);
							}
							if (isImage(src)) {
								img = new Image();
								img.src = src;
							}
						}
	                }
	            } else {
	                $groupControls.hide();
	            }
	            
	            if (settings.iframe) {
	                iframe = $tag('iframe')[0];
	                
	                if (frameBorder in iframe) {
	                    iframe[frameBorder] = 0;
	                }
	                if (allowTransparency in iframe) {
	                    iframe[allowTransparency] = "true";
	                }
	                // give the iframe a unique name to prevent caching
	                iframe.name = prefix + (+new Date());
	                if (settings.fastIframe) {
	                    complete();
	                } else {
	                    $(iframe).one('load', complete);
	                }
	                iframe.src = settings.href;
	                if (!settings.scrolling) {
	                    iframe.scrolling = "no";
	                }
	                $(iframe).addClass(prefix + 'Iframe').appendTo($loaded).one(event_purge, function () {
	                    iframe.src = "//about:blank";
	                });
	            } else {
	                complete();
	            }
	            
	            if (settings.transition === 'fade') {
	                $box.fadeTo(speed, 1, removeFilter);
	            } else {
	                removeFilter();
	            }
			};
			
			if (settings.transition === 'fade') {
				$box.fadeTo(speed, 0, function () {
					publicMethod.position(0, callback);
				});
			} else {
				publicMethod.position(speed, callback);
			}
		};
	
		publicMethod.load = function (launched) {
			var href, setResize, prep = publicMethod.prep;
			
			active = true;
			
			photo = false;
			
			element = $related[index];
			
			if (!launched) {
				makeSettings();
			}
			
			trigger(event_purge);
			
			trigger(event_load, settings.onLoad);
			
			settings.h = settings.height ?
					setSize(settings.height, 'y') - loadedHeight - interfaceHeight :
					settings.innerHeight && setSize(settings.innerHeight, 'y');
			
			settings.w = settings.width ?
					setSize(settings.width, 'x') - loadedWidth - interfaceWidth :
					settings.innerWidth && setSize(settings.innerWidth, 'x');
			
			// Sets the minimum dimensions for use in image scaling
			settings.mw = settings.w;
			settings.mh = settings.h;
			
			// Re-evaluate the minimum width and height based on maxWidth and maxHeight values.
			// If the width or height exceed the maxWidth or maxHeight, use the maximum values instead.
			if (settings.maxWidth) {
				settings.mw = setSize(settings.maxWidth, 'x') - loadedWidth - interfaceWidth;
				settings.mw = settings.w && settings.w < settings.mw ? settings.w : settings.mw;
			}
			if (settings.maxHeight) {
				settings.mh = setSize(settings.maxHeight, 'y') - loadedHeight - interfaceHeight;
				settings.mh = settings.h && settings.h < settings.mh ? settings.h : settings.mh;
			}
			
			href = settings.href;
			
	        loadingTimer = setTimeout(function () {
	            $loadingOverlay.show();
	        }, 100);
	        
			if (settings.inline) {
				// Inserts an empty placeholder where inline content is being pulled from.
				// An event is bound to put inline content back when ColorBox closes or loads new content.
				$tag(div).hide().insertBefore($(href)[0]).one(event_purge, function () {
					$(this).replaceWith($loaded.children());
				});
				prep($(href));
			} else if (settings.iframe) {
				// IFrame element won't be added to the DOM until it is ready to be displayed,
				// to avoid problems with DOM-ready JS that might be trying to run in that iframe.
				prep(" ");
			} else if (settings.html) {
				prep(settings.html);
			} else if (isImage(href)) {
				$(photo = new Image())
				.addClass(prefix + 'Photo')
				.error(function () {
					settings.title = false;
					prep($tag(div, 'Error').text('This image could not be loaded'));
				})
				.load(function () {
					var percent;
					photo.onload = null; //stops animated gifs from firing the onload repeatedly.
					
					if (settings.scalePhotos) {
						setResize = function () {
							photo.height -= photo.height * percent;
							photo.width -= photo.width * percent;	
						};
						if (settings.mw && photo.width > settings.mw) {
							percent = (photo.width - settings.mw) / photo.width;
							setResize();
						}
						if (settings.mh && photo.height > settings.mh) {
							percent = (photo.height - settings.mh) / photo.height;
							setResize();
						}
					}
					
					if (settings.h) {
						photo.style.marginTop = Math.max(settings.h - photo.height, 0) / 2 + 'px';
					}
					
					if ($related[1] && (index < $related.length - 1 || settings.loop)) {
						photo.style.cursor = 'pointer';
						photo.onclick = function () {
	                        publicMethod.next();
	                    };
					}
					
					if (isIE) {
						photo.style.msInterpolationMode = 'bicubic';
					}
					
					setTimeout(function () { // A pause because Chrome will sometimes report a 0 by 0 size otherwise.
						prep(photo);
					}, 1);
				});
				
				setTimeout(function () { // A pause because Opera 10.6+ will sometimes not run the onload function otherwise.
					photo.src = href;
				}, 1);
			} else if (href) {
				$loadingBay.load(href, settings.data, function (data, status, xhr) {
					prep(status === 'error' ? $tag(div, 'Error').text('Request unsuccessful: ' + xhr.statusText) : $(this).contents());
				});
			}
		};
	        
		// Navigates to the next page/image in a set.
		publicMethod.next = function () {
			if (!active && $related[1] && (index < $related.length - 1 || settings.loop)) {
				index = getIndex(1);
				publicMethod.load();
			}
		};
		
		publicMethod.prev = function () {
			if (!active && $related[1] && (index || settings.loop)) {
				index = getIndex(-1);
				publicMethod.load();
			}
		};
	
		// Note: to use this within an iframe use the following format: parent.$.fn.colorbox.close();
		publicMethod.close = function () {
			if (open && !closing) {
				
				closing = true;
				
				open = false;
				
				trigger(event_cleanup, settings.onCleanup);
				
				$window.unbind('.' + prefix + ' .' + event_ie6);
				
				$overlay.fadeTo(200, 0);
				
				$box.stop().fadeTo(300, 0, function () {
	                 
					$box.add($overlay).css({'opacity': 1, cursor: 'auto'}).hide();
					
					trigger(event_purge);
					
					$loaded.remove();
					
					setTimeout(function () {
						closing = false;
						trigger(event_closed, settings.onClosed);
					}, 1);
				});
			}
		};
	
		// A method for fetching the current element ColorBox is referencing.
		// returns a jQuery object.
		publicMethod.element = function () {
			return $(element);
		};
	
		publicMethod.settings = defaults;
	    
		// Bind the live event before DOM-ready for maximum performance in IE6 & 7.
		$(document).on('click', '.' + boxElement, function (e) {
	        // ignore non-left-mouse-clicks and clicks modified with ctrl / command, shift, or alt.
	        // See: http://jacklmoore.com/notes/click-events/
	        if (!(e.which > 1 || e.shiftKey || e.altKey || e.metaKey)) {
	            e.preventDefault();
	            launch(this);
	        }
	    });
	
		// Setup ColorBox
		publicMethod.init();
	
	}(jQuery, document, window));


/***/ }),
/* 218 */,
/* 219 */,
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery JavaScript Library v2.2.3
	 * http://jquery.com/
	 *
	 * Includes Sizzle.js
	 * http://sizzlejs.com/
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2016-04-05T19:26Z
	 */
	
	(function( global, factory ) {
	
		if ( typeof module === "object" && typeof module.exports === "object" ) {
			// For CommonJS and CommonJS-like environments where a proper `window`
			// is present, execute the factory and get jQuery.
			// For environments that do not have a `window` with a `document`
			// (such as Node.js), expose a factory as module.exports.
			// This accentuates the need for the creation of a real `window`.
			// e.g. var jQuery = require("jquery")(window);
			// See ticket #14549 for more info.
			module.exports = global.document ?
				factory( global, true ) :
				function( w ) {
					if ( !w.document ) {
						throw new Error( "jQuery requires a window with a document" );
					}
					return factory( w );
				};
		} else {
			factory( global );
		}
	
	// Pass this if window is not defined yet
	}(typeof window !== "undefined" ? window : this, function( window, noGlobal ) {
	
	// Support: Firefox 18+
	// Can't be in strict mode, several libs including ASP.NET trace
	// the stack via arguments.caller.callee and Firefox dies if
	// you try to trace through "use strict" call chains. (#13335)
	//"use strict";
	var arr = [];
	
	var document = window.document;
	
	var slice = arr.slice;
	
	var concat = arr.concat;
	
	var push = arr.push;
	
	var indexOf = arr.indexOf;
	
	var class2type = {};
	
	var toString = class2type.toString;
	
	var hasOwn = class2type.hasOwnProperty;
	
	var support = {};
	
	
	
	var
		version = "2.2.3",
	
		// Define a local copy of jQuery
		jQuery = function( selector, context ) {
	
			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init( selector, context );
		},
	
		// Support: Android<4.1
		// Make sure we trim BOM and NBSP
		rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
	
		// Matches dashed string for camelizing
		rmsPrefix = /^-ms-/,
		rdashAlpha = /-([\da-z])/gi,
	
		// Used by jQuery.camelCase as callback to replace()
		fcamelCase = function( all, letter ) {
			return letter.toUpperCase();
		};
	
	jQuery.fn = jQuery.prototype = {
	
		// The current version of jQuery being used
		jquery: version,
	
		constructor: jQuery,
	
		// Start with an empty selector
		selector: "",
	
		// The default length of a jQuery object is 0
		length: 0,
	
		toArray: function() {
			return slice.call( this );
		},
	
		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {
			return num != null ?
	
				// Return just the one element from the set
				( num < 0 ? this[ num + this.length ] : this[ num ] ) :
	
				// Return all the elements in a clean array
				slice.call( this );
		},
	
		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {
	
			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );
	
			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;
			ret.context = this.context;
	
			// Return the newly-formed element set
			return ret;
		},
	
		// Execute a callback for every element in the matched set.
		each: function( callback ) {
			return jQuery.each( this, callback );
		},
	
		map: function( callback ) {
			return this.pushStack( jQuery.map( this, function( elem, i ) {
				return callback.call( elem, i, elem );
			} ) );
		},
	
		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},
	
		first: function() {
			return this.eq( 0 );
		},
	
		last: function() {
			return this.eq( -1 );
		},
	
		eq: function( i ) {
			var len = this.length,
				j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
		},
	
		end: function() {
			return this.prevObject || this.constructor();
		},
	
		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: arr.sort,
		splice: arr.splice
	};
	
	jQuery.extend = jQuery.fn.extend = function() {
		var options, name, src, copy, copyIsArray, clone,
			target = arguments[ 0 ] || {},
			i = 1,
			length = arguments.length,
			deep = false;
	
		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;
	
			// Skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}
	
		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !jQuery.isFunction( target ) ) {
			target = {};
		}
	
		// Extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}
	
		for ( ; i < length; i++ ) {
	
			// Only deal with non-null/undefined values
			if ( ( options = arguments[ i ] ) != null ) {
	
				// Extend the base object
				for ( name in options ) {
					src = target[ name ];
					copy = options[ name ];
	
					// Prevent never-ending loop
					if ( target === copy ) {
						continue;
					}
	
					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
						( copyIsArray = jQuery.isArray( copy ) ) ) ) {
	
						if ( copyIsArray ) {
							copyIsArray = false;
							clone = src && jQuery.isArray( src ) ? src : [];
	
						} else {
							clone = src && jQuery.isPlainObject( src ) ? src : {};
						}
	
						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );
	
					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	jQuery.extend( {
	
		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
	
		// Assume jQuery is ready without the ready module
		isReady: true,
	
		error: function( msg ) {
			throw new Error( msg );
		},
	
		noop: function() {},
	
		isFunction: function( obj ) {
			return jQuery.type( obj ) === "function";
		},
	
		isArray: Array.isArray,
	
		isWindow: function( obj ) {
			return obj != null && obj === obj.window;
		},
	
		isNumeric: function( obj ) {
	
			// parseFloat NaNs numeric-cast false positives (null|true|false|"")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			// adding 1 corrects loss of precision from parseFloat (#15100)
			var realStringObj = obj && obj.toString();
			return !jQuery.isArray( obj ) && ( realStringObj - parseFloat( realStringObj ) + 1 ) >= 0;
		},
	
		isPlainObject: function( obj ) {
			var key;
	
			// Not plain objects:
			// - Any object or value whose internal [[Class]] property is not "[object Object]"
			// - DOM nodes
			// - window
			if ( jQuery.type( obj ) !== "object" || obj.nodeType || jQuery.isWindow( obj ) ) {
				return false;
			}
	
			// Not own constructor property must be Object
			if ( obj.constructor &&
					!hasOwn.call( obj, "constructor" ) &&
					!hasOwn.call( obj.constructor.prototype || {}, "isPrototypeOf" ) ) {
				return false;
			}
	
			// Own properties are enumerated firstly, so to speed up,
			// if last one is own, then all properties are own
			for ( key in obj ) {}
	
			return key === undefined || hasOwn.call( obj, key );
		},
	
		isEmptyObject: function( obj ) {
			var name;
			for ( name in obj ) {
				return false;
			}
			return true;
		},
	
		type: function( obj ) {
			if ( obj == null ) {
				return obj + "";
			}
	
			// Support: Android<4.0, iOS<6 (functionish RegExp)
			return typeof obj === "object" || typeof obj === "function" ?
				class2type[ toString.call( obj ) ] || "object" :
				typeof obj;
		},
	
		// Evaluates a script in a global context
		globalEval: function( code ) {
			var script,
				indirect = eval;
	
			code = jQuery.trim( code );
	
			if ( code ) {
	
				// If the code includes a valid, prologue position
				// strict mode pragma, execute code by injecting a
				// script tag into the document.
				if ( code.indexOf( "use strict" ) === 1 ) {
					script = document.createElement( "script" );
					script.text = code;
					document.head.appendChild( script ).parentNode.removeChild( script );
				} else {
	
					// Otherwise, avoid the DOM node creation, insertion
					// and removal by using an indirect global eval
	
					indirect( code );
				}
			}
		},
	
		// Convert dashed to camelCase; used by the css and data modules
		// Support: IE9-11+
		// Microsoft forgot to hump their vendor prefix (#9572)
		camelCase: function( string ) {
			return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
		},
	
		nodeName: function( elem, name ) {
			return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
		},
	
		each: function( obj, callback ) {
			var length, i = 0;
	
			if ( isArrayLike( obj ) ) {
				length = obj.length;
				for ( ; i < length; i++ ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			}
	
			return obj;
		},
	
		// Support: Android<4.1
		trim: function( text ) {
			return text == null ?
				"" :
				( text + "" ).replace( rtrim, "" );
		},
	
		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];
	
			if ( arr != null ) {
				if ( isArrayLike( Object( arr ) ) ) {
					jQuery.merge( ret,
						typeof arr === "string" ?
						[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}
	
			return ret;
		},
	
		inArray: function( elem, arr, i ) {
			return arr == null ? -1 : indexOf.call( arr, elem, i );
		},
	
		merge: function( first, second ) {
			var len = +second.length,
				j = 0,
				i = first.length;
	
			for ( ; j < len; j++ ) {
				first[ i++ ] = second[ j ];
			}
	
			first.length = i;
	
			return first;
		},
	
		grep: function( elems, callback, invert ) {
			var callbackInverse,
				matches = [],
				i = 0,
				length = elems.length,
				callbackExpect = !invert;
	
			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}
	
			return matches;
		},
	
		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var length, value,
				i = 0,
				ret = [];
	
			// Go through the array, translating each of the items to their new values
			if ( isArrayLike( elems ) ) {
				length = elems.length;
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
	
			// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
			}
	
			// Flatten any nested arrays
			return concat.apply( [], ret );
		},
	
		// A global GUID counter for objects
		guid: 1,
	
		// Bind a function to a context, optionally partially applying any
		// arguments.
		proxy: function( fn, context ) {
			var tmp, args, proxy;
	
			if ( typeof context === "string" ) {
				tmp = fn[ context ];
				context = fn;
				fn = tmp;
			}
	
			// Quick check to determine if target is callable, in the spec
			// this throws a TypeError, but we will just return undefined.
			if ( !jQuery.isFunction( fn ) ) {
				return undefined;
			}
	
			// Simulated bind
			args = slice.call( arguments, 2 );
			proxy = function() {
				return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
			};
	
			// Set the guid of unique handler to the same of original handler, so it can be removed
			proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
			return proxy;
		},
	
		now: Date.now,
	
		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	} );
	
	// JSHint would error on this code due to the Symbol not being defined in ES5.
	// Defining this global in .jshintrc would create a danger of using the global
	// unguarded in another place, it seems safer to just disable JSHint for these
	// three lines.
	/* jshint ignore: start */
	if ( typeof Symbol === "function" ) {
		jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
	}
	/* jshint ignore: end */
	
	// Populate the class2type map
	jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );
	
	function isArrayLike( obj ) {
	
		// Support: iOS 8.2 (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = !!obj && "length" in obj && obj.length,
			type = jQuery.type( obj );
	
		if ( type === "function" || jQuery.isWindow( obj ) ) {
			return false;
		}
	
		return type === "array" || length === 0 ||
			typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	var Sizzle =
	/*!
	 * Sizzle CSS Selector Engine v2.2.1
	 * http://sizzlejs.com/
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2015-10-17
	 */
	(function( window ) {
	
	var i,
		support,
		Expr,
		getText,
		isXML,
		tokenize,
		compile,
		select,
		outermostContext,
		sortInput,
		hasDuplicate,
	
		// Local document vars
		setDocument,
		document,
		docElem,
		documentIsHTML,
		rbuggyQSA,
		rbuggyMatches,
		matches,
		contains,
	
		// Instance-specific data
		expando = "sizzle" + 1 * new Date(),
		preferredDoc = window.document,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},
	
		// General-purpose constants
		MAX_NEGATIVE = 1 << 31,
	
		// Instance methods
		hasOwn = ({}).hasOwnProperty,
		arr = [],
		pop = arr.pop,
		push_native = arr.push,
		push = arr.push,
		slice = arr.slice,
		// Use a stripped-down indexOf as it's faster than native
		// http://jsperf.com/thor-indexof-vs-for/5
		indexOf = function( list, elem ) {
			var i = 0,
				len = list.length;
			for ( ; i < len; i++ ) {
				if ( list[i] === elem ) {
					return i;
				}
			}
			return -1;
		},
	
		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
	
		// Regular expressions
	
		// http://www.w3.org/TR/css3-selectors/#whitespace
		whitespace = "[\\x20\\t\\r\\n\\f]",
	
		// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
		identifier = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",
	
		// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
			// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
			"*\\]",
	
		pseudos = ":(" + identifier + ")(?:\\((" +
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
			// 3. anything else (capture 2)
			".*" +
			")\\)|)",
	
		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp( whitespace + "+", "g" ),
		rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),
	
		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),
	
		rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),
	
		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),
	
		matchExpr = {
			"ID": new RegExp( "^#(" + identifier + ")" ),
			"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
			"TAG": new RegExp( "^(" + identifier + "|[*])" ),
			"ATTR": new RegExp( "^" + attributes ),
			"PSEUDO": new RegExp( "^" + pseudos ),
			"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
				"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
				"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
				whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},
	
		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,
	
		rnative = /^[^{]+\{\s*\[native \w/,
	
		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	
		rsibling = /[+~]/,
		rescape = /'|\\/g,
	
		// CSS escapes http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
		funescape = function( _, escaped, escapedWhitespace ) {
			var high = "0x" + escaped - 0x10000;
			// NaN means non-codepoint
			// Support: Firefox<24
			// Workaround erroneous numeric interpretation of +"0x"
			return high !== high || escapedWhitespace ?
				escaped :
				high < 0 ?
					// BMP codepoint
					String.fromCharCode( high + 0x10000 ) :
					// Supplemental Plane codepoint (surrogate pair)
					String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		},
	
		// Used for iframes
		// See setDocument()
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE
		unloadHandler = function() {
			setDocument();
		};
	
	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			(arr = slice.call( preferredDoc.childNodes )),
			preferredDoc.childNodes
		);
		// Support: Android<4.0
		// Detect silently failing push.apply
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = { apply: arr.length ?
	
			// Leverage slice if possible
			function( target, els ) {
				push_native.apply( target, slice.call(els) );
			} :
	
			// Support: IE<9
			// Otherwise append directly
			function( target, els ) {
				var j = target.length,
					i = 0;
				// Can't trust NodeList.length
				while ( (target[j++] = els[i++]) ) {}
				target.length = j - 1;
			}
		};
	}
	
	function Sizzle( selector, context, results, seed ) {
		var m, i, elem, nid, nidselect, match, groups, newSelector,
			newContext = context && context.ownerDocument,
	
			// nodeType defaults to 9, since context defaults to document
			nodeType = context ? context.nodeType : 9;
	
		results = results || [];
	
		// Return early from calls with invalid selector or context
		if ( typeof selector !== "string" || !selector ||
			nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {
	
			return results;
		}
	
		// Try to shortcut find operations (as opposed to filters) in HTML documents
		if ( !seed ) {
	
			if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
				setDocument( context );
			}
			context = context || document;
	
			if ( documentIsHTML ) {
	
				// If the selector is sufficiently simple, try using a "get*By*" DOM method
				// (excepting DocumentFragment context, where the methods don't exist)
				if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {
	
					// ID selector
					if ( (m = match[1]) ) {
	
						// Document context
						if ( nodeType === 9 ) {
							if ( (elem = context.getElementById( m )) ) {
	
								// Support: IE, Opera, Webkit
								// TODO: identify versions
								// getElementById can match elements by name instead of ID
								if ( elem.id === m ) {
									results.push( elem );
									return results;
								}
							} else {
								return results;
							}
	
						// Element context
						} else {
	
							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( newContext && (elem = newContext.getElementById( m )) &&
								contains( context, elem ) &&
								elem.id === m ) {
	
								results.push( elem );
								return results;
							}
						}
	
					// Type selector
					} else if ( match[2] ) {
						push.apply( results, context.getElementsByTagName( selector ) );
						return results;
	
					// Class selector
					} else if ( (m = match[3]) && support.getElementsByClassName &&
						context.getElementsByClassName ) {
	
						push.apply( results, context.getElementsByClassName( m ) );
						return results;
					}
				}
	
				// Take advantage of querySelectorAll
				if ( support.qsa &&
					!compilerCache[ selector + " " ] &&
					(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {
	
					if ( nodeType !== 1 ) {
						newContext = context;
						newSelector = selector;
	
					// qSA looks outside Element context, which is not what we want
					// Thanks to Andrew Dupont for this workaround technique
					// Support: IE <=8
					// Exclude object elements
					} else if ( context.nodeName.toLowerCase() !== "object" ) {
	
						// Capture the context ID, setting it first if necessary
						if ( (nid = context.getAttribute( "id" )) ) {
							nid = nid.replace( rescape, "\\$&" );
						} else {
							context.setAttribute( "id", (nid = expando) );
						}
	
						// Prefix every selector in the list
						groups = tokenize( selector );
						i = groups.length;
						nidselect = ridentifier.test( nid ) ? "#" + nid : "[id='" + nid + "']";
						while ( i-- ) {
							groups[i] = nidselect + " " + toSelector( groups[i] );
						}
						newSelector = groups.join( "," );
	
						// Expand context for sibling selectors
						newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
							context;
					}
	
					if ( newSelector ) {
						try {
							push.apply( results,
								newContext.querySelectorAll( newSelector )
							);
							return results;
						} catch ( qsaError ) {
						} finally {
							if ( nid === expando ) {
								context.removeAttribute( "id" );
							}
						}
					}
				}
			}
		}
	
		// All others
		return select( selector.replace( rtrim, "$1" ), context, results, seed );
	}
	
	/**
	 * Create key-value caches of limited size
	 * @returns {function(string, object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];
	
		function cache( key, value ) {
			// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {
				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return (cache[ key + " " ] = value);
		}
		return cache;
	}
	
	/**
	 * Mark a function for special use by Sizzle
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}
	
	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created div and expects a boolean result
	 */
	function assert( fn ) {
		var div = document.createElement("div");
	
		try {
			return !!fn( div );
		} catch (e) {
			return false;
		} finally {
			// Remove from its parent by default
			if ( div.parentNode ) {
				div.parentNode.removeChild( div );
			}
			// release memory in IE
			div = null;
		}
	}
	
	/**
	 * Adds the same handler for all of the specified attrs
	 * @param {String} attrs Pipe-separated list of attributes
	 * @param {Function} handler The method that will be applied
	 */
	function addHandle( attrs, handler ) {
		var arr = attrs.split("|"),
			i = arr.length;
	
		while ( i-- ) {
			Expr.attrHandle[ arr[i] ] = handler;
		}
	}
	
	/**
	 * Checks document order of two siblings
	 * @param {Element} a
	 * @param {Element} b
	 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
	 */
	function siblingCheck( a, b ) {
		var cur = b && a,
			diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
				( ~b.sourceIndex || MAX_NEGATIVE ) -
				( ~a.sourceIndex || MAX_NEGATIVE );
	
		// Use IE sourceIndex if available on both nodes
		if ( diff ) {
			return diff;
		}
	
		// Check if b follows a
		if ( cur ) {
			while ( (cur = cur.nextSibling) ) {
				if ( cur === b ) {
					return -1;
				}
			}
		}
	
		return a ? 1 : -1;
	}
	
	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return (name === "input" || name === "button") && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction(function( argument ) {
			argument = +argument;
			return markFunction(function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;
	
				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ (j = matchIndexes[i]) ] ) {
						seed[j] = !(matches[j] = seed[j]);
					}
				}
			});
		});
	}
	
	/**
	 * Checks a node for validity as a Sizzle context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== "undefined" && context;
	}
	
	// Expose support vars for convenience
	support = Sizzle.support = {};
	
	/**
	 * Detects XML nodes
	 * @param {Element|Object} elem An element or a document
	 * @returns {Boolean} True iff elem is a non-HTML XML node
	 */
	isXML = Sizzle.isXML = function( elem ) {
		// documentElement is verified for cases where it doesn't yet exist
		// (such as loading iframes in IE - #4833)
		var documentElement = elem && (elem.ownerDocument || elem).documentElement;
		return documentElement ? documentElement.nodeName !== "HTML" : false;
	};
	
	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [doc] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	setDocument = Sizzle.setDocument = function( node ) {
		var hasCompare, parent,
			doc = node ? node.ownerDocument || node : preferredDoc;
	
		// Return early if doc is invalid or already selected
		if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}
	
		// Update global variables
		document = doc;
		docElem = document.documentElement;
		documentIsHTML = !isXML( document );
	
		// Support: IE 9-11, Edge
		// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
		if ( (parent = document.defaultView) && parent.top !== parent ) {
			// Support: IE 11
			if ( parent.addEventListener ) {
				parent.addEventListener( "unload", unloadHandler, false );
	
			// Support: IE 9 - 10 only
			} else if ( parent.attachEvent ) {
				parent.attachEvent( "onunload", unloadHandler );
			}
		}
	
		/* Attributes
		---------------------------------------------------------------------- */
	
		// Support: IE<8
		// Verify that getAttribute really returns attributes and not properties
		// (excepting IE8 booleans)
		support.attributes = assert(function( div ) {
			div.className = "i";
			return !div.getAttribute("className");
		});
	
		/* getElement(s)By*
		---------------------------------------------------------------------- */
	
		// Check if getElementsByTagName("*") returns only elements
		support.getElementsByTagName = assert(function( div ) {
			div.appendChild( document.createComment("") );
			return !div.getElementsByTagName("*").length;
		});
	
		// Support: IE<9
		support.getElementsByClassName = rnative.test( document.getElementsByClassName );
	
		// Support: IE<10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert(function( div ) {
			docElem.appendChild( div ).id = expando;
			return !document.getElementsByName || !document.getElementsByName( expando ).length;
		});
	
		// ID find and filter
		if ( support.getById ) {
			Expr.find["ID"] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var m = context.getElementById( id );
					return m ? [ m ] : [];
				}
			};
			Expr.filter["ID"] = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute("id") === attrId;
				};
			};
		} else {
			// Support: IE6/7
			// getElementById is not reliable as a find shortcut
			delete Expr.find["ID"];
	
			Expr.filter["ID"] =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== "undefined" &&
						elem.getAttributeNode("id");
					return node && node.value === attrId;
				};
			};
		}
	
		// Tag
		Expr.find["TAG"] = support.getElementsByTagName ?
			function( tag, context ) {
				if ( typeof context.getElementsByTagName !== "undefined" ) {
					return context.getElementsByTagName( tag );
	
				// DocumentFragment nodes don't have gEBTN
				} else if ( support.qsa ) {
					return context.querySelectorAll( tag );
				}
			} :
	
			function( tag, context ) {
				var elem,
					tmp = [],
					i = 0,
					// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
					results = context.getElementsByTagName( tag );
	
				// Filter out possible comments
				if ( tag === "*" ) {
					while ( (elem = results[i++]) ) {
						if ( elem.nodeType === 1 ) {
							tmp.push( elem );
						}
					}
	
					return tmp;
				}
				return results;
			};
	
		// Class
		Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
			if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};
	
		/* QSA/matchesSelector
		---------------------------------------------------------------------- */
	
		// QSA and matchesSelector support
	
		// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
		rbuggyMatches = [];
	
		// qSa(:focus) reports false when true (Chrome 21)
		// We allow this because of a bug in IE8/9 that throws an error
		// whenever `document.activeElement` is accessed on an iframe
		// So, we allow :focus to pass through QSA all the time to avoid the IE error
		// See http://bugs.jquery.com/ticket/13378
		rbuggyQSA = [];
	
		if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
			// Build QSA regex
			// Regex strategy adopted from Diego Perini
			assert(function( div ) {
				// Select is set to empty string on purpose
				// This is to test IE's treatment of not explicitly
				// setting a boolean content attribute,
				// since its presence should be enough
				// http://bugs.jquery.com/ticket/12359
				docElem.appendChild( div ).innerHTML = "<a id='" + expando + "'></a>" +
					"<select id='" + expando + "-\r\\' msallowcapture=''>" +
					"<option selected=''></option></select>";
	
				// Support: IE8, Opera 11-12.16
				// Nothing should be selected when empty strings follow ^= or $= or *=
				// The test attribute must be unknown in Opera but "safe" for WinRT
				// http://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
				if ( div.querySelectorAll("[msallowcapture^='']").length ) {
					rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
				}
	
				// Support: IE8
				// Boolean attributes and "value" are not treated correctly
				if ( !div.querySelectorAll("[selected]").length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
				}
	
				// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
				if ( !div.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
					rbuggyQSA.push("~=");
				}
	
				// Webkit/Opera - :checked should return selected option elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				// IE8 throws error here and will not see later tests
				if ( !div.querySelectorAll(":checked").length ) {
					rbuggyQSA.push(":checked");
				}
	
				// Support: Safari 8+, iOS 8+
				// https://bugs.webkit.org/show_bug.cgi?id=136851
				// In-page `selector#id sibing-combinator selector` fails
				if ( !div.querySelectorAll( "a#" + expando + "+*" ).length ) {
					rbuggyQSA.push(".#.+[+~]");
				}
			});
	
			assert(function( div ) {
				// Support: Windows 8 Native Apps
				// The type and name attributes are restricted during .innerHTML assignment
				var input = document.createElement("input");
				input.setAttribute( "type", "hidden" );
				div.appendChild( input ).setAttribute( "name", "D" );
	
				// Support: IE8
				// Enforce case-sensitivity of name attribute
				if ( div.querySelectorAll("[name=d]").length ) {
					rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
				}
	
				// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
				// IE8 throws error here and will not see later tests
				if ( !div.querySelectorAll(":enabled").length ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Opera 10-11 does not throw on post-comma invalid pseudos
				div.querySelectorAll("*,:x");
				rbuggyQSA.push(",.*:");
			});
		}
	
		if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
			docElem.webkitMatchesSelector ||
			docElem.mozMatchesSelector ||
			docElem.oMatchesSelector ||
			docElem.msMatchesSelector) )) ) {
	
			assert(function( div ) {
				// Check to see if it's possible to do matchesSelector
				// on a disconnected node (IE 9)
				support.disconnectedMatch = matches.call( div, "div" );
	
				// This should fail with an exception
				// Gecko does not error, returns false instead
				matches.call( div, "[s!='']:x" );
				rbuggyMatches.push( "!=", pseudos );
			});
		}
	
		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
		rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );
	
		/* Contains
		---------------------------------------------------------------------- */
		hasCompare = rnative.test( docElem.compareDocumentPosition );
	
		// Element contains another
		// Purposefully self-exclusive
		// As in, an element does not contain itself
		contains = hasCompare || rnative.test( docElem.contains ) ?
			function( a, b ) {
				var adown = a.nodeType === 9 ? a.documentElement : a,
					bup = b && b.parentNode;
				return a === bup || !!( bup && bup.nodeType === 1 && (
					adown.contains ?
						adown.contains( bup ) :
						a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
				));
			} :
			function( a, b ) {
				if ( b ) {
					while ( (b = b.parentNode) ) {
						if ( b === a ) {
							return true;
						}
					}
				}
				return false;
			};
	
		/* Sorting
		---------------------------------------------------------------------- */
	
		// Document order sorting
		sortOrder = hasCompare ?
		function( a, b ) {
	
			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}
	
			// Calculate position if both inputs belong to the same document
			compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :
	
				// Otherwise we know they are disconnected
				1;
	
			// Disconnected nodes
			if ( compare & 1 ||
				(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {
	
				// Choose the first element that is related to our preferred document
				if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
					return -1;
				}
				if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
					return 1;
				}
	
				// Maintain original order
				return sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
			}
	
			return compare & 4 ? -1 : 1;
		} :
		function( a, b ) {
			// Exit early if the nodes are identical
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			var cur,
				i = 0,
				aup = a.parentNode,
				bup = b.parentNode,
				ap = [ a ],
				bp = [ b ];
	
			// Parentless nodes are either documents or disconnected
			if ( !aup || !bup ) {
				return a === document ? -1 :
					b === document ? 1 :
					aup ? -1 :
					bup ? 1 :
					sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
	
			// If the nodes are siblings, we can do a quick check
			} else if ( aup === bup ) {
				return siblingCheck( a, b );
			}
	
			// Otherwise we need full lists of their ancestors for comparison
			cur = a;
			while ( (cur = cur.parentNode) ) {
				ap.unshift( cur );
			}
			cur = b;
			while ( (cur = cur.parentNode) ) {
				bp.unshift( cur );
			}
	
			// Walk down the tree looking for a discrepancy
			while ( ap[i] === bp[i] ) {
				i++;
			}
	
			return i ?
				// Do a sibling check if the nodes have a common ancestor
				siblingCheck( ap[i], bp[i] ) :
	
				// Otherwise nodes in our document sort first
				ap[i] === preferredDoc ? -1 :
				bp[i] === preferredDoc ? 1 :
				0;
		};
	
		return document;
	};
	
	Sizzle.matches = function( expr, elements ) {
		return Sizzle( expr, null, null, elements );
	};
	
	Sizzle.matchesSelector = function( elem, expr ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		// Make sure that attribute selectors are quoted
		expr = expr.replace( rattributeQuotes, "='$1']" );
	
		if ( support.matchesSelector && documentIsHTML &&
			!compilerCache[ expr + " " ] &&
			( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
			( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {
	
			try {
				var ret = matches.call( elem, expr );
	
				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||
						// As well, disconnected nodes are said to be in a document
						// fragment in IE 9
						elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch (e) {}
		}
	
		return Sizzle( expr, document, null, [ elem ] ).length > 0;
	};
	
	Sizzle.contains = function( context, elem ) {
		// Set document vars if needed
		if ( ( context.ownerDocument || context ) !== document ) {
			setDocument( context );
		}
		return contains( context, elem );
	};
	
	Sizzle.attr = function( elem, name ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		var fn = Expr.attrHandle[ name.toLowerCase() ],
			// Don't get fooled by Object.prototype properties (jQuery #13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;
	
		return val !== undefined ?
			val :
			support.attributes || !documentIsHTML ?
				elem.getAttribute( name ) :
				(val = elem.getAttributeNode(name)) && val.specified ?
					val.value :
					null;
	};
	
	Sizzle.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};
	
	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	Sizzle.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;
	
		// Unless we *know* we can detect duplicates, assume their presence
		hasDuplicate = !support.detectDuplicates;
		sortInput = !support.sortStable && results.slice( 0 );
		results.sort( sortOrder );
	
		if ( hasDuplicate ) {
			while ( (elem = results[i++]) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				results.splice( duplicates[ j ], 1 );
			}
		}
	
		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;
	
		return results;
	};
	
	/**
	 * Utility function for retrieving the text value of an array of DOM nodes
	 * @param {Array|Element} elem
	 */
	getText = Sizzle.getText = function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;
	
		if ( !nodeType ) {
			// If no nodeType, this is expected to be an array
			while ( (node = elem[i++]) ) {
				// Do not traverse comment nodes
				ret += getText( node );
			}
		} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
			// Use textContent for elements
			// innerText usage removed for consistency of new lines (jQuery #11153)
			if ( typeof elem.textContent === "string" ) {
				return elem.textContent;
			} else {
				// Traverse its children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					ret += getText( elem );
				}
			}
		} else if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}
		// Do not include comment or processing instruction nodes
	
		return ret;
	};
	
	Expr = Sizzle.selectors = {
	
		// Can be adjusted by the user
		cacheLength: 50,
	
		createPseudo: markFunction,
	
		match: matchExpr,
	
		attrHandle: {},
	
		find: {},
	
		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},
	
		preFilter: {
			"ATTR": function( match ) {
				match[1] = match[1].replace( runescape, funescape );
	
				// Move the given value to match[3] whether quoted or unquoted
				match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );
	
				if ( match[2] === "~=" ) {
					match[3] = " " + match[3] + " ";
				}
	
				return match.slice( 0, 4 );
			},
	
			"CHILD": function( match ) {
				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[1] = match[1].toLowerCase();
	
				if ( match[1].slice( 0, 3 ) === "nth" ) {
					// nth-* requires argument
					if ( !match[3] ) {
						Sizzle.error( match[0] );
					}
	
					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
					match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );
	
				// other types prohibit arguments
				} else if ( match[3] ) {
					Sizzle.error( match[0] );
				}
	
				return match;
			},
	
			"PSEUDO": function( match ) {
				var excess,
					unquoted = !match[6] && match[2];
	
				if ( matchExpr["CHILD"].test( match[0] ) ) {
					return null;
				}
	
				// Accept quoted arguments as-is
				if ( match[3] ) {
					match[2] = match[4] || match[5] || "";
	
				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&
					// Get excess from tokenize (recursively)
					(excess = tokenize( unquoted, true )) &&
					// advance to the next closing parenthesis
					(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {
	
					// excess is a negative index
					match[0] = match[0].slice( 0, excess );
					match[2] = unquoted.slice( 0, excess );
				}
	
				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},
	
		filter: {
	
			"TAG": function( nodeNameSelector ) {
				var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() { return true; } :
					function( elem ) {
						return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
					};
			},
	
			"CLASS": function( className ) {
				var pattern = classCache[ className + " " ];
	
				return pattern ||
					(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
					classCache( className, function( elem ) {
						return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
					});
			},
	
			"ATTR": function( name, operator, check ) {
				return function( elem ) {
					var result = Sizzle.attr( elem, name );
	
					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}
	
					result += "";
	
					return operator === "=" ? result === check :
						operator === "!=" ? result !== check :
						operator === "^=" ? check && result.indexOf( check ) === 0 :
						operator === "*=" ? check && result.indexOf( check ) > -1 :
						operator === "$=" ? check && result.slice( -check.length ) === check :
						operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
						operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
						false;
				};
			},
	
			"CHILD": function( type, what, argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";
	
				return first === 1 && last === 0 ?
	
					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :
	
					function( elem, context, xml ) {
						var cache, uniqueCache, outerCache, node, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType,
							diff = false;
	
						if ( parent ) {
	
							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( (node = node[ dir ]) ) {
										if ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) {
	
											return false;
										}
									}
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}
	
							start = [ forward ? parent.firstChild : parent.lastChild ];
	
							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {
	
								// Seek `elem` from a previously-cached index
	
								// ...in a gzip-friendly way
								node = parent;
								outerCache = node[ expando ] || (node[ expando ] = {});
	
								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});
	
								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex && cache[ 2 ];
								node = nodeIndex && parent.childNodes[ nodeIndex ];
	
								while ( (node = ++nodeIndex && node && node[ dir ] ||
	
									// Fallback to seeking `elem` from the start
									(diff = nodeIndex = 0) || start.pop()) ) {
	
									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}
	
							} else {
								// Use previously-cached element index if available
								if ( useCache ) {
									// ...in a gzip-friendly way
									node = elem;
									outerCache = node[ expando ] || (node[ expando ] = {});
	
									// Support: IE <9 only
									// Defend against cloned attroperties (jQuery gh-1709)
									uniqueCache = outerCache[ node.uniqueID ] ||
										(outerCache[ node.uniqueID ] = {});
	
									cache = uniqueCache[ type ] || [];
									nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
									diff = nodeIndex;
								}
	
								// xml :nth-child(...)
								// or :nth-last-child(...) or :nth(-last)?-of-type(...)
								if ( diff === false ) {
									// Use the same loop as above to seek `elem` from the start
									while ( (node = ++nodeIndex && node && node[ dir ] ||
										(diff = nodeIndex = 0) || start.pop()) ) {
	
										if ( ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) &&
											++diff ) {
	
											// Cache the index of each encountered element
											if ( useCache ) {
												outerCache = node[ expando ] || (node[ expando ] = {});
	
												// Support: IE <9 only
												// Defend against cloned attroperties (jQuery gh-1709)
												uniqueCache = outerCache[ node.uniqueID ] ||
													(outerCache[ node.uniqueID ] = {});
	
												uniqueCache[ type ] = [ dirruns, diff ];
											}
	
											if ( node === elem ) {
												break;
											}
										}
									}
								}
							}
	
							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},
	
			"PSEUDO": function( pseudo, argument ) {
				// pseudo-class names are case-insensitive
				// http://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						Sizzle.error( "unsupported pseudo: " + pseudo );
	
				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as Sizzle does
				if ( fn[ expando ] ) {
					return fn( argument );
				}
	
				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction(function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf( seed, matched[i] );
								seed[ idx ] = !( matches[ idx ] = matched[i] );
							}
						}) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}
	
				return fn;
			}
		},
	
		pseudos: {
			// Potentially complex pseudos
			"not": markFunction(function( selector ) {
				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrim, "$1" ) );
	
				return matcher[ expando ] ?
					markFunction(function( seed, matches, context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;
	
						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( (elem = unmatched[i]) ) {
								seed[i] = !(matches[i] = elem);
							}
						}
					}) :
					function( elem, context, xml ) {
						input[0] = elem;
						matcher( input, null, xml, results );
						// Don't keep the element (issue #299)
						input[0] = null;
						return !results.pop();
					};
			}),
	
			"has": markFunction(function( selector ) {
				return function( elem ) {
					return Sizzle( selector, elem ).length > 0;
				};
			}),
	
			"contains": markFunction(function( text ) {
				text = text.replace( runescape, funescape );
				return function( elem ) {
					return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
				};
			}),
	
			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// http://www.w3.org/TR/selectors/#lang-pseudo
			"lang": markFunction( function( lang ) {
				// lang value must be a valid identifier
				if ( !ridentifier.test(lang || "") ) {
					Sizzle.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( (elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {
	
							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
					return false;
				};
			}),
	
			// Miscellaneous
			"target": function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},
	
			"root": function( elem ) {
				return elem === docElem;
			},
	
			"focus": function( elem ) {
				return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
			},
	
			// Boolean properties
			"enabled": function( elem ) {
				return elem.disabled === false;
			},
	
			"disabled": function( elem ) {
				return elem.disabled === true;
			},
	
			"checked": function( elem ) {
				// In CSS3, :checked should return both checked and selected elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				var nodeName = elem.nodeName.toLowerCase();
				return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
			},
	
			"selected": function( elem ) {
				// Accessing this property makes selected-by-default
				// options in Safari work properly
				if ( elem.parentNode ) {
					elem.parentNode.selectedIndex;
				}
	
				return elem.selected === true;
			},
	
			// Contents
			"empty": function( elem ) {
				// http://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},
	
			"parent": function( elem ) {
				return !Expr.pseudos["empty"]( elem );
			},
	
			// Element/input types
			"header": function( elem ) {
				return rheader.test( elem.nodeName );
			},
	
			"input": function( elem ) {
				return rinputs.test( elem.nodeName );
			},
	
			"button": function( elem ) {
				var name = elem.nodeName.toLowerCase();
				return name === "input" && elem.type === "button" || name === "button";
			},
	
			"text": function( elem ) {
				var attr;
				return elem.nodeName.toLowerCase() === "input" &&
					elem.type === "text" &&
	
					// Support: IE<8
					// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
					( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
			},
	
			// Position-in-collection
			"first": createPositionalPseudo(function() {
				return [ 0 ];
			}),
	
			"last": createPositionalPseudo(function( matchIndexes, length ) {
				return [ length - 1 ];
			}),
	
			"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			}),
	
			"even": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"odd": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			})
		}
	};
	
	Expr.pseudos["nth"] = Expr.pseudos["eq"];
	
	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}
	
	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();
	
	tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];
	
		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}
	
		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;
	
		while ( soFar ) {
	
			// Comma and first run
			if ( !matched || (match = rcomma.exec( soFar )) ) {
				if ( match ) {
					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[0].length ) || soFar;
				}
				groups.push( (tokens = []) );
			}
	
			matched = false;
	
			// Combinators
			if ( (match = rcombinators.exec( soFar )) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					// Cast descendant combinators to space
					type: match[0].replace( rtrim, " " )
				});
				soFar = soFar.slice( matched.length );
			}
	
			// Filters
			for ( type in Expr.filter ) {
				if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
					(match = preFilters[ type ]( match ))) ) {
					matched = match.shift();
					tokens.push({
						value: matched,
						type: type,
						matches: match
					});
					soFar = soFar.slice( matched.length );
				}
			}
	
			if ( !matched ) {
				break;
			}
		}
	
		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		return parseOnly ?
			soFar.length :
			soFar ?
				Sizzle.error( selector ) :
				// Cache the tokens
				tokenCache( selector, groups ).slice( 0 );
	};
	
	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[i].value;
		}
		return selector;
	}
	
	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			checkNonElements = base && dir === "parentNode",
			doneName = done++;
	
		return combinator.first ?
			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
			} :
	
			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, uniqueCache, outerCache,
					newCache = [ dirruns, doneName ];
	
				// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
				if ( xml ) {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || (elem[ expando ] = {});
	
							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});
	
							if ( (oldCache = uniqueCache[ dir ]) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
	
								// Assign to newCache so results back-propagate to previous elements
								return (newCache[ 2 ] = oldCache[ 2 ]);
							} else {
								// Reuse newcache so results back-propagate to previous elements
								uniqueCache[ dir ] = newCache;
	
								// A match means we're done; a fail means we have to keep checking
								if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
									return true;
								}
							}
						}
					}
				}
			};
	}
	
	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[i]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[0];
	}
	
	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			Sizzle( selector, contexts[i], results );
		}
		return results;
	}
	
	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;
	
		for ( ; i < len; i++ ) {
			if ( (elem = unmatched[i]) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}
	
		return newUnmatched;
	}
	
	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction(function( seed, results, context, xml ) {
			var temp, i, elem,
				preMap = [],
				postMap = [],
				preexisting = results.length,
	
				// Get initial elements from seed or context
				elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),
	
				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems,
	
				matcherOut = matcher ?
					// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
					postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
	
						// ...intermediate processing is necessary
						[] :
	
						// ...otherwise use results directly
						results :
					matcherIn;
	
			// Find primary matches
			if ( matcher ) {
				matcher( matcherIn, matcherOut, context, xml );
			}
	
			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );
	
				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( (elem = temp[i]) ) {
						matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
					}
				}
			}
	
			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {
						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( (elem = matcherOut[i]) ) {
								// Restore matcherIn since elem is not yet a final match
								temp.push( (matcherIn[i] = elem) );
							}
						}
						postFinder( null, (matcherOut = []), temp, xml );
					}
	
					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) &&
							(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {
	
							seed[temp] = !(results[temp] = elem);
						}
					}
				}
	
			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		});
	}
	
	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[0].type ],
			implicitRelative = leadingRelative || Expr.relative[" "],
			i = leadingRelative ? 1 : 0,
	
			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
				var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
					(checkContext = context).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );
				// Avoid hanging onto element (issue #299)
				checkContext = null;
				return ret;
			} ];
	
		for ( ; i < len; i++ ) {
			if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
				matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
			} else {
				matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );
	
				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {
					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[j].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(
							// If the preceding token was a descendant combinator, insert an implicit any-element `*`
							tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
						).replace( rtrim, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}
	
		return elementMatcher( matchers );
	}
	
	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
					len = elems.length;
	
				if ( outermost ) {
					outermostContext = context === document || context || outermost;
				}
	
				// Add elements passing elementMatchers directly to results
				// Support: IE<9, Safari
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
				for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;
						if ( !context && elem.ownerDocument !== document ) {
							setDocument( elem );
							xml = !documentIsHTML;
						}
						while ( (matcher = elementMatchers[j++]) ) {
							if ( matcher( elem, context || document, xml) ) {
								results.push( elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}
	
					// Track unmatched elements for set filters
					if ( bySet ) {
						// They will have gone through all possible matchers
						if ( (elem = !matcher && elem) ) {
							matchedCount--;
						}
	
						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}
	
				// `i` is now the count of elements visited above, and adding it to `matchedCount`
				// makes the latter nonnegative.
				matchedCount += i;
	
				// Apply set filters to unmatched elements
				// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
				// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
				// no element matchers and no seed.
				// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
				// case, which will result in a "00" `matchedCount` that differs from `i` but is also
				// numerically zero.
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( (matcher = setMatchers[j++]) ) {
						matcher( unmatched, setMatched, context, xml );
					}
	
					if ( seed ) {
						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !(unmatched[i] || setMatched[i]) ) {
									setMatched[i] = pop.call( results );
								}
							}
						}
	
						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}
	
					// Add matches to results
					push.apply( results, setMatched );
	
					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {
	
						Sizzle.uniqueSort( results );
					}
				}
	
				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}
	
				return unmatched;
			};
	
		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}
	
	compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];
	
		if ( !cached ) {
			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[i] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}
	
			// Cache the compiled function
			cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );
	
			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	};
	
	/**
	 * A low-level selection function that works with Sizzle's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with Sizzle.compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	select = Sizzle.select = function( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( (selector = compiled.selector || selector) );
	
		results = results || [];
	
		// Try to minimize operations if there is only one selector in the list and no seed
		// (the latter of which guarantees us context)
		if ( match.length === 1 ) {
	
			// Reduce context if the leading compound selector is an ID
			tokens = match[0] = match[0].slice( 0 );
			if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
					support.getById && context.nodeType === 9 && documentIsHTML &&
					Expr.relative[ tokens[1].type ] ) {
	
				context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
				if ( !context ) {
					return results;
	
				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}
	
				selector = selector.slice( tokens.shift().value.length );
			}
	
			// Fetch a seed set for right-to-left matching
			i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[i];
	
				// Abort if we hit a combinator
				if ( Expr.relative[ (type = token.type) ] ) {
					break;
				}
				if ( (find = Expr.find[ type ]) ) {
					// Search, expanding context for leading sibling combinators
					if ( (seed = find(
						token.matches[0].replace( runescape, funescape ),
						rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
					)) ) {
	
						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}
	
						break;
					}
				}
			}
		}
	
		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	};
	
	// One-time assignments
	
	// Sort stability
	support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;
	
	// Support: Chrome 14-35+
	// Always assume duplicates if they aren't passed to the comparison function
	support.detectDuplicates = !!hasDuplicate;
	
	// Initialize against the default document
	setDocument();
	
	// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert(function( div1 ) {
		// Should return 1, but returns 4 (following)
		return div1.compareDocumentPosition( document.createElement("div") ) & 1;
	});
	
	// Support: IE<8
	// Prevent attribute/property "interpolation"
	// http://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
	if ( !assert(function( div ) {
		div.innerHTML = "<a href='#'></a>";
		return div.firstChild.getAttribute("href") === "#" ;
	}) ) {
		addHandle( "type|href|height|width", function( elem, name, isXML ) {
			if ( !isXML ) {
				return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
			}
		});
	}
	
	// Support: IE<9
	// Use defaultValue in place of getAttribute("value")
	if ( !support.attributes || !assert(function( div ) {
		div.innerHTML = "<input/>";
		div.firstChild.setAttribute( "value", "" );
		return div.firstChild.getAttribute( "value" ) === "";
	}) ) {
		addHandle( "value", function( elem, name, isXML ) {
			if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
				return elem.defaultValue;
			}
		});
	}
	
	// Support: IE<9
	// Use getAttributeNode to fetch booleans when getAttribute lies
	if ( !assert(function( div ) {
		return div.getAttribute("disabled") == null;
	}) ) {
		addHandle( booleans, function( elem, name, isXML ) {
			var val;
			if ( !isXML ) {
				return elem[ name ] === true ? name.toLowerCase() :
						(val = elem.getAttributeNode( name )) && val.specified ?
						val.value :
					null;
			}
		});
	}
	
	return Sizzle;
	
	})( window );
	
	
	
	jQuery.find = Sizzle;
	jQuery.expr = Sizzle.selectors;
	jQuery.expr[ ":" ] = jQuery.expr.pseudos;
	jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
	jQuery.text = Sizzle.getText;
	jQuery.isXMLDoc = Sizzle.isXML;
	jQuery.contains = Sizzle.contains;
	
	
	
	var dir = function( elem, dir, until ) {
		var matched = [],
			truncate = until !== undefined;
	
		while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	};
	
	
	var siblings = function( n, elem ) {
		var matched = [];
	
		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}
	
		return matched;
	};
	
	
	var rneedsContext = jQuery.expr.match.needsContext;
	
	var rsingleTag = ( /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/ );
	
	
	
	var risSimple = /^.[^:#\[\.,]*$/;
	
	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( jQuery.isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				/* jshint -W018 */
				return !!qualifier.call( elem, i, elem ) !== not;
			} );
	
		}
	
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			} );
	
		}
	
		if ( typeof qualifier === "string" ) {
			if ( risSimple.test( qualifier ) ) {
				return jQuery.filter( qualifier, elements, not );
			}
	
			qualifier = jQuery.filter( qualifier, elements );
		}
	
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}
	
	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];
	
		if ( not ) {
			expr = ":not(" + expr + ")";
		}
	
		return elems.length === 1 && elem.nodeType === 1 ?
			jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [] :
			jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
				return elem.nodeType === 1;
			} ) );
	};
	
	jQuery.fn.extend( {
		find: function( selector ) {
			var i,
				len = this.length,
				ret = [],
				self = this;
	
			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter( function() {
					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this ) ) {
							return true;
						}
					}
				} ) );
			}
	
			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}
	
			// Needed because $( selector, context ) becomes $( context ).find( selector )
			ret = this.pushStack( len > 1 ? jQuery.unique( ret ) : ret );
			ret.selector = this.selector ? this.selector + " " + selector : selector;
			return ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow( this, selector || [], false ) );
		},
		not: function( selector ) {
			return this.pushStack( winnow( this, selector || [], true ) );
		},
		is: function( selector ) {
			return !!winnow(
				this,
	
				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test( selector ) ?
					jQuery( selector ) :
					selector || [],
				false
			).length;
		}
	} );
	
	
	// Initialize a jQuery object
	
	
	// A central reference to the root jQuery(document)
	var rootjQuery,
	
		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
		// Strict HTML recognition (#11290: must start with <)
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,
	
		init = jQuery.fn.init = function( selector, context, root ) {
			var match, elem;
	
			// HANDLE: $(""), $(null), $(undefined), $(false)
			if ( !selector ) {
				return this;
			}
	
			// Method init() accepts an alternate rootjQuery
			// so migrate can support jQuery.sub (gh-2101)
			root = root || rootjQuery;
	
			// Handle HTML strings
			if ( typeof selector === "string" ) {
				if ( selector[ 0 ] === "<" &&
					selector[ selector.length - 1 ] === ">" &&
					selector.length >= 3 ) {
	
					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [ null, selector, null ];
	
				} else {
					match = rquickExpr.exec( selector );
				}
	
				// Match html or make sure no context is specified for #id
				if ( match && ( match[ 1 ] || !context ) ) {
	
					// HANDLE: $(html) -> $(array)
					if ( match[ 1 ] ) {
						context = context instanceof jQuery ? context[ 0 ] : context;
	
						// Option to run scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge( this, jQuery.parseHTML(
							match[ 1 ],
							context && context.nodeType ? context.ownerDocument || context : document,
							true
						) );
	
						// HANDLE: $(html, props)
						if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
							for ( match in context ) {
	
								// Properties of context are called as methods if possible
								if ( jQuery.isFunction( this[ match ] ) ) {
									this[ match ]( context[ match ] );
	
								// ...and otherwise set as attributes
								} else {
									this.attr( match, context[ match ] );
								}
							}
						}
	
						return this;
	
					// HANDLE: $(#id)
					} else {
						elem = document.getElementById( match[ 2 ] );
	
						// Support: Blackberry 4.6
						// gEBID returns nodes no longer in the document (#6963)
						if ( elem && elem.parentNode ) {
	
							// Inject the element directly into the jQuery object
							this.length = 1;
							this[ 0 ] = elem;
						}
	
						this.context = document;
						this.selector = selector;
						return this;
					}
	
				// HANDLE: $(expr, $(...))
				} else if ( !context || context.jquery ) {
					return ( context || root ).find( selector );
	
				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor( context ).find( selector );
				}
	
			// HANDLE: $(DOMElement)
			} else if ( selector.nodeType ) {
				this.context = this[ 0 ] = selector;
				this.length = 1;
				return this;
	
			// HANDLE: $(function)
			// Shortcut for document ready
			} else if ( jQuery.isFunction( selector ) ) {
				return root.ready !== undefined ?
					root.ready( selector ) :
	
					// Execute immediately if ready is not present
					selector( jQuery );
			}
	
			if ( selector.selector !== undefined ) {
				this.selector = selector.selector;
				this.context = selector.context;
			}
	
			return jQuery.makeArray( selector, this );
		};
	
	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;
	
	// Initialize central reference
	rootjQuery = jQuery( document );
	
	
	var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	
		// Methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};
	
	jQuery.fn.extend( {
		has: function( target ) {
			var targets = jQuery( target, this ),
				l = targets.length;
	
			return this.filter( function() {
				var i = 0;
				for ( ; i < l; i++ ) {
					if ( jQuery.contains( this, targets[ i ] ) ) {
						return true;
					}
				}
			} );
		},
	
		closest: function( selectors, context ) {
			var cur,
				i = 0,
				l = this.length,
				matched = [],
				pos = rneedsContext.test( selectors ) || typeof selectors !== "string" ?
					jQuery( selectors, context || this.context ) :
					0;
	
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {
	
					// Always skip document fragments
					if ( cur.nodeType < 11 && ( pos ?
						pos.index( cur ) > -1 :
	
						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {
	
						matched.push( cur );
						break;
					}
				}
			}
	
			return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
		},
	
		// Determine the position of an element within the set
		index: function( elem ) {
	
			// No argument, return index in parent
			if ( !elem ) {
				return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
			}
	
			// Index in selector
			if ( typeof elem === "string" ) {
				return indexOf.call( jQuery( elem ), this[ 0 ] );
			}
	
			// Locate the position of the desired element
			return indexOf.call( this,
	
				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[ 0 ] : elem
			);
		},
	
		add: function( selector, context ) {
			return this.pushStack(
				jQuery.uniqueSort(
					jQuery.merge( this.get(), jQuery( selector, context ) )
				)
			);
		},
	
		addBack: function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		}
	} );
	
	function sibling( cur, dir ) {
		while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
		return cur;
	}
	
	jQuery.each( {
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, i, until ) {
			return dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, i, until ) {
			return dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, i, until ) {
			return dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return siblings( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return siblings( elem.firstChild );
		},
		contents: function( elem ) {
			return elem.contentDocument || jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var matched = jQuery.map( this, fn, until );
	
			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}
	
			if ( selector && typeof selector === "string" ) {
				matched = jQuery.filter( selector, matched );
			}
	
			if ( this.length > 1 ) {
	
				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					jQuery.uniqueSort( matched );
				}
	
				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					matched.reverse();
				}
			}
	
			return this.pushStack( matched );
		};
	} );
	var rnotwhite = ( /\S+/g );
	
	
	
	// Convert String-formatted options into Object-formatted ones
	function createOptions( options ) {
		var object = {};
		jQuery.each( options.match( rnotwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		} );
		return object;
	}
	
	/*
	 * Create a callback list using the following parameters:
	 *
	 *	options: an optional list of space-separated options that will change how
	 *			the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *	once:			will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *	memory:			will keep track of previous values and will call any callback added
	 *					after the list has been fired right away with the latest "memorized"
	 *					values (like a Deferred)
	 *
	 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *	stopOnFalse:	interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {
	
		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
			createOptions( options ) :
			jQuery.extend( {}, options );
	
		var // Flag to know if list is currently firing
			firing,
	
			// Last fire value for non-forgettable lists
			memory,
	
			// Flag to know if list was already fired
			fired,
	
			// Flag to prevent firing
			locked,
	
			// Actual callback list
			list = [],
	
			// Queue of execution data for repeatable lists
			queue = [],
	
			// Index of currently firing callback (modified by add/remove as needed)
			firingIndex = -1,
	
			// Fire callbacks
			fire = function() {
	
				// Enforce single-firing
				locked = options.once;
	
				// Execute callbacks for all pending executions,
				// respecting firingIndex overrides and runtime changes
				fired = firing = true;
				for ( ; queue.length; firingIndex = -1 ) {
					memory = queue.shift();
					while ( ++firingIndex < list.length ) {
	
						// Run callback and check for early termination
						if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
							options.stopOnFalse ) {
	
							// Jump to end and forget the data so .add doesn't re-fire
							firingIndex = list.length;
							memory = false;
						}
					}
				}
	
				// Forget the data if we're done with it
				if ( !options.memory ) {
					memory = false;
				}
	
				firing = false;
	
				// Clean up if we're done firing for good
				if ( locked ) {
	
					// Keep an empty list if we have data for future add calls
					if ( memory ) {
						list = [];
	
					// Otherwise, this object is spent
					} else {
						list = "";
					}
				}
			},
	
			// Actual Callbacks object
			self = {
	
				// Add a callback or a collection of callbacks to the list
				add: function() {
					if ( list ) {
	
						// If we have memory from a past run, we should fire after adding
						if ( memory && !firing ) {
							firingIndex = list.length - 1;
							queue.push( memory );
						}
	
						( function add( args ) {
							jQuery.each( args, function( _, arg ) {
								if ( jQuery.isFunction( arg ) ) {
									if ( !options.unique || !self.has( arg ) ) {
										list.push( arg );
									}
								} else if ( arg && arg.length && jQuery.type( arg ) !== "string" ) {
	
									// Inspect recursively
									add( arg );
								}
							} );
						} )( arguments );
	
						if ( memory && !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Remove a callback from the list
				remove: function() {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );
	
							// Handle firing indexes
							if ( index <= firingIndex ) {
								firingIndex--;
							}
						}
					} );
					return this;
				},
	
				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function( fn ) {
					return fn ?
						jQuery.inArray( fn, list ) > -1 :
						list.length > 0;
				},
	
				// Remove all callbacks from the list
				empty: function() {
					if ( list ) {
						list = [];
					}
					return this;
				},
	
				// Disable .fire and .add
				// Abort any current/pending executions
				// Clear all callbacks and values
				disable: function() {
					locked = queue = [];
					list = memory = "";
					return this;
				},
				disabled: function() {
					return !list;
				},
	
				// Disable .fire
				// Also disable .add unless we have memory (since it would have no effect)
				// Abort any pending executions
				lock: function() {
					locked = queue = [];
					if ( !memory ) {
						list = memory = "";
					}
					return this;
				},
				locked: function() {
					return !!locked;
				},
	
				// Call all callbacks with the given context and arguments
				fireWith: function( context, args ) {
					if ( !locked ) {
						args = args || [];
						args = [ context, args.slice ? args.slice() : args ];
						queue.push( args );
						if ( !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Call all the callbacks with the given arguments
				fire: function() {
					self.fireWith( this, arguments );
					return this;
				},
	
				// To know if the callbacks have already been called at least once
				fired: function() {
					return !!fired;
				}
			};
	
		return self;
	};
	
	
	jQuery.extend( {
	
		Deferred: function( func ) {
			var tuples = [
	
					// action, add listener, listener list, final state
					[ "resolve", "done", jQuery.Callbacks( "once memory" ), "resolved" ],
					[ "reject", "fail", jQuery.Callbacks( "once memory" ), "rejected" ],
					[ "notify", "progress", jQuery.Callbacks( "memory" ) ]
				],
				state = "pending",
				promise = {
					state: function() {
						return state;
					},
					always: function() {
						deferred.done( arguments ).fail( arguments );
						return this;
					},
					then: function( /* fnDone, fnFail, fnProgress */ ) {
						var fns = arguments;
						return jQuery.Deferred( function( newDefer ) {
							jQuery.each( tuples, function( i, tuple ) {
								var fn = jQuery.isFunction( fns[ i ] ) && fns[ i ];
	
								// deferred[ done | fail | progress ] for forwarding actions to newDefer
								deferred[ tuple[ 1 ] ]( function() {
									var returned = fn && fn.apply( this, arguments );
									if ( returned && jQuery.isFunction( returned.promise ) ) {
										returned.promise()
											.progress( newDefer.notify )
											.done( newDefer.resolve )
											.fail( newDefer.reject );
									} else {
										newDefer[ tuple[ 0 ] + "With" ](
											this === promise ? newDefer.promise() : this,
											fn ? [ returned ] : arguments
										);
									}
								} );
							} );
							fns = null;
						} ).promise();
					},
	
					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function( obj ) {
						return obj != null ? jQuery.extend( obj, promise ) : promise;
					}
				},
				deferred = {};
	
			// Keep pipe for back-compat
			promise.pipe = promise.then;
	
			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
					stateString = tuple[ 3 ];
	
				// promise[ done | fail | progress ] = list.add
				promise[ tuple[ 1 ] ] = list.add;
	
				// Handle state
				if ( stateString ) {
					list.add( function() {
	
						// state = [ resolved | rejected ]
						state = stateString;
	
					// [ reject_list | resolve_list ].disable; progress_list.lock
					}, tuples[ i ^ 1 ][ 2 ].disable, tuples[ 2 ][ 2 ].lock );
				}
	
				// deferred[ resolve | reject | notify ]
				deferred[ tuple[ 0 ] ] = function() {
					deferred[ tuple[ 0 ] + "With" ]( this === deferred ? promise : this, arguments );
					return this;
				};
				deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
			} );
	
			// Make the deferred a promise
			promise.promise( deferred );
	
			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}
	
			// All done!
			return deferred;
		},
	
		// Deferred helper
		when: function( subordinate /* , ..., subordinateN */ ) {
			var i = 0,
				resolveValues = slice.call( arguments ),
				length = resolveValues.length,
	
				// the count of uncompleted subordinates
				remaining = length !== 1 ||
					( subordinate && jQuery.isFunction( subordinate.promise ) ) ? length : 0,
	
				// the master Deferred.
				// If resolveValues consist of only a single Deferred, just use that.
				deferred = remaining === 1 ? subordinate : jQuery.Deferred(),
	
				// Update function for both resolve and progress values
				updateFunc = function( i, contexts, values ) {
					return function( value ) {
						contexts[ i ] = this;
						values[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
						if ( values === progressValues ) {
							deferred.notifyWith( contexts, values );
						} else if ( !( --remaining ) ) {
							deferred.resolveWith( contexts, values );
						}
					};
				},
	
				progressValues, progressContexts, resolveContexts;
	
			// Add listeners to Deferred subordinates; treat others as resolved
			if ( length > 1 ) {
				progressValues = new Array( length );
				progressContexts = new Array( length );
				resolveContexts = new Array( length );
				for ( ; i < length; i++ ) {
					if ( resolveValues[ i ] && jQuery.isFunction( resolveValues[ i ].promise ) ) {
						resolveValues[ i ].promise()
							.progress( updateFunc( i, progressContexts, progressValues ) )
							.done( updateFunc( i, resolveContexts, resolveValues ) )
							.fail( deferred.reject );
					} else {
						--remaining;
					}
				}
			}
	
			// If we're not waiting on anything, resolve the master
			if ( !remaining ) {
				deferred.resolveWith( resolveContexts, resolveValues );
			}
	
			return deferred.promise();
		}
	} );
	
	
	// The deferred used on DOM ready
	var readyList;
	
	jQuery.fn.ready = function( fn ) {
	
		// Add the callback
		jQuery.ready.promise().done( fn );
	
		return this;
	};
	
	jQuery.extend( {
	
		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,
	
		// A counter to track how many items to wait for before
		// the ready event fires. See #6781
		readyWait: 1,
	
		// Hold (or release) the ready event
		holdReady: function( hold ) {
			if ( hold ) {
				jQuery.readyWait++;
			} else {
				jQuery.ready( true );
			}
		},
	
		// Handle when the DOM is ready
		ready: function( wait ) {
	
			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}
	
			// Remember that the DOM is ready
			jQuery.isReady = true;
	
			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}
	
			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
	
			// Trigger any bound ready events
			if ( jQuery.fn.triggerHandler ) {
				jQuery( document ).triggerHandler( "ready" );
				jQuery( document ).off( "ready" );
			}
		}
	} );
	
	/**
	 * The ready event handler and self cleanup method
	 */
	function completed() {
		document.removeEventListener( "DOMContentLoaded", completed );
		window.removeEventListener( "load", completed );
		jQuery.ready();
	}
	
	jQuery.ready.promise = function( obj ) {
		if ( !readyList ) {
	
			readyList = jQuery.Deferred();
	
			// Catch cases where $(document).ready() is called
			// after the browser event has already occurred.
			// Support: IE9-10 only
			// Older IE sometimes signals "interactive" too soon
			if ( document.readyState === "complete" ||
				( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {
	
				// Handle it asynchronously to allow scripts the opportunity to delay ready
				window.setTimeout( jQuery.ready );
	
			} else {
	
				// Use the handy event callback
				document.addEventListener( "DOMContentLoaded", completed );
	
				// A fallback to window.onload, that will always work
				window.addEventListener( "load", completed );
			}
		}
		return readyList.promise( obj );
	};
	
	// Kick off the DOM ready check even if the user does not
	jQuery.ready.promise();
	
	
	
	
	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
			len = elems.length,
			bulk = key == null;
	
		// Sets many values
		if ( jQuery.type( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				access( elems, fn, i, key[ i ], true, emptyGet, raw );
			}
	
		// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;
	
			if ( !jQuery.isFunction( value ) ) {
				raw = true;
			}
	
			if ( bulk ) {
	
				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;
	
				// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}
	
			if ( fn ) {
				for ( ; i < len; i++ ) {
					fn(
						elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
					);
				}
			}
		}
	
		return chainable ?
			elems :
	
			// Gets
			bulk ?
				fn.call( elems ) :
				len ? fn( elems[ 0 ], key ) : emptyGet;
	};
	var acceptData = function( owner ) {
	
		// Accepts only:
		//  - Node
		//    - Node.ELEMENT_NODE
		//    - Node.DOCUMENT_NODE
		//  - Object
		//    - Any
		/* jshint -W018 */
		return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
	};
	
	
	
	
	function Data() {
		this.expando = jQuery.expando + Data.uid++;
	}
	
	Data.uid = 1;
	
	Data.prototype = {
	
		register: function( owner, initial ) {
			var value = initial || {};
	
			// If it is a node unlikely to be stringify-ed or looped over
			// use plain assignment
			if ( owner.nodeType ) {
				owner[ this.expando ] = value;
	
			// Otherwise secure it in a non-enumerable, non-writable property
			// configurability must be true to allow the property to be
			// deleted with the delete operator
			} else {
				Object.defineProperty( owner, this.expando, {
					value: value,
					writable: true,
					configurable: true
				} );
			}
			return owner[ this.expando ];
		},
		cache: function( owner ) {
	
			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( !acceptData( owner ) ) {
				return {};
			}
	
			// Check if the owner object already has a cache
			var value = owner[ this.expando ];
	
			// If not, create one
			if ( !value ) {
				value = {};
	
				// We can accept data for non-element nodes in modern browsers,
				// but we should not, see #8335.
				// Always return an empty object.
				if ( acceptData( owner ) ) {
	
					// If it is a node unlikely to be stringify-ed or looped over
					// use plain assignment
					if ( owner.nodeType ) {
						owner[ this.expando ] = value;
	
					// Otherwise secure it in a non-enumerable property
					// configurable must be true to allow the property to be
					// deleted when data is removed
					} else {
						Object.defineProperty( owner, this.expando, {
							value: value,
							configurable: true
						} );
					}
				}
			}
	
			return value;
		},
		set: function( owner, data, value ) {
			var prop,
				cache = this.cache( owner );
	
			// Handle: [ owner, key, value ] args
			if ( typeof data === "string" ) {
				cache[ data ] = value;
	
			// Handle: [ owner, { properties } ] args
			} else {
	
				// Copy the properties one-by-one to the cache object
				for ( prop in data ) {
					cache[ prop ] = data[ prop ];
				}
			}
			return cache;
		},
		get: function( owner, key ) {
			return key === undefined ?
				this.cache( owner ) :
				owner[ this.expando ] && owner[ this.expando ][ key ];
		},
		access: function( owner, key, value ) {
			var stored;
	
			// In cases where either:
			//
			//   1. No key was specified
			//   2. A string key was specified, but no value provided
			//
			// Take the "read" path and allow the get method to determine
			// which value to return, respectively either:
			//
			//   1. The entire cache object
			//   2. The data stored at the key
			//
			if ( key === undefined ||
					( ( key && typeof key === "string" ) && value === undefined ) ) {
	
				stored = this.get( owner, key );
	
				return stored !== undefined ?
					stored : this.get( owner, jQuery.camelCase( key ) );
			}
	
			// When the key is not a string, or both a key and value
			// are specified, set or extend (existing objects) with either:
			//
			//   1. An object of properties
			//   2. A key and value
			//
			this.set( owner, key, value );
	
			// Since the "set" path can have two possible entry points
			// return the expected data based on which path was taken[*]
			return value !== undefined ? value : key;
		},
		remove: function( owner, key ) {
			var i, name, camel,
				cache = owner[ this.expando ];
	
			if ( cache === undefined ) {
				return;
			}
	
			if ( key === undefined ) {
				this.register( owner );
	
			} else {
	
				// Support array or space separated string of keys
				if ( jQuery.isArray( key ) ) {
	
					// If "name" is an array of keys...
					// When data is initially created, via ("key", "val") signature,
					// keys will be converted to camelCase.
					// Since there is no way to tell _how_ a key was added, remove
					// both plain key and camelCase key. #12786
					// This will only penalize the array argument path.
					name = key.concat( key.map( jQuery.camelCase ) );
				} else {
					camel = jQuery.camelCase( key );
	
					// Try the string as a key before any manipulation
					if ( key in cache ) {
						name = [ key, camel ];
					} else {
	
						// If a key with the spaces exists, use it.
						// Otherwise, create an array by matching non-whitespace
						name = camel;
						name = name in cache ?
							[ name ] : ( name.match( rnotwhite ) || [] );
					}
				}
	
				i = name.length;
	
				while ( i-- ) {
					delete cache[ name[ i ] ];
				}
			}
	
			// Remove the expando if there's no more data
			if ( key === undefined || jQuery.isEmptyObject( cache ) ) {
	
				// Support: Chrome <= 35-45+
				// Webkit & Blink performance suffers when deleting properties
				// from DOM nodes, so set to undefined instead
				// https://code.google.com/p/chromium/issues/detail?id=378607
				if ( owner.nodeType ) {
					owner[ this.expando ] = undefined;
				} else {
					delete owner[ this.expando ];
				}
			}
		},
		hasData: function( owner ) {
			var cache = owner[ this.expando ];
			return cache !== undefined && !jQuery.isEmptyObject( cache );
		}
	};
	var dataPriv = new Data();
	
	var dataUser = new Data();
	
	
	
	//	Implementation Summary
	//
	//	1. Enforce API surface and semantic compatibility with 1.9.x branch
	//	2. Improve the module's maintainability by reducing the storage
	//		paths to a single mechanism.
	//	3. Use the same single mechanism to support "private" and "user" data.
	//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
	//	5. Avoid exposing implementation details on user objects (eg. expando properties)
	//	6. Provide a clear path for implementation upgrade to WeakMap in 2014
	
	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		rmultiDash = /[A-Z]/g;
	
	function dataAttr( elem, key, data ) {
		var name;
	
		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
			name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
			data = elem.getAttribute( name );
	
			if ( typeof data === "string" ) {
				try {
					data = data === "true" ? true :
						data === "false" ? false :
						data === "null" ? null :
	
						// Only convert to a number if it doesn't change the string
						+data + "" === data ? +data :
						rbrace.test( data ) ? jQuery.parseJSON( data ) :
						data;
				} catch ( e ) {}
	
				// Make sure we set the data so it isn't changed later
				dataUser.set( elem, key, data );
			} else {
				data = undefined;
			}
		}
		return data;
	}
	
	jQuery.extend( {
		hasData: function( elem ) {
			return dataUser.hasData( elem ) || dataPriv.hasData( elem );
		},
	
		data: function( elem, name, data ) {
			return dataUser.access( elem, name, data );
		},
	
		removeData: function( elem, name ) {
			dataUser.remove( elem, name );
		},
	
		// TODO: Now that all calls to _data and _removeData have been replaced
		// with direct calls to dataPriv methods, these can be deprecated.
		_data: function( elem, name, data ) {
			return dataPriv.access( elem, name, data );
		},
	
		_removeData: function( elem, name ) {
			dataPriv.remove( elem, name );
		}
	} );
	
	jQuery.fn.extend( {
		data: function( key, value ) {
			var i, name, data,
				elem = this[ 0 ],
				attrs = elem && elem.attributes;
	
			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = dataUser.get( elem );
	
					if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {
	
							// Support: IE11+
							// The attrs elements can be null (#14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = jQuery.camelCase( name.slice( 5 ) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						dataPriv.set( elem, "hasDataAttrs", true );
					}
				}
	
				return data;
			}
	
			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each( function() {
					dataUser.set( this, key );
				} );
			}
	
			return access( this, function( value ) {
				var data, camelKey;
	
				// The calling jQuery object (element matches) is not empty
				// (and therefore has an element appears at this[ 0 ]) and the
				// `value` parameter was not undefined. An empty jQuery object
				// will result in `undefined` for elem = this[ 0 ] which will
				// throw an exception if an attempt to read a data cache is made.
				if ( elem && value === undefined ) {
	
					// Attempt to get data from the cache
					// with the key as-is
					data = dataUser.get( elem, key ) ||
	
						// Try to find dashed key if it exists (gh-2779)
						// This is for 2.2.x only
						dataUser.get( elem, key.replace( rmultiDash, "-$&" ).toLowerCase() );
	
					if ( data !== undefined ) {
						return data;
					}
	
					camelKey = jQuery.camelCase( key );
	
					// Attempt to get data from the cache
					// with the key camelized
					data = dataUser.get( elem, camelKey );
					if ( data !== undefined ) {
						return data;
					}
	
					// Attempt to "discover" the data in
					// HTML5 custom data-* attrs
					data = dataAttr( elem, camelKey, undefined );
					if ( data !== undefined ) {
						return data;
					}
	
					// We tried really hard, but the data doesn't exist.
					return;
				}
	
				// Set the data...
				camelKey = jQuery.camelCase( key );
				this.each( function() {
	
					// First, attempt to store a copy or reference of any
					// data that might've been store with a camelCased key.
					var data = dataUser.get( this, camelKey );
	
					// For HTML5 data-* attribute interop, we have to
					// store property names with dashes in a camelCase form.
					// This might not apply to all properties...*
					dataUser.set( this, camelKey, value );
	
					// *... In the case of properties that might _actually_
					// have dashes, we need to also store a copy of that
					// unchanged property.
					if ( key.indexOf( "-" ) > -1 && data !== undefined ) {
						dataUser.set( this, key, value );
					}
				} );
			}, null, value, arguments.length > 1, null, true );
		},
	
		removeData: function( key ) {
			return this.each( function() {
				dataUser.remove( this, key );
			} );
		}
	} );
	
	
	jQuery.extend( {
		queue: function( elem, type, data ) {
			var queue;
	
			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = dataPriv.get( elem, type );
	
				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || jQuery.isArray( data ) ) {
						queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},
	
		dequeue: function( elem, type ) {
			type = type || "fx";
	
			var queue = jQuery.queue( elem, type ),
				startLength = queue.length,
				fn = queue.shift(),
				hooks = jQuery._queueHooks( elem, type ),
				next = function() {
					jQuery.dequeue( elem, type );
				};
	
			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}
	
			if ( fn ) {
	
				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}
	
				// Clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}
	
			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},
	
		// Not public - generate a queueHooks object, or return the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
				empty: jQuery.Callbacks( "once memory" ).add( function() {
					dataPriv.remove( elem, [ type + "queue", key ] );
				} )
			} );
		}
	} );
	
	jQuery.fn.extend( {
		queue: function( type, data ) {
			var setter = 2;
	
			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}
	
			if ( arguments.length < setter ) {
				return jQuery.queue( this[ 0 ], type );
			}
	
			return data === undefined ?
				this :
				this.each( function() {
					var queue = jQuery.queue( this, type, data );
	
					// Ensure a hooks for this queue
					jQuery._queueHooks( this, type );
	
					if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
						jQuery.dequeue( this, type );
					}
				} );
		},
		dequeue: function( type ) {
			return this.each( function() {
				jQuery.dequeue( this, type );
			} );
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},
	
		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
				count = 1,
				defer = jQuery.Deferred(),
				elements = this,
				i = this.length,
				resolve = function() {
					if ( !( --count ) ) {
						defer.resolveWith( elements, [ elements ] );
					}
				};
	
			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";
	
			while ( i-- ) {
				tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	} );
	var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
	
	var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );
	
	
	var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
	
	var isHidden = function( elem, el ) {
	
			// isHidden might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;
			return jQuery.css( elem, "display" ) === "none" ||
				!jQuery.contains( elem.ownerDocument, elem );
		};
	
	
	
	function adjustCSS( elem, prop, valueParts, tween ) {
		var adjusted,
			scale = 1,
			maxIterations = 20,
			currentValue = tween ?
				function() { return tween.cur(); } :
				function() { return jQuery.css( elem, prop, "" ); },
			initial = currentValue(),
			unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
	
			// Starting value computation is required for potential unit mismatches
			initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
				rcssNum.exec( jQuery.css( elem, prop ) );
	
		if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {
	
			// Trust units reported by jQuery.css
			unit = unit || initialInUnit[ 3 ];
	
			// Make sure we update the tween properties later on
			valueParts = valueParts || [];
	
			// Iteratively approximate from a nonzero starting point
			initialInUnit = +initial || 1;
	
			do {
	
				// If previous iteration zeroed out, double until we get *something*.
				// Use string for doubling so we don't accidentally see scale as unchanged below
				scale = scale || ".5";
	
				// Adjust and apply
				initialInUnit = initialInUnit / scale;
				jQuery.style( elem, prop, initialInUnit + unit );
	
			// Update scale, tolerating zero or NaN from tween.cur()
			// Break the loop if scale is unchanged or perfect, or if we've just had enough.
			} while (
				scale !== ( scale = currentValue() / initial ) && scale !== 1 && --maxIterations
			);
		}
	
		if ( valueParts ) {
			initialInUnit = +initialInUnit || +initial || 0;
	
			// Apply relative offset (+=/-=) if specified
			adjusted = valueParts[ 1 ] ?
				initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
				+valueParts[ 2 ];
			if ( tween ) {
				tween.unit = unit;
				tween.start = initialInUnit;
				tween.end = adjusted;
			}
		}
		return adjusted;
	}
	var rcheckableType = ( /^(?:checkbox|radio)$/i );
	
	var rtagName = ( /<([\w:-]+)/ );
	
	var rscriptType = ( /^$|\/(?:java|ecma)script/i );
	
	
	
	// We have to close these tags to support XHTML (#13200)
	var wrapMap = {
	
		// Support: IE9
		option: [ 1, "<select multiple='multiple'>", "</select>" ],
	
		// XHTML parsers do not magically insert elements in the
		// same way that tag soup parsers do. So we cannot shorten
		// this by omitting <tbody> or other required elements.
		thead: [ 1, "<table>", "</table>" ],
		col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
	
		_default: [ 0, "", "" ]
	};
	
	// Support: IE9
	wrapMap.optgroup = wrapMap.option;
	
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	
	function getAll( context, tag ) {
	
		// Support: IE9-11+
		// Use typeof to avoid zero-argument method invocation on host objects (#15151)
		var ret = typeof context.getElementsByTagName !== "undefined" ?
				context.getElementsByTagName( tag || "*" ) :
				typeof context.querySelectorAll !== "undefined" ?
					context.querySelectorAll( tag || "*" ) :
				[];
	
		return tag === undefined || tag && jQuery.nodeName( context, tag ) ?
			jQuery.merge( [ context ], ret ) :
			ret;
	}
	
	
	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			dataPriv.set(
				elems[ i ],
				"globalEval",
				!refElements || dataPriv.get( refElements[ i ], "globalEval" )
			);
		}
	}
	
	
	var rhtml = /<|&#?\w+;/;
	
	function buildFragment( elems, context, scripts, selection, ignored ) {
		var elem, tmp, tag, wrap, contains, j,
			fragment = context.createDocumentFragment(),
			nodes = [],
			i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			elem = elems[ i ];
	
			if ( elem || elem === 0 ) {
	
				// Add nodes directly
				if ( jQuery.type( elem ) === "object" ) {
	
					// Support: Android<4.1, PhantomJS<2
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
	
				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );
	
				// Convert html into DOM nodes
				} else {
					tmp = tmp || fragment.appendChild( context.createElement( "div" ) );
	
					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
					tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];
	
					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}
	
					// Support: Android<4.1, PhantomJS<2
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, tmp.childNodes );
	
					// Remember the top-level container
					tmp = fragment.firstChild;
	
					// Ensure the created nodes are orphaned (#12392)
					tmp.textContent = "";
				}
			}
		}
	
		// Remove wrapper from fragment
		fragment.textContent = "";
	
		i = 0;
		while ( ( elem = nodes[ i++ ] ) ) {
	
			// Skip elements already in the context collection (trac-4087)
			if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
				if ( ignored ) {
					ignored.push( elem );
				}
				continue;
			}
	
			contains = jQuery.contains( elem.ownerDocument, elem );
	
			// Append to fragment
			tmp = getAll( fragment.appendChild( elem ), "script" );
	
			// Preserve script evaluation history
			if ( contains ) {
				setGlobalEval( tmp );
			}
	
			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( ( elem = tmp[ j++ ] ) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}
	
		return fragment;
	}
	
	
	( function() {
		var fragment = document.createDocumentFragment(),
			div = fragment.appendChild( document.createElement( "div" ) ),
			input = document.createElement( "input" );
	
		// Support: Android 4.0-4.3, Safari<=5.1
		// Check state lost if the name is set (#11217)
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (#14901)
		input.setAttribute( "type", "radio" );
		input.setAttribute( "checked", "checked" );
		input.setAttribute( "name", "t" );
	
		div.appendChild( input );
	
		// Support: Safari<=5.1, Android<4.2
		// Older WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
	
		// Support: IE<=11+
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
	} )();
	
	
	var
		rkeyEvent = /^key/,
		rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
		rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
	
	function returnTrue() {
		return true;
	}
	
	function returnFalse() {
		return false;
	}
	
	// Support: IE9
	// See #13393 for more info
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch ( err ) { }
	}
	
	function on( elem, types, selector, data, fn, one ) {
		var origFn, type;
	
		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {
	
			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {
	
				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				on( elem, type, selector, data, types[ type ], one );
			}
			return elem;
		}
	
		if ( data == null && fn == null ) {
	
			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {
	
				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {
	
				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return elem;
		}
	
		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {
	
				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};
	
			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return elem.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		} );
	}
	
	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {
	
		global: {},
	
		add: function( elem, types, handler, data, selector ) {
	
			var handleObjIn, eventHandle, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.get( elem );
	
			// Don't attach events to noData or text/comment nodes (but allow plain objects)
			if ( !elemData ) {
				return;
			}
	
			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}
	
			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}
	
			// Init the element's event structure and main handler, if this is the first
			if ( !( events = elemData.events ) ) {
				events = elemData.events = {};
			}
			if ( !( eventHandle = elemData.handle ) ) {
				eventHandle = elemData.handle = function( e ) {
	
					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
						jQuery.event.dispatch.apply( elem, arguments ) : undefined;
				};
			}
	
			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnotwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}
	
				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};
	
				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;
	
				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};
	
				// handleObj is passed to all event handlers
				handleObj = jQuery.extend( {
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join( "." )
				}, handleObjIn );
	
				// Init the event handler queue if we're the first
				if ( !( handlers = events[ type ] ) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;
	
					// Only use addEventListener if the special events handler returns false
					if ( !special.setup ||
						special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
	
						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle );
						}
					}
				}
	
				if ( special.add ) {
					special.add.call( elem, handleObj );
	
					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}
	
				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}
	
				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}
	
		},
	
		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {
	
			var j, origCount, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );
	
			if ( !elemData || !( events = elemData.events ) ) {
				return;
			}
	
			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnotwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}
	
				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[ 2 ] &&
					new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );
	
				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];
	
					if ( ( mappedTypes || origType === handleObj.origType ) &&
						( !handler || handler.guid === handleObj.guid ) &&
						( !tmp || tmp.test( handleObj.namespace ) ) &&
						( !selector || selector === handleObj.selector ||
							selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );
	
						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}
	
				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown ||
						special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
	
						jQuery.removeEvent( elem, type, elemData.handle );
					}
	
					delete events[ type ];
				}
			}
	
			// Remove data and the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				dataPriv.remove( elem, "handle events" );
			}
		},
	
		dispatch: function( event ) {
	
			// Make a writable jQuery.Event from the native event object
			event = jQuery.event.fix( event );
	
			var i, j, ret, matched, handleObj,
				handlerQueue = [],
				args = slice.call( arguments ),
				handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
				special = jQuery.event.special[ event.type ] || {};
	
			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[ 0 ] = event;
			event.delegateTarget = this;
	
			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}
	
			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );
	
			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;
	
				j = 0;
				while ( ( handleObj = matched.handlers[ j++ ] ) &&
					!event.isImmediatePropagationStopped() ) {
	
					// Triggered event must either 1) have no namespace, or 2) have namespace(s)
					// a subset or equal to those in the bound event (both can have no namespace).
					if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {
	
						event.handleObj = handleObj;
						event.data = handleObj.data;
	
						ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
							handleObj.handler ).apply( matched.elem, args );
	
						if ( ret !== undefined ) {
							if ( ( event.result = ret ) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}
	
			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}
	
			return event.result;
		},
	
		handlers: function( event, handlers ) {
			var i, matches, sel, handleObj,
				handlerQueue = [],
				delegateCount = handlers.delegateCount,
				cur = event.target;
	
			// Support (at least): Chrome, IE9
			// Find delegate handlers
			// Black-hole SVG <use> instance trees (#13180)
			//
			// Support: Firefox<=42+
			// Avoid non-left-click in FF but don't block IE radio events (#3861, gh-2343)
			if ( delegateCount && cur.nodeType &&
				( event.type !== "click" || isNaN( event.button ) || event.button < 1 ) ) {
	
				for ( ; cur !== this; cur = cur.parentNode || this ) {
	
					// Don't check non-elements (#13208)
					// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
					if ( cur.nodeType === 1 && ( cur.disabled !== true || event.type !== "click" ) ) {
						matches = [];
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];
	
							// Don't conflict with Object.prototype properties (#13203)
							sel = handleObj.selector + " ";
	
							if ( matches[ sel ] === undefined ) {
								matches[ sel ] = handleObj.needsContext ?
									jQuery( sel, this ).index( cur ) > -1 :
									jQuery.find( sel, this, null, [ cur ] ).length;
							}
							if ( matches[ sel ] ) {
								matches.push( handleObj );
							}
						}
						if ( matches.length ) {
							handlerQueue.push( { elem: cur, handlers: matches } );
						}
					}
				}
			}
	
			// Add the remaining (directly-bound) handlers
			if ( delegateCount < handlers.length ) {
				handlerQueue.push( { elem: this, handlers: handlers.slice( delegateCount ) } );
			}
	
			return handlerQueue;
		},
	
		// Includes some event props shared by KeyEvent and MouseEvent
		props: ( "altKey bubbles cancelable ctrlKey currentTarget detail eventPhase " +
			"metaKey relatedTarget shiftKey target timeStamp view which" ).split( " " ),
	
		fixHooks: {},
	
		keyHooks: {
			props: "char charCode key keyCode".split( " " ),
			filter: function( event, original ) {
	
				// Add which for key events
				if ( event.which == null ) {
					event.which = original.charCode != null ? original.charCode : original.keyCode;
				}
	
				return event;
			}
		},
	
		mouseHooks: {
			props: ( "button buttons clientX clientY offsetX offsetY pageX pageY " +
				"screenX screenY toElement" ).split( " " ),
			filter: function( event, original ) {
				var eventDoc, doc, body,
					button = original.button;
	
				// Calculate pageX/Y if missing and clientX/Y available
				if ( event.pageX == null && original.clientX != null ) {
					eventDoc = event.target.ownerDocument || document;
					doc = eventDoc.documentElement;
					body = eventDoc.body;
	
					event.pageX = original.clientX +
						( doc && doc.scrollLeft || body && body.scrollLeft || 0 ) -
						( doc && doc.clientLeft || body && body.clientLeft || 0 );
					event.pageY = original.clientY +
						( doc && doc.scrollTop  || body && body.scrollTop  || 0 ) -
						( doc && doc.clientTop  || body && body.clientTop  || 0 );
				}
	
				// Add which for click: 1 === left; 2 === middle; 3 === right
				// Note: button is not normalized, so don't use it
				if ( !event.which && button !== undefined ) {
					event.which = ( button & 1 ? 1 : ( button & 2 ? 3 : ( button & 4 ? 2 : 0 ) ) );
				}
	
				return event;
			}
		},
	
		fix: function( event ) {
			if ( event[ jQuery.expando ] ) {
				return event;
			}
	
			// Create a writable copy of the event object and normalize some properties
			var i, prop, copy,
				type = event.type,
				originalEvent = event,
				fixHook = this.fixHooks[ type ];
	
			if ( !fixHook ) {
				this.fixHooks[ type ] = fixHook =
					rmouseEvent.test( type ) ? this.mouseHooks :
					rkeyEvent.test( type ) ? this.keyHooks :
					{};
			}
			copy = fixHook.props ? this.props.concat( fixHook.props ) : this.props;
	
			event = new jQuery.Event( originalEvent );
	
			i = copy.length;
			while ( i-- ) {
				prop = copy[ i ];
				event[ prop ] = originalEvent[ prop ];
			}
	
			// Support: Cordova 2.5 (WebKit) (#13255)
			// All events should have a target; Cordova deviceready doesn't
			if ( !event.target ) {
				event.target = document;
			}
	
			// Support: Safari 6.0+, Chrome<28
			// Target should not be a text node (#504, #13143)
			if ( event.target.nodeType === 3 ) {
				event.target = event.target.parentNode;
			}
	
			return fixHook.filter ? fixHook.filter( event, originalEvent ) : event;
		},
	
		special: {
			load: {
	
				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			focus: {
	
				// Fire native event if possible so blur/focus sequence is correct
				trigger: function() {
					if ( this !== safeActiveElement() && this.focus ) {
						this.focus();
						return false;
					}
				},
				delegateType: "focusin"
			},
			blur: {
				trigger: function() {
					if ( this === safeActiveElement() && this.blur ) {
						this.blur();
						return false;
					}
				},
				delegateType: "focusout"
			},
			click: {
	
				// For checkbox, fire native event so checked state will be right
				trigger: function() {
					if ( this.type === "checkbox" && this.click && jQuery.nodeName( this, "input" ) ) {
						this.click();
						return false;
					}
				},
	
				// For cross-browser consistency, don't fire native .click() on links
				_default: function( event ) {
					return jQuery.nodeName( event.target, "a" );
				}
			},
	
			beforeunload: {
				postDispatch: function( event ) {
	
					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		}
	};
	
	jQuery.removeEvent = function( elem, type, handle ) {
	
		// This "if" is needed for plain objects
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle );
		}
	};
	
	jQuery.Event = function( src, props ) {
	
		// Allow instantiation without the 'new' keyword
		if ( !( this instanceof jQuery.Event ) ) {
			return new jQuery.Event( src, props );
		}
	
		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;
	
			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
					src.defaultPrevented === undefined &&
	
					// Support: Android<4.0
					src.returnValue === false ?
				returnTrue :
				returnFalse;
	
		// Event type
		} else {
			this.type = src;
		}
	
		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}
	
		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || jQuery.now();
	
		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};
	
	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// http://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		constructor: jQuery.Event,
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
	
		preventDefault: function() {
			var e = this.originalEvent;
	
			this.isDefaultPrevented = returnTrue;
	
			if ( e ) {
				e.preventDefault();
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;
	
			this.isPropagationStopped = returnTrue;
	
			if ( e ) {
				e.stopPropagation();
			}
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;
	
			this.isImmediatePropagationStopped = returnTrue;
	
			if ( e ) {
				e.stopImmediatePropagation();
			}
	
			this.stopPropagation();
		}
	};
	
	// Create mouseenter/leave events using mouseover/out and event-time checks
	// so that event delegation works in jQuery.
	// Do the same for pointerenter/pointerleave and pointerover/pointerout
	//
	// Support: Safari 7 only
	// Safari sends mouseenter too often; see:
	// https://code.google.com/p/chromium/issues/detail?id=470258
	// for the description of the bug (it existed in older Chrome versions as well).
	jQuery.each( {
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,
	
			handle: function( event ) {
				var ret,
					target = this,
					related = event.relatedTarget,
					handleObj = event.handleObj;
	
				// For mouseenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	} );
	
	jQuery.fn.extend( {
		on: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn );
		},
		one: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {
	
				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
					handleObj.namespace ?
						handleObj.origType + "." + handleObj.namespace :
						handleObj.origType,
					handleObj.selector,
					handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {
	
				// ( types-object [, selector] )
				for ( type in types ) {
					this.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {
	
				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each( function() {
				jQuery.event.remove( this, types, fn, selector );
			} );
		}
	} );
	
	
	var
		rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi,
	
		// Support: IE 10-11, Edge 10240+
		// In IE/Edge using regex groups here causes severe slowdowns.
		// See https://connect.microsoft.com/IE/feedback/details/1736512/
		rnoInnerhtml = /<script|<style|<link/i,
	
		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
		rscriptTypeMasked = /^true\/(.*)/,
		rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
	
	// Manipulating tables requires a tbody
	function manipulationTarget( elem, content ) {
		return jQuery.nodeName( elem, "table" ) &&
			jQuery.nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ?
	
			elem.getElementsByTagName( "tbody" )[ 0 ] ||
				elem.appendChild( elem.ownerDocument.createElement( "tbody" ) ) :
			elem;
	}
	
	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		var match = rscriptTypeMasked.exec( elem.type );
	
		if ( match ) {
			elem.type = match[ 1 ];
		} else {
			elem.removeAttribute( "type" );
		}
	
		return elem;
	}
	
	function cloneCopyEvent( src, dest ) {
		var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;
	
		if ( dest.nodeType !== 1 ) {
			return;
		}
	
		// 1. Copy private data: events, handlers, etc.
		if ( dataPriv.hasData( src ) ) {
			pdataOld = dataPriv.access( src );
			pdataCur = dataPriv.set( dest, pdataOld );
			events = pdataOld.events;
	
			if ( events ) {
				delete pdataCur.handle;
				pdataCur.events = {};
	
				for ( type in events ) {
					for ( i = 0, l = events[ type ].length; i < l; i++ ) {
						jQuery.event.add( dest, type, events[ type ][ i ] );
					}
				}
			}
		}
	
		// 2. Copy user data
		if ( dataUser.hasData( src ) ) {
			udataOld = dataUser.access( src );
			udataCur = jQuery.extend( {}, udataOld );
	
			dataUser.set( dest, udataCur );
		}
	}
	
	// Fix IE bugs, see support tests
	function fixInput( src, dest ) {
		var nodeName = dest.nodeName.toLowerCase();
	
		// Fails to persist the checked state of a cloned checkbox or radio button.
		if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
			dest.checked = src.checked;
	
		// Fails to return the selected option to the default selected state when cloning options
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}
	
	function domManip( collection, args, callback, ignored ) {
	
		// Flatten any nested arrays
		args = concat.apply( [], args );
	
		var fragment, first, scripts, hasScripts, node, doc,
			i = 0,
			l = collection.length,
			iNoClone = l - 1,
			value = args[ 0 ],
			isFunction = jQuery.isFunction( value );
	
		// We can't cloneNode fragments that contain checked, in WebKit
		if ( isFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return collection.each( function( index ) {
				var self = collection.eq( index );
				if ( isFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				domManip( self, args, callback, ignored );
			} );
		}
	
		if ( l ) {
			fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
			first = fragment.firstChild;
	
			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}
	
			// Require either new content or an interest in ignored elements to invoke the callback
			if ( first || ignored ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;
	
				// Use the original fragment for the last item
				// instead of the first because it can end up
				// being emptied incorrectly in certain situations (#8070).
				for ( ; i < l; i++ ) {
					node = fragment;
	
					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );
	
						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {
	
							// Support: Android<4.1, PhantomJS<2
							// push.apply(_, arraylike) throws on ancient WebKit
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}
	
					callback.call( collection[ i ], node, i );
				}
	
				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;
	
					// Reenable scripts
					jQuery.map( scripts, restoreScript );
	
					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!dataPriv.access( node, "globalEval" ) &&
							jQuery.contains( doc, node ) ) {
	
							if ( node.src ) {
	
								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl ) {
									jQuery._evalUrl( node.src );
								}
							} else {
								jQuery.globalEval( node.textContent.replace( rcleanScript, "" ) );
							}
						}
					}
				}
			}
		}
	
		return collection;
	}
	
	function remove( elem, selector, keepData ) {
		var node,
			nodes = selector ? jQuery.filter( selector, elem ) : elem,
			i = 0;
	
		for ( ; ( node = nodes[ i ] ) != null; i++ ) {
			if ( !keepData && node.nodeType === 1 ) {
				jQuery.cleanData( getAll( node ) );
			}
	
			if ( node.parentNode ) {
				if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
					setGlobalEval( getAll( node, "script" ) );
				}
				node.parentNode.removeChild( node );
			}
		}
	
		return elem;
	}
	
	jQuery.extend( {
		htmlPrefilter: function( html ) {
			return html.replace( rxhtmlTag, "<$1></$2>" );
		},
	
		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var i, l, srcElements, destElements,
				clone = elem.cloneNode( true ),
				inPage = jQuery.contains( elem.ownerDocument, elem );
	
			// Fix IE cloning issues
			if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
					!jQuery.isXMLDoc( elem ) ) {
	
				// We eschew Sizzle here for performance reasons: http://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );
	
				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					fixInput( srcElements[ i ], destElements[ i ] );
				}
			}
	
			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );
	
					for ( i = 0, l = srcElements.length; i < l; i++ ) {
						cloneCopyEvent( srcElements[ i ], destElements[ i ] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}
	
			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}
	
			// Return the cloned set
			return clone;
		},
	
		cleanData: function( elems ) {
			var data, elem, type,
				special = jQuery.event.special,
				i = 0;
	
			for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
				if ( acceptData( elem ) ) {
					if ( ( data = elem[ dataPriv.expando ] ) ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );
	
								// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}
	
						// Support: Chrome <= 35-45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataPriv.expando ] = undefined;
					}
					if ( elem[ dataUser.expando ] ) {
	
						// Support: Chrome <= 35-45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataUser.expando ] = undefined;
					}
				}
			}
		}
	} );
	
	jQuery.fn.extend( {
	
		// Keep domManip exposed until 3.0 (gh-2225)
		domManip: domManip,
	
		detach: function( selector ) {
			return remove( this, selector, true );
		},
	
		remove: function( selector ) {
			return remove( this, selector );
		},
	
		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
					jQuery.text( this ) :
					this.empty().each( function() {
						if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
							this.textContent = value;
						}
					} );
			}, null, value, arguments.length );
		},
	
		append: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			} );
		},
	
		prepend: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			} );
		},
	
		before: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			} );
		},
	
		after: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			} );
		},
	
		empty: function() {
			var elem,
				i = 0;
	
			for ( ; ( elem = this[ i ] ) != null; i++ ) {
				if ( elem.nodeType === 1 ) {
	
					// Prevent memory leaks
					jQuery.cleanData( getAll( elem, false ) );
	
					// Remove any remaining nodes
					elem.textContent = "";
				}
			}
	
			return this;
		},
	
		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
			return this.map( function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			} );
		},
	
		html: function( value ) {
			return access( this, function( value ) {
				var elem = this[ 0 ] || {},
					i = 0,
					l = this.length;
	
				if ( value === undefined && elem.nodeType === 1 ) {
					return elem.innerHTML;
				}
	
				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
					!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {
	
					value = jQuery.htmlPrefilter( value );
	
					try {
						for ( ; i < l; i++ ) {
							elem = this[ i ] || {};
	
							// Remove element nodes and prevent memory leaks
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}
	
						elem = 0;
	
					// If using innerHTML throws an exception, use the fallback method
					} catch ( e ) {}
				}
	
				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},
	
		replaceWith: function() {
			var ignored = [];
	
			// Make the changes, replacing each non-ignored context element with the new content
			return domManip( this, arguments, function( elem ) {
				var parent = this.parentNode;
	
				if ( jQuery.inArray( this, ignored ) < 0 ) {
					jQuery.cleanData( getAll( this ) );
					if ( parent ) {
						parent.replaceChild( elem, this );
					}
				}
	
			// Force callback invocation
			}, ignored );
		}
	} );
	
	jQuery.each( {
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var elems,
				ret = [],
				insert = jQuery( selector ),
				last = insert.length - 1,
				i = 0;
	
			for ( ; i <= last; i++ ) {
				elems = i === last ? this : this.clone( true );
				jQuery( insert[ i ] )[ original ]( elems );
	
				// Support: QtWebKit
				// .get() because push.apply(_, arraylike) throws
				push.apply( ret, elems.get() );
			}
	
			return this.pushStack( ret );
		};
	} );
	
	
	var iframe,
		elemdisplay = {
	
			// Support: Firefox
			// We have to pre-define these values for FF (#10227)
			HTML: "block",
			BODY: "block"
		};
	
	/**
	 * Retrieve the actual display of a element
	 * @param {String} name nodeName of the element
	 * @param {Object} doc Document object
	 */
	
	// Called only from within defaultDisplay
	function actualDisplay( name, doc ) {
		var elem = jQuery( doc.createElement( name ) ).appendTo( doc.body ),
	
			display = jQuery.css( elem[ 0 ], "display" );
	
		// We don't have any data stored on the element,
		// so use "detach" method as fast way to get rid of the element
		elem.detach();
	
		return display;
	}
	
	/**
	 * Try to determine the default display value of an element
	 * @param {String} nodeName
	 */
	function defaultDisplay( nodeName ) {
		var doc = document,
			display = elemdisplay[ nodeName ];
	
		if ( !display ) {
			display = actualDisplay( nodeName, doc );
	
			// If the simple way fails, read from inside an iframe
			if ( display === "none" || !display ) {
	
				// Use the already-created iframe if possible
				iframe = ( iframe || jQuery( "<iframe frameborder='0' width='0' height='0'/>" ) )
					.appendTo( doc.documentElement );
	
				// Always write a new HTML skeleton so Webkit and Firefox don't choke on reuse
				doc = iframe[ 0 ].contentDocument;
	
				// Support: IE
				doc.write();
				doc.close();
	
				display = actualDisplay( nodeName, doc );
				iframe.detach();
			}
	
			// Store the correct default display
			elemdisplay[ nodeName ] = display;
		}
	
		return display;
	}
	var rmargin = ( /^margin/ );
	
	var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
	
	var getStyles = function( elem ) {
	
			// Support: IE<=11+, Firefox<=30+ (#15098, #14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			var view = elem.ownerDocument.defaultView;
	
			if ( !view || !view.opener ) {
				view = window;
			}
	
			return view.getComputedStyle( elem );
		};
	
	var swap = function( elem, options, callback, args ) {
		var ret, name,
			old = {};
	
		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}
	
		ret = callback.apply( elem, args || [] );
	
		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}
	
		return ret;
	};
	
	
	var documentElement = document.documentElement;
	
	
	
	( function() {
		var pixelPositionVal, boxSizingReliableVal, pixelMarginRightVal, reliableMarginLeftVal,
			container = document.createElement( "div" ),
			div = document.createElement( "div" );
	
		// Finish early in limited (non-browser) environments
		if ( !div.style ) {
			return;
		}
	
		// Support: IE9-11+
		// Style of cloned element affects source element cloned (#8908)
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";
	
		container.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;" +
			"padding:0;margin-top:1px;position:absolute";
		container.appendChild( div );
	
		// Executing both pixelPosition & boxSizingReliable tests require only one layout
		// so they're executed at the same time to save the second computation.
		function computeStyleTests() {
			div.style.cssText =
	
				// Support: Firefox<29, Android 2.3
				// Vendor-prefix box-sizing
				"-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;" +
				"position:relative;display:block;" +
				"margin:auto;border:1px;padding:1px;" +
				"top:1%;width:50%";
			div.innerHTML = "";
			documentElement.appendChild( container );
	
			var divStyle = window.getComputedStyle( div );
			pixelPositionVal = divStyle.top !== "1%";
			reliableMarginLeftVal = divStyle.marginLeft === "2px";
			boxSizingReliableVal = divStyle.width === "4px";
	
			// Support: Android 4.0 - 4.3 only
			// Some styles come back with percentage values, even though they shouldn't
			div.style.marginRight = "50%";
			pixelMarginRightVal = divStyle.marginRight === "4px";
	
			documentElement.removeChild( container );
		}
	
		jQuery.extend( support, {
			pixelPosition: function() {
	
				// This test is executed only once but we still do memoizing
				// since we can use the boxSizingReliable pre-computing.
				// No need to check if the test was already performed, though.
				computeStyleTests();
				return pixelPositionVal;
			},
			boxSizingReliable: function() {
				if ( boxSizingReliableVal == null ) {
					computeStyleTests();
				}
				return boxSizingReliableVal;
			},
			pixelMarginRight: function() {
	
				// Support: Android 4.0-4.3
				// We're checking for boxSizingReliableVal here instead of pixelMarginRightVal
				// since that compresses better and they're computed together anyway.
				if ( boxSizingReliableVal == null ) {
					computeStyleTests();
				}
				return pixelMarginRightVal;
			},
			reliableMarginLeft: function() {
	
				// Support: IE <=8 only, Android 4.0 - 4.3 only, Firefox <=3 - 37
				if ( boxSizingReliableVal == null ) {
					computeStyleTests();
				}
				return reliableMarginLeftVal;
			},
			reliableMarginRight: function() {
	
				// Support: Android 2.3
				// Check if div with explicit width and no margin-right incorrectly
				// gets computed margin-right based on width of container. (#3333)
				// WebKit Bug 13343 - getComputedStyle returns wrong value for margin-right
				// This support function is only executed once so no memoizing is needed.
				var ret,
					marginDiv = div.appendChild( document.createElement( "div" ) );
	
				// Reset CSS: box-sizing; display; margin; border; padding
				marginDiv.style.cssText = div.style.cssText =
	
					// Support: Android 2.3
					// Vendor-prefix box-sizing
					"-webkit-box-sizing:content-box;box-sizing:content-box;" +
					"display:block;margin:0;border:0;padding:0";
				marginDiv.style.marginRight = marginDiv.style.width = "0";
				div.style.width = "1px";
				documentElement.appendChild( container );
	
				ret = !parseFloat( window.getComputedStyle( marginDiv ).marginRight );
	
				documentElement.removeChild( container );
				div.removeChild( marginDiv );
	
				return ret;
			}
		} );
	} )();
	
	
	function curCSS( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,
			style = elem.style;
	
		computed = computed || getStyles( elem );
		ret = computed ? computed.getPropertyValue( name ) || computed[ name ] : undefined;
	
		// Support: Opera 12.1x only
		// Fall back to style even without computed
		// computed is undefined for elems on document fragments
		if ( ( ret === "" || ret === undefined ) && !jQuery.contains( elem.ownerDocument, elem ) ) {
			ret = jQuery.style( elem, name );
		}
	
		// Support: IE9
		// getPropertyValue is only needed for .css('filter') (#12537)
		if ( computed ) {
	
			// A tribute to the "awesome hack by Dean Edwards"
			// Android Browser returns percentage for some values,
			// but width seems to be reliably pixels.
			// This is against the CSSOM draft spec:
			// http://dev.w3.org/csswg/cssom/#resolved-values
			if ( !support.pixelMarginRight() && rnumnonpx.test( ret ) && rmargin.test( name ) ) {
	
				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;
	
				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;
	
				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}
	
		return ret !== undefined ?
	
			// Support: IE9-11+
			// IE returns zIndex value as an integer.
			ret + "" :
			ret;
	}
	
	
	function addGetHookIf( conditionFn, hookFn ) {
	
		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				if ( conditionFn() ) {
	
					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}
	
				// Hook needed; redefine it so that the support test is not executed again.
				return ( this.get = hookFn ).apply( this, arguments );
			}
		};
	}
	
	
	var
	
		// Swappable if display is none or starts with table
		// except "table", "table-cell", or "table-caption"
		// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	
		cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		},
	
		cssPrefixes = [ "Webkit", "O", "Moz", "ms" ],
		emptyStyle = document.createElement( "div" ).style;
	
	// Return a css property mapped to a potentially vendor prefixed property
	function vendorPropName( name ) {
	
		// Shortcut for names that are not vendor prefixed
		if ( name in emptyStyle ) {
			return name;
		}
	
		// Check for vendor prefixed names
		var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
			i = cssPrefixes.length;
	
		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in emptyStyle ) {
				return name;
			}
		}
	}
	
	function setPositiveNumber( elem, value, subtract ) {
	
		// Any relative (+/-) values have already been
		// normalized at this point
		var matches = rcssNum.exec( value );
		return matches ?
	
			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
			value;
	}
	
	function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
		var i = extra === ( isBorderBox ? "border" : "content" ) ?
	
			// If we already have the right measurement, avoid augmentation
			4 :
	
			// Otherwise initialize for horizontal or vertical properties
			name === "width" ? 1 : 0,
	
			val = 0;
	
		for ( ; i < 4; i += 2 ) {
	
			// Both box models exclude margin, so add it if we want it
			if ( extra === "margin" ) {
				val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
			}
	
			if ( isBorderBox ) {
	
				// border-box includes padding, so remove it if we want content
				if ( extra === "content" ) {
					val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}
	
				// At this point, extra isn't border nor margin, so remove border
				if ( extra !== "margin" ) {
					val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			} else {
	
				// At this point, extra isn't content, so add padding
				val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
	
				// At this point, extra isn't content nor padding, so add border
				if ( extra !== "padding" ) {
					val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}
	
		return val;
	}
	
	function getWidthOrHeight( elem, name, extra ) {
	
		// Start with offset property, which is equivalent to the border-box value
		var valueIsBorderBox = true,
			val = name === "width" ? elem.offsetWidth : elem.offsetHeight,
			styles = getStyles( elem ),
			isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";
	
		// Support: IE11 only
		// In IE 11 fullscreen elements inside of an iframe have
		// 100x too small dimensions (gh-1764).
		if ( document.msFullscreenElement && window.top !== window ) {
	
			// Support: IE11 only
			// Running getBoundingClientRect on a disconnected node
			// in IE throws an error.
			if ( elem.getClientRects().length ) {
				val = Math.round( elem.getBoundingClientRect()[ name ] * 100 );
			}
		}
	
		// Some non-html elements return undefined for offsetWidth, so check for null/undefined
		// svg - https://bugzilla.mozilla.org/show_bug.cgi?id=649285
		// MathML - https://bugzilla.mozilla.org/show_bug.cgi?id=491668
		if ( val <= 0 || val == null ) {
	
			// Fall back to computed then uncomputed css if necessary
			val = curCSS( elem, name, styles );
			if ( val < 0 || val == null ) {
				val = elem.style[ name ];
			}
	
			// Computed unit is not pixels. Stop here and return.
			if ( rnumnonpx.test( val ) ) {
				return val;
			}
	
			// Check for style in case a browser which returns unreliable values
			// for getComputedStyle silently falls back to the reliable elem.style
			valueIsBorderBox = isBorderBox &&
				( support.boxSizingReliable() || val === elem.style[ name ] );
	
			// Normalize "", auto, and prepare for extra
			val = parseFloat( val ) || 0;
		}
	
		// Use the active box-sizing model to add/subtract irrelevant styles
		return ( val +
			augmentWidthOrHeight(
				elem,
				name,
				extra || ( isBorderBox ? "border" : "content" ),
				valueIsBorderBox,
				styles
			)
		) + "px";
	}
	
	function showHide( elements, show ) {
		var display, elem, hidden,
			values = [],
			index = 0,
			length = elements.length;
	
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
	
			values[ index ] = dataPriv.get( elem, "olddisplay" );
			display = elem.style.display;
			if ( show ) {
	
				// Reset the inline display of this element to learn if it is
				// being hidden by cascaded rules or not
				if ( !values[ index ] && display === "none" ) {
					elem.style.display = "";
				}
	
				// Set elements which have been overridden with display: none
				// in a stylesheet to whatever the default browser style is
				// for such an element
				if ( elem.style.display === "" && isHidden( elem ) ) {
					values[ index ] = dataPriv.access(
						elem,
						"olddisplay",
						defaultDisplay( elem.nodeName )
					);
				}
			} else {
				hidden = isHidden( elem );
	
				if ( display !== "none" || !hidden ) {
					dataPriv.set(
						elem,
						"olddisplay",
						hidden ? display : jQuery.css( elem, "display" )
					);
				}
			}
		}
	
		// Set the display of most of the elements in a second loop
		// to avoid the constant reflow
		for ( index = 0; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
			if ( !show || elem.style.display === "none" || elem.style.display === "" ) {
				elem.style.display = show ? values[ index ] || "" : "none";
			}
		}
	
		return elements;
	}
	
	jQuery.extend( {
	
		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {
	
						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},
	
		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			"animationIterationCount": true,
			"columnCount": true,
			"fillOpacity": true,
			"flexGrow": true,
			"flexShrink": true,
			"fontWeight": true,
			"lineHeight": true,
			"opacity": true,
			"order": true,
			"orphans": true,
			"widows": true,
			"zIndex": true,
			"zoom": true
		},
	
		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {
			"float": "cssFloat"
		},
	
		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {
	
			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}
	
			// Make sure that we're working with the right name
			var ret, type, hooks,
				origName = jQuery.camelCase( name ),
				style = elem.style;
	
			name = jQuery.cssProps[ origName ] ||
				( jQuery.cssProps[ origName ] = vendorPropName( origName ) || origName );
	
			// Gets hook for the prefixed version, then unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;
	
				// Convert "+=" or "-=" to relative numbers (#7345)
				if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
					value = adjustCSS( elem, name, ret );
	
					// Fixes bug #9237
					type = "number";
				}
	
				// Make sure that null and NaN values aren't set (#7116)
				if ( value == null || value !== value ) {
					return;
				}
	
				// If a number was passed in, add the unit (except for certain CSS properties)
				if ( type === "number" ) {
					value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
				}
	
				// Support: IE9-11+
				// background-* props affect original clone's values
				if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
					style[ name ] = "inherit";
				}
	
				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !( "set" in hooks ) ||
					( value = hooks.set( elem, value, extra ) ) !== undefined ) {
	
					style[ name ] = value;
				}
	
			} else {
	
				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks &&
					( ret = hooks.get( elem, false, extra ) ) !== undefined ) {
	
					return ret;
				}
	
				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},
	
		css: function( elem, name, extra, styles ) {
			var val, num, hooks,
				origName = jQuery.camelCase( name );
	
			// Make sure that we're working with the right name
			name = jQuery.cssProps[ origName ] ||
				( jQuery.cssProps[ origName ] = vendorPropName( origName ) || origName );
	
			// Try prefixed name followed by the unprefixed name
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}
	
			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}
	
			// Convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}
	
			// Make numeric if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || isFinite( num ) ? num || 0 : val;
			}
			return val;
		}
	} );
	
	jQuery.each( [ "height", "width" ], function( i, name ) {
		jQuery.cssHooks[ name ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {
	
					// Certain elements can have dimension info if we invisibly show them
					// but it must have a current display style that would benefit
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
						elem.offsetWidth === 0 ?
							swap( elem, cssShow, function() {
								return getWidthOrHeight( elem, name, extra );
							} ) :
							getWidthOrHeight( elem, name, extra );
				}
			},
	
			set: function( elem, value, extra ) {
				var matches,
					styles = extra && getStyles( elem ),
					subtract = extra && augmentWidthOrHeight(
						elem,
						name,
						extra,
						jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
						styles
					);
	
				// Convert to pixels if value adjustment is needed
				if ( subtract && ( matches = rcssNum.exec( value ) ) &&
					( matches[ 3 ] || "px" ) !== "px" ) {
	
					elem.style[ name ] = value;
					value = jQuery.css( elem, name );
				}
	
				return setPositiveNumber( elem, value, subtract );
			}
		};
	} );
	
	jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
		function( elem, computed ) {
			if ( computed ) {
				return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
					elem.getBoundingClientRect().left -
						swap( elem, { marginLeft: 0 }, function() {
							return elem.getBoundingClientRect().left;
						} )
					) + "px";
			}
		}
	);
	
	// Support: Android 2.3
	jQuery.cssHooks.marginRight = addGetHookIf( support.reliableMarginRight,
		function( elem, computed ) {
			if ( computed ) {
				return swap( elem, { "display": "inline-block" },
					curCSS, [ elem, "marginRight" ] );
			}
		}
	);
	
	// These hooks are used by animate to expand properties
	jQuery.each( {
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
					expanded = {},
	
					// Assumes a single number if not a string
					parts = typeof value === "string" ? value.split( " " ) : [ value ];
	
				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
						parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}
	
				return expanded;
			}
		};
	
		if ( !rmargin.test( prefix ) ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	} );
	
	jQuery.fn.extend( {
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
					map = {},
					i = 0;
	
				if ( jQuery.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;
	
					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}
	
					return map;
				}
	
				return value !== undefined ?
					jQuery.style( elem, name, value ) :
					jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		},
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}
	
			return this.each( function() {
				if ( isHidden( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			} );
		}
	} );
	
	
	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;
	
	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || jQuery.easing._default;
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];
	
			return hooks && hooks.get ?
				hooks.get( this ) :
				Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
				hooks = Tween.propHooks[ this.prop ];
	
			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
					percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;
	
			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}
	
			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};
	
	Tween.prototype.init.prototype = Tween.prototype;
	
	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;
	
				// Use a property on the element directly when it is not a DOM element,
				// or when there is no matching style property that exists.
				if ( tween.elem.nodeType !== 1 ||
					tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
					return tween.elem[ tween.prop ];
				}
	
				// Passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails.
				// Simple values such as "10px" are parsed to Float;
				// complex values such as "rotate(1rad)" are returned as-is.
				result = jQuery.css( tween.elem, tween.prop, "" );
	
				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {
	
				// Use step hook for back compat.
				// Use cssHook if its there.
				// Use .style if available and use plain properties where available.
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.nodeType === 1 &&
					( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
						jQuery.cssHooks[ tween.prop ] ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};
	
	// Support: IE9
	// Panic based approach to setting things on disconnected nodes
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};
	
	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		},
		_default: "swing"
	};
	
	jQuery.fx = Tween.prototype.init;
	
	// Back Compat <1.8 extension point
	jQuery.fx.step = {};
	
	
	
	
	var
		fxNow, timerId,
		rfxtypes = /^(?:toggle|show|hide)$/,
		rrun = /queueHooks$/;
	
	// Animations created synchronously will run synchronously
	function createFxNow() {
		window.setTimeout( function() {
			fxNow = undefined;
		} );
		return ( fxNow = jQuery.now() );
	}
	
	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
			i = 0,
			attrs = { height: type };
	
		// If we include width, step value is 1 to do all cssExpand values,
		// otherwise step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4 ; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}
	
		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}
	
		return attrs;
	}
	
	function createTween( value, prop, animation ) {
		var tween,
			collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
			index = 0,
			length = collection.length;
		for ( ; index < length; index++ ) {
			if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {
	
				// We're done with this property
				return tween;
			}
		}
	}
	
	function defaultPrefilter( elem, props, opts ) {
		/* jshint validthis: true */
		var prop, value, toggle, tween, hooks, oldfire, display, checkDisplay,
			anim = this,
			orig = {},
			style = elem.style,
			hidden = elem.nodeType && isHidden( elem ),
			dataShow = dataPriv.get( elem, "fxshow" );
	
		// Handle queue: false promises
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;
	
			anim.always( function() {
	
				// Ensure the complete handler is called before this completes
				anim.always( function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				} );
			} );
		}
	
		// Height/width overflow pass
		if ( elem.nodeType === 1 && ( "height" in props || "width" in props ) ) {
	
			// Make sure that nothing sneaks out
			// Record all 3 overflow attributes because IE9-10 do not
			// change the overflow attribute when overflowX and
			// overflowY are set to the same value
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
	
			// Set display property to inline-block for height/width
			// animations on inline elements that are having width/height animated
			display = jQuery.css( elem, "display" );
	
			// Test default display if display is currently "none"
			checkDisplay = display === "none" ?
				dataPriv.get( elem, "olddisplay" ) || defaultDisplay( elem.nodeName ) : display;
	
			if ( checkDisplay === "inline" && jQuery.css( elem, "float" ) === "none" ) {
				style.display = "inline-block";
			}
		}
	
		if ( opts.overflow ) {
			style.overflow = "hidden";
			anim.always( function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			} );
		}
	
		// show/hide pass
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.exec( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {
	
					// If there is dataShow left over from a stopped hide or show
					// and we are going to proceed with show, we should pretend to be hidden
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
	
			// Any non-fx value stops us from restoring the original display value
			} else {
				display = undefined;
			}
		}
	
		if ( !jQuery.isEmptyObject( orig ) ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", {} );
			}
	
			// Store state if its toggle - enables .stop().toggle() to "reverse"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}
			if ( hidden ) {
				jQuery( elem ).show();
			} else {
				anim.done( function() {
					jQuery( elem ).hide();
				} );
			}
			anim.done( function() {
				var prop;
	
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
			for ( prop in orig ) {
				tween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
	
				if ( !( prop in dataShow ) ) {
					dataShow[ prop ] = tween.start;
					if ( hidden ) {
						tween.end = tween.start;
						tween.start = prop === "width" || prop === "height" ? 1 : 0;
					}
				}
			}
	
		// If this is a noop like .hide().hide(), restore an overwritten display value
		} else if ( ( display === "none" ? defaultDisplay( elem.nodeName ) : display ) === "inline" ) {
			style.display = display;
		}
	}
	
	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;
	
		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = jQuery.camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( jQuery.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}
	
			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}
	
			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];
	
				// Not quite $.extend, this won't overwrite existing keys.
				// Reusing 'index' because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}
	
	function Animation( elem, properties, options ) {
		var result,
			stopped,
			index = 0,
			length = Animation.prefilters.length,
			deferred = jQuery.Deferred().always( function() {
	
				// Don't match elem in the :animated selector
				delete tick.elem;
			} ),
			tick = function() {
				if ( stopped ) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
					remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
	
					// Support: Android 2.3
					// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
					temp = remaining / animation.duration || 0,
					percent = 1 - temp,
					index = 0,
					length = animation.tweens.length;
	
				for ( ; index < length ; index++ ) {
					animation.tweens[ index ].run( percent );
				}
	
				deferred.notifyWith( elem, [ animation, percent, remaining ] );
	
				if ( percent < 1 && length ) {
					return remaining;
				} else {
					deferred.resolveWith( elem, [ animation ] );
					return false;
				}
			},
			animation = deferred.promise( {
				elem: elem,
				props: jQuery.extend( {}, properties ),
				opts: jQuery.extend( true, {
					specialEasing: {},
					easing: jQuery.easing._default
				}, options ),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function( prop, end ) {
					var tween = jQuery.Tween( elem, animation.opts, prop, end,
							animation.opts.specialEasing[ prop ] || animation.opts.easing );
					animation.tweens.push( tween );
					return tween;
				},
				stop: function( gotoEnd ) {
					var index = 0,
	
						// If we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
					if ( stopped ) {
						return this;
					}
					stopped = true;
					for ( ; index < length ; index++ ) {
						animation.tweens[ index ].run( 1 );
					}
	
					// Resolve when we played the last frame; otherwise, reject
					if ( gotoEnd ) {
						deferred.notifyWith( elem, [ animation, 1, 0 ] );
						deferred.resolveWith( elem, [ animation, gotoEnd ] );
					} else {
						deferred.rejectWith( elem, [ animation, gotoEnd ] );
					}
					return this;
				}
			} ),
			props = animation.props;
	
		propFilter( props, animation.opts.specialEasing );
	
		for ( ; index < length ; index++ ) {
			result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				if ( jQuery.isFunction( result.stop ) ) {
					jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
						jQuery.proxy( result.stop, result );
				}
				return result;
			}
		}
	
		jQuery.map( props, createTween, animation );
	
		if ( jQuery.isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}
	
		jQuery.fx.timer(
			jQuery.extend( tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			} )
		);
	
		// attach callbacks from options
		return animation.progress( animation.opts.progress )
			.done( animation.opts.done, animation.opts.complete )
			.fail( animation.opts.fail )
			.always( animation.opts.always );
	}
	
	jQuery.Animation = jQuery.extend( Animation, {
		tweeners: {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value );
				adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
				return tween;
			} ]
		},
	
		tweener: function( props, callback ) {
			if ( jQuery.isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.match( rnotwhite );
			}
	
			var prop,
				index = 0,
				length = props.length;
	
			for ( ; index < length ; index++ ) {
				prop = props[ index ];
				Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
				Animation.tweeners[ prop ].unshift( callback );
			}
		},
	
		prefilters: [ defaultPrefilter ],
	
		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				Animation.prefilters.unshift( callback );
			} else {
				Animation.prefilters.push( callback );
			}
		}
	} );
	
	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				jQuery.isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
		};
	
		opt.duration = jQuery.fx.off ? 0 : typeof opt.duration === "number" ?
			opt.duration : opt.duration in jQuery.fx.speeds ?
				jQuery.fx.speeds[ opt.duration ] : jQuery.fx.speeds._default;
	
		// Normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}
	
		// Queueing
		opt.old = opt.complete;
	
		opt.complete = function() {
			if ( jQuery.isFunction( opt.old ) ) {
				opt.old.call( this );
			}
	
			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};
	
		return opt;
	};
	
	jQuery.fn.extend( {
		fadeTo: function( speed, to, easing, callback ) {
	
			// Show any hidden elements after setting opacity to 0
			return this.filter( isHidden ).css( "opacity", 0 ).show()
	
				// Animate to the value specified
				.end().animate( { opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
				optall = jQuery.speed( speed, easing, callback ),
				doAnimation = function() {
	
					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation( this, jQuery.extend( {}, prop ), optall );
	
					// Empty animations, or finishing resolves immediately
					if ( empty || dataPriv.get( this, "finish" ) ) {
						anim.stop( true );
					}
				};
				doAnimation.finish = doAnimation;
	
			return empty || optall.queue === false ?
				this.each( doAnimation ) :
				this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};
	
			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue && type !== false ) {
				this.queue( type || "fx", [] );
			}
	
			return this.each( function() {
				var dequeue = true,
					index = type != null && type + "queueHooks",
					timers = jQuery.timers,
					data = dataPriv.get( this );
	
				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}
	
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this &&
						( type == null || timers[ index ].queue === type ) ) {
	
						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}
	
				// Start the next in the queue if the last step wasn't forced.
				// Timers currently will call their complete callbacks, which
				// will dequeue but only if they were gotoEnd.
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			} );
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each( function() {
				var index,
					data = dataPriv.get( this ),
					queue = data[ type + "queue" ],
					hooks = data[ type + "queueHooks" ],
					timers = jQuery.timers,
					length = queue ? queue.length : 0;
	
				// Enable finishing flag on private data
				data.finish = true;
	
				// Empty the queue first
				jQuery.queue( this, type, [] );
	
				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}
	
				// Look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}
	
				// Look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this );
					}
				}
	
				// Turn off finishing flag
				delete data.finish;
			} );
		}
	} );
	
	jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
				cssFn.apply( this, arguments ) :
				this.animate( genFx( name, true ), speed, easing, callback );
		};
	} );
	
	// Generate shortcuts for custom animations
	jQuery.each( {
		slideDown: genFx( "show" ),
		slideUp: genFx( "hide" ),
		slideToggle: genFx( "toggle" ),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	} );
	
	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
			i = 0,
			timers = jQuery.timers;
	
		fxNow = jQuery.now();
	
		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];
	
			// Checks the timer has not already been removed
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}
	
		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};
	
	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		if ( timer() ) {
			jQuery.fx.start();
		} else {
			jQuery.timers.pop();
		}
	};
	
	jQuery.fx.interval = 13;
	jQuery.fx.start = function() {
		if ( !timerId ) {
			timerId = window.setInterval( jQuery.fx.tick, jQuery.fx.interval );
		}
	};
	
	jQuery.fx.stop = function() {
		window.clearInterval( timerId );
	
		timerId = null;
	};
	
	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,
	
		// Default speed
		_default: 400
	};
	
	
	// Based off of the plugin by Clint Helfers, with permission.
	// http://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";
	
		return this.queue( type, function( next, hooks ) {
			var timeout = window.setTimeout( next, time );
			hooks.stop = function() {
				window.clearTimeout( timeout );
			};
		} );
	};
	
	
	( function() {
		var input = document.createElement( "input" ),
			select = document.createElement( "select" ),
			opt = select.appendChild( document.createElement( "option" ) );
	
		input.type = "checkbox";
	
		// Support: iOS<=5.1, Android<=4.2+
		// Default value for a checkbox should be "on"
		support.checkOn = input.value !== "";
	
		// Support: IE<=11+
		// Must access selectedIndex to make default options select
		support.optSelected = opt.selected;
	
		// Support: Android<=2.3
		// Options inside disabled selects are incorrectly marked as disabled
		select.disabled = true;
		support.optDisabled = !opt.disabled;
	
		// Support: IE<=11+
		// An input loses its value after becoming a radio
		input = document.createElement( "input" );
		input.value = "t";
		input.type = "radio";
		support.radioValue = input.value === "t";
	} )();
	
	
	var boolHook,
		attrHandle = jQuery.expr.attrHandle;
	
	jQuery.fn.extend( {
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},
	
		removeAttr: function( name ) {
			return this.each( function() {
				jQuery.removeAttr( this, name );
			} );
		}
	} );
	
	jQuery.extend( {
		attr: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set attributes on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === "undefined" ) {
				return jQuery.prop( elem, name, value );
			}
	
			// All attributes are lowercase
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				name = name.toLowerCase();
				hooks = jQuery.attrHooks[ name ] ||
					( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
			}
	
			if ( value !== undefined ) {
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
					return;
				}
	
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				elem.setAttribute( name, value + "" );
				return value;
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			ret = jQuery.find.attr( elem, name );
	
			// Non-existent attributes return null, we normalize to undefined
			return ret == null ? undefined : ret;
		},
	
		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" &&
						jQuery.nodeName( elem, "input" ) ) {
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		},
	
		removeAttr: function( elem, value ) {
			var name, propName,
				i = 0,
				attrNames = value && value.match( rnotwhite );
	
			if ( attrNames && elem.nodeType === 1 ) {
				while ( ( name = attrNames[ i++ ] ) ) {
					propName = jQuery.propFix[ name ] || name;
	
					// Boolean attributes get special treatment (#10870)
					if ( jQuery.expr.match.bool.test( name ) ) {
	
						// Set corresponding property to false
						elem[ propName ] = false;
					}
	
					elem.removeAttribute( name );
				}
			}
		}
	} );
	
	// Hooks for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {
	
				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else {
				elem.setAttribute( name, name );
			}
			return name;
		}
	};
	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
		var getter = attrHandle[ name ] || jQuery.find.attr;
	
		attrHandle[ name ] = function( elem, name, isXML ) {
			var ret, handle;
			if ( !isXML ) {
	
				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ name ];
				attrHandle[ name ] = ret;
				ret = getter( elem, name, isXML ) != null ?
					name.toLowerCase() :
					null;
				attrHandle[ name ] = handle;
			}
			return ret;
		};
	} );
	
	
	
	
	var rfocusable = /^(?:input|select|textarea|button)$/i,
		rclickable = /^(?:a|area)$/i;
	
	jQuery.fn.extend( {
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},
	
		removeProp: function( name ) {
			return this.each( function() {
				delete this[ jQuery.propFix[ name ] || name ];
			} );
		}
	} );
	
	jQuery.extend( {
		prop: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set properties on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
	
				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}
	
			if ( value !== undefined ) {
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				return ( elem[ name ] = value );
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			return elem[ name ];
		},
	
		propHooks: {
			tabIndex: {
				get: function( elem ) {
	
					// elem.tabIndex doesn't always return the
					// correct value when it hasn't been explicitly set
					// http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
					// Use proper attribute retrieval(#12072)
					var tabindex = jQuery.find.attr( elem, "tabindex" );
	
					return tabindex ?
						parseInt( tabindex, 10 ) :
						rfocusable.test( elem.nodeName ) ||
							rclickable.test( elem.nodeName ) && elem.href ?
								0 :
								-1;
				}
			}
		},
	
		propFix: {
			"for": "htmlFor",
			"class": "className"
		}
	} );
	
	// Support: IE <=11 only
	// Accessing the selectedIndex property
	// forces the browser to respect setting selected
	// on the option
	// The getter ensures a default option is selected
	// when in an optgroup
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {
				var parent = elem.parentNode;
				if ( parent && parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
				return null;
			},
			set: function( elem ) {
				var parent = elem.parentNode;
				if ( parent ) {
					parent.selectedIndex;
	
					if ( parent.parentNode ) {
						parent.parentNode.selectedIndex;
					}
				}
			}
		};
	}
	
	jQuery.each( [
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	} );
	
	
	
	
	var rclass = /[\t\r\n\f]/g;
	
	function getClass( elem ) {
		return elem.getAttribute && elem.getAttribute( "class" ) || "";
	}
	
	jQuery.fn.extend( {
		addClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( typeof value === "string" && value ) {
				classes = value.match( rnotwhite ) || [];
	
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
					cur = elem.nodeType === 1 &&
						( " " + curValue + " " ).replace( rclass, " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
							if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
								cur += clazz + " ";
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = jQuery.trim( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		removeClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( !arguments.length ) {
				return this.attr( "class", "" );
			}
	
			if ( typeof value === "string" && value ) {
				classes = value.match( rnotwhite ) || [];
	
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
	
					// This expression is here for better compressibility (see addClass)
					cur = elem.nodeType === 1 &&
						( " " + curValue + " " ).replace( rclass, " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
	
							// Remove *all* instances
							while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
								cur = cur.replace( " " + clazz + " ", " " );
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = jQuery.trim( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		toggleClass: function( value, stateVal ) {
			var type = typeof value;
	
			if ( typeof stateVal === "boolean" && type === "string" ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( i ) {
					jQuery( this ).toggleClass(
						value.call( this, i, getClass( this ), stateVal ),
						stateVal
					);
				} );
			}
	
			return this.each( function() {
				var className, i, self, classNames;
	
				if ( type === "string" ) {
	
					// Toggle individual class names
					i = 0;
					self = jQuery( this );
					classNames = value.match( rnotwhite ) || [];
	
					while ( ( className = classNames[ i++ ] ) ) {
	
						// Check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}
	
				// Toggle whole class name
				} else if ( value === undefined || type === "boolean" ) {
					className = getClass( this );
					if ( className ) {
	
						// Store className if set
						dataPriv.set( this, "__className__", className );
					}
	
					// If the element has a class name or if we're passed `false`,
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					if ( this.setAttribute ) {
						this.setAttribute( "class",
							className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
						);
					}
				}
			} );
		},
	
		hasClass: function( selector ) {
			var className, elem,
				i = 0;
	
			className = " " + selector + " ";
			while ( ( elem = this[ i++ ] ) ) {
				if ( elem.nodeType === 1 &&
					( " " + getClass( elem ) + " " ).replace( rclass, " " )
						.indexOf( className ) > -1
				) {
					return true;
				}
			}
	
			return false;
		}
	} );
	
	
	
	
	var rreturn = /\r/g,
		rspaces = /[\x20\t\r\n\f]+/g;
	
	jQuery.fn.extend( {
		val: function( value ) {
			var hooks, ret, isFunction,
				elem = this[ 0 ];
	
			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] ||
						jQuery.valHooks[ elem.nodeName.toLowerCase() ];
	
					if ( hooks &&
						"get" in hooks &&
						( ret = hooks.get( elem, "value" ) ) !== undefined
					) {
						return ret;
					}
	
					ret = elem.value;
	
					return typeof ret === "string" ?
	
						// Handle most common string cases
						ret.replace( rreturn, "" ) :
	
						// Handle cases where value is null/undef or number
						ret == null ? "" : ret;
				}
	
				return;
			}
	
			isFunction = jQuery.isFunction( value );
	
			return this.each( function( i ) {
				var val;
	
				if ( this.nodeType !== 1 ) {
					return;
				}
	
				if ( isFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}
	
				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";
	
				} else if ( typeof val === "number" ) {
					val += "";
	
				} else if ( jQuery.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					} );
				}
	
				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
	
				// If set returns undefined, fall back to normal setting
				if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			} );
		}
	} );
	
	jQuery.extend( {
		valHooks: {
			option: {
				get: function( elem ) {
	
					var val = jQuery.find.attr( elem, "value" );
					return val != null ?
						val :
	
						// Support: IE10-11+
						// option.text throws exceptions (#14686, #14858)
						// Strip and collapse whitespace
						// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
						jQuery.trim( jQuery.text( elem ) ).replace( rspaces, " " );
				}
			},
			select: {
				get: function( elem ) {
					var value, option,
						options = elem.options,
						index = elem.selectedIndex,
						one = elem.type === "select-one" || index < 0,
						values = one ? null : [],
						max = one ? index + 1 : options.length,
						i = index < 0 ?
							max :
							one ? index : 0;
	
					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];
	
						// IE8-9 doesn't update selected after form reset (#2551)
						if ( ( option.selected || i === index ) &&
	
								// Don't return options that are disabled or in a disabled optgroup
								( support.optDisabled ?
									!option.disabled : option.getAttribute( "disabled" ) === null ) &&
								( !option.parentNode.disabled ||
									!jQuery.nodeName( option.parentNode, "optgroup" ) ) ) {
	
							// Get the specific value for the option
							value = jQuery( option ).val();
	
							// We don't need an array for one selects
							if ( one ) {
								return value;
							}
	
							// Multi-Selects return an array
							values.push( value );
						}
					}
	
					return values;
				},
	
				set: function( elem, value ) {
					var optionSet, option,
						options = elem.options,
						values = jQuery.makeArray( value ),
						i = options.length;
	
					while ( i-- ) {
						option = options[ i ];
						if ( option.selected =
							jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
						) {
							optionSet = true;
						}
					}
	
					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
					return values;
				}
			}
		}
	} );
	
	// Radios and checkboxes getter/setter
	jQuery.each( [ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( jQuery.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				return elem.getAttribute( "value" ) === null ? "on" : elem.value;
			};
		}
	} );
	
	
	
	
	// Return jQuery for attributes-only inclusion
	
	
	var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/;
	
	jQuery.extend( jQuery.event, {
	
		trigger: function( event, data, elem, onlyHandlers ) {
	
			var i, cur, tmp, bubbleType, ontype, handle, special,
				eventPath = [ elem || document ],
				type = hasOwn.call( event, "type" ) ? event.type : event,
				namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];
	
			cur = tmp = elem = elem || document;
	
			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}
	
			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}
	
			if ( type.indexOf( "." ) > -1 ) {
	
				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split( "." );
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf( ":" ) < 0 && "on" + type;
	
			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
				event :
				new jQuery.Event( type, typeof event === "object" && event );
	
			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join( "." );
			event.rnamespace = event.namespace ?
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
				null;
	
			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}
	
			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
				[ event ] :
				jQuery.makeArray( data, [ event ] );
	
			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}
	
			// Determine event propagation path in advance, per W3C events spec (#9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
			if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {
	
				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}
	
				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === ( elem.ownerDocument || document ) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}
	
			// Fire handlers on the event path
			i = 0;
			while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
	
				event.type = i > 1 ?
					bubbleType :
					special.bindType || type;
	
				// jQuery handler
				handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
					dataPriv.get( cur, "handle" );
				if ( handle ) {
					handle.apply( cur, data );
				}
	
				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;
	
			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {
	
				if ( ( !special._default ||
					special._default.apply( eventPath.pop(), data ) === false ) &&
					acceptData( elem ) ) {
	
					// Call a native DOM method on the target with the same name name as the event.
					// Don't do default actions on window, that's where global variables be (#6170)
					if ( ontype && jQuery.isFunction( elem[ type ] ) && !jQuery.isWindow( elem ) ) {
	
						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];
	
						if ( tmp ) {
							elem[ ontype ] = null;
						}
	
						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;
						elem[ type ]();
						jQuery.event.triggered = undefined;
	
						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}
	
			return event.result;
		},
	
		// Piggyback on a donor event to simulate a different one
		simulate: function( type, elem, event ) {
			var e = jQuery.extend(
				new jQuery.Event(),
				event,
				{
					type: type,
					isSimulated: true
	
					// Previously, `originalEvent: {}` was set here, so stopPropagation call
					// would not be triggered on donor event, since in our own
					// jQuery.event.stopPropagation function we had a check for existence of
					// originalEvent.stopPropagation method, so, consequently it would be a noop.
					//
					// But now, this "simulate" function is used only for events
					// for which stopPropagation() is noop, so there is no need for that anymore.
					//
					// For the 1.x branch though, guard for "click" and "submit"
					// events is still used, but was moved to jQuery.event.stopPropagation function
					// because `originalEvent` should point to the original event for the constancy
					// with other events and for more focused logic
				}
			);
	
			jQuery.event.trigger( e, null, elem );
	
			if ( e.isDefaultPrevented() ) {
				event.preventDefault();
			}
		}
	
	} );
	
	jQuery.fn.extend( {
	
		trigger: function( type, data ) {
			return this.each( function() {
				jQuery.event.trigger( type, data, this );
			} );
		},
		triggerHandler: function( type, data ) {
			var elem = this[ 0 ];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	} );
	
	
	jQuery.each( ( "blur focus focusin focusout load resize scroll unload click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup error contextmenu" ).split( " " ),
		function( i, name ) {
	
		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	} );
	
	jQuery.fn.extend( {
		hover: function( fnOver, fnOut ) {
			return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
		}
	} );
	
	
	
	
	support.focusin = "onfocusin" in window;
	
	
	// Support: Firefox
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome, Safari
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://code.google.com/p/chromium/issues/detail?id=449857
	if ( !support.focusin ) {
		jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {
	
			// Attach a single capturing handler on the document while someone wants focusin/focusout
			var handler = function( event ) {
				jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
			};
	
			jQuery.event.special[ fix ] = {
				setup: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix );
	
					if ( !attaches ) {
						doc.addEventListener( orig, handler, true );
					}
					dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
				},
				teardown: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix ) - 1;
	
					if ( !attaches ) {
						doc.removeEventListener( orig, handler, true );
						dataPriv.remove( doc, fix );
	
					} else {
						dataPriv.access( doc, fix, attaches );
					}
				}
			};
		} );
	}
	var location = window.location;
	
	var nonce = jQuery.now();
	
	var rquery = ( /\?/ );
	
	
	
	// Support: Android 2.3
	// Workaround failure to string-cast null input
	jQuery.parseJSON = function( data ) {
		return JSON.parse( data + "" );
	};
	
	
	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml;
		if ( !data || typeof data !== "string" ) {
			return null;
		}
	
		// Support: IE9
		try {
			xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
		} catch ( e ) {
			xml = undefined;
		}
	
		if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
			jQuery.error( "Invalid XML: " + data );
		}
		return xml;
	};
	
	
	var
		rhash = /#.*$/,
		rts = /([?&])_=[^&]*/,
		rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
	
		// #7653, #8125, #8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		rnoContent = /^(?:GET|HEAD)$/,
		rprotocol = /^\/\//,
	
		/* Prefilters
		 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		 * 2) These are called:
		 *    - BEFORE asking for a transport
		 *    - AFTER param serialization (s.data is a string if s.processData is true)
		 * 3) key is the dataType
		 * 4) the catchall symbol "*" can be used
		 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
		 */
		prefilters = {},
	
		/* Transports bindings
		 * 1) key is the dataType
		 * 2) the catchall symbol "*" can be used
		 * 3) selection will start with transport dataType and THEN go to "*" if needed
		 */
		transports = {},
	
		// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
		allTypes = "*/".concat( "*" ),
	
		// Anchor tag for parsing the document origin
		originAnchor = document.createElement( "a" );
		originAnchor.href = location.href;
	
	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {
	
		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {
	
			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}
	
			var dataType,
				i = 0,
				dataTypes = dataTypeExpression.toLowerCase().match( rnotwhite ) || [];
	
			if ( jQuery.isFunction( func ) ) {
	
				// For each dataType in the dataTypeExpression
				while ( ( dataType = dataTypes[ i++ ] ) ) {
	
					// Prepend if requested
					if ( dataType[ 0 ] === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );
	
					// Otherwise append
					} else {
						( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
					}
				}
			}
		};
	}
	
	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
	
		var inspected = {},
			seekingTransport = ( structure === transports );
	
		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" &&
					!seekingTransport && !inspected[ dataTypeOrTransport ] ) {
	
					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			} );
			return selected;
		}
	
		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}
	
	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes #9887
	function ajaxExtend( target, src ) {
		var key, deep,
			flatOptions = jQuery.ajaxSettings.flatOptions || {};
	
		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}
	
		return target;
	}
	
	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {
	
		var ct, type, finalDataType, firstDataType,
			contents = s.contents,
			dataTypes = s.dataTypes;
	
		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
			}
		}
	
		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}
	
		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {
	
			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}
	
			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}
	
		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}
	
	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
			converters = {},
	
			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();
	
		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}
	
		current = dataTypes.shift();
	
		// Convert to each sequential dataType
		while ( current ) {
	
			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}
	
			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}
	
			prev = current;
			current = dataTypes.shift();
	
			if ( current ) {
	
			// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {
	
					current = prev;
	
				// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {
	
					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];
	
					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {
	
							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {
	
								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
									converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {
	
									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];
	
									// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}
	
					// Apply converter (if not an equivalence)
					if ( conv !== true ) {
	
						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s.throws ) {
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return {
									state: "parsererror",
									error: conv ? e : "No conversion from " + prev + " to " + current
								};
							}
						}
					}
				}
			}
		}
	
		return { state: "success", data: response };
	}
	
	jQuery.extend( {
	
		// Counter for holding the number of active queries
		active: 0,
	
		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},
	
		ajaxSettings: {
			url: location.href,
			type: "GET",
			isLocal: rlocalProtocol.test( location.protocol ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",
			/*
			timeout: 0,
			data: null,
			dataType: null,
			username: null,
			password: null,
			cache: null,
			throws: false,
			traditional: false,
			headers: {},
			*/
	
			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},
	
			contents: {
				xml: /\bxml\b/,
				html: /\bhtml/,
				json: /\bjson\b/
			},
	
			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},
	
			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {
	
				// Convert anything to text
				"* text": String,
	
				// Text to html (true = no transformation)
				"text html": true,
	
				// Evaluate text as a json expression
				"text json": jQuery.parseJSON,
	
				// Parse text as xml
				"text xml": jQuery.parseXML
			},
	
			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},
	
		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?
	
				// Building a settings object
				ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
	
				// Extending ajaxSettings
				ajaxExtend( jQuery.ajaxSettings, target );
		},
	
		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),
	
		// Main method
		ajax: function( url, options ) {
	
			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}
	
			// Force options to be an object
			options = options || {};
	
			var transport,
	
				// URL without anti-cache param
				cacheURL,
	
				// Response headers
				responseHeadersString,
				responseHeaders,
	
				// timeout handle
				timeoutTimer,
	
				// Url cleanup var
				urlAnchor,
	
				// To know if global events are to be dispatched
				fireGlobals,
	
				// Loop variable
				i,
	
				// Create the final options object
				s = jQuery.ajaxSetup( {}, options ),
	
				// Callbacks context
				callbackContext = s.context || s,
	
				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context &&
					( callbackContext.nodeType || callbackContext.jquery ) ?
						jQuery( callbackContext ) :
						jQuery.event,
	
				// Deferreds
				deferred = jQuery.Deferred(),
				completeDeferred = jQuery.Callbacks( "once memory" ),
	
				// Status-dependent callbacks
				statusCode = s.statusCode || {},
	
				// Headers (they are sent all at once)
				requestHeaders = {},
				requestHeadersNames = {},
	
				// The jqXHR state
				state = 0,
	
				// Default abort message
				strAbort = "canceled",
	
				// Fake xhr
				jqXHR = {
					readyState: 0,
	
					// Builds headers hashtable if needed
					getResponseHeader: function( key ) {
						var match;
						if ( state === 2 ) {
							if ( !responseHeaders ) {
								responseHeaders = {};
								while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
									responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
								}
							}
							match = responseHeaders[ key.toLowerCase() ];
						}
						return match == null ? null : match;
					},
	
					// Raw string
					getAllResponseHeaders: function() {
						return state === 2 ? responseHeadersString : null;
					},
	
					// Caches the header
					setRequestHeader: function( name, value ) {
						var lname = name.toLowerCase();
						if ( !state ) {
							name = requestHeadersNames[ lname ] = requestHeadersNames[ lname ] || name;
							requestHeaders[ name ] = value;
						}
						return this;
					},
	
					// Overrides response content-type header
					overrideMimeType: function( type ) {
						if ( !state ) {
							s.mimeType = type;
						}
						return this;
					},
	
					// Status-dependent callbacks
					statusCode: function( map ) {
						var code;
						if ( map ) {
							if ( state < 2 ) {
								for ( code in map ) {
	
									// Lazy-add the new callback in a way that preserves old ones
									statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
								}
							} else {
	
								// Execute the appropriate callbacks
								jqXHR.always( map[ jqXHR.status ] );
							}
						}
						return this;
					},
	
					// Cancel the request
					abort: function( statusText ) {
						var finalText = statusText || strAbort;
						if ( transport ) {
							transport.abort( finalText );
						}
						done( 0, finalText );
						return this;
					}
				};
	
			// Attach deferreds
			deferred.promise( jqXHR ).complete = completeDeferred.add;
			jqXHR.success = jqXHR.done;
			jqXHR.error = jqXHR.fail;
	
			// Remove hash character (#7531: and string promotion)
			// Add protocol if not provided (prefilters might expect it)
			// Handle falsy url in the settings object (#10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || location.href ) + "" ).replace( rhash, "" )
				.replace( rprotocol, location.protocol + "//" );
	
			// Alias method option to type as per ticket #12004
			s.type = options.method || options.type || s.method || s.type;
	
			// Extract dataTypes list
			s.dataTypes = jQuery.trim( s.dataType || "*" ).toLowerCase().match( rnotwhite ) || [ "" ];
	
			// A cross-domain request is in order when the origin doesn't match the current origin.
			if ( s.crossDomain == null ) {
				urlAnchor = document.createElement( "a" );
	
				// Support: IE8-11+
				// IE throws exception if url is malformed, e.g. http://example.com:80x/
				try {
					urlAnchor.href = s.url;
	
					// Support: IE8-11+
					// Anchor's host property isn't correctly set when s.url is relative
					urlAnchor.href = urlAnchor.href;
					s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
						urlAnchor.protocol + "//" + urlAnchor.host;
				} catch ( e ) {
	
					// If there is an error parsing the URL, assume it is crossDomain,
					// it can be rejected by the transport if it is invalid
					s.crossDomain = true;
				}
			}
	
			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}
	
			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
	
			// If request was aborted inside a prefilter, stop there
			if ( state === 2 ) {
				return jqXHR;
			}
	
			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
			fireGlobals = jQuery.event && s.global;
	
			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger( "ajaxStart" );
			}
	
			// Uppercase the type
			s.type = s.type.toUpperCase();
	
			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );
	
			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			cacheURL = s.url;
	
			// More options handling for requests with no content
			if ( !s.hasContent ) {
	
				// If data is available, append data to url
				if ( s.data ) {
					cacheURL = ( s.url += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data );
	
					// #9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}
	
				// Add anti-cache in url if needed
				if ( s.cache === false ) {
					s.url = rts.test( cacheURL ) ?
	
						// If there is already a '_' parameter, set its value
						cacheURL.replace( rts, "$1_=" + nonce++ ) :
	
						// Otherwise add one to the end
						cacheURL + ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + nonce++;
				}
			}
	
			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}
	
			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}
	
			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
				"Accept",
				s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
					s.accepts[ s.dataTypes[ 0 ] ] +
						( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
					s.accepts[ "*" ]
			);
	
			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}
	
			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend &&
				( s.beforeSend.call( callbackContext, jqXHR, s ) === false || state === 2 ) ) {
	
				// Abort if not done already and return
				return jqXHR.abort();
			}
	
			// Aborting is no longer a cancellation
			strAbort = "abort";
	
			// Install callbacks on deferreds
			for ( i in { success: 1, error: 1, complete: 1 } ) {
				jqXHR[ i ]( s[ i ] );
			}
	
			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
	
			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;
	
				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}
	
				// If request was aborted inside ajaxSend, stop there
				if ( state === 2 ) {
					return jqXHR;
				}
	
				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = window.setTimeout( function() {
						jqXHR.abort( "timeout" );
					}, s.timeout );
				}
	
				try {
					state = 1;
					transport.send( requestHeaders, done );
				} catch ( e ) {
	
					// Propagate exception as error if not done
					if ( state < 2 ) {
						done( -1, e );
	
					// Simply rethrow otherwise
					} else {
						throw e;
					}
				}
			}
	
			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
					statusText = nativeStatusText;
	
				// Called once
				if ( state === 2 ) {
					return;
				}
	
				// State is "done" now
				state = 2;
	
				// Clear timeout if it exists
				if ( timeoutTimer ) {
					window.clearTimeout( timeoutTimer );
				}
	
				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;
	
				// Cache response headers
				responseHeadersString = headers || "";
	
				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;
	
				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;
	
				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}
	
				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );
	
				// If successful, handle type chaining
				if ( isSuccess ) {
	
					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader( "Last-Modified" );
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader( "etag" );
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}
	
					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";
	
					// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";
	
					// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {
	
					// Extract error from statusText and normalize for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}
	
				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";
	
				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}
	
				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;
	
				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
						[ jqXHR, s, isSuccess ? success : error ] );
				}
	
				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
	
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
	
					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger( "ajaxStop" );
					}
				}
			}
	
			return jqXHR;
		},
	
		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},
	
		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	} );
	
	jQuery.each( [ "get", "post" ], function( i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {
	
			// Shift arguments if data argument was omitted
			if ( jQuery.isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}
	
			// The url can be an options object (which then must have .url)
			return jQuery.ajax( jQuery.extend( {
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			}, jQuery.isPlainObject( url ) && url ) );
		};
	} );
	
	
	jQuery._evalUrl = function( url ) {
		return jQuery.ajax( {
			url: url,
	
			// Make this explicit, since user can override this through ajaxSetup (#11264)
			type: "GET",
			dataType: "script",
			async: false,
			global: false,
			"throws": true
		} );
	};
	
	
	jQuery.fn.extend( {
		wrapAll: function( html ) {
			var wrap;
	
			if ( jQuery.isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapAll( html.call( this, i ) );
				} );
			}
	
			if ( this[ 0 ] ) {
	
				// The elements to wrap the target around
				wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );
	
				if ( this[ 0 ].parentNode ) {
					wrap.insertBefore( this[ 0 ] );
				}
	
				wrap.map( function() {
					var elem = this;
	
					while ( elem.firstElementChild ) {
						elem = elem.firstElementChild;
					}
	
					return elem;
				} ).append( this );
			}
	
			return this;
		},
	
		wrapInner: function( html ) {
			if ( jQuery.isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapInner( html.call( this, i ) );
				} );
			}
	
			return this.each( function() {
				var self = jQuery( this ),
					contents = self.contents();
	
				if ( contents.length ) {
					contents.wrapAll( html );
	
				} else {
					self.append( html );
				}
			} );
		},
	
		wrap: function( html ) {
			var isFunction = jQuery.isFunction( html );
	
			return this.each( function( i ) {
				jQuery( this ).wrapAll( isFunction ? html.call( this, i ) : html );
			} );
		},
	
		unwrap: function() {
			return this.parent().each( function() {
				if ( !jQuery.nodeName( this, "body" ) ) {
					jQuery( this ).replaceWith( this.childNodes );
				}
			} ).end();
		}
	} );
	
	
	jQuery.expr.filters.hidden = function( elem ) {
		return !jQuery.expr.filters.visible( elem );
	};
	jQuery.expr.filters.visible = function( elem ) {
	
		// Support: Opera <= 12.12
		// Opera reports offsetWidths and offsetHeights less than zero on some elements
		// Use OR instead of AND as the element is not visible if either is true
		// See tickets #10406 and #13132
		return elem.offsetWidth > 0 || elem.offsetHeight > 0 || elem.getClientRects().length > 0;
	};
	
	
	
	
	var r20 = /%20/g,
		rbracket = /\[\]$/,
		rCRLF = /\r?\n/g,
		rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		rsubmittable = /^(?:input|select|textarea|keygen)/i;
	
	function buildParams( prefix, obj, traditional, add ) {
		var name;
	
		if ( jQuery.isArray( obj ) ) {
	
			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {
	
					// Treat each array item as a scalar.
					add( prefix, v );
	
				} else {
	
					// Item is non-scalar (array or object), encode its numeric index.
					buildParams(
						prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
						v,
						traditional,
						add
					);
				}
			} );
	
		} else if ( !traditional && jQuery.type( obj ) === "object" ) {
	
			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}
	
		} else {
	
			// Serialize scalar item.
			add( prefix, obj );
		}
	}
	
	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
			s = [],
			add = function( key, value ) {
	
				// If value is a function, invoke it and return its value
				value = jQuery.isFunction( value ) ? value() : ( value == null ? "" : value );
				s[ s.length ] = encodeURIComponent( key ) + "=" + encodeURIComponent( value );
			};
	
		// Set traditional to true for jQuery <= 1.3.2 behavior.
		if ( traditional === undefined ) {
			traditional = jQuery.ajaxSettings && jQuery.ajaxSettings.traditional;
		}
	
		// If an array was passed in, assume that it is an array of form elements.
		if ( jQuery.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
	
			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			} );
	
		} else {
	
			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}
	
		// Return the resulting serialization
		return s.join( "&" ).replace( r20, "+" );
	};
	
	jQuery.fn.extend( {
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map( function() {
	
				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			} )
			.filter( function() {
				var type = this.type;
	
				// Use .is( ":disabled" ) so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
					rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
					( this.checked || !rcheckableType.test( type ) );
			} )
			.map( function( i, elem ) {
				var val = jQuery( this ).val();
	
				return val == null ?
					null :
					jQuery.isArray( val ) ?
						jQuery.map( val, function( val ) {
							return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
						} ) :
						{ name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			} ).get();
		}
	} );
	
	
	jQuery.ajaxSettings.xhr = function() {
		try {
			return new window.XMLHttpRequest();
		} catch ( e ) {}
	};
	
	var xhrSuccessStatus = {
	
			// File protocol always yields status code 0, assume 200
			0: 200,
	
			// Support: IE9
			// #1450: sometimes IE returns 1223 when it should be 204
			1223: 204
		},
		xhrSupported = jQuery.ajaxSettings.xhr();
	
	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	support.ajax = xhrSupported = !!xhrSupported;
	
	jQuery.ajaxTransport( function( options ) {
		var callback, errorCallback;
	
		// Cross domain only allowed if supported through XMLHttpRequest
		if ( support.cors || xhrSupported && !options.crossDomain ) {
			return {
				send: function( headers, complete ) {
					var i,
						xhr = options.xhr();
	
					xhr.open(
						options.type,
						options.url,
						options.async,
						options.username,
						options.password
					);
	
					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}
	
					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}
	
					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
						headers[ "X-Requested-With" ] = "XMLHttpRequest";
					}
	
					// Set headers
					for ( i in headers ) {
						xhr.setRequestHeader( i, headers[ i ] );
					}
	
					// Callback
					callback = function( type ) {
						return function() {
							if ( callback ) {
								callback = errorCallback = xhr.onload =
									xhr.onerror = xhr.onabort = xhr.onreadystatechange = null;
	
								if ( type === "abort" ) {
									xhr.abort();
								} else if ( type === "error" ) {
	
									// Support: IE9
									// On a manual native abort, IE9 throws
									// errors on any property access that is not readyState
									if ( typeof xhr.status !== "number" ) {
										complete( 0, "error" );
									} else {
										complete(
	
											// File: protocol always yields status 0; see #8605, #14207
											xhr.status,
											xhr.statusText
										);
									}
								} else {
									complete(
										xhrSuccessStatus[ xhr.status ] || xhr.status,
										xhr.statusText,
	
										// Support: IE9 only
										// IE9 has no XHR2 but throws on binary (trac-11426)
										// For XHR2 non-text, let the caller handle it (gh-2498)
										( xhr.responseType || "text" ) !== "text"  ||
										typeof xhr.responseText !== "string" ?
											{ binary: xhr.response } :
											{ text: xhr.responseText },
										xhr.getAllResponseHeaders()
									);
								}
							}
						};
					};
	
					// Listen to events
					xhr.onload = callback();
					errorCallback = xhr.onerror = callback( "error" );
	
					// Support: IE9
					// Use onreadystatechange to replace onabort
					// to handle uncaught aborts
					if ( xhr.onabort !== undefined ) {
						xhr.onabort = errorCallback;
					} else {
						xhr.onreadystatechange = function() {
	
							// Check readyState before timeout as it changes
							if ( xhr.readyState === 4 ) {
	
								// Allow onerror to be called first,
								// but that will not handle a native abort
								// Also, save errorCallback to a variable
								// as xhr.onerror cannot be accessed
								window.setTimeout( function() {
									if ( callback ) {
										errorCallback();
									}
								} );
							}
						};
					}
	
					// Create the abort callback
					callback = callback( "abort" );
	
					try {
	
						// Do send the request (this may raise an exception)
						xhr.send( options.hasContent && options.data || null );
					} catch ( e ) {
	
						// #14683: Only rethrow if this hasn't been notified as an error yet
						if ( callback ) {
							throw e;
						}
					}
				},
	
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	// Install script dataType
	jQuery.ajaxSetup( {
		accepts: {
			script: "text/javascript, application/javascript, " +
				"application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /\b(?:java|ecma)script\b/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	} );
	
	// Handle cache's special case and crossDomain
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
		}
	} );
	
	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {
	
		// This transport only deals with cross domain requests
		if ( s.crossDomain ) {
			var script, callback;
			return {
				send: function( _, complete ) {
					script = jQuery( "<script>" ).prop( {
						charset: s.scriptCharset,
						src: s.url
					} ).on(
						"load error",
						callback = function( evt ) {
							script.remove();
							callback = null;
							if ( evt ) {
								complete( evt.type === "error" ? 404 : 200, evt.type );
							}
						}
					);
	
					// Use native DOM manipulation to avoid our domManip AJAX trickery
					document.head.appendChild( script[ 0 ] );
				},
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	var oldCallbacks = [],
		rjsonp = /(=)\?(?=&|$)|\?\?/;
	
	// Default jsonp settings
	jQuery.ajaxSetup( {
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
			this[ callback ] = true;
			return callback;
		}
	} );
	
	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
	
		var callbackName, overwritten, responseContainer,
			jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
				"url" :
				typeof s.data === "string" &&
					( s.contentType || "" )
						.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
					rjsonp.test( s.data ) && "data"
			);
	
		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
	
			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
				s.jsonpCallback() :
				s.jsonpCallback;
	
			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}
	
			// Use data converter to retrieve json after script execution
			s.converters[ "script json" ] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};
	
			// Force json dataType
			s.dataTypes[ 0 ] = "json";
	
			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};
	
			// Clean-up function (fires after converters)
			jqXHR.always( function() {
	
				// If previous value didn't exist - remove it
				if ( overwritten === undefined ) {
					jQuery( window ).removeProp( callbackName );
	
				// Otherwise restore preexisting value
				} else {
					window[ callbackName ] = overwritten;
				}
	
				// Save back as free
				if ( s[ callbackName ] ) {
	
					// Make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;
	
					// Save the callback name for future use
					oldCallbacks.push( callbackName );
				}
	
				// Call if it was a function and we have a response
				if ( responseContainer && jQuery.isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}
	
				responseContainer = overwritten = undefined;
			} );
	
			// Delegate to script
			return "script";
		}
	} );
	
	
	
	
	// Argument "data" should be string of html
	// context (optional): If specified, the fragment will be created in this context,
	// defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( !data || typeof data !== "string" ) {
			return null;
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}
		context = context || document;
	
		var parsed = rsingleTag.exec( data ),
			scripts = !keepScripts && [];
	
		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[ 1 ] ) ];
		}
	
		parsed = buildFragment( [ data ], context, scripts );
	
		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}
	
		return jQuery.merge( [], parsed.childNodes );
	};
	
	
	// Keep a copy of the old load method
	var _load = jQuery.fn.load;
	
	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		if ( typeof url !== "string" && _load ) {
			return _load.apply( this, arguments );
		}
	
		var selector, type, response,
			self = this,
			off = url.indexOf( " " );
	
		if ( off > -1 ) {
			selector = jQuery.trim( url.slice( off ) );
			url = url.slice( 0, off );
		}
	
		// If it's a function
		if ( jQuery.isFunction( params ) ) {
	
			// We assume that it's the callback
			callback = params;
			params = undefined;
	
		// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}
	
		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax( {
				url: url,
	
				// If "type" variable is undefined, then "GET" method will be used.
				// Make value of this field explicit since
				// user can override it through ajaxSetup method
				type: type || "GET",
				dataType: "html",
				data: params
			} ).done( function( responseText ) {
	
				// Save response for use in complete callback
				response = arguments;
	
				self.html( selector ?
	
					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :
	
					// Otherwise use the full result
					responseText );
	
			// If the request succeeds, this function gets "data", "status", "jqXHR"
			// but they are ignored because response was set above.
			// If it fails, this function gets "jqXHR", "status", "error"
			} ).always( callback && function( jqXHR, status ) {
				self.each( function() {
					callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
				} );
			} );
		}
	
		return this;
	};
	
	
	
	
	// Attach a bunch of functions for handling common AJAX events
	jQuery.each( [
		"ajaxStart",
		"ajaxStop",
		"ajaxComplete",
		"ajaxError",
		"ajaxSuccess",
		"ajaxSend"
	], function( i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	} );
	
	
	
	
	jQuery.expr.filters.animated = function( elem ) {
		return jQuery.grep( jQuery.timers, function( fn ) {
			return elem === fn.elem;
		} ).length;
	};
	
	
	
	
	/**
	 * Gets a window from an element
	 */
	function getWindow( elem ) {
		return jQuery.isWindow( elem ) ? elem : elem.nodeType === 9 && elem.defaultView;
	}
	
	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
				position = jQuery.css( elem, "position" ),
				curElem = jQuery( elem ),
				props = {};
	
			// Set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}
	
			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
				( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;
	
			// Need to be able to calculate position if either
			// top or left is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;
	
			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}
	
			if ( jQuery.isFunction( options ) ) {
	
				// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
				options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
			}
	
			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}
	
			if ( "using" in options ) {
				options.using.call( elem, props );
	
			} else {
				curElem.css( props );
			}
		}
	};
	
	jQuery.fn.extend( {
		offset: function( options ) {
			if ( arguments.length ) {
				return options === undefined ?
					this :
					this.each( function( i ) {
						jQuery.offset.setOffset( this, options, i );
					} );
			}
	
			var docElem, win,
				elem = this[ 0 ],
				box = { top: 0, left: 0 },
				doc = elem && elem.ownerDocument;
	
			if ( !doc ) {
				return;
			}
	
			docElem = doc.documentElement;
	
			// Make sure it's not a disconnected DOM node
			if ( !jQuery.contains( docElem, elem ) ) {
				return box;
			}
	
			box = elem.getBoundingClientRect();
			win = getWindow( doc );
			return {
				top: box.top + win.pageYOffset - docElem.clientTop,
				left: box.left + win.pageXOffset - docElem.clientLeft
			};
		},
	
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}
	
			var offsetParent, offset,
				elem = this[ 0 ],
				parentOffset = { top: 0, left: 0 };
	
			// Fixed elements are offset from window (parentOffset = {top:0, left: 0},
			// because it is its only offset parent
			if ( jQuery.css( elem, "position" ) === "fixed" ) {
	
				// Assume getBoundingClientRect is there when computed position is fixed
				offset = elem.getBoundingClientRect();
	
			} else {
	
				// Get *real* offsetParent
				offsetParent = this.offsetParent();
	
				// Get correct offsets
				offset = this.offset();
				if ( !jQuery.nodeName( offsetParent[ 0 ], "html" ) ) {
					parentOffset = offsetParent.offset();
				}
	
				// Add offsetParent borders
				parentOffset.top += jQuery.css( offsetParent[ 0 ], "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true );
			}
	
			// Subtract parent offsets and element margins
			return {
				top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
			};
		},
	
		// This method will return documentElement in the following cases:
		// 1) For the element inside the iframe without offsetParent, this method will return
		//    documentElement of the parent window
		// 2) For the hidden or detached element
		// 3) For body or html element, i.e. in case of the html node - it will return itself
		//
		// but those exceptions were never presented as a real life use-cases
		// and might be considered as more preferable results.
		//
		// This logic, however, is not guaranteed and can change at any point in the future
		offsetParent: function() {
			return this.map( function() {
				var offsetParent = this.offsetParent;
	
				while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
					offsetParent = offsetParent.offsetParent;
				}
	
				return offsetParent || documentElement;
			} );
		}
	} );
	
	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = "pageYOffset" === prop;
	
		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {
				var win = getWindow( elem );
	
				if ( val === undefined ) {
					return win ? win[ prop ] : elem[ method ];
				}
	
				if ( win ) {
					win.scrollTo(
						!top ? val : win.pageXOffset,
						top ? val : win.pageYOffset
					);
	
				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length );
		};
	} );
	
	// Support: Safari<7-8+, Chrome<37-44+
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// Blink bug: https://code.google.com/p/chromium/issues/detail?id=229280
	// getComputedStyle returns percent when specified for top/left/bottom/right;
	// rather than make the css module depend on the offset module, just check for it here
	jQuery.each( [ "top", "left" ], function( i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
			function( elem, computed ) {
				if ( computed ) {
					computed = curCSS( elem, prop );
	
					// If curCSS returns percentage, fallback to offset
					return rnumnonpx.test( computed ) ?
						jQuery( elem ).position()[ prop ] + "px" :
						computed;
				}
			}
		);
	} );
	
	
	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
			function( defaultExtra, funcName ) {
	
			// Margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
					extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
	
				return access( this, function( elem, type, value ) {
					var doc;
	
					if ( jQuery.isWindow( elem ) ) {
	
						// As of 5/8/2012 this will yield incorrect results for Mobile Safari, but there
						// isn't a whole lot we can do. See pull request at this URL for discussion:
						// https://github.com/jquery/jquery/pull/764
						return elem.document.documentElement[ "client" + name ];
					}
	
					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;
	
						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						return Math.max(
							elem.body[ "scroll" + name ], doc[ "scroll" + name ],
							elem.body[ "offset" + name ], doc[ "offset" + name ],
							doc[ "client" + name ]
						);
					}
	
					return value === undefined ?
	
						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css( elem, type, extra ) :
	
						// Set width or height on the element
						jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable, null );
			};
		} );
	} );
	
	
	jQuery.fn.extend( {
	
		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},
	
		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {
	
			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ?
				this.off( selector, "**" ) :
				this.off( types, selector || "**", fn );
		},
		size: function() {
			return this.length;
		}
	} );
	
	jQuery.fn.andSelf = jQuery.fn.addBack;
	
	
	
	
	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.
	
	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
	
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return jQuery;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	
	
	var
	
		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,
	
		// Map over the $ in case of overwrite
		_$ = window.$;
	
	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}
	
		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}
	
		return jQuery;
	};
	
	// Expose jQuery and $ identifiers, even in AMD
	// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (#13566)
	if ( !noGlobal ) {
		window.jQuery = window.$ = jQuery;
	}
	
	return jQuery;
	}));


/***/ }),
/* 221 */,
/* 222 */
/***/ (function(module, exports) {

	/*!
	 * jQuery Form Plugin
	 * version: 2.64 (25-FEB-2011)
	 * @requires jQuery v1.3.2 or later
	 *
	 * Examples and documentation at: http://malsup.com/jquery/form/
	 * Dual licensed under the MIT and GPL licenses:
	 *   http://www.opensource.org/licenses/mit-license.php
	 *   http://www.gnu.org/licenses/gpl.html
	 */
	;(function($) {
	
	/*
		Usage Note:
		-----------
		Do not use both ajaxSubmit and ajaxForm on the same form.  These
		functions are intended to be exclusive.  Use ajaxSubmit if you want
		to bind your own submit handler to the form.  For example,
	
		$(document).ready(function() {
			$('#myForm').bind('submit', function(e) {
				e.preventDefault(); // <-- important
				$(this).ajaxSubmit({
					target: '#output'
				});
			});
		});
	
		Use ajaxForm when you want the plugin to manage all the event binding
		for you.  For example,
	
		$(document).ready(function() {
			$('#myForm').ajaxForm({
				target: '#output'
			});
		});
	
		When using ajaxForm, the ajaxSubmit function will be invoked for you
		at the appropriate time.
	*/
	
	/**
	 * ajaxSubmit() provides a mechanism for immediately submitting
	 * an HTML form using AJAX.
	 */
	$.fn.ajaxSubmit = function(options) {
		// fast fail if nothing selected (http://dev.jquery.com/ticket/2752)
		if (!this.length) {
			log('ajaxSubmit: skipping submit process - no element selected');
			return this;
		}
	
		if (typeof options == 'function') {
			options = { success: options };
		}
	
		var action = this.attr('action');
		var url = (typeof action === 'string') ? $.trim(action) : '';
		if (url) {
			// clean url (don't include hash vaue)
			url = (url.match(/^([^#]+)/)||[])[1];
		}
		url = url || window.location.href || '';
	
		options = $.extend(true, {
			url:  url,
			type: this[0].getAttribute('method') || 'GET', // IE7 massage (see issue 57)
			iframeSrc: /^https/i.test(window.location.href || '') ? 'javascript:false' : 'about:blank'
		}, options);
	
		// hook for manipulating the form data before it is extracted;
		// convenient for use with rich editors like tinyMCE or FCKEditor
		var veto = {};
		this.trigger('form-pre-serialize', [this, options, veto]);
		if (veto.veto) {
			log('ajaxSubmit: submit vetoed via form-pre-serialize trigger');
			return this;
		}
	
		// provide opportunity to alter form data before it is serialized
		if (options.beforeSerialize && options.beforeSerialize(this, options) === false) {
			log('ajaxSubmit: submit aborted via beforeSerialize callback');
			return this;
		}
	
		var n,v,a = this.formToArray(options.semantic);
		if (options.data) {
			options.extraData = options.data;
			for (n in options.data) {
				if(options.data[n] instanceof Array) {
					for (var k in options.data[n]) {
						a.push( { name: n, value: options.data[n][k] } );
					}
				}
				else {
					v = options.data[n];
					v = $.isFunction(v) ? v() : v; // if value is fn, invoke it
					a.push( { name: n, value: v } );
				}
			}
		}
	
		// give pre-submit callback an opportunity to abort the submit
		if (options.beforeSubmit && options.beforeSubmit(a, this, options) === false) {
			log('ajaxSubmit: submit aborted via beforeSubmit callback');
			return this;
		}
	
		// fire vetoable 'validate' event
		this.trigger('form-submit-validate', [a, this, options, veto]);
		if (veto.veto) {
			log('ajaxSubmit: submit vetoed via form-submit-validate trigger');
			return this;
		}
	
		var q = $.param(a);
	
		if (options.type.toUpperCase() == 'GET') {
			options.url += (options.url.indexOf('?') >= 0 ? '&' : '?') + q;
			options.data = null;  // data is null for 'get'
		}
		else {
			options.data = q; // data is the query string for 'post'
		}
	
		var $form = this, callbacks = [];
		if (options.resetForm) {
			callbacks.push(function() { $form.resetForm(); });
		}
		if (options.clearForm) {
			callbacks.push(function() { $form.clearForm(); });
		}
	
		// perform a load on the target only if dataType is not provided
		if (!options.dataType && options.target) {
			var oldSuccess = options.success || function(){};
			callbacks.push(function(data) {
				var fn = options.replaceTarget ? 'replaceWith' : 'html';
				$(options.target)[fn](data).each(oldSuccess, arguments);
			});
		}
		else if (options.success) {
			callbacks.push(options.success);
		}
	
		options.success = function(data, status, xhr) { // jQuery 1.4+ passes xhr as 3rd arg
			var context = options.context || options;   // jQuery 1.4+ supports scope context 
			for (var i=0, max=callbacks.length; i < max; i++) {
				callbacks[i].apply(context, [data, status, xhr || $form, $form]);
			}
		};
	
		// are there files to upload?
		var fileInputs = $('input:file', this).length > 0;
		var mp = 'multipart/form-data';
		var multipart = ($form.attr('enctype') == mp || $form.attr('encoding') == mp);
	
		// options.iframe allows user to force iframe mode
		// 06-NOV-09: now defaulting to iframe mode if file input is detected
	   if (options.iframe !== false && (fileInputs || options.iframe || multipart)) {
		   // hack to fix Safari hang (thanks to Tim Molendijk for this)
		   // see:  http://groups.google.com/group/jquery-dev/browse_thread/thread/36395b7ab510dd5d
		   if (options.closeKeepAlive) {
			   $.get(options.closeKeepAlive, fileUpload);
			}
		   else {
			   fileUpload();
			}
	   }
	   else {
			$.ajax(options);
	   }
	
		// fire 'notify' event
		this.trigger('form-submit-notify', [this, options]);
		return this;
	
	
		// private function for handling file uploads (hat tip to YAHOO!)
		function fileUpload() {
			var form = $form[0];
	
			if ($(':input[name=submit],:input[id=submit]', form).length) {
				// if there is an input with a name or id of 'submit' then we won't be
				// able to invoke the submit fn on the form (at least not x-browser)
				alert('Error: Form elements must not have name or id of "submit".');
				return;
			}
			
			var s = $.extend(true, {}, $.ajaxSettings, options);
			s.context = s.context || s;
			var id = 'jqFormIO' + (new Date().getTime()), fn = '_'+id;
			var $io = $('<iframe id="' + id + '" name="' + id + '" src="'+ s.iframeSrc +'" />');
			var io = $io[0];
	
			$io.css({ position: 'absolute', top: '-1000px', left: '-1000px' });
	
			var xhr = { // mock object
				aborted: 0,
				responseText: null,
				responseXML: null,
				status: 0,
				statusText: 'n/a',
				getAllResponseHeaders: function() {},
				getResponseHeader: function() {},
				setRequestHeader: function() {},
				abort: function() {
					this.aborted = 1;
					$io.attr('src', s.iframeSrc); // abort op in progress
				}
			};
	
			var g = s.global;
			// trigger ajax global events so that activity/block indicators work like normal
			if (g && ! $.active++) {
				$.event.trigger("ajaxStart");
			}
			if (g) {
				$.event.trigger("ajaxSend", [xhr, s]);
			}
	
			if (s.beforeSend && s.beforeSend.call(s.context, xhr, s) === false) {
				if (s.global) { 
					$.active--;
				}
				return;
			}
			if (xhr.aborted) {
				return;
			}
	
			var timedOut = 0;
	
			// add submitting element to data if we know it
			var sub = form.clk;
			if (sub) {
				var n = sub.name;
				if (n && !sub.disabled) {
					s.extraData = s.extraData || {};
					s.extraData[n] = sub.value;
					if (sub.type == "image") {
						s.extraData[n+'.x'] = form.clk_x;
						s.extraData[n+'.y'] = form.clk_y;
					}
				}
			}
	
			// take a breath so that pending repaints get some cpu time before the upload starts
			function doSubmit() {
				// make sure form attrs are set
				var t = $form.attr('target'), a = $form.attr('action');
	
				// update form attrs in IE friendly way
				form.setAttribute('target',id);
				if (form.getAttribute('method') != 'POST') {
					form.setAttribute('method', 'POST');
				}
				if (form.getAttribute('action') != s.url) {
					form.setAttribute('action', s.url);
				}
	
				// ie borks in some cases when setting encoding
				if (! s.skipEncodingOverride) {
					$form.attr({
						encoding: 'multipart/form-data',
						enctype:  'multipart/form-data'
					});
				}
	
				// support timout
				if (s.timeout) {
					setTimeout(function() { timedOut = true; cb(); }, s.timeout);
				}
	
				// add "extra" data to form if provided in options
				var extraInputs = [];
				try {
					if (s.extraData) {
						for (var n in s.extraData) {
							extraInputs.push(
								$('<input type="hidden" name="'+n+'" value="'+s.extraData[n]+'" />')
									.appendTo(form)[0]);
						}
					}
	
					// add iframe to doc and submit the form
					$io.appendTo('body');
	                io.attachEvent ? io.attachEvent('onload', cb) : io.addEventListener('load', cb, false);
					form.submit();
				}
				finally {
					// reset attrs and remove "extra" input elements
					form.setAttribute('action',a);
					if(t) {
						form.setAttribute('target', t);
					} else {
						$form.removeAttr('target');
					}
					$(extraInputs).remove();
				}
			}
	
			if (s.forceSync) {
				doSubmit();
			}
			else {
				setTimeout(doSubmit, 10); // this lets dom updates render
			}
		
			var data, doc, domCheckCount = 50;
	
			function cb() {
				doc = io.contentWindow ? io.contentWindow.document : io.contentDocument ? io.contentDocument : io.document;
				if (!doc || doc.location.href == s.iframeSrc) {
					// response not received yet
					return;
				}
	            io.detachEvent ? io.detachEvent('onload', cb) : io.removeEventListener('load', cb, false);
	
				var ok = true;
				try {
					if (timedOut) {
						throw 'timeout';
					}
	
					var isXml = s.dataType == 'xml' || doc.XMLDocument || $.isXMLDoc(doc);
					log('isXml='+isXml);
					if (!isXml && window.opera && (doc.body == null || doc.body.innerHTML == '')) {
						if (--domCheckCount) {
							// in some browsers (Opera) the iframe DOM is not always traversable when
							// the onload callback fires, so we loop a bit to accommodate
							log('requeing onLoad callback, DOM not available');
							setTimeout(cb, 250);
							return;
						}
						// let this fall through because server response could be an empty document
						//log('Could not access iframe DOM after mutiple tries.');
						//throw 'DOMException: not available';
					}
	
					//log('response detected');
					xhr.responseText = doc.body ? doc.body.innerHTML : doc.documentElement ? doc.documentElement.innerHTML : null; 
					xhr.responseXML = doc.XMLDocument ? doc.XMLDocument : doc;
					xhr.getResponseHeader = function(header){
						var headers = {'content-type': s.dataType};
						return headers[header];
					};
	
					var scr = /(json|script)/.test(s.dataType);
					if (scr || s.textarea) {
						// see if user embedded response in textarea
						var ta = doc.getElementsByTagName('textarea')[0];
						if (ta) {
							xhr.responseText = ta.value;
						}
						else if (scr) {
							// account for browsers injecting pre around json response
							var pre = doc.getElementsByTagName('pre')[0];
							var b = doc.getElementsByTagName('body')[0];
							if (pre) {
								xhr.responseText = pre.textContent;
							}
							else if (b) {
								xhr.responseText = b.innerHTML;
							}
						}			  
					}
					else if (s.dataType == 'xml' && !xhr.responseXML && xhr.responseText != null) {
						xhr.responseXML = toXml(xhr.responseText);
					}
					
					data = httpData(xhr, s.dataType, s);
				}
				catch(e){
					log('error caught:',e);
					ok = false;
					xhr.error = e;
					s.error && s.error.call(s.context, xhr, 'error', e);
					g && $.event.trigger("ajaxError", [xhr, s, e]);
				}
				
				if (xhr.aborted) {
					log('upload aborted');
					ok = false;
				}
	
				// ordering of these callbacks/triggers is odd, but that's how $.ajax does it
				if (ok) {
					s.success && s.success.call(s.context, data, 'success', xhr);
					g && $.event.trigger("ajaxSuccess", [xhr, s]);
				}
				
				g && $.event.trigger("ajaxComplete", [xhr, s]);
	
				if (g && ! --$.active) {
					$.event.trigger("ajaxStop");
				}
				
				s.complete && s.complete.call(s.context, xhr, ok ? 'success' : 'error');
	
				// clean up
				setTimeout(function() {
					$io.removeData('form-plugin-onload');
					$io.remove();
					xhr.responseXML = null;
				}, 100);
			}
	
			var toXml = $.parseXML || function(s, doc) { // use parseXML if available (jQuery 1.5+)
				if (window.ActiveXObject) {
					doc = new ActiveXObject('Microsoft.XMLDOM');
					doc.async = 'false';
					doc.loadXML(s);
				}
				else {
					doc = (new DOMParser()).parseFromString(s, 'text/xml');
				}
				return (doc && doc.documentElement && doc.documentElement.nodeName != 'parsererror') ? doc : null;
			};
			var parseJSON = $.parseJSON || function(s) {
				return window['eval']('(' + s + ')');
			};
			
			var httpData = function( xhr, type, s ) { // mostly lifted from jq1.4.4
				var ct = xhr.getResponseHeader('content-type') || '',
					xml = type === 'xml' || !type && ct.indexOf('xml') >= 0,
					data = xml ? xhr.responseXML : xhr.responseText;
	
				if (xml && data.documentElement.nodeName === 'parsererror') {
					$.error && $.error('parsererror');
				}
				if (s && s.dataFilter) {
					data = s.dataFilter(data, type);
				}
				if (typeof data === 'string') {
					if (type === 'json' || !type && ct.indexOf('json') >= 0) {
						data = parseJSON(data);
					} else if (type === "script" || !type && ct.indexOf("javascript") >= 0) {
						$.globalEval(data);
					}
				}
				return data;
			};
		}
	};
	
	/**
	 * ajaxForm() provides a mechanism for fully automating form submission.
	 *
	 * The advantages of using this method instead of ajaxSubmit() are:
	 *
	 * 1: This method will include coordinates for <input type="image" /> elements (if the element
	 *	is used to submit the form).
	 * 2. This method will include the submit element's name/value data (for the element that was
	 *	used to submit the form).
	 * 3. This method binds the submit() method to the form for you.
	 *
	 * The options argument for ajaxForm works exactly as it does for ajaxSubmit.  ajaxForm merely
	 * passes the options argument along after properly binding events for submit elements and
	 * the form itself.
	 */
	$.fn.ajaxForm = function(options) {
		// in jQuery 1.3+ we can fix mistakes with the ready state
		if (this.length === 0) {
			var o = { s: this.selector, c: this.context };
			if (!$.isReady && o.s) {
				log('DOM not ready, queuing ajaxForm');
				$(function() {
					$(o.s,o.c).ajaxForm(options);
				});
				return this;
			}
			// is your DOM ready?  http://docs.jquery.com/Tutorials:Introducing_$(document).ready()
			log('terminating; zero elements found by selector' + ($.isReady ? '' : ' (DOM not ready)'));
			return this;
		}
		
		return this.ajaxFormUnbind().bind('submit.form-plugin', function(e) {
			if (!e.isDefaultPrevented()) { // if event has been canceled, don't proceed
				e.preventDefault();
				$(this).ajaxSubmit(options);
			}
		}).bind('click.form-plugin', function(e) {
			var target = e.target;
			var $el = $(target);
			if (!($el.is(":submit,input:image"))) {
				// is this a child element of the submit el?  (ex: a span within a button)
				var t = $el.closest(':submit');
				if (t.length == 0) {
					return;
				}
				target = t[0];
			}
			var form = this;
			form.clk = target;
			if (target.type == 'image') {
				if (e.offsetX != undefined) {
					form.clk_x = e.offsetX;
					form.clk_y = e.offsetY;
				} else if (typeof $.fn.offset == 'function') { // try to use dimensions plugin
					var offset = $el.offset();
					form.clk_x = e.pageX - offset.left;
					form.clk_y = e.pageY - offset.top;
				} else {
					form.clk_x = e.pageX - target.offsetLeft;
					form.clk_y = e.pageY - target.offsetTop;
				}
			}
			// clear form vars
			setTimeout(function() { form.clk = form.clk_x = form.clk_y = null; }, 100);
		});
	};
	
	// ajaxFormUnbind unbinds the event handlers that were bound by ajaxForm
	$.fn.ajaxFormUnbind = function() {
		return this.unbind('submit.form-plugin click.form-plugin');
	};
	
	/**
	 * formToArray() gathers form element data into an array of objects that can
	 * be passed to any of the following ajax functions: $.get, $.post, or load.
	 * Each object in the array has both a 'name' and 'value' property.  An example of
	 * an array for a simple login form might be:
	 *
	 * [ { name: 'username', value: 'jresig' }, { name: 'password', value: 'secret' } ]
	 *
	 * It is this array that is passed to pre-submit callback functions provided to the
	 * ajaxSubmit() and ajaxForm() methods.
	 */
	$.fn.formToArray = function(semantic) {
		var a = [];
		if (this.length === 0) {
			return a;
		}
	
		var form = this[0];
		var els = semantic ? form.getElementsByTagName('*') : form.elements;
		if (!els) {
			return a;
		}
		
		var i,j,n,v,el,max,jmax;
		for(i=0, max=els.length; i < max; i++) {
			el = els[i];
			n = el.name;
			if (!n) {
				continue;
			}
	
			if (semantic && form.clk && el.type == "image") {
				// handle image inputs on the fly when semantic == true
				if(!el.disabled && form.clk == el) {
					a.push({name: n, value: $(el).val()});
					a.push({name: n+'.x', value: form.clk_x}, {name: n+'.y', value: form.clk_y});
				}
				continue;
			}
	
			v = $.fieldValue(el, true);
			if (v && v.constructor == Array) {
				for(j=0, jmax=v.length; j < jmax; j++) {
					a.push({name: n, value: v[j]});
				}
			}
			else if (v !== null && typeof v != 'undefined') {
				a.push({name: n, value: v});
			}
		}
	
		if (!semantic && form.clk) {
			// input type=='image' are not found in elements array! handle it here
			var $input = $(form.clk), input = $input[0];
			n = input.name;
			if (n && !input.disabled && input.type == 'image') {
				a.push({name: n, value: $input.val()});
				a.push({name: n+'.x', value: form.clk_x}, {name: n+'.y', value: form.clk_y});
			}
		}
		return a;
	};
	
	/**
	 * Serializes form data into a 'submittable' string. This method will return a string
	 * in the format: name1=value1&amp;name2=value2
	 */
	$.fn.formSerialize = function(semantic) {
		//hand off to jQuery.param for proper encoding
		return $.param(this.formToArray(semantic));
	};
	
	/**
	 * Serializes all field elements in the jQuery object into a query string.
	 * This method will return a string in the format: name1=value1&amp;name2=value2
	 */
	$.fn.fieldSerialize = function(successful) {
		var a = [];
		this.each(function() {
			var n = this.name;
			if (!n) {
				return;
			}
			var v = $.fieldValue(this, successful);
			if (v && v.constructor == Array) {
				for (var i=0,max=v.length; i < max; i++) {
					a.push({name: n, value: v[i]});
				}
			}
			else if (v !== null && typeof v != 'undefined') {
				a.push({name: this.name, value: v});
			}
		});
		//hand off to jQuery.param for proper encoding
		return $.param(a);
	};
	
	/**
	 * Returns the value(s) of the element in the matched set.  For example, consider the following form:
	 *
	 *  <form><fieldset>
	 *	  <input name="A" type="text" />
	 *	  <input name="A" type="text" />
	 *	  <input name="B" type="checkbox" value="B1" />
	 *	  <input name="B" type="checkbox" value="B2"/>
	 *	  <input name="C" type="radio" value="C1" />
	 *	  <input name="C" type="radio" value="C2" />
	 *  </fieldset></form>
	 *
	 *  var v = $(':text').fieldValue();
	 *  // if no values are entered into the text inputs
	 *  v == ['','']
	 *  // if values entered into the text inputs are 'foo' and 'bar'
	 *  v == ['foo','bar']
	 *
	 *  var v = $(':checkbox').fieldValue();
	 *  // if neither checkbox is checked
	 *  v === undefined
	 *  // if both checkboxes are checked
	 *  v == ['B1', 'B2']
	 *
	 *  var v = $(':radio').fieldValue();
	 *  // if neither radio is checked
	 *  v === undefined
	 *  // if first radio is checked
	 *  v == ['C1']
	 *
	 * The successful argument controls whether or not the field element must be 'successful'
	 * (per http://www.w3.org/TR/html4/interact/forms.html#successful-controls).
	 * The default value of the successful argument is true.  If this value is false the value(s)
	 * for each element is returned.
	 *
	 * Note: This method *always* returns an array.  If no valid value can be determined the
	 *	   array will be empty, otherwise it will contain one or more values.
	 */
	$.fn.fieldValue = function(successful) {
		for (var val=[], i=0, max=this.length; i < max; i++) {
			var el = this[i];
			var v = $.fieldValue(el, successful);
			if (v === null || typeof v == 'undefined' || (v.constructor == Array && !v.length)) {
				continue;
			}
			v.constructor == Array ? $.merge(val, v) : val.push(v);
		}
		return val;
	};
	
	/**
	 * Returns the value of the field element.
	 */
	$.fieldValue = function(el, successful) {
		var n = el.name, t = el.type, tag = el.tagName.toLowerCase();
		if (successful === undefined) {
			successful = true;
		}
	
		if (successful && (!n || el.disabled || t == 'reset' || t == 'button' ||
			(t == 'checkbox' || t == 'radio') && !el.checked ||
			(t == 'submit' || t == 'image') && el.form && el.form.clk != el ||
			tag == 'select' && el.selectedIndex == -1)) {
				return null;
		}
	
		if (tag == 'select') {
			var index = el.selectedIndex;
			if (index < 0) {
				return null;
			}
			var a = [], ops = el.options;
			var one = (t == 'select-one');
			var max = (one ? index+1 : ops.length);
			for(var i=(one ? index : 0); i < max; i++) {
				var op = ops[i];
				if (op.selected) {
					var v = op.value;
					if (!v) { // extra pain for IE...
						v = (op.attributes && op.attributes['value'] && !(op.attributes['value'].specified)) ? op.text : op.value;
					}
					if (one) {
						return v;
					}
					a.push(v);
				}
			}
			return a;
		}
		return $(el).val();
	};
	
	/**
	 * Clears the form data.  Takes the following actions on the form's input fields:
	 *  - input text fields will have their 'value' property set to the empty string
	 *  - select elements will have their 'selectedIndex' property set to -1
	 *  - checkbox and radio inputs will have their 'checked' property set to false
	 *  - inputs of type submit, button, reset, and hidden will *not* be effected
	 *  - button elements will *not* be effected
	 */
	$.fn.clearForm = function() {
		return this.each(function() {
			$('input,select,textarea', this).clearFields();
		});
	};
	
	/**
	 * Clears the selected form elements.
	 */
	$.fn.clearFields = $.fn.clearInputs = function() {
		return this.each(function() {
			var t = this.type, tag = this.tagName.toLowerCase();
			if (t == 'text' || t == 'password' || tag == 'textarea') {
				this.value = '';
			}
			else if (t == 'checkbox' || t == 'radio') {
				this.checked = false;
			}
			else if (tag == 'select') {
				this.selectedIndex = -1;
			}
		});
	};
	
	/**
	 * Resets the form data.  Causes all form elements to be reset to their original value.
	 */
	$.fn.resetForm = function() {
		return this.each(function() {
			// guard against an input with the name of 'reset'
			// note that IE reports the reset function as an 'object'
			if (typeof this.reset == 'function' || (typeof this.reset == 'object' && !this.reset.nodeType)) {
				this.reset();
			}
		});
	};
	
	/**
	 * Enables or disables any matching elements.
	 */
	$.fn.enable = function(b) {
		if (b === undefined) {
			b = true;
		}
		return this.each(function() {
			this.disabled = !b;
		});
	};
	
	/**
	 * Checks/unchecks any matching checkboxes or radio buttons and
	 * selects/deselects and matching option elements.
	 */
	$.fn.selected = function(select) {
		if (select === undefined) {
			select = true;
		}
		return this.each(function() {
			var t = this.type;
			if (t == 'checkbox' || t == 'radio') {
				this.checked = select;
			}
			else if (this.tagName.toLowerCase() == 'option') {
				var $sel = $(this).parent('select');
				if (select && $sel[0] && $sel[0].type == 'select-one') {
					// deselect all other options
					$sel.find('option').selected(false);
				}
				this.selected = select;
			}
		});
	};
	
	// helper fn for console logging
	// set $.fn.ajaxSubmit.debug to true to enable debug logging
	function log() {
		if ($.fn.ajaxSubmit.debug) {
			var msg = '[jquery.form] ' + Array.prototype.join.call(arguments,'');
			if (window.console && window.console.log) {
				window.console.log(msg);
			}
			else if (window.opera && window.opera.postError) {
				window.opera.postError(msg);
			}
		}
	};
	
	})(jQuery);


/***/ }),
/* 223 */
/***/ (function(module, exports) {

	/**
	 * jGrowl 1.4.5
	 *
	 * Dual licensed under the MIT (http://www.opensource.org/licenses/mit-license.php)
	 * and GPL (http://www.opensource.org/licenses/gpl-license.php) licenses.
	 *
	 * Written by Stan Lemon <stosh1985@gmail.com>
	 * Last updated: 2015.02.01
	 *
	 * jGrowl is a jQuery plugin implementing unobtrusive userland notifications.  These
	 * notifications function similarly to the Growl Framework available for
	 * Mac OS X (http://growl.info).
	 *
	 * To Do:
	 * - Move library settings to containers and allow them to be changed per container
	 *
	 * Changes in 1.4.5
	 * - Fixed arguement list for click callback, thanks @timotheeg
	 *
	 * Changes in 1.4.4
	 * - Revert word-break changes, thanks @curtisgibby
	 *
	 * Changes in 1.4.3
	 * - Fixed opactiy in LESS for older version of IE
	 *
	 * Changes in 1.4.2
	 * - Added word-break to less/css
	 *
	 * Changes in 1.4.1
	 * - Added appendTo option
	 * - jQuery compatibility updates
	 * - Add check for closing a notification before it opens
	 *
	 * Changes in 1.4.0
	 * - Removed IE6 support
	 * - Added LESS support
	 *
	 * Changes in 1.3.0
	 * - Added non-vendor border-radius to stylesheet
	 * - Added grunt for generating minified js and css
	 * - Added npm package info
	 * - Added bower package info
	 * - Updates for jshint
	 *
	 * Changes in 1.2.13
	 * - Fixed clearing interval when the container shuts down
	 *
	 * Changes in 1.2.12
	 * - Added compressed versions using UglifyJS and Sqwish
	 * - Improved README with configuration options explanation
	 * - Added a source map
	 *
	 * Changes in 1.2.11
	 * - Fix artifacts left behind by the shutdown method and text-cleanup
	 *
	 * Changes in 1.2.10
	 * - Fix beforeClose to be called in click event
	 *
	 * Changes in 1.2.9
	 * - Fixed BC break in jQuery 2.0 beta
	 *
	 * Changes in 1.2.8
	 * - Fixes for jQuery 1.9 and the MSIE6 check, note that with jQuery 2.0 support
	 *   jGrowl intends to drop support for IE6 altogether
	 *
	 * Changes in 1.2.6
	 * - Fixed js error when a notification is opening and closing at the same time
	 *
	 * Changes in 1.2.5
	 * - Changed wrapper jGrowl's options usage to "o" instead of $.jGrowl.defaults
	 * - Added themeState option to control 'highlight' or 'error' for jQuery UI
	 * - Ammended some CSS to provide default positioning for nested usage.
	 * - Changed some CSS to be prefixed with jGrowl- to prevent namespacing issues
	 * - Added two new options - openDuration and closeDuration to allow
	 *   better control of notification open and close speeds, respectively
	 *   Patch contributed by Jesse Vincet.
	 * - Added afterOpen callback.  Patch contributed by Russel Branca.
	 *
	 * Changes in 1.2.4
	 * - Fixed IE bug with the close-all button
	 * - Fixed IE bug with the filter CSS attribute (special thanks to gotwic)
	 * - Update IE opacity CSS
	 * - Changed font sizes to use "em", and only set the base style
	 *
	 * Changes in 1.2.3
	 * - The callbacks no longer use the container as context, instead they use the actual notification
	 * - The callbacks now receive the container as a parameter after the options parameter
	 * - beforeOpen and beforeClose now check the return value, if it's false - the notification does
	 *   not continue.  The open callback will also halt execution if it returns false.
	 * - Fixed bug where containers would get confused
	 * - Expanded the pause functionality to pause an entire container.
	 *
	 * Changes in 1.2.2
	 * - Notification can now be theme rolled for jQuery UI, special thanks to Jeff Chan!
	 *
	 * Changes in 1.2.1
	 * - Fixed instance where the interval would fire the close method multiple times.
	 * - Added CSS to hide from print media
	 * - Fixed issue with closer button when div { position: relative } is set
	 * - Fixed leaking issue with multiple containers.  Special thanks to Matthew Hanlon!
	 *
	 * Changes in 1.2.0
	 * - Added message pooling to limit the number of messages appearing at a given time.
	 * - Closing a notification is now bound to the notification object and triggered by the close button.
	 *
	 * Changes in 1.1.2
	 * - Added iPhone styled example
	 * - Fixed possible IE7 bug when determining if the ie6 class shoudl be applied.
	 * - Added template for the close button, so that it's content could be customized.
	 *
	 * Changes in 1.1.1
	 * - Fixed CSS styling bug for ie6 caused by a mispelling
	 * - Changes height restriction on default notifications to min-height
	 * - Added skinned examples using a variety of images
	 * - Added the ability to customize the content of the [close all] box
	 * - Added jTweet, an example of using jGrowl + Twitter
	 *
	 * Changes in 1.1.0
	 * - Multiple container and instances.
	 * - Standard $.jGrowl() now wraps $.fn.jGrowl() by first establishing a generic jGrowl container.
	 * - Instance methods of a jGrowl container can be called by $.fn.jGrowl(methodName)
	 * - Added glue preferenced, which allows notifications to be inserted before or after nodes in the container
	 * - Added new log callback which is called before anything is done for the notification
	 * - Corner's attribute are now applied on an individual notification basis.
	 *
	 * Changes in 1.0.4
	 * - Various CSS fixes so that jGrowl renders correctly in IE6.
	 *
	 * Changes in 1.0.3
	 * - Fixed bug with options persisting across notifications
	 * - Fixed theme application bug
	 * - Simplified some selectors and manipulations.
	 * - Added beforeOpen and beforeClose callbacks
	 * - Reorganized some lines of code to be more readable
	 * - Removed unnecessary this.defaults context
	 * - If corners plugin is present, it's now customizable.
	 * - Customizable open animation.
	 * - Customizable close animation.
	 * - Customizable animation easing.
	 * - Added customizable positioning (top-left, top-right, bottom-left, bottom-right, center)
	 *
	 * Changes in 1.0.2
	 * - All CSS styling is now external.
	 * - Added a theme parameter which specifies a secondary class for styling, such
	 *   that notifications can be customized in appearance on a per message basis.
	 * - Notification life span is now customizable on a per message basis.
	 * - Added the ability to disable the global closer, enabled by default.
	 * - Added callbacks for when a notification is opened or closed.
	 * - Added callback for the global closer.
	 * - Customizable animation speed.
	 * - jGrowl now set itself up and tears itself down.
	 *
	 * Changes in 1.0.1:
	 * - Removed dependency on metadata plugin in favor of .data()
	 * - Namespaced all events
	 */
	(function($) {
		/** jGrowl Wrapper - Establish a base jGrowl Container for compatibility with older releases. **/
		$.jGrowl = function( m , o ) {
			// To maintain compatibility with older version that only supported one instance we'll create the base container.
			if ( $('#jGrowl').length === 0 )
				$('<div id="jGrowl"></div>').addClass( (o && o.position) ? o.position : $.jGrowl.defaults.position ).appendTo( (o && o.appendTo) ? o.appendTo : $.jGrowl.defaults.appendTo );
	
			// Create a notification on the container.
			$('#jGrowl').jGrowl(m,o);
		};
	
	
		/** Raise jGrowl Notification on a jGrowl Container **/
		$.fn.jGrowl = function( m , o ) {
			// Short hand for passing in just an object to this method
			if ( o === undefined && $.isPlainObject(m) ) {
				o = m;
				m = o.message;
			}
	
			if ( $.isFunction(this.each) ) {
				var args = arguments;
	
				return this.each(function() {
					/** Create a jGrowl Instance on the Container if it does not exist **/
					if ( $(this).data('jGrowl.instance') === undefined ) {
						$(this).data('jGrowl.instance', $.extend( new $.fn.jGrowl(), { notifications: [], element: null, interval: null } ));
						$(this).data('jGrowl.instance').startup( this );
					}
	
					/** Optionally call jGrowl instance methods, or just raise a normal notification **/
					if ( $.isFunction($(this).data('jGrowl.instance')[m]) ) {
						$(this).data('jGrowl.instance')[m].apply( $(this).data('jGrowl.instance') , $.makeArray(args).slice(1) );
					} else {
						$(this).data('jGrowl.instance').create( m , o );
					}
				});
			}
		};
	
		$.extend( $.fn.jGrowl.prototype , {
	
			/** Default JGrowl Settings **/
			defaults: {
				pool:				0,
				header:				'',
				group:				'',
				sticky:				false,
				position:			'top-right',
				appendTo:			'body',
				glue:				'after',
				theme:				'default',
				themeState:			'highlight',
				corners:			'10px',
				check:				250,
				life:				3000,
				closeDuration:		'normal',
				openDuration:		'normal',
				easing:				'swing',
				closer:				true,
				closeTemplate:		'&times;',
				closerTemplate:		'<div>[ close all ]</div>',
				log:				function() {},
				beforeOpen:			function() {},
				afterOpen:			function() {},
				open:				function() {},
				beforeClose:		function() {},
				close:				function() {},
				click:				function() {},
				animateOpen:		{
					opacity:		'show'
				},
				animateClose:		{
					opacity:		'hide'
				}
			},
	
			notifications: [],
	
			/** jGrowl Container Node **/
			element:				null,
	
			/** Interval Function **/
			interval:				null,
	
			/** Create a Notification **/
			create: function( message , options ) {
				var o = $.extend({}, this.defaults, options);
	
				/* To keep backward compatibility with 1.24 and earlier, honor 'speed' if the user has set it */
				if (typeof o.speed !== 'undefined') {
					o.openDuration = o.speed;
					o.closeDuration = o.speed;
				}
	
				this.notifications.push({ message: message , options: o });
	
				o.log.apply( this.element , [this.element,message,o] );
			},
	
			render: function( n ) {
				var self = this;
				var message = n.message;
				var o = n.options;
	
				// Support for jQuery theme-states, if this is not used it displays a widget header
				o.themeState = (o.themeState === '') ? '' : 'ui-state-' + o.themeState;
	
				var notification = $('<div/>')
					.addClass('jGrowl-notification alert ' + o.themeState + ' ui-corner-all' + ((o.group !== undefined && o.group !== '') ? ' ' + o.group : ''))
					.append($('<button/>').addClass('jGrowl-close').html(o.closeTemplate))
					.append($('<div/>').addClass('jGrowl-header').html(o.header))
					.append($('<div/>').addClass('jGrowl-message').html(message))
					.data("jGrowl", o).addClass(o.theme).children('.jGrowl-close').bind("click.jGrowl", function() {
						$(this).parent().trigger('jGrowl.beforeClose');
						return false;
					})
					.parent();
	
	
				/** Notification Actions **/
				$(notification).bind("mouseover.jGrowl", function() {
					$('.jGrowl-notification', self.element).data("jGrowl.pause", true);
				}).bind("mouseout.jGrowl", function() {
					$('.jGrowl-notification', self.element).data("jGrowl.pause", false);
				}).bind('jGrowl.beforeOpen', function() {
					if ( o.beforeOpen.apply( notification , [notification,message,o,self.element] ) !== false ) {
						$(this).trigger('jGrowl.open');
					}
				}).bind('jGrowl.open', function() {
					if ( o.open.apply( notification , [notification,message,o,self.element] ) !== false ) {
						if ( o.glue == 'after' ) {
							$('.jGrowl-notification:last', self.element).after(notification);
						} else {
							$('.jGrowl-notification:first', self.element).before(notification);
						}
	
						$(this).animate(o.animateOpen, o.openDuration, o.easing, function() {
							// Fixes some anti-aliasing issues with IE filters.
							if ($.support.opacity === false)
								this.style.removeAttribute('filter');
	
							if ( $(this).data("jGrowl") !== null && typeof $(this).data("jGrowl") !== 'undefined') // Happens when a notification is closing before it's open.
								$(this).data("jGrowl").created = new Date();
	
							$(this).trigger('jGrowl.afterOpen');
						});
					}
				}).bind('jGrowl.afterOpen', function() {
					o.afterOpen.apply( notification , [notification,message,o,self.element] );
				}).bind('click', function() {
					o.click.apply( notification, [notification,message,o,self.element] );
				}).bind('jGrowl.beforeClose', function() {
					if ( o.beforeClose.apply( notification , [notification,message,o,self.element] ) !== false )
						$(this).trigger('jGrowl.close');
				}).bind('jGrowl.close', function() {
					// Pause the notification, lest during the course of animation another close event gets called.
					$(this).data('jGrowl.pause', true);
					$(this).animate(o.animateClose, o.closeDuration, o.easing, function() {
						if ( $.isFunction(o.close) ) {
							if ( o.close.apply( notification , [notification,message,o,self.element] ) !== false )
								$(this).remove();
						} else {
							$(this).remove();
						}
					});
				}).trigger('jGrowl.beforeOpen');
	
				/** Optional Corners Plugin **/
				if ( o.corners !== '' && $.fn.corner !== undefined ) $(notification).corner( o.corners );
	
				/** Add a Global Closer if more than one notification exists **/
				if ($('.jGrowl-notification:parent', self.element).length > 1 &&
					$('.jGrowl-closer', self.element).length === 0 && this.defaults.closer !== false ) {
					$(this.defaults.closerTemplate).addClass('jGrowl-closer ' + this.defaults.themeState + ' ui-corner-all').addClass(this.defaults.theme)
						.appendTo(self.element).animate(this.defaults.animateOpen, this.defaults.speed, this.defaults.easing)
						.bind("click.jGrowl", function() {
							$(this).siblings().trigger("jGrowl.beforeClose");
	
							if ( $.isFunction( self.defaults.closer ) ) {
								self.defaults.closer.apply( $(this).parent()[0] , [$(this).parent()[0]] );
							}
						});
				}
			},
	
			/** Update the jGrowl Container, removing old jGrowl notifications **/
			update: function() {
				$(this.element).find('.jGrowl-notification:parent').each( function() {
					if ($(this).data("jGrowl") !== undefined && $(this).data("jGrowl").created !== undefined &&
						($(this).data("jGrowl").created.getTime() + parseInt($(this).data("jGrowl").life, 10))  < (new Date()).getTime() &&
						$(this).data("jGrowl").sticky !== true &&
						($(this).data("jGrowl.pause") === undefined || $(this).data("jGrowl.pause") !== true) ) {
	
						// Pause the notification, lest during the course of animation another close event gets called.
						$(this).trigger('jGrowl.beforeClose');
					}
				});
	
				if (this.notifications.length > 0 &&
					(this.defaults.pool === 0 || $(this.element).find('.jGrowl-notification:parent').length < this.defaults.pool) )
					this.render( this.notifications.shift() );
	
				if ($(this.element).find('.jGrowl-notification:parent').length < 2 ) {
					$(this.element).find('.jGrowl-closer').animate(this.defaults.animateClose, this.defaults.speed, this.defaults.easing, function() {
						$(this).remove();
					});
				}
			},
	
			/** Setup the jGrowl Notification Container **/
			startup: function(e) {
				this.element = $(e).addClass('jGrowl').append('<div class="jGrowl-notification"></div>');
				this.interval = setInterval( function() {
					// some error in chage ^^
					var instance = $(e).data('jGrowl.instance');
					if (undefined !== instance) {
						instance.update();
					}
				}, parseInt(this.defaults.check, 10));
			},
	
			/** Shutdown jGrowl, removing it and clearing the interval **/
			shutdown: function() {
				$(this.element).removeClass('jGrowl')
					.find('.jGrowl-notification').trigger('jGrowl.close')
					.parent().empty()
				;
	
				clearInterval(this.interval);
			},
	
			close: function() {
				$(this.element).find('.jGrowl-notification').each(function(){
					$(this).trigger('jGrowl.beforeClose');
				});
			}
		});
	
		/** Reference the Defaults Object for compatibility with older versions of jGrowl **/
		$.jGrowl.defaults = $.fn.jGrowl.prototype.defaults;
	
	})(jQuery);


/***/ }),
/* 224 */
/***/ (function(module, exports) {

	/*
	 * jQuery JSON Plugin
	 * version: 1.0 (2008-04-17)
	 *
	 * This document is licensed as free software under the terms of the
	 * MIT License: http://www.opensource.org/licenses/mit-license.php
	 *
	 * Brantley Harris technically wrote this plugin, but it is based somewhat
	 * on the JSON.org website's http://www.json.org/json2.js, which proclaims:
	 * "NO WARRANTY EXPRESSED OR IMPLIED. USE AT YOUR OWN RISK.", a sentiment that
	 * I uphold.  I really just cleaned it up.
	 *
	 * It is also based heavily on MochiKit's serializeJSON, which is 
	 * copywrited 2005 by Bob Ippolito.
	 */
	 
	(function($) {   
	    function toIntegersAtLease(n) 
	    // Format integers to have at least two digits.
	    {    
	        return n < 10 ? '0' + n : n;
	    }
	
	    Date.prototype.toJSON = function()
	    // Yes, it polutes the Date namespace, but we'll allow it here, as
	    // it's damned usefull.
	    {
	        return this.getUTCFullYear()   + '-' +
	             toIntegersAtLease(this.getUTCMonth()) + '-' +
	             toIntegersAtLease(this.getUTCDate());
	    };
	
	    var escapeable = /["\\\x00-\x1f\x7f-\x9f]/g;
	    var meta = {    // table of character substitutions
	            '\b': '\\b',
	            '\t': '\\t',
	            '\n': '\\n',
	            '\f': '\\f',
	            '\r': '\\r',
	            '"' : '\\"',
	            '\\': '\\\\'
	        };
	        
	    $.quoteString = function(string)
	    // Places quotes around a string, inteligently.
	    // If the string contains no control characters, no quote characters, and no
	    // backslash characters, then we can safely slap some quotes around it.
	    // Otherwise we must also replace the offending characters with safe escape
	    // sequences.
	    {
	        if (escapeable.test(string))
	        {
	            return '"' + string.replace(escapeable, function (a) 
	            {
	                var c = meta[a];
	                if (typeof c === 'string') {
	                    return c;
	                }
	                c = a.charCodeAt();
	                return '\\u00' + Math.floor(c / 16).toString(16) + (c % 16).toString(16);
	            }) + '"';
	        }
	        return '"' + string + '"';
	    };
	    
	    $.toJSON = function(o, compact)
	    {
	        var type = typeof(o);
	        
	        if (type == "undefined")
	            return "undefined";
	        else if (type == "number" || type == "boolean")
	            return o + "";
	        else if (o === null)
	            return "null";
	        
	        // Is it a string?
	        if (type == "string") 
	        {
	            return $.quoteString(o);
	        }
	        
	        // Does it have a .toJSON function?
	        if (type == "object" && typeof o.toJSON == "function") 
	            return o.toJSON(compact);
	        
	        // Is it an array?
	        if (type != "function" && typeof(o.length) == "number") 
	        {
	            var ret = [];
	            for (var i = 0; i < o.length; i++) {
	                ret.push( $.toJSON(o[i], compact) );
	            }
	            if (compact)
	                return "[" + ret.join(",") + "]";
	            else
	                return "[" + ret.join(", ") + "]";
	        }
	        
	        // If it's a function, we have to warn somebody!
	        if (type == "function") {
	            throw new TypeError("Unable to convert object of type 'function' to json.");
	        }
	        
	        // It's probably an object, then.
	        ret = [];
	        for (var k in o) {
	            var name;
	            type = typeof(k);
	            
	            if (type == "number")
	                name = '"' + k + '"';
	            else if (type == "string")
	                name = $.quoteString(k);
	            else
	                continue;  //skip non-string or number keys
	            
	            var val = $.toJSON(o[k], compact);
	            if (typeof(val) != "string") {
	                // skip non-serializable values
	                continue;
	            }
	            
	            if (compact)
	                ret.push(name + ":" + val);
	            else
	                ret.push(name + ": " + val);
	        }
	        return "{" + ret.join(", ") + "}";
	    };
	    
	    $.compactJSON = function(o)
	    {
	        return $.toJSON(o, true);
	    };
	    
	    $.evalJSON = function(src)
	    // Evals JSON that we know to be safe.
	    {
	        return eval("(" + src + ")");
	    };
	    
	    $.secureEvalJSON = function(src)
	    // Evals JSON in a way that is *more* secure.
	    {
	        var filtered = src;
	        filtered = filtered.replace(/\\["\\\/bfnrtu]/g, '@');
	        filtered = filtered.replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']');
	        filtered = filtered.replace(/(?:^|:|,)(?:\s*\[)+/g, '');
	        
	        if (/^[\],:{}\s]*$/.test(filtered))
	            return eval("(" + src + ")");
	        else
	            throw new SyntaxError("Error parsing JSON, source is not valid.");
	    };
	})(jQuery);


/***/ }),
/* 225 */,
/* 226 */
/***/ (function(module, exports) {

	/*!
	 * jQuery Templates Plugin 1.0.0pre
	 * http://github.com/jquery/jquery-tmpl
	 * Requires jQuery 1.4.2
	 *
	 * Copyright Software Freedom Conservancy, Inc.
	 * Dual licensed under the MIT or GPL Version 2 licenses.
	 * http://jquery.org/license
	 */
	(function( jQuery, undefined ){
	  var oldManip = jQuery.fn.domManip, tmplItmAtt = "_tmplitem", htmlExpr = /^[^<]*(<[\w\W]+>)[^>]*$|\{\{\! /,
	    newTmplItems = {}, wrappedItems = {}, appendToTmplItems, topTmplItem = { key: 0, data: {} }, itemKey = 0, cloneIndex = 0, stack = [];
	
	  function newTmplItem( options, parentItem, fn, data ) {
	    // Returns a template item data structure for a new rendered instance of a template (a 'template item').
	    // The content field is a hierarchical array of strings and nested items (to be
	    // removed and replaced by nodes field of dom elements, once inserted in DOM).
	    var newItem = {
	      data: data || (data === 0 || data === false) ? data : (parentItem ? parentItem.data : {}),
	      _wrap: parentItem ? parentItem._wrap : null,
	      tmpl: null,
	      parent: parentItem || null,
	      nodes: [],
	      calls: tiCalls,
	      nest: tiNest,
	      wrap: tiWrap,
	      html: tiHtml,
	      update: tiUpdate
	    };
	    if ( options ) {
	      jQuery.extend( newItem, options, { nodes: [], parent: parentItem });
	    }
	    if ( fn ) {
	      // Build the hierarchical content to be used during insertion into DOM
	      newItem.tmpl = fn;
	      newItem._ctnt = newItem._ctnt || newItem.tmpl( jQuery, newItem );
	      newItem.key = ++itemKey;
	      // Keep track of new template item, until it is stored as jQuery Data on DOM element
	      (stack.length ? wrappedItems : newTmplItems)[itemKey] = newItem;
	    }
	    return newItem;
	  }
	
	  // Override appendTo etc., in order to provide support for targeting multiple elements. (This code would disappear if integrated in jquery core).
	  jQuery.each({
	    appendTo: "append",
	    prependTo: "prepend",
	    insertBefore: "before",
	    insertAfter: "after",
	    replaceAll: "replaceWith"
	  }, function( name, original ) {
	    jQuery.fn[ name ] = function( selector ) {
	      var ret = [], insert = jQuery( selector ), elems, i, l, tmplItems,
	        parent = this.length === 1 && this[0].parentNode;
	
	      appendToTmplItems = newTmplItems || {};
	      if ( parent && parent.nodeType === 11 && parent.childNodes.length === 1 && insert.length === 1 ) {
	        insert[ original ]( this[0] );
	        ret = this;
	      } else {
	        for ( i = 0, l = insert.length; i < l; i++ ) {
	          cloneIndex = i;
	          elems = (i > 0 ? this.clone(true) : this).get();
	          jQuery( insert[i] )[ original ]( elems );
	          ret = ret.concat( elems );
	        }
	        cloneIndex = 0;
	        ret = this.pushStack( ret, name, insert.selector );
	      }
	      tmplItems = appendToTmplItems;
	      appendToTmplItems = null;
	      jQuery.tmpl.complete( tmplItems );
	      return ret;
	    };
	  });
	
	  jQuery.fn.extend({
	    // Use first wrapped element as template markup.
	    // Return wrapped set of template items, obtained by rendering template against data.
	    tmpl: function( data, options, parentItem ) {
	      return jQuery.tmpl( this[0], data, options, parentItem );
	    },
	
	    // Find which rendered template item the first wrapped DOM element belongs to
	    tmplItem: function() {
	      return jQuery.tmplItem( this[0] );
	    },
	
	    // Consider the first wrapped element as a template declaration, and get the compiled template or store it as a named template.
	    template: function( name ) {
	      return jQuery.template( name, this[0] );
	    },
	
	    domManip: function( args, table, callback, options ) {
	      if ( args[0] && jQuery.isArray( args[0] )) {
	        var dmArgs = jQuery.makeArray( arguments ), elems = args[0], elemsLength = elems.length, i = 0, tmplItem;
	        while ( i < elemsLength && !(tmplItem = jQuery.data( elems[i++], "tmplItem" ))) {}
	        if ( tmplItem && cloneIndex ) {
	          dmArgs[2] = function( fragClone ) {
	            // Handler called by oldManip when rendered template has been inserted into DOM.
	            jQuery.tmpl.afterManip( this, fragClone, callback );
	          };
	        }
	        oldManip.apply( this, dmArgs );
	      } else {
	        oldManip.apply( this, arguments );
	      }
	      cloneIndex = 0;
	      if ( !appendToTmplItems ) {
	        jQuery.tmpl.complete( newTmplItems );
	      }
	      return this;
	    }
	  });
	
	  jQuery.extend({
	    // Return wrapped set of template items, obtained by rendering template against data.
	    tmpl: function( tmpl, data, options, parentItem ) {
	      var ret, topLevel = !parentItem;
	      if ( topLevel ) {
	        // This is a top-level tmpl call (not from a nested template using {{tmpl}})
	        parentItem = topTmplItem;
	        tmpl = jQuery.template[tmpl] || jQuery.template( null, tmpl );
	        wrappedItems = {}; // Any wrapped items will be rebuilt, since this is top level
	      } else if ( !tmpl ) {
	        // The template item is already associated with DOM - this is a refresh.
	        // Re-evaluate rendered template for the parentItem
	        tmpl = parentItem.tmpl;
	        newTmplItems[parentItem.key] = parentItem;
	        parentItem.nodes = [];
	        if ( parentItem.wrapped ) {
	          updateWrapped( parentItem, parentItem.wrapped );
	        }
	        // Rebuild, without creating a new template item
	        return jQuery( build( parentItem, null, parentItem.tmpl( jQuery, parentItem ) ));
	      }
	      if ( !tmpl ) {
	        return []; // Could throw...
	      }
	      if ( typeof data === "function" ) {
	        data = data.call( parentItem || {} );
	      }
	      if ( options && options.wrapped ) {
	        updateWrapped( options, options.wrapped );
	      }
	      ret = jQuery.isArray( data ) ?
	        jQuery.map( data, function( dataItem ) {
	          return dataItem ? newTmplItem( options, parentItem, tmpl, dataItem ) : null;
	        }) :
	        [ newTmplItem( options, parentItem, tmpl, data ) ];
	      return topLevel ? jQuery( build( parentItem, null, ret ) ) : ret;
	    },
	
	    // Return rendered template item for an element.
	    tmplItem: function( elem ) {
	      var tmplItem;
	      if ( elem instanceof jQuery ) {
	        elem = elem[0];
	      }
	      while ( elem && elem.nodeType === 1 && !(tmplItem = jQuery.data( elem, "tmplItem" )) && (elem = elem.parentNode) ) {}
	      return tmplItem || topTmplItem;
	    },
	
	    // Set:
	    // Use $.template( name, tmpl ) to cache a named template,
	    // where tmpl is a template string, a script element or a jQuery instance wrapping a script element, etc.
	    // Use $( "selector" ).template( name ) to provide access by name to a script block template declaration.
	
	    // Get:
	    // Use $.template( name ) to access a cached template.
	    // Also $( selectorToScriptBlock ).template(), or $.template( null, templateString )
	    // will return the compiled template, without adding a name reference.
	    // If templateString includes at least one HTML tag, $.template( templateString ) is equivalent
	    // to $.template( null, templateString )
	    template: function( name, tmpl ) {
	      if (tmpl) {
	        // Compile template and associate with name
	        if ( typeof tmpl === "string" ) {
	          // This is an HTML string being passed directly in.
	          tmpl = buildTmplFn( tmpl );
	        } else if ( tmpl instanceof jQuery ) {
	          tmpl = tmpl[0] || {};
	        }
	        if ( tmpl.nodeType ) {
	          // If this is a template block, use cached copy, or generate tmpl function and cache.
	          tmpl = jQuery.data( tmpl, "tmpl" ) || jQuery.data( tmpl, "tmpl", buildTmplFn( tmpl.innerHTML ));
	          // Issue: In IE, if the container element is not a script block, the innerHTML will remove quotes from attribute values whenever the value does not include white space.
	          // This means that foo="${x}" will not work if the value of x includes white space: foo="${x}" -> foo=value of x.
	          // To correct this, include space in tag: foo="${ x }" -> foo="value of x"
	        }
	        return typeof name === "string" ? (jQuery.template[name] = tmpl) : tmpl;
	      }
	      // Return named compiled template
	      return name ? (typeof name !== "string" ? jQuery.template( null, name ):
	        (jQuery.template[name] ||
	          // If not in map, and not containing at least on HTML tag, treat as a selector.
	          // (If integrated with core, use quickExpr.exec)
	          jQuery.template( null, htmlExpr.test( name ) ? name : jQuery( name )))) : null;
	    },
	
	    encode: function( text ) {
	      // Do HTML encoding replacing < > & and ' and " by corresponding entities.
	      return ("" + text).split("<").join("&lt;").split(">").join("&gt;").split('"').join("&#34;").split("'").join("&#39;");
	    }
	  });
	
	  jQuery.extend( jQuery.tmpl, {
	    tag: {
	      "tmpl": {
	        _default: { $2: "null" },
	        open: "if($notnull_1){__=__.concat($item.nest($1,$2));}"
	        // tmpl target parameter can be of type function, so use $1, not $1a (so not auto detection of functions)
	        // This means that {{tmpl foo}} treats foo as a template (which IS a function).
	        // Explicit parens can be used if foo is a function that returns a template: {{tmpl foo()}}.
	      },
	      "wrap": {
	        _default: { $2: "null" },
	        open: "$item.calls(__,$1,$2);__=[];",
	        close: "call=$item.calls();__=call._.concat($item.wrap(call,__));"
	      },
	      "each": {
	        _default: { $2: "$index, $value" },
	        open: "if($notnull_1){$.each($1a,function($2){with(this){",
	        close: "}});}"
	      },
	      "if": {
	        open: "if(($notnull_1) && $1a){",
	        close: "}"
	      },
	      "else": {
	        _default: { $1: "true" },
	        open: "}else if(($notnull_1) && $1a){"
	      },
	      "html": {
	        // Unecoded expression evaluation.
	        open: "if($notnull_1){__.push($1a);}"
	      },
	      "=": {
	        // Encoded expression evaluation. Abbreviated form is ${}.
	        _default: { $1: "$data" },
	        open: "if($notnull_1){__.push($.encode($1a));}"
	      },
	      "!": {
	        // Comment tag. Skipped by parser
	        open: ""
	      }
	    },
	
	    // This stub can be overridden, e.g. in jquery.tmplPlus for providing rendered events
	    complete: function( items ) {
	      newTmplItems = {};
	    },
	
	    // Call this from code which overrides domManip, or equivalent
	    // Manage cloning/storing template items etc.
	    afterManip: function afterManip( elem, fragClone, callback ) {
	      // Provides cloned fragment ready for fixup prior to and after insertion into DOM
	      var content = fragClone.nodeType === 11 ?
	        jQuery.makeArray(fragClone.childNodes) :
	        fragClone.nodeType === 1 ? [fragClone] : [];
	
	      // Return fragment to original caller (e.g. append) for DOM insertion
	      callback.call( elem, fragClone );
	
	      // Fragment has been inserted:- Add inserted nodes to tmplItem data structure. Replace inserted element annotations by jQuery.data.
	      storeTmplItems( content );
	      cloneIndex++;
	    }
	  });
	
	  //========================== Private helper functions, used by code above ==========================
	
	  function build( tmplItem, nested, content ) {
	    // Convert hierarchical content into flat string array
	    // and finally return array of fragments ready for DOM insertion
	    var frag, ret = content ? jQuery.map( content, function( item ) {
	      return (typeof item === "string") ?
	        // Insert template item annotations, to be converted to jQuery.data( "tmplItem" ) when elems are inserted into DOM.
	        (tmplItem.key ? item.replace( /(<\w+)(?=[\s>])(?![^>]*_tmplitem)([^>]*)/g, "$1 " + tmplItmAtt + "=\"" + tmplItem.key + "\" $2" ) : item) :
	        // This is a child template item. Build nested template.
	        build( item, tmplItem, item._ctnt );
	    }) :
	    // If content is not defined, insert tmplItem directly. Not a template item. May be a string, or a string array, e.g. from {{html $item.html()}}.
	    tmplItem;
	    if ( nested ) {
	      return ret;
	    }
	
	    // top-level template
	    ret = ret.join("");
	
	    // Support templates which have initial or final text nodes, or consist only of text
	    // Also support HTML entities within the HTML markup.
	    ret.replace( /^\s*([^<\s][^<]*)?(<[\w\W]+>)([^>]*[^>\s])?\s*$/, function( all, before, middle, after) {
	      frag = jQuery( middle ).get();
	
	      storeTmplItems( frag );
	      if ( before ) {
	        frag = unencode( before ).concat(frag);
	      }
	      if ( after ) {
	        frag = frag.concat(unencode( after ));
	      }
	    });
	    return frag ? frag : unencode( ret );
	  }
	
	  function unencode( text ) {
	    // Use createElement, since createTextNode will not render HTML entities correctly
	    var el = document.createElement( "div" );
	    el.innerHTML = text;
	    return jQuery.makeArray(el.childNodes);
	  }
	
	  // Generate a reusable function that will serve to render a template against data
	  function buildTmplFn( markup ) {
	    return new Function("jQuery","$item",
	      // Use the variable __ to hold a string array while building the compiled template. (See https://github.com/jquery/jquery-tmpl/issues#issue/10).
	      "var $=jQuery,call,__=[],$data=$item.data;" +
	
	      // Introduce the data as local variables using with(){}
	      "with($data){__.push('" +
	
	      // Convert the template into pure JavaScript
	      jQuery.trim(markup)
	        .replace( /([\\'])/g, "\\$1" )
	        .replace( /[\r\t\n]/g, " " )
	        .replace( /\$\{([^\}]*)\}/g, "{{= $1}}" )
	        .replace( /\{\{(\/?)(\w+|.)(?:\(((?:[^\}]|\}(?!\}))*?)?\))?(?:\s+(.*?)?)?(\(((?:[^\}]|\}(?!\}))*?)\))?\s*\}\}/g,
	        function( all, slash, type, fnargs, target, parens, args ) {
	          var tag = jQuery.tmpl.tag[ type ], def, expr, exprAutoFnDetect;
	          if ( !tag ) {
	            throw "Unknown template tag: " + type;
	          }
	          def = tag._default || [];
	          if ( parens && !/\w$/.test(target)) {
	            target += parens;
	            parens = "";
	          }
	          if ( target ) {
	            target = unescape( target );
	            args = args ? ("," + unescape( args ) + ")") : (parens ? ")" : "");
	            // Support for target being things like a.toLowerCase();
	            // In that case don't call with template item as 'this' pointer. Just evaluate...
	            expr = parens ? (target.indexOf(".") > -1 ? target + unescape( parens ) : ("(" + target + ").call($item" + args)) : target;
	            exprAutoFnDetect = parens ? expr : "(typeof(" + target + ")==='function'?(" + target + ").call($item):(" + target + "))";
	          } else {
	            exprAutoFnDetect = expr = def.$1 || "null";
	          }
	          fnargs = unescape( fnargs );
	          return "');" +
	            tag[ slash ? "close" : "open" ]
	              .split( "$notnull_1" ).join( target ? "typeof(" + target + ")!=='undefined' && (" + target + ")!=null" : "true" )
	              .split( "$1a" ).join( exprAutoFnDetect )
	              .split( "$1" ).join( expr )
	              .split( "$2" ).join( fnargs || def.$2 || "" ) +
	            "__.push('";
	        }) +
	      "');}return __;"
	    );
	  }
	  function updateWrapped( options, wrapped ) {
	    // Build the wrapped content.
	    options._wrap = build( options, true,
	      // Suport imperative scenario in which options.wrapped can be set to a selector or an HTML string.
	      jQuery.isArray( wrapped ) ? wrapped : [htmlExpr.test( wrapped ) ? wrapped : jQuery( wrapped ).html()]
	    ).join("");
	  }
	
	  function unescape( args ) {
	    return args ? args.replace( /\\'/g, "'").replace(/\\\\/g, "\\" ) : null;
	  }
	  function outerHtml( elem ) {
	    var div = document.createElement("div");
	    div.appendChild( elem.cloneNode(true) );
	    return div.innerHTML;
	  }
	
	  // Store template items in jQuery.data(), ensuring a unique tmplItem data data structure for each rendered template instance.
	  function storeTmplItems( content ) {
	    var keySuffix = "_" + cloneIndex, elem, elems, newClonedItems = {}, i, l, m;
	    for ( i = 0, l = content.length; i < l; i++ ) {
	      if ( (elem = content[i]).nodeType !== 1 ) {
	        continue;
	      }
	      elems = elem.getElementsByTagName("*");
	      for ( m = elems.length - 1; m >= 0; m-- ) {
	        processItemKey( elems[m] );
	      }
	      processItemKey( elem );
	    }
	    function processItemKey( el ) {
	      var pntKey, pntNode = el, pntItem, tmplItem, key;
	      // Ensure that each rendered template inserted into the DOM has its own template item,
	      if ( (key = el.getAttribute( tmplItmAtt ))) {
	        while ( pntNode.parentNode && (pntNode = pntNode.parentNode).nodeType === 1 && !(pntKey = pntNode.getAttribute( tmplItmAtt ))) { }
	        if ( pntKey !== key ) {
	          // The next ancestor with a _tmplitem expando is on a different key than this one.
	          // So this is a top-level element within this template item
	          // Set pntNode to the key of the parentNode, or to 0 if pntNode.parentNode is null, or pntNode is a fragment.
	          pntNode = pntNode.parentNode ? (pntNode.nodeType === 11 ? 0 : (pntNode.getAttribute( tmplItmAtt ) || 0)) : 0;
	          if ( !(tmplItem = newTmplItems[key]) ) {
	            // The item is for wrapped content, and was copied from the temporary parent wrappedItem.
	            tmplItem = wrappedItems[key];
	            tmplItem = newTmplItem( tmplItem, newTmplItems[pntNode]||wrappedItems[pntNode] );
	            tmplItem.key = ++itemKey;
	            newTmplItems[itemKey] = tmplItem;
	          }
	          if ( cloneIndex ) {
	            cloneTmplItem( key );
	          }
	        }
	        el.removeAttribute( tmplItmAtt );
	      } else if ( cloneIndex && (tmplItem = jQuery.data( el, "tmplItem" )) ) {
	        // This was a rendered element, cloned during append or appendTo etc.
	        // TmplItem stored in jQuery data has already been cloned in cloneCopyEvent. We must replace it with a fresh cloned tmplItem.
	        cloneTmplItem( tmplItem.key );
	        newTmplItems[tmplItem.key] = tmplItem;
	        pntNode = jQuery.data( el.parentNode, "tmplItem" );
	        pntNode = pntNode ? pntNode.key : 0;
	      }
	      if ( tmplItem ) {
	        pntItem = tmplItem;
	        // Find the template item of the parent element.
	        // (Using !=, not !==, since pntItem.key is number, and pntNode may be a string)
	        while ( pntItem && pntItem.key != pntNode ) {
	          // Add this element as a top-level node for this rendered template item, as well as for any
	          // ancestor items between this item and the item of its parent element
	          pntItem.nodes.push( el );
	          pntItem = pntItem.parent;
	        }
	        // Delete content built during rendering - reduce API surface area and memory use, and avoid exposing of stale data after rendering...
	        delete tmplItem._ctnt;
	        delete tmplItem._wrap;
	        // Store template item as jQuery data on the element
	        jQuery.data( el, "tmplItem", tmplItem );
	      }
	      function cloneTmplItem( key ) {
	        key = key + keySuffix;
	        tmplItem = newClonedItems[key] =
	          (newClonedItems[key] || newTmplItem( tmplItem, newTmplItems[tmplItem.parent.key + keySuffix] || tmplItem.parent ));
	      }
	    }
	  }
	
	  //---- Helper functions for template item ----
	
	  function tiCalls( content, tmpl, data, options ) {
	    if ( !content ) {
	      return stack.pop();
	    }
	    stack.push({ _: content, tmpl: tmpl, item:this, data: data, options: options });
	  }
	
	  function tiNest( tmpl, data, options ) {
	    // nested template, using {{tmpl}} tag
	    return jQuery.tmpl( jQuery.template( tmpl ), data, options, this );
	  }
	
	  function tiWrap( call, wrapped ) {
	    // nested template, using {{wrap}} tag
	    var options = call.options || {};
	    options.wrapped = wrapped;
	    // Apply the template, which may incorporate wrapped content,
	    return jQuery.tmpl( jQuery.template( call.tmpl ), call.data, options, call.item );
	  }
	
	  function tiHtml( filter, textOnly ) {
	    var wrapped = this._wrap;
	    return jQuery.map(
	      jQuery( jQuery.isArray( wrapped ) ? wrapped.join("") : wrapped ).filter( filter || "*" ),
	      function(e) {
	        return textOnly ?
	          e.innerText || e.textContent :
	          e.outerHTML || outerHtml(e);
	      });
	  }
	
	  function tiUpdate() {
	    var coll = this.nodes;
	    jQuery.tmpl( null, null, null, this).insertBefore( coll[0] );
	    jQuery( coll ).remove();
	  }
	})( jQuery );


/***/ }),
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */
/***/ (function(module, exports) {

	/*
	 * Thickbox 3.1 - One Box To Rule Them All.
	 * By Cody Lindley (http://www.codylindley.com)
	 * Copyright (c) 2007 cody lindley
	 * Licensed under the MIT License: http://www.opensource.org/licenses/mit-license.php
	 *
	 * Modification by Zack Ham: added no_close_on_blur param for ajax requests,
	 *   switched to using event delegation.
	 *
	 * Modification by Quinn Rohlf: removed jQuery.browser reference. As an aside, Thickbox
	 * is essentially abandonware at this point (updated 08/08/2007) and if you're
	 * considering implementing functionality that relies on it, please reconsider
	*/
	
	var tb_pathToImage = "/images/loadingAnimation.gif?2000000000";
	
	/*!!!!!!!!!!!!!!!!! edit below this line at your own risk !!!!!!!!!!!!!!!!!!!!!!!*/
	
	var imgLoader,
	TB_WIDTH,
	TB_HEIGHT,
	TB_PrevCaption,
	TB_PrevURL,
	TB_PrevHTML,
	TB_NextHTML,
	TB_imageCount,
	TB_FoundURL,
	TB_NextURL,
	TB_NextCaption,
	imgPreloader,
	arrayPageSize,
	ajaxContentH,
	ajaxContentW,
	keycode;
	
	//on page load call tb_init
	$(document).ready(function(){
		tb_init('a.thickbox, area.thickbox, input.thickbox');//pass where to apply thickbox
		imgLoader = new Image();// preload image
		imgLoader.src = tb_pathToImage;
	});
	
	//add thickbox to href & area elements that have a class of .thickbox
	window.tb_init = function tb_init(domChunk){
		$(domChunk).on('click', function(){
		var t = this.title || this.name || null;
		var a = this.href || this.alt;
		var g = this.rel || false;
		tb_show(t,a,g);
		this.blur();
		return false;
		});
	}
	
	window.autoResize = function autoResize() {
	  var $first = $($("#TB_ajaxContent").children().get(0));
	  if($first) {
	    $("#TB_ajaxContent").height($first.height() + 10);
	  }
	}
	
	window.tb_show = function tb_show(caption, url, imageGroup) {//function called when the user clicks on a thickbox link
		try {
			var params = {};
			if (typeof document.body.style.maxHeight === "undefined") {//if IE 6
				$("body","html").css({height: "100%", width: "100%"});
				$("html").css("overflow","hidden");
				if (document.getElementById("TB_HideSelect") === null) {//iframe to hide select elements in ie6
					$("body").append("<iframe id='TB_HideSelect'></iframe><div id='TB_overlay'></div><div id='TB_window'></div>");
					$("#TB_overlay").click(tb_remove);
				}
			}else{//all others
				if(document.getElementById("TB_overlay") === null){
					$("body").append("<div id='TB_overlay'></div><div id='TB_window'></div>");
					$("#TB_overlay").click(tb_remove);
				}
			}
	
			if(tb_detectMacXFF()){
				$("#TB_overlay").addClass("TB_overlayMacFFBGHack");//use png overlay so hide flash
			}else{
				$("#TB_overlay").addClass("TB_overlayBG");//use background and opacity
			}
	
			if(caption===null){caption="";}
			$("body").append("<div id='TB_load'><img src='"+imgLoader.src+"' /></div>");//add loader to the page
			$('#TB_load').show();//show loader
	
			var baseURL;
		   if(url.indexOf("?")!==-1){ //ff there is a query string involved
				baseURL = url.substr(0, url.indexOf("?"));
		   }else{
		   		baseURL = url;
		   }
	
		   var urlString = /\.jpg$|\.jpeg$|\.png$|\.gif$|\.bmp$/;
		   var urlType = baseURL.toLowerCase().match(urlString);
	
			if(urlType == '.jpg' || urlType == '.jpeg' || urlType == '.png' || urlType == '.gif' || urlType == '.bmp'){//code to show images
	
				TB_PrevCaption = "";
				TB_PrevURL = "";
				TB_PrevHTML = "";
				TB_NextCaption = "";
				TB_NextURL = "";
				TB_NextHTML = "";
				TB_imageCount = "";
				TB_FoundURL = false;
				if(imageGroup){
					TB_TempArray = $("a[@rel="+imageGroup+"]").get();
					for (TB_Counter = 0; ((TB_Counter < TB_TempArray.length) && (TB_NextHTML === "")); TB_Counter++) {
						var urlTypeTemp = TB_TempArray[TB_Counter].href.toLowerCase().match(urlString);
							if (!(TB_TempArray[TB_Counter].href == url)) {
								if (TB_FoundURL) {
									TB_NextCaption = TB_TempArray[TB_Counter].title;
									TB_NextURL = TB_TempArray[TB_Counter].href;
									TB_NextHTML = "<span id='TB_next'>&nbsp;&nbsp;<a href='#'>Next &gt;</a></span>";
								} else {
									TB_PrevCaption = TB_TempArray[TB_Counter].title;
									TB_PrevURL = TB_TempArray[TB_Counter].href;
									TB_PrevHTML = "<span id='TB_prev'>&nbsp;&nbsp;<a href='#'>&lt; Prev</a></span>";
								}
							} else {
								TB_FoundURL = true;
								TB_imageCount = "Image " + (TB_Counter + 1) +" of "+ (TB_TempArray.length);
							}
					}
				}
	
				imgPreloader = new Image();
				imgPreloader.onload = function(){
				imgPreloader.onload = null;
	
				// Resizing large images - orginal by Christian Montoya edited by me.
				var pagesize = tb_getPageSize();
				var x = pagesize[0] - 150;
				var y = pagesize[1] - 150;
				var imageWidth = imgPreloader.width;
				var imageHeight = imgPreloader.height;
				if (imageWidth > x) {
					imageHeight = imageHeight * (x / imageWidth);
					imageWidth = x;
					if (imageHeight > y) {
						imageWidth = imageWidth * (y / imageHeight);
						imageHeight = y;
					}
				} else if (imageHeight > y) {
					imageWidth = imageWidth * (y / imageHeight);
					imageHeight = y;
					if (imageWidth > x) {
						imageHeight = imageHeight * (x / imageWidth);
						imageWidth = x;
					}
				}
				// End Resizing
	
				TB_WIDTH = imageWidth + 30;
				TB_HEIGHT = imageHeight + 60;
				$("#TB_window").append("<a href='' id='TB_ImageOff' title='Close'><img id='TB_Image' src='"+url+"' width='"+imageWidth+"' height='"+imageHeight+"' alt='"+caption+"'/></a>" + "<div id='TB_caption'>"+caption+"<div id='TB_secondLine'>" + TB_imageCount + TB_PrevHTML + TB_NextHTML + "</div></div><div id='TB_closeWindow'><a href='#' id='TB_closeWindowButton' title='Close'><div id='TB_closeImg'></div></a></div>");
	
				$("#TB_closeWindowButton").click(tb_remove);
	
				if (!(TB_PrevHTML === "")) {
					function goPrev(){
						if($(document).unbind("click",goPrev)){$(document).unbind("click",goPrev);}
						$("#TB_window").remove();
						$("body").append("<div id='TB_window'></div>");
						tb_show(TB_PrevCaption, TB_PrevURL, imageGroup);
						return false;
					}
					$("#TB_prev").click(goPrev);
				}
	
				if (!(TB_NextHTML === "")) {
					function goNext(){
						$("#TB_window").remove();
						$("body").append("<div id='TB_window'></div>");
						tb_show(TB_NextCaption, TB_NextURL, imageGroup);
						return false;
					}
					$("#TB_next").click(goNext);
	
				}
	
				document.onkeydown = function(e){
					if (e == null) { // ie
						keycode = event.keyCode;
					} else { // mozilla
						keycode = e.which;
					}
					if(keycode == 27){ // close
						tb_remove();
					} else if(keycode == 190){ // display previous image
						if(!(TB_NextHTML == "")){
							document.onkeydown = "";
							goNext();
						}
					} else if(keycode == 188){ // display next image
						if(!(TB_PrevHTML == "")){
							document.onkeydown = "";
							goPrev();
						}
					}
				};
	
				tb_position();
				$("#TB_load").remove();
				$("#TB_ImageOff").click(tb_remove);
				$("#TB_window").css({display:"block"}); //for safari using css instead of show
				};
	
				imgPreloader.src = url;
			}else{//code to show html
				var queryString = url.replace(/^[^\?]+\??/,'');
				var params = tb_parseQuery( queryString );
	
				TB_WIDTH = (params['width']*1) + 30 || 630; //defaults to 630 if no paramaters were added to URL
				TB_HEIGHT = (params['height']*1) + 40 || 440; //defaults to 440 if no paramaters were added to URL
				ajaxContentW = TB_WIDTH - 30;
				ajaxContentH = TB_HEIGHT - 45;
	
				if(url.indexOf('TB_iframe') != -1){// either iframe or ajax window
						urlNoQuery = url.split('TB_');
						$("#TB_iframeContent").remove();
						if(params['modal'] != "true"){//iframe no modal
							$("#TB_window").append("<iframe frameborder='0' hspace='0' src='"+urlNoQuery[0]+"' id='TB_iframeContent' name='TB_iframeContent"+Math.round(Math.random()*1000)+"' onload='tb_showIframe()' style='width:"+(ajaxContentW + 29)+"px;height:"+(ajaxContentH + 17)+"px;' > </iframe>");
						}else{//iframe modal
						$("#TB_overlay").unbind();
							$("#TB_window").append("<iframe frameborder='0' hspace='0' src='"+urlNoQuery[0]+"' id='TB_iframeContent' name='TB_iframeContent"+Math.round(Math.random()*1000)+"' onload='tb_showIframe()' style='width:"+(ajaxContentW + 29)+"px;height:"+(ajaxContentH + 17)+"px;'> </iframe>");
						}
				}else{// not an iframe, ajax
						if($("#TB_window").css("display") != "block"){
							if(params['modal'] == "true"){//ajax modal
							$("#TB_overlay").unbind();
	  					$("#TB_window").append("<div id='TB_ajaxContent' class='TB_modal' style='width:"+ajaxContentW+"px;height:"+ajaxContentH+"px;'></div>");
	            }else if(params['no_close_on_blur'] == 'true'){
	          	$("#TB_overlay").unbind();
	          	$("#TB_window").append("<div id='TB_closeAjaxWindow'><a href='#' id='TB_closeWindowButton' title='Close'><div id='TB_closeImg'></div></a></div><div id='TB_ajaxContent' style='width:"+ajaxContentW+"px;height:"+ajaxContentH+"px'></div>");
							}else{//ajax modal
							$("#TB_window").append("<div id='TB_closeAjaxWindow'><a href='#' id='TB_closeWindowButton' title='Close'><div id='TB_closeImg'></div></a></div><div id='TB_ajaxContent' style='width:"+ajaxContentW+"px;height:"+ajaxContentH+"px'></div>");
							}
						}else{//this means the window is already up, we are just loading new content via ajax
							$("#TB_ajaxContent")[0].style.width = ajaxContentW +"px";
							$("#TB_ajaxContent")[0].style.height = ajaxContentH +"px";
							$("#TB_ajaxContent")[0].scrollTop = 0;
							$("#TB_ajaxWindowTitle").html(caption);
						}
				}
	
				$("#TB_closeWindowButton").click(tb_remove);
	
					if(url.indexOf('TB_inline') != -1){
						$("#TB_ajaxContent").append($('#' + params['inlineId']).children());
						$("#TB_window").unload(function () {
							$('#' + params['inlineId']).append( $("#TB_ajaxContent").children() ); // move elements back when you're finished
						});
						tb_position();
						$("#TB_load").remove();
						$("#TB_window").css({display:"block"});
	          if(params['autoresize'] == "true")
	            autoResize();
					}else if(url.indexOf('TB_iframe') != -1){
						tb_position();
						// the following two instructions were previously in an
						// if block, but it's okay to break them out since they'll
						// just be noops if the iframe onload fired correctly
						$("#TB_load").remove();
						$("#TB_window").css({display:"block"});
	          if(params['autoresize'] == "true")
	            jutoResize();
					}else{
						$("#TB_ajaxContent").load(url += "&random=" + (new Date().getTime()),function(){//to do a post change this load method
							tb_position();
							$("#TB_load").remove();
							tb_init("#TB_ajaxContent a.thickbox");
							$("#TB_window").css({display:"block"});
	            if(params['autoresize'] == "true")
	              autoResize();
						});
					}
			}
	
			if(!params['modal']){
				document.onkeyup = function(e){
					if (e == null) { // ie
						keycode = event.keyCode;
					} else { // mozilla
						keycode = e.which;
					}
					if(keycode == 27){ // close
						tb_remove();
					}
				};
			}
		} catch(e) {
	    console.log("ey!")
	    console.log(e)
			//nothing here
		}
	  $('body').trigger('tb:show');
	}
	
	//helper functions below
	window.tb_showIframe = function tb_showIframe(){
		$("#TB_load").remove();
		$("#TB_window").css({display:"block"});
	}
	
	window.tb_remove = function tb_remove() {
	 	$("#TB_imageOff").unbind("click");
		$("#TB_closeWindowButton").unbind("click");
		$("#TB_window").fadeOut("fast",function(){$('#TB_window,#TB_overlay,#TB_HideSelect').trigger("unload").unbind().remove();});
		$("#TB_load").remove();
		if (typeof document.body.style.maxHeight == "undefined") {//if IE 6
			$("body","html").css({height: "auto", width: "auto"});
			$("html").css("overflow","");
		}
		document.onkeydown = "";
		document.onkeyup = "";
	  $('body').trigger('tb:remove');
		return false;
	}
	
	window.tb_position = function tb_position() {
	$("#TB_window").css({marginLeft: '-' + parseInt((TB_WIDTH / 2),10) + 'px', width: TB_WIDTH + 'px'});
		if ( !(jQuery.browser.msie && jQuery.browser.version < 7)) { // take away IE6
			$("#TB_window").css({marginTop: '-' + parseInt((TB_HEIGHT / 2),10) + 'px'});
		}
	}
	
	window.tb_parseQuery = function tb_parseQuery ( query ) {
	   var Params = {};
	   if ( ! query ) {return Params;}// return empty object
	   var Pairs = query.split(/[;&]/);
	   for ( var i = 0; i < Pairs.length; i++ ) {
	      var KeyVal = Pairs[i].split('=');
	      if ( ! KeyVal || KeyVal.length != 2 ) {continue;}
	      var key = unescape( KeyVal[0] );
	      var val = unescape( KeyVal[1] );
	      val = val.replace(/\+/g, ' ');
	      Params[key] = val;
	   }
	   return Params;
	}
	
	window.tb_getPageSize = function tb_getPageSize(){
		var de = document.documentElement;
		var w = window.innerWidth || self.innerWidth || (de&&de.clientWidth) || document.body.clientWidth;
		var h = window.innerHeight || self.innerHeight || (de&&de.clientHeight) || document.body.clientHeight;
		arrayPageSize = [w,h];
		return arrayPageSize;
	}
	
	window.tb_detectMacXFF = function tb_detectMacXFF() {
	  var userAgent = navigator.userAgent.toLowerCase();
	  if (userAgent.indexOf('mac') != -1 && userAgent.indexOf('firefox')!=-1) {
	    return true;
	  }
	}


/***/ }),
/* 231 */,
/* 232 */,
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	var require;var require;/*! remarkable 1.5.0 https://github.com//jonschlinkert/remarkable @license MIT */
	!function(e){if(true)module.exports=e();else if("function"==typeof define&&define.amd)define([],e);else{var t;"undefined"!=typeof window?t=window:"undefined"!=typeof global?t=global:"undefined"!=typeof self&&(t=self),t.Remarkable=e()}}(function(){var e;return function t(e,r,n){function s(i,l){if(!r[i]){if(!e[i]){var a="function"==typeof require&&require;if(!l&&a)return require(i,!0);if(o)return o(i,!0);var c=new Error("Cannot find module '"+i+"'");throw c.code="MODULE_NOT_FOUND",c}var u=r[i]={exports:{}};e[i][0].call(u.exports,function(t){var r=e[i][1][t];return s(r?r:t)},u,u.exports,t,e,r,n)}return r[i].exports}for(var o="function"==typeof require&&require,i=0;i<n.length;i++)s(n[i]);return s}({1:[function(e,t){"use strict";t.exports={Aacute:"Á",aacute:"á",Abreve:"Ă",abreve:"ă",ac:"∾",acd:"∿",acE:"∾̳",Acirc:"Â",acirc:"â",acute:"´",Acy:"А",acy:"а",AElig:"Æ",aelig:"æ",af:"⁡",Afr:"𝔄",afr:"𝔞",Agrave:"À",agrave:"à",alefsym:"ℵ",aleph:"ℵ",Alpha:"Α",alpha:"α",Amacr:"Ā",amacr:"ā",amalg:"⨿",AMP:"&",amp:"&",And:"⩓",and:"∧",andand:"⩕",andd:"⩜",andslope:"⩘",andv:"⩚",ang:"∠",ange:"⦤",angle:"∠",angmsd:"∡",angmsdaa:"⦨",angmsdab:"⦩",angmsdac:"⦪",angmsdad:"⦫",angmsdae:"⦬",angmsdaf:"⦭",angmsdag:"⦮",angmsdah:"⦯",angrt:"∟",angrtvb:"⊾",angrtvbd:"⦝",angsph:"∢",angst:"Å",angzarr:"⍼",Aogon:"Ą",aogon:"ą",Aopf:"𝔸",aopf:"𝕒",ap:"≈",apacir:"⩯",apE:"⩰",ape:"≊",apid:"≋",apos:"'",ApplyFunction:"⁡",approx:"≈",approxeq:"≊",Aring:"Å",aring:"å",Ascr:"𝒜",ascr:"𝒶",Assign:"≔",ast:"*",asymp:"≈",asympeq:"≍",Atilde:"Ã",atilde:"ã",Auml:"Ä",auml:"ä",awconint:"∳",awint:"⨑",backcong:"≌",backepsilon:"϶",backprime:"‵",backsim:"∽",backsimeq:"⋍",Backslash:"∖",Barv:"⫧",barvee:"⊽",Barwed:"⌆",barwed:"⌅",barwedge:"⌅",bbrk:"⎵",bbrktbrk:"⎶",bcong:"≌",Bcy:"Б",bcy:"б",bdquo:"„",becaus:"∵",Because:"∵",because:"∵",bemptyv:"⦰",bepsi:"϶",bernou:"ℬ",Bernoullis:"ℬ",Beta:"Β",beta:"β",beth:"ℶ",between:"≬",Bfr:"𝔅",bfr:"𝔟",bigcap:"⋂",bigcirc:"◯",bigcup:"⋃",bigodot:"⨀",bigoplus:"⨁",bigotimes:"⨂",bigsqcup:"⨆",bigstar:"★",bigtriangledown:"▽",bigtriangleup:"△",biguplus:"⨄",bigvee:"⋁",bigwedge:"⋀",bkarow:"⤍",blacklozenge:"⧫",blacksquare:"▪",blacktriangle:"▴",blacktriangledown:"▾",blacktriangleleft:"◂",blacktriangleright:"▸",blank:"␣",blk12:"▒",blk14:"░",blk34:"▓",block:"█",bne:"=⃥",bnequiv:"≡⃥",bNot:"⫭",bnot:"⌐",Bopf:"𝔹",bopf:"𝕓",bot:"⊥",bottom:"⊥",bowtie:"⋈",boxbox:"⧉",boxDL:"╗",boxDl:"╖",boxdL:"╕",boxdl:"┐",boxDR:"╔",boxDr:"╓",boxdR:"╒",boxdr:"┌",boxH:"═",boxh:"─",boxHD:"╦",boxHd:"╤",boxhD:"╥",boxhd:"┬",boxHU:"╩",boxHu:"╧",boxhU:"╨",boxhu:"┴",boxminus:"⊟",boxplus:"⊞",boxtimes:"⊠",boxUL:"╝",boxUl:"╜",boxuL:"╛",boxul:"┘",boxUR:"╚",boxUr:"╙",boxuR:"╘",boxur:"└",boxV:"║",boxv:"│",boxVH:"╬",boxVh:"╫",boxvH:"╪",boxvh:"┼",boxVL:"╣",boxVl:"╢",boxvL:"╡",boxvl:"┤",boxVR:"╠",boxVr:"╟",boxvR:"╞",boxvr:"├",bprime:"‵",Breve:"˘",breve:"˘",brvbar:"¦",Bscr:"ℬ",bscr:"𝒷",bsemi:"⁏",bsim:"∽",bsime:"⋍",bsol:"\\",bsolb:"⧅",bsolhsub:"⟈",bull:"•",bullet:"•",bump:"≎",bumpE:"⪮",bumpe:"≏",Bumpeq:"≎",bumpeq:"≏",Cacute:"Ć",cacute:"ć",Cap:"⋒",cap:"∩",capand:"⩄",capbrcup:"⩉",capcap:"⩋",capcup:"⩇",capdot:"⩀",CapitalDifferentialD:"ⅅ",caps:"∩︀",caret:"⁁",caron:"ˇ",Cayleys:"ℭ",ccaps:"⩍",Ccaron:"Č",ccaron:"č",Ccedil:"Ç",ccedil:"ç",Ccirc:"Ĉ",ccirc:"ĉ",Cconint:"∰",ccups:"⩌",ccupssm:"⩐",Cdot:"Ċ",cdot:"ċ",cedil:"¸",Cedilla:"¸",cemptyv:"⦲",cent:"¢",CenterDot:"·",centerdot:"·",Cfr:"ℭ",cfr:"𝔠",CHcy:"Ч",chcy:"ч",check:"✓",checkmark:"✓",Chi:"Χ",chi:"χ",cir:"○",circ:"ˆ",circeq:"≗",circlearrowleft:"↺",circlearrowright:"↻",circledast:"⊛",circledcirc:"⊚",circleddash:"⊝",CircleDot:"⊙",circledR:"®",circledS:"Ⓢ",CircleMinus:"⊖",CirclePlus:"⊕",CircleTimes:"⊗",cirE:"⧃",cire:"≗",cirfnint:"⨐",cirmid:"⫯",cirscir:"⧂",ClockwiseContourIntegral:"∲",CloseCurlyDoubleQuote:"”",CloseCurlyQuote:"’",clubs:"♣",clubsuit:"♣",Colon:"∷",colon:":",Colone:"⩴",colone:"≔",coloneq:"≔",comma:",",commat:"@",comp:"∁",compfn:"∘",complement:"∁",complexes:"ℂ",cong:"≅",congdot:"⩭",Congruent:"≡",Conint:"∯",conint:"∮",ContourIntegral:"∮",Copf:"ℂ",copf:"𝕔",coprod:"∐",Coproduct:"∐",COPY:"©",copy:"©",copysr:"℗",CounterClockwiseContourIntegral:"∳",crarr:"↵",Cross:"⨯",cross:"✗",Cscr:"𝒞",cscr:"𝒸",csub:"⫏",csube:"⫑",csup:"⫐",csupe:"⫒",ctdot:"⋯",cudarrl:"⤸",cudarrr:"⤵",cuepr:"⋞",cuesc:"⋟",cularr:"↶",cularrp:"⤽",Cup:"⋓",cup:"∪",cupbrcap:"⩈",CupCap:"≍",cupcap:"⩆",cupcup:"⩊",cupdot:"⊍",cupor:"⩅",cups:"∪︀",curarr:"↷",curarrm:"⤼",curlyeqprec:"⋞",curlyeqsucc:"⋟",curlyvee:"⋎",curlywedge:"⋏",curren:"¤",curvearrowleft:"↶",curvearrowright:"↷",cuvee:"⋎",cuwed:"⋏",cwconint:"∲",cwint:"∱",cylcty:"⌭",Dagger:"‡",dagger:"†",daleth:"ℸ",Darr:"↡",dArr:"⇓",darr:"↓",dash:"‐",Dashv:"⫤",dashv:"⊣",dbkarow:"⤏",dblac:"˝",Dcaron:"Ď",dcaron:"ď",Dcy:"Д",dcy:"д",DD:"ⅅ",dd:"ⅆ",ddagger:"‡",ddarr:"⇊",DDotrahd:"⤑",ddotseq:"⩷",deg:"°",Del:"∇",Delta:"Δ",delta:"δ",demptyv:"⦱",dfisht:"⥿",Dfr:"𝔇",dfr:"𝔡",dHar:"⥥",dharl:"⇃",dharr:"⇂",DiacriticalAcute:"´",DiacriticalDot:"˙",DiacriticalDoubleAcute:"˝",DiacriticalGrave:"`",DiacriticalTilde:"˜",diam:"⋄",Diamond:"⋄",diamond:"⋄",diamondsuit:"♦",diams:"♦",die:"¨",DifferentialD:"ⅆ",digamma:"ϝ",disin:"⋲",div:"÷",divide:"÷",divideontimes:"⋇",divonx:"⋇",DJcy:"Ђ",djcy:"ђ",dlcorn:"⌞",dlcrop:"⌍",dollar:"$",Dopf:"𝔻",dopf:"𝕕",Dot:"¨",dot:"˙",DotDot:"⃜",doteq:"≐",doteqdot:"≑",DotEqual:"≐",dotminus:"∸",dotplus:"∔",dotsquare:"⊡",doublebarwedge:"⌆",DoubleContourIntegral:"∯",DoubleDot:"¨",DoubleDownArrow:"⇓",DoubleLeftArrow:"⇐",DoubleLeftRightArrow:"⇔",DoubleLeftTee:"⫤",DoubleLongLeftArrow:"⟸",DoubleLongLeftRightArrow:"⟺",DoubleLongRightArrow:"⟹",DoubleRightArrow:"⇒",DoubleRightTee:"⊨",DoubleUpArrow:"⇑",DoubleUpDownArrow:"⇕",DoubleVerticalBar:"∥",DownArrow:"↓",Downarrow:"⇓",downarrow:"↓",DownArrowBar:"⤓",DownArrowUpArrow:"⇵",DownBreve:"̑",downdownarrows:"⇊",downharpoonleft:"⇃",downharpoonright:"⇂",DownLeftRightVector:"⥐",DownLeftTeeVector:"⥞",DownLeftVector:"↽",DownLeftVectorBar:"⥖",DownRightTeeVector:"⥟",DownRightVector:"⇁",DownRightVectorBar:"⥗",DownTee:"⊤",DownTeeArrow:"↧",drbkarow:"⤐",drcorn:"⌟",drcrop:"⌌",Dscr:"𝒟",dscr:"𝒹",DScy:"Ѕ",dscy:"ѕ",dsol:"⧶",Dstrok:"Đ",dstrok:"đ",dtdot:"⋱",dtri:"▿",dtrif:"▾",duarr:"⇵",duhar:"⥯",dwangle:"⦦",DZcy:"Џ",dzcy:"џ",dzigrarr:"⟿",Eacute:"É",eacute:"é",easter:"⩮",Ecaron:"Ě",ecaron:"ě",ecir:"≖",Ecirc:"Ê",ecirc:"ê",ecolon:"≕",Ecy:"Э",ecy:"э",eDDot:"⩷",Edot:"Ė",eDot:"≑",edot:"ė",ee:"ⅇ",efDot:"≒",Efr:"𝔈",efr:"𝔢",eg:"⪚",Egrave:"È",egrave:"è",egs:"⪖",egsdot:"⪘",el:"⪙",Element:"∈",elinters:"⏧",ell:"ℓ",els:"⪕",elsdot:"⪗",Emacr:"Ē",emacr:"ē",empty:"∅",emptyset:"∅",EmptySmallSquare:"◻",emptyv:"∅",EmptyVerySmallSquare:"▫",emsp:" ",emsp13:" ",emsp14:" ",ENG:"Ŋ",eng:"ŋ",ensp:" ",Eogon:"Ę",eogon:"ę",Eopf:"𝔼",eopf:"𝕖",epar:"⋕",eparsl:"⧣",eplus:"⩱",epsi:"ε",Epsilon:"Ε",epsilon:"ε",epsiv:"ϵ",eqcirc:"≖",eqcolon:"≕",eqsim:"≂",eqslantgtr:"⪖",eqslantless:"⪕",Equal:"⩵",equals:"=",EqualTilde:"≂",equest:"≟",Equilibrium:"⇌",equiv:"≡",equivDD:"⩸",eqvparsl:"⧥",erarr:"⥱",erDot:"≓",Escr:"ℰ",escr:"ℯ",esdot:"≐",Esim:"⩳",esim:"≂",Eta:"Η",eta:"η",ETH:"Ð",eth:"ð",Euml:"Ë",euml:"ë",euro:"€",excl:"!",exist:"∃",Exists:"∃",expectation:"ℰ",ExponentialE:"ⅇ",exponentiale:"ⅇ",fallingdotseq:"≒",Fcy:"Ф",fcy:"ф",female:"♀",ffilig:"ﬃ",fflig:"ﬀ",ffllig:"ﬄ",Ffr:"𝔉",ffr:"𝔣",filig:"ﬁ",FilledSmallSquare:"◼",FilledVerySmallSquare:"▪",fjlig:"fj",flat:"♭",fllig:"ﬂ",fltns:"▱",fnof:"ƒ",Fopf:"𝔽",fopf:"𝕗",ForAll:"∀",forall:"∀",fork:"⋔",forkv:"⫙",Fouriertrf:"ℱ",fpartint:"⨍",frac12:"½",frac13:"⅓",frac14:"¼",frac15:"⅕",frac16:"⅙",frac18:"⅛",frac23:"⅔",frac25:"⅖",frac34:"¾",frac35:"⅗",frac38:"⅜",frac45:"⅘",frac56:"⅚",frac58:"⅝",frac78:"⅞",frasl:"⁄",frown:"⌢",Fscr:"ℱ",fscr:"𝒻",gacute:"ǵ",Gamma:"Γ",gamma:"γ",Gammad:"Ϝ",gammad:"ϝ",gap:"⪆",Gbreve:"Ğ",gbreve:"ğ",Gcedil:"Ģ",Gcirc:"Ĝ",gcirc:"ĝ",Gcy:"Г",gcy:"г",Gdot:"Ġ",gdot:"ġ",gE:"≧",ge:"≥",gEl:"⪌",gel:"⋛",geq:"≥",geqq:"≧",geqslant:"⩾",ges:"⩾",gescc:"⪩",gesdot:"⪀",gesdoto:"⪂",gesdotol:"⪄",gesl:"⋛︀",gesles:"⪔",Gfr:"𝔊",gfr:"𝔤",Gg:"⋙",gg:"≫",ggg:"⋙",gimel:"ℷ",GJcy:"Ѓ",gjcy:"ѓ",gl:"≷",gla:"⪥",glE:"⪒",glj:"⪤",gnap:"⪊",gnapprox:"⪊",gnE:"≩",gne:"⪈",gneq:"⪈",gneqq:"≩",gnsim:"⋧",Gopf:"𝔾",gopf:"𝕘",grave:"`",GreaterEqual:"≥",GreaterEqualLess:"⋛",GreaterFullEqual:"≧",GreaterGreater:"⪢",GreaterLess:"≷",GreaterSlantEqual:"⩾",GreaterTilde:"≳",Gscr:"𝒢",gscr:"ℊ",gsim:"≳",gsime:"⪎",gsiml:"⪐",GT:">",Gt:"≫",gt:">",gtcc:"⪧",gtcir:"⩺",gtdot:"⋗",gtlPar:"⦕",gtquest:"⩼",gtrapprox:"⪆",gtrarr:"⥸",gtrdot:"⋗",gtreqless:"⋛",gtreqqless:"⪌",gtrless:"≷",gtrsim:"≳",gvertneqq:"≩︀",gvnE:"≩︀",Hacek:"ˇ",hairsp:" ",half:"½",hamilt:"ℋ",HARDcy:"Ъ",hardcy:"ъ",hArr:"⇔",harr:"↔",harrcir:"⥈",harrw:"↭",Hat:"^",hbar:"ℏ",Hcirc:"Ĥ",hcirc:"ĥ",hearts:"♥",heartsuit:"♥",hellip:"…",hercon:"⊹",Hfr:"ℌ",hfr:"𝔥",HilbertSpace:"ℋ",hksearow:"⤥",hkswarow:"⤦",hoarr:"⇿",homtht:"∻",hookleftarrow:"↩",hookrightarrow:"↪",Hopf:"ℍ",hopf:"𝕙",horbar:"―",HorizontalLine:"─",Hscr:"ℋ",hscr:"𝒽",hslash:"ℏ",Hstrok:"Ħ",hstrok:"ħ",HumpDownHump:"≎",HumpEqual:"≏",hybull:"⁃",hyphen:"‐",Iacute:"Í",iacute:"í",ic:"⁣",Icirc:"Î",icirc:"î",Icy:"И",icy:"и",Idot:"İ",IEcy:"Е",iecy:"е",iexcl:"¡",iff:"⇔",Ifr:"ℑ",ifr:"𝔦",Igrave:"Ì",igrave:"ì",ii:"ⅈ",iiiint:"⨌",iiint:"∭",iinfin:"⧜",iiota:"℩",IJlig:"Ĳ",ijlig:"ĳ",Im:"ℑ",Imacr:"Ī",imacr:"ī",image:"ℑ",ImaginaryI:"ⅈ",imagline:"ℐ",imagpart:"ℑ",imath:"ı",imof:"⊷",imped:"Ƶ",Implies:"⇒","in":"∈",incare:"℅",infin:"∞",infintie:"⧝",inodot:"ı",Int:"∬","int":"∫",intcal:"⊺",integers:"ℤ",Integral:"∫",intercal:"⊺",Intersection:"⋂",intlarhk:"⨗",intprod:"⨼",InvisibleComma:"⁣",InvisibleTimes:"⁢",IOcy:"Ё",iocy:"ё",Iogon:"Į",iogon:"į",Iopf:"𝕀",iopf:"𝕚",Iota:"Ι",iota:"ι",iprod:"⨼",iquest:"¿",Iscr:"ℐ",iscr:"𝒾",isin:"∈",isindot:"⋵",isinE:"⋹",isins:"⋴",isinsv:"⋳",isinv:"∈",it:"⁢",Itilde:"Ĩ",itilde:"ĩ",Iukcy:"І",iukcy:"і",Iuml:"Ï",iuml:"ï",Jcirc:"Ĵ",jcirc:"ĵ",Jcy:"Й",jcy:"й",Jfr:"𝔍",jfr:"𝔧",jmath:"ȷ",Jopf:"𝕁",jopf:"𝕛",Jscr:"𝒥",jscr:"𝒿",Jsercy:"Ј",jsercy:"ј",Jukcy:"Є",jukcy:"є",Kappa:"Κ",kappa:"κ",kappav:"ϰ",Kcedil:"Ķ",kcedil:"ķ",Kcy:"К",kcy:"к",Kfr:"𝔎",kfr:"𝔨",kgreen:"ĸ",KHcy:"Х",khcy:"х",KJcy:"Ќ",kjcy:"ќ",Kopf:"𝕂",kopf:"𝕜",Kscr:"𝒦",kscr:"𝓀",lAarr:"⇚",Lacute:"Ĺ",lacute:"ĺ",laemptyv:"⦴",lagran:"ℒ",Lambda:"Λ",lambda:"λ",Lang:"⟪",lang:"⟨",langd:"⦑",langle:"⟨",lap:"⪅",Laplacetrf:"ℒ",laquo:"«",Larr:"↞",lArr:"⇐",larr:"←",larrb:"⇤",larrbfs:"⤟",larrfs:"⤝",larrhk:"↩",larrlp:"↫",larrpl:"⤹",larrsim:"⥳",larrtl:"↢",lat:"⪫",lAtail:"⤛",latail:"⤙",late:"⪭",lates:"⪭︀",lBarr:"⤎",lbarr:"⤌",lbbrk:"❲",lbrace:"{",lbrack:"[",lbrke:"⦋",lbrksld:"⦏",lbrkslu:"⦍",Lcaron:"Ľ",lcaron:"ľ",Lcedil:"Ļ",lcedil:"ļ",lceil:"⌈",lcub:"{",Lcy:"Л",lcy:"л",ldca:"⤶",ldquo:"“",ldquor:"„",ldrdhar:"⥧",ldrushar:"⥋",ldsh:"↲",lE:"≦",le:"≤",LeftAngleBracket:"⟨",LeftArrow:"←",Leftarrow:"⇐",leftarrow:"←",LeftArrowBar:"⇤",LeftArrowRightArrow:"⇆",leftarrowtail:"↢",LeftCeiling:"⌈",LeftDoubleBracket:"⟦",LeftDownTeeVector:"⥡",LeftDownVector:"⇃",LeftDownVectorBar:"⥙",LeftFloor:"⌊",leftharpoondown:"↽",leftharpoonup:"↼",leftleftarrows:"⇇",LeftRightArrow:"↔",Leftrightarrow:"⇔",leftrightarrow:"↔",leftrightarrows:"⇆",leftrightharpoons:"⇋",leftrightsquigarrow:"↭",LeftRightVector:"⥎",LeftTee:"⊣",LeftTeeArrow:"↤",LeftTeeVector:"⥚",leftthreetimes:"⋋",LeftTriangle:"⊲",LeftTriangleBar:"⧏",LeftTriangleEqual:"⊴",LeftUpDownVector:"⥑",LeftUpTeeVector:"⥠",LeftUpVector:"↿",LeftUpVectorBar:"⥘",LeftVector:"↼",LeftVectorBar:"⥒",lEg:"⪋",leg:"⋚",leq:"≤",leqq:"≦",leqslant:"⩽",les:"⩽",lescc:"⪨",lesdot:"⩿",lesdoto:"⪁",lesdotor:"⪃",lesg:"⋚︀",lesges:"⪓",lessapprox:"⪅",lessdot:"⋖",lesseqgtr:"⋚",lesseqqgtr:"⪋",LessEqualGreater:"⋚",LessFullEqual:"≦",LessGreater:"≶",lessgtr:"≶",LessLess:"⪡",lesssim:"≲",LessSlantEqual:"⩽",LessTilde:"≲",lfisht:"⥼",lfloor:"⌊",Lfr:"𝔏",lfr:"𝔩",lg:"≶",lgE:"⪑",lHar:"⥢",lhard:"↽",lharu:"↼",lharul:"⥪",lhblk:"▄",LJcy:"Љ",ljcy:"љ",Ll:"⋘",ll:"≪",llarr:"⇇",llcorner:"⌞",Lleftarrow:"⇚",llhard:"⥫",lltri:"◺",Lmidot:"Ŀ",lmidot:"ŀ",lmoust:"⎰",lmoustache:"⎰",lnap:"⪉",lnapprox:"⪉",lnE:"≨",lne:"⪇",lneq:"⪇",lneqq:"≨",lnsim:"⋦",loang:"⟬",loarr:"⇽",lobrk:"⟦",LongLeftArrow:"⟵",Longleftarrow:"⟸",longleftarrow:"⟵",LongLeftRightArrow:"⟷",Longleftrightarrow:"⟺",longleftrightarrow:"⟷",longmapsto:"⟼",LongRightArrow:"⟶",Longrightarrow:"⟹",longrightarrow:"⟶",looparrowleft:"↫",looparrowright:"↬",lopar:"⦅",Lopf:"𝕃",lopf:"𝕝",loplus:"⨭",lotimes:"⨴",lowast:"∗",lowbar:"_",LowerLeftArrow:"↙",LowerRightArrow:"↘",loz:"◊",lozenge:"◊",lozf:"⧫",lpar:"(",lparlt:"⦓",lrarr:"⇆",lrcorner:"⌟",lrhar:"⇋",lrhard:"⥭",lrm:"‎",lrtri:"⊿",lsaquo:"‹",Lscr:"ℒ",lscr:"𝓁",Lsh:"↰",lsh:"↰",lsim:"≲",lsime:"⪍",lsimg:"⪏",lsqb:"[",lsquo:"‘",lsquor:"‚",Lstrok:"Ł",lstrok:"ł",LT:"<",Lt:"≪",lt:"<",ltcc:"⪦",ltcir:"⩹",ltdot:"⋖",lthree:"⋋",ltimes:"⋉",ltlarr:"⥶",ltquest:"⩻",ltri:"◃",ltrie:"⊴",ltrif:"◂",ltrPar:"⦖",lurdshar:"⥊",luruhar:"⥦",lvertneqq:"≨︀",lvnE:"≨︀",macr:"¯",male:"♂",malt:"✠",maltese:"✠",Map:"⤅",map:"↦",mapsto:"↦",mapstodown:"↧",mapstoleft:"↤",mapstoup:"↥",marker:"▮",mcomma:"⨩",Mcy:"М",mcy:"м",mdash:"—",mDDot:"∺",measuredangle:"∡",MediumSpace:" ",Mellintrf:"ℳ",Mfr:"𝔐",mfr:"𝔪",mho:"℧",micro:"µ",mid:"∣",midast:"*",midcir:"⫰",middot:"·",minus:"−",minusb:"⊟",minusd:"∸",minusdu:"⨪",MinusPlus:"∓",mlcp:"⫛",mldr:"…",mnplus:"∓",models:"⊧",Mopf:"𝕄",mopf:"𝕞",mp:"∓",Mscr:"ℳ",mscr:"𝓂",mstpos:"∾",Mu:"Μ",mu:"μ",multimap:"⊸",mumap:"⊸",nabla:"∇",Nacute:"Ń",nacute:"ń",nang:"∠⃒",nap:"≉",napE:"⩰̸",napid:"≋̸",napos:"ŉ",napprox:"≉",natur:"♮",natural:"♮",naturals:"ℕ",nbsp:" ",nbump:"≎̸",nbumpe:"≏̸",ncap:"⩃",Ncaron:"Ň",ncaron:"ň",Ncedil:"Ņ",ncedil:"ņ",ncong:"≇",ncongdot:"⩭̸",ncup:"⩂",Ncy:"Н",ncy:"н",ndash:"–",ne:"≠",nearhk:"⤤",neArr:"⇗",nearr:"↗",nearrow:"↗",nedot:"≐̸",NegativeMediumSpace:"​",NegativeThickSpace:"​",NegativeThinSpace:"​",NegativeVeryThinSpace:"​",nequiv:"≢",nesear:"⤨",nesim:"≂̸",NestedGreaterGreater:"≫",NestedLessLess:"≪",NewLine:"\n",nexist:"∄",nexists:"∄",Nfr:"𝔑",nfr:"𝔫",ngE:"≧̸",nge:"≱",ngeq:"≱",ngeqq:"≧̸",ngeqslant:"⩾̸",nges:"⩾̸",nGg:"⋙̸",ngsim:"≵",nGt:"≫⃒",ngt:"≯",ngtr:"≯",nGtv:"≫̸",nhArr:"⇎",nharr:"↮",nhpar:"⫲",ni:"∋",nis:"⋼",nisd:"⋺",niv:"∋",NJcy:"Њ",njcy:"њ",nlArr:"⇍",nlarr:"↚",nldr:"‥",nlE:"≦̸",nle:"≰",nLeftarrow:"⇍",nleftarrow:"↚",nLeftrightarrow:"⇎",nleftrightarrow:"↮",nleq:"≰",nleqq:"≦̸",nleqslant:"⩽̸",nles:"⩽̸",nless:"≮",nLl:"⋘̸",nlsim:"≴",nLt:"≪⃒",nlt:"≮",nltri:"⋪",nltrie:"⋬",nLtv:"≪̸",nmid:"∤",NoBreak:"⁠",NonBreakingSpace:" ",Nopf:"ℕ",nopf:"𝕟",Not:"⫬",not:"¬",NotCongruent:"≢",NotCupCap:"≭",NotDoubleVerticalBar:"∦",NotElement:"∉",NotEqual:"≠",NotEqualTilde:"≂̸",NotExists:"∄",NotGreater:"≯",NotGreaterEqual:"≱",NotGreaterFullEqual:"≧̸",NotGreaterGreater:"≫̸",NotGreaterLess:"≹",NotGreaterSlantEqual:"⩾̸",NotGreaterTilde:"≵",NotHumpDownHump:"≎̸",NotHumpEqual:"≏̸",notin:"∉",notindot:"⋵̸",notinE:"⋹̸",notinva:"∉",notinvb:"⋷",notinvc:"⋶",NotLeftTriangle:"⋪",NotLeftTriangleBar:"⧏̸",NotLeftTriangleEqual:"⋬",NotLess:"≮",NotLessEqual:"≰",NotLessGreater:"≸",NotLessLess:"≪̸",NotLessSlantEqual:"⩽̸",NotLessTilde:"≴",NotNestedGreaterGreater:"⪢̸",NotNestedLessLess:"⪡̸",notni:"∌",notniva:"∌",notnivb:"⋾",notnivc:"⋽",NotPrecedes:"⊀",NotPrecedesEqual:"⪯̸",NotPrecedesSlantEqual:"⋠",NotReverseElement:"∌",NotRightTriangle:"⋫",NotRightTriangleBar:"⧐̸",NotRightTriangleEqual:"⋭",NotSquareSubset:"⊏̸",NotSquareSubsetEqual:"⋢",NotSquareSuperset:"⊐̸",NotSquareSupersetEqual:"⋣",NotSubset:"⊂⃒",NotSubsetEqual:"⊈",NotSucceeds:"⊁",NotSucceedsEqual:"⪰̸",NotSucceedsSlantEqual:"⋡",NotSucceedsTilde:"≿̸",NotSuperset:"⊃⃒",NotSupersetEqual:"⊉",NotTilde:"≁",NotTildeEqual:"≄",NotTildeFullEqual:"≇",NotTildeTilde:"≉",NotVerticalBar:"∤",npar:"∦",nparallel:"∦",nparsl:"⫽⃥",npart:"∂̸",npolint:"⨔",npr:"⊀",nprcue:"⋠",npre:"⪯̸",nprec:"⊀",npreceq:"⪯̸",nrArr:"⇏",nrarr:"↛",nrarrc:"⤳̸",nrarrw:"↝̸",nRightarrow:"⇏",nrightarrow:"↛",nrtri:"⋫",nrtrie:"⋭",nsc:"⊁",nsccue:"⋡",nsce:"⪰̸",Nscr:"𝒩",nscr:"𝓃",nshortmid:"∤",nshortparallel:"∦",nsim:"≁",nsime:"≄",nsimeq:"≄",nsmid:"∤",nspar:"∦",nsqsube:"⋢",nsqsupe:"⋣",nsub:"⊄",nsubE:"⫅̸",nsube:"⊈",nsubset:"⊂⃒",nsubseteq:"⊈",nsubseteqq:"⫅̸",nsucc:"⊁",nsucceq:"⪰̸",nsup:"⊅",nsupE:"⫆̸",nsupe:"⊉",nsupset:"⊃⃒",nsupseteq:"⊉",nsupseteqq:"⫆̸",ntgl:"≹",Ntilde:"Ñ",ntilde:"ñ",ntlg:"≸",ntriangleleft:"⋪",ntrianglelefteq:"⋬",ntriangleright:"⋫",ntrianglerighteq:"⋭",Nu:"Ν",nu:"ν",num:"#",numero:"№",numsp:" ",nvap:"≍⃒",nVDash:"⊯",nVdash:"⊮",nvDash:"⊭",nvdash:"⊬",nvge:"≥⃒",nvgt:">⃒",nvHarr:"⤄",nvinfin:"⧞",nvlArr:"⤂",nvle:"≤⃒",nvlt:"<⃒",nvltrie:"⊴⃒",nvrArr:"⤃",nvrtrie:"⊵⃒",nvsim:"∼⃒",nwarhk:"⤣",nwArr:"⇖",nwarr:"↖",nwarrow:"↖",nwnear:"⤧",Oacute:"Ó",oacute:"ó",oast:"⊛",ocir:"⊚",Ocirc:"Ô",ocirc:"ô",Ocy:"О",ocy:"о",odash:"⊝",Odblac:"Ő",odblac:"ő",odiv:"⨸",odot:"⊙",odsold:"⦼",OElig:"Œ",oelig:"œ",ofcir:"⦿",Ofr:"𝔒",ofr:"𝔬",ogon:"˛",Ograve:"Ò",ograve:"ò",ogt:"⧁",ohbar:"⦵",ohm:"Ω",oint:"∮",olarr:"↺",olcir:"⦾",olcross:"⦻",oline:"‾",olt:"⧀",Omacr:"Ō",omacr:"ō",Omega:"Ω",omega:"ω",Omicron:"Ο",omicron:"ο",omid:"⦶",ominus:"⊖",Oopf:"𝕆",oopf:"𝕠",opar:"⦷",OpenCurlyDoubleQuote:"“",OpenCurlyQuote:"‘",operp:"⦹",oplus:"⊕",Or:"⩔",or:"∨",orarr:"↻",ord:"⩝",order:"ℴ",orderof:"ℴ",ordf:"ª",ordm:"º",origof:"⊶",oror:"⩖",orslope:"⩗",orv:"⩛",oS:"Ⓢ",Oscr:"𝒪",oscr:"ℴ",Oslash:"Ø",oslash:"ø",osol:"⊘",Otilde:"Õ",otilde:"õ",Otimes:"⨷",otimes:"⊗",otimesas:"⨶",Ouml:"Ö",ouml:"ö",ovbar:"⌽",OverBar:"‾",OverBrace:"⏞",OverBracket:"⎴",OverParenthesis:"⏜",par:"∥",para:"¶",parallel:"∥",parsim:"⫳",parsl:"⫽",part:"∂",PartialD:"∂",Pcy:"П",pcy:"п",percnt:"%",period:".",permil:"‰",perp:"⊥",pertenk:"‱",Pfr:"𝔓",pfr:"𝔭",Phi:"Φ",phi:"φ",phiv:"ϕ",phmmat:"ℳ",phone:"☎",Pi:"Π",pi:"π",pitchfork:"⋔",piv:"ϖ",planck:"ℏ",planckh:"ℎ",plankv:"ℏ",plus:"+",plusacir:"⨣",plusb:"⊞",pluscir:"⨢",plusdo:"∔",plusdu:"⨥",pluse:"⩲",PlusMinus:"±",plusmn:"±",plussim:"⨦",plustwo:"⨧",pm:"±",Poincareplane:"ℌ",pointint:"⨕",Popf:"ℙ",popf:"𝕡",pound:"£",Pr:"⪻",pr:"≺",prap:"⪷",prcue:"≼",prE:"⪳",pre:"⪯",prec:"≺",precapprox:"⪷",preccurlyeq:"≼",Precedes:"≺",PrecedesEqual:"⪯",PrecedesSlantEqual:"≼",PrecedesTilde:"≾",preceq:"⪯",precnapprox:"⪹",precneqq:"⪵",precnsim:"⋨",precsim:"≾",Prime:"″",prime:"′",primes:"ℙ",prnap:"⪹",prnE:"⪵",prnsim:"⋨",prod:"∏",Product:"∏",profalar:"⌮",profline:"⌒",profsurf:"⌓",prop:"∝",Proportion:"∷",Proportional:"∝",propto:"∝",prsim:"≾",prurel:"⊰",Pscr:"𝒫",pscr:"𝓅",Psi:"Ψ",psi:"ψ",puncsp:" ",Qfr:"𝔔",qfr:"𝔮",qint:"⨌",Qopf:"ℚ",qopf:"𝕢",qprime:"⁗",Qscr:"𝒬",qscr:"𝓆",quaternions:"ℍ",quatint:"⨖",quest:"?",questeq:"≟",QUOT:'"',quot:'"',rAarr:"⇛",race:"∽̱",Racute:"Ŕ",racute:"ŕ",radic:"√",raemptyv:"⦳",Rang:"⟫",rang:"⟩",rangd:"⦒",range:"⦥",rangle:"⟩",raquo:"»",Rarr:"↠",rArr:"⇒",rarr:"→",rarrap:"⥵",rarrb:"⇥",rarrbfs:"⤠",rarrc:"⤳",rarrfs:"⤞",rarrhk:"↪",rarrlp:"↬",rarrpl:"⥅",rarrsim:"⥴",Rarrtl:"⤖",rarrtl:"↣",rarrw:"↝",rAtail:"⤜",ratail:"⤚",ratio:"∶",rationals:"ℚ",RBarr:"⤐",rBarr:"⤏",rbarr:"⤍",rbbrk:"❳",rbrace:"}",rbrack:"]",rbrke:"⦌",rbrksld:"⦎",rbrkslu:"⦐",Rcaron:"Ř",rcaron:"ř",Rcedil:"Ŗ",rcedil:"ŗ",rceil:"⌉",rcub:"}",Rcy:"Р",rcy:"р",rdca:"⤷",rdldhar:"⥩",rdquo:"”",rdquor:"”",rdsh:"↳",Re:"ℜ",real:"ℜ",realine:"ℛ",realpart:"ℜ",reals:"ℝ",rect:"▭",REG:"®",reg:"®",ReverseElement:"∋",ReverseEquilibrium:"⇋",ReverseUpEquilibrium:"⥯",rfisht:"⥽",rfloor:"⌋",Rfr:"ℜ",rfr:"𝔯",rHar:"⥤",rhard:"⇁",rharu:"⇀",rharul:"⥬",Rho:"Ρ",rho:"ρ",rhov:"ϱ",RightAngleBracket:"⟩",RightArrow:"→",Rightarrow:"⇒",rightarrow:"→",RightArrowBar:"⇥",RightArrowLeftArrow:"⇄",rightarrowtail:"↣",RightCeiling:"⌉",RightDoubleBracket:"⟧",RightDownTeeVector:"⥝",RightDownVector:"⇂",RightDownVectorBar:"⥕",RightFloor:"⌋",rightharpoondown:"⇁",rightharpoonup:"⇀",rightleftarrows:"⇄",rightleftharpoons:"⇌",rightrightarrows:"⇉",rightsquigarrow:"↝",RightTee:"⊢",RightTeeArrow:"↦",RightTeeVector:"⥛",rightthreetimes:"⋌",RightTriangle:"⊳",RightTriangleBar:"⧐",RightTriangleEqual:"⊵",RightUpDownVector:"⥏",RightUpTeeVector:"⥜",RightUpVector:"↾",RightUpVectorBar:"⥔",RightVector:"⇀",RightVectorBar:"⥓",ring:"˚",risingdotseq:"≓",rlarr:"⇄",rlhar:"⇌",rlm:"‏",rmoust:"⎱",rmoustache:"⎱",rnmid:"⫮",roang:"⟭",roarr:"⇾",robrk:"⟧",ropar:"⦆",Ropf:"ℝ",ropf:"𝕣",roplus:"⨮",rotimes:"⨵",RoundImplies:"⥰",rpar:")",rpargt:"⦔",rppolint:"⨒",rrarr:"⇉",Rrightarrow:"⇛",rsaquo:"›",Rscr:"ℛ",rscr:"𝓇",Rsh:"↱",rsh:"↱",rsqb:"]",rsquo:"’",rsquor:"’",rthree:"⋌",rtimes:"⋊",rtri:"▹",rtrie:"⊵",rtrif:"▸",rtriltri:"⧎",RuleDelayed:"⧴",ruluhar:"⥨",rx:"℞",Sacute:"Ś",sacute:"ś",sbquo:"‚",Sc:"⪼",sc:"≻",scap:"⪸",Scaron:"Š",scaron:"š",sccue:"≽",scE:"⪴",sce:"⪰",Scedil:"Ş",scedil:"ş",Scirc:"Ŝ",scirc:"ŝ",scnap:"⪺",scnE:"⪶",scnsim:"⋩",scpolint:"⨓",scsim:"≿",Scy:"С",scy:"с",sdot:"⋅",sdotb:"⊡",sdote:"⩦",searhk:"⤥",seArr:"⇘",searr:"↘",searrow:"↘",sect:"§",semi:";",seswar:"⤩",setminus:"∖",setmn:"∖",sext:"✶",Sfr:"𝔖",sfr:"𝔰",sfrown:"⌢",sharp:"♯",SHCHcy:"Щ",shchcy:"щ",SHcy:"Ш",shcy:"ш",ShortDownArrow:"↓",ShortLeftArrow:"←",shortmid:"∣",shortparallel:"∥",ShortRightArrow:"→",ShortUpArrow:"↑",shy:"­",Sigma:"Σ",sigma:"σ",sigmaf:"ς",sigmav:"ς",sim:"∼",simdot:"⩪",sime:"≃",simeq:"≃",simg:"⪞",simgE:"⪠",siml:"⪝",simlE:"⪟",simne:"≆",simplus:"⨤",simrarr:"⥲",slarr:"←",SmallCircle:"∘",smallsetminus:"∖",smashp:"⨳",smeparsl:"⧤",smid:"∣",smile:"⌣",smt:"⪪",smte:"⪬",smtes:"⪬︀",SOFTcy:"Ь",softcy:"ь",sol:"/",solb:"⧄",solbar:"⌿",Sopf:"𝕊",sopf:"𝕤",spades:"♠",spadesuit:"♠",spar:"∥",sqcap:"⊓",sqcaps:"⊓︀",sqcup:"⊔",sqcups:"⊔︀",Sqrt:"√",sqsub:"⊏",sqsube:"⊑",sqsubset:"⊏",sqsubseteq:"⊑",sqsup:"⊐",sqsupe:"⊒",sqsupset:"⊐",sqsupseteq:"⊒",squ:"□",Square:"□",square:"□",SquareIntersection:"⊓",SquareSubset:"⊏",SquareSubsetEqual:"⊑",SquareSuperset:"⊐",SquareSupersetEqual:"⊒",SquareUnion:"⊔",squarf:"▪",squf:"▪",srarr:"→",Sscr:"𝒮",sscr:"𝓈",ssetmn:"∖",ssmile:"⌣",sstarf:"⋆",Star:"⋆",star:"☆",starf:"★",straightepsilon:"ϵ",straightphi:"ϕ",strns:"¯",Sub:"⋐",sub:"⊂",subdot:"⪽",subE:"⫅",sube:"⊆",subedot:"⫃",submult:"⫁",subnE:"⫋",subne:"⊊",subplus:"⪿",subrarr:"⥹",Subset:"⋐",subset:"⊂",subseteq:"⊆",subseteqq:"⫅",SubsetEqual:"⊆",subsetneq:"⊊",subsetneqq:"⫋",subsim:"⫇",subsub:"⫕",subsup:"⫓",succ:"≻",succapprox:"⪸",succcurlyeq:"≽",Succeeds:"≻",SucceedsEqual:"⪰",SucceedsSlantEqual:"≽",SucceedsTilde:"≿",succeq:"⪰",succnapprox:"⪺",succneqq:"⪶",succnsim:"⋩",succsim:"≿",SuchThat:"∋",Sum:"∑",sum:"∑",sung:"♪",Sup:"⋑",sup:"⊃",sup1:"¹",sup2:"²",sup3:"³",supdot:"⪾",supdsub:"⫘",supE:"⫆",supe:"⊇",supedot:"⫄",Superset:"⊃",SupersetEqual:"⊇",suphsol:"⟉",suphsub:"⫗",suplarr:"⥻",supmult:"⫂",supnE:"⫌",supne:"⊋",supplus:"⫀",Supset:"⋑",supset:"⊃",supseteq:"⊇",supseteqq:"⫆",supsetneq:"⊋",supsetneqq:"⫌",supsim:"⫈",supsub:"⫔",supsup:"⫖",swarhk:"⤦",swArr:"⇙",swarr:"↙",swarrow:"↙",swnwar:"⤪",szlig:"ß",Tab:"	",target:"⌖",Tau:"Τ",tau:"τ",tbrk:"⎴",Tcaron:"Ť",tcaron:"ť",Tcedil:"Ţ",tcedil:"ţ",Tcy:"Т",tcy:"т",tdot:"⃛",telrec:"⌕",Tfr:"𝔗",tfr:"𝔱",there4:"∴",Therefore:"∴",therefore:"∴",Theta:"Θ",theta:"θ",thetasym:"ϑ",thetav:"ϑ",thickapprox:"≈",thicksim:"∼",ThickSpace:"  ",thinsp:" ",ThinSpace:" ",thkap:"≈",thksim:"∼",THORN:"Þ",thorn:"þ",Tilde:"∼",tilde:"˜",TildeEqual:"≃",TildeFullEqual:"≅",TildeTilde:"≈",times:"×",timesb:"⊠",timesbar:"⨱",timesd:"⨰",tint:"∭",toea:"⤨",top:"⊤",topbot:"⌶",topcir:"⫱",Topf:"𝕋",topf:"𝕥",topfork:"⫚",tosa:"⤩",tprime:"‴",TRADE:"™",trade:"™",triangle:"▵",triangledown:"▿",triangleleft:"◃",trianglelefteq:"⊴",triangleq:"≜",triangleright:"▹",trianglerighteq:"⊵",tridot:"◬",trie:"≜",triminus:"⨺",TripleDot:"⃛",triplus:"⨹",trisb:"⧍",tritime:"⨻",trpezium:"⏢",Tscr:"𝒯",tscr:"𝓉",TScy:"Ц",tscy:"ц",TSHcy:"Ћ",tshcy:"ћ",Tstrok:"Ŧ",tstrok:"ŧ",twixt:"≬",twoheadleftarrow:"↞",twoheadrightarrow:"↠",Uacute:"Ú",uacute:"ú",Uarr:"↟",uArr:"⇑",uarr:"↑",Uarrocir:"⥉",Ubrcy:"Ў",ubrcy:"ў",Ubreve:"Ŭ",ubreve:"ŭ",Ucirc:"Û",ucirc:"û",Ucy:"У",ucy:"у",udarr:"⇅",Udblac:"Ű",udblac:"ű",udhar:"⥮",ufisht:"⥾",Ufr:"𝔘",ufr:"𝔲",Ugrave:"Ù",ugrave:"ù",uHar:"⥣",uharl:"↿",uharr:"↾",uhblk:"▀",ulcorn:"⌜",ulcorner:"⌜",ulcrop:"⌏",ultri:"◸",Umacr:"Ū",umacr:"ū",uml:"¨",UnderBar:"_",UnderBrace:"⏟",UnderBracket:"⎵",UnderParenthesis:"⏝",Union:"⋃",UnionPlus:"⊎",Uogon:"Ų",uogon:"ų",Uopf:"𝕌",uopf:"𝕦",UpArrow:"↑",Uparrow:"⇑",uparrow:"↑",UpArrowBar:"⤒",UpArrowDownArrow:"⇅",UpDownArrow:"↕",Updownarrow:"⇕",updownarrow:"↕",UpEquilibrium:"⥮",upharpoonleft:"↿",upharpoonright:"↾",uplus:"⊎",UpperLeftArrow:"↖",UpperRightArrow:"↗",Upsi:"ϒ",upsi:"υ",upsih:"ϒ",Upsilon:"Υ",upsilon:"υ",UpTee:"⊥",UpTeeArrow:"↥",upuparrows:"⇈",urcorn:"⌝",urcorner:"⌝",urcrop:"⌎",Uring:"Ů",uring:"ů",urtri:"◹",Uscr:"𝒰",uscr:"𝓊",utdot:"⋰",Utilde:"Ũ",utilde:"ũ",utri:"▵",utrif:"▴",uuarr:"⇈",Uuml:"Ü",uuml:"ü",uwangle:"⦧",vangrt:"⦜",varepsilon:"ϵ",varkappa:"ϰ",varnothing:"∅",varphi:"ϕ",varpi:"ϖ",varpropto:"∝",vArr:"⇕",varr:"↕",varrho:"ϱ",varsigma:"ς",varsubsetneq:"⊊︀",varsubsetneqq:"⫋︀",varsupsetneq:"⊋︀",varsupsetneqq:"⫌︀",vartheta:"ϑ",vartriangleleft:"⊲",vartriangleright:"⊳",Vbar:"⫫",vBar:"⫨",vBarv:"⫩",Vcy:"В",vcy:"в",VDash:"⊫",Vdash:"⊩",vDash:"⊨",vdash:"⊢",Vdashl:"⫦",Vee:"⋁",vee:"∨",veebar:"⊻",veeeq:"≚",vellip:"⋮",Verbar:"‖",verbar:"|",Vert:"‖",vert:"|",VerticalBar:"∣",VerticalLine:"|",VerticalSeparator:"❘",VerticalTilde:"≀",VeryThinSpace:" ",Vfr:"𝔙",vfr:"𝔳",vltri:"⊲",vnsub:"⊂⃒",vnsup:"⊃⃒",Vopf:"𝕍",vopf:"𝕧",vprop:"∝",vrtri:"⊳",Vscr:"𝒱",vscr:"𝓋",vsubnE:"⫋︀",vsubne:"⊊︀",vsupnE:"⫌︀",vsupne:"⊋︀",Vvdash:"⊪",vzigzag:"⦚",Wcirc:"Ŵ",wcirc:"ŵ",wedbar:"⩟",Wedge:"⋀",wedge:"∧",wedgeq:"≙",weierp:"℘",Wfr:"𝔚",wfr:"𝔴",Wopf:"𝕎",wopf:"𝕨",wp:"℘",wr:"≀",wreath:"≀",Wscr:"𝒲",wscr:"𝓌",xcap:"⋂",xcirc:"◯",xcup:"⋃",xdtri:"▽",Xfr:"𝔛",xfr:"𝔵",xhArr:"⟺",xharr:"⟷",Xi:"Ξ",xi:"ξ",xlArr:"⟸",xlarr:"⟵",xmap:"⟼",xnis:"⋻",xodot:"⨀",Xopf:"𝕏",xopf:"𝕩",xoplus:"⨁",xotime:"⨂",xrArr:"⟹",xrarr:"⟶",Xscr:"𝒳",xscr:"𝓍",xsqcup:"⨆",xuplus:"⨄",xutri:"△",xvee:"⋁",xwedge:"⋀",Yacute:"Ý",yacute:"ý",YAcy:"Я",yacy:"я",Ycirc:"Ŷ",ycirc:"ŷ",Ycy:"Ы",ycy:"ы",yen:"¥",Yfr:"𝔜",yfr:"𝔶",YIcy:"Ї",yicy:"ї",Yopf:"𝕐",yopf:"𝕪",Yscr:"𝒴",yscr:"𝓎",YUcy:"Ю",yucy:"ю",Yuml:"Ÿ",yuml:"ÿ",Zacute:"Ź",zacute:"ź",Zcaron:"Ž",zcaron:"ž",Zcy:"З",zcy:"з",Zdot:"Ż",zdot:"ż",zeetrf:"ℨ",ZeroWidthSpace:"​",Zeta:"Ζ",zeta:"ζ",Zfr:"ℨ",zfr:"𝔷",ZHcy:"Ж",zhcy:"ж",zigrarr:"⇝",Zopf:"ℤ",zopf:"𝕫",Zscr:"𝒵",zscr:"𝓏",zwj:"‍",zwnj:"‌"}},{}],2:[function(e,t){"use strict";var r={};["article","aside","button","blockquote","body","canvas","caption","col","colgroup","dd","div","dl","dt","embed","fieldset","figcaption","figure","footer","form","h1","h2","h3","h4","h5","h6","header","hgroup","hr","iframe","li","map","object","ol","output","p","pre","progress","script","section","style","table","tbody","td","textarea","tfoot","th","tr","thead","ul","video"].forEach(function(e){r[e]=!0}),t.exports=r},{}],3:[function(e,t){"use strict";function r(e,t){return e=e.source,t=t||"",function r(n,s){return n?(s=s.source||s,e=e.replace(n,s),r):new RegExp(e,t)}}var n=/[a-zA-Z_:][a-zA-Z0-9:._-]*/,s=/[^"'=<>`\x00-\x20]+/,o=/'[^']*'/,i=/"[^"]*"/,l=r(/(?:unquoted|single_quoted|double_quoted)/)("unquoted",s)("single_quoted",o)("double_quoted",i)(),a=r(/(?:\s+attr_name(?:\s*=\s*attr_value)?)/)("attr_name",n)("attr_value",l)(),c=r(/<[A-Za-z][A-Za-z0-9]*attribute*\s*\/?>/)("attribute",a)(),u=/<\/[A-Za-z][A-Za-z0-9]*\s*>/,p=/<!--([^-]+|[-][^-]+)*-->/,h=/<[?].*?[?]>/,f=/<![A-Z]+\s+[^>]*>/,d=/<!\[CDATA\[([^\]]+|\][^\]]|\]\][^>])*\]\]>/,g=r(/^(?:open_tag|close_tag|comment|processing|declaration|cdata)/)("open_tag",c)("close_tag",u)("comment",p)("processing",h)("declaration",f)("cdata",d)();t.exports.HTML_TAG_RE=g},{}],4:[function(e,t){"use strict";t.exports=["coap","doi","javascript","aaa","aaas","about","acap","cap","cid","crid","data","dav","dict","dns","file","ftp","geo","go","gopher","h323","http","https","iax","icap","im","imap","info","ipp","iris","iris.beep","iris.xpc","iris.xpcs","iris.lwz","ldap","mailto","mid","msrp","msrps","mtqp","mupdate","news","nfs","ni","nih","nntp","opaquelocktoken","pop","pres","rtsp","service","session","shttp","sieve","sip","sips","sms","snmp","soap.beep","soap.beeps","tag","tel","telnet","tftp","thismessage","tn3270","tip","tv","urn","vemmi","ws","wss","xcon","xcon-userid","xmlrpc.beep","xmlrpc.beeps","xmpp","z39.50r","z39.50s","adiumxtra","afp","afs","aim","apt","attachment","aw","beshare","bitcoin","bolo","callto","chrome","chrome-extension","com-eventbrite-attendee","content","cvs","dlna-playsingle","dlna-playcontainer","dtn","dvb","ed2k","facetime","feed","finger","fish","gg","git","gizmoproject","gtalk","hcp","icon","ipn","irc","irc6","ircs","itms","jar","jms","keyparc","lastfm","ldaps","magnet","maps","market","message","mms","ms-help","msnim","mumble","mvn","notes","oid","palm","paparazzi","platform","proxy","psyc","query","res","resource","rmi","rsync","rtmp","secondlife","sftp","sgn","skype","smb","soldat","spotify","ssh","steam","svn","teamspeak","things","udp","unreal","ut2004","ventrilo","view-source","webcal","wtai","wyciwyg","xfire","xri","ymsgr"]},{}],5:[function(e,t,r){"use strict";function n(e){return Object.prototype.toString.call(e)}function s(e){return"[object String]"===n(e)}function o(e,t){return e?d.call(e,t):!1}function i(e){var t=Array.prototype.slice.call(arguments,1);return t.forEach(function(t){if(t){if("object"!=typeof t)throw new TypeError(t+"must be object");Object.keys(t).forEach(function(r){e[r]=t[r]})}}),e}function l(e){return e.indexOf("\\")<0?e:e.replace(g,"$1")}function a(e){return e>=55296&&57343>=e?!1:e>=64976&&65007>=e?!1:65535===(65535&e)||65534===(65535&e)?!1:e>=0&&8>=e?!1:11===e?!1:e>=14&&31>=e?!1:e>=127&&159>=e?!1:e>1114111?!1:!0}function c(e){if(e>65535){e-=65536;var t=55296+(e>>10),r=56320+(1023&e);return String.fromCharCode(t,r)}return String.fromCharCode(e)}function u(e,t){var r=0;return o(v,t)?v[t]:35===t.charCodeAt(0)&&b.test(t)&&(r="x"===t[1].toLowerCase()?parseInt(t.slice(2),16):parseInt(t.slice(1),10),a(r))?c(r):e}function p(e){return e.indexOf("&")<0?e:e.replace(m,u)}function h(e){return y[e]}function f(e){return k.test(e)?e.replace(_,h):e}var d=Object.prototype.hasOwnProperty,g=/\\([\\!"#$%&'()*+,.\/:;<=>?@[\]^_`{|}~-])/g,m=/&([a-z#][a-z0-9]{1,31});/gi,b=/^#((?:x[a-f0-9]{1,8}|[0-9]{1,8}))/i,v=e("./entities"),k=/[&<>"]/,_=/[&<>"]/g,y={"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"};r.assign=i,r.isString=s,r.has=o,r.unescapeMd=l,r.isValidEntityCode=a,r.fromCodePoint=c,r.replaceEntities=p,r.escapeHtml=f},{"./entities":1}],6:[function(e,t){"use strict";t.exports={options:{html:!0,xhtmlOut:!0,breaks:!1,langPrefix:"language-",linkify:!1,typographer:!1,quotes:"“”‘’",highlight:null,maxNesting:20},components:{core:{rules:["block","inline","references","abbr2"]},block:{rules:["blockquote","code","fences","heading","hr","htmlblock","lheading","list","paragraph"]},inline:{rules:["autolink","backticks","emphasis","entity","escape","htmltag","links","newline","text"]}}}},{}],7:[function(e,t){"use strict";t.exports={options:{html:!1,xhtmlOut:!1,breaks:!1,langPrefix:"language-",linkify:!1,typographer:!1,quotes:"“”‘’",highlight:null,maxNesting:20},components:{core:{rules:["block","inline","references","replacements","linkify","smartquotes","references","abbr2","footnote_tail"]},block:{rules:["blockquote","code","fences","heading","hr","htmlblock","lheading","list","paragraph","table"]},inline:{rules:["autolink","backticks","del","emphasis","entity","escape","footnote_ref","htmltag","links","newline","text","rwref"]}}}},{}],8:[function(e,t){"use strict";t.exports={options:{html:!1,xhtmlOut:!1,breaks:!1,langPrefix:"language-",linkify:!1,typographer:!1,quotes:"“”‘’",highlight:null,maxNesting:20},components:{core:{},block:{},inline:{}}}},{}],9:[function(e,t){"use strict";var r=e("../common/utils").replaceEntities;t.exports=function(e){var t=r(e);try{t=decodeURI(t)}catch(n){}return encodeURI(t)}},{"../common/utils":5}],10:[function(e,t){"use strict";t.exports=function(e){return e.trim().replace(/\s+/g," ").toUpperCase()}},{}],11:[function(e,t){"use strict";var r=e("./normalize_link"),n=e("../common/utils").unescapeMd;t.exports=function(e,t){var s,o,i,l=t,a=e.posMax;if(60===e.src.charCodeAt(t)){for(t++;a>t;){if(s=e.src.charCodeAt(t),10===s)return!1;if(62===s)return i=r(n(e.src.slice(l+1,t))),e.parser.validateLink(i)?(e.pos=t+1,e.linkContent=i,!0):!1;92===s&&a>t+1?t+=2:t++}return!1}for(o=0;a>t&&(s=e.src.charCodeAt(t),32!==s)&&!(32>s||127===s);)if(92===s&&a>t+1)t+=2;else{if(40===s&&(o++,o>1))break;if(41===s&&(o--,0>o))break;t++}return l===t?!1:(i=r(n(e.src.slice(l,t))),e.parser.validateLink(i)?(e.linkContent=i,e.pos=t,!0):!1)}},{"../common/utils":5,"./normalize_link":9}],12:[function(e,t){"use strict";t.exports=function(e,t){var r,n,s,o=-1,i=e.posMax,l=e.pos,a=e.isInLabel;
	if(e.isInLabel)return-1;if(e.labelUnmatchedScopes)return e.labelUnmatchedScopes--,-1;for(e.pos=t+1,e.isInLabel=!0,r=1;e.pos<i;){if(s=e.src.charCodeAt(e.pos),91===s)r++;else if(93===s&&(r--,0===r)){n=!0;break}e.parser.skipToken(e)}return n?(o=e.pos,e.labelUnmatchedScopes=0):e.labelUnmatchedScopes=r-1,e.pos=l,e.isInLabel=a,o}},{}],13:[function(e,t){"use strict";var r=e("../common/utils").unescapeMd;t.exports=function(e,t){var n,s=t,o=e.posMax,i=e.src.charCodeAt(t);if(34!==i&&39!==i&&40!==i)return!1;for(t++,40===i&&(i=41);o>t;){if(n=e.src.charCodeAt(t),n===i)return e.pos=t+1,e.linkContent=r(e.src.slice(s+1,t)),!0;92===n&&o>t+1?t+=2:t++}return!1}},{"../common/utils":5}],14:[function(e,t){"use strict";function r(e,t,r){this.src=t,this.env=r,this.options=e.options,this.tokens=[],this.inlineMode=!1,this.inline=e.inline,this.block=e.block,this.renderer=e.renderer,this.typographer=e.typographer}function n(e,t){t||o(e)||(t=e||{},e="default"),this.inline=new c,this.block=new a,this.core=new l,this.renderer=new i,this.ruler=new u,this.options={},this.configure(p[e]),t&&this.set(t)}var s=e("./common/utils").assign,o=e("./common/utils").isString,i=e("./renderer"),l=e("./parser_core"),a=e("./parser_block"),c=e("./parser_inline"),u=e("./ruler"),p={"default":e("./configs/default"),full:e("./configs/full"),commonmark:e("./configs/commonmark")};n.prototype.set=function(e){s(this.options,e)},n.prototype.configure=function(e){var t=this;if(!e)throw new Error("Wrong `remarkable` preset, check name/content");e.options&&t.set(e.options),e.components&&Object.keys(e.components).forEach(function(r){e.components[r].rules&&t[r].ruler.enable(e.components[r].rules,!0)})},n.prototype.use=function(e,t){return e(this,t),this},n.prototype.parse=function(e,t){var n=new r(this,e,t);return this.core.process(n),n.tokens},n.prototype.render=function(e,t){return t=t||{},this.renderer.render(this.parse(e,t),this.options,t)},n.prototype.parseInline=function(e,t){var n=new r(this,e,t);return n.inlineMode=!0,this.core.process(n),n.tokens},n.prototype.renderInline=function(e,t){return t=t||{},this.renderer.render(this.parseInline(e,t),this.options,t)},t.exports=n,t.exports.utils=e("./common/utils")},{"./common/utils":5,"./configs/commonmark":6,"./configs/default":7,"./configs/full":8,"./parser_block":15,"./parser_core":16,"./parser_inline":17,"./renderer":18,"./ruler":19}],15:[function(e,t){"use strict";function r(){this.ruler=new n;for(var e=0;e<o.length;e++)this.ruler.push(o[e][0],o[e][1],{alt:(o[e][2]||[]).slice()})}var n=e("./ruler"),s=e("./rules_block/state_block"),o=[["code",e("./rules_block/code")],["fences",e("./rules_block/fences"),["paragraph","blockquote","list"]],["blockquote",e("./rules_block/blockquote"),["paragraph","blockquote","list"]],["hr",e("./rules_block/hr"),["paragraph","blockquote","list"]],["list",e("./rules_block/list"),["paragraph","blockquote"]],["footnote",e("./rules_block/footnote"),["paragraph"]],["heading",e("./rules_block/heading"),["paragraph","blockquote"]],["lheading",e("./rules_block/lheading")],["htmlblock",e("./rules_block/htmlblock"),["paragraph","blockquote"]],["table",e("./rules_block/table"),["paragraph"]],["deflist",e("./rules_block/deflist"),["paragraph"]],["paragraph",e("./rules_block/paragraph")]];r.prototype.tokenize=function(e,t,r){for(var n,s,o=this.ruler.getRules(""),i=o.length,l=t,a=!1;r>l&&(e.line=l=e.skipEmptyLines(l),!(l>=r))&&!(e.tShift[l]<e.blkIndent);){for(s=0;i>s&&!(n=o[s](e,l,r,!1));s++);if(e.tight=!a,e.isEmpty(e.line-1)&&(a=!0),l=e.line,r>l&&e.isEmpty(l)){if(a=!0,l++,r>l&&"list"===e.parentType&&e.isEmpty(l))break;e.line=l}}};var i=/[\n\t]/g,l=/\r[\n\u0085]|[\u2424\u2028\u0085]/g,a=/\u00a0/g;r.prototype.parse=function(e,t,r,n){var o,c=0,u=0;return e?(e=e.replace(a," "),e=e.replace(l,"\n"),e.indexOf("	")>=0&&(e=e.replace(i,function(t,r){var n;return 10===e.charCodeAt(r)?(c=r+1,u=0,t):(n="    ".slice((r-c-u)%4),u=r-c+1,n)})),o=new s(e,this,t,r,n),void this.tokenize(o,o.line,o.lineMax)):[]},t.exports=r},{"./ruler":19,"./rules_block/blockquote":20,"./rules_block/code":21,"./rules_block/deflist":22,"./rules_block/fences":23,"./rules_block/footnote":24,"./rules_block/heading":25,"./rules_block/hr":26,"./rules_block/htmlblock":27,"./rules_block/lheading":28,"./rules_block/list":29,"./rules_block/paragraph":30,"./rules_block/state_block":31,"./rules_block/table":32}],16:[function(e,t){"use strict";function r(){this.options={},this.ruler=new n;for(var e=0;e<s.length;e++)this.ruler.push(s[e][0],s[e][1])}var n=e("./ruler"),s=[["block",e("./rules_core/block")],["abbr",e("./rules_core/abbr")],["references",e("./rules_core/references")],["inline",e("./rules_core/inline")],["footnote_tail",e("./rules_core/footnote_tail")],["abbr2",e("./rules_core/abbr2")],["replacements",e("./rules_core/replacements")],["smartquotes",e("./rules_core/smartquotes")],["linkify",e("./rules_core/linkify")]];r.prototype.process=function(e){var t,r,n;for(n=this.ruler.getRules(""),t=0,r=n.length;r>t;t++)n[t](e)},t.exports=r},{"./ruler":19,"./rules_core/abbr":33,"./rules_core/abbr2":34,"./rules_core/block":35,"./rules_core/footnote_tail":36,"./rules_core/inline":37,"./rules_core/linkify":38,"./rules_core/references":39,"./rules_core/replacements":40,"./rules_core/smartquotes":41}],17:[function(e,t){"use strict";function r(e){var t=e.trim().toLowerCase();return t=i(t),t.indexOf(":")>=0&&a.indexOf(t.split(":")[0])>=0?!1:!0}function n(){this.validateLink=r,this.ruler=new s;for(var e=0;e<l.length;e++)this.ruler.push(l[e][0],l[e][1])}var s=e("./ruler"),o=e("./rules_inline/state_inline"),i=e("./common/utils").replaceEntities,l=[["text",e("./rules_inline/text")],["newline",e("./rules_inline/newline")],["escape",e("./rules_inline/escape")],["backticks",e("./rules_inline/backticks")],["del",e("./rules_inline/del")],["ins",e("./rules_inline/ins")],["mark",e("./rules_inline/mark")],["emphasis",e("./rules_inline/emphasis")],["sub",e("./rules_inline/sub")],["sup",e("./rules_inline/sup")],["rwref",e("./rules_inline/rwref")],["links",e("./rules_inline/links")],["footnote_inline",e("./rules_inline/footnote_inline")],["footnote_ref",e("./rules_inline/footnote_ref")],["autolink",e("./rules_inline/autolink")],["htmltag",e("./rules_inline/htmltag")],["entity",e("./rules_inline/entity")]],a=["vbscript","javascript","file"];n.prototype.skipToken=function(e){var t,r,n=e.pos,s=this.ruler.getRules(""),o=s.length;if((r=e.cacheGet(n))>0)return void(e.pos=r);for(t=0;o>t;t++)if(s[t](e,!0))return void e.cacheSet(n,e.pos);e.pos++,e.cacheSet(n,e.pos)},n.prototype.tokenize=function(e){for(var t,r,n=this.ruler.getRules(""),s=n.length,o=e.posMax;e.pos<o;){for(r=0;s>r&&!(t=n[r](e,!1));r++);if(t){if(e.pos>=o)break}else e.pending+=e.src[e.pos++]}e.pending&&e.pushPending()},n.prototype.parse=function(e,t,r,n){var s=new o(e,this,t,r,n);this.tokenize(s)},t.exports=n},{"./common/utils":5,"./ruler":19,"./rules_inline/autolink":42,"./rules_inline/backticks":43,"./rules_inline/del":44,"./rules_inline/emphasis":45,"./rules_inline/entity":46,"./rules_inline/escape":47,"./rules_inline/footnote_inline":48,"./rules_inline/footnote_ref":49,"./rules_inline/htmltag":50,"./rules_inline/ins":51,"./rules_inline/links":52,"./rules_inline/mark":53,"./rules_inline/newline":54,"./rules_inline/rwref":55,"./rules_inline/state_inline":56,"./rules_inline/sub":57,"./rules_inline/sup":58,"./rules_inline/text":59}],18:[function(e,t){"use strict";function r(e,t){return++t>=e.length-2?t:"paragraph_open"===e[t].type&&e[t].tight&&"inline"===e[t+1].type&&0===e[t+1].content.length&&"paragraph_close"===e[t+2].type&&e[t+2].tight?r(e,t+2):t}function n(e,t){return t=r(e,t),t<e.length&&"list_item_close"===e[t].type?"":"\n"}function s(){this.rules=o({},u),this.getBreak=n}var o=e("./common/utils").assign,i=e("./common/utils").has,l=e("./common/utils").unescapeMd,a=e("./common/utils").replaceEntities,c=e("./common/utils").escapeHtml,u={};u.blockquote_open=function(){return"<blockquote>\n"},u.blockquote_close=function(e,t){return"</blockquote>"+n(e,t)},u.code=function(e,t){return e[t].block?"<pre><code>"+c(e[t].content)+"</code></pre>"+n(e,t):"<code>"+c(e[t].content)+"</code>"},u.fence=function(e,t,r,s,o){var u,p,h=e[t],f="",d=r.langPrefix,g="";if(h.params){if(u=h.params.split(/\s+/g)[0],i(o.rules.fence_custom,u))return o.rules.fence_custom[u](e,t,r,s,o);g=c(a(l(u))),f=' class="'+d+g+'"'}return p=r.highlight?r.highlight(h.content,g)||c(h.content):c(h.content),"<pre><code"+f+">"+p+"</code></pre>"+n(e,t)},u.fence_custom={},u.heading_open=function(e,t){return"<h"+e[t].hLevel+">"},u.heading_close=function(e,t){return"</h"+e[t].hLevel+">\n"},u.hr=function(e,t,r){return(r.xhtmlOut?"<hr />":"<hr>")+n(e,t)},u.bullet_list_open=function(){return"<ul>\n"},u.bullet_list_close=function(e,t){return"</ul>"+n(e,t)},u.list_item_open=function(){return"<li>"},u.list_item_close=function(){return"</li>\n"},u.ordered_list_open=function(e,t){var r=e[t];return"<ol"+(r.order>1?' start="'+r.order+'"':"")+">\n"},u.ordered_list_close=function(e,t){return"</ol>"+n(e,t)},u.paragraph_open=function(e,t){return e[t].tight?"":"<p>"},u.paragraph_close=function(e,t){var r=!(e[t].tight&&t&&"inline"===e[t-1].type&&!e[t-1].content);return(e[t].tight?"":"</p>")+(r?n(e,t):"")},u.link_open=function(e,t){var r=e[t].title?' title="'+c(a(e[t].title))+'"':"";return'<a href="'+c(e[t].href)+'"'+r+' target="_blank">'},u.link_close=function(){return"</a>"},u.image=function(e,t,r){var n=' src="'+c(e[t].src)+'"',s=e[t].title?' title="'+c(a(e[t].title))+'"':"",o=' alt="'+(e[t].alt?c(a(e[t].alt)):"")+'"',i=r.xhtmlOut?" /":"";return"<img"+n+o+s+i+">"},u.table_open=function(){return"<table>\n"},u.table_close=function(){return"</table>\n"},u.thead_open=function(){return"<thead>\n"},u.thead_close=function(){return"</thead>\n"},u.tbody_open=function(){return"<tbody>\n"},u.tbody_close=function(){return"</tbody>\n"},u.tr_open=function(){return"<tr>"},u.tr_close=function(){return"</tr>\n"},u.th_open=function(e,t){var r=e[t];return"<th"+(r.align?' style="text-align:'+r.align+'"':"")+">"},u.th_close=function(){return"</th>"},u.td_open=function(e,t){var r=e[t];return"<td"+(r.align?' style="text-align:'+r.align+'"':"")+">"},u.td_close=function(){return"</td>"},u.strong_open=function(){return"<strong>"},u.strong_close=function(){return"</strong>"},u.em_open=function(){return"<em>"},u.em_close=function(){return"</em>"},u.del_open=function(){return"<del>"},u.del_close=function(){return"</del>"},u.ins_open=function(){return"<ins>"},u.ins_close=function(){return"</ins>"},u.mark_open=function(){return"<mark>"},u.mark_close=function(){return"</mark>"},u.sub=function(e,t){return"<sub>"+c(e[t].content)+"</sub>"},u.sup=function(e,t){return"<sup>"+c(e[t].content)+"</sup>"},u.hardbreak=function(e,t,r){return r.xhtmlOut?"<br />\n":"<br>\n"},u.softbreak=function(e,t,r){return r.breaks?r.xhtmlOut?"<br />\n":"<br>\n":"\n"},u.text=function(e,t){return c(e[t].content)},u.htmlblock=function(e,t){return e[t].content},u.htmltag=function(e,t){return e[t].content},u.abbr_open=function(e,t){return'<abbr title="'+c(a(e[t].title))+'">'},u.abbr_close=function(){return"</abbr>"},u.footnote_ref=function(e,t){var r=Number(e[t].id+1).toString(),n="fnref"+r;return e[t].subId>0&&(n+=":"+e[t].subId),'<sup class="footnote-ref"><a href="#fn'+r+'" id="'+n+'">['+r+"]</a></sup>"},u.footnote_block_open=function(e,t,r){return(r.xhtmlOut?'<hr class="footnotes-sep" />\n':'<hr class="footnotes-sep">\n')+'<section class="footnotes">\n<ol class="footnotes-list">\n'},u.footnote_block_close=function(){return"</ol>\n</section>\n"},u.footnote_open=function(e,t){var r=Number(e[t].id+1).toString();return'<li id="fn'+r+'"  class="footnote-item">'},u.footnote_close=function(){return"</li>\n"},u.footnote_anchor=function(e,t){var r=Number(e[t].id+1).toString(),n="fnref"+r;return e[t].subId>0&&(n+=":"+e[t].subId),' <a href="#'+n+'" class="footnote-backref">↩</a>'},u.dl_open=function(){return"<dl>\n"},u.dt_open=function(){return"<dt>"},u.dd_open=function(){return"<dd>"},u.dl_close=function(){return"</dl>\n"},u.dt_close=function(){return"</dt>\n"},u.dd_close=function(){return"</dd>\n"},u.rwref_open=function(e,t){return'<a href="javascript:;" class="rwref rwref-'+c(e[t].rwrefType)+'" data-rwref_type="'+c(e[t].rwrefType)+'" data-rwref_id="'+c(e[t].rwrefId)+'">'},u.rwref_close=function(){return"</a>"},s.prototype.renderInline=function(e,t,r){for(var n="",s=this.rules,o=0,i=e.length;i>o;o++)n+=s[e[o].type](e,o,t,r,this);return n},s.prototype.render=function(e,t,r){var n,s,o="",i=this.rules;for(n=0,s=e.length;s>n;n++)o+="inline"===e[n].type?this.renderInline(e[n].children,t,r):i[e[n].type](e,n,t,r,this);return o},t.exports=s},{"./common/utils":5}],19:[function(e,t){"use strict";function r(){this.__rules__=[],this.__cache__=null}r.prototype.__find__=function(e){for(var t=0;t<this.__rules__.length;t++)if(this.__rules__[t].name===e)return t;return-1},r.prototype.__compile__=function(){var e=this,t=[""];e.__rules__.forEach(function(e){e.enabled&&e.alt.forEach(function(e){t.indexOf(e)<0&&t.push(e)})}),e.__cache__={},t.forEach(function(t){e.__cache__[t]=[],e.__rules__.forEach(function(r){r.enabled&&(t&&r.alt.indexOf(t)<0||e.__cache__[t].push(r.fn))})})},r.prototype.at=function(e,t,r){var n=this.__find__(e),s=r||{};if(-1===n)throw new Error("Parser rule not found: "+e);this.__rules__[n].fn=t,this.__rules__[n].alt=s.alt||[],this.__cache__=null},r.prototype.before=function(e,t,r,n){var s=this.__find__(e),o=n||{};if(-1===s)throw new Error("Parser rule not found: "+e);this.__rules__.splice(s,0,{name:t,enabled:!0,fn:r,alt:o.alt||[]}),this.__cache__=null},r.prototype.after=function(e,t,r,n){var s=this.__find__(e),o=n||{};if(-1===s)throw new Error("Parser rule not found: "+e);this.__rules__.splice(s+1,0,{name:t,enabled:!0,fn:r,alt:o.alt||[]}),this.__cache__=null},r.prototype.push=function(e,t,r){var n=r||{};this.__rules__.push({name:e,enabled:!0,fn:t,alt:n.alt||[]}),this.__cache__=null},r.prototype.enable=function(e,t){Array.isArray(e)||(e=[e]),t&&this.__rules__.forEach(function(e){e.enabled=!1}),e.forEach(function(e){var t=this.__find__(e);if(0>t)throw new Error("Rules manager: invalid rule name "+e);this.__rules__[t].enabled=!0},this),this.__cache__=null},r.prototype.disable=function(e){Array.isArray(e)||(e=[e]),e.forEach(function(e){var t=this.__find__(e);if(0>t)throw new Error("Rules manager: invalid rule name "+e);this.__rules__[t].enabled=!1},this),this.__cache__=null},r.prototype.getRules=function(e){return null===this.__cache__&&this.__compile__(),this.__cache__[e]},t.exports=r},{}],20:[function(e,t){"use strict";t.exports=function(e,t,r,n){var s,o,i,l,a,c,u,p,h,f,d,g=e.bMarks[t]+e.tShift[t],m=e.eMarks[t];if(g>m)return!1;if(62!==e.src.charCodeAt(g++))return!1;if(e.level>=e.options.maxNesting)return!1;if(n)return!0;for(32===e.src.charCodeAt(g)&&g++,a=e.blkIndent,e.blkIndent=0,l=[e.bMarks[t]],e.bMarks[t]=g,g=m>g?e.skipSpaces(g):g,o=g>=m,i=[e.tShift[t]],e.tShift[t]=g-e.bMarks[t],p=e.parser.ruler.getRules("blockquote"),s=t+1;r>s&&(g=e.bMarks[s]+e.tShift[s],m=e.eMarks[s],!(g>=m));s++)if(62!==e.src.charCodeAt(g++)){if(o)break;for(d=!1,h=0,f=p.length;f>h;h++)if(p[h](e,s,r,!0)){d=!0;break}if(d)break;l.push(e.bMarks[s]),i.push(e.tShift[s]),e.tShift[s]=-1337}else 32===e.src.charCodeAt(g)&&g++,l.push(e.bMarks[s]),e.bMarks[s]=g,g=m>g?e.skipSpaces(g):g,o=g>=m,i.push(e.tShift[s]),e.tShift[s]=g-e.bMarks[s];for(c=e.parentType,e.parentType="blockquote",e.tokens.push({type:"blockquote_open",lines:u=[t,0],level:e.level++}),e.parser.tokenize(e,t,s),e.tokens.push({type:"blockquote_close",level:--e.level}),e.parentType=c,u[1]=e.line,h=0;h<i.length;h++)e.bMarks[h+t]=l[h],e.tShift[h+t]=i[h];return e.blkIndent=a,!0}},{}],21:[function(e,t){"use strict";t.exports=function(e,t,r){var n,s;if(e.tShift[t]-e.blkIndent<4)return!1;for(s=n=t+1;r>n;)if(e.isEmpty(n))n++;else{if(!(e.tShift[n]-e.blkIndent>=4))break;n++,s=n}return e.line=n,e.tokens.push({type:"code",content:e.getLines(t,s,4+e.blkIndent,!0),block:!0,lines:[t,e.line],level:e.level}),!0}},{}],22:[function(e,t){"use strict";function r(e,t){var r,n,s=e.bMarks[t]+e.tShift[t],o=e.eMarks[t];return s>=o?-1:(n=e.src.charCodeAt(s++),126!==n&&58!==n?-1:(r=e.skipSpaces(s),s===r?-1:r>=o?-1:r))}function n(e,t){var r,n,s=e.level+2;for(r=t+2,n=e.tokens.length-2;n>r;r++)e.tokens[r].level===s&&"paragraph_open"===e.tokens[r].type&&(e.tokens[r+2].tight=!0,e.tokens[r].tight=!0,r+=2)}t.exports=function(e,t,s,o){var i,l,a,c,u,p,h,f,d,g,m,b,v,k;if(o)return e.ddIndent<0?!1:r(e,t)>=0;if(h=t+1,e.isEmpty(h)&&++h>s)return!1;if(e.tShift[h]<e.blkIndent)return!1;if(i=r(e,h),0>i)return!1;if(e.level>=e.options.maxNesting)return!1;p=e.tokens.length,e.tokens.push({type:"dl_open",lines:u=[t,0],level:e.level++}),a=t,l=h;e:for(;;){for(k=!0,v=!1,e.tokens.push({type:"dt_open",lines:[a,a],level:e.level++}),e.tokens.push({type:"inline",content:e.getLines(a,a+1,e.blkIndent,!1).trim(),level:e.level+1,lines:[a,a],children:[]}),e.tokens.push({type:"dt_close",level:--e.level});;){if(e.tokens.push({type:"dd_open",lines:c=[h,0],level:e.level++}),b=e.tight,d=e.ddIndent,f=e.blkIndent,m=e.tShift[l],g=e.parentType,e.blkIndent=e.ddIndent=e.tShift[l]+2,e.tShift[l]=i-e.bMarks[l],e.tight=!0,e.parentType="deflist",e.parser.tokenize(e,l,s,!0),(!e.tight||v)&&(k=!1),v=e.line-l>1&&e.isEmpty(e.line-1),e.tShift[l]=m,e.tight=b,e.parentType=g,e.blkIndent=f,e.ddIndent=d,e.tokens.push({type:"dd_close",level:--e.level}),c[1]=h=e.line,h>=s)break e;if(e.tShift[h]<e.blkIndent)break e;if(i=r(e,h),0>i)break;l=h}if(h>=s)break;if(a=h,e.isEmpty(a))break;if(e.tShift[a]<e.blkIndent)break;if(l=a+1,l>=s)break;if(e.isEmpty(l)&&l++,l>=s)break;if(e.tShift[l]<e.blkIndent)break;if(i=r(e,l),0>i)break}return e.tokens.push({type:"dl_close",level:--e.level}),u[1]=h,e.line=h,k&&n(e,p),!0}},{}],23:[function(e,t){"use strict";t.exports=function(e,t,r,n){var s,o,i,l,a,c=!1,u=e.bMarks[t]+e.tShift[t],p=e.eMarks[t];if(u+3>p)return!1;if(s=e.src.charCodeAt(u),126!==s&&96!==s)return!1;if(a=u,u=e.skipChars(u,s),o=u-a,3>o)return!1;if(i=e.src.slice(u,p).trim(),i.indexOf("`")>=0)return!1;if(n)return!0;for(l=t;(l++,!(l>=r))&&(u=a=e.bMarks[l]+e.tShift[l],p=e.eMarks[l],!(p>u&&e.tShift[l]<e.blkIndent));)if(e.src.charCodeAt(u)===s&&!(e.tShift[l]-e.blkIndent>=4||(u=e.skipChars(u,s),o>u-a||(u=e.skipSpaces(u),p>u)))){c=!0;break}return o=e.tShift[t],e.line=l+(c?1:0),e.tokens.push({type:"fence",params:i,content:e.getLines(t+1,l,o,!0),lines:[t,e.line],level:e.level}),!0}},{}],24:[function(e,t){"use strict";t.exports=function(e,t,r,n){var s,o,i,l,a,c=e.bMarks[t]+e.tShift[t],u=e.eMarks[t];if(c+4>u)return!1;if(91!==e.src.charCodeAt(c))return!1;if(94!==e.src.charCodeAt(c+1))return!1;if(e.level>=e.options.maxNesting)return!1;for(l=c+2;u>l;l++){if(32===e.src.charCodeAt(l))return!1;if(93===e.src.charCodeAt(l))break}return l===c+2?!1:l+1>=u||58!==e.src.charCodeAt(++l)?!1:n?!0:(l++,e.env.footnotes||(e.env.footnotes={}),e.env.footnotes.refs||(e.env.footnotes.refs={}),a=e.src.slice(c+2,l-2),e.env.footnotes.refs[":"+a]=-1,e.tokens.push({type:"footnote_reference_open",label:a,level:e.level++}),s=e.bMarks[t],o=e.tShift[t],i=e.parentType,e.tShift[t]=e.skipSpaces(l)-l,e.bMarks[t]=l,e.blkIndent+=4,e.parentType="footnote",e.tShift[t]<e.blkIndent&&(e.tShift[t]+=e.blkIndent,e.bMarks[t]-=e.blkIndent),e.parser.tokenize(e,t,r,!0),e.parentType=i,e.blkIndent-=4,e.tShift[t]=o,e.bMarks[t]=s,e.tokens.push({type:"footnote_reference_close",level:--e.level}),!0)}},{}],25:[function(e,t){"use strict";t.exports=function(e,t,r,n){var s,o,i,l=e.bMarks[t]+e.tShift[t],a=e.eMarks[t];if(l>=a)return!1;if(s=e.src.charCodeAt(l),35!==s||l>=a)return!1;for(o=1,s=e.src.charCodeAt(++l);35===s&&a>l&&6>=o;)o++,s=e.src.charCodeAt(++l);return o>6||a>l&&32!==s?!1:n?!0:(a=e.skipCharsBack(a,32,l),i=e.skipCharsBack(a,35,l),i>l&&32===e.src.charCodeAt(i-1)&&(a=i),e.line=t+1,e.tokens.push({type:"heading_open",hLevel:o,lines:[t,e.line],level:e.level}),a>l&&e.tokens.push({type:"inline",content:e.src.slice(l,a).trim(),level:e.level+1,lines:[t,e.line],children:[]}),e.tokens.push({type:"heading_close",hLevel:o,level:e.level}),!0)}},{}],26:[function(e,t){"use strict";t.exports=function(e,t,r,n){var s,o,i,l=e.bMarks[t],a=e.eMarks[t];if(l+=e.tShift[t],l>a)return!1;if(s=e.src.charCodeAt(l++),42!==s&&45!==s&&95!==s)return!1;for(o=1;a>l;){if(i=e.src.charCodeAt(l++),i!==s&&32!==i)return!1;i===s&&o++}return 3>o?!1:n?!0:(e.line=t+1,e.tokens.push({type:"hr",lines:[t,e.line],level:e.level}),!0)}},{}],27:[function(e,t){"use strict";function r(e){var t=32|e;return t>=97&&122>=t}var n=e("../common/html_blocks"),s=/^<([a-zA-Z]{1,15})[\s\/>]/,o=/^<\/([a-zA-Z]{1,15})[\s>]/;t.exports=function(e,t,i,l){var a,c,u,p=e.bMarks[t],h=e.eMarks[t],f=e.tShift[t];if(p+=f,!e.options.html)return!1;if(f>3||p+2>=h)return!1;if(60!==e.src.charCodeAt(p))return!1;if(a=e.src.charCodeAt(p+1),33===a||63===a){if(l)return!0}else{if(47!==a&&!r(a))return!1;if(47===a){if(c=e.src.slice(p,h).match(o),!c)return!1}else if(c=e.src.slice(p,h).match(s),!c)return!1;if(n[c[1].toLowerCase()]!==!0)return!1;if(l)return!0}for(u=t+1;u<e.lineMax&&!e.isEmpty(u);)u++;return e.line=u,e.tokens.push({type:"htmlblock",level:e.level,lines:[t,e.line],content:e.getLines(t,u,0,!0)}),!0}},{"../common/html_blocks":2}],28:[function(e,t){"use strict";t.exports=function(e,t,r){var n,s,o,i=t+1;return i>=r?!1:e.tShift[i]<e.blkIndent?!1:e.tShift[i]-e.blkIndent>3?!1:(s=e.bMarks[i]+e.tShift[i],o=e.eMarks[i],s>=o?!1:(n=e.src.charCodeAt(s),45!==n&&61!==n?!1:(s=e.skipChars(s,n),s=e.skipSpaces(s),o>s?!1:(s=e.bMarks[t]+e.tShift[t],e.line=i+1,e.tokens.push({type:"heading_open",hLevel:61===n?1:2,lines:[t,e.line],level:e.level}),e.tokens.push({type:"inline",content:e.src.slice(s,e.eMarks[t]).trim(),level:e.level+1,lines:[t,e.line-1],children:[]}),e.tokens.push({type:"heading_close",hLevel:61===n?1:2,level:e.level}),!0))))}},{}],29:[function(e,t){"use strict";function r(e,t){var r,n,s;return n=e.bMarks[t]+e.tShift[t],s=e.eMarks[t],n>=s?-1:(r=e.src.charCodeAt(n++),42!==r&&45!==r&&43!==r?-1:s>n&&32!==e.src.charCodeAt(n)?-1:n)}function n(e,t){var r,n=e.bMarks[t]+e.tShift[t],s=e.eMarks[t];if(n+1>=s)return-1;if(r=e.src.charCodeAt(n++),48>r||r>57)return-1;for(;;){if(n>=s)return-1;if(r=e.src.charCodeAt(n++),!(r>=48&&57>=r)){if(41===r||46===r)break;return-1}}return s>n&&32!==e.src.charCodeAt(n)?-1:n}function s(e,t){var r,n,s=e.level+2;for(r=t+2,n=e.tokens.length-2;n>r;r++)e.tokens[r].level===s&&"paragraph_open"===e.tokens[r].type&&(e.tokens[r+2].tight=!0,e.tokens[r].tight=!0,r+=2)}t.exports=function(e,t,o,i){var l,a,c,u,p,h,f,d,g,m,b,v,k,_,y,x,w,A,q,C,S,M,E=!0;if((d=n(e,t))>=0)k=!0;else{if(!((d=r(e,t))>=0))return!1;k=!1}if(e.level>=e.options.maxNesting)return!1;if(v=e.src.charCodeAt(d-1),i)return!0;for(y=e.tokens.length,k?(f=e.bMarks[t]+e.tShift[t],b=Number(e.src.substr(f,d-f-1)),e.tokens.push({type:"ordered_list_open",order:b,lines:w=[t,0],level:e.level++})):e.tokens.push({type:"bullet_list_open",lines:w=[t,0],level:e.level++}),l=t,x=!1,q=e.parser.ruler.getRules("list");!(!(o>l)||(_=e.skipSpaces(d),g=e.eMarks[l],m=_>=g?1:_-d,m>4&&(m=1),1>m&&(m=1),a=d-e.bMarks[l]+m,e.tokens.push({type:"list_item_open",lines:A=[t,0],level:e.level++}),u=e.blkIndent,p=e.tight,c=e.tShift[t],h=e.parentType,e.tShift[t]=_-e.bMarks[t],e.blkIndent=a,e.tight=!0,e.parentType="list",e.parser.tokenize(e,t,o,!0),(!e.tight||x)&&(E=!1),x=e.line-t>1&&e.isEmpty(e.line-1),e.blkIndent=u,e.tShift[t]=c,e.tight=p,e.parentType=h,e.tokens.push({type:"list_item_close",level:--e.level}),l=t=e.line,A[1]=l,_=e.bMarks[t],l>=o)||e.isEmpty(l)||e.tShift[l]<e.blkIndent);){for(M=!1,C=0,S=q.length;S>C;C++)if(q[C](e,l,o,!0)){M=!0;break}if(M)break;if(k){if(d=n(e,l),0>d)break}else if(d=r(e,l),0>d)break;if(v!==e.src.charCodeAt(d-1))break}return e.tokens.push({type:k?"ordered_list_close":"bullet_list_close",level:--e.level}),w[1]=l,e.line=l,E&&s(e,y),!0}},{}],30:[function(e,t){"use strict";t.exports=function(e,t){var r,n,s,o,i,l,a=t+1;if(r=e.lineMax,r>a&&!e.isEmpty(a))for(l=e.parser.ruler.getRules("paragraph");r>a&&!e.isEmpty(a);a++)if(!(e.tShift[a]-e.blkIndent>3)){for(s=!1,o=0,i=l.length;i>o;o++)if(l[o](e,a,r,!0)){s=!0;break}if(s)break}return n=e.getLines(t,a,e.blkIndent,!1).trim(),e.line=a,n.length&&(e.tokens.push({type:"paragraph_open",tight:!1,lines:[t,e.line],level:e.level}),e.tokens.push({type:"inline",content:n,level:e.level+1,lines:[t,e.line],children:[]}),e.tokens.push({type:"paragraph_close",tight:!1,level:e.level})),!0}},{}],31:[function(e,t){"use strict";function r(e,t,r,n,s){var o,i,l,a,c,u,p;for(this.src=e,this.parser=t,this.options=r,this.env=n,this.tokens=s,this.bMarks=[],this.eMarks=[],this.tShift=[],this.blkIndent=0,this.line=0,this.lineMax=0,this.tight=!1,this.parentType="root",this.ddIndent=-1,this.level=0,this.result="",i=this.src,u=0,p=!1,l=a=u=0,c=i.length;c>a;a++){if(o=i.charCodeAt(a),!p){if(32===o){u++;continue}p=!0}(10===o||a===c-1)&&(10!==o&&a++,this.bMarks.push(l),this.eMarks.push(a),this.tShift.push(u),p=!1,u=0,l=a+1)}this.bMarks.push(i.length),this.eMarks.push(i.length),this.tShift.push(0),this.lineMax=this.bMarks.length-1}r.prototype.isEmpty=function(e){return this.bMarks[e]+this.tShift[e]>=this.eMarks[e]},r.prototype.skipEmptyLines=function(e){for(var t=this.lineMax;t>e&&!(this.bMarks[e]+this.tShift[e]<this.eMarks[e]);e++);return e},r.prototype.skipSpaces=function(e){for(var t=this.src.length;t>e&&32===this.src.charCodeAt(e);e++);return e},r.prototype.skipChars=function(e,t){for(var r=this.src.length;r>e&&this.src.charCodeAt(e)===t;e++);return e},r.prototype.skipCharsBack=function(e,t,r){if(r>=e)return e;for(;e>r;)if(t!==this.src.charCodeAt(--e))return e+1;return e},r.prototype.getLines=function(e,t,r,n){var s,o,i,l,a,c=e;if(e>=t)return"";if(c+1===t)return o=this.bMarks[c]+Math.min(this.tShift[c],r),i=n?this.bMarks[t]:this.eMarks[t-1],this.src.slice(o,i);for(l=new Array(t-e),s=0;t>c;c++,s++)a=this.tShift[c],a>r&&(a=r),0>a&&(a=0),o=this.bMarks[c]+a,i=t>c+1||n?this.eMarks[c]+1:this.eMarks[c],l[s]=this.src.slice(o,i);return l.join("")},t.exports=r},{}],32:[function(e,t){"use strict";function r(e,t){var r=e.bMarks[t]+e.blkIndent,n=e.eMarks[t];return e.src.substr(r,n-r)}t.exports=function(e,t,n,s){var o,i,l,a,c,u,p,h,f,d;if(t+2>n)return!1;if(c=t+1,e.tShift[c]<e.blkIndent)return!1;if(l=e.bMarks[c]+e.tShift[c],l>=e.eMarks[c])return!1;if(o=e.src.charCodeAt(l),124!==o&&45!==o&&58!==o)return!1;if(i=r(e,t+1),!/^[-:| ]+$/.test(i))return!1;if(u=i.split("|"),2>=u)return!1;for(p=[],a=0;a<u.length;a++){if(h=u[a].trim(),!h){if(0===a||a===u.length-1)continue;return!1}if(!/^:?-+:?$/.test(h))return!1;p.push(58===h.charCodeAt(h.length-1)?58===h.charCodeAt(0)?"center":"right":58===h.charCodeAt(0)?"left":"")}if(i=r(e,t).trim(),-1===i.indexOf("|"))return!1;if(u=i.replace(/^\||\|$/g,"").split("|"),p.length!==u.length)return!1;if(s)return!0;for(e.tokens.push({type:"table_open",lines:f=[t,0],level:e.level++}),e.tokens.push({type:"thead_open",lines:[t,t+1],level:e.level++}),e.tokens.push({type:"tr_open",lines:[t,t+1],level:e.level++}),a=0;a<u.length;a++)e.tokens.push({type:"th_open",align:p[a],lines:[t,t+1],level:e.level++}),e.tokens.push({type:"inline",content:u[a].trim(),lines:[t,t+1],level:e.level,children:[]}),e.tokens.push({type:"th_close",level:--e.level});for(e.tokens.push({type:"tr_close",level:--e.level}),e.tokens.push({type:"thead_close",level:--e.level}),e.tokens.push({type:"tbody_open",lines:d=[t+2,0],level:e.level++}),c=t+2;n>c&&!(e.tShift[c]<e.blkIndent)&&(i=r(e,c).trim(),-1!==i.indexOf("|"));c++){for(u=i.replace(/^\||\|$/g,"").split("|"),e.tokens.push({type:"tr_open",level:e.level++}),a=0;a<u.length;a++)e.tokens.push({type:"td_open",align:p[a],level:e.level++}),e.tokens.push({type:"inline",content:u[a].replace(/^\|? *| *\|?$/g,""),level:e.level,children:[]}),e.tokens.push({type:"td_close",level:--e.level});e.tokens.push({type:"tr_close",level:--e.level})}return e.tokens.push({type:"tbody_close",level:--e.level}),e.tokens.push({type:"table_close",level:--e.level}),f[1]=d[1]=c,e.line=c,!0}},{}],33:[function(e,t){"use strict";function r(e,t,r,o){var i,l,a,c,u,p;if(42!==e.charCodeAt(0))return-1;if(91!==e.charCodeAt(1))return-1;if(-1===e.indexOf("]:"))return-1;if(i=new n(e,t,r,o,[]),l=s(i,1),0>l||58!==e.charCodeAt(l+1))return-1;for(c=i.posMax,a=l+2;c>a&&10!==i.src.charCodeAt(a);a++);return u=e.slice(2,l),p=e.slice(l+2,a).trim(),0===p.length?-1:(o.abbreviations||(o.abbreviations={}),"undefined"==typeof o.abbreviations[":"+u]&&(o.abbreviations[":"+u]=p),a)}var n=e("../rules_inline/state_inline"),s=e("../helpers/parse_link_label");t.exports=function(e){var t,n,s,o,i=e.tokens;if(!e.inlineMode)for(t=1,n=i.length-1;n>t;t++)if("paragraph_open"===i[t-1].type&&"inline"===i[t].type&&"paragraph_close"===i[t+1].type){for(s=i[t].content;s.length&&(o=r(s,e.inline,e.options,e.env),!(0>o));)s=s.slice(o).trim();i[t].content=s,s.length||(i[t-1].tight=!0,i[t+1].tight=!0)}}},{"../helpers/parse_link_label":12,"../rules_inline/state_inline":56}],34:[function(e,t){"use strict";function r(e){return e.replace(/([-()\[\]{}+?*.$\^|,:#<!\\])/g,"\\$1")}var n=" \n()[]'\".,!?-";t.exports=function(e){var t,s,o,i,l,a,c,u,p,h,f,d,g=e.tokens;if(e.env.abbreviations)for(e.env.abbrRegExp||(d="(^|["+n.split("").map(r).join("")+"])("+Object.keys(e.env.abbreviations).map(function(e){return e.substr(1)}).sort(function(e,t){return t.length-e.length}).map(r).join("|")+")($|["+n.split("").map(r).join("")+"])",e.env.abbrRegExp=new RegExp(d,"g")),h=e.env.abbrRegExp,s=0,o=g.length;o>s;s++)if("inline"===g[s].type)for(i=g[s].children,t=i.length-1;t>=0;t--)if(l=i[t],"text"===l.type){for(u=0,a=l.content,h.lastIndex=0,p=l.level,c=[];f=h.exec(a);)h.lastIndex>u&&c.push({type:"text",content:a.slice(u,f.index+f[1].length),level:p}),c.push({type:"abbr_open",title:e.env.abbreviations[":"+f[2]],level:p++}),c.push({type:"text",content:f[2],level:p}),c.push({type:"abbr_close",level:--p}),u=h.lastIndex-f[3].length;c.length&&(u<a.length&&c.push({type:"text",content:a.slice(u),level:p}),g[s].children=i=[].concat(i.slice(0,t),c,i.slice(t+1)))}}},{}],35:[function(e,t){"use strict";t.exports=function(e){e.inlineMode?e.tokens.push({type:"inline",content:e.src.replace(/\n/g," ").trim(),level:0,lines:[0,1],children:[]}):e.block.parse(e.src,e.options,e.env,e.tokens)}},{}],36:[function(e,t){"use strict";t.exports=function(e){var t,r,n,s,o,i,l,a,c,u=0,p=!1,h={};if(e.env.footnotes&&(e.tokens=e.tokens.filter(function(e){return"footnote_reference_open"===e.type?(p=!0,a=[],c=e.label,!1):"footnote_reference_close"===e.type?(p=!1,h[":"+c]=a,!1):(p&&a.push(e),!p)}),e.env.footnotes.list)){for(i=e.env.footnotes.list,e.tokens.push({type:"footnote_block_open",level:u++}),t=0,r=i.length;r>t;t++){for(e.tokens.push({type:"footnote_open",id:t,level:u++}),i[t].tokens?(l=[],l.push({type:"paragraph_open",tight:!1,level:u++}),l.push({type:"inline",content:"",level:u,children:i[t].tokens}),l.push({type:"paragraph_close",tight:!1,level:--u})):i[t].label&&(l=h[":"+i[t].label]),e.tokens=e.tokens.concat(l),o="paragraph_close"===e.tokens[e.tokens.length-1].type?e.tokens.pop():null,s=i[t].count>0?i[t].count:1,n=0;s>n;n++)e.tokens.push({type:"footnote_anchor",id:t,subId:n,level:u});o&&e.tokens.push(o),e.tokens.push({type:"footnote_close",level:--u})}e.tokens.push({type:"footnote_block_close",level:--u})}}},{}],37:[function(e,t){"use strict";t.exports=function(e){var t,r,n,s=e.tokens;for(r=0,n=s.length;n>r;r++)t=s[r],"inline"===t.type&&e.inline.parse(t.content,e.options,e.env,t.children)}},{}],38:[function(e,t){"use strict";function r(e){return/^<a[>\s]/i.test(e)}function n(e){return/^<\/a\s*>/i.test(e)}function s(){var e=[],t=new o({stripPrefix:!1,url:!0,email:!0,twitter:!1,replaceFn:function(t,r){switch(r.getType()){case"url":e.push({text:r.matchedText,url:r.getUrl()});break;case"email":e.push({text:r.matchedText,url:"mailto:"+r.getEmail().replace(/^mailto:/i,"")})}return!1}});return{links:e,autolinker:t}}var o=e("autolinker"),i=/www|@|\:\/\//;t.exports=function(e){var t,o,l,a,c,u,p,h,f,d,g,m,b,v=e.tokens,k=null;if(e.options.linkify)for(o=0,l=v.length;l>o;o++)if("inline"===v[o].type)for(a=v[o].children,g=0,t=a.length-1;t>=0;t--)if(c=a[t],"link_close"!==c.type){if("htmltag"===c.type&&(r(c.content)&&g>0&&g--,n(c.content)&&g++),!(g>0)&&"text"===c.type&&i.test(c.content)){if(k||(k=s(),m=k.links,b=k.autolinker),u=c.content,m.length=0,b.link(u),!m.length)continue;
	for(p=[],d=c.level,h=0;h<m.length;h++)e.inline.validateLink(m[h].url)&&(f=u.indexOf(m[h].text),f&&(d=d,p.push({type:"text",content:u.slice(0,f),level:d})),p.push({type:"link_open",href:m[h].url,title:"",level:d++}),p.push({type:"text",content:m[h].text,level:d}),p.push({type:"link_close",level:--d}),u=u.slice(f+m[h].text.length));u.length&&p.push({type:"text",content:u,level:d}),v[o].children=a=[].concat(a.slice(0,t),p,a.slice(t+1))}}else for(t--;a[t].level!==c.level&&"link_open"!==a[t].type;)t--}},{autolinker:60}],39:[function(e,t){"use strict";function r(e,t,r,a){var c,u,p,h,f,d,g,m,b;if(91!==e.charCodeAt(0))return-1;if(-1===e.indexOf("]:"))return-1;if(c=new n(e,t,r,a,[]),u=s(c,0),0>u||58!==e.charCodeAt(u+1))return-1;for(h=c.posMax,p=u+2;h>p&&(f=c.src.charCodeAt(p),32===f||10===f);p++);if(!o(c,p))return-1;for(g=c.linkContent,p=c.pos,d=p,p+=1;h>p&&(f=c.src.charCodeAt(p),32===f||10===f);p++);for(h>p&&d!==p&&i(c,p)?(m=c.linkContent,p=c.pos):(m="",p=d);h>p&&32===c.src.charCodeAt(p);)p++;return h>p&&10!==c.src.charCodeAt(p)?-1:(b=l(e.slice(1,u)),"undefined"==typeof a.references[b]&&(a.references[b]={title:m,href:g}),p)}var n=e("../rules_inline/state_inline"),s=e("../helpers/parse_link_label"),o=e("../helpers/parse_link_destination"),i=e("../helpers/parse_link_title"),l=e("../helpers/normalize_reference");t.exports=function(e){var t,n,s,o,i=e.tokens;if(e.env.references=e.env.references||{},!e.inlineMode)for(t=1,n=i.length-1;n>t;t++)if("inline"===i[t].type&&"paragraph_open"===i[t-1].type&&"paragraph_close"===i[t+1].type){for(s=i[t].content;s.length&&(o=r(s,e.inline,e.options,e.env),!(0>o));)s=s.slice(o).trim();i[t].content=s,s.length||(i[t-1].tight=!0,i[t+1].tight=!0)}}},{"../helpers/normalize_reference":10,"../helpers/parse_link_destination":11,"../helpers/parse_link_label":12,"../helpers/parse_link_title":13,"../rules_inline/state_inline":56}],40:[function(e,t){"use strict";function r(e){return e.indexOf("(")<0?e:e.replace(s,function(e,t){return o[t.toLowerCase()]})}var n=/\+-|\.\.|\?\?\?\?|!!!!|,,|--/,s=/\((c|tm|r|p)\)/gi,o={c:"©",r:"®",p:"§",tm:"™"};t.exports=function(e){var t,s,o,i,l;if(e.options.typographer)for(l=e.tokens.length-1;l>=0;l--)if("inline"===e.tokens[l].type)for(i=e.tokens[l].children,t=i.length-1;t>=0;t--)s=i[t],"text"===s.type&&(o=s.content,o=r(o),n.test(o)&&(o=o.replace(/\+-/g,"±").replace(/\.{2,}/g,"…").replace(/([?!])…/g,"$1..").replace(/([?!]){4,}/g,"$1$1$1").replace(/,{2,}/g,",").replace(/(^|[^-])---([^-]|$)/gm,"$1—$2").replace(/(^|\s)--(\s|$)/gm,"$1–$2").replace(/(^|[^-\s])--([^-\s]|$)/gm,"$1–$2")),s.content=o)}},{}],41:[function(e,t){"use strict";function r(e,t){return 0>t||t>=e.length?!1:!i.test(e[t])}function n(e,t,r){return e.substr(0,t)+r+e.substr(t+1)}var s=/['"]/,o=/['"]/g,i=/[-\s()\[\]]/,l="’";t.exports=function(e){var t,i,a,c,u,p,h,f,d,g,m,b,v,k,_,y,x;if(e.options.typographer)for(x=[],_=e.tokens.length-1;_>=0;_--)if("inline"===e.tokens[_].type)for(y=e.tokens[_].children,x.length=0,t=0;t<y.length;t++)if(i=y[t],"text"===i.type&&!s.test(i.text)){for(h=y[t].level,v=x.length-1;v>=0&&!(x[v].level<=h);v--);x.length=v+1,a=i.content,u=0,p=a.length;e:for(;p>u&&(o.lastIndex=u,c=o.exec(a));)if(f=!r(a,c.index-1),u=c.index+1,k="'"===c[0],d=!r(a,u),d||f){if(m=!d,b=!f)for(v=x.length-1;v>=0&&(g=x[v],!(x[v].level<h));v--)if(g.single===k&&x[v].level===h){g=x[v],k?(y[g.token].content=n(y[g.token].content,g.pos,e.options.quotes[2]),i.content=n(i.content,c.index,e.options.quotes[3])):(y[g.token].content=n(y[g.token].content,g.pos,e.options.quotes[0]),i.content=n(i.content,c.index,e.options.quotes[1])),x.length=v;continue e}m?x.push({token:t,pos:c.index,single:k,level:h}):b&&k&&(i.content=n(i.content,c.index,l))}else k&&(i.content=n(i.content,c.index,l))}}},{}],42:[function(e,t){"use strict";var r=e("../common/url_schemas"),n=e("../helpers/normalize_link"),s=/^<([a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)>/,o=/^<([a-zA-Z.\-]{1,25}):([^<>\x00-\x20]*)>/;t.exports=function(e,t){var i,l,a,c,u,p=e.pos;return 60!==e.src.charCodeAt(p)?!1:(i=e.src.slice(p),i.indexOf(">")<0?!1:(l=i.match(o))?r.indexOf(l[1].toLowerCase())<0?!1:(c=l[0].slice(1,-1),u=n(c),e.parser.validateLink(c)?(t||(e.push({type:"link_open",href:u,level:e.level}),e.push({type:"text",content:c,level:e.level+1}),e.push({type:"link_close",level:e.level})),e.pos+=l[0].length,!0):!1):(a=i.match(s),a?(c=a[0].slice(1,-1),u=n("mailto:"+c),e.parser.validateLink(u)?(t||(e.push({type:"link_open",href:u,level:e.level}),e.push({type:"text",content:c,level:e.level+1}),e.push({type:"link_close",level:e.level})),e.pos+=a[0].length,!0):!1):!1))}},{"../common/url_schemas":4,"../helpers/normalize_link":9}],43:[function(e,t){"use strict";t.exports=function(e,t){var r,n,s,o,i,l=e.pos,a=e.src.charCodeAt(l);if(96!==a)return!1;for(r=l,l++,n=e.posMax;n>l&&96===e.src.charCodeAt(l);)l++;for(s=e.src.slice(r,l),o=i=l;-1!==(o=e.src.indexOf("`",i));){for(i=o+1;n>i&&96===e.src.charCodeAt(i);)i++;if(i-o===s.length)return t||e.push({type:"code",content:e.src.slice(l,o).replace(/[ \n]+/g," ").trim(),block:!1,level:e.level}),e.pos=i,!0}return t||(e.pending+=s),e.pos+=s.length,!0}},{}],44:[function(e,t){"use strict";t.exports=function(e,t){var r,n,s,o,i,l=e.posMax,a=e.pos;if(126!==e.src.charCodeAt(a))return!1;if(t)return!1;if(a+4>=l)return!1;if(126!==e.src.charCodeAt(a+1))return!1;if(e.level>=e.options.maxNesting)return!1;if(o=a>0?e.src.charCodeAt(a-1):-1,i=e.src.charCodeAt(a+2),126===o)return!1;if(126===i)return!1;if(32===i||10===i)return!1;for(n=a+2;l>n&&126===e.src.charCodeAt(n);)n++;if(n>a+3)return e.pos+=n-a,t||(e.pending+=e.src.slice(a,n)),!0;for(e.pos=a+2,s=1;e.pos+1<l;){if(126===e.src.charCodeAt(e.pos)&&126===e.src.charCodeAt(e.pos+1)&&(o=e.src.charCodeAt(e.pos-1),i=e.pos+2<l?e.src.charCodeAt(e.pos+2):-1,126!==i&&126!==o&&(32!==o&&10!==o?s--:32!==i&&10!==i&&s++,0>=s))){r=!0;break}e.parser.skipToken(e)}return r?(e.posMax=e.pos,e.pos=a+2,t||(e.push({type:"del_open",level:e.level++}),e.parser.tokenize(e),e.push({type:"del_close",level:--e.level})),e.pos=e.posMax+2,e.posMax=l,!0):(e.pos=a,!1)}},{}],45:[function(e,t){"use strict";function r(e){return e>=48&&57>=e||e>=65&&90>=e||e>=97&&122>=e}function n(e,t){var n,s,o,i=t,l=!0,a=!0,c=e.posMax,u=e.src.charCodeAt(t);for(n=t>0?e.src.charCodeAt(t-1):-1;c>i&&e.src.charCodeAt(i)===u;)i++;return i>=c&&(l=!1),o=i-t,o>=4?l=a=!1:(s=c>i?e.src.charCodeAt(i):-1,(32===s||10===s)&&(l=!1),(32===n||10===n)&&(a=!1),95===u&&(r(n)&&(l=!1),r(s)&&(a=!1))),{can_open:l,can_close:a,delims:o}}t.exports=function(e,t){var r,s,o,i,l,a,c,u=e.posMax,p=e.pos,h=e.src.charCodeAt(p);if(95!==h&&42!==h)return!1;if(t)return!1;if(c=n(e,p),r=c.delims,!c.can_open)return e.pos+=r,t||(e.pending+=e.src.slice(p,e.pos)),!0;if(e.level>=e.options.maxNesting)return!1;for(e.pos=p+r,a=[r];e.pos<u;)if(e.src.charCodeAt(e.pos)!==h)e.parser.skipToken(e);else{if(c=n(e,e.pos),s=c.delims,c.can_close){for(i=a.pop(),l=s;i!==l;){if(i>l){a.push(i-l);break}if(l-=i,0===a.length)break;e.pos+=i,i=a.pop()}if(0===a.length){r=i,o=!0;break}e.pos+=s;continue}c.can_open&&a.push(s),e.pos+=s}return o?(e.posMax=e.pos,e.pos=p+r,t||((2===r||3===r)&&e.push({type:"strong_open",level:e.level++}),(1===r||3===r)&&e.push({type:"em_open",level:e.level++}),e.parser.tokenize(e),(1===r||3===r)&&e.push({type:"em_close",level:--e.level}),(2===r||3===r)&&e.push({type:"strong_close",level:--e.level})),e.pos=e.posMax+r,e.posMax=u,!0):(e.pos=p,!1)}},{}],46:[function(e,t){"use strict";var r=e("../common/entities"),n=e("../common/utils").has,s=e("../common/utils").isValidEntityCode,o=e("../common/utils").fromCodePoint,i=/^&#((?:x[a-f0-9]{1,8}|[0-9]{1,8}));/i,l=/^&([a-z][a-z0-9]{1,31});/i;t.exports=function(e,t){var a,c,u,p=e.pos,h=e.posMax;if(38!==e.src.charCodeAt(p))return!1;if(h>p+1)if(a=e.src.charCodeAt(p+1),35===a){if(u=e.src.slice(p).match(i))return t||(c="x"===u[1][0].toLowerCase()?parseInt(u[1].slice(1),16):parseInt(u[1],10),e.pending+=o(s(c)?c:65533)),e.pos+=u[0].length,!0}else if(u=e.src.slice(p).match(l),u&&n(r,u[1]))return t||(e.pending+=r[u[1]]),e.pos+=u[0].length,!0;return t||(e.pending+="&"),e.pos++,!0}},{"../common/entities":1,"../common/utils":5}],47:[function(e,t){"use strict";for(var r=[],n=0;256>n;n++)r.push(0);"\\!\"#$%&'()*+,./:;<=>?@[]^_`{|}~-".split("").forEach(function(e){r[e.charCodeAt(0)]=1}),t.exports=function(e,t){var n,s=e.pos,o=e.posMax;if(92!==e.src.charCodeAt(s))return!1;if(s++,o>s){if(n=e.src.charCodeAt(s),256>n&&0!==r[n])return t||(e.pending+=e.src[s]),e.pos+=2,!0;if(10===n){for(t||e.push({type:"hardbreak",level:e.level}),s++;o>s&&32===e.src.charCodeAt(s);)s++;return e.pos=s,!0}}return t||(e.pending+="\\"),e.pos++,!0}},{}],48:[function(e,t){"use strict";var r=e("../helpers/parse_link_label");t.exports=function(e,t){var n,s,o,i,l=e.posMax,a=e.pos;return a+2>=l?!1:94!==e.src.charCodeAt(a)?!1:91!==e.src.charCodeAt(a+1)?!1:e.level>=e.options.maxNesting?!1:(n=a+2,s=r(e,a+1),0>s?!1:(t||(e.env.footnotes||(e.env.footnotes={}),e.env.footnotes.list||(e.env.footnotes.list=[]),o=e.env.footnotes.list.length,e.pos=n,e.posMax=s,e.push({type:"footnote_ref",id:o,level:e.level}),e.linkLevel++,i=e.tokens.length,e.parser.tokenize(e),e.env.footnotes.list[o]={tokens:e.tokens.splice(i)},e.linkLevel--),e.pos=s+1,e.posMax=l,!0))}},{"../helpers/parse_link_label":12}],49:[function(e,t){"use strict";t.exports=function(e,t){var r,n,s,o,i=e.posMax,l=e.pos;if(l+3>i)return!1;if(!e.env.footnotes||!e.env.footnotes.refs)return!1;if(91!==e.src.charCodeAt(l))return!1;if(94!==e.src.charCodeAt(l+1))return!1;if(e.level>=e.options.maxNesting)return!1;for(n=l+2;i>n;n++){if(32===e.src.charCodeAt(n))return!1;if(10===e.src.charCodeAt(n))return!1;if(93===e.src.charCodeAt(n))break}return n===l+2?!1:n>=i?!1:(n++,r=e.src.slice(l+2,n-1),"undefined"==typeof e.env.footnotes.refs[":"+r]?!1:(t||(e.env.footnotes.list||(e.env.footnotes.list=[]),e.env.footnotes.refs[":"+r]<0?(s=e.env.footnotes.list.length,e.env.footnotes.list[s]={label:r,count:0},e.env.footnotes.refs[":"+r]=s):s=e.env.footnotes.refs[":"+r],o=e.env.footnotes.list[s].count,e.env.footnotes.list[s].count++,e.push({type:"footnote_ref",id:s,subId:o,level:e.level})),e.pos=n,e.posMax=i,!0))}},{}],50:[function(e,t){"use strict";function r(e){var t=32|e;return t>=97&&122>=t}var n=e("../common/html_re").HTML_TAG_RE;t.exports=function(e,t){var s,o,i,l=e.pos;return e.options.html?(i=e.posMax,60!==e.src.charCodeAt(l)||l+2>=i?!1:(s=e.src.charCodeAt(l+1),(33===s||63===s||47===s||r(s))&&(o=e.src.slice(l).match(n))?(t||e.push({type:"htmltag",content:e.src.slice(l,l+o[0].length),level:e.level}),e.pos+=o[0].length,!0):!1)):!1}},{"../common/html_re":3}],51:[function(e,t){"use strict";t.exports=function(e,t){var r,n,s,o,i,l=e.posMax,a=e.pos;if(43!==e.src.charCodeAt(a))return!1;if(t)return!1;if(a+4>=l)return!1;if(43!==e.src.charCodeAt(a+1))return!1;if(e.level>=e.options.maxNesting)return!1;if(o=a>0?e.src.charCodeAt(a-1):-1,i=e.src.charCodeAt(a+2),43===o)return!1;if(43===i)return!1;if(32===i||10===i)return!1;for(n=a+2;l>n&&43===e.src.charCodeAt(n);)n++;if(n!==a+2)return e.pos+=n-a,t||(e.pending+=e.src.slice(a,n)),!0;for(e.pos=a+2,s=1;e.pos+1<l;){if(43===e.src.charCodeAt(e.pos)&&43===e.src.charCodeAt(e.pos+1)&&(o=e.src.charCodeAt(e.pos-1),i=e.pos+2<l?e.src.charCodeAt(e.pos+2):-1,43!==i&&43!==o&&(32!==o&&10!==o?s--:32!==i&&10!==i&&s++,0>=s))){r=!0;break}e.parser.skipToken(e)}return r?(e.posMax=e.pos,e.pos=a+2,t||(e.push({type:"ins_open",level:e.level++}),e.parser.tokenize(e),e.push({type:"ins_close",level:--e.level})),e.pos=e.posMax+2,e.posMax=l,!0):(e.pos=a,!1)}},{}],52:[function(e,t){"use strict";var r=e("../helpers/parse_link_label"),n=e("../helpers/parse_link_destination"),s=e("../helpers/parse_link_title"),o=e("../helpers/normalize_reference");t.exports=function(e,t){var i,l,a,c,u,p,h,f,d=!1,g=e.pos,m=e.posMax,b=e.pos,v=e.src.charCodeAt(b);if(33===v&&(d=!0,v=e.src.charCodeAt(++b)),91!==v)return!1;if(e.level>=e.options.maxNesting)return!1;if(i=b+1,l=r(e,b),0>l)return!1;if(p=l+1,m>p&&40===e.src.charCodeAt(p)){for(p++;m>p&&(f=e.src.charCodeAt(p),32===f||10===f);p++);if(p>=m)return!1;for(b=p,n(e,p)?(c=e.linkContent,p=e.pos):c="",b=p;m>p&&(f=e.src.charCodeAt(p),32===f||10===f);p++);if(m>p&&b!==p&&s(e,p))for(u=e.linkContent,p=e.pos;m>p&&(f=e.src.charCodeAt(p),32===f||10===f);p++);else u="";if(p>=m||41!==e.src.charCodeAt(p))return e.pos=g,!1;p++}else{if(e.linkLevel>0)return!1;for(;m>p&&(f=e.src.charCodeAt(p),32===f||10===f);p++);if(m>p&&91===e.src.charCodeAt(p)&&(b=p+1,p=r(e,p),p>=0?a=e.src.slice(b,p++):p=b-1),a||(a=e.src.slice(i,l)),h=e.env.references[o(a)],!h)return e.pos=g,!1;c=h.href,u=h.title}return t||(e.pos=i,e.posMax=l,d?e.push({type:"image",src:c,title:u,alt:e.src.substr(i,l-i),level:e.level}):(e.push({type:"link_open",href:c,title:u,level:e.level++}),e.linkLevel++,e.parser.tokenize(e),e.linkLevel--,e.push({type:"link_close",level:--e.level}))),e.pos=p,e.posMax=m,!0}},{"../helpers/normalize_reference":10,"../helpers/parse_link_destination":11,"../helpers/parse_link_label":12,"../helpers/parse_link_title":13}],53:[function(e,t){"use strict";t.exports=function(e,t){var r,n,s,o,i,l=e.posMax,a=e.pos;if(61!==e.src.charCodeAt(a))return!1;if(t)return!1;if(a+4>=l)return!1;if(61!==e.src.charCodeAt(a+1))return!1;if(e.level>=e.options.maxNesting)return!1;if(o=a>0?e.src.charCodeAt(a-1):-1,i=e.src.charCodeAt(a+2),61===o)return!1;if(61===i)return!1;if(32===i||10===i)return!1;for(n=a+2;l>n&&61===e.src.charCodeAt(n);)n++;if(n!==a+2)return e.pos+=n-a,t||(e.pending+=e.src.slice(a,n)),!0;for(e.pos=a+2,s=1;e.pos+1<l;){if(61===e.src.charCodeAt(e.pos)&&61===e.src.charCodeAt(e.pos+1)&&(o=e.src.charCodeAt(e.pos-1),i=e.pos+2<l?e.src.charCodeAt(e.pos+2):-1,61!==i&&61!==o&&(32!==o&&10!==o?s--:32!==i&&10!==i&&s++,0>=s))){r=!0;break}e.parser.skipToken(e)}return r?(e.posMax=e.pos,e.pos=a+2,t||(e.push({type:"mark_open",level:e.level++}),e.parser.tokenize(e),e.push({type:"mark_close",level:--e.level})),e.pos=e.posMax+2,e.posMax=l,!0):(e.pos=a,!1)}},{}],54:[function(e,t){"use strict";t.exports=function(e,t){var r,n,s=e.pos;if(10!==e.src.charCodeAt(s))return!1;for(r=e.pending.length-1,n=e.posMax,t||(r>=0&&32===e.pending.charCodeAt(r)?r>=1&&32===e.pending.charCodeAt(r-1)?(e.pending=e.pending.replace(/ +$/,""),e.push({type:"hardbreak",level:e.level})):(e.pending=e.pending.slice(0,-1),e.push({type:"softbreak",level:e.level})):e.push({type:"softbreak",level:e.level})),s++;n>s&&32===e.src.charCodeAt(s);)s++;return e.pos=s,!0}},{}],55:[function(e,t){"use strict";var r=e("../helpers/parse_link_label"),n=/^[a-z]{3,16}/,s=/^[^)]{0,255}/;t.exports=function(e,t){var o,i,l,a,c,u=e.pos,p=e.pos,h=e.posMax;return 64!==e.src.charCodeAt(u++)?!1:(c=e.src.slice(u).match(n))?(l=c[0],u+=c[0].length,91!==e.src.charCodeAt(u)?!1:e.level>=e.options.maxNesting?!1:(o=u+1,i=r(e,u),0>i?!1:(u=i+1,u>=h||o===i?!1:40!==e.src.charCodeAt(u++)?!1:(c=e.src.slice(u).match(s))?(a=c[0],u+=c[0].length,u>=h||41!==e.src.charCodeAt(u++)?(e.pos=p,!1):(t||(e.pos=o,e.posMax=i,e.push({type:"rwref_open",rwrefType:l,rwrefId:a,level:e.level++}),e.linkLevel++,e.parser.tokenize(e),e.linkLevel--,e.push({type:"rwref_close",level:--e.level})),e.pos=u,e.posMax=h,!0)):!1))):!1}},{"../helpers/parse_link_label":12}],56:[function(e,t){"use strict";function r(e,t,r,n,s){this.src=e,this.env=n,this.options=r,this.parser=t,this.tokens=s,this.pos=0,this.posMax=this.src.length,this.level=0,this.pending="",this.pendingLevel=0,this.cache=[],this.isInLabel=!1,this.linkLevel=0,this.linkContent="",this.labelUnmatchedScopes=0}r.prototype.pushPending=function(){this.tokens.push({type:"text",content:this.pending,level:this.pendingLevel}),this.pending=""},r.prototype.push=function(e){this.pending&&this.pushPending(),this.tokens.push(e),this.pendingLevel=this.level},r.prototype.cacheSet=function(e,t){for(var r=this.cache.length;e>=r;r++)this.cache.push(0);this.cache[e]=t},r.prototype.cacheGet=function(e){return e<this.cache.length?this.cache[e]:0},t.exports=r},{}],57:[function(e,t){"use strict";var r=/\\([ \\!"#$%&'()*+,.\/:;<=>?@[\]^_`{|}~-])/g;t.exports=function(e,t){var n,s,o=e.posMax,i=e.pos;if(126!==e.src.charCodeAt(i))return!1;if(t)return!1;if(i+2>=o)return!1;if(e.level>=e.options.maxNesting)return!1;for(e.pos=i+1;e.pos<o;){if(126===e.src.charCodeAt(e.pos)){n=!0;break}e.parser.skipToken(e)}return n&&i+1!==e.pos?(s=e.src.slice(i+1,e.pos),s.match(/(^|[^\\])(\\\\)*\s/)?(e.pos=i,!1):(e.posMax=e.pos,e.pos=i+1,t||e.push({type:"sub",level:e.level,content:s.replace(r,"$1")}),e.pos=e.posMax+1,e.posMax=o,!0)):(e.pos=i,!1)}},{}],58:[function(e,t){"use strict";var r=/\\([ \\!"#$%&'()*+,.\/:;<=>?@[\]^_`{|}~-])/g;t.exports=function(e,t){var n,s,o=e.posMax,i=e.pos;if(94!==e.src.charCodeAt(i))return!1;if(t)return!1;if(i+2>=o)return!1;if(e.level>=e.options.maxNesting)return!1;for(e.pos=i+1;e.pos<o;){if(94===e.src.charCodeAt(e.pos)){n=!0;break}e.parser.skipToken(e)}return n&&i+1!==e.pos?(s=e.src.slice(i+1,e.pos),s.match(/(^|[^\\])(\\\\)*\s/)?(e.pos=i,!1):(e.posMax=e.pos,e.pos=i+1,t||e.push({type:"sup",level:e.level,content:s.replace(r,"$1")}),e.pos=e.posMax+1,e.posMax=o,!0)):(e.pos=i,!1)}},{}],59:[function(e,t){"use strict";function r(e){switch(e){case 10:case 92:case 96:case 42:case 95:case 94:case 91:case 93:case 33:case 38:case 60:case 62:case 123:case 125:case 36:case 37:case 64:case 126:case 43:case 61:case 58:return!0;default:return!1}}t.exports=function(e,t){for(var n=e.pos;n<e.posMax&&!r(e.src.charCodeAt(n));)n++;return n===e.pos?!1:(t||(e.pending+=e.src.slice(e.pos,n)),e.pos=n,!0)}},{}],60:[function(t,r,n){!function(t,s){"function"==typeof e&&e.amd?e([],function(){return t.returnExportsGlobal=s()}):"object"==typeof n?r.exports=s():t.Autolinker=s()}(this,function(){var e=function(t){e.Util.assign(this,t),this.matchValidator=new e.MatchValidator};return e.prototype={constructor:e,urls:!0,email:!0,twitter:!0,newWindow:!0,stripPrefix:!0,className:"",htmlCharacterEntitiesRegex:/(&nbsp;|&#160;|&lt;|&#60;|&gt;|&#62;)/gi,matcherRegex:function(){var e=/(^|[^\w])@(\w{1,15})/,t=/(?:[\-;:&=\+\$,\w\.]+@)/,r=/(?:[A-Za-z][-.+A-Za-z0-9]+:(?![A-Za-z][-.+A-Za-z0-9]+:\/\/)(?!\d+\/?)(?:\/\/)?)/,n=/(?:www\.)/,s=/[A-Za-z0-9\.\-]*[A-Za-z0-9\-]/,o=/\.(?:international|construction|contractors|enterprises|photography|productions|foundation|immobilien|industries|management|properties|technology|christmas|community|directory|education|equipment|institute|marketing|solutions|vacations|bargains|boutique|builders|catering|cleaning|clothing|computer|democrat|diamonds|graphics|holdings|lighting|partners|plumbing|supplies|training|ventures|academy|careers|company|cruises|domains|exposed|flights|florist|gallery|guitars|holiday|kitchen|neustar|okinawa|recipes|rentals|reviews|shiksha|singles|support|systems|agency|berlin|camera|center|coffee|condos|dating|estate|events|expert|futbol|kaufen|luxury|maison|monash|museum|nagoya|photos|repair|report|social|supply|tattoo|tienda|travel|viajes|villas|vision|voting|voyage|actor|build|cards|cheap|codes|dance|email|glass|house|mango|ninja|parts|photo|shoes|solar|today|tokyo|tools|watch|works|aero|arpa|asia|best|bike|blue|buzz|camp|club|cool|coop|farm|fish|gift|guru|info|jobs|kiwi|kred|land|limo|link|menu|mobi|moda|name|pics|pink|post|qpon|rich|ruhr|sexy|tips|vote|voto|wang|wien|wiki|zone|bar|bid|biz|cab|cat|ceo|com|edu|gov|int|kim|mil|net|onl|org|pro|pub|red|tel|uno|wed|xxx|xyz|ac|ad|ae|af|ag|ai|al|am|an|ao|aq|ar|as|at|au|aw|ax|az|ba|bb|bd|be|bf|bg|bh|bi|bj|bm|bn|bo|br|bs|bt|bv|bw|by|bz|ca|cc|cd|cf|cg|ch|ci|ck|cl|cm|cn|co|cr|cu|cv|cw|cx|cy|cz|de|dj|dk|dm|do|dz|ec|ee|eg|er|es|et|eu|fi|fj|fk|fm|fo|fr|ga|gb|gd|ge|gf|gg|gh|gi|gl|gm|gn|gp|gq|gr|gs|gt|gu|gw|gy|hk|hm|hn|hr|ht|hu|id|ie|il|im|in|io|iq|ir|is|it|je|jm|jo|jp|ke|kg|kh|ki|km|kn|kp|kr|kw|ky|kz|la|lb|lc|li|lk|lr|ls|lt|lu|lv|ly|ma|mc|md|me|mg|mh|mk|ml|mm|mn|mo|mp|mq|mr|ms|mt|mu|mv|mw|mx|my|mz|na|nc|ne|nf|ng|ni|nl|no|np|nr|nu|nz|om|pa|pe|pf|pg|ph|pk|pl|pm|pn|pr|ps|pt|pw|py|qa|re|ro|rs|ru|rw|sa|sb|sc|sd|se|sg|sh|si|sj|sk|sl|sm|sn|so|sr|st|su|sv|sx|sy|sz|tc|td|tf|tg|th|tj|tk|tl|tm|tn|to|tp|tr|tt|tv|tw|tz|ua|ug|uk|us|uy|uz|va|vc|ve|vg|vi|vn|vu|wf|ws|ye|yt|za|zm|zw)\b/,i=/[\-A-Za-z0-9+&@#\/%=~_()|'$*\[\]?!:,.;]*[\-A-Za-z0-9+&@#\/%=~_()|'$*\[\]]/;return new RegExp(["(",e.source,")","|","(",t.source,s.source,o.source,")","|","(","(?:","(",r.source,s.source,")","|","(?:","(.?//)?",n.source,s.source,")","|","(?:","(.?//)?",s.source,o.source,")",")","(?:"+i.source+")?",")"].join(""),"gi")}(),charBeforeProtocolRelMatchRegex:/^(.)?\/\//,link:function(t){var r=this,n=this.getHtmlParser(),s=this.htmlCharacterEntitiesRegex,o=0,i=[];return n.parse(t,{processHtmlNode:function(e,t,r){"a"===t&&(r?o=Math.max(o-1,0):o++),i.push(e)},processTextNode:function(t){if(0===o)for(var n=e.Util.splitAndCapture(t,s),l=0,a=n.length;a>l;l++){var c=n[l],u=r.processTextNode(c);i.push(u)}else i.push(t)}}),i.join("")},getHtmlParser:function(){var t=this.htmlParser;return t||(t=this.htmlParser=new e.HtmlParser),t},getTagBuilder:function(){var t=this.tagBuilder;return t||(t=this.tagBuilder=new e.AnchorTagBuilder({newWindow:this.newWindow,truncate:this.truncate,className:this.className})),t},processTextNode:function(e){var t=this;return e.replace(this.matcherRegex,function(e,r,n,s,o,i,l,a,c){var u=t.processCandidateMatch(e,r,n,s,o,i,l,a,c);if(u){var p=t.createMatchReturnVal(u.match,u.matchStr);return u.prefixStr+p+u.suffixStr}return e})},processCandidateMatch:function(t,r,n,s,o,i,l,a,c){var u,p=a||c,h="",f="";if(r&&!this.twitter||o&&!this.email||i&&!this.urls||!this.matchValidator.isValidMatch(i,l,p))return null;if(this.matchHasUnbalancedClosingParen(t)&&(t=t.substr(0,t.length-1),f=")"),o)u=new e.match.Email({matchedText:t,email:o});else if(r)n&&(h=n,t=t.slice(1)),u=new e.match.Twitter({matchedText:t,twitterHandle:s});else{if(p){var d=p.match(this.charBeforeProtocolRelMatchRegex)[1]||"";d&&(h=d,t=t.slice(1))}u=new e.match.Url({matchedText:t,url:t,protocolUrlMatch:!!l,protocolRelativeMatch:!!p,stripPrefix:this.stripPrefix})}return{prefixStr:h,suffixStr:f,matchStr:t,match:u}},matchHasUnbalancedClosingParen:function(e){var t=e.charAt(e.length-1);if(")"===t){var r=e.match(/\(/g),n=e.match(/\)/g),s=r&&r.length||0,o=n&&n.length||0;if(o>s)return!0}return!1},createMatchReturnVal:function(t,r){var n;if(this.replaceFn&&(n=this.replaceFn.call(this,this,t)),"string"==typeof n)return n;if(n===!1)return r;if(n instanceof e.HtmlTag)return n.toString();var s=this.getTagBuilder(),o=s.build(t);return o.toString()}},e.link=function(t,r){var n=new e(r);return n.link(t)},e.match={},e.Util={abstractMethod:function(){throw"abstract"},assign:function(e,t){for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);return e},extend:function(t,r){var n=t.prototype,s=function(){};s.prototype=n;var o;o=r.hasOwnProperty("constructor")?r.constructor:function(){n.constructor.apply(this,arguments)};var i=o.prototype=new s;return i.constructor=o,i.superclass=n,delete r.constructor,e.Util.assign(i,r),o},ellipsis:function(e,t,r){return e.length>t&&(r=null==r?"..":r,e=e.substring(0,t-r.length)+r),e},indexOf:function(e,t){if(Array.prototype.indexOf)return e.indexOf(t);for(var r=0,n=e.length;n>r;r++)if(e[r]===t)return r;return-1},splitAndCapture:function(e,t){if(!t.global)throw new Error("`splitRegex` must have the 'g' flag set");for(var r,n=[],s=0;r=t.exec(e);)n.push(e.substring(s,r.index)),n.push(r[0]),s=r.index+r[0].length;return n.push(e.substring(s)),n}},e.HtmlParser=e.Util.extend(Object,{htmlRegex:function(){var e=/[0-9a-zA-Z][0-9a-zA-Z:]*/,t=/[^\s\0"'>\/=\x01-\x1F\x7F]+/,r=/(?:".*?"|'.*?'|[^'"=<>`\s]+)/,n=t.source+"(?:\\s*=\\s*"+r.source+")?";return new RegExp(["(?:","<(!DOCTYPE)","(?:","\\s+","(?:",n,"|",r.source+")",")*",">",")","|","(?:","<(/)?","("+e.source+")","(?:","\\s+",n,")*","\\s*/?",">",")"].join(""),"gi")}(),parse:function(e,t){t=t||{};for(var r,n=t.processHtmlNode||function(){},s=t.processTextNode||function(){},o=this.htmlRegex,i=0;null!==(r=o.exec(e));){var l=r[0],a=r[1]||r[3],c=!!r[2],u=e.substring(i,r.index);u&&s(u),n(l,a.toLowerCase(),c),i=r.index+l.length}if(i<e.length){var p=e.substring(i);p&&s(p)}}}),e.HtmlTag=e.Util.extend(Object,{whitespaceRegex:/\s+/,constructor:function(t){e.Util.assign(this,t),this.innerHtml=this.innerHtml||this.innerHTML},setTagName:function(e){return this.tagName=e,this},getTagName:function(){return this.tagName||""},setAttr:function(e,t){var r=this.getAttrs();return r[e]=t,this},getAttr:function(e){return this.getAttrs()[e]},setAttrs:function(t){var r=this.getAttrs();return e.Util.assign(r,t),this},getAttrs:function(){return this.attrs||(this.attrs={})},setClass:function(e){return this.setAttr("class",e)},addClass:function(t){for(var r,n=this.getClass(),s=this.whitespaceRegex,o=e.Util.indexOf,i=n?n.split(s):[],l=t.split(s);r=l.shift();)-1===o(i,r)&&i.push(r);return this.getAttrs()["class"]=i.join(" "),this},removeClass:function(t){for(var r,n=this.getClass(),s=this.whitespaceRegex,o=e.Util.indexOf,i=n?n.split(s):[],l=t.split(s);i.length&&(r=l.shift());){var a=o(i,r);-1!==a&&i.splice(a,1)}return this.getAttrs()["class"]=i.join(" "),this},getClass:function(){return this.getAttrs()["class"]||""},hasClass:function(e){return-1!==(" "+this.getClass()+" ").indexOf(" "+e+" ")},setInnerHtml:function(e){return this.innerHtml=e,this},getInnerHtml:function(){return this.innerHtml||""},toString:function(){var e=this.getTagName(),t=this.buildAttrsStr();return t=t?" "+t:"",["<",e,t,">",this.getInnerHtml(),"</",e,">"].join("")},buildAttrsStr:function(){if(!this.attrs)return"";var e=this.getAttrs(),t=[];for(var r in e)e.hasOwnProperty(r)&&t.push(r+'="'+e[r]+'"');return t.join(" ")}}),e.MatchValidator=e.Util.extend(Object,{invalidProtocolRelMatchRegex:/^[\w]\/\//,hasFullProtocolRegex:/^[A-Za-z][-.+A-Za-z0-9]+:\/\//,uriSchemeRegex:/^[A-Za-z][-.+A-Za-z0-9]+:/,hasWordCharAfterProtocolRegex:/:[^\s]*?[A-Za-z]/,isValidMatch:function(e,t,r){return t&&!this.isValidUriScheme(t)||this.urlMatchDoesNotHaveProtocolOrDot(e,t)||this.urlMatchDoesNotHaveAtLeastOneWordChar(e,t)||this.isInvalidProtocolRelativeMatch(r)?!1:!0},isValidUriScheme:function(e){var t=e.match(this.uriSchemeRegex)[0];return"javascript:"!==t&&"vbscript:"!==t},urlMatchDoesNotHaveProtocolOrDot:function(e,t){return!(!e||t&&this.hasFullProtocolRegex.test(t)||-1!==e.indexOf("."))},urlMatchDoesNotHaveAtLeastOneWordChar:function(e,t){return e&&t?!this.hasWordCharAfterProtocolRegex.test(e):!1},isInvalidProtocolRelativeMatch:function(e){return!!e&&this.invalidProtocolRelMatchRegex.test(e)}}),e.AnchorTagBuilder=e.Util.extend(Object,{constructor:function(t){e.Util.assign(this,t)},build:function(t){var r=new e.HtmlTag({tagName:"a",attrs:this.createAttrs(t.getType(),t.getAnchorHref()),innerHtml:this.processAnchorText(t.getAnchorText())});return r},createAttrs:function(e,t){var r={href:t},n=this.createCssClass(e);return n&&(r["class"]=n),this.newWindow&&(r.target="_blank"),r},createCssClass:function(e){var t=this.className;return t?t+" "+t+"-"+e:""},processAnchorText:function(e){return e=this.doTruncate(e)},doTruncate:function(t){return e.Util.ellipsis(t,this.truncate||Number.POSITIVE_INFINITY)}}),e.match.Match=e.Util.extend(Object,{constructor:function(t){e.Util.assign(this,t)},getType:e.Util.abstractMethod,getMatchedText:function(){return this.matchedText},getAnchorHref:e.Util.abstractMethod,getAnchorText:e.Util.abstractMethod}),e.match.Email=e.Util.extend(e.match.Match,{getType:function(){return"email"},getEmail:function(){return this.email},getAnchorHref:function(){return"mailto:"+this.email},getAnchorText:function(){return this.email}}),e.match.Twitter=e.Util.extend(e.match.Match,{getType:function(){return"twitter"},getTwitterHandle:function(){return this.twitterHandle},getAnchorHref:function(){return"https://twitter.com/"+this.twitterHandle},getAnchorText:function(){return"@"+this.twitterHandle}}),e.match.Url=e.Util.extend(e.match.Match,{urlPrefixRegex:/^(https?:\/\/)?(www\.)?/i,protocolRelativeRegex:/^\/\//,protocolPrepended:!1,getType:function(){return"url"},getUrl:function(){var e=this.url;return this.protocolRelativeMatch||this.protocolUrlMatch||this.protocolPrepended||(e=this.url="http://"+e,this.protocolPrepended=!0),e},getAnchorHref:function(){var e=this.getUrl();return e.replace(/&amp;/g,"&")},getAnchorText:function(){var e=this.getUrl();return this.protocolRelativeMatch&&(e=this.stripProtocolRelativePrefix(e)),this.stripPrefix&&(e=this.stripUrlPrefix(e)),e=this.removeTrailingSlash(e)},stripUrlPrefix:function(e){return e.replace(this.urlPrefixRegex,"")},stripProtocolRelativePrefix:function(e){return e.replace(this.protocolRelativeRegex,"")},removeTrailingSlash:function(e){return"/"===e.charAt(e.length-1)&&(e=e.slice(0,-1)),e}}),e})},{}],"/":[function(e,t){"use strict";t.exports=e("./lib/")},{"./lib/":14}]},{},[])("/")});

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;//     Underscore.js 1.4.4
	//     http://underscorejs.org
	//     (c) 2009-2013 Jeremy Ashkenas, DocumentCloud Inc.
	//     Underscore may be freely distributed under the MIT license.
	
	(function() {
	
	  // Baseline setup
	  // --------------
	
	  // Establish the root object, `window` in the browser, or `global` on the server.
	  var root = this;
	
	  // Save the previous value of the `_` variable.
	  var previousUnderscore = root._;
	
	  // Establish the object that gets returned to break out of a loop iteration.
	  var breaker = {};
	
	  // Save bytes in the minified (but not gzipped) version:
	  var ArrayProto = Array.prototype, ObjProto = Object.prototype, FuncProto = Function.prototype;
	
	  // Create quick reference variables for speed access to core prototypes.
	  var push             = ArrayProto.push,
	      slice            = ArrayProto.slice,
	      concat           = ArrayProto.concat,
	      toString         = ObjProto.toString,
	      hasOwnProperty   = ObjProto.hasOwnProperty;
	
	  // All **ECMAScript 5** native function implementations that we hope to use
	  // are declared here.
	  var
	    nativeForEach      = ArrayProto.forEach,
	    nativeMap          = ArrayProto.map,
	    nativeReduce       = ArrayProto.reduce,
	    nativeReduceRight  = ArrayProto.reduceRight,
	    nativeFilter       = ArrayProto.filter,
	    nativeEvery        = ArrayProto.every,
	    nativeSome         = ArrayProto.some,
	    nativeIndexOf      = ArrayProto.indexOf,
	    nativeLastIndexOf  = ArrayProto.lastIndexOf,
	    nativeIsArray      = Array.isArray,
	    nativeKeys         = Object.keys,
	    nativeBind         = FuncProto.bind;
	
	  // Create a safe reference to the Underscore object for use below.
	  var _ = function(obj) {
	    if (obj instanceof _) return obj;
	    if (!(this instanceof _)) return new _(obj);
	    this._wrapped = obj;
	  };
	
	  // Export the Underscore object for **Node.js**, with
	  // backwards-compatibility for the old `require()` API. If we're in
	  // the browser, add `_` as a global object via a string identifier,
	  // for Closure Compiler "advanced" mode.
	  if (true) {
	    if (typeof module !== 'undefined' && module.exports) {
	      exports = module.exports = _;
	    }
	    exports._ = _;
	  } else {
	    root._ = _;
	  }
	
	  // Current version.
	  _.VERSION = '1.4.4';
	
	  // Collection Functions
	  // --------------------
	
	  // The cornerstone, an `each` implementation, aka `forEach`.
	  // Handles objects with the built-in `forEach`, arrays, and raw objects.
	  // Delegates to **ECMAScript 5**'s native `forEach` if available.
	  var each = _.each = _.forEach = function(obj, iterator, context) {
	    if (obj == null) return;
	    if (nativeForEach && obj.forEach === nativeForEach) {
	      obj.forEach(iterator, context);
	    } else if (obj.length === +obj.length) {
	      for (var i = 0, l = obj.length; i < l; i++) {
	        if (iterator.call(context, obj[i], i, obj) === breaker) return;
	      }
	    } else {
	      for (var key in obj) {
	        if (_.has(obj, key)) {
	          if (iterator.call(context, obj[key], key, obj) === breaker) return;
	        }
	      }
	    }
	  };
	
	  // Return the results of applying the iterator to each element.
	  // Delegates to **ECMAScript 5**'s native `map` if available.
	  _.map = _.collect = function(obj, iterator, context) {
	    var results = [];
	    if (obj == null) return results;
	    if (nativeMap && obj.map === nativeMap) return obj.map(iterator, context);
	    each(obj, function(value, index, list) {
	      results[results.length] = iterator.call(context, value, index, list);
	    });
	    return results;
	  };
	
	  var reduceError = 'Reduce of empty array with no initial value';
	
	  // **Reduce** builds up a single result from a list of values, aka `inject`,
	  // or `foldl`. Delegates to **ECMAScript 5**'s native `reduce` if available.
	  _.reduce = _.foldl = _.inject = function(obj, iterator, memo, context) {
	    var initial = arguments.length > 2;
	    if (obj == null) obj = [];
	    if (nativeReduce && obj.reduce === nativeReduce) {
	      if (context) iterator = _.bind(iterator, context);
	      return initial ? obj.reduce(iterator, memo) : obj.reduce(iterator);
	    }
	    each(obj, function(value, index, list) {
	      if (!initial) {
	        memo = value;
	        initial = true;
	      } else {
	        memo = iterator.call(context, memo, value, index, list);
	      }
	    });
	    if (!initial) throw new TypeError(reduceError);
	    return memo;
	  };
	
	  // The right-associative version of reduce, also known as `foldr`.
	  // Delegates to **ECMAScript 5**'s native `reduceRight` if available.
	  _.reduceRight = _.foldr = function(obj, iterator, memo, context) {
	    var initial = arguments.length > 2;
	    if (obj == null) obj = [];
	    if (nativeReduceRight && obj.reduceRight === nativeReduceRight) {
	      if (context) iterator = _.bind(iterator, context);
	      return initial ? obj.reduceRight(iterator, memo) : obj.reduceRight(iterator);
	    }
	    var length = obj.length;
	    if (length !== +length) {
	      var keys = _.keys(obj);
	      length = keys.length;
	    }
	    each(obj, function(value, index, list) {
	      index = keys ? keys[--length] : --length;
	      if (!initial) {
	        memo = obj[index];
	        initial = true;
	      } else {
	        memo = iterator.call(context, memo, obj[index], index, list);
	      }
	    });
	    if (!initial) throw new TypeError(reduceError);
	    return memo;
	  };
	
	  // Return the first value which passes a truth test. Aliased as `detect`.
	  _.find = _.detect = function(obj, iterator, context) {
	    var result;
	    any(obj, function(value, index, list) {
	      if (iterator.call(context, value, index, list)) {
	        result = value;
	        return true;
	      }
	    });
	    return result;
	  };
	
	  // Return all the elements that pass a truth test.
	  // Delegates to **ECMAScript 5**'s native `filter` if available.
	  // Aliased as `select`.
	  _.filter = _.select = function(obj, iterator, context) {
	    var results = [];
	    if (obj == null) return results;
	    if (nativeFilter && obj.filter === nativeFilter) return obj.filter(iterator, context);
	    each(obj, function(value, index, list) {
	      if (iterator.call(context, value, index, list)) results[results.length] = value;
	    });
	    return results;
	  };
	
	  // Return all the elements for which a truth test fails.
	  _.reject = function(obj, iterator, context) {
	    return _.filter(obj, function(value, index, list) {
	      return !iterator.call(context, value, index, list);
	    }, context);
	  };
	
	  // Determine whether all of the elements match a truth test.
	  // Delegates to **ECMAScript 5**'s native `every` if available.
	  // Aliased as `all`.
	  _.every = _.all = function(obj, iterator, context) {
	    iterator || (iterator = _.identity);
	    var result = true;
	    if (obj == null) return result;
	    if (nativeEvery && obj.every === nativeEvery) return obj.every(iterator, context);
	    each(obj, function(value, index, list) {
	      if (!(result = result && iterator.call(context, value, index, list))) return breaker;
	    });
	    return !!result;
	  };
	
	  // Determine if at least one element in the object matches a truth test.
	  // Delegates to **ECMAScript 5**'s native `some` if available.
	  // Aliased as `any`.
	  var any = _.some = _.any = function(obj, iterator, context) {
	    iterator || (iterator = _.identity);
	    var result = false;
	    if (obj == null) return result;
	    if (nativeSome && obj.some === nativeSome) return obj.some(iterator, context);
	    each(obj, function(value, index, list) {
	      if (result || (result = iterator.call(context, value, index, list))) return breaker;
	    });
	    return !!result;
	  };
	
	  // Determine if the array or object contains a given value (using `===`).
	  // Aliased as `include`.
	  _.contains = _.include = function(obj, target) {
	    if (obj == null) return false;
	    if (nativeIndexOf && obj.indexOf === nativeIndexOf) return obj.indexOf(target) != -1;
	    return any(obj, function(value) {
	      return value === target;
	    });
	  };
	
	  // Invoke a method (with arguments) on every item in a collection.
	  _.invoke = function(obj, method) {
	    var args = slice.call(arguments, 2);
	    var isFunc = _.isFunction(method);
	    return _.map(obj, function(value) {
	      return (isFunc ? method : value[method]).apply(value, args);
	    });
	  };
	
	  // Convenience version of a common use case of `map`: fetching a property.
	  _.pluck = function(obj, key) {
	    return _.map(obj, function(value){ return value[key]; });
	  };
	
	  // Convenience version of a common use case of `filter`: selecting only objects
	  // containing specific `key:value` pairs.
	  _.where = function(obj, attrs, first) {
	    if (_.isEmpty(attrs)) return first ? null : [];
	    return _[first ? 'find' : 'filter'](obj, function(value) {
	      for (var key in attrs) {
	        if (attrs[key] !== value[key]) return false;
	      }
	      return true;
	    });
	  };
	
	  // Convenience version of a common use case of `find`: getting the first object
	  // containing specific `key:value` pairs.
	  _.findWhere = function(obj, attrs) {
	    return _.where(obj, attrs, true);
	  };
	
	  // Return the maximum element or (element-based computation).
	  // Can't optimize arrays of integers longer than 65,535 elements.
	  // See: https://bugs.webkit.org/show_bug.cgi?id=80797
	  _.max = function(obj, iterator, context) {
	    if (!iterator && _.isArray(obj) && obj[0] === +obj[0] && obj.length < 65535) {
	      return Math.max.apply(Math, obj);
	    }
	    if (!iterator && _.isEmpty(obj)) return -Infinity;
	    var result = {computed : -Infinity, value: -Infinity};
	    each(obj, function(value, index, list) {
	      var computed = iterator ? iterator.call(context, value, index, list) : value;
	      computed >= result.computed && (result = {value : value, computed : computed});
	    });
	    return result.value;
	  };
	
	  // Return the minimum element (or element-based computation).
	  _.min = function(obj, iterator, context) {
	    if (!iterator && _.isArray(obj) && obj[0] === +obj[0] && obj.length < 65535) {
	      return Math.min.apply(Math, obj);
	    }
	    if (!iterator && _.isEmpty(obj)) return Infinity;
	    var result = {computed : Infinity, value: Infinity};
	    each(obj, function(value, index, list) {
	      var computed = iterator ? iterator.call(context, value, index, list) : value;
	      computed < result.computed && (result = {value : value, computed : computed});
	    });
	    return result.value;
	  };
	
	  // Shuffle an array.
	  _.shuffle = function(obj) {
	    var rand;
	    var index = 0;
	    var shuffled = [];
	    each(obj, function(value) {
	      rand = _.random(index++);
	      shuffled[index - 1] = shuffled[rand];
	      shuffled[rand] = value;
	    });
	    return shuffled;
	  };
	
	  // An internal function to generate lookup iterators.
	  var lookupIterator = function(value) {
	    return _.isFunction(value) ? value : function(obj){ return obj[value]; };
	  };
	
	  // Sort the object's values by a criterion produced by an iterator.
	  _.sortBy = function(obj, value, context) {
	    var iterator = lookupIterator(value);
	    return _.pluck(_.map(obj, function(value, index, list) {
	      return {
	        value : value,
	        index : index,
	        criteria : iterator.call(context, value, index, list)
	      };
	    }).sort(function(left, right) {
	      var a = left.criteria;
	      var b = right.criteria;
	      if (a !== b) {
	        if (a > b || a === void 0) return 1;
	        if (a < b || b === void 0) return -1;
	      }
	      return left.index < right.index ? -1 : 1;
	    }), 'value');
	  };
	
	  // An internal function used for aggregate "group by" operations.
	  var group = function(obj, value, context, behavior) {
	    var result = {};
	    var iterator = lookupIterator(value || _.identity);
	    each(obj, function(value, index) {
	      var key = iterator.call(context, value, index, obj);
	      behavior(result, key, value);
	    });
	    return result;
	  };
	
	  // Groups the object's values by a criterion. Pass either a string attribute
	  // to group by, or a function that returns the criterion.
	  _.groupBy = function(obj, value, context) {
	    return group(obj, value, context, function(result, key, value) {
	      (_.has(result, key) ? result[key] : (result[key] = [])).push(value);
	    });
	  };
	
	  // Counts instances of an object that group by a certain criterion. Pass
	  // either a string attribute to count by, or a function that returns the
	  // criterion.
	  _.countBy = function(obj, value, context) {
	    return group(obj, value, context, function(result, key) {
	      if (!_.has(result, key)) result[key] = 0;
	      result[key]++;
	    });
	  };
	
	  // Use a comparator function to figure out the smallest index at which
	  // an object should be inserted so as to maintain order. Uses binary search.
	  _.sortedIndex = function(array, obj, iterator, context) {
	    iterator = iterator == null ? _.identity : lookupIterator(iterator);
	    var value = iterator.call(context, obj);
	    var low = 0, high = array.length;
	    while (low < high) {
	      var mid = (low + high) >>> 1;
	      iterator.call(context, array[mid]) < value ? low = mid + 1 : high = mid;
	    }
	    return low;
	  };
	
	  // Safely convert anything iterable into a real, live array.
	  _.toArray = function(obj) {
	    if (!obj) return [];
	    if (_.isArray(obj)) return slice.call(obj);
	    if (obj.length === +obj.length) return _.map(obj, _.identity);
	    return _.values(obj);
	  };
	
	  // Return the number of elements in an object.
	  _.size = function(obj) {
	    if (obj == null) return 0;
	    return (obj.length === +obj.length) ? obj.length : _.keys(obj).length;
	  };
	
	  // Array Functions
	  // ---------------
	
	  // Get the first element of an array. Passing **n** will return the first N
	  // values in the array. Aliased as `head` and `take`. The **guard** check
	  // allows it to work with `_.map`.
	  _.first = _.head = _.take = function(array, n, guard) {
	    if (array == null) return void 0;
	    return (n != null) && !guard ? slice.call(array, 0, n) : array[0];
	  };
	
	  // Returns everything but the last entry of the array. Especially useful on
	  // the arguments object. Passing **n** will return all the values in
	  // the array, excluding the last N. The **guard** check allows it to work with
	  // `_.map`.
	  _.initial = function(array, n, guard) {
	    return slice.call(array, 0, array.length - ((n == null) || guard ? 1 : n));
	  };
	
	  // Get the last element of an array. Passing **n** will return the last N
	  // values in the array. The **guard** check allows it to work with `_.map`.
	  _.last = function(array, n, guard) {
	    if (array == null) return void 0;
	    if ((n != null) && !guard) {
	      return slice.call(array, Math.max(array.length - n, 0));
	    } else {
	      return array[array.length - 1];
	    }
	  };
	
	  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
	  // Especially useful on the arguments object. Passing an **n** will return
	  // the rest N values in the array. The **guard**
	  // check allows it to work with `_.map`.
	  _.rest = _.tail = _.drop = function(array, n, guard) {
	    return slice.call(array, (n == null) || guard ? 1 : n);
	  };
	
	  // Trim out all falsy values from an array.
	  _.compact = function(array) {
	    return _.filter(array, _.identity);
	  };
	
	  // Internal implementation of a recursive `flatten` function.
	  var flatten = function(input, shallow, output) {
	    each(input, function(value) {
	      if (_.isArray(value)) {
	        shallow ? push.apply(output, value) : flatten(value, shallow, output);
	      } else {
	        output.push(value);
	      }
	    });
	    return output;
	  };
	
	  // Return a completely flattened version of an array.
	  _.flatten = function(array, shallow) {
	    return flatten(array, shallow, []);
	  };
	
	  // Return a version of the array that does not contain the specified value(s).
	  _.without = function(array) {
	    return _.difference(array, slice.call(arguments, 1));
	  };
	
	  // Produce a duplicate-free version of the array. If the array has already
	  // been sorted, you have the option of using a faster algorithm.
	  // Aliased as `unique`.
	  _.uniq = _.unique = function(array, isSorted, iterator, context) {
	    if (_.isFunction(isSorted)) {
	      context = iterator;
	      iterator = isSorted;
	      isSorted = false;
	    }
	    var initial = iterator ? _.map(array, iterator, context) : array;
	    var results = [];
	    var seen = [];
	    each(initial, function(value, index) {
	      if (isSorted ? (!index || seen[seen.length - 1] !== value) : !_.contains(seen, value)) {
	        seen.push(value);
	        results.push(array[index]);
	      }
	    });
	    return results;
	  };
	
	  // Produce an array that contains the union: each distinct element from all of
	  // the passed-in arrays.
	  _.union = function() {
	    return _.uniq(concat.apply(ArrayProto, arguments));
	  };
	
	  // Produce an array that contains every item shared between all the
	  // passed-in arrays.
	  _.intersection = function(array) {
	    var rest = slice.call(arguments, 1);
	    return _.filter(_.uniq(array), function(item) {
	      return _.every(rest, function(other) {
	        return _.indexOf(other, item) >= 0;
	      });
	    });
	  };
	
	  // Take the difference between one array and a number of other arrays.
	  // Only the elements present in just the first array will remain.
	  _.difference = function(array) {
	    var rest = concat.apply(ArrayProto, slice.call(arguments, 1));
	    return _.filter(array, function(value){ return !_.contains(rest, value); });
	  };
	
	  // Zip together multiple lists into a single array -- elements that share
	  // an index go together.
	  _.zip = function() {
	    var args = slice.call(arguments);
	    var length = _.max(_.pluck(args, 'length'));
	    var results = new Array(length);
	    for (var i = 0; i < length; i++) {
	      results[i] = _.pluck(args, "" + i);
	    }
	    return results;
	  };
	
	  // Converts lists into objects. Pass either a single array of `[key, value]`
	  // pairs, or two parallel arrays of the same length -- one of keys, and one of
	  // the corresponding values.
	  _.object = function(list, values) {
	    if (list == null) return {};
	    var result = {};
	    for (var i = 0, l = list.length; i < l; i++) {
	      if (values) {
	        result[list[i]] = values[i];
	      } else {
	        result[list[i][0]] = list[i][1];
	      }
	    }
	    return result;
	  };
	
	  // If the browser doesn't supply us with indexOf (I'm looking at you, **MSIE**),
	  // we need this function. Return the position of the first occurrence of an
	  // item in an array, or -1 if the item is not included in the array.
	  // Delegates to **ECMAScript 5**'s native `indexOf` if available.
	  // If the array is large and already in sort order, pass `true`
	  // for **isSorted** to use binary search.
	  _.indexOf = function(array, item, isSorted) {
	    if (array == null) return -1;
	    var i = 0, l = array.length;
	    if (isSorted) {
	      if (typeof isSorted == 'number') {
	        i = (isSorted < 0 ? Math.max(0, l + isSorted) : isSorted);
	      } else {
	        i = _.sortedIndex(array, item);
	        return array[i] === item ? i : -1;
	      }
	    }
	    if (nativeIndexOf && array.indexOf === nativeIndexOf) return array.indexOf(item, isSorted);
	    for (; i < l; i++) if (array[i] === item) return i;
	    return -1;
	  };
	
	  // Delegates to **ECMAScript 5**'s native `lastIndexOf` if available.
	  _.lastIndexOf = function(array, item, from) {
	    if (array == null) return -1;
	    var hasIndex = from != null;
	    if (nativeLastIndexOf && array.lastIndexOf === nativeLastIndexOf) {
	      return hasIndex ? array.lastIndexOf(item, from) : array.lastIndexOf(item);
	    }
	    var i = (hasIndex ? from : array.length);
	    while (i--) if (array[i] === item) return i;
	    return -1;
	  };
	
	  // Generate an integer Array containing an arithmetic progression. A port of
	  // the native Python `range()` function. See
	  // [the Python documentation](http://docs.python.org/library/functions.html#range).
	  _.range = function(start, stop, step) {
	    if (arguments.length <= 1) {
	      stop = start || 0;
	      start = 0;
	    }
	    step = arguments[2] || 1;
	
	    var len = Math.max(Math.ceil((stop - start) / step), 0);
	    var idx = 0;
	    var range = new Array(len);
	
	    while(idx < len) {
	      range[idx++] = start;
	      start += step;
	    }
	
	    return range;
	  };
	
	  // Function (ahem) Functions
	  // ------------------
	
	  // Create a function bound to a given object (assigning `this`, and arguments,
	  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
	  // available.
	  _.bind = function(func, context) {
	    if (func.bind === nativeBind && nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
	    var args = slice.call(arguments, 2);
	    return function() {
	      return func.apply(context, args.concat(slice.call(arguments)));
	    };
	  };
	
	  // Partially apply a function by creating a version that has had some of its
	  // arguments pre-filled, without changing its dynamic `this` context.
	  _.partial = function(func) {
	    var args = slice.call(arguments, 1);
	    return function() {
	      return func.apply(this, args.concat(slice.call(arguments)));
	    };
	  };
	
	  // Bind all of an object's methods to that object. Useful for ensuring that
	  // all callbacks defined on an object belong to it.
	  _.bindAll = function(obj) {
	    var funcs = slice.call(arguments, 1);
	    if (funcs.length === 0) funcs = _.functions(obj);
	    each(funcs, function(f) { obj[f] = _.bind(obj[f], obj); });
	    return obj;
	  };
	
	  // Memoize an expensive function by storing its results.
	  _.memoize = function(func, hasher) {
	    var memo = {};
	    hasher || (hasher = _.identity);
	    return function() {
	      var key = hasher.apply(this, arguments);
	      return _.has(memo, key) ? memo[key] : (memo[key] = func.apply(this, arguments));
	    };
	  };
	
	  // Delays a function for the given number of milliseconds, and then calls
	  // it with the arguments supplied.
	  _.delay = function(func, wait) {
	    var args = slice.call(arguments, 2);
	    return setTimeout(function(){ return func.apply(null, args); }, wait);
	  };
	
	  // Defers a function, scheduling it to run after the current call stack has
	  // cleared.
	  _.defer = function(func) {
	    return _.delay.apply(_, [func, 1].concat(slice.call(arguments, 1)));
	  };
	
	  // Returns a function, that, when invoked, will only be triggered at most once
	  // during a given window of time.
	  _.throttle = function(func, wait) {
	    var context, args, timeout, result;
	    var previous = 0;
	    var later = function() {
	      previous = new Date;
	      timeout = null;
	      result = func.apply(context, args);
	    };
	    return function() {
	      var now = new Date;
	      var remaining = wait - (now - previous);
	      context = this;
	      args = arguments;
	      if (remaining <= 0) {
	        clearTimeout(timeout);
	        timeout = null;
	        previous = now;
	        result = func.apply(context, args);
	      } else if (!timeout) {
	        timeout = setTimeout(later, remaining);
	      }
	      return result;
	    };
	  };
	
	  // Returns a function, that, as long as it continues to be invoked, will not
	  // be triggered. The function will be called after it stops being called for
	  // N milliseconds. If `immediate` is passed, trigger the function on the
	  // leading edge, instead of the trailing.
	  _.debounce = function(func, wait, immediate) {
	    var timeout, result;
	    return function() {
	      var context = this, args = arguments;
	      var later = function() {
	        timeout = null;
	        if (!immediate) result = func.apply(context, args);
	      };
	      var callNow = immediate && !timeout;
	      clearTimeout(timeout);
	      timeout = setTimeout(later, wait);
	      if (callNow) result = func.apply(context, args);
	      return result;
	    };
	  };
	
	  // Returns a function that will be executed at most one time, no matter how
	  // often you call it. Useful for lazy initialization.
	  _.once = function(func) {
	    var ran = false, memo;
	    return function() {
	      if (ran) return memo;
	      ran = true;
	      memo = func.apply(this, arguments);
	      func = null;
	      return memo;
	    };
	  };
	
	  // Returns the first function passed as an argument to the second,
	  // allowing you to adjust arguments, run code before and after, and
	  // conditionally execute the original function.
	  _.wrap = function(func, wrapper) {
	    return function() {
	      var args = [func];
	      push.apply(args, arguments);
	      return wrapper.apply(this, args);
	    };
	  };
	
	  // Returns a function that is the composition of a list of functions, each
	  // consuming the return value of the function that follows.
	  _.compose = function() {
	    var funcs = arguments;
	    return function() {
	      var args = arguments;
	      for (var i = funcs.length - 1; i >= 0; i--) {
	        args = [funcs[i].apply(this, args)];
	      }
	      return args[0];
	    };
	  };
	
	  // Returns a function that will only be executed after being called N times.
	  _.after = function(times, func) {
	    if (times <= 0) return func();
	    return function() {
	      if (--times < 1) {
	        return func.apply(this, arguments);
	      }
	    };
	  };
	
	  // Object Functions
	  // ----------------
	
	  // Retrieve the names of an object's properties.
	  // Delegates to **ECMAScript 5**'s native `Object.keys`
	  _.keys = nativeKeys || function(obj) {
	    if (obj !== Object(obj)) throw new TypeError('Invalid object');
	    var keys = [];
	    for (var key in obj) if (_.has(obj, key)) keys[keys.length] = key;
	    return keys;
	  };
	
	  // Retrieve the values of an object's properties.
	  _.values = function(obj) {
	    var values = [];
	    for (var key in obj) if (_.has(obj, key)) values.push(obj[key]);
	    return values;
	  };
	
	  // Convert an object into a list of `[key, value]` pairs.
	  _.pairs = function(obj) {
	    var pairs = [];
	    for (var key in obj) if (_.has(obj, key)) pairs.push([key, obj[key]]);
	    return pairs;
	  };
	
	  // Invert the keys and values of an object. The values must be serializable.
	  _.invert = function(obj) {
	    var result = {};
	    for (var key in obj) if (_.has(obj, key)) result[obj[key]] = key;
	    return result;
	  };
	
	  // Return a sorted list of the function names available on the object.
	  // Aliased as `methods`
	  _.functions = _.methods = function(obj) {
	    var names = [];
	    for (var key in obj) {
	      if (_.isFunction(obj[key])) names.push(key);
	    }
	    return names.sort();
	  };
	
	  // Extend a given object with all the properties in passed-in object(s).
	  _.extend = function(obj) {
	    each(slice.call(arguments, 1), function(source) {
	      if (source) {
	        for (var prop in source) {
	          obj[prop] = source[prop];
	        }
	      }
	    });
	    return obj;
	  };
	
	  // Return a copy of the object only containing the whitelisted properties.
	  _.pick = function(obj) {
	    var copy = {};
	    var keys = concat.apply(ArrayProto, slice.call(arguments, 1));
	    each(keys, function(key) {
	      if (key in obj) copy[key] = obj[key];
	    });
	    return copy;
	  };
	
	   // Return a copy of the object without the blacklisted properties.
	  _.omit = function(obj) {
	    var copy = {};
	    var keys = concat.apply(ArrayProto, slice.call(arguments, 1));
	    for (var key in obj) {
	      if (!_.contains(keys, key)) copy[key] = obj[key];
	    }
	    return copy;
	  };
	
	  // Fill in a given object with default properties.
	  _.defaults = function(obj) {
	    each(slice.call(arguments, 1), function(source) {
	      if (source) {
	        for (var prop in source) {
	          if (obj[prop] == null) obj[prop] = source[prop];
	        }
	      }
	    });
	    return obj;
	  };
	
	  // Create a (shallow-cloned) duplicate of an object.
	  _.clone = function(obj) {
	    if (!_.isObject(obj)) return obj;
	    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
	  };
	
	  // Invokes interceptor with the obj, and then returns obj.
	  // The primary purpose of this method is to "tap into" a method chain, in
	  // order to perform operations on intermediate results within the chain.
	  _.tap = function(obj, interceptor) {
	    interceptor(obj);
	    return obj;
	  };
	
	  // Internal recursive comparison function for `isEqual`.
	  var eq = function(a, b, aStack, bStack) {
	    // Identical objects are equal. `0 === -0`, but they aren't identical.
	    // See the Harmony `egal` proposal: http://wiki.ecmascript.org/doku.php?id=harmony:egal.
	    if (a === b) return a !== 0 || 1 / a == 1 / b;
	    // A strict comparison is necessary because `null == undefined`.
	    if (a == null || b == null) return a === b;
	    // Unwrap any wrapped objects.
	    if (a instanceof _) a = a._wrapped;
	    if (b instanceof _) b = b._wrapped;
	    // Compare `[[Class]]` names.
	    var className = toString.call(a);
	    if (className != toString.call(b)) return false;
	    switch (className) {
	      // Strings, numbers, dates, and booleans are compared by value.
	      case '[object String]':
	        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
	        // equivalent to `new String("5")`.
	        return a == String(b);
	      case '[object Number]':
	        // `NaN`s are equivalent, but non-reflexive. An `egal` comparison is performed for
	        // other numeric values.
	        return a != +a ? b != +b : (a == 0 ? 1 / a == 1 / b : a == +b);
	      case '[object Date]':
	      case '[object Boolean]':
	        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
	        // millisecond representations. Note that invalid dates with millisecond representations
	        // of `NaN` are not equivalent.
	        return +a == +b;
	      // RegExps are compared by their source patterns and flags.
	      case '[object RegExp]':
	        return a.source == b.source &&
	               a.global == b.global &&
	               a.multiline == b.multiline &&
	               a.ignoreCase == b.ignoreCase;
	    }
	    if (typeof a != 'object' || typeof b != 'object') return false;
	    // Assume equality for cyclic structures. The algorithm for detecting cyclic
	    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
	    var length = aStack.length;
	    while (length--) {
	      // Linear search. Performance is inversely proportional to the number of
	      // unique nested structures.
	      if (aStack[length] == a) return bStack[length] == b;
	    }
	    // Add the first object to the stack of traversed objects.
	    aStack.push(a);
	    bStack.push(b);
	    var size = 0, result = true;
	    // Recursively compare objects and arrays.
	    if (className == '[object Array]') {
	      // Compare array lengths to determine if a deep comparison is necessary.
	      size = a.length;
	      result = size == b.length;
	      if (result) {
	        // Deep compare the contents, ignoring non-numeric properties.
	        while (size--) {
	          if (!(result = eq(a[size], b[size], aStack, bStack))) break;
	        }
	      }
	    } else {
	      // Objects with different constructors are not equivalent, but `Object`s
	      // from different frames are.
	      var aCtor = a.constructor, bCtor = b.constructor;
	      if (aCtor !== bCtor && !(_.isFunction(aCtor) && (aCtor instanceof aCtor) &&
	                               _.isFunction(bCtor) && (bCtor instanceof bCtor))) {
	        return false;
	      }
	      // Deep compare objects.
	      for (var key in a) {
	        if (_.has(a, key)) {
	          // Count the expected number of properties.
	          size++;
	          // Deep compare each member.
	          if (!(result = _.has(b, key) && eq(a[key], b[key], aStack, bStack))) break;
	        }
	      }
	      // Ensure that both objects contain the same number of properties.
	      if (result) {
	        for (key in b) {
	          if (_.has(b, key) && !(size--)) break;
	        }
	        result = !size;
	      }
	    }
	    // Remove the first object from the stack of traversed objects.
	    aStack.pop();
	    bStack.pop();
	    return result;
	  };
	
	  // Perform a deep comparison to check if two objects are equal.
	  _.isEqual = function(a, b) {
	    return eq(a, b, [], []);
	  };
	
	  // Is a given array, string, or object empty?
	  // An "empty" object has no enumerable own-properties.
	  _.isEmpty = function(obj) {
	    if (obj == null) return true;
	    if (_.isArray(obj) || _.isString(obj)) return obj.length === 0;
	    for (var key in obj) if (_.has(obj, key)) return false;
	    return true;
	  };
	
	  // Is a given value a DOM element?
	  _.isElement = function(obj) {
	    return !!(obj && obj.nodeType === 1);
	  };
	
	  // Is a given value an array?
	  // Delegates to ECMA5's native Array.isArray
	  _.isArray = nativeIsArray || function(obj) {
	    return toString.call(obj) == '[object Array]';
	  };
	
	  // Is a given variable an object?
	  _.isObject = function(obj) {
	    return obj === Object(obj);
	  };
	
	  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp.
	  each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp'], function(name) {
	    _['is' + name] = function(obj) {
	      return toString.call(obj) == '[object ' + name + ']';
	    };
	  });
	
	  // Define a fallback version of the method in browsers (ahem, IE), where
	  // there isn't any inspectable "Arguments" type.
	  if (!_.isArguments(arguments)) {
	    _.isArguments = function(obj) {
	      return !!(obj && _.has(obj, 'callee'));
	    };
	  }
	
	  // Optimize `isFunction` if appropriate.
	  if (true) {
	    _.isFunction = function(obj) {
	      return typeof obj === 'function';
	    };
	  }
	
	  // Is a given object a finite number?
	  _.isFinite = function(obj) {
	    return isFinite(obj) && !isNaN(parseFloat(obj));
	  };
	
	  // Is the given value `NaN`? (NaN is the only number which does not equal itself).
	  _.isNaN = function(obj) {
	    return _.isNumber(obj) && obj != +obj;
	  };
	
	  // Is a given value a boolean?
	  _.isBoolean = function(obj) {
	    return obj === true || obj === false || toString.call(obj) == '[object Boolean]';
	  };
	
	  // Is a given value equal to null?
	  _.isNull = function(obj) {
	    return obj === null;
	  };
	
	  // Is a given variable undefined?
	  _.isUndefined = function(obj) {
	    return obj === void 0;
	  };
	
	  // Shortcut function for checking if an object has a given property directly
	  // on itself (in other words, not on a prototype).
	  _.has = function(obj, key) {
	    return hasOwnProperty.call(obj, key);
	  };
	
	  // Utility Functions
	  // -----------------
	
	  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
	  // previous owner. Returns a reference to the Underscore object.
	  _.noConflict = function() {
	    root._ = previousUnderscore;
	    return this;
	  };
	
	  // Keep the identity function around for default iterators.
	  _.identity = function(value) {
	    return value;
	  };
	
	  // Run a function **n** times.
	  _.times = function(n, iterator, context) {
	    var accum = Array(n);
	    for (var i = 0; i < n; i++) accum[i] = iterator.call(context, i);
	    return accum;
	  };
	
	  // Return a random integer between min and max (inclusive).
	  _.random = function(min, max) {
	    if (max == null) {
	      max = min;
	      min = 0;
	    }
	    return min + Math.floor(Math.random() * (max - min + 1));
	  };
	
	  // List of HTML entities for escaping.
	  var entityMap = {
	    escape: {
	      '&': '&amp;',
	      '<': '&lt;',
	      '>': '&gt;',
	      '"': '&quot;',
	      "'": '&#x27;',
	      '/': '&#x2F;'
	    }
	  };
	  entityMap.unescape = _.invert(entityMap.escape);
	
	  // Regexes containing the keys and values listed immediately above.
	  var entityRegexes = {
	    escape:   new RegExp('[' + _.keys(entityMap.escape).join('') + ']', 'g'),
	    unescape: new RegExp('(' + _.keys(entityMap.unescape).join('|') + ')', 'g')
	  };
	
	  // Functions for escaping and unescaping strings to/from HTML interpolation.
	  _.each(['escape', 'unescape'], function(method) {
	    _[method] = function(string) {
	      if (string == null) return '';
	      return ('' + string).replace(entityRegexes[method], function(match) {
	        return entityMap[method][match];
	      });
	    };
	  });
	
	  // If the value of the named property is a function then invoke it;
	  // otherwise, return it.
	  _.result = function(object, property) {
	    if (object == null) return null;
	    var value = object[property];
	    return _.isFunction(value) ? value.call(object) : value;
	  };
	
	  // Add your own custom functions to the Underscore object.
	  _.mixin = function(obj) {
	    each(_.functions(obj), function(name){
	      var func = _[name] = obj[name];
	      _.prototype[name] = function() {
	        var args = [this._wrapped];
	        push.apply(args, arguments);
	        return result.call(this, func.apply(_, args));
	      };
	    });
	  };
	
	  // Generate a unique integer id (unique within the entire client session).
	  // Useful for temporary DOM ids.
	  var idCounter = 0;
	  _.uniqueId = function(prefix) {
	    var id = ++idCounter + '';
	    return prefix ? prefix + id : id;
	  };
	
	  // By default, Underscore uses ERB-style template delimiters, change the
	  // following template settings to use alternative delimiters.
	  _.templateSettings = {
	    evaluate    : /<%([\s\S]+?)%>/g,
	    interpolate : /<%=([\s\S]+?)%>/g,
	    escape      : /<%-([\s\S]+?)%>/g
	  };
	
	  // When customizing `templateSettings`, if you don't want to define an
	  // interpolation, evaluation or escaping regex, we need one that is
	  // guaranteed not to match.
	  var noMatch = /(.)^/;
	
	  // Certain characters need to be escaped so that they can be put into a
	  // string literal.
	  var escapes = {
	    "'":      "'",
	    '\\':     '\\',
	    '\r':     'r',
	    '\n':     'n',
	    '\t':     't',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  var escaper = /\\|'|\r|\n|\t|\u2028|\u2029/g;
	
	  // JavaScript micro-templating, similar to John Resig's implementation.
	  // Underscore templating handles arbitrary delimiters, preserves whitespace,
	  // and correctly escapes quotes within interpolated code.
	  _.template = function(text, data, settings) {
	    var render;
	    settings = _.defaults({}, settings, _.templateSettings);
	
	    // Combine delimiters into one regular expression via alternation.
	    var matcher = new RegExp([
	      (settings.escape || noMatch).source,
	      (settings.interpolate || noMatch).source,
	      (settings.evaluate || noMatch).source
	    ].join('|') + '|$', 'g');
	
	    // Compile the template source, escaping string literals appropriately.
	    var index = 0;
	    var source = "__p+='";
	    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
	      source += text.slice(index, offset)
	        .replace(escaper, function(match) { return '\\' + escapes[match]; });
	
	      if (escape) {
	        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
	      }
	      if (interpolate) {
	        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
	      }
	      if (evaluate) {
	        source += "';\n" + evaluate + "\n__p+='";
	      }
	      index = offset + match.length;
	      return match;
	    });
	    source += "';\n";
	
	    // If a variable is not specified, place data values in local scope.
	    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';
	
	    source = "var __t,__p='',__j=Array.prototype.join," +
	      "print=function(){__p+=__j.call(arguments,'');};\n" +
	      source + "return __p;\n";
	
	    try {
	      render = new Function(settings.variable || 'obj', '_', source);
	    } catch (e) {
	      e.source = source;
	      throw e;
	    }
	
	    if (data) return render(data, _);
	    var template = function(data) {
	      return render.call(this, data, _);
	    };
	
	    // Provide the compiled function source as a convenience for precompilation.
	    template.source = 'function(' + (settings.variable || 'obj') + '){\n' + source + '}';
	
	    return template;
	  };
	
	  // Add a "chain" function, which will delegate to the wrapper.
	  _.chain = function(obj) {
	    return _(obj).chain();
	  };
	
	  // OOP
	  // ---------------
	  // If Underscore is called as a function, it returns a wrapped object that
	  // can be used OO-style. This wrapper holds altered versions of all the
	  // underscore functions. Wrapped objects may be chained.
	
	  // Helper function to continue chaining intermediate results.
	  var result = function(obj) {
	    return this._chain ? _(obj).chain() : obj;
	  };
	
	  // Add all of the Underscore functions to the wrapper object.
	  _.mixin(_);
	
	  // Add all mutator Array functions to the wrapper.
	  each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function() {
	      var obj = this._wrapped;
	      method.apply(obj, arguments);
	      if ((name == 'shift' || name == 'splice') && obj.length === 0) delete obj[0];
	      return result.call(this, obj);
	    };
	  });
	
	  // Add all accessor Array functions to the wrapper.
	  each(['concat', 'join', 'slice'], function(name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function() {
	      return result.call(this, method.apply(this._wrapped, arguments));
	    };
	  });
	
	  _.extend(_.prototype, {
	
	    // Start chaining a wrapped Underscore object.
	    chain: function() {
	      this._chain = true;
	      return this;
	    },
	
	    // Extracts the result from a wrapped and chained object.
	    value: function() {
	      return this._wrapped;
	    }
	
	  });
	
	  // AMD define happens at the end for compatibility with AMD loaders
	  // that don't enforce next-turn semantics on modules.
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	
	}).call(this);


/***/ }),
/* 235 */,
/* 236 */,
/* 237 */
/***/ (function(module, exports) {

	module.exports = graph_lib;

/***/ }),
/* 238 */
/***/ (function(module, exports) {

	module.exports = jQuery;

/***/ }),
/* 239 */
/***/ (function(module, exports) {

	module.exports = map_lib;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// common-af012f2d5d00988ec965-bundle.js